function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
  var f,
    y,
    t,
    g,
    _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    };
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment CancellationPolicyInfoFragment on LodgingCancellationPolicyInfo {\n    policyContent {\n      policies {\n        ...LodgingPolicyFragment\n      }\n      title {\n        ... on EGDSStylizedText {\n          text\n        }\n        ... on EGDSGraphicText {\n          text\n        }\n      }\n    }\n    title {\n      ... on EGDSStylizedText {\n        text\n      }\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment DamageAndIncidentalsCardFragment on OfferDetails {\n    propertyContentSectionGroup {\n      ...PropertyContentSectionGroupFragment\n    }\n  }\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment FilterPillsFragment on OfferDetails {\n    filterPills {\n      pillLabel\n      query\n      type\n      value\n    }\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment HighlightedBenefitsFragment on OfferDetails {\n    highlightedBenefits {\n      listItems {\n        icon {\n          id\n        }\n        impressionAnalytics {\n          referrerId\n        }\n        text\n      }\n    }\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment LegalDisclaimerFragment on OfferDetails {\n    legalDisclaimer {\n      content {\n        markupType\n        text\n      }\n    }\n  }\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment LodgingOneKeyBurnSwitchFragment on OfferDetails {\n    lodgingOneKeyBurnSwitch {\n      burnSwitchGraphic: graphic {\n        ...UIGraphicFragment\n      }\n      switch {\n        enabled\n        checked\n        checkedLabel\n        uncheckedLabel\n        checkedDescription\n        uncheckedDescription\n        checkedAnalytics {\n          linkName\n          referrerId\n        }\n        uncheckedAnalytics {\n          linkName\n          referrerId\n        }\n      }\n      impressionTracking {\n        ...ClientSideAnalyticsFragment\n      }\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyDiscountToggleFragment on OfferDetails {\n    loyaltyDiscount {\n      saveWithPointsMessage\n      saveWithPointsActionMessage\n      toggleSubText\n    }\n  }\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment VipModuleFragment on PropertyHighlightSection {\n    label\n    header {\n      mark {\n        id\n        description\n      }\n      text\n    }\n    subSections {\n      title {\n        badge {\n          theme_temp\n          text\n        }\n        value\n        state\n      }\n      description\n      contents {\n        badge {\n          text\n          theme_temp\n        }\n        value\n      }\n      footerLink {\n        icon {\n          id\n          withBackground\n          description\n        }\n        link {\n          referrerId\n          uri {\n            relativePath\n            value\n          }\n          target\n        }\n        value\n        accessibilityLabel\n      }\n    }\n  }\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment NewVipModuleFragment on OfferDetails {\n    propertyHighlightSection {\n      ...VipModuleFragment\n    }\n  }\n  ", "\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment PriceInsightCardFragment on PriceInsightCard {\n    expando {\n      ...EGDSExpandoCardFragment\n    }\n    footer {\n      text\n    }\n    rangeIndicator {\n      accessibility\n      milestones {\n        label {\n          size\n          text\n          weight\n        }\n      }\n      segments {\n        pins {\n          badge {\n            accessibility\n            text\n          }\n          percentage\n        }\n        style\n        theme\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment PriceInsightDisclaimerFragment on PriceInsightDisclaimer {\n    title {\n      text\n      theme\n      weight\n      size\n      decorative\n      accessibility\n    }\n    description {\n      text\n      theme\n      weight\n      size\n      decorative\n      accessibility\n    }\n    openEvent {\n      ...ClientSideAnalyticsFragment\n    }\n    closeEvent {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n  ", "\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment PriceInsightFragment on OfferDetails {\n    priceInsight {\n      analyticsPayload\n      impressionAnalytics {\n        referrerId\n        linkName\n      }\n      card {\n        ...PriceInsightCardFragment\n      }\n      disclaimer {\n        ...PriceInsightDisclaimerFragment\n      }\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment PropertyLevelOffersCardFragment on OfferDetails {\n    propertyLevelOffersCard {\n      ...EGDSStandardMessagingCardFragment\n    }\n  }\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment PropertyLevelOffersMessageFragment on OfferDetails {\n    propertyLevelOffersMessage {\n      ...MessageResultFragment\n      ...SparkleBannerFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment PriceSummaryFooterFragment on PriceSummaryFooter {\n    footerMessages {\n      ...LodgingEnrichedMessageFragment\n    }\n  }\n  ", "\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment PriceSummaryLineItemFragment on PriceSummaryLineItem {\n    name {\n      primaryMessage {\n        ...LodgingEnrichedMessageFragment\n      }\n      secondaryMessages {\n        ...LodgingEnrichedMessageFragment\n      }\n    }\n    value {\n      primaryMessage {\n        ...LodgingEnrichedMessageFragment\n      }\n      secondaryMessages {\n        ...LodgingEnrichedMessageFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment PriceSummarySectionFragment on PriceSummarySection {\n    sectionHeading {\n      ...LodgingEnrichedMessageFragment\n    }\n    sectionFooter {\n      ...PriceSummaryFooterFragment\n    }\n    items {\n      ...PriceSummaryLineItemFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment PriceBreakdownSummaryFragment on Offer {\n    priceBreakDownSummary {\n      priceSummaryHeading {\n        ...LodgingEnrichedMessageFragment\n      }\n      sections {\n        ...PriceSummarySectionFragment\n      }\n      disclaimers {\n        ...LodgingEnrichedMessageFragment\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment ListingsHeaderFragment on OfferDetails {\n    listingsHeader {\n      text\n    }\n  }\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment AlternateDateOptionFragment on AlternateDateOption {\n    dates {\n      link {\n        uri {\n          relativePath\n        }\n        referrerId\n      }\n      value\n    }\n    price {\n      displayPrice {\n        formatted\n      }\n    }\n  }\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment AlternateDatesFragment on OfferDetails {\n    alternateDates {\n      header {\n        text\n        subText\n      }\n      options {\n        ...AlternateDateOptionFragment\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  fragment OfferCategoryHeadingFragment on OfferCategoryHeading {\n    text\n  }\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject22() {
  var data = _tagged_template_literal(["\n  fragment OfferCategoryMessageFragment on OfferCategoryMessage {\n    message {\n      ...EGDSStylizedTextFragment\n    }\n    icon {\n      ...IconFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject22 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject23() {
  var data = _tagged_template_literal(["\n  fragment LodgingReviewSectionFragment on LodgingReviewSection {\n    rating {\n      ... on LodgingCardRating {\n        ...LodgingCardRatingFragment\n      }\n    }\n    itemsHeader {\n      title {\n        ...LodgingHeaderFragment\n      }\n    }\n    items {\n      ... on EGDSTextStandardListItem {\n        text\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject23 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject24() {
  var data = _tagged_template_literal(["\n  fragment LodgingPlainSheetFragment on LodgingPlainDialog {\n    __typename\n    content\n    trigger {\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      icon {\n        description\n        id\n      }\n      theme\n      value\n    }\n    toolbar {\n      title\n      icon {\n        description\n      }\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"]);
  _templateObject24 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject25() {
  var data = _tagged_template_literal(["\n  fragment PropertyBaseFeaturesFragment on PropertyInfoItem {\n    primary {\n      text\n      graphic {\n        __typename\n        ... on Icon {\n          description\n          id\n        }\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject25 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject26() {
  var data = _tagged_template_literal(["\n  fragment PropertyFeaturesFragment on PropertyInfoItem {\n    text\n    graphic {\n      __typename\n      ... on Icon {\n        description\n        id\n      }\n      ... on Mark {\n        description\n        id\n        url {\n          value\n        }\n      }\n    }\n    moreInfoDialog {\n      ...LodgingPlainSheetFragment\n    }\n  }\n  ", "\n"]);
  _templateObject26 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject27() {
  var data = _tagged_template_literal(["\n  fragment PropertyOffersHeaderFragment on LodgingHeader {\n    text\n    subText\n  }\n"]);
  _templateObject27 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject28() {
  var data = _tagged_template_literal(["\n  fragment UIPrimaryButtonFragment on UIPrimaryButton {\n    primary\n    accessibility\n    action {\n      __typename\n      analytics {\n        referrerId\n        linkName\n      }\n      ... on UILinkAction {\n        resource {\n          value\n        }\n      }\n    }\n  }\n"]);
  _templateObject28 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject29() {
  var data = _tagged_template_literal(["\n  fragment UISecondaryButtonFragment on UISecondaryButton {\n    primary\n    action {\n      __typename\n      analytics {\n        referrerId\n        linkName\n      }\n      ... on UILinkAction {\n        resource {\n          value\n        }\n      }\n    }\n  }\n"]);
  _templateObject29 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject30() {
  var data = _tagged_template_literal(["\n  fragment LodgingPlainDialogFragment on LodgingPlainDialog {\n    content\n    primaryUIButton {\n      ...UIPrimaryButtonFragment\n    }\n    secondaryUIButton {\n      ...UISecondaryButtonFragment\n    }\n    primaryButton {\n      text\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n    trigger {\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      icon {\n        description\n        id\n      }\n      theme\n      value\n      secondaryValue\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject30 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject31() {
  var data = _tagged_template_literal(["\n  fragment LodgingPlainMessageFragment on LodgingPlainMessage {\n    value\n  }\n"]);
  _templateObject31 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject32() {
  var data = _tagged_template_literal(["\n  fragment LodgingPolicyDialogFragment on LodgingPolicyDialog {\n    policyContent {\n      ...LodgingDetailedTimelineFragment\n    }\n    trigger {\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      icon {\n        description\n        id\n      }\n      theme\n      value\n      secondaryValue\n      accessibilityLabel\n    }\n    toolbar {\n      title\n      icon {\n        description\n        __typename\n      }\n      clientSideAnalytics {\n        linkName\n        referrerId\n        __typename\n      }\n      __typename\n    }\n    __typename\n  }\n  ", "\n"]);
  _templateObject32 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject33() {
  var data = _tagged_template_literal(["\n  fragment RatePlanMessageFragment on RatePlanMessage {\n    ...LodgingPlainDialogFragment\n    ...LodgingEnrichedMessageFragment\n    ...LodgingPlainMessageFragment\n    ...LodgingPolicyDialogFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject33 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject34() {
  var data = _tagged_template_literal(["\n  fragment SpaceDetailsFloorPlanFragment on SpaceDetails {\n    floorPlan {\n      images {\n        alt\n        image {\n          description\n          url\n        }\n        subjectId\n      }\n      toolbar {\n        icon {\n          description\n          id\n          size\n        }\n        title\n      }\n      trigger {\n        value\n      }\n    }\n  }\n"]);
  _templateObject34 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject35() {
  var data = _tagged_template_literal(["\n  fragment SpaceDetailsHeaderFragment on SpaceDetails {\n    header {\n      text\n    }\n    summary\n  }\n"]);
  _templateObject35 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject36() {
  var data = _tagged_template_literal(["\n  fragment SpaceDetailsSpacesFragment on SpaceDetails {\n    spaces {\n      name\n      description\n      icons {\n        description\n        id\n        size\n      }\n    }\n  }\n"]);
  _templateObject36 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject37() {
  var data = _tagged_template_literal(["\n  fragment VirtualTourPromptFragment on VirtualTourPrompt {\n    heading {\n      text\n    }\n    button {\n      accessibility\n      primary\n      icon {\n        description\n        id\n      }\n      action {\n        resource {\n          value\n        }\n        accessibility\n      }\n    }\n    heroImage {\n      description\n      url\n      cameraMovement\n    }\n    caption {\n      text\n    }\n  }\n"]);
  _templateObject37 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject38() {
  var data = _tagged_template_literal(["\n  fragment SpaceDetailsFragment on SpaceDetails {\n    ...SpaceDetailsHeaderFragment\n    ...SpaceDetailsSpacesFragment\n    ...SpaceDetailsFloorPlanFragment\n    virtualTourPrompt {\n      ...VirtualTourPromptFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject38 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject39() {
  var data = _tagged_template_literal(["\n  fragment AvailabilityCallToActionFragment on AvailabilityCallToAction {\n    __typename\n    ... on LodgingPlainMessage {\n      value\n    }\n    ... on LodgingButton {\n      text\n    }\n  }\n"]);
  _templateObject39 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject40() {
  var data = _tagged_template_literal(["\n  fragment AvailabilityCtaFragment on PropertyUnit {\n    availabilityCallToAction {\n      ... on LodgingPlainMessage {\n        value\n      }\n      ... on LodgingButton {\n        text\n      }\n    }\n  }\n"]);
  _templateObject40 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject41() {
  var data = _tagged_template_literal(["\n  fragment ExpandoItemsCardFragment on LodgingExpandoItemsCard {\n    expando {\n      collapsedLabel\n      expandedLabel\n      expanded\n    }\n    header {\n      accessibilityLabel\n      egdsStandardBadge {\n        accessibility\n        theme\n        text\n      }\n      label\n      subText\n      text\n    }\n    items {\n      icon {\n        description\n        id\n      }\n      impressionAnalytics {\n        referrerId\n        linkName\n        event\n      }\n      subText\n      text\n    }\n  }\n"]);
  _templateObject41 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject42() {
  var data = _tagged_template_literal(["\n  fragment PropertyDialogFeaturesFragment on EGDSTextIconListItem {\n    __typename\n    text\n    icon {\n      id\n      description\n    }\n  }\n"]);
  _templateObject42 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject43() {
  var data = _tagged_template_literal(["\n  fragment ContentDialogFeaturesFragment on EGDSTextIconList {\n    listItems {\n      text\n      icon {\n        id\n        description\n      }\n    }\n  }\n"]);
  _templateObject43 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject44() {
  var data = _tagged_template_literal(["\n  fragment UnitHighlightsFragment on PropertyInfoContent {\n    header {\n      text\n      icon {\n        id\n        description\n        token\n      }\n    }\n    items {\n      text\n    }\n    iconAnalytics {\n      linkName\n      referrerId\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n  }\n"]);
  _templateObject44 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject45() {
  var data = _tagged_template_literal(["\n  fragment RoomAmenityContentTextFragment on PropertyContentItemMarkup {\n    content {\n      text\n    }\n  }\n"]);
  _templateObject45 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject46() {
  var data = _tagged_template_literal(["\n  fragment RoomAmenityContentFragment on PropertyContent {\n    header {\n      text\n      icon {\n        id\n      }\n    }\n    items {\n      ... on PropertyContentItemMarkup {\n        ...RoomAmenityContentTextFragment\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject46 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject47() {
  var data = _tagged_template_literal(["\n  fragment RoomAmenitiesDescriptionFragment on PropertyContentSection {\n    header {\n      text\n    }\n    bodySubSections {\n      contents {\n        ...RoomAmenityContentFragment\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject47 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject48() {
  var data = _tagged_template_literal(["\n  fragment UnitPropertyOffersDetailsDialogFragment on PropertyUnitDetailsDialog {\n    toolbar {\n      title\n      icon {\n        description\n      }\n    }\n    content {\n      ratePlanTitle {\n        text\n      }\n      baseDialogFeatures {\n        ...ContentDialogFeaturesFragment\n      }\n      dialogFeatures {\n        ...ContentDialogFeaturesFragment\n      }\n      details {\n        header {\n          text\n          subText\n        }\n        contents {\n          heading\n          items {\n            text\n          }\n        }\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject48 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject49() {
  var data = _tagged_template_literal(["\n  fragment LinkTriggerFragment on LodgingDialogTriggerMessage {\n    value\n    accessibilityLabel\n  }\n"]);
  _templateObject49 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject50() {
  var data = _tagged_template_literal(["\n  fragment LodgingPlainFullscreenDialogFragment on LodgingPlainDialog {\n    __typename\n    content\n    trigger {\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      icon {\n        description\n        id\n      }\n      theme\n      value\n    }\n    toolbar {\n      title\n      icon {\n        description\n      }\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"]);
  _templateObject50 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject51() {
  var data = _tagged_template_literal(["\n  fragment MarketingSectionFragment on MarketingSection {\n    title {\n      text\n    }\n    feeDialog {\n      title\n      content\n      tertiaryUIButton {\n        primary\n      }\n      trigger {\n        value\n        mark {\n          id\n        }\n        icon {\n          id\n          size\n        }\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n    paymentDetails {\n      ...LodgingEnrichedMessageFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject51 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject52() {
  var data = _tagged_template_literal(["\n  fragment HighlightedMessagesFragment on RatePlan {\n    id\n    highlightedMessages {\n      ...LodgingPlainDialogFragment\n      ...LodgingEnrichedMessageFragment\n      ...LodgingPlainMessageFragment\n      ...LodgingPolicyDialogFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject52 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject53() {
  var data = _tagged_template_literal(["\n  fragment PricePresentationDialogFragment on Offer {\n    pricePresentationDialog {\n      toolbar {\n        title\n        icon {\n          ...IconFragment\n        }\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n      }\n      trigger {\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n        accessibilityLabel\n        value\n      }\n    }\n    pricePresentation {\n      title {\n        primary\n      }\n      sections {\n        ...PricePresentationSectionFragment\n      }\n      footer {\n        header\n        messages {\n          ...PriceLineElementFragment\n        }\n      }\n    }\n  }\n\n  fragment PricePresentationSectionFragment on PricePresentationSection {\n    header {\n      name {\n        ...PricePresentationLineItemEntryFragment\n      }\n      enrichedValue {\n        ...PricePresentationLineItemEntryFragment\n      }\n    }\n    subSections {\n      ...PricePresentationSubSectionFragment\n    }\n  }\n\n  fragment PricePresentationSubSectionFragment on PricePresentationSubSection {\n    header {\n      name {\n        primaryMessage {\n          __typename\n          ... on PriceLineText {\n            primary\n          }\n          ... on PriceLineHeading {\n            primary\n          }\n        }\n      }\n      enrichedValue {\n        ...PricePresentationLineItemEntryFragment\n      }\n    }\n    items {\n      ...PricePresentationLineItemFragment\n    }\n  }\n\n  fragment PricePresentationLineItemFragment on PricePresentationLineItem {\n    enrichedValue {\n      ...PricePresentationLineItemEntryFragment\n    }\n    name {\n      ...PricePresentationLineItemEntryFragment\n    }\n  }\n\n  fragment PricePresentationLineItemEntryFragment on PricePresentationLineItemEntry {\n    primaryMessage {\n      ...PriceLineElementFragment\n    }\n    secondaryMessages {\n      ...PriceLineElementFragment\n    }\n  }\n\n  fragment PriceLineElementFragment on PricePresentationLineItemMessage {\n    __typename\n    ...PriceLineTextFragment\n    ...PriceLineHeadingFragment\n    ...PriceLineBadgeFragment\n    ...InlinePriceLineTextFragment\n  }\n\n  fragment PriceLineTextFragment on PriceLineText {\n    __typename\n    theme\n    primary\n    weight\n    additionalInfo {\n      ...AdditionalInformationPopoverFragment\n    }\n    icon {\n      ...IconFragment\n    }\n    graphic {\n      ...UIGraphicFragment\n    }\n  }\n  ", "\n\n  fragment AdditionalInformationPopoverFragment on AdditionalInformationPopover {\n    icon {\n      ...IconFragment\n    }\n    enrichedSecondaries {\n      ...AdditionalInformationPopoverSectionFragment\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n\n  fragment AdditionalInformationPopoverSectionFragment on AdditionalInformationPopoverSection {\n    __typename\n    ... on AdditionalInformationPopoverTextSection {\n      ...AdditionalInformationPopoverTextSectionFragment\n    }\n    ... on AdditionalInformationPopoverListSection {\n      ...AdditionalInformationPopoverListSectionFragment\n    }\n    ... on AdditionalInformationPopoverGridSection {\n      ...AdditionalInformationPopoverGridSectionFragment\n    }\n  }\n\n  fragment AdditionalInformationPopoverTextSectionFragment on AdditionalInformationPopoverTextSection {\n    __typename\n    text {\n      __typename\n      text\n      ... on EGDSStandardLink {\n        standardLinkIcon: icon {\n          ...IconFragment\n        }\n        action {\n          accessibility\n          analytics {\n            linkName\n            referrerId\n          }\n          resource {\n            value\n          }\n          target\n        }\n        iconPosition\n        size\n        text\n      }\n    }\n  }\n\n  fragment AdditionalInformationPopoverListSectionFragment on AdditionalInformationPopoverListSection {\n    __typename\n    content {\n      __typename\n      items {\n        text\n      }\n    }\n  }\n\n  fragment AdditionalInformationPopoverGridSectionFragment on AdditionalInformationPopoverGridSection {\n    __typename\n    subSections {\n      header {\n        name {\n          primaryMessage {\n            ...AdditionalInformationPopoverGridLineItemMessageFragment\n          }\n        }\n      }\n      items {\n        name {\n          ...AdditionalInformationPopoverGridLineItemEntryFragment\n        }\n        enrichedValue {\n          ...AdditionalInformationPopoverGridLineItemEntryFragment\n        }\n      }\n    }\n  }\n\n  fragment AdditionalInformationPopoverGridLineItemEntryFragment on PricePresentationLineItemEntry {\n    primaryMessage {\n      ...AdditionalInformationPopoverGridLineItemMessageFragment\n    }\n    secondaryMessages {\n      ...AdditionalInformationPopoverGridLineItemMessageFragment\n    }\n  }\n\n  fragment AdditionalInformationPopoverGridLineItemMessageFragment on PricePresentationLineItemMessage {\n    ... on PriceLineText {\n      __typename\n      primary\n    }\n    ... on PriceLineHeading {\n      __typename\n      tag\n      size\n      primary\n    }\n  }\n\n  fragment PriceLineHeadingFragment on PriceLineHeading {\n    __typename\n    primary\n    tag\n    size\n    additionalInfo {\n      ...AdditionalInformationPopoverFragment\n    }\n    icon {\n      ...IconFragment\n    }\n  }\n\n  fragment PriceLineBadgeFragment on PriceLineBadge {\n    __typename\n    badge {\n      accessibility\n      text\n      theme\n    }\n  }\n\n  fragment InlinePriceLineTextFragment on InlinePriceLineText {\n    __typename\n    inlineItems {\n      ...PriceLineTextFragment\n    }\n  }\n"]);
  _templateObject53 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject54() {
  var data = _tagged_template_literal(["\n  fragment PropertyOffersPriceChangeMessageFragment on RatePlan {\n    headerMessage {\n      ...LodgingEnrichedMessageFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject54 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject55() {
  var data = _tagged_template_literal(["\n  fragment PropertyOffersRateViewScarcityFragment on Offer {\n    availability {\n      scarcityMessage\n    }\n  }\n"]);
  _templateObject55 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject56() {
  var data = _tagged_template_literal(["\n  fragment PropertyRatePlanBadgeFragment on RatePlan {\n    badge {\n      theme_temp\n      text\n      icon_temp {\n        id\n        description\n        title\n      }\n    }\n  }\n"]);
  _templateObject56 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject57() {
  var data = _tagged_template_literal(["\n  fragment PropertyInfoMessageFragment on PropertyInfoItem {\n    text\n    icon {\n      id\n      token\n    }\n    state\n    graphic {\n      ...MarkFragment\n    }\n  }\n  ", "\n"]);
  _templateObject57 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject58() {
  var data = _tagged_template_literal(["\n  mutation LodgingPrepareChangeCheckoutMutation(\n    $context: ContextInput!\n    $tripId: String!\n    $options: [PrepareChangeCheckoutOptionInput!]\n    $lodgingInput: LodgingPrepareChangeCheckoutInput\n  ) {\n    prepareChangeCheckout(context: $context, tripId: $tripId, options: $options, lodgingInput: $lodgingInput) {\n      checkoutUrl\n      error {\n        heading\n        description\n        displayAnalytics {\n          referrerId\n          linkName\n          uisPrimeMessages {\n            schemaName\n            messageContent\n          }\n        }\n      }\n      toolbar {\n        closeText\n      }\n    }\n  }\n"]);
  _templateObject58 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject59() {
  var data = _tagged_template_literal(["\n  mutation lodgingPropertyCheckoutPrepareCheckout(\n    $context: ContextInput!\n    $activities: [ActivityNaturalKeyInput!]\n    $properties: [PropertyNaturalKeyInput!]\n    $totalPrice: MoneyInput\n    $checkoutOptions: [CheckoutOptionInput!]\n    $offerTokens: [OfferTokenInput!]\n  ) {\n    prepareCheckout(\n      context: $context\n      activities: $activities\n      properties: $properties\n      totalPrice: $totalPrice\n      checkoutOptions: $checkoutOptions\n      offerTokens: $offerTokens\n    ) {\n      __typename\n      tripId\n      checkoutUrl\n      failureReason {\n        description\n        message\n      }\n    }\n  }\n"]);
  _templateObject59 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject60() {
  var data = _tagged_template_literal(["\n  fragment PropertyLodgingPrepareCheckoutFragment on LodgingPrepareCheckout {\n    checkoutButton {\n      ...UIPrimaryButtonFragment\n    }\n    action {\n      checkoutOptions {\n        type\n        value\n      }\n      offerTokens {\n        token\n        lineOfBusiness\n      }\n      totalPrice {\n        amount\n        currencyInfo {\n          code\n        }\n      }\n      adaptExSuccessEvents {\n        ...LodgingAdaptExAnalyticsEventFragment\n      }\n      analyticsList {\n        eventType\n        linkName\n        referrerId\n        uisPrimeMessages {\n          messageContent\n          schemaName\n        }\n      }\n      lodgingRecommendationClickstreamEvent {\n        recommendationResponseId\n      }\n      propertyNaturalKeys {\n        id\n        businessModelType\n        checkIn {\n          month\n          day\n          year\n        }\n        checkOut {\n          month\n          day\n          year\n        }\n        inventoryType\n        noCreditCard\n        petsIncluded\n        ratePlanId\n        roomTypeId\n        ratePlanType\n        rooms {\n          childAges\n          numberOfAdults\n        }\n        shoppingPath\n      }\n      moreDetailsAnalyticsList {\n        eventType\n        linkName\n        referrerId\n        uisPrimeMessages {\n          messageContent\n          schemaName\n        }\n      }\n      __typename\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject60 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject61() {
  var data = _tagged_template_literal(["\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n"]);
  _templateObject61 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject62() {
  var data = _tagged_template_literal(["\n  fragment LodgingPrepareChangeCheckoutActionFragment on LodgingPrepareChangeCheckoutAction {\n    tripId\n    options {\n      type\n      value\n    }\n    lodgingInput {\n      orderLineGuid\n      orderNumber\n      propertyNaturalKey {\n        id\n        roomTypeId\n        ratePlanId\n        inventoryType\n        checkIn {\n          ...DateFragment\n        }\n        checkOut {\n          ...DateFragment\n        }\n        rooms {\n          numberOfAdults\n          childAges\n        }\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject62 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject63() {
  var data = _tagged_template_literal(["\n  fragment SelectChangeOfferActionFragment on SelectChangeOfferAction {\n    offer {\n      id\n      roomTypeId\n      ratePlanId\n      ratePlanType\n      inventoryType\n      noCreditCard\n      businessModelType\n      checkIn {\n        ...DateFragment\n      }\n      checkOut {\n        ...DateFragment\n      }\n      rooms {\n        numberOfAdults\n        childAges\n      }\n      petsIncluded\n      shoppingPath\n    }\n  }\n\n  ", "\n"]);
  _templateObject63 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject64() {
  var data = _tagged_template_literal(["\n  fragment ChangeOfferCallToActionFragment on ChangeOfferCallToAction {\n    action {\n      ...LodgingPrepareChangeCheckoutActionFragment\n      ...SelectChangeOfferActionFragment\n    }\n    button {\n      primary\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject64 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject65() {
  var data = _tagged_template_literal(["\n  fragment DatelessCheckAvailabilityFragment on DatelessCheckAvailability {\n    checkAvailabilityButton {\n      ...LodgingEGDSButtonFragment\n    }\n  }\n  ", "\n"]);
  _templateObject65 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject66() {
  var data = _tagged_template_literal(["\n  fragment LodgingMemberSignInDialogFragment on LodgingMemberSignInDialog {\n    dialogTrigger: trigger {\n      value\n      accessibilityLabel\n    }\n    title\n    dialogContent {\n      ...EGDSParagraphFragment\n    }\n    actionDialog {\n      ...EGDSActionDialogFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject66 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject67() {
  var data = _tagged_template_literal(["\n  fragment PropertyLodgingFormButtonFragment on LodgingForm {\n    action\n    inputs {\n      ... on LodgingTextInput {\n        name\n        type\n        value\n      }\n    }\n    method\n    submit {\n      text\n      accessibilityLabel\n      analytics {\n        linkName\n        referrerId\n      }\n      adaptExSuccessEvents {\n        ...LodgingAdaptExAnalyticsEventFragment\n      }\n      adaptExSuccessActionTracking {\n        ... on AdaptexCampaignTrackingDetail {\n          campaignId\n          eventTarget\n        }\n      }\n      lodgingRecommendationClickstreamEvent {\n        recommendationResponseId\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject67 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject68() {
  var data = _tagged_template_literal(["\n  fragment PropertyPaymentPriceFragment on Offer {\n    price {\n      lead {\n        formatted\n      }\n      priceMessaging {\n        value\n        theme\n      }\n      options {\n        leadingCaption\n        displayPrice {\n          formatted\n        }\n        disclaimer {\n          value\n        }\n        priceDisclaimer {\n          content\n          primaryButton {\n            text\n          }\n          trigger {\n            icon {\n              description\n            }\n          }\n        }\n        accessibilityLabel\n        strikeOut {\n          formatted\n        }\n        loyaltyPrice {\n          unit\n          amount {\n            formatted\n          }\n          totalStrikeOutPoints {\n            formatted\n          }\n        }\n      }\n    }\n  }\n"]);
  _templateObject68 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject69() {
  var data = _tagged_template_literal(["\n  fragment PropertyPaymentOptionsFragment on Offer {\n    loyaltyMessage {\n      ... on LodgingEnrichedMessage {\n        value\n        state\n      }\n    }\n    lodgingPrepareCheckout {\n      ...PropertyLodgingPrepareCheckoutFragment\n    }\n    offerBookButton {\n      ...PropertyLodgingFormButtonFragment\n    }\n    ...PropertyPaymentPriceFragment\n    price {\n      ...PropertyPriceFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject69 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject70() {
  var data = _tagged_template_literal(["\n  fragment PropertyReserveButtonFragment on RatePlan {\n    id\n    reserveCallToAction {\n      __typename\n      ... on EtpDialog {\n        content {\n          ... on LodgingPaymentOptionsDialogContent {\n            messages {\n              ...LodgingEGDSGraphicTextFragment\n            }\n          }\n        }\n        trigger {\n          value\n          accessibilityLabel\n          adaptExAttemptEvents {\n            ...LodgingAdaptExAnalyticsEventFragment\n          }\n        }\n        toolbar {\n          icon {\n            description\n          }\n          title\n        }\n      }\n      ... on LodgingForm {\n        ...PropertyLodgingFormButtonFragment\n      }\n      ... on LodgingMemberSignInDialog {\n        ...LodgingMemberSignInDialogFragment\n      }\n      ... on DatelessCheckAvailability {\n        ...DatelessCheckAvailabilityFragment\n      }\n    }\n    etpDialogTopMessage {\n      ...MessageResultFragment\n    }\n    priceDetails {\n      action {\n        ... on SelectPackageActionInput {\n          packageOfferId\n          __typename\n        }\n      }\n      price {\n        multiItemPriceToken\n      }\n      hotelCollect\n      propertyNaturalKeys {\n        id\n        businessModelType\n        checkIn {\n          month\n          day\n          year\n        }\n        checkOut {\n          month\n          day\n          year\n        }\n        inventoryType\n        noCreditCard\n        petsIncluded\n        ratePlanId\n        roomTypeId\n        ratePlanType\n        rooms {\n          childAges\n          numberOfAdults\n        }\n        shoppingPath\n      }\n      noCreditCard\n      paymentModel\n      ...PropertyPaymentOptionsFragment\n      dealMarker\n      changeOfferCallToAction {\n        ...ChangeOfferCallToActionFragment\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject70 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject71() {
  var data = _tagged_template_literal(["\n  fragment RatePlanAmenitiesFragment on RatePlanAmenity {\n    icon {\n      id\n      description\n      size\n    }\n    description\n    additionalInformation\n    id\n  }\n"]);
  _templateObject71 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject72() {
  var data = _tagged_template_literal(["\n  fragment RatePlanAnalyticsFragment on RatePlan {\n    clientSideAnalytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n  }\n"]);
  _templateObject72 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject73() {
  var data = _tagged_template_literal(["\n  fragment RatePlanWithAmenitiesFragment on RatePlan {\n    ...RatePlanAnalyticsFragment\n    shareUrl {\n      accessibilityLabel\n      value\n      link {\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n        uri {\n          relativePath\n        }\n      }\n    }\n    id\n    amenities {\n      ...RatePlanAmenitiesFragment\n    }\n    ...PropertyRatePlanBadgeFragment\n    paymentPolicy {\n      paymentType\n      heading\n      price {\n        ...PropertyPriceFragment\n      }\n      descriptions {\n        heading\n        header {\n          text\n          mark {\n            id\n            url {\n              value\n            }\n          }\n        }\n        items {\n          ...PropertyInfoMessageFragment\n        }\n      }\n    }\n    priceDetails {\n      optionTitle {\n        text\n      }\n      pointsApplied\n      ...PropertyOffersRateViewScarcityFragment\n      ...LodgingPriceSummaryFragment\n      ...PriceBreakdownSummaryFragment\n      ...PricePresentationDialogFragment\n      price {\n        ...PropertyPriceFragment\n      }\n    }\n    marketingSection {\n      ...MarketingSectionFragment\n    }\n    ...HighlightedMessagesFragment\n    ...PropertyOffersPriceChangeMessageFragment\n    ...PropertyReserveButtonFragment\n    loyaltyMessage {\n      ...LodgingEnrichedMessageFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject73 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject74() {
  var data = _tagged_template_literal(["\n  fragment LodgingNotificationsCardFragment on LodgingNotificationsCard {\n    header {\n      text\n    }\n    messages {\n      ...LodgingEnrichedMessageFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject74 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject75() {
  var data = _tagged_template_literal(["\n  fragment PropertyRatePlanStandardBadgeFragment on RatePlan {\n    standardBadge {\n      standardBadge {\n        theme\n        text\n        graphic {\n          __typename\n          ... on Icon {\n            description\n            id\n          }\n          ... on Mark {\n            description\n            id\n          }\n        }\n      }\n      impressionEventAnalytics {\n        referrerId\n        linkName\n        event\n      }\n    }\n  }\n"]);
  _templateObject75 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject76() {
  var data = _tagged_template_literal(["\n  fragment UnitCategorizationRatePlanFragment on RatePlan {\n    ...RatePlanAnalyticsFragment\n    shareUrl {\n      accessibilityLabel\n      value\n      link {\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n        uri {\n          relativePath\n        }\n      }\n    }\n    id\n    loyaltyMessage {\n      ...LodgingEnrichedMessageFragment\n    }\n    paymentPolicy {\n      paymentType\n      heading\n      descriptions {\n        heading\n        header {\n          text\n          mark {\n            id\n            url {\n              value\n            }\n          }\n        }\n        items {\n          text\n          icon {\n            id\n            token\n          }\n        }\n      }\n      price {\n        ...PropertyPriceFragment\n      }\n    }\n    priceDetails {\n      pointsApplied\n      ...PropertyOffersRateViewScarcityFragment\n      ...LodgingPriceSummaryFragment\n      ...PriceBreakdownSummaryFragment\n      ...PricePresentationDialogFragment\n      price {\n        ...PropertyPriceFragment\n      }\n    }\n    ...HighlightedMessagesFragment\n    ...PropertyOffersPriceChangeMessageFragment\n    ...PropertyRatePlanBadgeFragment\n    ...PropertyRatePlanStandardBadgeFragment\n    ...PropertyReserveButtonFragment\n    offerNotifications {\n      ...LodgingNotificationsCardFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject76 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject77() {
  var data = _tagged_template_literal(["\n  fragment FooterTextFragment on LodgingCategorizedUnit {\n    footerText {\n      text\n      accessibilityLabel\n      impressionAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"]);
  _templateObject77 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject78() {
  var data = _tagged_template_literal(["\n  fragment UnitCategorizationComplexDialogFragment on LodgingComplexDialog {\n    content {\n      content\n      title {\n        text\n      }\n    }\n    primaryUIButton {\n      ...UIPrimaryButtonFragment\n    }\n    toolbar {\n      title\n      icon {\n        description\n      }\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n    }\n    trigger {\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      icon {\n        id\n        description\n      }\n      value\n    }\n  }\n  ", "\n"]);
  _templateObject78 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject79() {
  var data = _tagged_template_literal(["\n  fragment SelectionHeaderDialogFragment on LodgingOfferSelectionHeaderDialog {\n    ...UnitCategorizationComplexDialogFragment\n    ...LodgingPolicyDialogFragment\n  }\n  ", "\n  ", "\n"]);
  _templateObject79 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject80() {
  var data = _tagged_template_literal(["\n  fragment SelectionHeaderFragment on LodgingOfferSelectionHeader {\n    title {\n      text\n      subText\n      accessibilityLabel\n    }\n    dialog {\n      ...UnitCategorizationComplexDialogFragment\n    }\n    complexDialog {\n      ...SelectionHeaderDialogFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject80 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject81() {
  var data = _tagged_template_literal(["\n  fragment UnitCategorizationPropertyUnitFragment on PropertyUnit {\n    ...AvailabilityCtaFragment\n    detailsDialog {\n      ...UnitPropertyOffersDetailsDialogFragment\n      toolbar {\n        clientSideAnalytics {\n          referrerId\n          linkName\n        }\n      }\n      trigger {\n        ...LinkTriggerFragment\n        clientSideAnalytics {\n          referrerId\n          linkName\n        }\n      }\n    }\n    id\n    ratePlans {\n      ...RatePlanWithAmenitiesFragment\n      ...UnitCategorizationRatePlanFragment\n    }\n    roomAmenities {\n      ...RoomAmenitiesDescriptionFragment\n    }\n    unitGallery {\n      accessibilityLabel\n      images {\n        image {\n          description\n          url\n          thumbnailClickAnalytics {\n            referrerId\n            linkName\n          }\n        }\n        imageId\n        trackingId\n        impressionAnalytics {\n          referrerId\n          linkName\n        }\n      }\n    }\n    spaceDetails {\n      ...SpaceDetailsFragment\n    }\n    roomHighlights {\n      ...UnitHighlightsFragment\n    }\n    roomHighlights {\n      ...UnitHighlightsFragment\n    }\n    matchingFilterIds\n    lodgingReview {\n      ...LodgingReviewSectionFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject81 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject82() {
  var data = _tagged_template_literal(["\n  fragment UnitCategorizationSelectionFragment on LodgingOfferOption {\n    clientSideAnalytics {\n      linkName\n      referrerId\n    }\n    description\n    enabled\n    optionId\n    price\n    subText\n    stylizedSubTexts {\n      accessibility\n      text\n      theme\n      weight\n    }\n    accessibilityLabel\n    liveAnnounceMessage\n    liveAnnouncePoliteness\n    selected\n  }\n"]);
  _templateObject82 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject83() {
  var data = _tagged_template_literal(["\n  fragment UnitCategorizationFragment on LodgingCategorizedUnit {\n    primarySelections {\n      propertyUnit {\n        ...UnitCategorizationPropertyUnitFragment\n      }\n      primarySelection {\n        ...UnitCategorizationSelectionFragment\n      }\n      secondarySelections {\n        recommendedSelection\n        secondarySelection {\n          ...UnitCategorizationSelectionFragment\n          dialog {\n            ...LodgingPlainFullscreenDialogFragment\n          }\n        }\n        tertiarySelections {\n          ...UnitCategorizationSelectionFragment\n          dialog {\n            ...LodgingPlainFullscreenDialogFragment\n          }\n        }\n      }\n    }\n    primaryHeader {\n      ...SelectionHeaderFragment\n    }\n    secondaryHeader {\n      ...SelectionHeaderFragment\n    }\n    tertiaryHeader {\n      ...SelectionHeaderFragment\n    }\n    footerButton {\n      primary\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n    ...FooterTextFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject83 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject84() {
  var data = _tagged_template_literal(["\n  fragment PropertyUnitCardFragment on LodgingCategorizedUnit {\n    unitId\n    header {\n      ...PropertyOffersHeaderFragment\n    }\n    baseFeatures {\n      ...PropertyBaseFeaturesFragment\n    }\n    features {\n      ...PropertyFeaturesFragment\n    }\n    highlightedMessages {\n      ...RatePlanMessageFragment\n    }\n    featureHeader {\n      text\n    }\n    expandoItemsCard {\n      ...ExpandoItemsCardFragment\n    }\n    lodgingReview {\n      ...LodgingReviewSectionFragment\n    }\n    ...UnitCategorizationFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject84 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject85() {
  var data = _tagged_template_literal(["\n  fragment PropertyUnitCategorizationFragment on LodgingCategorizedUnit {\n    unitId\n    __typename\n    header {\n      ...PropertyOffersHeaderFragment\n    }\n    baseFeatures {\n      ...PropertyBaseFeaturesFragment\n    }\n    features {\n      ...PropertyFeaturesFragment\n    }\n    highlightedMessages {\n      ...RatePlanMessageFragment\n    }\n    featureHeader {\n      text\n    }\n    expandoItemsCard {\n      ...ExpandoItemsCardFragment\n    }\n    lodgingReview {\n      ...LodgingReviewSectionFragment\n    }\n    ...UnitCategorizationFragment\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject85 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject86() {
  var data = _tagged_template_literal(["\n  fragment CategoryOverlayBodyFragment on OfferCategoryOverlayContentBodyCategorizedOffers {\n    messages {\n      ...OfferCategoryMessageFragment\n    }\n    offerIdentifiers\n    offerFilters {\n      ...LodgingOfferFiltersFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject86 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject87() {
  var data = _tagged_template_literal(["\n  fragment OfferCategoryOverlayContentBodyFragment on OfferCategoryOverlayContent {\n    body {\n      ...CategoryOverlayBodyFragment\n    }\n  }\n  ", "\n"]);
  _templateObject87 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject88() {
  var data = _tagged_template_literal(["\n  fragment OfferCategoryOverlayContentHeadingFragment on OfferCategoryOverlayContent {\n    heading {\n      ...OfferCategoryHeadingFragment\n    }\n  }\n  ", "\n"]);
  _templateObject88 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject89() {
  var data = _tagged_template_literal(["\n  fragment OverlayContentsFragment on OfferCategoriesSectionOverlayContentsContainer {\n    content {\n      ...OfferCategoryOverlayContentFragment\n    }\n    contentId\n  }\n\n  fragment OfferCategoryOverlayContentFragment on OfferCategoryOverlayContent {\n    ...OfferCategoryOverlayContentHeadingFragment\n    ...OfferCategoryOverlayContentBodyFragment\n  }\n  ", "\n  ", "\n"]);
  _templateObject89 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject90() {
  var data = _tagged_template_literal(["\n  fragment AllOffersSectionFragment on AllOffersSection {\n    actionId\n    primaryButton {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      primary\n    }\n  }\n"]);
  _templateObject90 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject91() {
  var data = _tagged_template_literal(["\n  fragment OfferCategoryCardFragment on OfferCategory {\n    media {\n      ...LodgingEGDSImageFragment\n    }\n    heading {\n      ...OfferCategoryHeadingFragment\n    }\n    messages {\n      ...OfferCategoryMessageFragment\n    }\n    actionId\n  }\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject91 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject92() {
  var data = _tagged_template_literal(["\n  fragment OffersCategoriesFragment on OfferCategoriesSection {\n    offerCategories {\n      ...OfferCategoryCardFragment\n    }\n  }\n  ", "\n"]);
  _templateObject92 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject93() {
  var data = _tagged_template_literal(["\n  fragment ExperimentalOfferCategoriesSectionFragment on OfferDetails {\n    experimentalOfferCategoriesSection {\n      heading\n      ...OffersCategoriesFragment\n      overlayContents {\n        ...OverlayContentsFragment\n      }\n      shoppingJoinListContainer {\n        ...ShoppingJoinListContainerFragment\n      }\n      allOffersSection {\n        ...AllOffersSectionFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject93 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject94() {
  var data = _tagged_template_literal(["\n  fragment PropertyOffersIncludedPerksFragment on OfferDetails {\n    includedPerks {\n      header {\n        text\n        accessibilityLabel\n      }\n      icon {\n        id\n        spotLight\n      }\n      iconAnalytics {\n        linkName\n        referrerId\n        uisPrimeMessages {\n          messageContent\n          schemaName\n        }\n      }\n      items {\n        accessibilityLabel\n        graphic {\n          ... on Icon {\n            description\n            id\n          }\n          ... on Mark {\n            description\n            id\n            url {\n              value\n            }\n          }\n        }\n        moreInfoDialog {\n          ...LodgingPlainFullscreenDialogFragment\n        }\n        text\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject94 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject95() {
  var data = _tagged_template_literal(["\n  fragment LodgingSectionHeaderFragment on LodgingHeader {\n    text\n    accessibilityLabel\n    impressionAnalytics {\n      event\n      referrerId\n    }\n  }\n"]);
  _templateObject95 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject96() {
  var data = _tagged_template_literal(["\n  fragment VerticalMessagingCardFragment on MessageResult {\n    title {\n      text\n    }\n    subtitle {\n      text\n    }\n    featuredImage {\n      url\n      description\n    }\n    action {\n      primary {\n        text\n        referrerId\n        actionDetails {\n          action\n          accessibilityLabel\n        }\n      }\n      secondary {\n        text\n        referrerId\n        actionDetails {\n          action\n          accessibilityLabel\n        }\n      }\n    }\n  }\n"]);
  _templateObject96 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject97() {
  var data = _tagged_template_literal(["\n  fragment InsurtechPrimingCardCategorizedListingFragment on InsurTechComponentPlacement {\n    placementContext {\n      lob\n      placement\n      path\n    }\n    position\n  }\n"]);
  _templateObject97 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject98() {
  var data = _tagged_template_literal(["\n  fragment ListingsToggleFragment on ListingsToggle {\n    analytics {\n      ...ListingsToggleAnalyticsFragment\n    }\n    localizationMap {\n      key\n      value\n    }\n  }\n\n  fragment ListingsToggleAnalyticsFragment on ListingsToggleAnalytics {\n    toggled {\n      ...PartialAnalyticsFragment\n    }\n    untoggled {\n      ...PartialAnalyticsFragment\n    }\n  }\n\n  fragment PartialAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n"]);
  _templateObject98 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject99() {
  var data = _tagged_template_literal(["\n  fragment SleepingArrangementsFragment on PropertyUnit {\n    spaceDetails {\n      ...SpaceDetailsHeaderFragment\n      ...SpaceDetailsSpacesFragment\n      ...SpaceDetailsFloorPlanFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject99 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject100() {
  var data = _tagged_template_literal(["\n  fragment RatePlansExpandoFragment on RatePlansExpando {\n    collapseButton {\n      text\n    }\n    expandButton {\n      text\n    }\n  }\n"]);
  _templateObject100 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject101() {
  var data = _tagged_template_literal(["\n  fragment PropertyUnitFragment on PropertyUnit {\n    __typename\n    ... on PropertyUnit {\n      id\n      header {\n        ...PropertyOffersHeaderFragment\n      }\n      features {\n        ...PropertyFeaturesFragment\n      }\n      unitGallery {\n        accessibilityLabel\n        images {\n          image {\n            description\n            url\n            thumbnailClickAnalytics {\n              referrerId\n              linkName\n            }\n          }\n          imageId\n          trackingId\n          impressionAnalytics {\n            referrerId\n            linkName\n          }\n        }\n      }\n      ratePlans {\n        ...RatePlanWithAmenitiesFragment\n      }\n      ratePlansExpando {\n        ...RatePlansExpandoFragment\n      }\n      ...AvailabilityCtaFragment\n      roomAmenities {\n        ...RoomAmenitiesDescriptionFragment\n      }\n      detailsDialog {\n        ...UnitPropertyOffersDetailsDialogFragment\n        toolbar {\n          clientSideAnalytics {\n            referrerId\n            linkName\n          }\n        }\n        trigger {\n          ...LinkTriggerFragment\n          clientSideAnalytics {\n            referrerId\n            linkName\n          }\n        }\n      }\n      spaceDetails {\n        ...SpaceDetailsFragment\n      }\n      ...SleepingArrangementsFragment\n      roomHighlights {\n        ...UnitHighlightsFragment\n      }\n      lodgingReview {\n        ...LodgingReviewSectionFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject101 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject102() {
  var data = _tagged_template_literal(["\n  fragment ListingsFragment on OfferDetails {\n    listings {\n      ...PropertyUnitFragment\n    }\n    categorizedListings {\n      ...PropertyUnitCategorizationFragment\n      ...VerticalMessagingCardFragment\n      ...LodgingSectionHeaderFragment\n    }\n    offerAdaptExSuccessEvents {\n      ...LodgingAdaptExAnalyticsEventFragment\n    }\n    id\n    listingsToggle {\n      ...ListingsToggleFragment\n    }\n    insurtechPrimingCardCategorizedListing {\n      ...InsurtechPrimingCardCategorizedListingFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject102 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject103() {
  var data = _tagged_template_literal(["\n  fragment ErrorMessageFragment on MessageResult {\n    title {\n      text\n    }\n    action {\n      primary {\n        text\n        linkUrl\n      }\n    }\n  }\n"]);
  _templateObject103 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject104() {
  var data = _tagged_template_literal(["\n  fragment ListingsErrorMessageFragment on OfferDetails {\n    errorMessage {\n      ...ErrorMessageFragment\n    }\n  }\n  ", "\n"]);
  _templateObject104 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject105() {
  var data = _tagged_template_literal(["\n  fragment ShoppingContextFragment on OfferDetails {\n    shoppingContext {\n      multiItem {\n        id\n        packageType\n      }\n    }\n  }\n"]);
  _templateObject105 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject106() {
  var data = _tagged_template_literal(["\n  fragment StickyBarDisclaimerFragment on OfferDetails {\n    stickyBar {\n      price {\n        disclaimer {\n          value\n        }\n      }\n    }\n  }\n"]);
  _templateObject106 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject107() {
  var data = _tagged_template_literal(["\n  fragment PropertyOffersFragment on OfferDetails {\n    ...ListingsHeaderFragment\n    ...AlternateDatesFragment\n    ...ListingsErrorMessageFragment\n    ...ListingsFragment\n    ...StickyBarDisclaimerFragment\n    ...ShoppingContextFragment\n    offerLevelMessages {\n      ...MessageResultFragment\n    }\n    offerFilters {\n      ...LodgingOfferFiltersFragment\n    }\n    ...FilterPillsFragment\n    ...PropertyOffersIncludedPerksFragment\n    ...ExperimentalOfferCategoriesSectionFragment\n    clickstreamEvents\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject107 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject108() {
  var data = _tagged_template_literal(["\n  fragment OffersLodgingLinkMessageFragment on LodgingLinkMessage {\n    icon {\n      id\n    }\n    link {\n      clientSideAnalytics {\n        referrerId\n        linkName\n      }\n      uri {\n        relativePath\n        value\n      }\n      referrerId\n    }\n    value\n  }\n"]);
  _templateObject108 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject109() {
  var data = _tagged_template_literal(["\n  fragment PropertySearchLinkFragment on OfferDetails {\n    propertySearchLink {\n      ...OffersLodgingLinkMessageFragment\n    }\n    partnerPropertySearchLink {\n      ...OffersLodgingLinkMessageFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject109 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject110() {
  var data = _tagged_template_literal(["\n  fragment AlternateAvailabilityMsgFragment on LodgingComplexLinkMessage {\n    text {\n      value\n    }\n    actionLink {\n      link {\n        uri {\n          relativePath\n          value\n        }\n      }\n      value\n    }\n  }\n"]);
  _templateObject110 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject111() {
  var data = _tagged_template_literal(["\n  fragment SingleOfferAvailabilityCtaFragment on SingleUnitOfferDetails {\n    availabilityCallToAction {\n      ... on LodgingPlainMessage {\n        value\n      }\n      ... on LodgingButton {\n        text\n      }\n    }\n  }\n"]);
  _templateObject111 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject112() {
  var data = _tagged_template_literal(["\n  fragment PriceMessagesFragment on SingleUnitOfferDetails {\n    displayPrice {\n      priceMessages {\n        ...LodgingEnrichedMessageFragment\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject112 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject113() {
  var data = _tagged_template_literal(["\n  fragment SingleUnitPriceSummaryFragment on RatePlan {\n    ...PropertyOffersPriceChangeMessageFragment\n    ...PropertyRatePlanBadgeFragment\n    priceDetails {\n      pointsApplied\n      ...LodgingPriceSummaryFragment\n      price {\n        ...PropertyPriceFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject113 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject114() {
  var data = _tagged_template_literal(["\n  fragment PropertySingleOfferDetailsFragment on SingleUnitOfferDetails {\n    id\n    ...PriceMessagesFragment\n    ratePlans {\n      ...SingleUnitPriceSummaryFragment\n      ...HighlightedMessagesFragment\n    }\n    ...SingleOfferAvailabilityCtaFragment\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject114 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject115() {
  var data = _tagged_template_literal(["\n  fragment PropertyAffirmDetailsFragment on AffirmInstallmentPlanDetails {\n    apiKey\n    elementAttributes {\n      key\n      value\n    }\n    interactionAnalytics {\n      linkName\n      referrerId\n    }\n    scriptUrl\n  }\n"]);
  _templateObject115 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject116() {
  var data = _tagged_template_literal(["\n  fragment InstallmentPlanFragment on LodgingInstallmentPlan {\n    installmentPlanDetails {\n      ...PropertyAffirmDetailsFragment\n    }\n    impressionAnalytics {\n      linkName\n      referrerId\n    }\n  }\n  ", "\n"]);
  _templateObject116 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject117() {
  var data = _tagged_template_literal(["\n  fragment ReservePropertyFragment on RatePlan {\n    paymentPolicy {\n      paymentType\n      heading\n      descriptions {\n        heading\n        header {\n          text\n          mark {\n            id\n            token\n            url {\n              value\n            }\n          }\n        }\n        items {\n          ...PropertyInfoMessageFragment\n          icon {\n            id\n            token\n          }\n        }\n      }\n      price {\n        ...PropertyPriceFragment\n      }\n    }\n    priceDetails {\n      ...PriceBreakdownSummaryFragment\n    }\n    ...PropertyReserveButtonFragment\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject117 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject118() {
  var data = _tagged_template_literal(["\n  fragment PropertySingleOfferDialogLinkFragment on OfferDetails {\n    singleUnitOfferDialog {\n      content {\n        ...PropertySingleOfferDetailsFragment\n        ratePlans {\n          priceDetails {\n            ...PriceBreakdownSummaryFragment\n            ...PricePresentationDialogFragment\n          }\n          marketingSection {\n            ...MarketingSectionFragment\n          }\n          ...ReservePropertyFragment\n        }\n      }\n      trigger {\n        value\n        secondaryValue\n      }\n      toolbar {\n        icon {\n          description\n        }\n        title\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject118 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject119() {
  var data = _tagged_template_literal(["\n  fragment TotalPriceFragment on SingleUnitOfferDetails {\n    totalPrice {\n      label {\n        ...LodgingEnrichedMessageFragment\n      }\n      amount {\n        ...LodgingEnrichedMessageFragment\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject119 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject120() {
  var data = _tagged_template_literal(["\n  fragment PropertySingleRatePlanFragment on OfferDetails {\n    errorMessage {\n      ...ErrorMessageFragment\n    }\n    alternateAvailabilityMsg {\n      ...AlternateAvailabilityMsgFragment\n    }\n    ...AlternateDatesFragment\n    singleUnitOffer {\n      accessibilityLabel\n      ...TotalPriceFragment\n      ...PropertySingleOfferDetailsFragment\n      ratePlans {\n        priceDetails {\n          ...PriceBreakdownSummaryFragment\n          ...PricePresentationDialogFragment\n        }\n        marketingSection {\n          ...MarketingSectionFragment\n        }\n        shareUrl {\n          accessibilityLabel\n          value\n          link {\n            clientSideAnalytics {\n              linkName\n              referrerId\n            }\n            uri {\n              relativePath\n              value\n            }\n          }\n        }\n        paymentReassuranceMessage {\n          ...LodgingEnrichedMessageFragment\n        }\n        ...ReservePropertyFragment\n      }\n      installmentPlan {\n        ...InstallmentPlanFragment\n      }\n      view\n    }\n    ...PropertySingleOfferDialogLinkFragment\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject120 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject121() {
  var data = _tagged_template_literal(["\n  fragment SingleOfferFragment on OfferDetails {\n    ...PropertySingleRatePlanFragment\n  }\n\n  ", "\n"]);
  _templateObject121 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject122() {
  var data = _tagged_template_literal(["\n  fragment PropertySpaceDetailsFragment on OfferDetails {\n    spaceDetails {\n      ...SpaceDetailsHeaderFragment\n      ...SpaceDetailsSpacesFragment\n      ...SpaceDetailsFloorPlanFragment\n      virtualTourPrompt {\n        ...VirtualTourPromptFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject122 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject123() {
  var data = _tagged_template_literal(["\n  fragment StickyCtaFragment on OfferDetails {\n    stickyBar {\n      stickyButton {\n        text\n        targetRef\n        adaptExSuccessActionTracking {\n          ... on AdaptexCampaignTrackingDetail {\n            campaignId\n            eventTarget\n          }\n        }\n      }\n    }\n    shoppingContext {\n      multiItem {\n        packageType\n      }\n    }\n    ...PropertySingleOfferDialogLinkFragment\n  }\n  ", "\n  ", "\n"]);
  _templateObject123 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject124() {
  var data = _tagged_template_literal(["\n  fragment StickyPropertyPriceFragment on PropertyDetailsStickyBar {\n    qualifier\n    subText\n    price {\n      formattedDisplayPrice\n      accessibilityLabel\n      priceDisclaimer {\n        content\n        primaryUIButton {\n          primary\n        }\n        trigger {\n          icon {\n            id\n            size\n          }\n        }\n      }\n    }\n    propertyPrice {\n      ...PropertyPriceFragment\n    }\n  }\n  ", "\n"]);
  _templateObject124 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject125() {
  var data = _tagged_template_literal(["\n  fragment PropertyStickyBookBarPricePresentationDialogFragment on PropertyDetailsStickyBar {\n    pricePresentationDialog {\n      toolbar {\n        title\n        icon {\n          ...IconFragment\n        }\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n      }\n      trigger {\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n        value\n      }\n    }\n    pricePresentation {\n      title {\n        primary\n      }\n      sections {\n        ...PricePresentationSectionFragment\n      }\n      footer {\n        header\n        messages {\n          ...PriceLineElementFragment\n        }\n      }\n    }\n  }\n\n  fragment PricePresentationSectionFragment on PricePresentationSection {\n    header {\n      name {\n        ...PricePresentationLineItemEntryFragment\n      }\n      enrichedValue {\n        ...PricePresentationLineItemEntryFragment\n      }\n    }\n    subSections {\n      ...PricePresentationSubSectionFragment\n    }\n  }\n\n  fragment PricePresentationSubSectionFragment on PricePresentationSubSection {\n    header {\n      name {\n        primaryMessage {\n          __typename\n          ... on PriceLineText {\n            primary\n          }\n          ... on PriceLineHeading {\n            primary\n          }\n        }\n      }\n      enrichedValue {\n        ...PricePresentationLineItemEntryFragment\n      }\n    }\n    items {\n      ...PricePresentationLineItemFragment\n    }\n  }\n\n  fragment PricePresentationLineItemFragment on PricePresentationLineItem {\n    enrichedValue {\n      ...PricePresentationLineItemEntryFragment\n    }\n    name {\n      ...PricePresentationLineItemEntryFragment\n    }\n  }\n\n  fragment PricePresentationLineItemEntryFragment on PricePresentationLineItemEntry {\n    primaryMessage {\n      ...PriceLineElementFragment\n    }\n    secondaryMessages {\n      ...PriceLineElementFragment\n    }\n  }\n\n  fragment PriceLineElementFragment on PricePresentationLineItemMessage {\n    __typename\n    ...PriceLineTextFragment\n    ...PriceLineHeadingFragment\n    ...PriceLineBadgeFragment\n    ...InlinePriceLineTextFragment\n  }\n\n  fragment PriceLineTextFragment on PriceLineText {\n    __typename\n    theme\n    primary\n    weight\n    additionalInfo {\n      ...AdditionalInformationPopoverFragment\n    }\n    icon {\n      ...IconFragment\n    }\n    graphic {\n      ...UIGraphicFragment\n    }\n  }\n  ", "\n\n  fragment AdditionalInformationPopoverFragment on AdditionalInformationPopover {\n    icon {\n      ...IconFragment\n    }\n    enrichedSecondaries {\n      ...AdditionalInformationPopoverSectionFragment\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n\n  fragment AdditionalInformationPopoverSectionFragment on AdditionalInformationPopoverSection {\n    __typename\n    ... on AdditionalInformationPopoverTextSection {\n      ...AdditionalInformationPopoverTextSectionFragment\n    }\n    ... on AdditionalInformationPopoverListSection {\n      ...AdditionalInformationPopoverListSectionFragment\n    }\n    ... on AdditionalInformationPopoverGridSection {\n      ...AdditionalInformationPopoverGridSectionFragment\n    }\n  }\n\n  fragment AdditionalInformationPopoverTextSectionFragment on AdditionalInformationPopoverTextSection {\n    __typename\n    text {\n      __typename\n      text\n      ... on EGDSStandardLink {\n        standardLinkIcon: icon {\n          ...IconFragment\n        }\n        action {\n          accessibility\n          analytics {\n            linkName\n            referrerId\n          }\n          resource {\n            value\n          }\n          target\n        }\n        iconPosition\n        size\n        text\n      }\n    }\n  }\n\n  fragment AdditionalInformationPopoverListSectionFragment on AdditionalInformationPopoverListSection {\n    __typename\n    content {\n      __typename\n      items {\n        text\n      }\n    }\n  }\n\n  fragment AdditionalInformationPopoverGridSectionFragment on AdditionalInformationPopoverGridSection {\n    __typename\n    subSections {\n      header {\n        name {\n          primaryMessage {\n            ...AdditionalInformationPopoverGridLineItemMessageFragment\n          }\n        }\n      }\n      items {\n        name {\n          ...AdditionalInformationPopoverGridLineItemEntryFragment\n        }\n        enrichedValue {\n          ...AdditionalInformationPopoverGridLineItemEntryFragment\n        }\n      }\n    }\n  }\n\n  fragment AdditionalInformationPopoverGridLineItemEntryFragment on PricePresentationLineItemEntry {\n    primaryMessage {\n      ...AdditionalInformationPopoverGridLineItemMessageFragment\n    }\n    secondaryMessages {\n      ...AdditionalInformationPopoverGridLineItemMessageFragment\n    }\n  }\n\n  fragment AdditionalInformationPopoverGridLineItemMessageFragment on PricePresentationLineItemMessage {\n    ... on PriceLineText {\n      __typename\n      primary\n    }\n    ... on PriceLineHeading {\n      __typename\n      tag\n      size\n      primary\n    }\n  }\n\n  fragment PriceLineHeadingFragment on PriceLineHeading {\n    __typename\n    primary\n    tag\n    size\n    additionalInfo {\n      ...AdditionalInformationPopoverFragment\n    }\n    icon {\n      ...IconFragment\n    }\n  }\n\n  fragment PriceLineBadgeFragment on PriceLineBadge {\n    __typename\n    badge {\n      accessibility\n      text\n      theme\n    }\n  }\n\n  fragment InlinePriceLineTextFragment on InlinePriceLineText {\n    __typename\n    inlineItems {\n      ...PriceLineTextFragment\n    }\n  }\n"]);
  _templateObject125 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject126() {
  var data = _tagged_template_literal(["\n  fragment PropertyUnitListViewElementFragment on LodgingCategorizedUnit {\n    header {\n      text\n    }\n  }\n"]);
  _templateObject126 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject127() {
  var data = _tagged_template_literal(["\n  fragment PropertyUnitListViewFragment on OfferDetails {\n    categorizedListings {\n      ...PropertyUnitListViewElementFragment\n    }\n  }\n  ", "\n"]);
  _templateObject127 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject128() {
  var data = _tagged_template_literal(["\n  fragment PropertyStickyBookBarFragment on OfferDetails {\n    soldOut\n    stickyBar {\n      ...StickyPropertyPriceFragment\n      ...PropertyStickyBookBarPricePresentationDialogFragment\n      structuredData {\n        itemprop\n        itemscope\n        itemtype\n        content\n      }\n    }\n    ...StickyCtaFragment\n    ...PropertySingleOfferDialogLinkFragment\n    ...PropertyUnitListViewFragment\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject128 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject129() {
  var data = _tagged_template_literal(["\n  fragment PropertyStickyPriceHeaderFragment on OfferDetails {\n    soldOut\n    stickyBar {\n      ...StickyPropertyPriceFragment\n    }\n    ...StickyCtaFragment\n  }\n  ", "\n  ", "\n"]);
  _templateObject129 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject130() {
  var data = _tagged_template_literal(["\n  fragment TripSummaryFragment on TripSummaryContent {\n    header {\n      text\n    }\n    summary {\n      value\n    }\n    installmentPlanOptions {\n      totalPrice\n      textRequired\n    }\n    price {\n      options {\n        leadingCaption\n        displayPrice {\n          formatted\n        }\n        loyaltyPrice {\n          unit\n          amount {\n            formatted\n          }\n          totalStrikeOutPoints {\n            formatted\n          }\n        }\n        strikeOut {\n          formatted\n        }\n        accessibilityLabel\n        priceDisclaimer {\n          content\n          primaryButton {\n            text\n          }\n          tertiaryUIButton {\n            primary\n            action {\n              analytics {\n                referrerId\n                linkName\n              }\n            }\n          }\n          trigger {\n            icon {\n              id\n              description\n            }\n            clientSideAnalytics {\n              linkName\n              referrerId\n            }\n            value\n          }\n        }\n        ...PriceHeaderDialogFragment\n      }\n      priceMessaging {\n        value\n      }\n    }\n    tripSummaryHeaderBanner {\n      ...EGDSStandardMessageFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject130 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject131() {
  var data = _tagged_template_literal(["\n  fragment PropertyTripSummaryFragment on OfferDetails {\n    tripSummary {\n      ...TripSummaryFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject131 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject132() {
  var data = _tagged_template_literal(["\n  fragment SingleOfferSearchFragment on OfferDetails {\n    errorMessage {\n      title {\n        text\n      }\n      action {\n        primary {\n          text\n          linkUrl\n        }\n      }\n    }\n    searchCriteria {\n      primary {\n        dateRange {\n          checkInDate {\n            month\n          }\n        }\n      }\n    }\n    singleUnitOffer {\n      ratePlans {\n        id\n      }\n    }\n  }\n"]);
  _templateObject132 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject133() {
  var data = _tagged_template_literal(["\n  fragment EGDSTravelersFragment on EGDSTravelers {\n    adults {\n      ...EGDSTravelerStepInputFragment\n    }\n    children {\n      count {\n        ...EGDSTravelerStepInputFragment\n      }\n      ages {\n        ...EGDSTravelerChildAgeSelectFragment\n      }\n    }\n    pets {\n      ...EGDSBasicCheckBoxFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject133 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject134() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicTravelerSelectorFragment on EGDSBasicTravelerSelector {\n    doneButton {\n      ...LodgingEGDSButtonFragment\n    }\n    title\n    travelers {\n      ...EGDSTravelersFragment\n    }\n    validations {\n      ... on EGDSTravelersInputValidation {\n        errorMessage\n        maxCount\n        type\n      }\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject134 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject135() {
  var data = _tagged_template_literal(["\n  fragment EGDSOpenTravelerSelectorActionFragment on EGDSOpenTravelerSelectorAction {\n    travelerSelector {\n      title\n      ... on EGDSBasicTravelerSelector {\n        ...EGDSBasicTravelerSelectorFragment\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject135 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject136() {
  var data = _tagged_template_literal(["\n  fragment EGDSSearchFormTravelersFieldFragment on EGDSSearchFormTravelersField {\n    action {\n      ...EGDSOpenTravelerSelectorActionFragment\n    }\n    egdsElementId\n    label\n    labelTemplate {\n      ... on EGDSCardinalLocalizedText {\n        models {\n          key\n          source\n        }\n        templates {\n          category\n          template\n        }\n        secondaryTemplates {\n          category\n          template\n        }\n        text\n      }\n    }\n    readOnly\n    value\n  }\n  ", "\n"]);
  _templateObject136 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject137() {
  var data = _tagged_template_literal(["\n  fragment OffersTravelerSelectorFragment on OffersTravelerSelector {\n    travelers {\n      ...EGDSSearchFormTravelersFieldFragment\n    }\n  }\n  ", "\n"]);
  _templateObject137 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject138() {
  var data = _tagged_template_literal(["\n  fragment UnitsCarouselFragment on OfferDetails {\n    unitsCarousel {\n      carousel {\n        nextButton {\n          __typename\n          icon {\n            description\n          }\n        }\n        previousButton {\n          __typename\n          icon {\n            description\n          }\n        }\n      }\n      heading {\n        ... on EGDSStylizedText {\n          text\n        }\n      }\n      impressionAnalytics {\n        linkName\n        referrerId\n      }\n      items {\n        ... on LodgingUnitCard {\n          ...LodgingUnitCardFragment\n        }\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject138 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject139() {
  var data = _tagged_template_literal(["\n  fragment PropertyContentItemLodgingLinkMessageFragment on LodgingLinkMessage {\n    icon {\n      id\n      __typename\n    }\n    link {\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      uri {\n        relativePath\n        value\n        __typename\n      }\n      target\n      __typename\n    }\n    value\n    accessibilityLabel\n    __typename\n  }\n"]);
  _templateObject139 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject140() {
  var data = _tagged_template_literal(["\n  fragment OffersPropertyContentItemTextFragment on PropertyContentItemText {\n    content {\n      primary {\n        value\n        badge {\n          icon_temp {\n            id\n            description\n            title\n            __typename\n          }\n          mark {\n            id\n            description\n            __typename\n          }\n          text\n          theme_temp\n          __typename\n        }\n        __typename\n      }\n      __typename\n    }\n  }\n"]);
  _templateObject140 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject141() {
  var data = _tagged_template_literal(["\n  fragment VipAccessModuleDetailFragment on PropertyContentSectionGroup {\n    sections {\n      sectionName\n      header {\n        text\n      }\n      bodySubSections {\n        elementsV2 {\n          elements {\n            __typename\n            ... on PropertyContent {\n              items {\n                __typename\n                ...OffersPropertyContentItemTextFragment\n                ...PropertyContentItemLodgingLinkMessageFragment\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject141 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject142() {
  var data = _tagged_template_literal(["\n  fragment PropertyHighlightSectionFragment on PropertyHighlightSection {\n    label\n    header {\n      badge {\n        text\n        theme_temp\n      }\n      mark {\n        id\n        description\n      }\n      text\n    }\n    subSections {\n      description\n      contents {\n        icon {\n          id\n          withBackground\n          description\n        }\n        value\n      }\n    }\n    footerLink {\n      icon {\n        id\n      }\n      link {\n        referrerId\n        uri {\n          relativePath\n          value\n        }\n        target\n      }\n      value\n      accessibilityLabel\n    }\n  }\n"]);
  _templateObject142 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject143() {
  var data = _tagged_template_literal(["\n  fragment VipMessagingCardFragment on OfferDetails {\n    propertyHighlightSection {\n      ...PropertyHighlightSectionFragment\n    }\n    propertyContentSectionGroup {\n      ...VipAccessModuleDetailFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject143 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject144() {
  var data = _tagged_template_literal(["\n  query PropertyOffersQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $searchCriteria: PropertySearchCriteriaInput\n    $shoppingContext: ShoppingContextInput\n    $travelAdTrackingInfo: PropertyTravelAdTrackingInfoInput\n    $searchOffer: SearchOfferInput\n    $referrer: String\n    $productIdentifier: ProductIdentifierInput\n  ) {\n    propertyOffers(\n      context: $context\n      propertyId: $propertyId\n      referrer: $referrer\n      searchCriteria: $searchCriteria\n      searchOffer: $searchOffer\n      shoppingContext: $shoppingContext\n      travelAdTrackingInfo: $travelAdTrackingInfo\n      productIdentifier: $productIdentifier\n    ) {\n      id\n      loading {\n        accessibilityLabel\n      }\n      ...PropertyLevelOffersMessageFragment\n      ...PropertyLevelOffersCardFragment\n      ...ListingsHeaderFragment\n      ...VipMessagingCardFragment\n      ...DamageAndIncidentalsCardFragment\n      ...NewVipModuleFragment\n      ...PriceInsightFragment\n      ...PropertyTripSummaryFragment\n      ...SingleOfferFragment\n      ...PropertyStickyBookBarFragment\n      ...PropertyStickyPriceHeaderFragment\n      ...PropertyOffersFragment\n      ...PropertySpaceDetailsFragment\n      ...PropertySearchLinkFragment\n      ...PropertyUnitListViewFragment\n      ...FilterPillsFragment\n      ...LoyaltyDiscountToggleFragment\n      ...LegalDisclaimerFragment\n      ...HighlightedBenefitsFragment\n      ...LodgingOneKeyBurnSwitchFragment\n      ...UnitsCarouselFragment\n    }\n    offersTravelerSelector(context: $context, searchCriteria: $searchCriteria, propertyId: $propertyId) {\n      ...OffersTravelerSelectorFragment\n    }\n    cancellationPolicyInfo(\n      context: $context\n      propertyId: $propertyId\n      searchCriteria: $searchCriteria\n      shoppingContext: $shoppingContext\n      searchOffer: $searchOffer\n    ) {\n      ...CancellationPolicyInfoFragment\n    }\n  }\n\n  # fragments for the main components\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject144 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject145() {
  var data = _tagged_template_literal(["\n  query RoomsAndRatesPropertyOffersQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $searchCriteria: PropertySearchCriteriaInput\n    $shoppingContext: ShoppingContextInput\n    $travelAdTrackingInfo: PropertyTravelAdTrackingInfoInput\n    $searchOffer: SearchOfferInput\n    $referrer: String\n    $productIdentifier: ProductIdentifierInput\n  ) {\n    propertyOffers(\n      context: $context\n      propertyId: $propertyId\n      referrer: $referrer\n      searchCriteria: $searchCriteria\n      searchOffer: $searchOffer\n      shoppingContext: $shoppingContext\n      travelAdTrackingInfo: $travelAdTrackingInfo\n      productIdentifier: $productIdentifier\n    ) {\n      ...PropertyOffersFragment\n    }\n  }\n  ", "\n"]);
  _templateObject145 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject146() {
  var data = _tagged_template_literal(["\n  query AncillaryPropertyOffersQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $searchCriteria: PropertySearchCriteriaInput\n    $shoppingContext: ShoppingContextInput\n    $travelAdTrackingInfo: PropertyTravelAdTrackingInfoInput\n    $searchOffer: SearchOfferInput\n    $referrer: String\n  ) {\n    propertyOffers(\n      context: $context\n      propertyId: $propertyId\n      referrer: $referrer\n      searchCriteria: $searchCriteria\n      searchOffer: $searchOffer\n      shoppingContext: $shoppingContext\n      travelAdTrackingInfo: $travelAdTrackingInfo\n    ) {\n      id\n      loading {\n        accessibilityLabel\n      }\n      ...PropertyLevelOffersMessageFragment\n      ...PropertyLevelOffersCardFragment\n      ...ListingsHeaderFragment\n      ...VipMessagingCardFragment\n      ...DamageAndIncidentalsCardFragment\n      ...NewVipModuleFragment\n      ...PriceInsightFragment\n      ...PropertyTripSummaryFragment\n      ...SingleOfferFragment\n      ...PropertyStickyBookBarFragment\n      ...PropertyStickyPriceHeaderFragment\n      ...PropertySpaceDetailsFragment\n      ...PropertySearchLinkFragment\n      ...PropertyUnitListViewFragment\n      ...FilterPillsFragment\n      ...LoyaltyDiscountToggleFragment\n      ...LegalDisclaimerFragment\n      ...HighlightedBenefitsFragment\n      ...LodgingOneKeyBurnSwitchFragment\n      ...UnitsCarouselFragment\n    }\n    offersTravelerSelector(context: $context, searchCriteria: $searchCriteria, propertyId: $propertyId) {\n      ...OffersTravelerSelectorFragment\n    }\n    cancellationPolicyInfo(\n      context: $context\n      propertyId: $propertyId\n      searchCriteria: $searchCriteria\n      shoppingContext: $shoppingContext\n      searchOffer: $searchOffer\n    ) {\n      ...CancellationPolicyInfoFragment\n    }\n  }\n\n  # fragments for the main components\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject146 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject147() {
  var data = _tagged_template_literal(["\n  fragment CancellationChangeFragment on LodgingPlainDialog {\n    trigger {\n      theme\n      value\n    }\n    content\n    primaryUIButton {\n      primary\n    }\n  }\n"]);
  _templateObject147 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject148() {
  var data = _tagged_template_literal(["\n  fragment LodgingChangeShoppingBannerTextFragment on LodgingChangeShoppingBannerText {\n    ...EGDSPlainTextFragment\n    ...EGDSStylizedTextFragment\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject148 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject149() {
  var data = _tagged_template_literal(["\n  fragment LodgingErrorBannerFragment on LodgingChangeShoppingBanner {\n    graphic {\n      ...UIGraphicFragment\n    }\n    content {\n      ...LodgingChangeShoppingBannerTextFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject149 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject150() {
  var data = _tagged_template_literal(["\n  fragment LodgingChangeContentElementFragment on ShoppingProductContentElement {\n    ... on ShoppingProductContent {\n      header {\n        icon {\n          ...IconFragment\n        }\n        text\n      }\n      impressionAnalytics {\n        linkName\n        referrerId\n      }\n      items {\n        ... on EGDSPlainText {\n          text\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject150 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject151() {
  var data = _tagged_template_literal(["\n  fragment LodgingChangeContentElementGroupFragment on ShoppingProductContentElementGroup {\n    elements {\n      ...LodgingChangeContentElementFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject151 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject152() {
  var data = _tagged_template_literal(["\n  fragment LodgingChangeContentSubSectionFragment on ShoppingProductContentSubSection {\n    elements {\n      ...LodgingChangeContentElementGroupFragment\n    }\n    header {\n      text\n    }\n  }\n\n  ", "\n"]);
  _templateObject152 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject153() {
  var data = _tagged_template_literal(["\n  fragment LodgingChangeContentSectionFragment on ShoppingProductContentSection {\n    subSections {\n      ...LodgingChangeContentSubSectionFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject153 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject154() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextListItemFragment on EGDSTextListItem {\n    ... on EGDSTextIconListItem {\n      ...EGDSTextIconListItemFragment\n    }\n    ... on EGDSTextStandardListItem {\n      ...EGDSTextStandardListItemFragment\n    }\n  }\n\n  fragment EGDSTextIconListItemFragment on EGDSTextIconListItem {\n    accessibilityLabel\n    icon {\n      id\n    }\n    subText\n    text\n    __typename\n  }\n\n  fragment EGDSTextStandardListItemFragment on EGDSTextStandardListItem {\n    accessibilityLabel\n    subText\n    text\n    __typename\n  }\n"]);
  _templateObject154 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject155() {
  var data = _tagged_template_literal(["\n  fragment CriteriaPlaybackCardFragment on LodgingCriteriaPlaybackCard {\n    title\n    criteriaType\n    criteria {\n      ...EGDSTextListItemFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject155 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject156() {
  var data = _tagged_template_literal(["\n  fragment LodgingPricePresentationFragment on PricePresentation {\n    title {\n      primary\n    }\n    sections {\n      ...LodgingPricePresentationSectionFragment\n    }\n    footer {\n      header\n      messages {\n        ...ChangeShoppingPriceLineTextFragment\n      }\n    }\n  }\n  fragment LodgingPricePresentationSectionFragment on PricePresentationSection {\n    header {\n      name {\n        primaryMessage {\n          ...ChangeShoppingPriceLineTextFragment\n        }\n      }\n      enrichedValue {\n        primaryMessage {\n          ...ChangeShoppingPriceLineTextFragment\n        }\n      }\n    }\n    subSections {\n      ...ChangeShoppingPricePresentationSubSectionFragment\n    }\n  }\n  fragment ChangeShoppingPricePresentationSubSectionFragment on PricePresentationSubSection {\n    header {\n      name {\n        primaryMessage {\n          __typename\n          ... on PriceLineText {\n            primary\n          }\n        }\n      }\n      enrichedValue {\n        ...LodgingPricePresentationLineItemEntryFragment\n      }\n    }\n    items {\n      ...ChangeShoppingPricePresentationLineItemFragment\n    }\n  }\n  fragment ChangeShoppingPricePresentationLineItemFragment on PricePresentationLineItem {\n    enrichedValue {\n      ...LodgingPricePresentationLineItemEntryFragment\n    }\n    name {\n      ...LodgingPricePresentationLineItemEntryFragment\n    }\n  }\n  fragment LodgingPricePresentationLineItemEntryFragment on PricePresentationLineItemEntry {\n    primaryMessage {\n      ...ChangeShoppingPriceLineHeadingFragment\n      ...ChangeShoppingPriceLineTextFragment\n    }\n    secondaryMessages {\n      ...ChangeShoppingPriceLineHeadingFragment\n      ...ChangeShoppingPriceLineTextFragment\n    }\n  }\n  fragment ChangeShoppingPriceLineTextFragment on PriceLineText {\n    __typename\n    theme\n    primary\n    weight\n    icon {\n      id\n      description\n      size\n    }\n    graphic {\n      ...ChangeShoppingUIGraphicFragment\n    }\n  }\n  fragment ChangeShoppingUIGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...IconFragments\n    }\n    ... on Mark {\n      ...MarkFragments\n    }\n    ... on Illustration {\n      ...IllustrationFragments\n    }\n  }\n  fragment IconFragments on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n  }\n  fragment MarkFragments on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        __typename\n        relativePath\n        value\n      }\n    }\n  }\n  fragment IllustrationFragments on Illustration {\n    description\n    id\n    link: url\n  }\n  fragment ChangeShoppingPriceLineHeadingFragment on PriceLineHeading {\n    __typename\n    primary\n    tag\n    size\n    icon {\n      id\n      description\n      size\n    }\n  }\n"]);
  _templateObject156 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject157() {
  var data = _tagged_template_literal(["\n  fragment LodgingPricePresentationExpandoFragment on LodgingPricePresentationExpando {\n    collapsedAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    collapsedLabel {\n      ...ChangeShoppingPricePresentationLineItemFragment\n    }\n    expandedAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    expandedLabel {\n      ...ChangeShoppingPricePresentationLineItemFragment\n    }\n  }\n\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n    uisPrimeMessages {\n      schemaName\n      messageContent\n    }\n  }\n"]);
  _templateObject157 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject158() {
  var data = _tagged_template_literal(["\n  fragment PricePlaybackDetailsFragment on LodgingChangePriceDetails {\n    content {\n      ...LodgingPricePresentationFragment\n    }\n    expando {\n      ...LodgingPricePresentationExpandoFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject158 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject159() {
  var data = _tagged_template_literal(["\n  fragment LodgingChangePlaybackButtonFragment on LodgingChangePlaybackButton {\n    action\n    button {\n      ... on UIPrimaryButton {\n        primary\n        analytics {\n          ...ClientSideAnalyticsFragment\n        }\n      }\n      ... on UISecondaryButton {\n        primary\n        analytics {\n          ...ClientSideAnalyticsFragment\n        }\n      }\n      ... on UITertiaryButton {\n        primary\n        analytics {\n          ...ClientSideAnalyticsFragment\n        }\n      }\n    }\n    toggledText\n  }\n  ", "\n"]);
  _templateObject159 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject160() {
  var data = _tagged_template_literal(["\n  fragment DetailsDisclaimerFragment on LodgingChangeShoppingBanner {\n    graphic {\n      ...UIGraphicFragment\n    }\n    content {\n      ...LodgingChangeShoppingBannerTextFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject160 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject161() {
  var data = _tagged_template_literal(["\n  fragment LodgingChangeListingsFragment on LodgingChangeListings {\n    listings {\n      ...PropertyUnitCategorizationFragment\n    }\n    banner {\n      ...DetailsDisclaimerFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject161 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject162() {
  var data = _tagged_template_literal(["\n  fragment LodgingChangePlaybackSectionFragment on LodgingChangePlaybackSection {\n    sectionId\n    title\n    separator {\n      graphic {\n        ... on Icon {\n          id\n          description\n        }\n      }\n      accessibilityLabel\n    }\n    items {\n      ...CriteriaPlaybackCardFragment\n      ...LodgingChangeListingsFragment\n      ...LodgingChangePlaybackButtonFragment\n      ...LodgingMicroCardFragment\n      ...PricePlaybackDetailsFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject162 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject163() {
  var data = _tagged_template_literal(["\n  fragment TotalDifferenceFragment on PricePresentationSection {\n    header {\n      name {\n        ...TotalDifferenceLineItemEntryFragment\n      }\n      enrichedValue {\n        ...TotalDifferenceLineItemEntryFragment\n      }\n      accessibilityLabel\n    }\n  }\n\n  fragment TotalDifferenceLineItemEntryFragment on PricePresentationLineItemEntry {\n    primaryMessage {\n      ... on PriceLineHeading {\n        primary\n      }\n    }\n  }\n"]);
  _templateObject163 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject164() {
  var data = _tagged_template_literal(["\n  query ChangeShoppingQuery(\n    $context: ContextInput!\n    $tripId: String!\n    $orderNumber: String\n    $orderLineNumber: String\n    $searchCriteria: PropertySearchCriteriaInput!\n    $changeType: String\n  ) {\n    changeOffers(\n      context: $context\n      tripId: $tripId\n      orderNumber: $orderNumber\n      orderLineNumber: $orderLineNumber\n      searchCriteria: $searchCriteria\n      changeType: $changeType\n    ) {\n      comboChangeType\n      propertyId\n      title\n      subtitle\n      banner {\n        ...LodgingErrorBannerFragment\n      }\n      callToAction {\n        ...ChangeOfferCallToActionFragment\n      }\n      changeYourOptionsLink {\n        action {\n          analytics {\n            linkName\n            referrerId\n          }\n          accessibility\n        }\n      }\n      changePlaybackSections {\n        ...LodgingChangePlaybackSectionFragment\n      }\n      cancellationChange {\n        ...CancellationChangeFragment\n      }\n      totalDifference {\n        ...TotalDifferenceFragment\n      }\n      messaging {\n        ...LodgingChangeContentSectionFragment\n      }\n      errorRedirectUrlPath\n      impressionAnalytics {\n        event\n        linkName\n        referrerId\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject164 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject165() {
  var data = _tagged_template_literal(["\n  query LodgingBookingPlaybackQuery($context: ContextInput!, $changeType: String, $tripId: String!, $offerKey: PropertyNaturalKeyInput) {\n    lodgingBookingPlayback(context: $context, changeType: $changeType, tripId: $tripId, offerKey: $offerKey) {\n      changePlaybackSections {\n        ...LodgingChangePlaybackSectionFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject165 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject166() {
  var data = _tagged_template_literal(["\n  fragment ChangeShoppingNavigationLinkActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n    }\n    resource {\n      value\n    }\n  }\n"]);
  _templateObject166 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject167() {
  var data = _tagged_template_literal(["\n  query BasicPropertyOffersQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $searchCriteria: PropertySearchCriteriaInput\n    $shoppingContext: ShoppingContextInput\n    $searchOffer: SearchOfferInput\n  ) {\n    propertyOffers(\n      context: $context\n      propertyId: $propertyId\n      searchCriteria: $searchCriteria\n      searchOffer: $searchOffer\n      shoppingContext: $shoppingContext\n    ) {\n      ...ListingsHeaderFragment\n      ...ListingsFragment\n      ...ShoppingContextFragment\n      offerFilters {\n        ...LodgingOfferFiltersFragment\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject167 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject168() {
  var data = _tagged_template_literal(["\n  query RoomDetailsQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $searchCriteria: PropertySearchCriteriaInput\n    $shoppingContext: ShoppingContextInput\n    $travelAdTrackingInfo: PropertyTravelAdTrackingInfoInput\n    $searchOffer: SearchOfferInput\n    $referrer: String\n  ) {\n    propertyOffers(\n      context: $context\n      propertyId: $propertyId\n      referrer: $referrer\n      searchCriteria: $searchCriteria\n      searchOffer: $searchOffer\n      shoppingContext: $shoppingContext\n      travelAdTrackingInfo: $travelAdTrackingInfo\n    ) {\n      units {\n        ...PropertyUnitFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject168 = function _templateObject() {
    return data;
  };
  return data;
}
var __defProp = Object.defineProperty;
var __export = function (target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
// src/components/property-offers.tsx
import React194, { useRef as useRef5 } from "react";
import { gql as gql142, useQuery } from "@apollo/client";
import { useBexApi as useBexApi9 } from "@shared-ui/bex-api-context";
import { useExperiment as useExperiment12 } from "@shared-ui/experiment-context";
// src/context/property-offers-context.tsx
import React from "react";
var defaultPropertyOffersContext = {
  availableRooms: false,
  setAvailableRooms: function () {},
  isLoading: false,
  setIsLoading: function () {}
};
var PropertyOffersContext = React.createContext(defaultPropertyOffersContext);
var PropertyOffersContextProvider = function (param) {
  var children = param.children;
  var _React_useState = _sliced_to_array(React.useState(false), 2),
    availableRooms = _React_useState[0],
    setAvailableRooms = _React_useState[1];
  var _React_useState1 = _sliced_to_array(React.useState(false), 2),
    isLoading = _React_useState1[0],
    setIsLoading = _React_useState1[1];
  var providerValues = {
    availableRooms: availableRooms,
    setAvailableRooms: setAvailableRooms,
    isLoading: isLoading,
    setIsLoading: setIsLoading
  };
  var value = React.useMemo(function () {
    return _object_spread({}, providerValues);
  }, [providerValues]);
  return /* @__PURE__ */React.createElement(PropertyOffersContext.Provider, {
    value: value
  }, children);
};
var usePropertyOffersContext = function () {
  return React.useContext(PropertyOffersContext);
};
// src/components/cancellation-policy-info/cancellation-policy-info.tsx
import React2 from "react";
import { gql } from "@apollo/client";
import { EGDSCard, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSLayoutFlex } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading } from "@egds/react-core/text";
import { LodgingDetailedTimeline } from "@shared-ui/lodging-fragments";
var __CancellationPolicyInfoFragment = gql(_templateObject());
var CancellationPolicyInfo = function (param) {
  var data = param.data;
  var title = data.title.text;
  var policyContent = data.policyContent;
  return /* @__PURE__ */React2.createElement(EGDSSpacing, {
    padding: {
      block: "six",
      large: {
        inline: "six"
      },
      extra_large: {
        inline: "six"
      }
    }
  }, /* @__PURE__ */React2.createElement(EGDSCard, null, /* @__PURE__ */React2.createElement(EGDSCardContentSection, null, /* @__PURE__ */React2.createElement(EGDSLayoutGrid, {
    space: "six",
    columns: {
      medium: 1,
      large: 3
    }
  }, /* @__PURE__ */React2.createElement(EGDSLayoutGridItem, {
    colSpan: 1
  }, title && /* @__PURE__ */React2.createElement(EGDSLayoutFlex, {
    direction: "column"
  }, /* @__PURE__ */React2.createElement(EGDSHeading, {
    tag: "h2",
    size: 4
  }, title))), /* @__PURE__ */React2.createElement(EGDSLayoutGridItem, {
    colSpan: {
      medium: 1,
      large: 2
    }
  }, /* @__PURE__ */React2.createElement(EGDSLayoutFlex, {
    direction: "column"
  }, /* @__PURE__ */React2.createElement(LodgingDetailedTimeline, {
    data: policyContent
  })))))));
};
CancellationPolicyInfo.fragment = __CancellationPolicyInfoFragment;
CancellationPolicyInfo.displayName = "CancellationPolicyInfo";
// src/components/damage-and-incidentals-card/damage-and-incidentals-card.tsx
import React3 from "react";
import { gql as gql2 } from "@apollo/client";
import { PropertyContentSectionGroup } from "@shared-ui/lodging-fragments";
var fragment = gql2(_templateObject1(), PropertyContentSectionGroup.fragment);
var DamageAndIncidentalsCard = function (param) {
  var data = param.data;
  var propertyContentSectionGroup = data.propertyContentSectionGroup;
  if (!propertyContentSectionGroup) {
    return null;
  }
  return /* @__PURE__ */React3.createElement(PropertyContentSectionGroup, {
    data: propertyContentSectionGroup
  });
};
DamageAndIncidentalsCard.fragment = fragment;
DamageAndIncidentalsCard.displayName = "DamageAndIncidentalsCard";
// src/components/filter-pills/filter-pills.tsx
import React5 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSPillContainer, EGDSRemovablePill } from "@egds/react-core/pill";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
// src/components/__private/context/link-component-context.tsx
import React4, { useMemo } from "react";
var DefaultLinkWrapper = function (_param) {
  var children = _param.children,
    props = _object_without_properties(_param, ["children"]);
  return /* @__PURE__ */React4.createElement("a", _object_spread({}, props), children);
};
var LinkComponentContext = React4.createContext({
  Link: DefaultLinkWrapper
});
var useLinkComponent = function () {
  return React4.useContext(LinkComponentContext);
};
var LinkComponentProvider = function (param) {
  var Link = param.Link,
    children = param.children;
  return /* @__PURE__ */React4.createElement(LinkComponentContext.Provider, {
    value: useMemo(function () {
      return {
        Link: Link || DefaultLinkWrapper
      };
    }, [Link])
  }, children);
};
// src/components/filter-pills/filter-pills.tsx
var __FilterPillsFragment = gql3(_templateObject2());
var FilterPills = function (param) {
  var data = param.data;
  var clickTracker = useClickTracker();
  var Link = useLinkComponent().Link;
  var filterPills = data.filterPills;
  if (!(filterPills === null || filterPills === void 0 ? void 0 : filterPills.length)) {
    return null;
  }
  var pills = filterPills.map(function (pill) {
    var type = pill.type,
      value = pill.value,
      pillLabel = pill.pillLabel,
      query = pill.query;
    var onClick = function () {
      return clickTracker("RoomFilter.".concat(value, ".Off"), "pill link");
    };
    var child = /* @__PURE__ */React5.createElement(EGDSRemovablePill, {
      id: "".concat(type, "-").concat(value),
      onClick: onClick
    }, pillLabel);
    return query ? /* @__PURE__ */React5.createElement(Link, {
      key: pillLabel,
      href: query
    }, child) : /* @__PURE__ */React5.createElement(React5.Fragment, {
      key: pillLabel
    }, child);
  });
  return /* @__PURE__ */React5.createElement(EGDSSpacing2, {
    margin: {
      block: "three"
    }
  }, /* @__PURE__ */React5.createElement("div", null, /* @__PURE__ */React5.createElement(Viewport, null, /* @__PURE__ */React5.createElement(ViewSmall, null, /* @__PURE__ */React5.createElement(EGDSPillContainer, null, pills)), /* @__PURE__ */React5.createElement(ViewLarge, null, /* @__PURE__ */React5.createElement(EGDSPillContainer, {
    wrap: true
  }, pills)))));
};
FilterPills.displayName = "FilterPills";
FilterPills.fragment = __FilterPillsFragment;
// src/components/highlighted-benefits/index.tsx
import React6 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSIcon } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2, FitContent } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSText } from "@egds/react-core/text";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
var __HighlightedBenefitsFragment = gql4(_templateObject3());
var HighlightedBenefits = function (param) {
  var data = param.data;
  var _data_highlightedBenefits;
  var listItems = data === null || data === void 0 ? void 0 : (_data_highlightedBenefits = data.highlightedBenefits) === null || _data_highlightedBenefits === void 0 ? void 0 : _data_highlightedBenefits.listItems;
  if (!listItems || !listItems.length) {
    return null;
  }
  var renderGrid = function () {
    return /* @__PURE__ */React6.createElement(EGDSSpacing3, {
      padding: {
        blockend: "six"
      }
    }, /* @__PURE__ */React6.createElement(EGDSLayoutGrid2, {
      columns: [FitContent("48x"), FitContent("48x")],
      space: "six"
    }, listItems.map(function (param, index) {
      var icon = param.icon,
        text = param.text,
        impressionAnalytics = param.impressionAnalytics;
      return /* @__PURE__ */React6.createElement(IntersectionTracker, {
        trackOnce: true,
        referrerId: "".concat(impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId),
        linkName: text,
        intersectionOptions: {
          threshold: 1
        },
        key: index
      }, /* @__PURE__ */React6.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React6.createElement(EGDSLayoutFlex2, null, /* @__PURE__ */React6.createElement(EGDSLayoutFlexItem, {
        alignSelf: "center"
      }, /* @__PURE__ */React6.createElement(EGDSSpacing3, {
        margin: {
          inlineend: "two"
        }
      }, /* @__PURE__ */React6.createElement(EGDSIcon, {
        name: icon.id,
        theme: "positive"
      }))), /* @__PURE__ */React6.createElement(EGDSLayoutFlexItem, {
        alignSelf: "center"
      }, /* @__PURE__ */React6.createElement(EGDSText, {
        theme: "positive"
      }, text)))));
    })));
  };
  return renderGrid();
};
HighlightedBenefits.displayName = "HighlightedBenefits";
HighlightedBenefits.fragment = __HighlightedBenefitsFragment;
// src/components/highlighted-benefits/placeholder.tsx
import React7 from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem3, MinMax } from "@egds/react-core/layout-grid";
import { EGDSLineSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
var HighlightedBenefitsPlaceholder = function () {
  return /* @__PURE__ */React7.createElement(EGDSSpacing4, {
    padding: {
      blockend: "six"
    }
  }, /* @__PURE__ */React7.createElement(EGDSLayoutGrid3, {
    columns: [MinMax("16x", "40x"), MinMax("16x", "40x")],
    space: "six",
    alignItems: "center"
  }, /* @__PURE__ */React7.createElement(EGDSLayoutGridItem3, null, /* @__PURE__ */React7.createElement(EGDSLineSkeleton, {
    animation: false,
    type: "primary"
  })), /* @__PURE__ */React7.createElement(EGDSLayoutGridItem3, null, /* @__PURE__ */React7.createElement(EGDSLineSkeleton, {
    animation: false,
    type: "primary"
  }))));
};
// src/components/inputs-context.tsx
import React8 from "react";
var defaultInputs = {
  propertyId: ""
};
var InputsContext = React8.createContext(defaultInputs);
var usePropertyOffersInputs = function () {
  return React8.useContext(InputsContext);
};
var InputsProvider = function (param) {
  var children = param.children,
    inputs = param.inputs;
  return /* @__PURE__ */React8.createElement(InputsContext.Provider, {
    value: inputs
  }, children);
};
// src/components/legal-disclaimer/legal-disclaimer.tsx
import React9 from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSCard as EGDSCard2 } from "@egds/react-core/cards";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
var __LegalDisclaimerFragment = gql5(_templateObject4());
var LegalDisclaimer = function (param) {
  var data = param.data;
  var legalDisclaimer = data.legalDisclaimer;
  if (!legalDisclaimer || legalDisclaimer.content.length === 0) {
    return null;
  }
  var legalDisclaimerHTMLContent = legalDisclaimer.content.filter(function (content) {
    return content.markupType === "HTML";
  }).map(function (content) {
    return content.text;
  }).join("<br/><br/>");
  return /* @__PURE__ */React9.createElement(EGDSSpacing5, {
    margin: {
      block: "four"
    }
  }, /* @__PURE__ */React9.createElement(EGDSCard2, {
    padded: true
  }, /* @__PURE__ */React9.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: legalDisclaimerHTMLContent
    }
  })));
};
LegalDisclaimer.fragment = __LegalDisclaimerFragment;
LegalDisclaimer.displayName = "LegalDisclaimer";
// src/components/lodging-one-key-burn-switch/lodging-one-key-burn-switch.tsx
import React10 from "react";
import { gql as gql6 } from "@apollo/client";
import { clientSideAnalyticsFragment, UiGraphic } from "@shared-ui/lodging-fragments";
import { OneKeyBurnSwitch } from "@shared-ui/retail-loyalty-one-key-burn-switch";
var __LodgingOneKeyBurnSwitchFragment = gql6(_templateObject5(), clientSideAnalyticsFragment, UiGraphic.fragment);
var LodgingOneKeyBurnSwitch = function (param) {
  var data = param.data,
    handler = param.handler,
    markSize = param.markSize,
    className = param.className;
  if (!data.lodgingOneKeyBurnSwitch) {
    return null;
  }
  return /* @__PURE__ */React10.createElement(OneKeyBurnSwitch, {
    className: className,
    data: data.lodgingOneKeyBurnSwitch,
    handler: handler,
    markSize: markSize
  });
};
LodgingOneKeyBurnSwitch.displayName = "LodgingOneKeyBurnSwitch";
LodgingOneKeyBurnSwitch.fragment = __LodgingOneKeyBurnSwitchFragment;
// src/components/loyalty-discount-toggle/loyalty-discount-toggle.tsx
import React11 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSSwitch } from "@egds/react-core/switch";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
var __LoyaltyDiscountToggleFragment = gql7(_templateObject6());
var LoyaltyDiscountToggle = function (param) {
  var data = param.data,
    _param_checked = param.checked,
    checked = _param_checked === void 0 ? false : _param_checked,
    onChange = param.onChange;
  var loyaltyDiscount = data.loyaltyDiscount;
  var _React11_useState = _sliced_to_array(React11.useState(checked), 2),
    isChecked = _React11_useState[0],
    setIsChecked = _React11_useState[1];
  var track = useClickTracker2();
  if (!loyaltyDiscount) {
    return null;
  }
  var handleChange = function () {
    setIsChecked(!isChecked);
    onChange === null || onChange === void 0 ? void 0 : onChange(!isChecked);
    track("swpToggle: ".concat(loyaltyDiscount.saveWithPointsActionMessage), "", true);
  };
  return /* @__PURE__ */React11.createElement(EGDSSpacing6, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React11.createElement("div", null, /* @__PURE__ */React11.createElement(EGDSSwitch, {
    id: "swpToggle",
    checked: isChecked,
    onChange: handleChange,
    labelClassName: "uitk-type-300",
    description: loyaltyDiscount.toggleSubText || ""
  }, loyaltyDiscount.saveWithPointsMessage || "")));
};
LoyaltyDiscountToggle.displayName = "LoyaltyDiscountToggle";
LoyaltyDiscountToggle.fragment = __LoyaltyDiscountToggleFragment;
// src/components/new-vip-module/vip-module.tsx
import React13 from "react";
import { gql as gql9 } from "@apollo/client";
// src/components/new-vip-module/__private/__fragments/vip-module-detail.tsx
import React12 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSBadgeSize, EGDSBadgeTheme, EGDSMemberBadge } from "@egds/react-core/badge";
import { EGDSCard as EGDSCard3, EGDSCardContentSection as EGDSCardContentSection2 } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid4, EGDSLayoutGridItem as EGDSLayoutGridItem4, withEGDSLayoutGrid } from "@egds/react-core/layout-grid";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSList, EGDSListItem } from "@egds/react-core/list";
import { EGDSMark, EGDSMarkSize } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSText as EGDSText2 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
var fragment2 = gql8(_templateObject7());
var VipModuleDetail = function (param) {
  var data = param.data;
  var _rightSection_contents, _leftSection_title, _leftSection_footerLink_icon, _rightSection_title, _rightSection_title_badge, _rightSection_title1, _rightSection_title_badge1, _rightSection_title2, _rightSection_title_badge2, _rightSection_title3, _rightSection_title4, _rightSection_footerLink_icon;
  var label = data.label,
    header = data.header,
    subSections = data.subSections;
  var track = useClickTracker3();
  if (!(subSections === null || subSections === void 0 ? void 0 : subSections.length)) {
    return null;
  }
  var leftSection = subSections[0];
  var rightSection = subSections[1];
  if (!(rightSection === null || rightSection === void 0 ? void 0 : (_rightSection_contents = rightSection.contents) === null || _rightSection_contents === void 0 ? void 0 : _rightSection_contents.length)) {
    return null;
  }
  var contents = rightSection.contents;
  var onClickLearnMoreLink = function () {
    var _leftSection_footerLink;
    if (!(leftSection === null || leftSection === void 0 ? void 0 : (_leftSection_footerLink = leftSection.footerLink) === null || _leftSection_footerLink === void 0 ? void 0 : _leftSection_footerLink.link.referrerId)) {
      return;
    }
    track(leftSection.footerLink.link.referrerId, label || "Clicked Learn More Link of VipModule");
  };
  var onClickSignInLink = function () {
    var _rightSection_footerLink;
    if (!((_rightSection_footerLink = rightSection.footerLink) === null || _rightSection_footerLink === void 0 ? void 0 : _rightSection_footerLink.link.referrerId)) {
      return;
    }
    track(rightSection.footerLink.link.referrerId, label || "Clicked Sign In Sign Up Link of VipModule");
  };
  var List = function (props) {
    var _rightSection_title;
    return ((_rightSection_title = rightSection.title) === null || _rightSection_title === void 0 ? void 0 : _rightSection_title.badge) ? /* @__PURE__ */React12.createElement(EGDSList, _object_spread({}, props), contents.map(function (content, index) {
      var value = content.value;
      return /* @__PURE__ */React12.createElement(EGDSListItem, {
        key: "property-highlight-list-item-".concat(index)
      }, value);
    })) : /* @__PURE__ */React12.createElement(EGDSLayoutGrid4, {
      columns: ["max-content", "auto"],
      "data-stid": "contentList",
      space: "two"
    }, contents.map(function (content, index) {
      var badge = content.badge,
        value = content.value;
      return /* @__PURE__ */React12.createElement(React12.Fragment, {
        key: "property-highlight-list-item-".concat(index)
      }, /* @__PURE__ */React12.createElement(EGDSLayoutGridItem4, null, /* @__PURE__ */React12.createElement(EGDSText2, null, /* @__PURE__ */React12.createElement(EGDSMemberBadge, {
        text: (badge === null || badge === void 0 ? void 0 : badge.text) || "",
        theme: (badge === null || badge === void 0 ? void 0 : badge.theme_temp) && EGDSBadgeTheme[badge.theme_temp] || "",
        size: EGDSBadgeSize.LARGE
      }))), /* @__PURE__ */React12.createElement(EGDSLayoutGridItem4, null, /* @__PURE__ */React12.createElement(EGDSText2, null, value)));
    }));
  };
  var MessagesListWithGrid = withEGDSLayoutGrid(List);
  var messagesRowsCount = Math.ceil(contents.length / 2);
  return /* @__PURE__ */React12.createElement("div", null, /* @__PURE__ */React12.createElement(EGDSCard3, null, /* @__PURE__ */React12.createElement(EGDSSpacing7, {
    padding: {
      blockstart: "four",
      small: {
        blockend: "six",
        inline: "four"
      },
      medium: {
        blockend: "one",
        inline: "six"
      }
    }
  }, /* @__PURE__ */React12.createElement(EGDSCardContentSection2, null, /* @__PURE__ */React12.createElement(EGDSLayoutGrid4, {
    columns: {
      medium: ["1fr", "2fr"]
    },
    rows: {
      small: ["1fr"],
      medium: ["1fr"]
    }
  }, /* @__PURE__ */React12.createElement(EGDSLayoutGridItem4, {
    colSpan: {
      small: 1,
      medium: 3
    }
  }, /* @__PURE__ */React12.createElement(EGDSCardContentSection2, {
    border: "bottom",
    padded: false
  }, /* @__PURE__ */React12.createElement(EGDSSpacing7, {
    padding: {
      blockend: "three"
    }
  }, /* @__PURE__ */React12.createElement("div", null, /* @__PURE__ */React12.createElement(EGDSText2, {
    className: "is-visually-hidden"
  }, label), (header === null || header === void 0 ? void 0 : header.mark) && /* @__PURE__ */React12.createElement(EGDSSpacing7, {
    margin: {
      inlineend: "three"
    }
  }, /* @__PURE__ */React12.createElement(EGDSMark, {
    name: header.mark.id,
    size: EGDSMarkSize.MEDIUM_LARGE
  })))))), /* @__PURE__ */React12.createElement(EGDSLayoutGridItem4, null, /* @__PURE__ */React12.createElement(EGDSSpacing7, {
    padding: {
      block: "four"
    }
  }, /* @__PURE__ */React12.createElement(EGDSLayoutFlex3, {
    direction: "column",
    space: "two"
  }, /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React12.createElement(EGDSHeading2, {
    tag: "h3",
    size: 7
  }, /* @__PURE__ */React12.createElement(EGDSText2, {
    weight: "bold"
  }, leftSection === null || leftSection === void 0 ? void 0 : (_leftSection_title = leftSection.title) === null || _leftSection_title === void 0 ? void 0 : _leftSection_title.value))), /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React12.createElement(EGDSSpacing7, {
    padding: {
      small: {
        inlineend: "unset"
      },
      medium: {
        inlineend: "six"
      }
    }
  }, /* @__PURE__ */React12.createElement(EGDSText2, null, leftSection === null || leftSection === void 0 ? void 0 : leftSection.description))), /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React12.createElement(EGDSSpacing7, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React12.createElement("div", null, (leftSection === null || leftSection === void 0 ? void 0 : leftSection.footerLink) && /* @__PURE__ */React12.createElement(EGDSLink, {
    onClick: onClickLearnMoreLink
  }, /* @__PURE__ */React12.createElement("a", {
    href: leftSection.footerLink.link.uri.value,
    target: leftSection.footerLink.link.target || ""
  }, leftSection.footerLink.value, /* @__PURE__ */React12.createElement("span", {
    className: "is-visually-hidden"
  }, leftSection.footerLink.accessibilityLabel), /* @__PURE__ */React12.createElement(EGDSIcon2, {
    name: ((_leftSection_footerLink_icon = leftSection.footerLink.icon) === null || _leftSection_footerLink_icon === void 0 ? void 0 : _leftSection_footerLink_icon.id) || ""
  }))))))))), /* @__PURE__ */React12.createElement(EGDSLayoutGridItem4, {
    colSpan: {
      small: 1,
      medium: 2
    }
  }, /* @__PURE__ */React12.createElement(EGDSSpacing7, {
    padding: {
      small: {
        block: "unset"
      },
      medium: {
        block: "three",
        inlinestart: "twelve"
      }
    }
  }, /* @__PURE__ */React12.createElement(EGDSLayoutFlex3, {
    direction: "column",
    space: "two"
  }, /* @__PURE__ */React12.createElement(EGDSSpacing7, {
    margin: {
      small: {
        blockstart: "four",
        blockend: "two"
      },
      medium: {
        blockstart: "one"
      }
    }
  }, /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React12.createElement(EGDSLayoutFlex3, {
    space: "two",
    alignItems: "center"
  }, ((_rightSection_title = rightSection.title) === null || _rightSection_title === void 0 ? void 0 : _rightSection_title.badge) && /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React12.createElement(EGDSMemberBadge, {
    text: ((_rightSection_title1 = rightSection.title) === null || _rightSection_title1 === void 0 ? void 0 : (_rightSection_title_badge = _rightSection_title1.badge) === null || _rightSection_title_badge === void 0 ? void 0 : _rightSection_title_badge.text) || "",
    theme: ((_rightSection_title2 = rightSection.title) === null || _rightSection_title2 === void 0 ? void 0 : (_rightSection_title_badge1 = _rightSection_title2.badge) === null || _rightSection_title_badge1 === void 0 ? void 0 : _rightSection_title_badge1.theme_temp) && EGDSBadgeTheme[(_rightSection_title3 = rightSection.title) === null || _rightSection_title3 === void 0 ? void 0 : (_rightSection_title_badge2 = _rightSection_title3.badge) === null || _rightSection_title_badge2 === void 0 ? void 0 : _rightSection_title_badge2.theme_temp] || "",
    size: EGDSBadgeSize.LARGE
  })), /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React12.createElement(EGDSHeading2, {
    tag: "h3",
    size: 7
  }, /* @__PURE__ */React12.createElement(EGDSText2, {
    weight: "regular"
  }, (_rightSection_title4 = rightSection.title) === null || _rightSection_title4 === void 0 ? void 0 : _rightSection_title4.value)))))), /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React12.createElement(EGDSLayoutFlex3, null, /* @__PURE__ */React12.createElement(MessagesListWithGrid, {
    rows: messagesRowsCount
  }))), /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React12.createElement(EGDSSpacing7, {
    margin: {
      small: {
        block: "unset"
      },
      medium: {
        block: "two"
      }
    }
  }, /* @__PURE__ */React12.createElement("div", null, rightSection.footerLink && /* @__PURE__ */React12.createElement(EGDSLink, {
    onClick: onClickSignInLink
  }, /* @__PURE__ */React12.createElement("a", {
    href: rightSection.footerLink.link.uri.value,
    target: rightSection.footerLink.link.target || ""
  }, rightSection.footerLink.value, /* @__PURE__ */React12.createElement(EGDSIcon2, {
    name: ((_rightSection_footerLink_icon = rightSection.footerLink.icon) === null || _rightSection_footerLink_icon === void 0 ? void 0 : _rightSection_footerLink_icon.id) || ""
  }))))))))))))));
};
VipModuleDetail.fragment = fragment2;
VipModuleDetail.displayName = "VipModule";
// src/components/new-vip-module/vip-module.tsx
var __NewVipModuleFragment = gql9(_templateObject8(), VipModuleDetail.fragment);
var NewVipModule = function (param) {
  var data = param.data;
  var propertyHighlightSection = data.propertyHighlightSection;
  if (!propertyHighlightSection) {
    return null;
  }
  return /* @__PURE__ */React13.createElement(VipModuleDetail, {
    data: propertyHighlightSection
  });
};
NewVipModule.fragment = __NewVipModuleFragment;
NewVipModule.displayName = "NewVipModule";
// src/components/price-insight/price-insight.tsx
import React16, { useEffect } from "react";
import { gql as gql12 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker2, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { useExperiment } from "@shared-ui/experiment-context";
// src/utils/clickstream-constants.ts
var PRICE_REQUEST_CALIFORNIA_SUBMITTED = "price_request_california.submitted";
// src/components/price-insight/__private/__fragments/price-insight-card.tsx
import React14 from "react";
import { gql as gql10 } from "@apollo/client";
import { EGDSIcon as EGDSIcon3, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSLayoutGrid as EGDSLayoutGrid5, EGDSLayoutGridItem as EGDSLayoutGridItem5 } from "@egds/react-core/layout-grid";
import { EGDSMoreInfoTrigger } from "@egds/react-core/more-info-trigger";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
import { EGDSLocalRangeIndicator } from "@egds/react-lodging";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { EGDSExpandoCard } from "@shared-ui/lodging-fragments";
import { ViewMedium, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
var __PriceInsightCardFragment = gql10(_templateObject9(), EGDSExpandoCard.fragment);
var PriceInsightCard = function (param) {
  var data = param.data,
    showMoreInfo = param.showMoreInfo,
    disclaimerOpenEvent = param.disclaimerOpenEvent;
  var _useDialog = _sliced_to_array(useDialog("price-insight-dialog"), 2),
    dialogActions = _useDialog[1];
  var trackClick = useClickTracker4();
  var eventCallback = React14.useCallback(function (referrerId, linkName) {
    trackClick(referrerId, linkName);
  }, [trackClick]);
  if (!(data === null || data === void 0 ? void 0 : data.expando) || !(data === null || data === void 0 ? void 0 : data.rangeIndicator)) {
    return null;
  }
  var expando = data.expando,
    rangeIndicator = data.rangeIndicator,
    footer = data.footer;
  var accessibility = rangeIndicator.accessibility;
  var milestones = rangeIndicator.milestones;
  var segments = rangeIndicator.segments;
  var expandoTitleMoreInfoTrigger = /* @__PURE__ */React14.createElement(React14.Fragment, null, showMoreInfo && disclaimerOpenEvent && /* @__PURE__ */React14.createElement(EGDSSpacing8, {
    margin: {
      inlinestart: "one"
    }
  }, /* @__PURE__ */React14.createElement(EGDSMoreInfoTrigger, {
    size: "small",
    analytics: {
      id: disclaimerOpenEvent.referrerId,
      description: disclaimerOpenEvent.linkName,
      callback: eventCallback
    }
  }, /* @__PURE__ */React14.createElement("button", {
    type: "button",
    onClick: function (event) {
      event.preventDefault();
      dialogActions.openDialog();
    }
  }, /* @__PURE__ */React14.createElement(EGDSIcon3, {
    name: "info_outline",
    size: EGDSIconSize.SMALL
  })))));
  return /* @__PURE__ */React14.createElement(Viewport2, null, /* @__PURE__ */React14.createElement(ViewSmall2, null, /* @__PURE__ */React14.createElement(EGDSExpandoCard, {
    data: _object_spread_props(_object_spread({}, expando), {
      subtitle: null
    }),
    isIndented: false,
    padding: "four",
    titleSize: 500,
    titleWeight: "medium",
    expandoTitleMoreInfoTrigger: expandoTitleMoreInfoTrigger,
    hasBorder: true
  }, /* @__PURE__ */React14.createElement(EGDSSpacing8, {
    padding: {
      inlineend: "six"
    }
  }, /* @__PURE__ */React14.createElement(EGDSText3, {
    size: 200
  }, expando === null || expando === void 0 ? void 0 : expando.subtitle)), /* @__PURE__ */React14.createElement(EGDSSpacing8, {
    padding: {
      blockstart: "four"
    }
  }, segments && milestones && /* @__PURE__ */React14.createElement(EGDSLocalRangeIndicator, {
    accessibility: accessibility,
    segments: segments,
    milestones: milestones
  })), footer && /* @__PURE__ */React14.createElement(EGDSSpacing8, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React14.createElement(EGDSText3, {
    size: 200
  }, footer.text)))), /* @__PURE__ */React14.createElement(ViewMedium, null, /* @__PURE__ */React14.createElement(EGDSExpandoCard, {
    data: _object_spread_props(_object_spread({}, expando), {
      subtitle: null
    }),
    isIndented: false,
    titleSize: 500,
    titleWeight: "medium",
    expandoTitleMoreInfoTrigger: expandoTitleMoreInfoTrigger,
    hasBorder: true
  }, /* @__PURE__ */React14.createElement(EGDSLayoutGrid5, {
    columns: 2
  }, /* @__PURE__ */React14.createElement(EGDSLayoutGridItem5, null, /* @__PURE__ */React14.createElement("div", null, /* @__PURE__ */React14.createElement(EGDSText3, {
    size: 200
  }, expando === null || expando === void 0 ? void 0 : expando.subtitle), footer && /* @__PURE__ */React14.createElement(EGDSSpacing8, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React14.createElement(EGDSText3, {
    size: 200
  }, footer.text)))), /* @__PURE__ */React14.createElement(EGDSLayoutGridItem5, null, /* @__PURE__ */React14.createElement(EGDSSpacing8, {
    margin: {
      inlinestart: "four"
    }
  }, segments && milestones && /* @__PURE__ */React14.createElement(EGDSLocalRangeIndicator, {
    accessibility: accessibility,
    segments: segments,
    milestones: milestones
  })))))));
};
PriceInsightCard.displayName = "PriceInsight";
PriceInsightCard.fragment = __PriceInsightCardFragment;
// src/components/price-insight/__private/__fragments/price-insight-disclaimer.tsx
import React15 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon4, EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { EGDSSheet, EGDSSheetCloseButton, EGDSSheetContent, EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { clientSideAnalyticsFragment as clientSideAnalyticsFragment2, EGDSStylizedText } from "@shared-ui/lodging-fragments";
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
var __PriceInsightDisclaimerFragment = gql11(_templateObject10(), clientSideAnalyticsFragment2);
var PriceInsightDisclaimer = function (param) {
  var data = param.data;
  var _useDialog2 = _sliced_to_array(useDialog2("price-insight-dialog"), 3),
    isDialogOpen = _useDialog2[0],
    dialogActions = _useDialog2[1],
    DialogComponent = _useDialog2[2];
  var trackClick = useClickTracker5();
  var eventCallback = React15.useCallback(function (referrerId, linkName) {
    trackClick(referrerId, linkName);
  }, [trackClick]);
  var isSmallViewSize = useMediaQueries({
    viewSizes: defaultViewSizes
  }) === defaultViewSizes.SMALL;
  if (!(data === null || data === void 0 ? void 0 : data.description) || !(data === null || data === void 0 ? void 0 : data.title)) {
    return null;
  }
  var description = data.description,
    title = data.title,
    closeEvent = data.closeEvent;
  return /* @__PURE__ */React15.createElement(DialogComponent, null, /* @__PURE__ */React15.createElement(EGDSSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React15.createElement(EGDSSheet, {
    type: isSmallViewSize ? "bottom" : "centered",
    isVisible: isDialogOpen,
    triggerRef: null,
    hasModal: true
  }, /* @__PURE__ */React15.createElement(EGDSSheetCloseButton, null, /* @__PURE__ */React15.createElement(EGDSTertiaryButton, {
    type: "button",
    onClick: function () {
      return dialogActions.closeDialog();
    },
    analytics: {
      id: closeEvent.referrerId,
      description: closeEvent.linkName,
      callback: eventCallback
    }
  }, /* @__PURE__ */React15.createElement(EGDSIcon4, {
    name: "close",
    size: EGDSIconSize2.EXTRA_SMALL,
    id: "close",
    title: "close"
  }))), /* @__PURE__ */React15.createElement(EGDSSheetContent, null, /* @__PURE__ */React15.createElement(EGDSSpacing9, {
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React15.createElement(EGDSStylizedText, {
    data: title,
    size: isSmallViewSize ? 400 : 300,
    weight: "bold"
  })), /* @__PURE__ */React15.createElement(EGDSText4, {
    size: 300
  }, description.text)))));
};
PriceInsightDisclaimer.displayName = "PriceInsightDisclaimer";
PriceInsightDisclaimer.fragment = __PriceInsightDisclaimerFragment;
// src/components/price-insight/price-insight.tsx
var __PriceInsightFragment = gql12(_templateObject11(), PriceInsightCard.fragment, PriceInsightDisclaimer.fragment);
var PriceInsight = function (param) {
  var data = param.data;
  var _data_priceInsight;
  var exposure = useExperiment("Lodging_Price_Insight_MVP").exposure;
  var track = useEgClickstream();
  useEffect(function () {
    if (data === null || data === void 0 ? void 0 : data.priceInsight) {
      var _data_priceInsight = data.priceInsight,
        analyticsPayload = _data_priceInsight.analyticsPayload,
        card2 = _data_priceInsight.card;
      var unpackedAnalyticsPayload = JSON.parse(analyticsPayload);
      var trackAnalytics = exposure.bucket !== 0;
      if (card2 && trackAnalytics) {
        var _unpackedAnalyticsPayload_events_price_insight_modulepresented_v1, _unpackedAnalyticsPayload_events_price_insight_modulepresented;
        track((_unpackedAnalyticsPayload_events_price_insight_modulepresented = unpackedAnalyticsPayload.events["price_insight_module.presented" /* PRICE_INSIGHT_MODULE_PRESENTED */]) === null || _unpackedAnalyticsPayload_events_price_insight_modulepresented === void 0 ? void 0 : (_unpackedAnalyticsPayload_events_price_insight_modulepresented_v1 = _unpackedAnalyticsPayload_events_price_insight_modulepresented.v1) === null || _unpackedAnalyticsPayload_events_price_insight_modulepresented_v1 === void 0 ? void 0 : _unpackedAnalyticsPayload_events_price_insight_modulepresented_v1.event_data);
      } else if (trackAnalytics) {
        var _unpackedAnalyticsPayload_events_price_insight_modulefailed_v1, _unpackedAnalyticsPayload_events_price_insight_modulefailed;
        track((_unpackedAnalyticsPayload_events_price_insight_modulefailed = unpackedAnalyticsPayload.events["price_insight_module.failed" /* PRICE_INSIGHT_MODULE_FAILED */]) === null || _unpackedAnalyticsPayload_events_price_insight_modulefailed === void 0 ? void 0 : (_unpackedAnalyticsPayload_events_price_insight_modulefailed_v1 = _unpackedAnalyticsPayload_events_price_insight_modulefailed.v1) === null || _unpackedAnalyticsPayload_events_price_insight_modulefailed_v1 === void 0 ? void 0 : _unpackedAnalyticsPayload_events_price_insight_modulefailed_v1.event_data);
      }
    }
  }, []);
  if (!(data === null || data === void 0 ? void 0 : (_data_priceInsight = data.priceInsight) === null || _data_priceInsight === void 0 ? void 0 : _data_priceInsight.card) || exposure.bucket !== 1) {
    return null;
  }
  var _data_priceInsight1 = data.priceInsight,
    card = _data_priceInsight1.card,
    disclaimer = _data_priceInsight1.disclaimer,
    impressionAnalytics = _data_priceInsight1.impressionAnalytics;
  var _impressionAnalytics_referrerId, _impressionAnalytics_linkName;
  return /* @__PURE__ */React16.createElement(IntersectionTracker2, {
    trackOnce: true,
    referrerId: (_impressionAnalytics_referrerId = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) !== null && _impressionAnalytics_referrerId !== void 0 ? _impressionAnalytics_referrerId : "",
    linkName: (_impressionAnalytics_linkName = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) !== null && _impressionAnalytics_linkName !== void 0 ? _impressionAnalytics_linkName : ""
  }, /* @__PURE__ */React16.createElement(PriceInsightCard, {
    data: card,
    showMoreInfo: !!disclaimer,
    disclaimerOpenEvent: disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.openEvent
  }), disclaimer && /* @__PURE__ */React16.createElement(PriceInsightDisclaimer, {
    data: disclaimer
  }));
};
PriceInsight.displayName = "PriceInsight";
PriceInsight.fragment = __PriceInsightFragment;
// src/components/property-level-offers-card/property-level-offers-card.tsx
import React17 from "react";
import { gql as gql13 } from "@apollo/client";
import { EGDSStandardMessagingCard } from "@shared-ui/lodging-fragments";
var fragment3 = gql13(_templateObject12(), EGDSStandardMessagingCard.fragment);
var PropertyLevelOffersCard = function (param) {
  var data = param.data;
  if (!(data === null || data === void 0 ? void 0 : data.propertyLevelOffersCard)) {
    return null;
  }
  return /* @__PURE__ */React17.createElement(EGDSStandardMessagingCard, {
    data: data.propertyLevelOffersCard,
    dataStid: "property-offers-message-card",
    markSize: 11,
    showBorder: true
  });
};
PropertyLevelOffersCard.fragment = fragment3;
PropertyLevelOffersCard.displayName = "PropertyLevelOffersCard";
// src/components/property-level-offers-message/property-level-offers-message.tsx
import React18 from "react";
import { gql as gql14 } from "@apollo/client";
import { MessageResult, SparkleBanner } from "@shared-ui/lodging-fragments";
var __PropertyLevelOffersMessageFragment = gql14(_templateObject13(), MessageResult.fragment, SparkleBanner.fragment);
var PropertyLevelOffersMessage = function (param) {
  var data = param.data,
    className = param.className;
  var propertyLevelOffersMessage = data.propertyLevelOffersMessage;
  if (!propertyLevelOffersMessage) {
    return null;
  }
  return propertyLevelOffersMessage.type === "BRANDED_THEME_DARK" || propertyLevelOffersMessage.type === "BRANDED_THEME_ACCENT" ? /* @__PURE__ */React18.createElement(SparkleBanner, {
    data: propertyLevelOffersMessage,
    className: className,
    bannerToAddMargin: "sparklePDP"
  }) : /* @__PURE__ */React18.createElement(MessageResult, {
    data: propertyLevelOffersMessage,
    className: className
  });
};
PropertyLevelOffersMessage.fragment = __PropertyLevelOffersMessageFragment;
PropertyLevelOffersMessage.displayName = "PropertyLevelOffersMessage";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/price-breakdown-summary-fragment.tsx
import { gql as gql18 } from "@apollo/client";
import { LodgingEnrichedMessage as LodgingEnrichedMessage4 } from "@shared-ui/lodging-fragments";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/__private/__fragments/price-summary-section.tsx
import React21 from "react";
import { gql as gql17 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing12 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText6 } from "@egds/react-core/text";
import { LodgingEnrichedMessage as LodgingEnrichedMessage3 } from "@shared-ui/lodging-fragments";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/__private/__fragments/price-summary-footer.tsx
import React19 from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing10 } from "@egds/react-core/spacing";
import { LodgingEnrichedMessage } from "@shared-ui/lodging-fragments";
var __PriceSummaryFooterFragment = gql15(_templateObject14(), LodgingEnrichedMessage.fragment);
var PriceSummaryFooter = function (param) {
  var data = param.data;
  var footerMessages = data.footerMessages;
  if (!(footerMessages === null || footerMessages === void 0 ? void 0 : footerMessages.length)) {
    return null;
  }
  return /* @__PURE__ */React19.createElement(EGDSSpacing10, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React19.createElement("div", null, footerMessages.map(function (message, index) {
    return /* @__PURE__ */React19.createElement(LodgingEnrichedMessage, {
      key: "price-summary-footer-message-".concat(index),
      data: message
    });
  })));
};
PriceSummaryFooter.fragment = __PriceSummaryFooterFragment;
PriceSummaryFooter.displayName = "PriceSummaryFooter";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/__private/__fragments/price-summary-line-item.tsx
import React20 from "react";
import { gql as gql16 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing11 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";
import { LodgingEnrichedMessage as LodgingEnrichedMessage2 } from "@shared-ui/lodging-fragments";
// src/__generated__/types.ts
var IdentifierType = /* @__PURE__ */function (IdentifierType2) {
  IdentifierType2["ACTIVITY_ID"] = "ACTIVITY_ID";
  IdentifierType2["CART_ID"] = "CART_ID";
  IdentifierType2["CHECKOUT_SESSION_ID"] = "CHECKOUT_SESSION_ID";
  IdentifierType2["ENTITY_ID"] = "ENTITY_ID";
  IdentifierType2["LEGACY_ORDER_ID"] = "LEGACY_ORDER_ID";
  IdentifierType2["OFFER_ID"] = "OFFER_ID";
  IdentifierType2["ORDER_ID"] = "ORDER_ID";
  IdentifierType2["PROPERTY_ID"] = "PROPERTY_ID";
  IdentifierType2["SAILING_TOKEN"] = "SAILING_TOKEN";
  return IdentifierType2;
}(IdentifierType || {});
// src/components/property-offers/__private/__fragments/price-breakdown-summary/__private/__fragments/price-summary-line-item.tsx
var __PriceSummaryLineItemFragment = gql16(_templateObject15(), LodgingEnrichedMessage2.fragment);
var PriceSummaryLineItem = function (param) {
  var data = param.data;
  var _name_secondaryMessages, _value_secondaryMessages;
  var name = data.name,
    value = data.value;
  return /* @__PURE__ */React20.createElement(EGDSSpacing11, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React20.createElement(EGDSLayoutFlex4, {
    justifyContent: "space-between"
  }, /* @__PURE__ */React20.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React20.createElement("div", null, /* @__PURE__ */React20.createElement(EGDSText5, {
    size: name.primaryMessage.theme === "STRONG" /* STRONG */ ? 400 : 300,
    weight: "regular",
    theme: "emphasis"
  }, /* @__PURE__ */React20.createElement(LodgingEnrichedMessage2, {
    data: name.primaryMessage
  })), (_name_secondaryMessages = name.secondaryMessages) === null || _name_secondaryMessages === void 0 ? void 0 : _name_secondaryMessages.map(function (message, index) {
    return /* @__PURE__ */React20.createElement(EGDSText5, {
      size: 200,
      theme: "standard",
      key: "line-item-name-".concat(index)
    }, /* @__PURE__ */React20.createElement(LodgingEnrichedMessage2, {
      data: message
    }));
  }))), /* @__PURE__ */React20.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React20.createElement("div", null, /* @__PURE__ */React20.createElement(EGDSText5, {
    size: value.primaryMessage.theme === "STRONG" /* STRONG */ ? 400 : 300,
    weight: "regular",
    theme: "emphasis"
  }, /* @__PURE__ */React20.createElement(LodgingEnrichedMessage2, {
    data: value.primaryMessage
  })), (_value_secondaryMessages = value.secondaryMessages) === null || _value_secondaryMessages === void 0 ? void 0 : _value_secondaryMessages.map(function (message, index) {
    return /* @__PURE__ */React20.createElement(LodgingEnrichedMessage2, {
      data: message,
      key: "line-item-value-".concat(index)
    });
  })))));
};
PriceSummaryLineItem.fragment = __PriceSummaryLineItemFragment;
PriceSummaryLineItem.displayName = "PriceSummaryLineItem";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/__private/__fragments/price-summary-section.tsx
var __PriceSummarySectionFragment = gql17(_templateObject16(), LodgingEnrichedMessage3.fragment, PriceSummaryLineItem.fragment, PriceSummaryFooter.fragment);
var PriceSummarySection = function (param) {
  var data = param.data,
    lastSection = param.lastSection;
  var sectionHeading = data.sectionHeading,
    sectionFooter = data.sectionFooter,
    items = data.items;
  return /* @__PURE__ */React21.createElement(EGDSSpacing12, _object_spread({
    padding: {
      block: "three"
    }
  }, !lastSection ? {
    border: ["blockend"]
  } : {}), /* @__PURE__ */React21.createElement("div", null, sectionHeading && /* @__PURE__ */React21.createElement(EGDSText6, {
    size: 300
  }, /* @__PURE__ */React21.createElement(LodgingEnrichedMessage3, {
    data: sectionHeading
  })), items.map(function (item, index) {
    return /* @__PURE__ */React21.createElement(PriceSummaryLineItem, {
      data: item,
      key: "price-summary-line-item-".concat(index)
    });
  }), sectionFooter && /* @__PURE__ */React21.createElement(PriceSummaryFooter, {
    data: sectionFooter
  })));
};
PriceSummarySection.fragment = __PriceSummarySectionFragment;
PriceSummarySection.displayName = "PriceSummarySection";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/price-breakdown-summary-fragment.tsx
var fragment4 = gql18(_templateObject17(), LodgingEnrichedMessage4.fragment, PriceSummarySection.fragment);
// src/components/property-offers/listings-header.tsx
import React22 from "react";
import { gql as gql19 } from "@apollo/client";
import { EGDSHeading as EGDSHeading3 } from "@egds/react-core/text";
import { ViewLarge as ViewLarge2, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
var __ListingsHeaderFragment = gql19(_templateObject18());
var ListingsHeader = function (param) {
  var className = param.className,
    data = param.data;
  var listingsHeader = data.listingsHeader;
  if (!listingsHeader.text) {
    return null;
  }
  var sharedProps = {
    tag: "h2",
    id: "ListingsHeader"
  };
  return /* @__PURE__ */React22.createElement("div", {
    className: className
  }, /* @__PURE__ */React22.createElement(Viewport3, null, /* @__PURE__ */React22.createElement(ViewSmall3, null, /* @__PURE__ */React22.createElement(EGDSHeading3, _object_spread_props(_object_spread({}, sharedProps), {
    size: 4
  }), listingsHeader.text)), /* @__PURE__ */React22.createElement(ViewLarge2, null, /* @__PURE__ */React22.createElement(EGDSHeading3, _object_spread_props(_object_spread({}, sharedProps), {
    size: 4,
    tabIndex: -1
  }), listingsHeader.text))));
};
ListingsHeader.displayName = "ListingsHeader";
ListingsHeader.fragment = __ListingsHeaderFragment;
// src/components/property-offers/listings-placeholder.tsx
import React146 from "react";
import { EGDSCard as EGDSCard24, EGDSCardContentSection as EGDSCardContentSection15 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure5, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType7 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex29 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid21, EGDSLayoutGridItem as EGDSLayoutGridItem18 } from "@egds/react-core/layout-grid";
import { EGDSBlockSkeleton, EGDSLineSkeleton as EGDSLineSkeleton2 } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing80 } from "@egds/react-core/spacing";
import { Carousel as Carousel2 } from "@egds/react-lodging";
import { useBexApi as useBexApi8 } from "@shared-ui/bex-api-context";
import { useExperiment as useExperiment9 } from "@shared-ui/experiment-context";
import { findReactChildByType as findReactChildByType2 } from "@shared-ui/lodging-fragments";
import { LodgingOfferFilters as LodgingOfferFilters3 } from "@shared-ui/retail-sort-and-filter-shared";
import { ViewLarge as ViewLarge4, ViewMedium as ViewMedium14, Viewport as Viewport17, ViewSmall as ViewSmall16 } from "@shared-ui/viewport-context";
// src/components/property-offers/property-offers.tsx
import React145, { useEffect as useEffect7, useRef as useRef3, useState as useState4 } from "react";
import { gql as gql105 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex28 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing79 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi7 } from "@shared-ui/bex-api-context";
import { useEgClickstream as useEgClickstream13 } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment4, ExperimentControl as ExperimentControl4, ExperimentVariant as ExperimentVariant4 } from "@shared-ui/experiment-context";
import { findReactChildByType, MessageResult as MessageResult4 } from "@shared-ui/lodging-fragments";
import { usePropertyActivitiesCrossSellContext as usePropertyActivitiesCrossSellContext2 } from "@shared-ui/retail-lodging-property-activities-cross-sell";
import { LodgingOfferFilters as LodgingOfferFilters2, PropertyOffersFiltersProvider as PropertyOffersFiltersProvider2 } from "@shared-ui/retail-sort-and-filter-shared";
// src/context/listings-limit-context.ts
import { createContext, useContext } from "react";
var defaultListingsLimit = {
  listingsLimit: void 0,
  setListingsLimit: function () {
    return void 0;
  }
};
var ListingsLimitContext = createContext(defaultListingsLimit);
function useListingsLimitContext() {
  return useContext(ListingsLimitContext);
}
// src/components/__private/__fragments/alternate-dates.tsx
import React24 from "react";
import { gql as gql21 } from "@apollo/client";
import { EGDSCard as EGDSCard4, EGDSCardContentSection as EGDSCardContentSection3 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid6 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing13 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading4, EGDSText as EGDSText8 } from "@egds/react-core/text";
// src/components/__private/__fragments/alternate-dates-option.tsx
import React23 from "react";
import { gql as gql20 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGridItem as EGDSLayoutGridItem6 } from "@egds/react-core/layout-grid";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { EGDSText as EGDSText7 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
var fragment5 = gql20(_templateObject19());
var AlternateDateOption = function (param) {
  var data = param.data,
    id = param.id,
    _param_justifyContent = param.justifyContent,
    justifyContent = _param_justifyContent === void 0 ? "start" : _param_justifyContent;
  var track = useClickTracker6();
  var Link = useLinkComponent().Link;
  if (!data) {
    return null;
  }
  var trackClick = function () {
    track("Alternate Dates Selection", "AlternateDates.SoldOut".concat(id + 1));
  };
  var dates = data.dates,
    price = data.price;
  var option = /* @__PURE__ */React23.createElement(React23.Fragment, null, /* @__PURE__ */React23.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React23.createElement(EGDSLink2, {
    onClick: trackClick,
    inline: true
  }, /* @__PURE__ */React23.createElement(Link, {
    href: dates.link.uri.relativePath
  }, dates.value))), (price === null || price === void 0 ? void 0 : price.displayPrice) && /* @__PURE__ */React23.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React23.createElement(EGDSText7, null, price.displayPrice.formatted)));
  return /* @__PURE__ */React23.createElement(EGDSLayoutGridItem6, {
    key: "alternate-date-option-".concat(id)
  }, /* @__PURE__ */React23.createElement(EGDSLayoutFlex5, {
    space: "six",
    justifyContent: justifyContent
  }, option));
};
AlternateDateOption.fragment = fragment5;
AlternateDateOption.displayName = "AlternateDateOption";
// src/components/__private/__fragments/alternate-dates.tsx
var fragment6 = gql21(_templateObject20(), AlternateDateOption.fragment);
var AlternateDates = function (param) {
  var data = param.data,
    className = param.className,
    columns = param.columns,
    _param_justifyContent = param.justifyContent,
    justifyContent = _param_justifyContent === void 0 ? "start" : _param_justifyContent;
  var alternateDates = data.alternateDates;
  if (!alternateDates || !alternateDates.header || !alternateDates.options.length) {
    return null;
  }
  var header = alternateDates.header,
    options = alternateDates.options;
  var text = header.text,
    subText = header.subText;
  var cols = {
    small: 1,
    medium: columns || 2,
    large: columns || 3
  };
  return /* @__PURE__ */React24.createElement(EGDSCard4, {
    className: className,
    key: "alternate-dates",
    "data-stid": "alternate-dates"
  }, /* @__PURE__ */React24.createElement(EGDSCardContentSection3, null, text && /* @__PURE__ */React24.createElement(EGDSHeading4, {
    tag: "h3",
    size: 6,
    "data-stid": "alternate-dates-heading"
  }, text), subText && /* @__PURE__ */React24.createElement(EGDSText8, {
    size: 200,
    "data-stid": "alternate-dates-subheading"
  }, subText)), /* @__PURE__ */React24.createElement(EGDSCardContentSection3, {
    padded: false
  }, /* @__PURE__ */React24.createElement(EGDSSpacing13, {
    padding: {
      blockend: "three",
      inline: "three"
    }
  }, /* @__PURE__ */React24.createElement(EGDSLayoutGrid6, {
    columns: cols,
    space: "four"
  }, options.map(function (option, index) {
    return /* @__PURE__ */React24.createElement(AlternateDateOption, {
      data: option,
      key: index,
      id: index,
      justifyContent: justifyContent
    });
  })))));
};
AlternateDates.displayName = "AlternateDates";
AlternateDates.fragment = fragment6;
// src/components/experimental-offer-categories-section/experimental-offer-categories-section.tsx
import React118 from "react";
import { gql as gql91 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing64 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading22 } from "@egds/react-core/text";
import { ShoppingActionProvider, shoppingJoinListContainerFragment } from "@shared-ui/retail-shopping-tools-action-providers";
// src/components/experimental-offer-categories-section/all-offers-section.tsx
import React114, { useCallback, useMemo as useMemo4 } from "react";
import { gql as gql88 } from "@apollo/client";
import { EGDSPrimaryButton as EGDSPrimaryButton9, UitkButtonSize } from "@egds/react-core/button";
import { useClickTracker as useClickTracker30 } from "@shared-ui/clickstream-analytics-context";
import { useShoppingActionCallback } from "@shared-ui/retail-shopping-tools-action-providers";
// src/components/experimental-offer-categories-section/offer-categories/card-action-wrapper.tsx
import React113 from "react";
import { ShoppingOverlayMapper, useShoppingAction, useShoppingOverlayContainer } from "@shared-ui/retail-shopping-tools-action-providers";
// src/components/experimental-offer-categories-section/overlay-content/overlay-content.tsx
import React110 from "react";
import { gql as gql87 } from "@apollo/client";
import { EGDSSheetContent as EGDSSheetContent8 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing61 } from "@egds/react-core/spacing";
// src/components/experimental-offer-categories-section/overlay-content/overlay-content-body/overlay-body.tsx
import React108 from "react";
import { gql as gql85 } from "@apollo/client";
// src/components/experimental-offer-categories-section/overlay-content/overlay-content-body/overlay-content-body.tsx
import React107 from "react";
import { gql as gql84 } from "@apollo/client";
import { EGDSStylizedText as EGDSStylizedText3 } from "@shared-ui/lodging-fragments";
import { LodgingOfferFilters, PropertyOffersFiltersProvider } from "@shared-ui/retail-sort-and-filter-shared";
// src/components/experimental-offer-categories-section/property-offers-context/hooks.tsx
import React26 from "react";
// src/components/experimental-offer-categories-section/property-offers-context/property-offers-provider.tsx
import React25 from "react";
var defaultValue = {
  offers: []
};
var PropertyOffersContext2 = React25.createContext(defaultValue);
var PropertyOffersProvider = function (param) {
  var children = param.children,
    value = param.value;
  var offers = React25.useMemo(function () {
    return {
      offers: value
    };
  }, [value]);
  return /* @__PURE__ */React25.createElement(PropertyOffersContext2.Provider, {
    value: offers
  }, children);
};
// src/components/experimental-offer-categories-section/property-offers-context/hooks.tsx
var useSelectedPropertyOffers = function (offersIds) {
  var offers = React26.useContext(PropertyOffersContext2).offers;
  if (!offersIds) {
    return;
  }
  var sortedOffersIdentifiers = offersIds.map(function (offersId) {
    return offers === null || offers === void 0 ? void 0 : offers.find(function (offer) {
      if (offer.__typename === "LodgingCategorizedUnit") {
        return offer.unitId === offersId;
      }
      return false;
    });
  }).filter(function (offer) {
    return Boolean(offer);
  });
  return sortedOffersIdentifiers;
};
// src/components/experimental-offer-categories-section/text/heading.tsx
import React27 from "react";
import { gql as gql22 } from "@apollo/client";
import { EGDSSubheading } from "@egds/react-core/text";
var fragment7 = gql22(_templateObject21());
var Heading = function (param) {
  var data = param.data;
  var text = data.text;
  if (!text) {
    return null;
  }
  return /* @__PURE__ */React27.createElement(EGDSSubheading, null, text);
};
Heading.fragment = fragment7;
Heading.displayName = "Heading";
// src/components/experimental-offer-categories-section/text/message.tsx
import React28 from "react";
import { gql as gql23 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing14 } from "@egds/react-core/spacing";
import { EGDSStylizedText as EGDSStylizedText2, Icon } from "@shared-ui/lodging-fragments";
var fragment8 = gql23(_templateObject22(), Icon.fragment, EGDSStylizedText2.fragment);
var Message = function (param) {
  var data = param.data;
  var message = data.message,
    icon = data.icon;
  if (!message) {
    return null;
  }
  return /* @__PURE__ */React28.createElement(EGDSLayoutFlex6, {
    alignItems: "center"
  }, icon && /* @__PURE__ */React28.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React28.createElement(EGDSSpacing14, {
    padding: {
      inlineend: "two"
    }
  }, /* @__PURE__ */React28.createElement(Icon, {
    data: icon
  }))), /* @__PURE__ */React28.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React28.createElement(EGDSStylizedText2, {
    data: message
  })));
};
Message.fragment = fragment8;
Message.displayName = "OfferCategoryMessage";
// src/components/experimental-offer-categories-section/text/messages.tsx
import React29 from "react";
import { EGDSSpacing as EGDSSpacing15 } from "@egds/react-core/spacing";
var Messages = function (param) {
  var messages = param.data;
  if (!messages || messages.length === 0) {
    return null;
  }
  return /* @__PURE__ */React29.createElement("div", null, messages.map(function (msg, idx) {
    return /* @__PURE__ */React29.createElement(EGDSSpacing15, {
      margin: {
        block: "two"
      },
      key: idx
    }, /* @__PURE__ */React29.createElement(Message, {
      data: msg
    }));
  }));
};
// src/components/experimental-offer-categories-section/overlay-content/overlay-content-body/offers.tsx
import React106 from "react";
import { EGDSSpacing as EGDSSpacing60 } from "@egds/react-core/spacing";
import { usePropertyOffersFiltersContext } from "@shared-ui/retail-sort-and-filter-shared";
// src/components/property-offers/__private/__fragments/listings/property-unit-categorization/property-unit-categorization.tsx
import React105 from "react";
import { gql as gql83 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker11 } from "@shared-ui/clickstream-analytics-context";
// src/components/property-offers/__private/__fragments/lodging-review-section.tsx
import React30 from "react";
import { gql as gql24 } from "@apollo/client";
import { EGDSList as EGDSList2, EGDSListItem as EGDSListItem2 } from "@egds/react-core/list";
import { EGDSSpacing as EGDSSpacing16 } from "@egds/react-core/spacing";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { LodgingCardRating, LodgingHeader } from "@shared-ui/lodging-fragments";
import { PropertyRoomScore } from "@shared-ui/lodging-reviews";
var fragment9 = gql24(_templateObject23(), LodgingHeader.fragment, LodgingCardRating.fragment);
var LodgingReviewSection = function (param) {
  var data = param.data,
    roomId = param.roomId,
    withinDialog = param.withinDialog;
  var _data_rating;
  var _useExperiment2 = useExperiment2("Prominent_Room_Scores_Web_and_Android"),
    prominentRoomScoresExperimentExposure = _useExperiment2.exposure;
  var propertyId = usePropertyOffersInputs().propertyId;
  if (prominentRoomScoresExperimentExposure.bucket === 0) {
    return /* @__PURE__ */React30.createElement(PropertyRoomScore, {
      inputs: {
        propertyId: propertyId,
        withTags: true
      },
      roomId: roomId,
      withinDialog: withinDialog,
      skipSsr: true
    });
  }
  if ((data === null || data === void 0 ? void 0 : (_data_rating = data.rating) === null || _data_rating === void 0 ? void 0 : _data_rating.__typename) !== "LodgingCardRating") {
    return null;
  }
  var rating = data.rating,
    itemsHeader = data.itemsHeader,
    items = data.items;
  return /* @__PURE__ */React30.createElement(React30.Fragment, null, /* @__PURE__ */React30.createElement(EGDSSpacing16, {
    margin: {
      blockstart: items ? void 0 : "one",
      blockend: items ? "two" : void 0
    }
  }, /* @__PURE__ */React30.createElement("div", null, /* @__PURE__ */React30.createElement(LodgingCardRating, {
    data: rating
  }))), items && /* @__PURE__ */React30.createElement(EGDSSpacing16, {
    margin: {
      blockstart: "one",
      blockend: "six"
    }
  }, /* @__PURE__ */React30.createElement("div", null, itemsHeader && /* @__PURE__ */React30.createElement(LodgingHeader, {
    data: itemsHeader.title
  }), /* @__PURE__ */React30.createElement(EGDSList2, {
    bullet: "no-bullet"
  }, items.map(function (item, index) {
    return item.__typename === "EGDSTextStandardListItem" && /* @__PURE__ */React30.createElement(EGDSListItem2, {
      key: "review-section-item-".concat(index)
    }, item.text);
  })))));
};
LodgingReviewSection.fragment = fragment9;
LodgingReviewSection.displayName = "LodgingReviewSection";
// src/components/property-offers/__private/__fragments/property-base-features.tsx
import React32 from "react";
import { gql as gql26 } from "@apollo/client";
import { EGDSIcon as EGDSIcon6 } from "@egds/react-core/icons";
import { EGDSListItem as EGDSListItem3 } from "@egds/react-core/list";
// src/components/property-offers/__private/__fragments/logding-plain-sheet.tsx
import React31 from "react";
import { gql as gql25 } from "@apollo/client";
import { EGDSIcon as EGDSIcon5, EGDSIconSize as EGDSIconSize3 } from "@egds/react-core/icons";
import { EGDSMoreInfoTrigger as EGDSMoreInfoTrigger2 } from "@egds/react-core/more-info-trigger";
import { EGDSSheet as EGDSSheet2, EGDSSheetContent as EGDSSheetContent2, EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing17 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText10 } from "@egds/react-core/text";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { EGDSUnformattedHtml } from "@egds/react-core/unformatted-html";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { highlightedMessagesThemeToEGDSTextTheme, useDialogId } from "@shared-ui/lodging-fragments";
import { ViewMedium as ViewMedium2, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
var fragment10 = gql25(_templateObject24());
var LodgingPlainSheet = function (param) {
  var data = param.data,
    uniqueDialogId = param.uniqueDialogId,
    _param_isHtmlContent = param.isHtmlContent,
    isHtmlContent = _param_isHtmlContent === void 0 ? false : _param_isHtmlContent,
    _param_spacing = param.spacing,
    spacing = _param_spacing === void 0 ? {} : _param_spacing;
  var dialogPostfix = useDialogId();
  var _useDialog3 = _sliced_to_array(useDialog3("".concat(uniqueDialogId, "-").concat(dialogPostfix), "pwaDialogNested"), 3),
    isDialogOpen = _useDialog3[0],
    dialogActions = _useDialog3[1],
    DialogComponent = _useDialog3[2];
  var trackClick = useClickTracker7();
  if (!data) {
    return null;
  }
  var content = data.content,
    trigger = data.trigger,
    toolbar = data.toolbar;
  var openDialog = function () {
    var clientSideAnalytics = trigger.clientSideAnalytics;
    dialogActions.openDialog();
    if (clientSideAnalytics) {
      trackClick("HOT.HIS".concat(clientSideAnalytics.referrerId), clientSideAnalytics.linkName);
    }
  };
  var closeDialog = function () {
    var clientSideAnalytics = (toolbar || {}).clientSideAnalytics;
    dialogActions.closeDialog();
    if (clientSideAnalytics) {
      trackClick("HOT.HIS".concat(clientSideAnalytics.referrerId), clientSideAnalytics.linkName);
    }
  };
  var SheetComponent = function (param) {
    var sheetSize = param.sheetSize;
    var _toolbar_icon;
    var _toolbar_title;
    return /* @__PURE__ */React31.createElement(EGDSSheet2, {
      triggerRef: null,
      isVisible: isDialogOpen,
      type: "centered",
      centeredSheetSize: sheetSize
    }, /* @__PURE__ */React31.createElement(EGDSToolbar, {
      key: "".concat(uniqueDialogId, "-toolbar"),
      toolbarTitle: (_toolbar_title = toolbar === null || toolbar === void 0 ? void 0 : toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
      navigationContent: {
        navIconLabel: toolbar === null || toolbar === void 0 ? void 0 : (_toolbar_icon = toolbar.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description,
        navType: "close",
        onClick: closeDialog
      }
    }), /* @__PURE__ */React31.createElement(EGDSSheetContent2, null, content.map(function (item, contentIndex) {
      return isHtmlContent ? /* @__PURE__ */React31.createElement(EGDSSpacing17, {
        padding: "three",
        key: "".concat(uniqueDialogId, "-content-").concat(contentIndex)
      }, /* @__PURE__ */React31.createElement(EGDSUnformattedHtml, {
        htmlToParse: item
      })) : /* @__PURE__ */React31.createElement(EGDSText10, {
        key: "".concat(uniqueDialogId, "-content-").concat(contentIndex),
        spacing: contentIndex !== 0 ? "four" : void 0
      }, item);
    })));
  };
  return /* @__PURE__ */React31.createElement(React31.Fragment, null, /* @__PURE__ */React31.createElement(EGDSSpacing17, _object_spread({}, spacing), /* @__PURE__ */React31.createElement(EGDSMoreInfoTrigger2, {
    onClick: openDialog
  }, /* @__PURE__ */React31.createElement("button", {
    type: "button"
  }, /* @__PURE__ */React31.createElement(EGDSText10, {
    className: "uitk-layout-flex",
    size: 300,
    theme: trigger.theme ? highlightedMessagesThemeToEGDSTextTheme[trigger.theme] : "default"
  }, trigger.value, trigger.icon && /* @__PURE__ */React31.createElement(EGDSIcon5, {
    name: trigger.icon.id,
    size: EGDSIconSize3.SMALL
  }))))), /* @__PURE__ */React31.createElement(EGDSSheetTransition2, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React31.createElement(DialogComponent, null, /* @__PURE__ */React31.createElement(Viewport4, null, /* @__PURE__ */React31.createElement(ViewSmall4, null, /* @__PURE__ */React31.createElement(SheetComponent, {
    sheetSize: "small"
  })), /* @__PURE__ */React31.createElement(ViewMedium2, null, /* @__PURE__ */React31.createElement(SheetComponent, {
    sheetSize: "medium"
  }))))));
};
LodgingPlainSheet.fragment = fragment10;
LodgingPlainSheet.displayName = "LodgingPlainSheet";
// src/components/property-offers/__private/__fragments/property-base-features.tsx
var __PropertyBaseFeaturesFragment = gql26(_templateObject25(), LodgingPlainSheet.fragment);
var PropertyBaseFeatures = function (param) {
  var data = param.data;
  var _data_primary;
  var _ref = (_data_primary = data.primary) !== null && _data_primary !== void 0 ? _data_primary : {},
    text = _ref.text,
    graphic = _ref.graphic;
  return /* @__PURE__ */React32.createElement(EGDSListItem3, null, graphic && graphic.__typename === "Icon" && /* @__PURE__ */React32.createElement(EGDSIcon6, {
    name: graphic.id,
    description: graphic.description,
    id: graphic.id
  }), text);
};
PropertyBaseFeatures.fragment = __PropertyBaseFeaturesFragment;
PropertyBaseFeatures.displayName = "PropertyBaseFeatures";
// src/components/property-offers/__private/__fragments/property-features.tsx
import React33 from "react";
import { gql as gql27 } from "@apollo/client";
import { EGDSIcon as EGDSIcon7 } from "@egds/react-core/icons";
import { EGDSListItem as EGDSListItem4 } from "@egds/react-core/list";
import { EGDSMark as EGDSMark2, EGDSMarkSize as EGDSMarkSize2 } from "@egds/react-core/mark";
var fragment11 = gql27(_templateObject26(), LodgingPlainSheet.fragment);
var PropertyFeatures = function (param) {
  var data = param.data,
    uniqueDialogId = param.uniqueDialogId;
  var _graphic_url;
  var text = data.text,
    moreInfoDialog = data.moreInfoDialog,
    graphic = data.graphic;
  return /* @__PURE__ */React33.createElement(EGDSListItem4, null, graphic && graphic.__typename === "Icon" && /* @__PURE__ */React33.createElement(EGDSIcon7, {
    name: graphic.id,
    description: graphic.description,
    id: graphic.id
  }), graphic && graphic.__typename === "Mark" && /* @__PURE__ */React33.createElement(EGDSMark2, {
    url: (_graphic_url = graphic.url) === null || _graphic_url === void 0 ? void 0 : _graphic_url.value,
    name: graphic.id,
    description: graphic.description,
    id: graphic.id,
    size: EGDSMarkSize2.SMALL
  }), !moreInfoDialog && text, uniqueDialogId && moreInfoDialog && /* @__PURE__ */React33.createElement(LodgingPlainSheet, {
    uniqueDialogId: uniqueDialogId,
    isHtmlContent: true,
    data: moreInfoDialog
  }));
};
PropertyFeatures.fragment = fragment11;
PropertyFeatures.displayName = "PropertyFeatures";
// src/components/property-offers/__private/__fragments/property-offers-header.tsx
import React34 from "react";
import { gql as gql28 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing18 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading5, EGDSText as EGDSText11 } from "@egds/react-core/text";
var fragment12 = gql28(_templateObject27());
var PropertyOffersHeader = function (param) {
  var data = param.data,
    _param_textSize = param.textSize,
    textSize = _param_textSize === void 0 ? 4 : _param_textSize,
    roomId = param.roomId,
    reviewSection = param.reviewSection;
  var text = data.text,
    subText = data.subText;
  return /* @__PURE__ */React34.createElement(React34.Fragment, null, /* @__PURE__ */React34.createElement(EGDSSpacing18, {
    padding: subText ? {} : {
      small: {
        blockend: "half"
      }
    }
  }, /* @__PURE__ */React34.createElement("div", null, /* @__PURE__ */React34.createElement(EGDSHeading5, {
    tag: "h3",
    size: textSize
  }, text))), /* @__PURE__ */React34.createElement(LodgingReviewSection, {
    data: reviewSection !== null && reviewSection !== void 0 ? reviewSection : null,
    roomId: roomId
  }), subText && /* @__PURE__ */React34.createElement(EGDSSpacing18, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React34.createElement(EGDSText11, null, subText)));
};
PropertyOffersHeader.fragment = fragment12;
PropertyOffersHeader.displayName = "PropertyOffersHeader";
// src/components/property-offers/__private/__fragments/rate-plan-message.tsx
import React39 from "react";
import { gql as gql33 } from "@apollo/client";
import { LodgingEnrichedMessage as LodgingEnrichedMessage5 } from "@shared-ui/lodging-fragments";
// src/components/property-offers/__private/__fragments/lodging-plain-dialog.tsx
import React36 from "react";
import { gql as gql30 } from "@apollo/client";
import { EGDSTertiaryButton as EGDSTertiaryButton2 } from "@egds/react-core/button";
import { EGDSDialog, EGDSDialogContent, EGDSDialogFooter } from "@egds/react-core/dialog";
import { EGDSIcon as EGDSIcon8, EGDSIconSize as EGDSIconSize4 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex7 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink3 } from "@egds/react-core/link";
import { EGDSSheetTransition as EGDSSheetTransition3 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing19 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText12 } from "@egds/react-core/text";
import { EGDSUnformattedHtml as EGDSUnformattedHtml2 } from "@egds/react-core/unformatted-html";
import { useClickTracker as useClickTracker9, useEgClickstream as useEgClickstream3 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
import { highlightedMessagesThemeToEGDSTextTheme as highlightedMessagesThemeToEGDSTextTheme2, useDialogId as useDialogId2 } from "@shared-ui/lodging-fragments";
// src/utils/clickstream-builder.ts
var clickstreamPresentedEventBuilder = function (prefix, pageName, actionLocation) {
  return {
    experience: {
      page_name: pageName
    },
    event: {
      event_type: "Impression" /* IMPRESSION */,
      event_name: "".concat(prefix, ".presented"),
      event_version: "1.0.0" /* GENERAL_VERSION */,
      action_location: actionLocation
    }
  };
};
function buildRoomsAndRatesClientPayload(eventName, roomTypeId, ratePlanId) {
  var payload = {
    experience: {
      page_name: "Product Details" /* PRODUCT_DETAILS */
    },
    event: {
      event_category: "rooms_and_rates" /* ROOMS_AND_RATES */,
      event_name: eventName,
      event_type: "Interaction" /* INTERACTION */,
      event_version: "1.0.0" /* GENERAL_VERSION */
    },
    rooms: [{
      type_code: roomTypeId,
      rate_plans: [{
        code: ratePlanId
      }]
    }]
  };
  return payload;
}
// src/components/property-offers/__private/__fragments/listings/property-unit-categorization/unit-rate-context.tsx
import React35, { useEffect as useEffect2 } from "react";
import { useClickTracker as useClickTracker8, useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
var UnitRateContext = React35.createContext({});
var getUnitRateIndex = function (value) {
  var values = value.split("-");
  return parseInt(values[values.length - 1] || "", 10);
};
var getUnitRateCategory = function (value) {
  var values = value.split("-");
  return values[values.length - 2] || "";
};
var getEnabledIndexes = function (primarySelections, indexes) {
  var _targetPrimary_primarySelection, _secondarySelections_secondaryIndex_secondarySelection, _secondarySelections_secondaryIndex, _tertiarySelections_tertiaryIndex;
  var _ref = indexes || {
      primaryIndex: 0,
      secondaryIndex: 0,
      tertiaryIndex: 0
    },
    primaryIndex = _ref.primaryIndex,
    secondaryIndex = _ref.secondaryIndex,
    tertiaryIndex = _ref.tertiaryIndex;
  var enabledPrimary = primarySelections.find(function (param) {
    var primarySelection = param.primarySelection;
    return primarySelection === null || primarySelection === void 0 ? void 0 : primarySelection.enabled;
  }) || primarySelections.find(Boolean);
  var targetPrimary = primarySelections[primaryIndex];
  var enabledPrimaryIndex = (targetPrimary === null || targetPrimary === void 0 ? void 0 : (_targetPrimary_primarySelection = targetPrimary.primarySelection) === null || _targetPrimary_primarySelection === void 0 ? void 0 : _targetPrimary_primarySelection.enabled) ? primaryIndex : enabledPrimary ? primarySelections === null || primarySelections === void 0 ? void 0 : primarySelections.indexOf(enabledPrimary) : 0;
  var secondarySelections = (primarySelections[enabledPrimaryIndex] || {
    secondarySelections: null
  }).secondarySelections;
  var enabledSecondaryOption = (secondarySelections === null || secondarySelections === void 0 ? void 0 : secondarySelections.find(function (param) {
    var secondarySelection = param.secondarySelection;
    return secondarySelection === null || secondarySelection === void 0 ? void 0 : secondarySelection.enabled;
  })) || (secondarySelections === null || secondarySelections === void 0 ? void 0 : secondarySelections[0]);
  if (!secondarySelections || !enabledSecondaryOption) {
    return {
      primaryIndex: enabledPrimaryIndex,
      secondaryIndex: 0,
      tertiaryIndex: 0
    };
  }
  var defaultSecondaryIndex = secondarySelections === null || secondarySelections === void 0 ? void 0 : secondarySelections.indexOf(enabledSecondaryOption);
  var hasSecondaryTarget = secondaryIndex && ((_secondarySelections_secondaryIndex = secondarySelections[secondaryIndex]) === null || _secondarySelections_secondaryIndex === void 0 ? void 0 : (_secondarySelections_secondaryIndex_secondarySelection = _secondarySelections_secondaryIndex.secondarySelection) === null || _secondarySelections_secondaryIndex_secondarySelection === void 0 ? void 0 : _secondarySelections_secondaryIndex_secondarySelection.enabled);
  var enabledSecondaryIndex = hasSecondaryTarget && secondaryIndex ? secondaryIndex : defaultSecondaryIndex;
  var tertiarySelections = (secondarySelections[enabledSecondaryIndex] || {
    tertiarySelections: null
  }).tertiarySelections;
  var enabledTertiaryOption = tertiarySelections === null || tertiarySelections === void 0 ? void 0 : tertiarySelections.find(function (param) {
    var enabled = param.enabled;
    return enabled;
  });
  if (!tertiarySelections || !enabledTertiaryOption) {
    return {
      primaryIndex: enabledPrimaryIndex,
      secondaryIndex: enabledSecondaryIndex,
      tertiaryIndex: 0
    };
  }
  var defaultTertiaryIndex = enabledTertiaryOption && (tertiarySelections === null || tertiarySelections === void 0 ? void 0 : tertiarySelections.indexOf(enabledTertiaryOption));
  var hasTertiaryTarget = tertiaryIndex && (tertiarySelections === null || tertiarySelections === void 0 ? void 0 : (_tertiarySelections_tertiaryIndex = tertiarySelections[tertiaryIndex]) === null || _tertiarySelections_tertiaryIndex === void 0 ? void 0 : _tertiarySelections_tertiaryIndex.enabled);
  var enabledTertiaryIndex = hasTertiaryTarget && tertiaryIndex ? tertiaryIndex : defaultTertiaryIndex;
  return {
    primaryIndex: enabledPrimaryIndex,
    secondaryIndex: enabledSecondaryIndex,
    tertiaryIndex: enabledTertiaryIndex
  };
};
var getSelections = function (primarySelections, indexes) {
  var _secondarySelections_secondaryIndex;
  var primaryIndex = indexes.primaryIndex,
    secondaryIndex = indexes.secondaryIndex,
    tertiaryIndex = indexes.tertiaryIndex;
  var _ref = primarySelections[primaryIndex] || {
      propertyUnit: null,
      primarySelection: null,
      secondarySelections: null
    },
    propertyUnit = _ref.propertyUnit,
    primarySelection = _ref.primarySelection,
    secondarySelections = _ref.secondarySelections;
  var secondaryTarget = secondarySelections === null || secondarySelections === void 0 ? void 0 : secondarySelections[secondaryIndex];
  var secondarySelection = secondaryTarget === null || secondaryTarget === void 0 ? void 0 : secondaryTarget.secondarySelection;
  var tertiarySelections = secondarySelections === null || secondarySelections === void 0 ? void 0 : (_secondarySelections_secondaryIndex = secondarySelections[secondaryIndex]) === null || _secondarySelections_secondaryIndex === void 0 ? void 0 : _secondarySelections_secondaryIndex.tertiarySelections;
  var tertiarySelection = tertiarySelections === null || tertiarySelections === void 0 ? void 0 : tertiarySelections[tertiaryIndex];
  return {
    propertyUnit: propertyUnit || {},
    primarySelection: primarySelection,
    secondaryTarget: secondaryTarget,
    secondarySelection: secondarySelection,
    secondarySelections: secondarySelections,
    tertiarySelection: tertiarySelection
  };
};
var getRatePlan = function (selections) {
  var _selections_primarySelection, _selections_secondarySelection, _selections_tertiarySelection;
  var ratePlans = selections.propertyUnit.ratePlans;
  var primaryId = selections === null || selections === void 0 ? void 0 : (_selections_primarySelection = selections.primarySelection) === null || _selections_primarySelection === void 0 ? void 0 : _selections_primarySelection.optionId;
  var secondaryId = selections === null || selections === void 0 ? void 0 : (_selections_secondarySelection = selections.secondarySelection) === null || _selections_secondarySelection === void 0 ? void 0 : _selections_secondarySelection.optionId;
  var tertiaryId = selections === null || selections === void 0 ? void 0 : (_selections_tertiarySelection = selections.tertiarySelection) === null || _selections_tertiarySelection === void 0 ? void 0 : _selections_tertiarySelection.optionId;
  var optionId = tertiaryId || secondaryId || primaryId;
  var ratePlan = ratePlans.find(function (param) {
    var id = param.id;
    return id === optionId;
  }) || ratePlans.find(function () {
    return true;
  });
  var ratePlanIndex = ratePlan ? ratePlans.indexOf(ratePlan) + 1 : 1;
  return {
    ratePlan: ratePlan,
    ratePlanIndex: ratePlanIndex
  };
};
var getRoomType = function (selections) {
  var _selections_propertyUnit = selections.propertyUnit,
    roomTypeId = _selections_propertyUnit.id;
  return {
    roomTypeId: roomTypeId
  };
};
var selectedIndexOrZero = function (selectedIndex) {
  return selectedIndex && selectedIndex >= 0 ? selectedIndex : 0;
};
var getDefaultSelections = function (primarySelections) {
  var _primarySelections_primaryIndex, _secondarySelections_secondaryIndex_tertiarySelections, _secondarySelections_secondaryIndex;
  var primaryIndex = selectedIndexOrZero(primarySelections.findIndex(function (param) {
    var primarySelection = param.primarySelection;
    return primarySelection === null || primarySelection === void 0 ? void 0 : primarySelection.selected;
  }));
  var secondarySelections = (_primarySelections_primaryIndex = primarySelections[primaryIndex]) === null || _primarySelections_primaryIndex === void 0 ? void 0 : _primarySelections_primaryIndex.secondarySelections;
  var secondaryIndex = selectedIndexOrZero(secondarySelections === null || secondarySelections === void 0 ? void 0 : secondarySelections.findIndex(function (param) {
    var secondarySelection = param.secondarySelection;
    return secondarySelection === null || secondarySelection === void 0 ? void 0 : secondarySelection.selected;
  }));
  var tertiaryIndex = selectedIndexOrZero(secondarySelections === null || secondarySelections === void 0 ? void 0 : (_secondarySelections_secondaryIndex = secondarySelections[secondaryIndex]) === null || _secondarySelections_secondaryIndex === void 0 ? void 0 : (_secondarySelections_secondaryIndex_tertiarySelections = _secondarySelections_secondaryIndex.tertiarySelections) === null || _secondarySelections_secondaryIndex_tertiarySelections === void 0 ? void 0 : _secondarySelections_secondaryIndex_tertiarySelections.findIndex(function (param) {
    var selected = param.selected;
    return selected;
  }));
  return {
    primaryIndex: primaryIndex,
    secondaryIndex: secondaryIndex,
    tertiaryIndex: tertiaryIndex
  };
};
var hasRadioSelection = function (primarySelections, secondaryTarget) {
  var _secondaryTarget_tertiarySelections;
  var hasPrimary = primarySelections.length > 1;
  var hasSecondary = Boolean(secondaryTarget === null || secondaryTarget === void 0 ? void 0 : secondaryTarget.secondarySelection);
  var hasTertiary = Boolean(secondaryTarget === null || secondaryTarget === void 0 ? void 0 : (_secondaryTarget_tertiarySelections = secondaryTarget.tertiarySelections) === null || _secondaryTarget_tertiarySelections === void 0 ? void 0 : _secondaryTarget_tertiarySelections.length);
  return hasPrimary || hasSecondary || hasTertiary ? {
    hasPrimary: hasPrimary,
    hasSecondary: hasSecondary,
    hasTertiary: hasTertiary
  } : void 0;
};
var UnitRateContextProvider = function (param) {
  var isFullyRefundable = param.isFullyRefundable,
    primarySelections = param.primarySelections,
    setDismissMessagingCard = param.setDismissMessagingCard,
    setDefaultToFullyRefundable = param.setDefaultToFullyRefundable,
    children = param.children;
  var initialIndexes = getEnabledIndexes(primarySelections, getDefaultSelections(primarySelections));
  var _React35_useState = _sliced_to_array(React35.useState(initialIndexes.primaryIndex), 2),
    primaryIndex = _React35_useState[0],
    setPrimaryIndex = _React35_useState[1];
  var _React35_useState1 = _sliced_to_array(React35.useState(initialIndexes.secondaryIndex), 2),
    secondaryIndex = _React35_useState1[0],
    setSecondaryIndex = _React35_useState1[1];
  var _React35_useState2 = _sliced_to_array(React35.useState(initialIndexes.tertiaryIndex), 2),
    tertiaryIndex = _React35_useState2[0],
    setTertiaryIndex = _React35_useState2[1];
  var _React35_useState3 = _sliced_to_array(React35.useState(false), 2),
    hasRecommendation = _React35_useState3[0],
    setHasRecommendation = _React35_useState3[1];
  var analyticsTracker = useClickTracker8();
  var trackEgClickstreamEvent = useEgClickstream2();
  var selections = getSelections(primarySelections, {
    primaryIndex: primaryIndex,
    secondaryIndex: secondaryIndex,
    tertiaryIndex: tertiaryIndex
  });
  var _getRatePlan = getRatePlan(selections),
    ratePlan = _getRatePlan.ratePlan,
    ratePlanIndex = _getRatePlan.ratePlanIndex;
  var roomTypeId = getRoomType(selections).roomTypeId;
  var secondarySelections = selections.secondarySelections,
    secondaryTarget = selections.secondaryTarget;
  var radioSelections = hasRadioSelection(primarySelections, secondaryTarget);
  useEffect2(function () {
    setPrimaryIndex(initialIndexes.primaryIndex);
  }, [initialIndexes.primaryIndex]);
  useEffect2(function () {
    setSecondaryIndex(initialIndexes.secondaryIndex);
  }, [initialIndexes.secondaryIndex]);
  useEffect2(function () {
    setTertiaryIndex(initialIndexes.tertiaryIndex);
  }, [initialIndexes.tertiaryIndex]);
  useEffect2(function () {
    if (isFullyRefundable) {
      secondarySelections === null || secondarySelections === void 0 ? void 0 : secondarySelections.forEach(function (param, index) {
        var recommendedSelection = param.recommendedSelection;
        if (!recommendedSelection) {
          return;
        }
        var indexes = getEnabledIndexes(primarySelections, {
          primaryIndex: primaryIndex,
          secondaryIndex: index,
          tertiaryIndex: tertiaryIndex
        });
        setSecondaryIndex(index);
        if (setDismissMessagingCard) {
          setDismissMessagingCard(true);
        }
        setTertiaryIndex(indexes.tertiaryIndex);
      });
      if (setDefaultToFullyRefundable) {
        setDefaultToFullyRefundable(false);
      }
    }
  }, [isFullyRefundable, primaryIndex, primarySelections, secondarySelections, setDefaultToFullyRefundable, setDismissMessagingCard, tertiaryIndex]);
  var handleRadio = function (event) {
    var _getRatePlan_ratePlan;
    var index = getUnitRateIndex(event.target.value);
    var category = getUnitRateCategory(event.target.value);
    var map = {
      roomFeatures: {
        getIndexes: function () {
          return getEnabledIndexes(primarySelections, {
            primaryIndex: index,
            secondaryIndex: 0,
            tertiaryIndex: 0
          });
        },
        selectionKey: "primarySelection"
      },
      cancellationPolicy: {
        getIndexes: function () {
          return getEnabledIndexes(primarySelections, {
            primaryIndex: primaryIndex,
            secondaryIndex: index,
            tertiaryIndex: 0
          });
        },
        selectionKey: "secondarySelection"
      },
      extras: {
        getIndexes: function () {
          return getEnabledIndexes(primarySelections, {
            primaryIndex: primaryIndex,
            secondaryIndex: secondaryIndex,
            tertiaryIndex: index
          });
        },
        selectionKey: "tertiarySelection"
      }
    };
    var _map_category = map[category],
      getIndexes = _map_category.getIndexes,
      selectionKey = _map_category.selectionKey;
    var indexes = getIndexes();
    setPrimaryIndex(indexes.primaryIndex);
    setSecondaryIndex(indexes.secondaryIndex);
    setTertiaryIndex(indexes.tertiaryIndex);
    var unitSelections = getSelections(primarySelections, indexes);
    var clientSideAnalytics = unitSelections[selectionKey].clientSideAnalytics;
    var ratePlanId = (_getRatePlan_ratePlan = getRatePlan(unitSelections).ratePlan) === null || _getRatePlan_ratePlan === void 0 ? void 0 : _getRatePlan_ratePlan.id;
    if (category !== "roomFeatures" && ratePlanId) {
      trackEgClickstreamEvent(buildRoomsAndRatesClientPayload("rooms_and_rates_radio_button.selected" /* ROOMS_AND_RATES_RADIO_BUTTON_SELECTED */, roomTypeId, ratePlanId));
    }
    analyticsTracker("".concat(clientSideAnalytics.referrerId, ".").concat(roomTypeId, ".").concat(ratePlanId), clientSideAnalytics.linkName, true);
  };
  var setHasRecommendationValue = function () {
    setHasRecommendation(true);
  };
  return /* @__PURE__ */React35.createElement(UnitRateContext.Provider, {
    value: {
      primaryIndex: primaryIndex,
      ratePlan: ratePlan,
      ratePlanIndex: ratePlanIndex,
      secondaryIndex: secondaryIndex,
      tertiaryIndex: tertiaryIndex,
      handleRadio: handleRadio,
      radioSelections: radioSelections,
      roomTypeId: roomTypeId,
      hasRecommendation: hasRecommendation,
      setHasRecommendationValue: setHasRecommendationValue
    }
  }, children);
};
// src/components/property-offers/__private/__fragments/ui-button.tsx
import { gql as gql29 } from "@apollo/client";
var __UIPrimaryButtonFragment = gql29(_templateObject28());
var __UISecondaryButtonFragment = gql29(_templateObject29());
var getUiButtonProps = function (action, track, closeDialog) {
  if (!action) {
    return {
      onClick: closeDialog
    };
  }
  var analytics2 = action.analytics;
  var onClick = function () {
    track("HOT.HIS".concat(analytics2.referrerId), analytics2.linkName, false);
    if (action.__typename !== "UILinkAction") {
      closeDialog();
    }
  };
  var href = action.__typename === "UILinkAction" ? action.resource.value : void 0;
  return {
    onClick: onClick,
    href: href
  };
};
// src/components/property-offers/__private/__fragments/lodging-plain-dialog.tsx
var fragment13 = gql30(_templateObject30(), __UIPrimaryButtonFragment, __UISecondaryButtonFragment);
var LodgingPlainDialog = function (param) {
  var data = param.data,
    text = param.text,
    uniqueDialogId = param.uniqueDialogId;
  var _data_content;
  var _React36_useContext = React36.useContext(UnitRateContext),
    ratePlan = _React36_useContext.ratePlan,
    roomTypeId = _React36_useContext.roomTypeId;
  var dialogPostfix = useDialogId2();
  var _useDialog4 = _sliced_to_array(useDialog4("".concat(uniqueDialogId, "-").concat(dialogPostfix), "nestedLodgingPlainDialog"), 3),
    isDialogOpen = _useDialog4[0],
    dialogActions = _useDialog4[1],
    DialogComponent = _useDialog4[2];
  var triggerRef = React36.useRef(null);
  var trackClick = useClickTracker9();
  var trackEgClickstreamEvent = useEgClickstream3();
  var isHtmlContent = (data === null || data === void 0 ? void 0 : (_data_content = data.content) === null || _data_content === void 0 ? void 0 : _data_content.length) <= 1;
  if (!data || !data.trigger) {
    return null;
  }
  var content = data.content,
    trigger = data.trigger,
    primaryButton = data.primaryButton,
    primaryUIButton = data.primaryUIButton,
    secondaryUIButton = data.secondaryUIButton;
  var openDialog = function () {
    var clientSideAnalytics = trigger.clientSideAnalytics;
    dialogActions.openDialog();
    if (roomTypeId && (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.id)) {
      trackEgClickstreamEvent(buildRoomsAndRatesClientPayload("cancellation_options.selected" /* CANCELLATION_OPTIONS_SELECTED */, roomTypeId, ratePlan.id));
    }
    if (clientSideAnalytics) {
      trackClick("HOT.HIS".concat(clientSideAnalytics.referrerId), clientSideAnalytics.linkName);
    }
  };
  var closeDialog = function () {
    var _ref = primaryButton || {},
      analytics2 = _ref.analytics;
    dialogActions.closeDialog();
    if (analytics2) {
      trackClick("HOT.HIS".concat(analytics2.referrerId), analytics2.linkName);
    }
  };
  return /* @__PURE__ */React36.createElement(EGDSLayoutFlex7, null, /* @__PURE__ */React36.createElement(EGDSSpacing19, {
    padding: {
      blockstart: "half"
    }
  }, /* @__PURE__ */React36.createElement("div", null, /* @__PURE__ */React36.createElement(EGDSLink3, {
    onClick: openDialog
  }, /* @__PURE__ */React36.createElement("button", {
    type: "button",
    ref: triggerRef
  }, /* @__PURE__ */React36.createElement(EGDSText12, {
    size: 300,
    theme: trigger.theme ? highlightedMessagesThemeToEGDSTextTheme2[trigger.theme] : "default"
  }, text || trigger.value, trigger.icon && /* @__PURE__ */React36.createElement(EGDSSpacing19, {
    padding: {
      inline: "two"
    }
  }, /* @__PURE__ */React36.createElement(EGDSIcon8, {
    name: trigger.icon.id,
    size: EGDSIconSize4.SMALL
  }))))), trigger.secondaryValue && /* @__PURE__ */React36.createElement(EGDSText12, {
    theme: "standard",
    size: 200
  }, trigger.secondaryValue), /* @__PURE__ */React36.createElement(EGDSSheetTransition3, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React36.createElement(DialogComponent, null, /* @__PURE__ */React36.createElement(EGDSDialog, {
    ariaLabel: trigger.value,
    dialogShow: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef: triggerRef
  }, /* @__PURE__ */React36.createElement(EGDSDialogContent, null, content.map(function (item, contentIndex) {
    return isHtmlContent ? /* @__PURE__ */React36.createElement(EGDSSpacing19, {
      padding: "three",
      key: "content-".concat(contentIndex)
    }, /* @__PURE__ */React36.createElement(EGDSUnformattedHtml2, {
      htmlToParse: item
    })) : /* @__PURE__ */React36.createElement(EGDSText12, {
      key: "content-".concat(contentIndex),
      spacing: contentIndex !== 0 ? "four" : void 0
    }, item);
  }), primaryButton && /* @__PURE__ */React36.createElement(EGDSDialogFooter, {
    stacked: false,
    buttonOne: {
      onClick: closeDialog,
      text: primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.text,
      type: "tertiary"
    }
  }), primaryUIButton && /* @__PURE__ */React36.createElement(EGDSDialogFooter, null, /* @__PURE__ */React36.createElement(EGDSTertiaryButton2, _object_spread({}, getUiButtonProps(primaryUIButton.action, trackClick, closeDialog)), primaryUIButton.primary || ""), secondaryUIButton && /* @__PURE__ */React36.createElement(EGDSTertiaryButton2, _object_spread({}, getUiButtonProps(secondaryUIButton.action, trackClick, closeDialog)), secondaryUIButton.primary || "")))))))));
};
LodgingPlainDialog.fragment = fragment13;
LodgingPlainDialog.displayName = "LodgingPlainDialog";
// src/components/property-offers/__private/__fragments/lodging-plain-message.tsx
import React37 from "react";
import { gql as gql31 } from "@apollo/client";
import { EGDSText as EGDSText13 } from "@egds/react-core/text";
var fragment14 = gql31(_templateObject31());
var LodgingPlainMessage = function (param) {
  var value = param.data.value;
  return /* @__PURE__ */React37.createElement(EGDSText13, null, value);
};
LodgingPlainMessage.displayName = "LodgingPlainMessage";
LodgingPlainMessage.fragment = fragment14;
// src/components/property-offers/__private/__fragments/lodging-policy-dialog.tsx
import React38 from "react";
import { gql as gql32 } from "@apollo/client";
import { EGDSDialogContent as EGDSDialogContent2 } from "@egds/react-core/dialog";
import { EGDSIcon as EGDSIcon9, EGDSIconSize as EGDSIconSize5 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink4 } from "@egds/react-core/link";
import { EGDSSheet as EGDSSheet3, EGDSSheetTransition as EGDSSheetTransition4 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing20 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText14 } from "@egds/react-core/text";
import { EGDSToolbar as EGDSToolbar2 } from "@egds/react-core/toolbar";
import { useClickTracker as useClickTracker10, useEgClickstream as useEgClickstream4 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";
import { highlightedMessagesThemeToEGDSTextTheme as highlightedMessagesThemeToEGDSTextTheme3, LodgingDetailedTimeline as LodgingDetailedTimeline2, useDialogId as useDialogId3 } from "@shared-ui/lodging-fragments";
import { ViewMedium as ViewMedium3, Viewport as Viewport5, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
var fragment15 = gql32(_templateObject32(), LodgingDetailedTimeline2.fragment);
var LodgingPolicyDialog = function (param) {
  var data = param.data,
    uniqueDialogId = param.uniqueDialogId,
    _param_policyType = param.policyType,
    policyType = _param_policyType === void 0 ? "SINGLE" /* SINGLE */ : _param_policyType;
  var _toolbar_icon;
  var _React38_useContext = React38.useContext(UnitRateContext),
    ratePlan = _React38_useContext.ratePlan,
    roomTypeId = _React38_useContext.roomTypeId;
  var dialogPostfix = useDialogId3();
  var _useDialog5 = _sliced_to_array(useDialog5("".concat(uniqueDialogId, "-").concat(dialogPostfix), "lodging-policy-dialog"), 3),
    isDialogOpen = _useDialog5[0],
    dialogActions = _useDialog5[1],
    DialogComponent = _useDialog5[2];
  var triggerRef = React38.useRef(null);
  var trackClick = useClickTracker10();
  var trackEgClickstreamEvent = useEgClickstream4();
  if (!(data === null || data === void 0 ? void 0 : data.trigger)) {
    return null;
  }
  var policyContent = data.policyContent,
    trigger = data.trigger,
    toolbar = data.toolbar;
  var openDialog = function () {
    var clientSideAnalytics = trigger.clientSideAnalytics;
    dialogActions.openDialog();
    if (roomTypeId && (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.id)) {
      trackEgClickstreamEvent(buildRoomsAndRatesClientPayload("more_details.selected" /* MORE_DETAILS_SELECTED */, roomTypeId, ratePlan.id));
    }
    if (clientSideAnalytics) {
      trackClick(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
    }
    trackEgClickstreamEvent(clickstreamPresentedEventBuilder("cancellation_policy" /* CANCELLATION_POLICY */, "Product Details" /* PRODUCT_DETAILS */, "PDP" /* PDP */));
  };
  var closeDialog = function () {
    var clientSideAnalytics = toolbar === null || toolbar === void 0 ? void 0 : toolbar.clientSideAnalytics;
    dialogActions.closeDialog();
    if (clientSideAnalytics) {
      trackClick(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
    }
  };
  var _toolbar_title;
  var dialogContent = /* @__PURE__ */React38.createElement(React38.Fragment, null, /* @__PURE__ */React38.createElement(EGDSToolbar2, {
    toolbarTitle: (_toolbar_title = toolbar === null || toolbar === void 0 ? void 0 : toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
    navigationContent: {
      onClick: closeDialog,
      navIconLabel: toolbar === null || toolbar === void 0 ? void 0 : (_toolbar_icon = toolbar.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description
    }
  }), /* @__PURE__ */React38.createElement(EGDSDialogContent2, null, /* @__PURE__ */React38.createElement(LodgingDetailedTimeline2, {
    data: policyContent
  })));
  var _toolbar_title1, _toolbar_title2;
  return /* @__PURE__ */React38.createElement(EGDSSpacing20, {
    padding: policyType === "SINGLE" /* SINGLE */ ? {
      blockstart: "half"
    } : {
      blockstart: "half",
      blockend: "one"
    }
  }, /* @__PURE__ */React38.createElement("div", null, /* @__PURE__ */React38.createElement(EGDSSpacing20, {
    padding: policyType === "MULTIPLE" /* MULTIPLE */ ? {
      block: "two"
    } : {}
  }, /* @__PURE__ */React38.createElement(EGDSLink4, {
    onClick: openDialog,
    "aria-label": trigger.accessibilityLabel
  }, /* @__PURE__ */React38.createElement("button", {
    type: "button",
    ref: triggerRef
  }, /* @__PURE__ */React38.createElement(EGDSText14, {
    size: policyType === "SINGLE" /* SINGLE */ ? 300 : 200,
    theme: trigger.theme ? highlightedMessagesThemeToEGDSTextTheme3[trigger.theme] : "default"
  }, trigger.value, trigger.icon && /* @__PURE__ */React38.createElement(EGDSSpacing20, {
    padding: policyType === "SINGLE" /* SINGLE */ ? {
      inline: "two"
    } : {}
  }, /* @__PURE__ */React38.createElement(EGDSIcon9, {
    name: trigger.icon.id,
    size: EGDSIconSize5.SMALL
  })))))), trigger.secondaryValue && /* @__PURE__ */React38.createElement(EGDSText14, {
    theme: "standard",
    size: 200
  }, trigger.secondaryValue), /* @__PURE__ */React38.createElement(EGDSSheetTransition4, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React38.createElement(DialogComponent, null, /* @__PURE__ */React38.createElement(Viewport5, null, /* @__PURE__ */React38.createElement(ViewSmall5, null, /* @__PURE__ */React38.createElement(EGDSSheet3, {
    ariaLabel: (_toolbar_title1 = toolbar === null || toolbar === void 0 ? void 0 : toolbar.title) !== null && _toolbar_title1 !== void 0 ? _toolbar_title1 : void 0,
    type: "full",
    isVisible: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef: triggerRef
  }, dialogContent)), /* @__PURE__ */React38.createElement(ViewMedium3, null, /* @__PURE__ */React38.createElement(EGDSSheet3, {
    ariaLabel: (_toolbar_title2 = toolbar === null || toolbar === void 0 ? void 0 : toolbar.title) !== null && _toolbar_title2 !== void 0 ? _toolbar_title2 : void 0,
    type: "centered",
    isVisible: isDialogOpen,
    centeredSheetSize: "small",
    returnFocusOnClose: true,
    triggerRef: triggerRef
  }, dialogContent)))))));
};
LodgingPolicyDialog.fragment = fragment15;
LodgingPolicyDialog.displayName = "LodgingPlainDialog";
// src/components/property-offers/__private/__fragments/rate-plan-message.tsx
var fragment16 = gql33(_templateObject33(), LodgingEnrichedMessage5.fragment, LodgingPlainDialog.fragment, LodgingPolicyDialog.fragment, LodgingPlainMessage.fragment);
var RatePlanMessage = function (param) {
  var data = param.data;
  switch (data === null || data === void 0 ? void 0 : data.__typename) {
    case "LodgingEnrichedMessage":
      return /* @__PURE__ */React39.createElement(LodgingEnrichedMessage5, {
        data: data
      });
    case "LodgingPlainDialog":
      return /* @__PURE__ */React39.createElement(LodgingPlainDialog, {
        data: data,
        uniqueDialogId: "cancellation-policy-dialog"
      });
    case "LodgingPolicyDialog":
      return /* @__PURE__ */React39.createElement(LodgingPolicyDialog, {
        data: data,
        uniqueDialogId: "lodging-cancellation-policy-dialog",
        policyType: "SINGLE" /* SINGLE */
      });
    case "LodgingPlainMessage":
      return /* @__PURE__ */React39.createElement(LodgingPlainMessage, {
        data: data
      });
    default:
      return null;
  }
};
RatePlanMessage.fragment = fragment16;
RatePlanMessage.displayName = "RatePlanMessage";
// src/components/property-offers/__private/__fragments/listings/offers-level-provider/offers-level-provider.tsx
import React40, { useMemo as useMemo2, useState } from "react";
var OffersLevelContext = React40.createContext({});
var OffersLevelProvider = function (param) {
  var children = param.children;
  var _useState = _sliced_to_array(useState(false), 2),
    isFullyRefundable = _useState[0],
    setDefaultToFullyRefundable = _useState[1];
  var _useState1 = _sliced_to_array(useState(false), 2),
    isMessagingCardDismissed = _useState1[0],
    setDismissMessagingCard = _useState1[1];
  return /* @__PURE__ */React40.createElement(OffersLevelContext.Provider, {
    value: useMemo2(function () {
      return {
        isFullyRefundable: isFullyRefundable,
        setDefaultToFullyRefundable: setDefaultToFullyRefundable,
        isMessagingCardDismissed: isMessagingCardDismissed,
        setDismissMessagingCard: setDismissMessagingCard
      };
    }, [isFullyRefundable, setDefaultToFullyRefundable, isMessagingCardDismissed, setDismissMessagingCard])
  }, children);
};
// src/components/property-offers/__private/__fragments/listings/sections/unit-categorization.tsx
import React100 from "react";
import { gql as gql81 } from "@apollo/client";
import { EGDSCardContentSection as EGDSCardContentSection8 } from "@egds/react-core/cards";
import { EGDSSpacing as EGDSSpacing56 } from "@egds/react-core/spacing";
import { Level, liveAnnounce } from "@egds/react-core/utils";
import { RadioButtonDescriptionExtensionWithPositiveTheme } from "@egds/react-lodging";
import { DialogContext as DialogContext11 } from "@shared-ui/lodging-fragments";
// src/components/__private/__fragments/space-details.tsx
import React45 from "react";
import { gql as gql38 } from "@apollo/client";
import { EGDSCard as EGDSCard6 } from "@egds/react-core/cards";
import { EGDSSpacing as EGDSSpacing23 } from "@egds/react-core/spacing";
// src/components/__private/__fragments/space-details-floor-plan.tsx
import React41 from "react";
import { gql as gql34 } from "@apollo/client";
import { EGDSLink as EGDSLink5 } from "@egds/react-core/link";
import { UitkMediaGalleryImageDialog as EGDSMediaGalleryImageDialog, UitkMediaGalleryImageView as EGDSMediaGalleryImageView } from "@egds/react-core/media-gallery";
import { EGDSSheetTransition as EGDSSheetTransition5 } from "@egds/react-core/sheet";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog6 } from "@shared-ui/dialog-context";
import { useDialogId as useDialogId4 } from "@shared-ui/lodging-fragments";
var mapImages = function (image) {
  var _image_image, _image_image1;
  return {
    alt: image === null || image === void 0 ? void 0 : image.alt,
    caption: image === null || image === void 0 ? void 0 : (_image_image = image.image) === null || _image_image === void 0 ? void 0 : _image_image.description,
    src: image === null || image === void 0 ? void 0 : (_image_image1 = image.image) === null || _image_image1 === void 0 ? void 0 : _image_image1.url,
    subjectId: image === null || image === void 0 ? void 0 : image.subjectId
  };
};
var __SpaceDetailsFloorPlanFragment = gql34(_templateObject34());
var SpaceDetailsFloorPlan = function (param) {
  var data = param.data,
    rfrr = param.rfrr,
    className = param.className;
  var floorPlan = data.floorPlan;
  var dialogPostfix = useDialogId4();
  var _useDialog6 = _sliced_to_array(useDialog6("space-details-".concat(dialogPostfix), "pwaDialogNested"), 3),
    isDialogOpen = _useDialog6[0],
    dialogActions = _useDialog6[1],
    DialogComponent = _useDialog6[2];
  var track = useClickTracker11();
  if (!(floorPlan === null || floorPlan === void 0 ? void 0 : floorPlan.images.length)) {
    return null;
  }
  var images = floorPlan.images,
    toolbar = floorPlan.toolbar,
    trigger = floorPlan.trigger;
  var uitkImages = images.map(mapImages);
  var toolBarAttributes = {
    type: "close",
    header: toolbar === null || toolbar === void 0 ? void 0 : toolbar.title
  };
  var toolbarAnalytics = {
    id: rfrr,
    description: "Close floorplan dialog",
    callback: function (_id, _desc) {
      return track(_id, _desc, true);
    }
  };
  var mediaGalleryControlsAnalytics = {
    id: rfrr,
    description: "Change image in floorplan gallery",
    callback: function (_id, _desc) {
      return track(_id, _desc, true);
    }
  };
  var handleTriggerClick = function () {
    dialogActions.openDialog();
    track(rfrr, "Open floor plan dialog", true);
  };
  var mediaGalleryImageViewProps = {
    galleryName: "Floorplan",
    currentIndex: 0,
    analytics: mediaGalleryControlsAnalytics
  };
  return /* @__PURE__ */React41.createElement(React41.Fragment, null, /* @__PURE__ */React41.createElement(EGDSLink5, {
    className: className
  }, /* @__PURE__ */React41.createElement("button", {
    type: "button",
    onClick: handleTriggerClick
  }, trigger.value)), /* @__PURE__ */React41.createElement(EGDSSheetTransition5, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React41.createElement(DialogComponent, null, /* @__PURE__ */React41.createElement(EGDSMediaGalleryImageDialog, _object_spread({
    dialogShow: true,
    strictFullscreen: true,
    onDismiss: dialogActions.closeDialog,
    analytics: toolbarAnalytics
  }, toolBarAttributes), /* @__PURE__ */React41.createElement(EGDSMediaGalleryImageView, _object_spread_props(_object_spread({}, mediaGalleryImageViewProps), {
    images: uitkImages,
    stretchToFill: false
  }))))));
};
SpaceDetailsFloorPlan.displayName = "SpaceDetailsFloorPlan";
SpaceDetailsFloorPlan.fragment = __SpaceDetailsFloorPlanFragment;
// src/components/__private/__fragments/space-details-header.tsx
import React42 from "react";
import { gql as gql35 } from "@apollo/client";
import { EGDSHeading as EGDSHeading6, EGDSText as EGDSText15 } from "@egds/react-core/text";
var __SpaceDetailsHeaderFragment = gql35(_templateObject35());
var SpaceDetailsHeader = function (param) {
  var data = param.data,
    _param_headingSize = param.headingSize,
    headingSize = _param_headingSize === void 0 ? 4 : _param_headingSize;
  var header = data.header,
    summary = data.summary;
  return /* @__PURE__ */React42.createElement(React42.Fragment, null, /* @__PURE__ */React42.createElement(EGDSHeading6, {
    size: headingSize,
    tag: "h3"
  }, header.text), summary === null || summary === void 0 ? void 0 : summary.map(function (value, index) {
    return /* @__PURE__ */React42.createElement(EGDSText15, {
      theme: "standard",
      key: "spacedetails-summary-".concat(index),
      spacing: index === 0 ? "three" : void 0
    }, value);
  }));
};
SpaceDetailsHeader.displayName = "SpaceDetailsHeader";
SpaceDetailsHeader.fragment = __SpaceDetailsHeaderFragment;
// src/components/__private/__fragments/space-details-spaces.tsx
import React43 from "react";
import { gql as gql36 } from "@apollo/client";
import { EGDSIcon as EGDSIcon10, EGDSIconSize as EGDSIconSize6 } from "@egds/react-core/icons";
import { EGDSLayoutGrid as EGDSLayoutGrid7, EGDSLayoutGridItem as EGDSLayoutGridItem7 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing21 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText16 } from "@egds/react-core/text";
var __SpaceDetailsSpacesFragment = gql36(_templateObject36());
var SpaceDetailsSpaces = function (param) {
  var data = param.data,
    className = param.className;
  var spaces = data.spaces;
  if (!(spaces === null || spaces === void 0 ? void 0 : spaces.length)) {
    return null;
  }
  var numLargeColumns = spaces.length > 6 ? 3 : 2;
  return /* @__PURE__ */React43.createElement(EGDSLayoutGrid7, {
    className: className,
    space: "two",
    columns: {
      large: numLargeColumns,
      small: 2
    }
  }, spaces.map(function (space, index) {
    var _space_icons, _space_description;
    return /* @__PURE__ */React43.createElement(EGDSLayoutGridItem7, {
      key: "spacedetails-spaces-".concat(index)
    }, /* @__PURE__ */React43.createElement(EGDSSpacing21, {
      margin: {
        blockend: "four"
      }
    }, /* @__PURE__ */React43.createElement("div", null, /* @__PURE__ */React43.createElement(EGDSSpacing21, {
      padding: {
        blockend: "half"
      }
    }, /* @__PURE__ */React43.createElement(EGDSText16, {
      size: 500,
      weight: "bold"
    }, space.name)), (_space_icons = space.icons) === null || _space_icons === void 0 ? void 0 : _space_icons.map(function (icon, iconIndex) {
      var _space_icons;
      return /* @__PURE__ */React43.createElement(EGDSSpacing21, {
        margin: {
          inlineend: "two"
        },
        key: "".concat(space.name, "-").concat(iconIndex)
      }, /* @__PURE__ */React43.createElement(EGDSIcon10, {
        name: icon.id,
        size: ((_space_icons = space.icons) === null || _space_icons === void 0 ? void 0 : _space_icons.length) && space.icons.length > 1 ? EGDSIconSize6.SMALL : EGDSIconSize6.MEDIUM,
        description: icon.description,
        theme: "secondary"
      }));
    }), /* @__PURE__ */React43.createElement("ul", {
      className: "no-bullet"
    }, (_space_description = space.description) === null || _space_description === void 0 ? void 0 : _space_description.map(function (desc, descIndex) {
      return /* @__PURE__ */React43.createElement(EGDSText16, {
        spacing: "two",
        theme: "standard",
        size: 300,
        key: "description-".concat(descIndex)
      }, desc);
    })))));
  }));
};
SpaceDetailsSpaces.displayName = "SpaceDetailsSpaces";
SpaceDetailsSpaces.fragment = __SpaceDetailsSpacesFragment;
// src/components/__private/__fragments/virtual-tour-prompt.tsx
import React44 from "react";
import { gql as gql37 } from "@apollo/client";
import { EGDSOverlayButton } from "@egds/react-core/button";
import { EGDSCard as EGDSCard5, EGDSCardLink } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon11 } from "@egds/react-core/icons";
import { EGDSFigure, EGDSFigureAspectRatioType, EGDSImage } from "@egds/react-core/images";
import { EGDSLayoutGrid as EGDSLayoutGrid8, EGDSLayoutGridItem as EGDSLayoutGridItem8 } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSSpacing as EGDSSpacing22 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading7, EGDSText as EGDSText17 } from "@egds/react-core/text";
var __VirtualTourPromptFragment = gql37(_templateObject37());
var VirtualTourPrompt = function (param) {
  var data = param.data,
    className = param.className,
    _param_headingSize = param.headingSize,
    headingSize = _param_headingSize === void 0 ? 4 : _param_headingSize,
    _param_captionSize = param.captionSize,
    captionSize = _param_captionSize === void 0 ? 200 : _param_captionSize;
  var _button_icon, _button_icon1, _button_icon2, _button_action;
  if (!data) {
    return null;
  }
  var heading = data.heading,
    button = data.button,
    heroImage = data.heroImage,
    caption = data.caption;
  return /* @__PURE__ */React44.createElement("div", {
    className: className
  }, /* @__PURE__ */React44.createElement(EGDSHeading7, {
    size: headingSize,
    tag: "h3"
  }, heading === null || heading === void 0 ? void 0 : heading.text), button && /* @__PURE__ */React44.createElement(EGDSSpacing22, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React44.createElement(EGDSCard5, null, /* @__PURE__ */React44.createElement(EGDSFigure, {
    ratio: EGDSFigureAspectRatioType.R16_9
  }, /* @__PURE__ */React44.createElement(EGDSImage, {
    placeholderImage: true,
    alt: heroImage === null || heroImage === void 0 ? void 0 : heroImage.description,
    src: heroImage === null || heroImage === void 0 ? void 0 : heroImage.url
  }), /* @__PURE__ */React44.createElement(EGDSLayoutPosition, {
    type: "absolute",
    position: {
      top: "zero",
      right: "zero",
      bottom: "zero",
      left: "zero"
    },
    cloneElement: true
  }, /* @__PURE__ */React44.createElement(EGDSLayoutGrid8, {
    alignItems: "center",
    justifyItems: "center"
  }, /* @__PURE__ */React44.createElement(EGDSLayoutGridItem8, null, /* @__PURE__ */React44.createElement(EGDSOverlayButton, null, /* @__PURE__ */React44.createElement(EGDSIcon11, {
    description: (_button_icon = button.icon) === null || _button_icon === void 0 ? void 0 : _button_icon.description,
    id: (_button_icon1 = button.icon) === null || _button_icon1 === void 0 ? void 0 : _button_icon1.id,
    name: ((_button_icon2 = button.icon) === null || _button_icon2 === void 0 ? void 0 : _button_icon2.id) || ""
  }), button.primary))))), /* @__PURE__ */React44.createElement(EGDSCardLink, null, /* @__PURE__ */React44.createElement("a", {
    href: (_button_action = button.action) === null || _button_action === void 0 ? void 0 : _button_action.resource.value,
    target: "_blank",
    rel: "noreferrer"
  }, button.accessibility)))), caption && /* @__PURE__ */React44.createElement(EGDSSpacing22, {
    padding: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React44.createElement(EGDSText17, {
    size: captionSize,
    weight: "regular"
  }, caption.text)));
};
VirtualTourPrompt.displayName = "VirtualTourPrompt";
VirtualTourPrompt.fragment = __VirtualTourPromptFragment;
// src/components/__private/__fragments/space-details.tsx
var __SpaceDetailsFragment = gql38(_templateObject38(), SpaceDetailsHeader.fragment, SpaceDetailsSpaces.fragment, SpaceDetailsFloorPlan.fragment, VirtualTourPrompt.fragment);
var SpaceDetails = function (param) {
  var spaceDetails = param.data,
    className = param.className;
  if (!spaceDetails) {
    return null;
  }
  return /* @__PURE__ */React45.createElement(EGDSSpacing23, {
    className: className
  }, /* @__PURE__ */React45.createElement(EGDSCard6, null, /* @__PURE__ */React45.createElement(SpaceDetailsHeader, {
    data: spaceDetails
  }), /* @__PURE__ */React45.createElement(EGDSSpacing23, {
    padding: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React45.createElement(SpaceDetailsFloorPlan, {
    data: spaceDetails,
    rfrr: "HOT.HIS.SpaceDetails.SingleiUnit.Floorplan"
  })), /* @__PURE__ */React45.createElement(EGDSSpacing23, {
    padding: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React45.createElement(SpaceDetailsSpaces, {
    data: spaceDetails
  })), spaceDetails.virtualTourPrompt ? /* @__PURE__ */React45.createElement(EGDSSpacing23, {
    padding: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React45.createElement(VirtualTourPrompt, {
    data: spaceDetails.virtualTourPrompt
  })) : null));
};
SpaceDetails.displayName = "SpaceDetails";
SpaceDetails.fragment = __SpaceDetailsFragment;
// src/components/property-offers/__private/__fragments/availability-cta/availability-cta.tsx
import React47 from "react";
import { gql as gql40 } from "@apollo/client";
// src/components/property-offers/__private/__fragments/availability-cta/availability-call-to-action.tsx
import React46 from "react";
import { gql as gql39 } from "@apollo/client";
import { EGDSPrimaryButton } from "@egds/react-core/button";
import { EGDSText as EGDSText18 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
import { useRefContext } from "@shared-ui/ref-context";
import { useSignalPublisher } from "@shared-ui/signal-events-context";
// src/utils/constants.ts
var INTERACTION = "Interaction";
var RECOMMENDATION_MODULE = "recommendation_module";
var MODULE_SELECTED = "selected";
var DEFAULT_INSURANCE_PRIMING_POSITION = 2;
var PropertyOffersSignalNames = /* @__PURE__ */function (PropertyOffersSignalNames2) {
  PropertyOffersSignalNames2["AVAILABILITY_CALL_TO_ACTION_CTA_BUTTON_CLICK"] = "PROPERTY_OFFERS_AVAILABILITY_CALL_TO_ACTION_CTA_BUTTON_CLICK";
  PropertyOffersSignalNames2["RATE_CHECK_CTA_BUTTON_CLICK"] = "PROPERTY_OFFERS_RATE_CHECK_CTA_BUTTON_CLICK";
  return PropertyOffersSignalNames2;
}(PropertyOffersSignalNames || {});
// src/utils/offers-layout.ts
var OffersLayouts = {
  CAROUSEL: "carousel",
  GRID: "grid"
};
// src/components/property-offers/__private/__fragments/availability-cta/availability-call-to-action.tsx
var fragment17 = gql39(_templateObject39());
var START_DATE_REF_NAME = "startDate";
var AvailabilityCallToAction = function (param) {
  var closeDialog = param.closeDialog,
    listingIndex = param.listingIndex,
    data = param.data,
    targetItem = param.targetItem;
  var availabilityCallToAction = data;
  var clickTrack = useClickTracker12();
  var getTargets = useRefContext().getTargets;
  var publishSignal = useSignalPublisher().publishSignal;
  if (!availabilityCallToAction) {
    return null;
  }
  var handleCtaButtonClick = function () {
    var _clickRef_current;
    publishSignal({
      payload: {},
      type: targetItem !== void 0 ? targetItem : "PROPERTY_OFFERS_AVAILABILITY_CALL_TO_ACTION_CTA_BUTTON_CLICK" /* AVAILABILITY_CALL_TO_ACTION_CTA_BUTTON_CLICK */
    });
    if (closeDialog && typeof closeDialog === "function") {
      closeDialog();
    }
    var _getTargets = getTargets([START_DATE_REF_NAME]),
      clickRef = _getTargets.startDate;
    clickRef === null || clickRef === void 0 ? void 0 : (_clickRef_current = clickRef.current) === null || _clickRef_current === void 0 ? void 0 : _clickRef_current.click();
    clickTrack("ROOM[".concat(listingIndex, "].CHOOSEDATE.CTA"), "Go to select dates");
  };
  if (availabilityCallToAction.__typename === "LodgingButton" && availabilityCallToAction.text) {
    return /* @__PURE__ */React46.createElement(EGDSPrimaryButton, {
      onClick: handleCtaButtonClick
    }, availabilityCallToAction.text);
  }
  if (availabilityCallToAction.__typename === "LodgingPlainMessage" && availabilityCallToAction.value) {
    return /* @__PURE__ */React46.createElement(EGDSText18, {
      weight: "bold",
      theme: "negative"
    }, availabilityCallToAction.value);
  }
  return null;
};
AvailabilityCallToAction.displayName = "AvailabilityCallToAction";
AvailabilityCallToAction.fragment = fragment17;
// src/components/property-offers/__private/__fragments/availability-cta/availability-cta.tsx
var fragment18 = gql40(_templateObject40());
var AvailabilityCta = function (param) {
  var closeDialog = param.closeDialog,
    listingIndex = param.listingIndex,
    targetItem = param.targetItem,
    data = param.data;
  var availabilityCallToAction = data.availabilityCallToAction;
  if (!availabilityCallToAction) {
    return null;
  }
  return /* @__PURE__ */React47.createElement(AvailabilityCallToAction, {
    closeDialog: closeDialog,
    listingIndex: listingIndex,
    data: availabilityCallToAction,
    targetItem: targetItem
  });
};
AvailabilityCta.displayName = "AvailabilityCta";
AvailabilityCta.fragment = fragment18;
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/unit-property-offers-details-dialog.tsx
import React58 from "react";
import { gql as gql48 } from "@apollo/client";
import { EGDSSheet as EGDSSheet4, EGDSSheetContent as EGDSSheetContent3 } from "@egds/react-core/sheet";
import { EGDSToolbar as EGDSToolbar3 } from "@egds/react-core/toolbar";
import { Sheet } from "@egds/react-lodging";
import { useExperiment as useExperiment3 } from "@shared-ui/experiment-context";
import { useLocalization } from "@shared-ui/localization-context";
import { DialogContext } from "@shared-ui/lodging-fragments";
import { usePackageOperations } from "@shared-ui/multi-item-operations-providers";
import { useViewportMap, ViewMedium as ViewMedium4, Viewport as Viewport6, ViewSizes, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
// src/components/property-offers/__private/__fragments/listings/property-unit-categorization/micro-room-card/micro-room-card-provider.tsx
import React48 from "react";
var initialValue = {
  listingIndex: void 0,
  isMicroRoomCardRatesDialog: false,
  isMicroRoomCardCarousel: false,
  hasSelections: false,
  isSeeOptionsDialogLayout: false
};
var MicroRoomCardContext = React48.createContext(initialValue);
var useMicroRoomCard = function () {
  return React48.useContext(MicroRoomCardContext);
};
var MicroRoomCardProvider = MicroRoomCardContext.Provider;
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/details-dialog-content.tsx
import React57 from "react";
import { EGDSSpacing as EGDSSpacing31 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading12, EGDSText as EGDSText21 } from "@egds/react-core/text";
// src/components/property-offers/__private/__fragments/listings/property-unit-categorization/expando-items-card.tsx
import React49 from "react";
import { gql as gql41 } from "@apollo/client";
import { EGDSBadgeLoyalty } from "@egds/react-core/badge";
import { EGDSCard as EGDSCard7, EGDSCardContentSection as EGDSCardContentSection4 } from "@egds/react-core/cards";
import { EGDSExpandoPeek } from "@egds/react-core/expando";
import { EGDSIcon as EGDSIcon12, EGDSIconSize as EGDSIconSize7 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex8 } from "@egds/react-core/layout-flex";
import { EGDSList as EGDSList3, EGDSListItem as EGDSListItem5 } from "@egds/react-core/list";
import { EGDSSpacing as EGDSSpacing24 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading8, EGDSText as EGDSText19 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker3 } from "@shared-ui/clickstream-analytics-context";
import { EGDSBadgeLoyaltyThemeMapper } from "@shared-ui/lodging-fragments";
var __ExpandoItemsCardFragment = gql41(_templateObject41());
var ExpandoItemsCard = function (param) {
  var expandoItemsCard = param.data,
    isWithinDetailsDialog = param.isWithinDetailsDialog;
  var _header_egdsStandardBadge, _header_egdsStandardBadge1, _header_egdsStandardBadge2;
  var _React49_useState = _sliced_to_array(React49.useState(false), 2),
    isVisible = _React49_useState[0],
    setIsVisible = _React49_useState[1];
  if (!expandoItemsCard) {
    return null;
  }
  var header = expandoItemsCard.header,
    items = expandoItemsCard.items,
    expando = expandoItemsCard.expando;
  var theme = header === null || header === void 0 ? void 0 : (_header_egdsStandardBadge = header.egdsStandardBadge) === null || _header_egdsStandardBadge === void 0 ? void 0 : _header_egdsStandardBadge.theme;
  var perksList = function () {
    return items ? /* @__PURE__ */React49.createElement(EGDSList3, {
      bullet: "icon-standard"
    }, items.map(function (item, index) {
      var _item_impressionAnalytics, _item_impressionAnalytics1, _item_icon;
      return item.text && /* @__PURE__ */React49.createElement(IntersectionTracker3, {
        key: index,
        trackOnce: true,
        referrerId: ((_item_impressionAnalytics = item.impressionAnalytics) === null || _item_impressionAnalytics === void 0 ? void 0 : _item_impressionAnalytics.referrerId) || "",
        linkName: ((_item_impressionAnalytics1 = item.impressionAnalytics) === null || _item_impressionAnalytics1 === void 0 ? void 0 : _item_impressionAnalytics1.linkName) || ""
      }, /* @__PURE__ */React49.createElement(EGDSListItem5, {
        key: "bundled-perk-".concat(index)
      }, /* @__PURE__ */React49.createElement(EGDSIcon12, {
        name: ((_item_icon = item.icon) === null || _item_icon === void 0 ? void 0 : _item_icon.id) || "check",
        size: EGDSIconSize7.SMALL
      }), /* @__PURE__ */React49.createElement(EGDSText19, null, item.text)));
    })) : null;
  };
  return /* @__PURE__ */React49.createElement(EGDSSpacing24, {
    margin: {
      blockstart: "two",
      blockend: "four",
      inlinestart: !isWithinDetailsDialog ? "three" : void 0,
      inlineend: !isWithinDetailsDialog ? "three" : void 0
    }
  }, /* @__PURE__ */React49.createElement(EGDSCard7, {
    padded: true,
    "data-testid": "recommendation-card",
    backgroundTheme: "secondary"
  }, /* @__PURE__ */React49.createElement(EGDSLayoutFlex8, {
    alignItems: "start",
    space: "two",
    direction: "row"
  }, /* @__PURE__ */React49.createElement(EGDSHeading8, {
    tag: "h4",
    size: 7
  }, theme && /* @__PURE__ */React49.createElement(EGDSBadgeLoyalty, {
    text: (header === null || header === void 0 ? void 0 : (_header_egdsStandardBadge1 = header.egdsStandardBadge) === null || _header_egdsStandardBadge1 === void 0 ? void 0 : _header_egdsStandardBadge1.text) || "",
    theme: EGDSBadgeLoyaltyThemeMapper[theme],
    a11yText: (header === null || header === void 0 ? void 0 : (_header_egdsStandardBadge2 = header.egdsStandardBadge) === null || _header_egdsStandardBadge2 === void 0 ? void 0 : _header_egdsStandardBadge2.accessibility) || ""
  }), /* @__PURE__ */React49.createElement(EGDSSpacing24, {
    padding: {
      inlinestart: "two"
    }
  }, (header === null || header === void 0 ? void 0 : header.text) && /* @__PURE__ */React49.createElement(EGDSText19, {
    theme: "standard",
    inline: true,
    spacing: "six",
    "aria-hidden": "true"
  }, header.text)))), /* @__PURE__ */React49.createElement(EGDSCardContentSection4, {
    padded: false
  }, /* @__PURE__ */React49.createElement(EGDSList3, {
    bullet: "icon-alternate",
    type: "ordered",
    spacing: false
  }, !isWithinDetailsDialog ? /* @__PURE__ */React49.createElement(EGDSExpandoPeek, {
    isVisible: isVisible,
    expandLabel: expando === null || expando === void 0 ? void 0 : expando.expandedLabel,
    collapseLabel: expando === null || expando === void 0 ? void 0 : expando.collapsedLabel,
    handleClick: function () {
      return setIsVisible(function (prevIsVisible) {
        return !prevIsVisible;
      });
    },
    items: 2
  }, perksList()) : perksList()))));
};
ExpandoItemsCard.displayName = "ExpandoItemsCard";
ExpandoItemsCard.fragment = __ExpandoItemsCardFragment;
// src/components/property-offers/__private/__fragments/room-amenities/room-amenities-description.tsx
import React55 from "react";
import { gql as gql47 } from "@apollo/client";
import { EGDSLayoutGrid as EGDSLayoutGrid9 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing29 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading11 } from "@egds/react-core/text";
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/sections/dialog-info-section/sections/dialog-features.tsx
import React51 from "react";
import { gql as gql43 } from "@apollo/client";
import { withEGDSLayoutGrid as withEGDSLayoutGrid2 } from "@egds/react-core/layout-grid";
import { EGDSList as EGDSList4 } from "@egds/react-core/list";
import { EGDSSpacing as EGDSSpacing25 } from "@egds/react-core/spacing";
// src/components/property-offers/__private/__fragments/property-dialog-features.tsx
import React50 from "react";
import { gql as gql42 } from "@apollo/client";
import { EGDSIcon as EGDSIcon13, EGDSIconSize as EGDSIconSize8 } from "@egds/react-core/icons";
import { EGDSListItem as EGDSListItem6 } from "@egds/react-core/list";
var fragment19 = gql42(_templateObject42());
var PropertyDialogFeatures = function (param) {
  var data = param.data;
  var text = data.text,
    icon = data.icon;
  return /* @__PURE__ */React50.createElement(EGDSListItem6, null, icon && icon.__typename === "Icon" && /* @__PURE__ */React50.createElement(EGDSIcon13, {
    name: icon.id,
    description: icon.description,
    id: icon.id,
    size: EGDSIconSize8.SMALL
  }), text);
};
PropertyDialogFeatures.fragment = fragment19;
PropertyDialogFeatures.displayName = "PropertyDialogFeatures";
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/sections/dialog-info-section/sections/dialog-features.tsx
var fragment20 = gql43(_templateObject43());
var DialogFeatures = function (param) {
  var data = param.data,
    columns = param.columns;
  if (!data) {
    return null;
  }
  var featureList = function (props) {
    return /* @__PURE__ */React51.createElement(EGDSList4, _object_spread_props(_object_spread({}, props), {
      bullet: "icon-alternate"
    }), data.listItems.map(function (featureData, index) {
      return /* @__PURE__ */React51.createElement(PropertyDialogFeatures, {
        data: featureData,
        key: "feature-".concat(index)
      });
    }));
  };
  var FeatureListWithGrid = withEGDSLayoutGrid2(featureList);
  return /* @__PURE__ */React51.createElement(EGDSSpacing25, {
    margin: {
      blockend: "six"
    }
  }, /* @__PURE__ */React51.createElement(FeatureListWithGrid, {
    columns: columns
  }));
};
DialogFeatures.fragment = fragment20;
DialogFeatures.displayName = "DialogFeatures";
// src/components/property-offers/__private/__fragments/unit-highlights/unit-highlights.tsx
import React52 from "react";
import { gql as gql44 } from "@apollo/client";
import { EGDSCard as EGDSCard8, EGDSCardBackgroundThemes } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon14 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex9, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing26 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading9, EGDSText as EGDSText20 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker4 } from "@shared-ui/clickstream-analytics-context";
var __UnitHighlightsFragment = gql44(_templateObject44());
var UnitHighlights = function (param) {
  var data = param.data;
  var _iconAnalytics_uisPrimeMessages;
  var header = data.header,
    items = data.items,
    iconAnalytics = data.iconAnalytics;
  var _iconAnalytics_referrerId, _iconAnalytics_linkName;
  var trackingProps = {
    referrerId: (_iconAnalytics_referrerId = iconAnalytics === null || iconAnalytics === void 0 ? void 0 : iconAnalytics.referrerId) !== null && _iconAnalytics_referrerId !== void 0 ? _iconAnalytics_referrerId : "",
    linkName: (_iconAnalytics_linkName = iconAnalytics === null || iconAnalytics === void 0 ? void 0 : iconAnalytics.linkName) !== null && _iconAnalytics_linkName !== void 0 ? _iconAnalytics_linkName : "",
    additionalUisPrimeMicroMessages: iconAnalytics === null || iconAnalytics === void 0 ? void 0 : (_iconAnalytics_uisPrimeMessages = iconAnalytics.uisPrimeMessages) === null || _iconAnalytics_uisPrimeMessages === void 0 ? void 0 : _iconAnalytics_uisPrimeMessages.map(function (param) {
      var messageContent = param.messageContent,
        schemaName = param.schemaName;
      return {
        messageContent: JSON.parse(messageContent),
        schemaName: schemaName
      };
    })
  };
  var componentBase = /* @__PURE__ */React52.createElement(EGDSSpacing26, {
    margin: {
      blockend: "six"
    }
  }, /* @__PURE__ */React52.createElement(EGDSCard8, {
    padded: true,
    backgroundTheme: EGDSCardBackgroundThemes.SECONDARY
  }, header && /* @__PURE__ */React52.createElement(EGDSSpacing26, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React52.createElement(EGDSLayoutFlex9, {
    space: "two",
    alignItems: "center"
  }, header.icon && /* @__PURE__ */React52.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React52.createElement(EGDSIcon14, {
    name: header.icon.id,
    id: header.icon.id,
    description: header.icon.description
  })), header.text && /* @__PURE__ */React52.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React52.createElement(EGDSHeading9, {
    size: 6
  }, header.text)))), items.length > 0 && /* @__PURE__ */React52.createElement(EGDSLayoutFlex9, {
    space: "two",
    wrap: "wrap"
  }, items.map(function (item, idx) {
    return /* @__PURE__ */React52.createElement(EGDSLayoutFlexItem6, {
      key: idx
    }, /* @__PURE__ */React52.createElement(EGDSSpacing26, {
      margin: {
        inlineend: "two"
      }
    }, /* @__PURE__ */React52.createElement(EGDSText20, null, item.text)));
  }))));
  return (iconAnalytics === null || iconAnalytics === void 0 ? void 0 : iconAnalytics.referrerId) && (iconAnalytics === null || iconAnalytics === void 0 ? void 0 : iconAnalytics.linkName) ? /* @__PURE__ */React52.createElement(IntersectionTracker4, _object_spread({}, trackingProps), componentBase) : componentBase;
};
UnitHighlights.displayName = "UnitHighlights";
UnitHighlights.fragment = __UnitHighlightsFragment;
// src/components/property-offers/__private/__fragments/room-amenities/content/room-amenity-content.tsx
import React54 from "react";
import { gql as gql46 } from "@apollo/client";
import { EGDSIcon as EGDSIcon15 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex10, EGDSLayoutFlexItem as EGDSLayoutFlexItem7 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGridItem as EGDSLayoutGridItem9 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing28 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading10 } from "@egds/react-core/text";
// src/components/property-offers/__private/__fragments/room-amenities/content/room-amenity-content-text.tsx
import React53 from "react";
import { gql as gql45 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing27 } from "@egds/react-core/spacing";
import { EGDSUnformattedHtml as EGDSUnformattedHtml3 } from "@egds/react-core/unformatted-html";
var fragment21 = gql45(_templateObject45());
var RoomAmenityContentText = function (param) {
  var data = param.data;
  if (!data.content) {
    return null;
  }
  var content = data.content;
  return /* @__PURE__ */React53.createElement(EGDSSpacing27, {
    padding: {
      inlinestart: "three"
    }
  }, /* @__PURE__ */React53.createElement("div", null, /* @__PURE__ */React53.createElement(EGDSUnformattedHtml3, {
    htmlToParse: content.text
  })));
};
RoomAmenityContentText.displayName = "RoomAmenityContentText";
RoomAmenityContentText.fragment = fragment21;
// src/components/property-offers/__private/__fragments/room-amenities/content/room-amenity-content.tsx
var fragment22 = gql46(_templateObject46(), RoomAmenityContentText.fragment);
var RoomAmenityContent = function (param) {
  var data = param.data;
  var _header_icon;
  var header = data.header,
    items = data.items;
  if (!header) {
    return null;
  }
  return /* @__PURE__ */React54.createElement(EGDSLayoutGridItem9, null, /* @__PURE__ */React54.createElement("div", null, /* @__PURE__ */React54.createElement(EGDSLayoutFlex10, {
    space: "three"
  }, /* @__PURE__ */React54.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React54.createElement(EGDSIcon15, {
    name: ((_header_icon = header.icon) === null || _header_icon === void 0 ? void 0 : _header_icon.id) || ""
  })), /* @__PURE__ */React54.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React54.createElement(EGDSHeading10, {
    tag: "h4",
    size: 6
  }, header.text))), /* @__PURE__ */React54.createElement(EGDSSpacing28, {
    padding: {
      inlinestart: "six"
    }
  }, /* @__PURE__ */React54.createElement("div", null, items.map(function (amenity, index) {
    return /* @__PURE__ */React54.createElement(RoomAmenityContentText, {
      key: "amenities-content-".concat(index),
      data: amenity
    });
  })))));
};
RoomAmenityContent.displayName = "RoomAmenityContent";
RoomAmenityContent.fragment = fragment22;
// src/components/property-offers/__private/__fragments/room-amenities/room-amenities-description.tsx
var fragment23 = gql47(_templateObject47(), RoomAmenityContent.fragment);
var RoomAmenitiesDescription = function (param) {
  var data = param.data,
    baseDialogFeatures = param.baseDialogFeatures,
    dialogFeatures = param.dialogFeatures,
    roomHighlights = param.roomHighlights;
  var _bodySubSections__contents, _bodySubSections_;
  var header = data.header,
    bodySubSections = data.bodySubSections;
  if (!(bodySubSections === null || bodySubSections === void 0 ? void 0 : (_bodySubSections_ = bodySubSections[0]) === null || _bodySubSections_ === void 0 ? void 0 : (_bodySubSections__contents = _bodySubSections_.contents) === null || _bodySubSections__contents === void 0 ? void 0 : _bodySubSections__contents.length) && !dialogFeatures) {
    return null;
  }
  return /* @__PURE__ */React55.createElement(EGDSSpacing29, {
    margin: {
      blockend: "six"
    }
  }, /* @__PURE__ */React55.createElement("div", null, header && /* @__PURE__ */React55.createElement(EGDSSpacing29, {
    margin: {
      blockend: "six"
    }
  }, /* @__PURE__ */React55.createElement(EGDSHeading11, {
    tag: "h3",
    size: 5
  }, header.text)), roomHighlights && /* @__PURE__ */React55.createElement(UnitHighlights, {
    data: roomHighlights
  }), baseDialogFeatures && /* @__PURE__ */React55.createElement(DialogFeatures, {
    "data-stid": "primary-features",
    data: baseDialogFeatures,
    columns: 2
  }), dialogFeatures && /* @__PURE__ */React55.createElement(DialogFeatures, {
    "data-stid": "secondary-features",
    data: dialogFeatures
  }), bodySubSections.length > 0 && /* @__PURE__ */React55.createElement(EGDSLayoutGrid9, {
    columns: {
      small: 1,
      medium: 2
    },
    space: "six"
  }, bodySubSections.map(function (bodySection) {
    return bodySection.contents.map(function (content, index) {
      return /* @__PURE__ */React55.createElement(RoomAmenityContent, {
        key: "dialog-room-amenity-".concat(index),
        data: content
      });
    });
  }))));
};
RoomAmenitiesDescription.displayName = "RoomAmenitiesDescription";
RoomAmenitiesDescription.fragment = fragment23;
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/sections/dialog-gallery-section.tsx
import React56 from "react";
import { EGDSPagingButton } from "@egds/react-core/button";
import { EGDSCard as EGDSCard9 } from "@egds/react-core/cards";
import { UitkGalleryCarousel as EGDSGalleryCarousel } from "@egds/react-core/gallery-carousel";
import { EGDSFigure as EGDSFigure2, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2, EGDSImage as EGDSImage2 } from "@egds/react-core/images";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";
import { EGDSSpacing as EGDSSpacing30 } from "@egds/react-core/spacing";
import { IntersectionTracker as IntersectionTracker5, useClickTracker as useClickTracker13, useEgClickstream as useEgClickstream5 } from "@shared-ui/clickstream-analytics-context";
// src/utils/additional-uis-prime-micro-messages-utils.ts
var getCarouselNextIndex = function (currentIndex, mediaLength, carouselActionId) {
  if (carouselActionId.includes("clickRight")) {
    return currentIndex < mediaLength - 1 ? currentIndex + 1 : 0;
  }
  if (carouselActionId.includes("clickLeft")) {
    return currentIndex > 0 ? currentIndex - 1 : mediaLength - 1;
  }
  return currentIndex;
};
function additionalUisPrimeMicroMessages(galleryPosition, algoMediaGuid, galleryMaxPosition, imageId, productId, galleryName, repeatedGalleryIndex) {
  var timestamp = Date.now().toString();
  var messages = [{
    schemaName: "allHotelProducts",
    messageContent: {
      hotelProducts: [_object_spread({
        imageGalleryAlgorithm: {
          name: "heroaesthetics.v20190411-hsc.v20190223"
        },
        algoMediaGuid: algoMediaGuid
      }, productId ? {
        productId: Number(productId)
      } : {}, imageId ? {
        imageId: Number(imageId)
      } : {})]
    }
  }, {
    schemaName: "imageTracking",
    messageContent: _object_spread({
      galleryName: galleryName,
      galleryType: "GALLERY_TYPE_REPEATED",
      galleryMaxPosition: galleryMaxPosition,
      galleryPosition: galleryPosition,
      imageGalleryMetaTagList: [{
        imageGalleryMetaTagValue: timestamp,
        imageGalleryMetaTagType: "DEVICE_TIME_STAMP"
      }]
    }, repeatedGalleryIndex ? {
      repeatedGalleryIndex: repeatedGalleryIndex
    } : {})
  }];
  return messages;
}
// src/utils/room-schema-message-content.ts
var getRoomSchemaMessageContent = function (ratePlan) {
  var _ratePlan_clientSideAnalytics;
  var roomSchema2 = ratePlan === null || ratePlan === void 0 ? void 0 : (_ratePlan_clientSideAnalytics = ratePlan.clientSideAnalytics) === null || _ratePlan_clientSideAnalytics === void 0 ? void 0 : _ratePlan_clientSideAnalytics.uisPrimeMessages.find(function (uisPrimeMessages) {
    return uisPrimeMessages.schemaName === "room";
  });
  return roomSchema2 ? roomSchema2.messageContent : "";
};
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/sections/dialog-gallery-section.tsx
var DialogGallerySection = function (param) {
  var unitGallery = param.unitGallery,
    propertyId = param.propertyId,
    closeDialog = param.closeDialog,
    _param_isLargerImageExperimentVariant = param.isLargerImageExperimentVariant,
    isLargerImageExperimentVariant = _param_isLargerImageExperimentVariant === void 0 ? false : _param_isLargerImageExperimentVariant;
  var _unitGallery_images, _unitGallery_images_currentMediaIndex, _unitGallery_images_currentMediaIndex1;
  var track = useClickTracker13();
  var trackEgClickstreamEvent = useEgClickstream5();
  var isSeeOptionsDialogLayout = useMicroRoomCard().isSeeOptionsDialogLayout;
  var _React56_useContext = React56.useContext(UnitRateContext),
    ratePlan = _React56_useContext.ratePlan,
    roomTypeId = _React56_useContext.roomTypeId;
  var _React56_useState = _sliced_to_array(React56.useState(0), 2),
    currentMediaIndex = _React56_useState[0],
    setCurrentMediaIndex = _React56_useState[1];
  var galleryLength = (unitGallery === null || unitGallery === void 0 ? void 0 : unitGallery.images.length) || 0;
  var currentImage = unitGallery === null || unitGallery === void 0 ? void 0 : unitGallery.images[currentMediaIndex];
  var isImageThumbnailClickAnalytics = currentImage === null || currentImage === void 0 ? void 0 : currentImage.image.thumbnailClickAnalytics;
  var roomSchemaMessageContent = getRoomSchemaMessageContent(ratePlan);
  React56.useEffect(function () {
    setCurrentMediaIndex(0);
  }, [unitGallery]);
  var handleCurrentMediaIndexChange = function (index) {
    setCurrentMediaIndex(index);
    if (roomTypeId && (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.id)) {
      trackEgClickstreamEvent(buildRoomsAndRatesClientPayload("room_rate_plan_image.selected" /* ROOM_RATE_PLAN_IMAGE_SELECTED */, roomTypeId, ratePlan.id));
    }
  };
  var trackControlAnalytics = function () {
    if (isImageThumbnailClickAnalytics) {
      var _currentImage_image_thumbnailClickAnalytics, _currentImage_image_thumbnailClickAnalytics1;
      return {
        id: "".concat(currentImage === null || currentImage === void 0 ? void 0 : (_currentImage_image_thumbnailClickAnalytics = currentImage.image.thumbnailClickAnalytics) === null || _currentImage_image_thumbnailClickAnalytics === void 0 ? void 0 : _currentImage_image_thumbnailClickAnalytics.referrerId),
        description: "".concat(currentImage === null || currentImage === void 0 ? void 0 : (_currentImage_image_thumbnailClickAnalytics1 = currentImage.image.thumbnailClickAnalytics) === null || _currentImage_image_thumbnailClickAnalytics1 === void 0 ? void 0 : _currentImage_image_thumbnailClickAnalytics1.linkName),
        callback: function (id, desc) {
          var _unitGallery_images_currentMediaIndex, _unitGallery_images_currentMediaIndex1;
          var currentImageIndex = getCarouselNextIndex(currentMediaIndex, galleryLength, id);
          var imageTrackingSchema = additionalUisPrimeMicroMessages(currentImageIndex, (unitGallery === null || unitGallery === void 0 ? void 0 : (_unitGallery_images_currentMediaIndex = unitGallery.images[currentMediaIndex]) === null || _unitGallery_images_currentMediaIndex === void 0 ? void 0 : _unitGallery_images_currentMediaIndex.trackingId) || "", galleryLength, (unitGallery === null || unitGallery === void 0 ? void 0 : (_unitGallery_images_currentMediaIndex1 = unitGallery.images[currentMediaIndex]) === null || _unitGallery_images_currentMediaIndex1 === void 0 ? void 0 : _unitGallery_images_currentMediaIndex1.imageId) || "", propertyId, "PDP_ROOM_INFO" /* PDP_ROOM_INFO */);
          if (roomSchemaMessageContent) {
            imageTrackingSchema.push({
              schemaName: "room",
              messageContent: JSON.parse(roomSchemaMessageContent)
            });
          }
          track(id, desc, void 0, imageTrackingSchema);
        }
      };
    }
  };
  var controlAnalytics = React56.useMemo(function () {
    return trackControlAnalytics();
  }, [track]);
  var imageRatio = isLargerImageExperimentVariant && !isSeeOptionsDialogLayout ? EGDSFigureAspectRatioType2.R1_1 : EGDSFigureAspectRatioType2.R16_9;
  var overlayedCloseButton = isLargerImageExperimentVariant ? /* @__PURE__ */React56.createElement(EGDSLayoutPosition2, {
    type: "absolute",
    position: {
      top: "three",
      left: "two",
      zindex: "layer3"
    }
  }, /* @__PURE__ */React56.createElement(EGDSPagingButton, {
    icon: "close",
    "aria-label": "close",
    onClick: closeDialog
  })) : void 0;
  if (!(unitGallery === null || unitGallery === void 0 ? void 0 : (_unitGallery_images = unitGallery.images) === null || _unitGallery_images === void 0 ? void 0 : _unitGallery_images.length)) {
    return /* @__PURE__ */React56.createElement(EGDSSpacing30, {
      margin: {
        blockend: "three"
      }
    }, /* @__PURE__ */React56.createElement(EGDSFigure2, null, /* @__PURE__ */React56.createElement(EGDSImage2, {
      placeholderImage: true
    })));
  }
  var mappedImages = unitGallery.images.map(function (param) {
    var image = param.image;
    return {
      src: image.url,
      alt: image.description
    };
  });
  var galleryCarousel = /* @__PURE__ */React56.createElement(EGDSLayoutPosition2, {
    type: "relative"
  }, overlayedCloseButton, /* @__PURE__ */React56.createElement(EGDSGalleryCarousel, {
    carouselId: "property-offers-carousel",
    allyHeadingText: (unitGallery === null || unitGallery === void 0 ? void 0 : unitGallery.accessibilityLabel) || "",
    carouselName: "DialogPhotoGallery",
    images: mappedImages,
    ratio: imageRatio,
    showGalleryButton: false,
    analytics: controlAnalytics,
    onIndexChange: handleCurrentMediaIndexChange,
    currentIndex: currentMediaIndex
  }));
  return /* @__PURE__ */React56.createElement(EGDSCard9, {
    overflow: isLargerImageExperimentVariant
  }, /* @__PURE__ */React56.createElement(EGDSSpacing30, {
    margin: {
      blockend: isLargerImageExperimentVariant ? "four" : "six"
    }
  }, /* @__PURE__ */React56.createElement("div", null, (currentImage === null || currentImage === void 0 ? void 0 : currentImage.impressionAnalytics) ? /* @__PURE__ */React56.createElement(IntersectionTracker5, {
    tag: "span",
    referrerId: "".concat(currentImage.impressionAnalytics.referrerId, ".0"),
    linkName: currentImage.impressionAnalytics.linkName || "",
    trackOnce: true,
    additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages(currentMediaIndex, unitGallery === null || unitGallery === void 0 ? void 0 : (_unitGallery_images_currentMediaIndex = unitGallery.images[currentMediaIndex]) === null || _unitGallery_images_currentMediaIndex === void 0 ? void 0 : _unitGallery_images_currentMediaIndex.trackingId, galleryLength, unitGallery === null || unitGallery === void 0 ? void 0 : (_unitGallery_images_currentMediaIndex1 = unitGallery.images[currentMediaIndex]) === null || _unitGallery_images_currentMediaIndex1 === void 0 ? void 0 : _unitGallery_images_currentMediaIndex1.imageId, propertyId, "PDP_ROOM_INFO" /* PDP_ROOM_INFO */)
  }, galleryCarousel) : /* @__PURE__ */React56.createElement(React56.Fragment, null, galleryCarousel))));
};
DialogGallerySection.displayName = "DialogGallerySection";
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/details-dialog-content.tsx
var DetailsDialogContent = function (param) {
  var listing = param.listing,
    closeDialog = param.closeDialog,
    expandoItemsCard = param.expandoItemsCard,
    ratePlans = param.ratePlans,
    _param_isLargerImageExperimentVariant = param.isLargerImageExperimentVariant,
    isLargerImageExperimentVariant = _param_isLargerImageExperimentVariant === void 0 ? false : _param_isLargerImageExperimentVariant;
  var propertyId = usePropertyOffersInputs().propertyId;
  var _useMicroRoomCard = useMicroRoomCard(),
    isSeeOptionsDialogLayout = _useMicroRoomCard.isSeeOptionsDialogLayout,
    isSimplifiedAddOnsDrawer = _useMicroRoomCard.isSimplifiedAddOnsDrawer;
  var roomId = listing.id,
    roomAmenities = listing.roomAmenities,
    unitGallery = listing.unitGallery,
    spaceDetails = listing.spaceDetails,
    roomHighlights = listing.roomHighlights,
    lodgingReview = listing.lodgingReview;
  var detailsDialog = listing.detailsDialog;
  var _detailsDialog_content = detailsDialog.content,
    baseDialogFeatures = _detailsDialog_content.baseDialogFeatures,
    details = _detailsDialog_content.details,
    dialogFeatures = _detailsDialog_content.dialogFeatures;
  var header = details === null || details === void 0 ? void 0 : details.header;
  var roomAmenitiesDescription = roomAmenities && /* @__PURE__ */React57.createElement(RoomAmenitiesDescription, {
    data: roomAmenities,
    baseDialogFeatures: isSeeOptionsDialogLayout ? baseDialogFeatures : null,
    dialogFeatures: isSeeOptionsDialogLayout ? dialogFeatures : null,
    roomHighlights: isSeeOptionsDialogLayout ? roomHighlights : null
  });
  return isSimplifiedAddOnsDrawer && ratePlans ? /* @__PURE__ */React57.createElement(React57.Fragment, null, ratePlans) : /* @__PURE__ */React57.createElement(EGDSSpacing31, {
    padding: isLargerImageExperimentVariant ? {
      blockend: "six"
    } : {
      inline: "three",
      blockstart: "three",
      blockend: "six"
    }
  }, /* @__PURE__ */React57.createElement("div", null, /* @__PURE__ */React57.createElement(DialogGallerySection, {
    unitGallery: unitGallery,
    propertyId: propertyId,
    closeDialog: closeDialog,
    isLargerImageExperimentVariant: isLargerImageExperimentVariant
  }), /* @__PURE__ */React57.createElement(EGDSSpacing31, {
    padding: {
      inline: "three"
    }
  }, /* @__PURE__ */React57.createElement("div", null, header && /* @__PURE__ */React57.createElement(EGDSSpacing31, {
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React57.createElement("div", {
    "data-stid": "property-offers-details-dialog-header"
  }, /* @__PURE__ */React57.createElement(EGDSHeading12, {
    size: 5,
    tag: "h3"
  }, header.text), header.subText && /* @__PURE__ */React57.createElement(EGDSText21, {
    theme: "standard"
  }, header.subText))), isSeeOptionsDialogLayout && /* @__PURE__ */React57.createElement(EGDSSpacing31, {
    margin: {
      blockend: "six"
    }
  }, /* @__PURE__ */React57.createElement("div", null, ratePlans)), !isSeeOptionsDialogLayout && roomHighlights && /* @__PURE__ */React57.createElement(UnitHighlights, {
    data: roomHighlights
  }), !isSeeOptionsDialogLayout && baseDialogFeatures && /* @__PURE__ */React57.createElement(DialogFeatures, {
    "data-stid": "primary-features",
    data: baseDialogFeatures,
    columns: 2
  }), !isSeeOptionsDialogLayout && dialogFeatures && /* @__PURE__ */React57.createElement(DialogFeatures, {
    "data-stid": "secondary-features",
    data: dialogFeatures
  }), /* @__PURE__ */React57.createElement(LodgingReviewSection, {
    data: lodgingReview,
    roomId: roomId,
    withinDialog: true
  }), spaceDetails && /* @__PURE__ */React57.createElement(EGDSSpacing31, {
    padding: {
      blockend: "two"
    }
  }, /* @__PURE__ */React57.createElement(SpaceDetails, {
    data: spaceDetails
  })), expandoItemsCard && /* @__PURE__ */React57.createElement(ExpandoItemsCard, {
    isWithinDetailsDialog: true,
    data: expandoItemsCard
  }), isSeeOptionsDialogLayout ? roomAmenitiesDescription : /* @__PURE__ */React57.createElement(React57.Fragment, null, roomAmenitiesDescription, ratePlans)))));
};
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/unit-property-offers-details-dialog.tsx
var fragment24 = gql48(_templateObject48(), DialogFeatures.fragment);
var UnitPropertyOffersDetailsDialog = function (param) {
  var closeDialog = param.closeDialog,
    isDialogOpen = param.isDialogOpen,
    listing = param.listing,
    data = param.data,
    ratePlans = param.ratePlans,
    expandoItemsCard = param.expandoItemsCard;
  var _toolbar_icon;
  var toolbar = data.toolbar;
  var state = usePackageOperations().state;
  var triggerRef = React58.useRef(document.activeElement);
  React58.useEffect(function () {
    if (state.selectPackage.status === "IN_PROGRESS") {
      closeDialog();
    }
  }, [state.selectPackage.status, closeDialog]);
  React58.useEffect(function () {
    return function () {
      if (_instanceof(triggerRef.current, HTMLElement)) {
        triggerRef.current.focus();
      }
    };
  }, []);
  var isSimplifiedAddOnsDrawer = useMicroRoomCard().isSimplifiedAddOnsDrawer;
  var _useExperiment3 = useExperiment3("Larger_Image_Room_Compare"),
    largerImageExposure = _useExperiment3.exposure,
    logExperiment = _useExperiment3.logExperiment;
  var _obj;
  var isLargerImageEligible = useViewportMap((_obj = {}, _define_property(_obj, ViewSizes.SMALL, true), _define_property(_obj, ViewSizes.MEDIUM, false), _obj));
  if (isLargerImageEligible) {
    logExperiment(largerImageExposure);
  }
  var isLargerImageExperimentVariant = largerImageExposure.bucket > 0 && isLargerImageEligible;
  var shouldDisplayToolbar = !isLargerImageExperimentVariant || isSimplifiedAddOnsDrawer;
  var formatText = useLocalization().formatText;
  var dialogContent = /* @__PURE__ */React58.createElement(DetailsDialogContent, {
    ratePlans: ratePlans,
    expandoItemsCard: expandoItemsCard,
    closeDialog: closeDialog,
    listing: listing,
    isLargerImageExperimentVariant: isLargerImageExperimentVariant
  });
  var _toolbar_title;
  var dialog = /* @__PURE__ */React58.createElement(React58.Fragment, null, shouldDisplayToolbar && /* @__PURE__ */React58.createElement(EGDSToolbar3, {
    toolbarTitle: isSimplifiedAddOnsDrawer ? formatText("add-ons-drawer.title") : (_toolbar_title = toolbar === null || toolbar === void 0 ? void 0 : toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
    navigationContent: {
      navIconLabel: isSimplifiedAddOnsDrawer ? formatText("add-ons-drawer.close") : toolbar === null || toolbar === void 0 ? void 0 : (_toolbar_icon = toolbar.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description,
      navType: "close",
      onClick: closeDialog
    }
  }), /* @__PURE__ */React58.createElement(DialogContext.Provider, {
    value: true
  }, isSimplifiedAddOnsDrawer ? dialogContent : /* @__PURE__ */React58.createElement(EGDSSheetContent3, {
    padded: false
  }, dialogContent)));
  var sheetProps = {
    isVisible: isDialogOpen,
    triggerRef: null
  };
  return isSimplifiedAddOnsDrawer ? /* @__PURE__ */React58.createElement(Viewport6, null, /* @__PURE__ */React58.createElement(ViewSmall6, null, /* @__PURE__ */React58.createElement(Sheet, _object_spread_props(_object_spread({}, sheetProps), {
    type: "bottom",
    tall: true
  }), dialog)), /* @__PURE__ */React58.createElement(ViewMedium4, null, /* @__PURE__ */React58.createElement(Sheet, _object_spread_props(_object_spread({}, sheetProps), {
    type: "centered",
    centeredSheetSize: "small"
  }), dialog))) : /* @__PURE__ */React58.createElement(Viewport6, null, /* @__PURE__ */React58.createElement(ViewSmall6, null, /* @__PURE__ */React58.createElement(EGDSSheet4, _object_spread_props(_object_spread({}, sheetProps), {
    type: "full"
  }), dialog)), /* @__PURE__ */React58.createElement(ViewMedium4, null, /* @__PURE__ */React58.createElement(EGDSSheet4, _object_spread_props(_object_spread({}, sheetProps), {
    type: "centered"
  }), dialog)));
};
UnitPropertyOffersDetailsDialog.fragment = fragment24;
UnitPropertyOffersDetailsDialog.displayName = "UnitPropertyOffersDetailsDialog";
// src/components/property-offers/__private/__fragments/details-dialog-trigger/triggers/link-trigger.tsx
import React59 from "react";
import { gql as gql49 } from "@apollo/client";
import { EGDSIcon as EGDSIcon16, EGDSIconSize as EGDSIconSize9 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink6 } from "@egds/react-core/link";
var fragment25 = gql49(_templateObject49());
var LinkTrigger = function (param) {
  var data = param.data,
    openDialog = param.openDialog;
  var value = data.value,
    accessibilityLabel = data.accessibilityLabel;
  return /* @__PURE__ */React59.createElement(EGDSLink6, {
    onClick: openDialog
  }, /* @__PURE__ */React59.createElement("button", {
    type: "button"
  }, /* @__PURE__ */React59.createElement("span", {
    "aria-hidden": accessibilityLabel !== null
  }, value), accessibilityLabel && /* @__PURE__ */React59.createElement("span", {
    className: "is-visually-hidden"
  }, accessibilityLabel), /* @__PURE__ */React59.createElement(EGDSIcon16, {
    name: "chevron_right",
    size: EGDSIconSize9.SMALL
  })));
};
LinkTrigger.fragment = fragment25;
LinkTrigger.displayName = "LinkTrigger";
// src/components/property-offers/__private/__fragments/lodging-plain-fullscreen-dialog.tsx
import React60 from "react";
import { gql as gql50 } from "@apollo/client";
import { EGDSDialogContent as EGDSDialogContent3 } from "@egds/react-core/dialog";
import { EGDSIcon as EGDSIcon17, EGDSIconSize as EGDSIconSize10 } from "@egds/react-core/icons";
import { EGDSMoreInfoTrigger as EGDSMoreInfoTrigger3 } from "@egds/react-core/more-info-trigger";
import { EGDSSheet as EGDSSheet5, EGDSSheetTransition as EGDSSheetTransition6 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing32 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText22 } from "@egds/react-core/text";
import { EGDSToolbar as EGDSToolbar4 } from "@egds/react-core/toolbar";
import { EGDSUnformattedHtml as EGDSUnformattedHtml4 } from "@egds/react-core/unformatted-html";
import { useClickTracker as useClickTracker14 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog7 } from "@shared-ui/dialog-context";
import { highlightedMessagesThemeToEGDSTextTheme as highlightedMessagesThemeToEGDSTextTheme4, useDialogId as useDialogId5 } from "@shared-ui/lodging-fragments";
var fragment26 = gql50(_templateObject50());
var LodgingPlainFullscreenDialog = function (param) {
  var data = param.data,
    uniqueDialogId = param.uniqueDialogId,
    _param_isHtmlContent = param.isHtmlContent,
    isHtmlContent = _param_isHtmlContent === void 0 ? false : _param_isHtmlContent,
    _param_spacing = param.spacing,
    spacing = _param_spacing === void 0 ? {} : _param_spacing;
  var _toolbar_icon;
  var dialogPostfix = useDialogId5();
  var _useDialog7 = _sliced_to_array(useDialog7("".concat(uniqueDialogId, "-").concat(dialogPostfix), "pwaDialogNested"), 3),
    isDialogOpen = _useDialog7[0],
    dialogActions = _useDialog7[1],
    DialogComponent = _useDialog7[2];
  var trackClick = useClickTracker14();
  var triggerRef = React60.useRef(null);
  if (!data) {
    return null;
  }
  var content = data.content,
    trigger = data.trigger,
    toolbar = data.toolbar;
  var openDialog = function () {
    var clientSideAnalytics = trigger.clientSideAnalytics;
    dialogActions.openDialog();
    if (clientSideAnalytics) {
      trackClick("HOT.HIS".concat(clientSideAnalytics.referrerId), clientSideAnalytics.linkName);
    }
  };
  var closeDialog = function () {
    var clientSideAnalytics = (toolbar || {}).clientSideAnalytics;
    dialogActions.closeDialog();
    if (clientSideAnalytics) {
      trackClick("HOT.HIS".concat(clientSideAnalytics.referrerId), clientSideAnalytics.linkName);
    }
  };
  var _toolbar_title;
  return /* @__PURE__ */React60.createElement(React60.Fragment, null, /* @__PURE__ */React60.createElement(EGDSSpacing32, _object_spread({}, spacing), /* @__PURE__ */React60.createElement(EGDSMoreInfoTrigger3, {
    onClick: openDialog
  }, /* @__PURE__ */React60.createElement("button", {
    type: "button",
    ref: triggerRef
  }, /* @__PURE__ */React60.createElement(EGDSText22, {
    className: "uitk-layout-flex",
    size: 300,
    theme: trigger.theme ? highlightedMessagesThemeToEGDSTextTheme4[trigger.theme] : "default"
  }, trigger.value, trigger.icon && /* @__PURE__ */React60.createElement(EGDSIcon17, {
    name: trigger.icon.id,
    size: EGDSIconSize10.SMALL
  }))))), /* @__PURE__ */React60.createElement(EGDSSheetTransition6, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React60.createElement(DialogComponent, null, /* @__PURE__ */React60.createElement(EGDSSheet5, {
    type: "centered",
    isVisible: true,
    triggerRef: triggerRef,
    returnFocusOnClose: true
  }, /* @__PURE__ */React60.createElement(EGDSToolbar4, {
    key: "".concat(uniqueDialogId, "-toolbar"),
    toolbarTitle: (_toolbar_title = toolbar === null || toolbar === void 0 ? void 0 : toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
    navigationContent: {
      navIconLabel: toolbar === null || toolbar === void 0 ? void 0 : (_toolbar_icon = toolbar.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description,
      navType: "close",
      onClick: closeDialog
    }
  }), /* @__PURE__ */React60.createElement(EGDSDialogContent3, null, content.map(function (item, contentIndex) {
    return isHtmlContent ? /* @__PURE__ */React60.createElement(EGDSSpacing32, {
      padding: "three",
      key: "".concat(uniqueDialogId, "-content-").concat(contentIndex)
    }, /* @__PURE__ */React60.createElement(EGDSUnformattedHtml4, {
      htmlToParse: item
    })) : /* @__PURE__ */React60.createElement(EGDSText22, {
      key: "".concat(uniqueDialogId, "-content-").concat(contentIndex),
      spacing: contentIndex !== 0 ? "four" : void 0
    }, item);
  }))))));
};
LodgingPlainFullscreenDialog.fragment = fragment26;
LodgingPlainFullscreenDialog.displayName = "LodgingPlainFullscreenDialog";
// src/components/property-offers/__private/__fragments/rate-plan/rate-plan-with-amenities.tsx
import React88 from "react";
import { gql as gql73 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex19, EGDSLayoutFlexItem as EGDSLayoutFlexItem14 } from "@egds/react-core/layout-flex";
import { UitkPriceLockupAlign as EGDSPriceLockupAlign3 } from "@egds/react-core/price-lockup";
import { EGDSSpacing as EGDSSpacing46 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading16, EGDSText as EGDSText32 } from "@egds/react-core/text";
import { DialogContext as DialogContext8, LodgingEnrichedMessage as LodgingEnrichedMessage11, LodgingPriceSummary, PropertyPriceDocumentNode as PropertyPriceDocumentNode2 } from "@shared-ui/lodging-fragments";
import { PriceSummary as PriceSummary2 } from "@shared-ui/pricing-price-summary";
// src/utils/analytics.ts
var roomSchema = function (roomTypeCode, ratePlans) {
  return {
    schemaName: "room",
    messageContent: {
      roomTypeCode: roomTypeCode,
      ratePlans: ratePlans
    }
  };
};
var allRoomsSchema = function (params) {
  var rateUpsell = params.rateUpsell,
    additionalAmount = params.additionalAmount,
    ratePlanCode = params.ratePlanCode,
    roomId = params.roomId,
    propertyId = params.propertyId,
    roomUpsell = params.roomUpsell,
    propertyUpsellAmount = params.propertyUpsellAmount,
    ratePlanDenseRank = params.ratePlanDenseRank,
    roomUpgradeEligible = params.roomUpgradeEligible,
    rateUpgradeEligible = params.rateUpgradeEligible;
  return [{
    messageContent: {
      numOfProducts: 1,
      hotelProducts: [{
        productId: parseInt(propertyId, 10)
      }]
    },
    schemaName: "allHotelProducts"
  }, {
    messageContent: {
      productId: parseInt(propertyId, 10),
      rooms: [{
        roomTypeCode: roomId,
        propertyUpsell: {
          roomUpsell: roomUpsell,
          additionalAmount: propertyUpsellAmount,
          roomUpgradeEligible: roomUpgradeEligible
        },
        ratePlans: [{
          ratePlanCode: ratePlanCode,
          ratePlanDenseRank: ratePlanDenseRank,
          upsell: {
            rateUpsell: rateUpsell,
            additionalAmount: additionalAmount,
            rateUpgradeEligible: rateUpgradeEligible
          }
        }]
      }]
    },
    schemaName: "allRooms"
  }];
};
var egRecommendationClickstreamBuilder = function (recommendationResponseId, ratePlanId, eventName, eventType, listingIndex, clientSideAnalytics) {
  return [{
    messageContent: {
      eventName: eventName,
      eventType: eventType,
      egRecommendationResponseId: recommendationResponseId,
      redirectedDestinationName: clientSideAnalytics.referrerId,
      recommendations: [{
        recommendationId: ratePlanId,
        rank: listingIndex
      }]
    },
    schemaName: "allRecommendations"
  }, {
    messageContent: {
      referrerId: clientSideAnalytics.referrerId,
      linkName: clientSideAnalytics.linkName
    },
    schemaName: "referrer"
  }];
};
// src/components/__private/__fragments/marketing-section.tsx
import React61 from "react";
import { gql as gql51 } from "@apollo/client";
import { EGDSCard as EGDSCard10, EGDSCardContentSection as EGDSCardContentSection5 } from "@egds/react-core/cards";
import { EGDSDialog as EGDSDialog2, EGDSDialogContent as EGDSDialogContent4, EGDSDialogFooter as EGDSDialogFooter2 } from "@egds/react-core/dialog";
import { EGDSIcon as EGDSIcon18, EGDSIconSize as EGDSIconSize11 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex11, EGDSLayoutFlexItem as EGDSLayoutFlexItem8 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink7 } from "@egds/react-core/link";
import { EGDSMark as EGDSMark3, EGDSMarkSize as EGDSMarkSize3 } from "@egds/react-core/mark";
import { EGDSSheetTransition as EGDSSheetTransition7 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing33 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading13, EGDSText as EGDSText23 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog8 } from "@shared-ui/dialog-context";
import { DialogContext as DialogContext2, LodgingEnrichedMessage as LodgingEnrichedMessage6, useDialogId as useDialogId6 } from "@shared-ui/lodging-fragments";
var fragment27 = gql51(_templateObject51(), LodgingEnrichedMessage6.fragment);
var MarketingSection = function (param) {
  var data = param.data;
  var dialogPostfix = useDialogId6();
  var _useDialog8 = _sliced_to_array(useDialog8("marketing-info-".concat(dialogPostfix), "pwaDialogNested"), 3),
    isDialogOpen = _useDialog8[0],
    dialogActions = _useDialog8[1],
    DialogComponent = _useDialog8[2];
  var track = useClickTracker15();
  var isWithinDetailsDialog = React61.useContext(DialogContext2);
  if (!data) {
    return null;
  }
  var title = data.title,
    feeDialog = data.feeDialog,
    paymentDetails = data.paymentDetails;
  var content = feeDialog.content,
    dialogTitle = feeDialog.title,
    tertiaryUIButton = feeDialog.tertiaryUIButton,
    trigger = feeDialog.trigger;
  var clientSideAnalytics = trigger.clientSideAnalytics,
    icon = trigger.icon,
    mark = trigger.mark,
    value = trigger.value;
  var handleOpenDialog = function () {
    dialogActions.openDialog();
    if (clientSideAnalytics) {
      track("HOT.HIS.".concat(clientSideAnalytics.referrerId), "".concat(clientSideAnalytics.linkName));
    }
  };
  return /* @__PURE__ */React61.createElement(EGDSCard10, {
    padded: true,
    border: true,
    "data-stid": "marketing-fee-info"
  }, (title === null || title === void 0 ? void 0 : title.text) && /* @__PURE__ */React61.createElement(EGDSSpacing33, {
    padding: {
      blockend: "two"
    }
  }, /* @__PURE__ */React61.createElement(EGDSHeading13, {
    tag: "h4",
    size: 7
  }, title === null || title === void 0 ? void 0 : title.text)), /* @__PURE__ */React61.createElement(EGDSCardContentSection5, {
    padded: false
  }, /* @__PURE__ */React61.createElement(EGDSLayoutFlex11, {
    space: "two",
    direction: "column",
    alignItems: "start"
  }, value && /* @__PURE__ */React61.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */React61.createElement(EGDSLink7, null, /* @__PURE__ */React61.createElement("button", {
    onClick: handleOpenDialog,
    type: "button"
  }, mark && /* @__PURE__ */React61.createElement(EGDSSpacing33, {
    margin: {
      inlineend: "two"
    }
  }, /* @__PURE__ */React61.createElement(EGDSMark3, {
    name: mark.id,
    size: EGDSMarkSize3.SMALL
  })), /* @__PURE__ */React61.createElement(EGDSText23, {
    size: 200,
    theme: "standard",
    inline: true
  }, value), (icon === null || icon === void 0 ? void 0 : icon.id) && /* @__PURE__ */React61.createElement(EGDSSpacing33, {
    margin: {
      inline: "one"
    }
  }, /* @__PURE__ */React61.createElement(EGDSIcon18, {
    name: icon.id.toLowerCase(),
    id: icon.id,
    size: icon.size ? EGDSIconSize11[icon.size] : EGDSIconSize11.SMALL
  }))))), paymentDetails && /* @__PURE__ */React61.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */React61.createElement(EGDSText23, {
    size: 200,
    inline: true
  }, /* @__PURE__ */React61.createElement(LodgingEnrichedMessage6, {
    data: paymentDetails
  }))), dialogTitle && (content === null || content === void 0 ? void 0 : content.length) && !isWithinDetailsDialog && /* @__PURE__ */React61.createElement(EGDSSheetTransition7, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React61.createElement(DialogComponent, null, /* @__PURE__ */React61.createElement(EGDSDialog2, {
    dialogShow: isDialogOpen,
    returnFocusOnClose: true
  }, /* @__PURE__ */React61.createElement(EGDSDialogContent4, null, /* @__PURE__ */React61.createElement(EGDSSpacing33, {
    padding: {
      blockend: "two"
    }
  }, /* @__PURE__ */React61.createElement(EGDSText23, {
    size: 500,
    weight: "bold"
  }, dialogTitle)), content.map(function (item, i) {
    return /* @__PURE__ */React61.createElement(EGDSText23, {
      key: "taap-content-".concat(i)
    }, item);
  }), (tertiaryUIButton === null || tertiaryUIButton === void 0 ? void 0 : tertiaryUIButton.primary) && /* @__PURE__ */React61.createElement(EGDSDialogFooter2, {
    buttonOne: {
      onClick: dialogActions.closeDialog,
      text: tertiaryUIButton === null || tertiaryUIButton === void 0 ? void 0 : tertiaryUIButton.primary,
      type: "tertiary"
    }
  }))))))));
};
MarketingSection.fragment = fragment27;
MarketingSection.displayName = "MarketingSection";
// src/components/property-offers/__private/__fragments/lodging-highlighted-messages.tsx
import React62 from "react";
import { gql as gql52 } from "@apollo/client";
import { EGDSLayoutGrid as EGDSLayoutGrid10 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing34 } from "@egds/react-core/spacing";
import { LodgingEnrichedMessage as LodgingEnrichedMessage7 } from "@shared-ui/lodging-fragments";
var fragment28 = gql52(_templateObject52(), LodgingEnrichedMessage7.fragment, LodgingPlainDialog.fragment, LodgingPolicyDialog.fragment, LodgingPlainMessage.fragment);
var LodgingHighlightedMessages = function (param) {
  var data = param.data;
  var highlightedMessages = data.highlightedMessages,
    id = data.id;
  if (!highlightedMessages) {
    return null;
  }
  var mappedMessages = highlightedMessages.map(function (highlightedMessage, index) {
    return highlightedMessage ? /* @__PURE__ */React62.createElement(RatePlanMessage, {
      key: "mapped-msg-".concat(index),
      data: highlightedMessage
    }) : null;
  });
  return /* @__PURE__ */React62.createElement(React62.Fragment, null, mappedMessages.length > 0 && /* @__PURE__ */React62.createElement(EGDSSpacing34, {
    padding: {
      blockend: "one"
    }
  }, /* @__PURE__ */React62.createElement(EGDSLayoutGrid10, {
    "data-stid": "cancellation-policy-".concat(id),
    space: "three"
  }, mappedMessages)));
};
LodgingHighlightedMessages.fragment = fragment28;
LodgingHighlightedMessages.displayName = "LodgingHighlightedMessages";
// src/components/property-offers/__private/__fragments/marketing-section-link.tsx
import React63 from "react";
import { EGDSCardContentSection as EGDSCardContentSection6 } from "@egds/react-core/cards";
import { EGDSLink as EGDSLink8 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing35 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
var MarketingSectionLink = function (param) {
  var shareUrl = param.shareUrl,
    _param_linkAlignment = param.linkAlignment,
    linkAlignment = _param_linkAlignment === void 0 ? "left" : _param_linkAlignment;
  var _link_uri;
  var track = useClickTracker16();
  if (!shareUrl) {
    return null;
  }
  var link = shareUrl.link;
  var handleLinkInNewTab = function () {
    if (link === null || link === void 0 ? void 0 : link.clientSideAnalytics) {
      track(link.clientSideAnalytics.referrerId, link.clientSideAnalytics.linkName);
    }
  };
  return /* @__PURE__ */React63.createElement(EGDSCardContentSection6, {
    border: "top",
    padded: false
  }, /* @__PURE__ */React63.createElement(EGDSSpacing35, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React63.createElement("div", null, /* @__PURE__ */React63.createElement(EGDSLink8, {
    align: linkAlignment,
    "data-stid": "marketing-link-info",
    onClick: handleLinkInNewTab
  }, /* @__PURE__ */React63.createElement("a", {
    href: link === null || link === void 0 ? void 0 : (_link_uri = link.uri) === null || _link_uri === void 0 ? void 0 : _link_uri.relativePath,
    target: "_blank",
    rel: "noopener noreferrer"
  }, shareUrl === null || shareUrl === void 0 ? void 0 : shareUrl.value, /* @__PURE__ */React63.createElement("span", {
    className: "is-visually-hidden"
  }, shareUrl === null || shareUrl === void 0 ? void 0 : shareUrl.accessibilityLabel))))));
};
MarketingSectionLink.displayName = "MarketingSectionLink";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/price-breakdown-summary.tsx
import React66 from "react";
import { EGDSSpacing as EGDSSpacing38 } from "@egds/react-core/spacing";
import { ViewMedium as ViewMedium5, Viewport as Viewport7, ViewSmall as ViewSmall7 } from "@shared-ui/viewport-context";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/price-breakdown-dialog.tsx
import React64 from "react";
import { EGDSDialogContent as EGDSDialogContent5 } from "@egds/react-core/dialog";
import { EGDSIcon as EGDSIcon19, EGDSIconSize as EGDSIconSize12 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex12, EGDSLayoutFlexItem as EGDSLayoutFlexItem9 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink9 } from "@egds/react-core/link";
import { EGDSScrim, EGDSScrimType } from "@egds/react-core/scrim";
import { EGDSSheet as EGDSSheet6, EGDSSheetTransition as EGDSSheetTransition8 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing36 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText24 } from "@egds/react-core/text";
import { EGDSToolbar as EGDSToolbar5 } from "@egds/react-core/toolbar";
import { useClickTracker as useClickTracker17, useEgClickstream as useEgClickstream6 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog9 } from "@shared-ui/dialog-context";
import { DialogContext as DialogContext3, LodgingEnrichedMessage as LodgingEnrichedMessage8, useDialogId as useDialogId7 } from "@shared-ui/lodging-fragments";
var PriceBreakdownDialog = function (param) {
  var data = param.data,
    actionButton = param.actionButton;
  var dialogPostfix = useDialogId7();
  var _useDialog9 = _sliced_to_array(useDialog9("price-breakdown-summary-".concat(dialogPostfix), "pwaDialogNested"), 3),
    isDialogOpen = _useDialog9[0],
    dialogActions = _useDialog9[1],
    DialogComponent = _useDialog9[2];
  var isWithinDetailsDialog = React64.useContext(DialogContext3);
  var _React64_useContext = React64.useContext(UnitRateContext),
    ratePlan = _React64_useContext.ratePlan,
    roomTypeId = _React64_useContext.roomTypeId;
  var track = useClickTracker17();
  var trackEgClickstreamEvent = useEgClickstream6();
  var triggerRef = React64.useRef(null);
  var _ref = data.priceBreakDownSummary || {},
    priceSummaryHeading = _ref.priceSummaryHeading,
    sections = _ref.sections,
    disclaimers = _ref.disclaimers;
  var rfrrSuffix = isWithinDetailsDialog ? "RoomInfo" : "RoomsAndRates";
  var onClick = function () {
    if (roomTypeId && (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.id)) {
      trackEgClickstreamEvent(buildRoomsAndRatesClientPayload("price_detail.selected" /* PRICE_DETAIL_SELECTED */, roomTypeId, ratePlan.id));
    }
    track("HOT.HIS.".concat(rfrrSuffix, ".PriceDetailDialog"), "price.breakdown.details");
    dialogActions.openDialog();
  };
  var onClose = function () {
    track("HOT.HIS.".concat(rfrrSuffix, ".PriceDetailDialog.Close"), "price.breakdown.details");
    dialogActions.closeDialog();
  };
  if (!(sections === null || sections === void 0 ? void 0 : sections.length)) {
    return null;
  }
  var _ref1 = priceSummaryHeading || {},
    triggerText = _ref1.value;
  return /* @__PURE__ */React64.createElement(React64.Fragment, null, /* @__PURE__ */React64.createElement(EGDSLink9, {
    onClick: onClick,
    inline: true
  }, /* @__PURE__ */React64.createElement("button", {
    type: "button",
    ref: triggerRef
  }, triggerText, /* @__PURE__ */React64.createElement(EGDSIcon19, {
    name: "chevron_right",
    size: EGDSIconSize12.SMALL
  }))), /* @__PURE__ */React64.createElement(EGDSSheetTransition8, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React64.createElement(DialogComponent, null, /* @__PURE__ */React64.createElement(EGDSSheet6, {
    type: "full",
    isVisible: isDialogOpen,
    triggerRef: triggerRef,
    returnFocusOnClose: true
  }, /* @__PURE__ */React64.createElement(EGDSToolbar5, {
    toolbarTitle: priceSummaryHeading === null || priceSummaryHeading === void 0 ? void 0 : priceSummaryHeading.value,
    navigationContent: {
      navType: "close",
      onClick: onClose
    }
  }), /* @__PURE__ */React64.createElement(EGDSDialogContent5, {
    zeroPadding: true
  }, /* @__PURE__ */React64.createElement(EGDSSpacing36, {
    padding: {
      inline: "four"
    }
  }, /* @__PURE__ */React64.createElement("div", null, sections.map(function (section, index) {
    return /* @__PURE__ */React64.createElement(PriceSummarySection, {
      data: section,
      key: "price-summary-section-".concat(index),
      lastSection: index === sections.length - 1
    });
  }))), /* @__PURE__ */React64.createElement(EGDSScrim, {
    type: EGDSScrimType.BUTTON
  }, actionButton), disclaimers && disclaimers.length > 0 && /* @__PURE__ */React64.createElement(EGDSSpacing36, {
    margin: {
      blockstart: "three",
      inline: "four"
    }
  }, /* @__PURE__ */React64.createElement(EGDSLayoutFlex12, {
    direction: "row"
  }, disclaimers.map(function (message, index) {
    return /* @__PURE__ */React64.createElement(EGDSLayoutFlexItem9, {
      key: "price-summary-disclaimer-message-".concat(index)
    }, /* @__PURE__ */React64.createElement(EGDSText24, {
      size: 100
    }, /* @__PURE__ */React64.createElement(LodgingEnrichedMessage8, {
      data: message
    })));
  }))))))));
};
PriceBreakdownDialog.fragment = fragment4;
PriceBreakdownDialog.displayName = "PriceBreakdownDialog";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/price-breakdown-menu.tsx
import React65 from "react";
import { EGDSIcon as EGDSIcon20, EGDSIconSize as EGDSIconSize13 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex13, EGDSLayoutFlexItem as EGDSLayoutFlexItem10 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink10 } from "@egds/react-core/link";
import { EGDSMenu, EGDSMenuContainer, EGDSMenuTrigger, PositionType } from "@egds/react-core/menu";
import { EGDSSpacing as EGDSSpacing37 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading14, EGDSText as EGDSText25 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker18 } from "@shared-ui/clickstream-analytics-context";
import { DialogContext as DialogContext4, LodgingEnrichedMessage as LodgingEnrichedMessage9 } from "@shared-ui/lodging-fragments";
var PriceBreakdownSummaryMenu = function (param) {
  var data = param.data,
    actionButton = param.actionButton,
    _param_menuContainerPosition = param.menuContainerPosition,
    menuContainerPosition = _param_menuContainerPosition === void 0 ? PositionType.RIGHT : _param_menuContainerPosition,
    roomTypeId = param.roomTypeId,
    ratePlanId = param.ratePlanId;
  var priceBreakDownSummary = data.priceBreakDownSummary;
  var _ref = priceBreakDownSummary || {},
    priceSummaryHeading = _ref.priceSummaryHeading,
    sections = _ref.sections,
    disclaimers = _ref.disclaimers;
  var _React65_useState = _sliced_to_array(React65.useState(false), 2),
    isMenuOpen = _React65_useState[0],
    setIsMenuOpen = _React65_useState[1];
  var track = useClickTracker18();
  var isWithinDetailsDialog = React65.useContext(DialogContext4);
  var rfrrSuffix = isWithinDetailsDialog ? "RoomInfo" : "RoomsAndRates";
  var toggleMenuOpen = function () {
    if (!isMenuOpen) {
      track("HOT.HIS.".concat(rfrrSuffix, ".PriceDetail.").concat(roomTypeId, ".").concat(ratePlanId), "price.breakdown.details");
    }
    setIsMenuOpen(!isMenuOpen);
  };
  if (!(sections === null || sections === void 0 ? void 0 : sections.length)) {
    return null;
  }
  var _ref1 = priceSummaryHeading || {},
    triggerText = _ref1.value,
    accessibilityLabel = _ref1.accessibilityLabel;
  return /* @__PURE__ */React65.createElement(EGDSMenu, {
    isOpen: isMenuOpen,
    onTriggerClick: toggleMenuOpen
  }, /* @__PURE__ */React65.createElement(EGDSMenuTrigger, null, /* @__PURE__ */React65.createElement(EGDSLink10, null, /* @__PURE__ */React65.createElement("button", {
    type: "button"
  }, /* @__PURE__ */React65.createElement("span", {
    "aria-hidden": accessibilityLabel !== null
  }, triggerText), accessibilityLabel && /* @__PURE__ */React65.createElement("span", {
    className: "is-visually-hidden"
  }, accessibilityLabel), /* @__PURE__ */React65.createElement(EGDSIcon20, {
    name: "expand_more",
    size: EGDSIconSize13.SMALL
  })))), /* @__PURE__ */React65.createElement(EGDSMenuContainer, {
    position: menuContainerPosition,
    width: 275
  }, /* @__PURE__ */React65.createElement(EGDSSpacing37, {
    padding: {
      inline: "four"
    }
  }, /* @__PURE__ */React65.createElement("div", null, priceSummaryHeading && /* @__PURE__ */React65.createElement(EGDSHeading14, {
    align: "left",
    tag: "h4",
    size: 6
  }, priceSummaryHeading.value), sections.map(function (section, index) {
    return /* @__PURE__ */React65.createElement(PriceSummarySection, {
      data: section,
      key: "price-summary-section-".concat(index),
      lastSection: index === sections.length - 1
    });
  }), /* @__PURE__ */React65.createElement(EGDSSpacing37, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React65.createElement("div", null, actionButton)), disclaimers && disclaimers.length > 0 && /* @__PURE__ */React65.createElement(EGDSSpacing37, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React65.createElement(EGDSLayoutFlex13, {
    direction: "row"
  }, disclaimers.map(function (message, index) {
    return /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem10, {
      key: "price-summary-disclaimer-message-".concat(index)
    }, /* @__PURE__ */React65.createElement(EGDSText25, {
      size: 100
    }, /* @__PURE__ */React65.createElement(LodgingEnrichedMessage9, {
      data: message
    })));
  })))))));
};
PriceBreakdownSummaryMenu.fragment = fragment4;
PriceBreakdownSummaryMenu.displayName = "PriceBreakdownSummaryMenu";
// src/components/property-offers/__private/__fragments/price-breakdown-summary/price-breakdown-summary.tsx
var PriceBreakdownSummary = function (param) {
  var data = param.data,
    actionButton = param.actionButton,
    menuContainerPosition = param.menuContainerPosition,
    roomTypeId = param.roomTypeId,
    ratePlanId = param.ratePlanId;
  return /* @__PURE__ */React66.createElement(EGDSSpacing38, {
    padding: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React66.createElement("div", null, /* @__PURE__ */React66.createElement(Viewport7, null, /* @__PURE__ */React66.createElement(ViewSmall7, null, /* @__PURE__ */React66.createElement(PriceBreakdownDialog, {
    data: data,
    actionButton: actionButton
  })), /* @__PURE__ */React66.createElement(ViewMedium5, null, /* @__PURE__ */React66.createElement(PriceBreakdownSummaryMenu, {
    data: data,
    actionButton: actionButton,
    menuContainerPosition: menuContainerPosition,
    roomTypeId: roomTypeId,
    ratePlanId: ratePlanId
  })))));
};
PriceBreakdownSummary.fragment = fragment4;
PriceBreakdownSummary.displayName = "PriceBreakdownSummary";
// src/components/property-offers/__private/__fragments/price-presentation-dialog/price-presentation-dialog.tsx
import React67 from "react";
import { EGDSDialogContent as EGDSDialogContent6 } from "@egds/react-core/dialog";
import { EGDSIcon as EGDSIcon21, EGDSIconSize as EGDSIconSize14 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex14, EGDSLayoutFlexItem as EGDSLayoutFlexItem11 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink11 } from "@egds/react-core/link";
import { EGDSSheet as EGDSSheet7, EGDSSheetTransition as EGDSSheetTransition9 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing39 } from "@egds/react-core/spacing";
import { EGDSToolbar as EGDSToolbar6 } from "@egds/react-core/toolbar";
import { useClickTracker as useClickTracker19, useEgClickstream as useEgClickstream7 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog10 } from "@shared-ui/dialog-context";
import { DialogContext as DialogContext5, useDialogId as useDialogId8 } from "@shared-ui/lodging-fragments";
import { PricePresentation } from "@shared-ui/pricing-price-details";
import { ViewMedium as ViewMedium6, Viewport as Viewport8, ViewSmall as ViewSmall8 } from "@shared-ui/viewport-context";
// src/components/property-offers/__private/__fragments/price-presentation-dialog/price-presentation-dialog-fragment.tsx
import { gql as gql53 } from "@apollo/client";
import { UiGraphic as UiGraphic2 } from "@shared-ui/lodging-fragments";
var PricePresentationDialogComponentFragment = gql53(_templateObject53(), UiGraphic2.fragment);
// src/components/property-offers/__private/__fragments/price-presentation-dialog/price-presentation-dialog.tsx
var Dialog = function (param) {
  var data = param.data,
    onClose = param.onClose,
    triggerRef = param.triggerRef,
    actionButton = param.actionButton,
    viewport = param.viewport;
  var _toolbar_icon;
  var pricePresentation = data.pricePresentation,
    pricePresentationDialog = data.pricePresentationDialog;
  var toolbar = pricePresentationDialog.toolbar;
  var _toolbar_title;
  return /* @__PURE__ */React67.createElement(EGDSSheet7, {
    type: viewport === "SMALL" ? "full" : "centered",
    isVisible: true,
    triggerRef: triggerRef,
    returnFocusOnClose: true
  }, /* @__PURE__ */React67.createElement(EGDSToolbar6, {
    toolbarTitle: (_toolbar_title = toolbar === null || toolbar === void 0 ? void 0 : toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
    navigationContent: {
      onClick: onClose,
      navType: "close",
      navIconLabel: toolbar === null || toolbar === void 0 ? void 0 : (_toolbar_icon = toolbar.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description
    }
  }), /* @__PURE__ */React67.createElement(EGDSDialogContent6, {
    zeroPadding: true
  }, /* @__PURE__ */React67.createElement(EGDSSpacing39, {
    padding: viewport === "SMALL" ? {
      block: "four",
      inline: "four"
    } : {
      block: "six",
      inline: "six"
    }
  }, /* @__PURE__ */React67.createElement(EGDSLayoutFlex14, {
    direction: "column",
    justifyContent: viewport === "SMALL" ? "space-between" : void 0,
    blockSize: viewport === "SMALL" ? "full_size" : void 0
  }, /* @__PURE__ */React67.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */React67.createElement(PricePresentation, {
    data: pricePresentation
  })), /* @__PURE__ */React67.createElement(EGDSLayoutFlexItem11, null, viewport === "SMALL" ? /* @__PURE__ */React67.createElement("div", null, React67.cloneElement(actionButton, {
    isFullWidth: true
  })) : /* @__PURE__ */React67.createElement(EGDSSpacing39, {
    padding: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React67.createElement("div", null, actionButton)))))));
};
var PricePresentationDialog = function (param) {
  var roomTypeId = param.roomTypeId,
    ratePlanId = param.ratePlanId,
    actionButton = param.actionButton,
    data = param.data;
  var dialogPostfix = useDialogId8();
  var _useDialog10 = _sliced_to_array(useDialog10("price-presentation-".concat(dialogPostfix), "pwaDialogNested"), 3),
    isDialogOpen = _useDialog10[0],
    dialogActions = _useDialog10[1],
    DialogComponent = _useDialog10[2];
  var isWithinDetailsDialog = React67.useContext(DialogContext5);
  var track = useClickTracker19();
  var trackEgClickstreamEvent = useEgClickstream7();
  var triggerRef = React67.useRef(null);
  var pricePresentation = data.pricePresentation,
    pricePresentationDialog = data.pricePresentationDialog;
  if (!pricePresentation || !pricePresentationDialog) {
    return null;
  }
  var toolbar = pricePresentationDialog.toolbar,
    trigger = pricePresentationDialog.trigger;
  var rfrrSuffix = isWithinDetailsDialog ? "RoomInfo" : "RoomsAndRates";
  var onClick = function () {
    var clientSideAnalytics = trigger.clientSideAnalytics;
    dialogActions.openDialog();
    if (roomTypeId && ratePlanId) {
      trackEgClickstreamEvent(buildRoomsAndRatesClientPayload("price_detail.selected" /* PRICE_DETAIL_SELECTED */, roomTypeId, ratePlanId));
    }
    if (clientSideAnalytics) {
      track("HOT.HIS.".concat(rfrrSuffix + clientSideAnalytics.referrerId, ".").concat(roomTypeId, ".").concat(ratePlanId), clientSideAnalytics.linkName);
    }
  };
  var onClose = function () {
    var clientSideAnalytics = (toolbar || {}).clientSideAnalytics;
    dialogActions.closeDialog();
    if (clientSideAnalytics) {
      track("HOT.HIS.".concat(rfrrSuffix + clientSideAnalytics.referrerId), clientSideAnalytics.linkName);
    }
  };
  var _trigger_accessibilityLabel;
  return /* @__PURE__ */React67.createElement(React67.Fragment, null, /* @__PURE__ */React67.createElement(EGDSSpacing39, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React67.createElement(EGDSLink11, {
    onClick: onClick
  }, /* @__PURE__ */React67.createElement("button", {
    type: "button",
    ref: triggerRef,
    "aria-label": (_trigger_accessibilityLabel = trigger.accessibilityLabel) !== null && _trigger_accessibilityLabel !== void 0 ? _trigger_accessibilityLabel : void 0
  }, trigger.value, /* @__PURE__ */React67.createElement(EGDSIcon21, {
    name: "chevron_right",
    size: EGDSIconSize14.SMALL
  })))), /* @__PURE__ */React67.createElement(EGDSSheetTransition9, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React67.createElement(DialogComponent, null, /* @__PURE__ */React67.createElement(Viewport8, null, /* @__PURE__ */React67.createElement(ViewSmall8, null, /* @__PURE__ */React67.createElement(Dialog, {
    data: data,
    onClose: onClose,
    triggerRef: triggerRef,
    actionButton: actionButton,
    viewport: "SMALL"
  })), /* @__PURE__ */React67.createElement(ViewMedium6, null, /* @__PURE__ */React67.createElement(Dialog, {
    data: data,
    onClose: onClose,
    triggerRef: triggerRef,
    actionButton: actionButton,
    viewport: "MEDIUM"
  }))))));
};
PricePresentationDialog.fragment = PricePresentationDialogComponentFragment;
PricePresentationDialog.displayName = "PricePresentationDialog";
// src/components/property-offers/__private/__fragments/property-offers-price-change-message.tsx
import React68 from "react";
import { gql as gql54 } from "@apollo/client";
import { EGDSCard as EGDSCard11, EGDSCardContentSection as EGDSCardContentSection7 } from "@egds/react-core/cards";
import { EGDSSpacing as EGDSSpacing40 } from "@egds/react-core/spacing";
import { LodgingEnrichedMessage as LodgingEnrichedMessage10 } from "@shared-ui/lodging-fragments";
var __PropertyOffersPriceChangeMessageFragment = gql54(_templateObject54(), LodgingEnrichedMessage10.fragment);
var PropertyOffersPriceChangeMessage = function (param) {
  var data = param.data;
  var headerMessage = data.headerMessage;
  if (!headerMessage) {
    return null;
  }
  return /* @__PURE__ */React68.createElement(EGDSSpacing40, {
    margin: {
      blockstart: "four",
      blockend: "three"
    }
  }, /* @__PURE__ */React68.createElement(EGDSCard11, {
    border: true
  }, /* @__PURE__ */React68.createElement(EGDSCardContentSection7, null, /* @__PURE__ */React68.createElement(LodgingEnrichedMessage10, {
    data: headerMessage
  }))));
};
PropertyOffersPriceChangeMessage.displayName = "PropertyOffersPriceChangeMessage";
PropertyOffersPriceChangeMessage.fragment = __PropertyOffersPriceChangeMessageFragment;
// src/components/property-offers/__private/__fragments/property-offers-scarcity.tsx
import React69 from "react";
import { gql as gql55 } from "@apollo/client";
import { EGDSText as EGDSText26 } from "@egds/react-core/text";
var fragment29 = gql55(_templateObject55());
var PropertyOffersRateViewScarcity = function (param) {
  var data = param.data;
  var _data_availability;
  if (!(data === null || data === void 0 ? void 0 : (_data_availability = data.availability) === null || _data_availability === void 0 ? void 0 : _data_availability.scarcityMessage)) {
    return null;
  }
  return /* @__PURE__ */React69.createElement(EGDSText26, {
    size: 100,
    theme: "negative",
    align: "right"
  }, data.availability.scarcityMessage);
};
PropertyOffersRateViewScarcity.fragment = fragment29;
PropertyOffersRateViewScarcity.displayName = "PropertyOffersRateViewScarcity";
// src/components/property-offers/__private/__fragments/property-rate-plan-badge.tsx
import React70 from "react";
import { gql as gql56 } from "@apollo/client";
import { EGDSBadge, EGDSBadgeLoyalty as EGDSBadgeLoyalty2 } from "@egds/react-core/badge";
import { EGDSIcon as EGDSIcon22, EGDSIconSize as EGDSIconSize15 } from "@egds/react-core/icons";
import { EGDSSpacing as EGDSSpacing41 } from "@egds/react-core/spacing";
// src/components/property-offers/__private/__fragments/rate-plan-utils.tsx
import { EGDSBadgeLoyaltyThemes, EGDSBadgeTheme as EGDSBadgeTheme2 } from "@egds/react-core/badge";
var _obj;
var badgeThemeToEGDSTheme = (_obj = {}, _define_property(_obj, "DEAL_GENERIC" /* DEAL_GENERIC */, EGDSBadgeTheme2.DEAL_GENERIC), _define_property(_obj, "DEAL_BUNDLED" /* DEAL_BUNDLED */, EGDSBadgeTheme2.DEAL_BUNDLED), _define_property(_obj, "DEAL_MEMBER" /* DEAL_MEMBER */, EGDSBadgeTheme2.DEAL_MEMBER), _define_property(_obj, "SPONSORED" /* SPONSORED */, EGDSBadgeTheme2.SPONSORED), _define_property(_obj, "FAMILY_FRIENDLY" /* FAMILY_FRIENDLY */, EGDSBadgeTheme2.FAMILY_FRIENDLY), _define_property(_obj, "SAVED" /* SAVED */, EGDSBadgeTheme2.SAVED), _define_property(_obj, "SUPPLIER_PROMO" /* SUPPLIER_PROMO */, EGDSBadgeTheme2.SUPPLIER_PROMO), _define_property(_obj, "VIEWED" /* VIEWED */, EGDSBadgeTheme2.VIEWED), _define_property(_obj, "NOTIFICATION" /* NOTIFICATION */, EGDSBadgeTheme2.NOTIFICATION_1), _define_property(_obj, "VIP" /* VIP */, EGDSBadgeTheme2.VIP), _define_property(_obj, "LOYALTY_EXTRA_HIGH_TIER" /* LOYALTY_EXTRA_HIGH_TIER */, EGDSBadgeTheme2.LOYALTY_EXTRA_HIGH_TIER), _define_property(_obj, "LOYALTY_HIGH_TIER" /* LOYALTY_HIGH_TIER */, EGDSBadgeTheme2.LOYALTY_HIGH_TIER), _define_property(_obj, "LOYALTY_MIDDLE_TIER" /* LOYALTY_MIDDLE_TIER */, EGDSBadgeTheme2.LOYALTY_MIDDLE_TIER), _define_property(_obj, "LOYALTY_LOW_TIER" /* LOYALTY_LOW_TIER */, EGDSBadgeTheme2.LOYALTY_LOW_TIER), _obj);
var _obj1;
var loyaltyBadgeThemeToEGDSTheme = (_obj1 = {}, _define_property(_obj1, "LOYALTY_GLOBAL_EXTRA_HIGH_TIER" /* LOYALTY_GLOBAL_EXTRA_HIGH_TIER */, EGDSBadgeLoyaltyThemes.GLOBAL_EXTRAHIGH), _define_property(_obj1, "LOYALTY_GLOBAL_HIGH_TIER" /* LOYALTY_GLOBAL_HIGH_TIER */, EGDSBadgeLoyaltyThemes.GLOBAL_HIGH), _define_property(_obj1, "LOYALTY_GLOBAL_MIDDLE_TIER" /* LOYALTY_GLOBAL_MIDDLE_TIER */, EGDSBadgeLoyaltyThemes.GLOBAL_MIDDLE), _define_property(_obj1, "LOYALTY_GLOBAL_LOW_TIER" /* LOYALTY_GLOBAL_LOW_TIER */, EGDSBadgeLoyaltyThemes.GLOBAL_LOW), _obj1);
// src/components/property-offers/__private/__fragments/property-rate-plan-badge.tsx
var fragment30 = gql56(_templateObject56());
var PropertyRatePlanBadge = function (param) {
  var data = param.data;
  var badge = data.badge;
  if (!(badge === null || badge === void 0 ? void 0 : badge.text)) {
    return null;
  }
  var text = badge.text,
    theme_temp = badge.theme_temp,
    icon_temp = badge.icon_temp;
  var globalLoyaltyBadge = theme_temp && loyaltyBadgeThemeToEGDSTheme[theme_temp];
  var children = icon_temp && /* @__PURE__ */React70.createElement(EGDSIcon22, {
    name: icon_temp.id,
    size: EGDSIconSize15.SMALL,
    id: icon_temp.id,
    description: icon_temp.description,
    title: icon_temp.title || void 0
  });
  return /* @__PURE__ */React70.createElement(EGDSSpacing41, {
    margin: {
      blockend: "one"
    }
  }, globalLoyaltyBadge ? /* @__PURE__ */React70.createElement(EGDSBadgeLoyalty2, {
    theme: globalLoyaltyBadge,
    text: text
  }, children) :
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  /* @__PURE__ */
  React70.createElement(EGDSBadge, {
    theme: theme_temp ? badgeThemeToEGDSTheme[theme_temp] : void 0,
    text: text
  }, children));
};
PropertyRatePlanBadge.fragment = fragment30;
PropertyRatePlanBadge.displayName = "PropertyRatePlanBadge";
// src/components/property-offers/__private/__fragments/reserve-button/dialog/property-info-message-fragments.tsx
import React71 from "react";
import { gql as gql57 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex15, EGDSLayoutFlexItem as EGDSLayoutFlexItem12 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid11, EGDSLayoutGridItem as EGDSLayoutGridItem10 } from "@egds/react-core/layout-grid";
import { EGDSListItem as EGDSListItem7 } from "@egds/react-core/list";
import { EGDSMarkSize as EGDSMarkSize4 } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing42 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText27 } from "@egds/react-core/text";
import { EGDSUnformattedHtml as EGDSUnformattedHtml5 } from "@egds/react-core/unformatted-html";
import { highlightedMessagesThemeToEGDSTextTheme as highlightedMessagesThemeToEGDSTextTheme5, Mark } from "@shared-ui/lodging-fragments";
var propertyInfoItemFragment = gql57(_templateObject57(), Mark.fragment);
var PropertyInfoMessage = function (param) {
  var data = param.data,
    index = param.index,
    markSize = param.markSize,
    textSize = param.textSize;
  var text = data.text,
    state = data.state,
    graphic = data.graphic;
  var plainText = React71.useCallback(function (param) {
    var children = param.children;
    return /* @__PURE__ */React71.createElement(EGDSText27, {
      size: textSize,
      weight: "regular",
      theme: state && highlightedMessagesThemeToEGDSTextTheme5[state] || void 0
    }, children);
  }, [textSize, state]);
  var graphicMarkIdToSpacingMap = {
    payment__affirm: {
      blockend: "two"
    },
    payment__afterpay: {
      blockstart: "half",
      blockend: "half"
    },
    payment__klarna: {
      blockend: "half"
    }
  };
  if (state !== "LOYALTY") {
    var _graphicMarkIdToSpacingMap_graphic_id;
    return /* @__PURE__ */React71.createElement(EGDSListItem7, {
      key: "policy_".concat(index)
    }, /* @__PURE__ */React71.createElement(EGDSLayoutFlex15, null, /* @__PURE__ */React71.createElement(EGDSLayoutFlexItem12, null, /* @__PURE__ */React71.createElement(EGDSText27, null, text, graphic && graphic.__typename === "Mark" && /* @__PURE__ */React71.createElement(EGDSSpacing42, {
      padding: (_graphicMarkIdToSpacingMap_graphic_id = graphicMarkIdToSpacingMap[graphic.id]) !== null && _graphicMarkIdToSpacingMap_graphic_id !== void 0 ? _graphicMarkIdToSpacingMap_graphic_id : {}
    }, /* @__PURE__ */React71.createElement(Mark, {
      data: graphic
    }))))));
  }
  return /* @__PURE__ */React71.createElement(EGDSLayoutGrid11, null, /* @__PURE__ */React71.createElement(EGDSLayoutGridItem10, null, /* @__PURE__ */React71.createElement(EGDSLayoutFlex15, null, graphic && /* @__PURE__ */React71.createElement(EGDSSpacing42, {
    margin: {
      inlineend: "two"
    }
  }, (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Mark" && /* @__PURE__ */React71.createElement(Mark, {
    data: graphic,
    markSize: markSize !== null && markSize !== void 0 ? markSize : EGDSMarkSize4.SMALL
  })), /* @__PURE__ */React71.createElement(EGDSUnformattedHtml5, {
    htmlToParse: text,
    plainTextElement: plainText
  }))));
};
PropertyInfoMessage.fragment = propertyInfoItemFragment;
PropertyInfoMessage.displayName = "PropertyInfoMessage";
// src/components/property-offers/__private/__fragments/reserve-button/property-reserve-button.tsx
import React85, { useEffect as useEffect6 } from "react";
import { gql as gql70 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize6, EGDSPrimaryButton as EGDSPrimaryButton7 } from "@egds/react-core/button";
import { EGDSLayoutGrid as EGDSLayoutGrid12, EGDSLayoutGridItem as EGDSLayoutGridItem11 } from "@egds/react-core/layout-grid";
import { EGDSSheet as EGDSSheet10, EGDSSheetContent as EGDSSheetContent6, EGDSSheetTransition as EGDSSheetTransition12 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing44 } from "@egds/react-core/spacing";
import { EGDSToolbar as EGDSToolbar9 } from "@egds/react-core/toolbar";
import { ITrackType as ITrackType3, useClickstreamAnalytics as useClickstreamAnalytics3, useClickTracker as useClickTracker25, useEgClickstream as useEgClickstream8 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog14 } from "@shared-ui/dialog-context";
import { useExperiment as useExperiment6 } from "@shared-ui/experiment-context";
import { AdaptExAnalyticsEventFragment as AdaptExAnalyticsEventFragment3, adaptToAdaptExSuccessEventSchema as adaptToAdaptExSuccessEventSchema3, DialogContext as DialogContext7, LodgingEGDSGraphicText, MessageResult as MessageResult2, useDialogId as useDialogId9 } from "@shared-ui/lodging-fragments";
import { ViewMedium as ViewMedium7, Viewport as Viewport9, ViewSmall as ViewSmall9 } from "@shared-ui/viewport-context";
// src/components/__private/__fragments/change-offer-call-to-action.tsx
import React77 from "react";
import { gql as gql64 } from "@apollo/client";
// src/components/__private/__fragments/lodging-prepare-change-checkout-action.tsx
import React75, { useEffect as useEffect5, useRef as useRef2 } from "react";
import { gql as gql62, useMutation as useMutation2 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize2, EGDSPrimaryButton as EGDSPrimaryButton3 } from "@egds/react-core/button";
import { EGDSPageLoader as EGDSPageLoader2 } from "@egds/react-core/loader";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker21 } from "@shared-ui/clickstream-analytics-context";
// src/components/property-offers/__private/__fragments/reserve-button/prepare-change-checkout/lodging-prepare-change-checkout-errors.tsx
import React72 from "react";
import { EGDSSheet as EGDSSheet8, EGDSSheetContent as EGDSSheetContent4, EGDSSheetTransition as EGDSSheetTransition10 } from "@egds/react-core/sheet";
import { EGDSText as EGDSText28 } from "@egds/react-core/text";
import { EGDSToolbar as EGDSToolbar7 } from "@egds/react-core/toolbar";
import { IntersectionTracker as IntersectionTracker6 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog11 } from "@shared-ui/dialog-context";
var LodgingPrepareChangeCheckoutErrors = function (param) {
  var data = param.data,
    buttonRef = param.buttonRef;
  var _error_displayAnalytics;
  var _useDialog11 = _sliced_to_array(useDialog11("prepare-change-checkout-error"), 3),
    isDialogOpen = _useDialog11[0],
    dialogActions = _useDialog11[1],
    DialogComponent = _useDialog11[2];
  var error = data.error,
    toolbar = data.toolbar;
  React72.useEffect(function () {
    if (error) {
      dialogActions.openDialog();
    }
  }, [error]);
  if (!error) {
    return null;
  }
  var analytics2 = (_error_displayAnalytics = error.displayAnalytics) === null || _error_displayAnalytics === void 0 ? void 0 : _error_displayAnalytics[0];
  var sheet = /* @__PURE__ */React72.createElement(EGDSSheetTransition10, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React72.createElement(DialogComponent, null, /* @__PURE__ */React72.createElement(EGDSSheet8, {
    isVisible: isDialogOpen,
    type: "centered",
    triggerRef: buttonRef
  }, /* @__PURE__ */React72.createElement(EGDSToolbar7, {
    navigationContent: {
      onClick: function () {
        return dialogActions.closeDialog();
      },
      navIconLabel: (toolbar === null || toolbar === void 0 ? void 0 : toolbar.closeText) || "Close dialog"
    },
    toolbarTitle: error.heading
  }), /* @__PURE__ */React72.createElement(EGDSSheetContent4, null, error.description.map(function (text, idx) {
    return /* @__PURE__ */React72.createElement(EGDSText28, {
      size: 300,
      key: "error-description-".concat(idx)
    }, text);
  })))));
  return (analytics2 === null || analytics2 === void 0 ? void 0 : analytics2.referrerId) ? /* @__PURE__ */React72.createElement(IntersectionTracker6, {
    trackOnce: false,
    referrerId: analytics2.referrerId,
    linkName: analytics2.linkName,
    additionalUisPrimeMicroMessages: analytics2.uisPrimeMessages.map(function (param) {
      var messageContent = param.messageContent,
        schemaName = param.schemaName;
      return {
        messageContent: JSON.parse(messageContent),
        schemaName: schemaName
      };
    })
  }, sheet) : sheet;
};
LodgingPrepareChangeCheckoutErrors.displayName = "PrepareCheckoutLoadingAndErrorHandling";
// src/components/property-offers/__private/__fragments/reserve-button/prepare-change-checkout/lodging-prepare-change-checkout-mutation.ts
import { gql as gql58 } from "@apollo/client";
var LodgingPrepareChangeCheckoutMutation = gql58(_templateObject58());
// src/components/property-offers/__private/__fragments/reserve-button/prepare-checkout/property-lodging-prepare-checkout.tsx
import React74, { useContext as useContext2, useEffect as useEffect4, useRef } from "react";
import { useLocation } from "react-router-dom";
import { gql as gql60, useMutation } from "@apollo/client";
import { parse } from "query-string";
import { EGDSButtonSize, EGDSPrimaryButton as EGDSPrimaryButton2 } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex16 } from "@egds/react-core/layout-flex";
import { useBexApi } from "@shared-ui/bex-api-context";
import { ITrackType, useClickstreamAnalytics, useClickTracker as useClickTracker20 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment4 } from "@shared-ui/experiment-context";
import { AdaptExAnalyticsEventFragment, adaptToAdaptExSuccessEventSchema, DialogContext as DialogContext6, lightweightAdaptExMicroMessage, useAdaptExEvents } from "@shared-ui/lodging-fragments";
import { PropertyDetailsAdaptExContext } from "@shared-ui/lodging-property-details";
import { usePropertyActivitiesCrossSellContext } from "@shared-ui/retail-lodging-property-activities-cross-sell";
import { ProductGalleryContext } from "@shared-ui/retail-product-gallery";
import { useSignalPublisher as useSignalPublisher2 } from "@shared-ui/signal-events-context";
// src/components/property-offers/__private/__fragments/reserve-button/track-analytics-list.ts
var trackAnalyticsList = function (trackClick, analyticsList) {
  analyticsList === null || analyticsList === void 0 ? void 0 : analyticsList.forEach(function (param) {
    var referrerId = param.referrerId,
      linkName = param.linkName,
      uisPrimeMessages = param.uisPrimeMessages;
    trackClick(referrerId, linkName, void 0, uisPrimeMessages.map(function (uisPrimeMessage) {
      return {
        schemaName: uisPrimeMessage.schemaName,
        messageContent: JSON.parse(uisPrimeMessage.messageContent)
      };
    }));
  });
};
var track_analytics_list_default = trackAnalyticsList;
// src/components/property-offers/__private/__fragments/reserve-button/prepare-checkout/prepare-checkout-loading-and-error-handling.tsx
import React73, { useEffect as useEffect3 } from "react";
import { EGDSPageLoader } from "@egds/react-core/loader";
import { EGDSSheet as EGDSSheet9, EGDSSheetContent as EGDSSheetContent5, EGDSSheetTransition as EGDSSheetTransition11 } from "@egds/react-core/sheet";
import { EGDSText as EGDSText29 } from "@egds/react-core/text";
import { EGDSToolbar as EGDSToolbar8 } from "@egds/react-core/toolbar";
import { useDialog as useDialog12 } from "@shared-ui/dialog-context";
var PrepareCheckoutLoadingAndErrorHandling = function (param) {
  var prepareCheckoutLoading = param.prepareCheckoutLoading,
    prepareCheckoutData = param.prepareCheckoutData,
    failureReason = param.failureReason,
    buttonRef = param.buttonRef;
  var _prepareCheckoutData_prepareCheckout;
  var _useDialog12 = _sliced_to_array(useDialog12("prepare-checkout-error"), 3),
    isDialogOpen = _useDialog12[0],
    dialogActions = _useDialog12[1],
    DialogComponent = _useDialog12[2];
  useEffect3(function () {
    if (failureReason) {
      dialogActions.openDialog();
    }
  }, [failureReason]);
  return /* @__PURE__ */React73.createElement(React73.Fragment, null, (prepareCheckoutLoading || (prepareCheckoutData === null || prepareCheckoutData === void 0 ? void 0 : (_prepareCheckoutData_prepareCheckout = prepareCheckoutData.prepareCheckout) === null || _prepareCheckoutData_prepareCheckout === void 0 ? void 0 : _prepareCheckoutData_prepareCheckout.checkoutUrl)) && /* @__PURE__ */React73.createElement(EGDSPageLoader, {
    visible: true
  }), failureReason && /* @__PURE__ */React73.createElement(EGDSSheetTransition11, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React73.createElement(DialogComponent, null, /* @__PURE__ */React73.createElement(EGDSSheet9, {
    isVisible: isDialogOpen,
    type: "centered",
    triggerRef: buttonRef
  }, /* @__PURE__ */React73.createElement(EGDSToolbar8, {
    navigationContent: {
      onClick: function () {
        return dialogActions.closeDialog();
      },
      navIconLabel: "Close Toolbar"
    },
    toolbarTitle: failureReason.message
  }), /* @__PURE__ */React73.createElement(EGDSSheetContent5, null, /* @__PURE__ */React73.createElement(EGDSText29, {
    size: 300
  }, failureReason.description))))));
};
PrepareCheckoutLoadingAndErrorHandling.displayName = "PrepareCheckoutLoadingAndErrorHandling";
// src/components/property-offers/__private/__fragments/reserve-button/prepare-checkout/prepare-checkout-mutation.ts
import { gql as gql59 } from "@apollo/client";
var PrepareCheckoutMutation = gql59(_templateObject59());
// src/components/property-offers/__private/__fragments/reserve-button/prepare-checkout/property-lodging-prepare-checkout.tsx
var fragment31 = gql60(_templateObject60(), __UIPrimaryButtonFragment, AdaptExAnalyticsEventFragment);
var getInputValue = function (checkoutOptions, typeName) {
  var _checkoutOptions_filter_, _checkoutOptions_filter;
  return (checkoutOptions === null || checkoutOptions === void 0 ? void 0 : checkoutOptions.length) ? (_checkoutOptions_filter = checkoutOptions.filter(function (option) {
    return (option === null || option === void 0 ? void 0 : option.type) === typeName;
  })) === null || _checkoutOptions_filter === void 0 ? void 0 : (_checkoutOptions_filter_ = _checkoutOptions_filter[0]) === null || _checkoutOptions_filter_ === void 0 ? void 0 : _checkoutOptions_filter_.value : "";
};
var useQueryParams = function () {
  var location = useLocation();
  return React74.useMemo(function () {
    return parse(location === null || location === void 0 ? void 0 : location.search);
  }, [location === null || location === void 0 ? void 0 : location.search]);
};
var removeTypename = function (key, value) {
  return key === "__typename" ? void 0 : value;
};
var PropertyLodgingPrepareCheckout = function (param) {
  var isFullWidth = param.isFullWidth,
    showLargeBtn = param.showLargeBtn,
    adaptExSuccessActionTracking = param.adaptExSuccessActionTracking,
    priceDetailsPropertyNaturalKeys = param.priceDetailsPropertyNaturalKeys,
    data = param.data;
  var _checkoutPropertyNaturalKeys_, _checkoutPropertyNaturalKeys_1, _checkoutPropertyNaturalKeys_2, _prepareCheckoutData_prepareCheckout;
  var _useAdaptExEvents = useAdaptExEvents(),
    offerAdaptExSuccessEvents = _useAdaptExEvents.adaptExSuccessEvents;
  var context = useBexApi().context;
  var buttonRef = useRef(null);
  var _useClickstreamAnalytics = useClickstreamAnalytics(),
    clickStreamTrack = _useClickstreamAnalytics.track;
  var trackClick = useClickTracker20();
  var publishSignal = useSignalPublisher2().publishSignal;
  var _useQueryParams = useQueryParams(),
    search_id = _useQueryParams.searchId,
    rffrid = _useQueryParams.rffrid;
  var isWithinDetailsDialog = React74.useContext(DialogContext6);
  var activityNaturalKey = usePropertyActivitiesCrossSellContext().activityNaturalKey;
  var checkoutButton = data.checkoutButton;
  var _data_action = data.action,
    checkoutOptions = _data_action.checkoutOptions,
    offerTokens = _data_action.offerTokens,
    totalPrice = _data_action.totalPrice,
    adaptExSuccessEvents = _data_action.adaptExSuccessEvents,
    analyticsList = _data_action.analyticsList,
    propertyNaturalKeys = _data_action.propertyNaturalKeys,
    moreDetailsAnalyticsList = _data_action.moreDetailsAnalyticsList;
  var checkoutPropertyNaturalKeys = propertyNaturalKeys.length > 0 ? propertyNaturalKeys : priceDetailsPropertyNaturalKeys;
  var _useContext2 = _sliced_to_array(useContext2(PropertyDetailsAdaptExContext), 1),
    adaptExState = _useContext2[0];
  var reserveAdaptExSuccessEvents = adaptExState.reserveAdaptExSuccessEvents;
  var _useAdaptExEvents1 = useAdaptExEvents(adaptExSuccessActionTracking !== null && adaptExSuccessActionTracking !== void 0 ? adaptExSuccessActionTracking : []),
    otherActiveCampaignsAdaptExSuccessEvents = _useAdaptExEvents1.adaptExSuccessEvents;
  var rateUpsell = getInputValue(checkoutOptions, "RATE_UPSELL") === "true";
  var roomUpsell = getInputValue(checkoutOptions, "ROOM_UPSELL") === "true";
  var additionalAmount = getInputValue(checkoutOptions, "RATE_UPSELL_AMOUNT");
  var propertyUpsellAmount = getInputValue(checkoutOptions, "PROPERTY_UPSELL_AMOUNT");
  var roomUpgradeEligible = getInputValue(checkoutOptions, "ROOM_UPGRADE_ELIGIBLE") === "true";
  var rateUpgradeEligible = getInputValue(checkoutOptions, "RATE_UPGRADE_ELIGIBLE") === "true";
  var roomTypeCode = (_checkoutPropertyNaturalKeys_ = checkoutPropertyNaturalKeys[0]) === null || _checkoutPropertyNaturalKeys_ === void 0 ? void 0 : _checkoutPropertyNaturalKeys_.roomTypeId;
  var ratePlanCode = (_checkoutPropertyNaturalKeys_1 = checkoutPropertyNaturalKeys[0]) === null || _checkoutPropertyNaturalKeys_1 === void 0 ? void 0 : _checkoutPropertyNaturalKeys_1.ratePlanId;
  var hotelID = (_checkoutPropertyNaturalKeys_2 = checkoutPropertyNaturalKeys[0]) === null || _checkoutPropertyNaturalKeys_2 === void 0 ? void 0 : _checkoutPropertyNaturalKeys_2.id;
  var _useMutation = _sliced_to_array(useMutation(PrepareCheckoutMutation), 2),
    prepareCheckout = _useMutation[0],
    _useMutation_ = _useMutation[1],
    prepareCheckoutData = _useMutation_.data,
    prepareCheckoutLoading = _useMutation_.loading;
  var vrboIdentityTestHeadersTnlEval = useExperiment4("Vrbo_Identity_Test_Headers").exposure;
  var _useExperiment4 = useExperiment4("Adaptex_campaign_PDP_mosaic_for_large_screens"),
    imageMosaicLargeScreensExposure = _useExperiment4.exposure;
  var _useExperiment41 = useExperiment4("Adaptex_campaign_PDP_mosaic_for_small_screens"),
    imageMosaicMWebExposure = _useExperiment41.exposure;
  var adaptexCampaignVariant = imageMosaicLargeScreensExposure.bucket === 1 || imageMosaicMWebExposure.bucket === 1;
  var _useExperiment4_exposure = useExperiment4("PDP_Highlights_Adaptex").exposure,
    isInProductHighlightsVariant = _useExperiment4_exposure.bucket;
  var setAdaptExSuccessEvent = useContext2(ProductGalleryContext).setAdaptExSuccessEvent;
  var failureReason = prepareCheckoutData === null || prepareCheckoutData === void 0 ? void 0 : (_prepareCheckoutData_prepareCheckout = prepareCheckoutData.prepareCheckout) === null || _prepareCheckoutData_prepareCheckout === void 0 ? void 0 : _prepareCheckoutData_prepareCheckout.failureReason;
  var trackReserveAdaptExSuccessEvents = function () {
    if (reserveAdaptExSuccessEvents === null || reserveAdaptExSuccessEvents === void 0 ? void 0 : reserveAdaptExSuccessEvents.length) {
      reserveAdaptExSuccessEvents.forEach(function (reserveAdaptExSuccessEvent) {
        var _reserveAdaptExSuccessEvent_events_, _reserveAdaptExSuccessEvent_events_1, _reserveAdaptExSuccessEvent_events_2;
        clickStreamTrack(ITrackType.EVENT, {
          data: lightweightAdaptExMicroMessage({
            campaignId: reserveAdaptExSuccessEvent.campaignId,
            payloadId: ((_reserveAdaptExSuccessEvent_events_ = reserveAdaptExSuccessEvent.events[0]) === null || _reserveAdaptExSuccessEvent_events_ === void 0 ? void 0 : _reserveAdaptExSuccessEvent_events_.payloadId) || "",
            eventType: ((_reserveAdaptExSuccessEvent_events_1 = reserveAdaptExSuccessEvent.events[0]) === null || _reserveAdaptExSuccessEvent_events_1 === void 0 ? void 0 : _reserveAdaptExSuccessEvent_events_1.eventType) || "",
            eventTarget: ((_reserveAdaptExSuccessEvent_events_2 = reserveAdaptExSuccessEvent.events[0]) === null || _reserveAdaptExSuccessEvent_events_2 === void 0 ? void 0 : _reserveAdaptExSuccessEvent_events_2.eventTarget) || ""
          })
        });
      });
    }
  };
  useEffect4(function () {
    if (prepareCheckoutData === null || prepareCheckoutData === void 0 ? void 0 : prepareCheckoutData.prepareCheckout.checkoutUrl) {
      if (adaptexCampaignVariant) {
        setAdaptExSuccessEvent("ADAPTEX_MOSAIC_VIEW_BOOKING_FORM_EVENT");
      }
      if (isInProductHighlightsVariant) {
        publishSignal({
          payload: {},
          type: "ADAPTEX_HIGHLIGHTS_PROGRESSION_EVENT"
        });
      }
      window.location.href = prepareCheckoutData.prepareCheckout.checkoutUrl;
    }
  }, [prepareCheckoutData]);
  var handleSubmit = function (event) {
    var _totalPrice_currencyInfo;
    event.preventDefault();
    trackReserveAdaptExSuccessEvents();
    _to_consumable_array(offerAdaptExSuccessEvents).concat(_to_consumable_array(adaptExSuccessEvents), _to_consumable_array(otherActiveCampaignsAdaptExSuccessEvents)).forEach(function (adaptExEvent) {
      clickStreamTrack(ITrackType.EVENT, {
        data: adaptToAdaptExSuccessEventSchema(_object_spread({}, adaptExEvent))
      });
    });
    if (hotelID) {
      trackClick("HOT.HIS.RoomsAndRates.Upsell", "Click on reserve button", void 0, allRoomsSchema({
        additionalAmount: additionalAmount ? parseInt(additionalAmount, 10) : void 0,
        propertyId: hotelID,
        propertyUpsellAmount: propertyUpsellAmount ? parseInt(propertyUpsellAmount, 10) : void 0,
        rateUpsell: rateUpsell,
        ratePlanCode: ratePlanCode,
        ratePlanDenseRank: 0,
        roomId: roomTypeCode,
        roomUpsell: roomUpsell,
        roomUpgradeEligible: roomUpgradeEligible,
        rateUpgradeEligible: rateUpgradeEligible
      }));
    }
    if (isWithinDetailsDialog) {
      track_analytics_list_default(trackClick, moreDetailsAnalyticsList);
    } else {
      track_analytics_list_default(trackClick, analyticsList);
    }
    var checkoutOptionList = checkoutOptions && _to_consumable_array(checkoutOptions) || [];
    if ((search_id === null || search_id === void 0 ? void 0 : search_id.length) > 0) {
      checkoutOptionList === null || checkoutOptionList === void 0 ? void 0 : checkoutOptionList.push({
        __typename: "CheckoutOptions",
        type: "SEARCH_ID" /* SEARCH_ID */,
        value: search_id
      });
    }
    if ((rffrid === null || rffrid === void 0 ? void 0 : rffrid.length) > 0) {
      checkoutOptionList === null || checkoutOptionList === void 0 ? void 0 : checkoutOptionList.push({
        __typename: "CheckoutOptions",
        type: "REFERRER_ID" /* REFERRER_ID */,
        value: rffrid
      });
    }
    var vrboCustomHeadersOrEmpty = vrboIdentityTestHeadersTnlEval.bucket === 1 ? {
      headers: {
        "VRBO-IDENTITY-TEST": "true",
        "IDENTITY-PLUGIN-CANARY": "true"
      }
    } : {};
    prepareCheckout({
      context: vrboCustomHeadersOrEmpty,
      variables: _object_spread(_object_spread_props(_object_spread({
        context: context
      }, (activityNaturalKey === null || activityNaturalKey === void 0 ? void 0 : activityNaturalKey.offerToken) && {
        activities: activityNaturalKey
      }), {
        properties: JSON.parse(JSON.stringify(checkoutPropertyNaturalKeys), removeTypename),
        checkoutOptions: JSON.parse(JSON.stringify(checkoutOptionList), removeTypename),
        offerTokens: JSON.parse(JSON.stringify(offerTokens), removeTypename)
      }), totalPrice && {
        totalPrice: {
          amount: totalPrice.amount,
          currency: (_totalPrice_currencyInfo = totalPrice.currencyInfo) === null || _totalPrice_currencyInfo === void 0 ? void 0 : _totalPrice_currencyInfo.code
        }
      })
    });
  };
  var reserveButtonBase = /* @__PURE__ */React74.createElement(EGDSPrimaryButton2, {
    size: showLargeBtn ? EGDSButtonSize.LARGE : EGDSButtonSize.MEDIUM,
    isFullWidth: isFullWidth,
    type: "submit",
    onClick: handleSubmit,
    "data-stid": "submit-hotel-reserve",
    role: "link",
    ref: buttonRef,
    disabled: prepareCheckoutLoading
  }, /* @__PURE__ */React74.createElement(React74.Fragment, null, /* @__PURE__ */React74.createElement("span", {
    "aria-hidden": Boolean(checkoutButton.accessibility)
  }, checkoutButton.primary), checkoutButton.accessibility && /* @__PURE__ */React74.createElement("span", {
    className: "is-visually-hidden"
  }, checkoutButton.accessibility)));
  var reserveButton = !isFullWidth ? /* @__PURE__ */React74.createElement(EGDSLayoutFlex16, {
    justifyContent: "end"
  }, reserveButtonBase) : reserveButtonBase;
  return /* @__PURE__ */React74.createElement(React74.Fragment, null, /* @__PURE__ */React74.createElement(PrepareCheckoutLoadingAndErrorHandling, {
    prepareCheckoutLoading: prepareCheckoutLoading,
    prepareCheckoutData: prepareCheckoutData,
    failureReason: failureReason,
    buttonRef: buttonRef
  }), reserveButton);
};
PropertyLodgingPrepareCheckout.fragment = fragment31;
PropertyLodgingPrepareCheckout.displayName = "PropertyLodgingPrepareCheckout";
// src/components/__private/__fragments/date.tsx
import { gql as gql61 } from "@apollo/client";
var DateFragment = gql61(_templateObject61());
// src/components/__private/__fragments/lodging-prepare-change-checkout-action.tsx
var fragment32 = gql62(_templateObject62(), DateFragment);
var LodgingPrepareChangeCheckoutAction = function (param) {
  var className = param.className,
    data = param.data,
    button = param.button,
    isFullWidth = param.isFullWidth;
  var context = useBexApi2().context;
  var track = useClickTracker21();
  var buttonRef = useRef2(null);
  var _useMutation2 = _sliced_to_array(useMutation2(LodgingPrepareChangeCheckoutMutation), 2),
    prepareChangeCheckout = _useMutation2[0],
    _useMutation2_ = _useMutation2[1],
    mutationData = _useMutation2_.data,
    error = _useMutation2_.error,
    mutationLoading = _useMutation2_.loading;
  useEffect5(function () {
    if (mutationData === null || mutationData === void 0 ? void 0 : mutationData.prepareChangeCheckout.checkoutUrl) {
      window.location.href = mutationData.prepareChangeCheckout.checkoutUrl;
    }
  }, [mutationData]);
  if (!button) {
    return null;
  }
  var tripId = data.tripId,
    options = data.options,
    lodgingInput = data.lodgingInput;
  var analytics2 = button.analytics;
  var variables = {
    context: context,
    tripId: tripId,
    options: JSON.parse(JSON.stringify(options), removeTypename),
    lodgingInput: JSON.parse(JSON.stringify(lodgingInput), removeTypename)
  };
  var handleClick = function (event) {
    event.preventDefault();
    if (analytics2) {
      track(analytics2.referrerId, analytics2.linkName);
    }
    prepareChangeCheckout({
      variables: variables
    });
  };
  var isMutationLoadingOrFinished = mutationLoading || (mutationData === null || mutationData === void 0 ? void 0 : mutationData.prepareChangeCheckout.checkoutUrl);
  return /* @__PURE__ */React75.createElement("div", {
    className: className
  }, isMutationLoadingOrFinished && /* @__PURE__ */React75.createElement(EGDSPageLoader2, {
    visible: true
  }), (mutationData === null || mutationData === void 0 ? void 0 : mutationData.prepareChangeCheckout) && /* @__PURE__ */React75.createElement(LodgingPrepareChangeCheckoutErrors, {
    data: mutationData.prepareChangeCheckout,
    buttonRef: buttonRef
  }), /* @__PURE__ */React75.createElement(EGDSPrimaryButton3, {
    domRef: buttonRef,
    disabled: isMutationLoadingOrFinished,
    isFullWidth: isFullWidth,
    onClick: handleClick,
    role: "link",
    size: EGDSButtonSize2.MEDIUM,
    type: "submit"
  }, /* @__PURE__ */React75.createElement(React75.Fragment, null, /* @__PURE__ */React75.createElement("span", {
    "aria-hidden": Boolean(button.accessibility)
  }, button.primary), button.accessibility && /* @__PURE__ */React75.createElement("span", {
    className: "is-visually-hidden"
  }, button.accessibility))));
};
LodgingPrepareChangeCheckoutAction.fragment = fragment32;
LodgingPrepareChangeCheckoutAction.displayName = "LodgingPrepareChangeCheckoutActionFragment";
// src/components/__private/__fragments/select-change-offer-action.tsx
import React76 from "react";
import { gql as gql63 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize3, EGDSPrimaryButton as EGDSPrimaryButton4 } from "@egds/react-core/button";
import { useClickTracker as useClickTracker22 } from "@shared-ui/clickstream-analytics-context";
var fragment33 = gql63(_templateObject63(), DateFragment);
var SelectChangeOfferAction = function (param) {
  var data = param.data,
    button = param.button,
    onContinue = param.onContinue,
    isFullWidth = param.isFullWidth,
    className = param.className;
  var track = useClickTracker22();
  var offer = data.offer;
  if (!button) {
    return null;
  }
  var handleClick = function () {
    var analytics2 = button.analytics;
    if (analytics2) {
      track(analytics2.referrerId, analytics2.linkName);
    }
    onContinue === null || onContinue === void 0 ? void 0 : onContinue(offer);
  };
  return /* @__PURE__ */React76.createElement(EGDSPrimaryButton4, {
    isFullWidth: isFullWidth,
    onClick: handleClick,
    type: "button",
    size: EGDSButtonSize3.MEDIUM,
    className: className
  }, /* @__PURE__ */React76.createElement(React76.Fragment, null, /* @__PURE__ */React76.createElement("span", {
    "aria-hidden": Boolean(button.accessibility)
  }, button.primary), button.accessibility && /* @__PURE__ */React76.createElement("span", {
    className: "is-visually-hidden"
  }, button.accessibility)));
};
SelectChangeOfferAction.fragment = fragment33;
SelectChangeOfferAction.displayName = "SelectChangeOfferActionFragment";
// src/components/__private/__fragments/change-offer-call-to-action.tsx
var fragment34 = gql64(_templateObject64(), LodgingPrepareChangeCheckoutAction.fragment, SelectChangeOfferAction.fragment);
var ChangeOfferCallToAction = function (param) {
  var data = param.data,
    onContinue = param.onContinue,
    className = param.className,
    isFullWidth = param.isFullWidth;
  var action = data.action,
    button = data.button;
  switch (action === null || action === void 0 ? void 0 : action.__typename) {
    case "SelectChangeOfferAction":
      return /* @__PURE__ */React77.createElement(SelectChangeOfferAction, {
        data: action,
        button: button,
        onContinue: onContinue,
        className: className,
        isFullWidth: isFullWidth
      });
    case "LodgingPrepareChangeCheckoutAction":
      return /* @__PURE__ */React77.createElement(LodgingPrepareChangeCheckoutAction, {
        data: action,
        button: button,
        className: className,
        isFullWidth: isFullWidth
      });
    default:
      return null;
  }
};
ChangeOfferCallToAction.fragment = fragment34;
ChangeOfferCallToAction.displayName = "ChangeOfferCallToActionFragment";
// src/components/property-offers/__private/__fragments/reserve-button/dateless-check-availability.tsx
import React78 from "react";
import { gql as gql65 } from "@apollo/client";
import { LodgingEGDSButton } from "@shared-ui/lodging-fragments";
import { useRefContext as useRefContext2 } from "@shared-ui/ref-context";
var fragment35 = gql65(_templateObject65(), LodgingEGDSButton.fragment);
var DatelessCheckAvailability = function (param) {
  var data = param.data,
    clickRefTarget = param.clickRefTarget,
    onClose = param.onClose;
  var getTargets = useRefContext2().getTargets;
  var checkAvailabilityButton = data.checkAvailabilityButton;
  var handleClickOpenCalendar = function () {
    var _getTargets = getTargets([clickRefTarget]),
      startDateRef = _getTargets.startDate;
    onClose === null || onClose === void 0 ? void 0 : onClose();
    setTimeout(function () {
      var _startDateRef_current, _startDateRef_current1;
      startDateRef === null || startDateRef === void 0 ? void 0 : (_startDateRef_current = startDateRef.current) === null || _startDateRef_current === void 0 ? void 0 : _startDateRef_current.scrollIntoView({
        behavior: "auto",
        block: "start",
        inline: "nearest"
      });
      startDateRef === null || startDateRef === void 0 ? void 0 : (_startDateRef_current1 = startDateRef.current) === null || _startDateRef_current1 === void 0 ? void 0 : _startDateRef_current1.click();
    }, 50);
  };
  return /* @__PURE__ */React78.createElement(LodgingEGDSButton, {
    data: checkAvailabilityButton,
    onClick: handleClickOpenCalendar,
    isFullWidth: true
  });
};
DatelessCheckAvailability.fragment = fragment35;
DatelessCheckAvailability.displayName = "DatelessCheckAvailability";
// src/components/property-offers/__private/__fragments/reserve-button/dialog/lodging-signin-dialog/lodging-sign-dialog.tsx
import React79 from "react";
import { gql as gql66 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize4, EGDSPrimaryButton as EGDSPrimaryButton5 } from "@egds/react-core/button";
import { useDialog as useDialog13 } from "@shared-ui/dialog-context";
import { EGDSActionDialog, SharedUIDialog, SharedUIParagraph } from "@shared-ui/lodging-fragments";
var fragment36 = gql66(_templateObject66(), SharedUIParagraph.fragment, EGDSActionDialog.fragment);
var LodgingSignInDialog = function (param) {
  var data = param.data,
    showLargeBtn = param.showLargeBtn,
    isFullWidth = param.isFullWidth,
    dialogId = param.dialogId;
  var dialogContent = data.dialogContent,
    title = data.title,
    dialogTrigger = data.dialogTrigger;
  var actionDialog = data.actionDialog;
  var _useDialog13 = _sliced_to_array(useDialog13(dialogId), 2),
    openDialog = _useDialog13[1].openDialog;
  if (!dialogContent || !actionDialog) {
    return null;
  }
  return /* @__PURE__ */React79.createElement(React79.Fragment, null, /* @__PURE__ */React79.createElement(EGDSPrimaryButton5, {
    onClick: function () {
      openDialog();
    },
    isFullWidth: isFullWidth,
    "data-stid": "submit-hotel-reserve",
    size: showLargeBtn ? EGDSButtonSize4.LARGE : EGDSButtonSize4.MEDIUM
  }, /* @__PURE__ */React79.createElement(React79.Fragment, null, (dialogTrigger === null || dialogTrigger === void 0 ? void 0 : dialogTrigger.accessibilityLabel) && /* @__PURE__ */React79.createElement("span", {
    className: "is-visually-hidden"
  }, dialogTrigger.accessibilityLabel), /* @__PURE__ */React79.createElement("span", {
    "aria-hidden": (dialogTrigger === null || dialogTrigger === void 0 ? void 0 : dialogTrigger.accessibilityLabel) !== null
  }, dialogTrigger === null || dialogTrigger === void 0 ? void 0 : dialogTrigger.value))), /* @__PURE__ */React79.createElement(SharedUIDialog, {
    dialogContent: dialogContent,
    data: actionDialog,
    dialogId: dialogId,
    title: title
  }));
};
LodgingSignInDialog.fragment = fragment36;
LodgingSignInDialog.displayName = "LodgingSignInDialog";
// src/components/property-offers/__private/__fragments/reserve-button/dialog/property-payment-options.tsx
import React84 from "react";
import { gql as gql69 } from "@apollo/client";
import { EGDSCard as EGDSCard12 } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon23 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex18, EGDSLayoutFlexItem as EGDSLayoutFlexItem13 } from "@egds/react-core/layout-flex";
import { EGDSList as EGDSList5, EGDSListItem as EGDSListItem8 } from "@egds/react-core/list";
import { EGDSMark as EGDSMark4, EGDSMarkSize as EGDSMarkSize5 } from "@egds/react-core/mark";
import { UitkPriceLockupAlign as EGDSPriceLockupAlign2 } from "@egds/react-core/price-lockup";
import { EGDSSpacing as EGDSSpacing43 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading15, EGDSText as EGDSText30 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker24 } from "@shared-ui/clickstream-analytics-context";
import { PropertyPriceDocumentNode } from "@shared-ui/lodging-fragments";
import { PriceSummary } from "@shared-ui/pricing-price-summary";
// src/components/property-offers/__private/__fragments/reserve-button/prepare-checkout/property-lodging-prepare-checkout-experiment-component.tsx
import React82 from "react";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
// src/components/property-offers/__private/context/multi-item-context.tsx
import React80 from "react";
var initialMultiItemContext = {
  packageType: void 0,
  sessionId: void 0,
  handleMultiItemCallback: void 0,
  error: void 0,
  setDefaultError: void 0,
  setError: void 0
};
var MultiItemContext = React80.createContext(initialMultiItemContext);
var useMultiItemContext = function () {
  return React80.useContext(MultiItemContext);
};
var MultiItemProvider = function (param) {
  var children = param.children,
    defaultError = param.defaultError,
    multiItemContext = param.multiItemContext;
  var _React80_useState = _sliced_to_array(React80.useState(null), 2),
    error = _React80_useState[0],
    setErrorState = _React80_useState[1];
  var setDefaultError = function () {
    return setErrorState(defaultError);
  };
  var setError = function (errorMessage) {
    return setErrorState(errorMessage);
  };
  var finalMultiItemContext = _object_spread_props(_object_spread({}, multiItemContext), {
    error: error,
    setDefaultError: setDefaultError,
    setError: setError
  });
  return React80.useMemo(function () {
    return /* @__PURE__ */React80.createElement(MultiItemContext.Provider, {
      value: finalMultiItemContext
    }, children);
  }, [finalMultiItemContext]);
};
var setMultiItemContext = function (shoppingContext) {
  var _shoppingContext_multiItem, _shoppingContext_multiItem1;
  return {
    sessionId: shoppingContext === null || shoppingContext === void 0 ? void 0 : (_shoppingContext_multiItem = shoppingContext.multiItem) === null || _shoppingContext_multiItem === void 0 ? void 0 : _shoppingContext_multiItem.id,
    packageType: shoppingContext === null || shoppingContext === void 0 ? void 0 : (_shoppingContext_multiItem1 = shoppingContext.multiItem) === null || _shoppingContext_multiItem1 === void 0 ? void 0 : _shoppingContext_multiItem1.packageType
  };
};
// src/components/property-offers/__private/__fragments/reserve-button/property-lodging-form-button.tsx
import React81, { useContext as useContext3 } from "react";
import { gql as gql67 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize5, EGDSPrimaryButton as EGDSPrimaryButton6 } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex17 } from "@egds/react-core/layout-flex";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { ITrackType as ITrackType2, useClickstreamAnalytics as useClickstreamAnalytics2, useClickTracker as useClickTracker23 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment5 } from "@shared-ui/experiment-context";
import { AdaptExAnalyticsEventFragment as AdaptExAnalyticsEventFragment2, adaptToAdaptExSuccessEventSchema as adaptToAdaptExSuccessEventSchema2, lightweightAdaptExMicroMessage as lightweightAdaptExMicroMessage2, useAdaptExEvents as useAdaptExEvents2 } from "@shared-ui/lodging-fragments";
import { PropertyDetailsAdaptExContext as PropertyDetailsAdaptExContext2 } from "@shared-ui/lodging-property-details";
import { usePackageOperations as usePackageOperations2, useSessionOperations } from "@shared-ui/multi-item-operations-providers";
import { ProductGalleryContext as ProductGalleryContext2 } from "@shared-ui/retail-product-gallery";
// src/utils/hooks/use-url-path.ts
import { useLocation as useLocation2 } from "react-router-dom";
function useUrlPath() {
  var location = useLocation2();
  return location.pathname;
}
// src/components/property-offers/__private/__fragments/reserve-button/property-lodging-form-button.tsx
var fragment37 = gql67(_templateObject67(), AdaptExAnalyticsEventFragment2);
var getInputType = function (inputType) {
  return inputType ? inputType.toLowerCase() : "hidden";
};
var onSubmit = function (event) {
  var formRef = event.target;
  event.preventDefault();
  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(function () {
      formRef.submit();
    });
  });
};
var getInputValue2 = function (inputs, inputName) {
  var _inputs_filter_, _inputs_filter;
  var _inputs_filter__value;
  return (_inputs_filter__value = (_inputs_filter = inputs.filter(function (input) {
    return (input === null || input === void 0 ? void 0 : input.name) === inputName;
  })) === null || _inputs_filter === void 0 ? void 0 : (_inputs_filter_ = _inputs_filter[0]) === null || _inputs_filter_ === void 0 ? void 0 : _inputs_filter_.value) !== null && _inputs_filter__value !== void 0 ? _inputs_filter__value : void 0;
};
var getBusinessModel = function (hotelCollect) {
  return hotelCollect ? "HC" /* HC */ : "EC" /* EC */;
};
var omitTypename = function (key, value) {
  return key === "__typename" ? void 0 : value;
};
var PropertyLodgingFormButton = function (param) {
  var data = param.data,
    trackReserveButtonClick = param.trackReserveButtonClick,
    isFullWidth = param.isFullWidth,
    propertyNaturalKeys = param.propertyNaturalKeys,
    hotelCollect = param.hotelCollect,
    noCreditCard = param.noCreditCard,
    priceDetail = param.priceDetail,
    showLargeBtn = param.showLargeBtn,
    listingIndex = param.listingIndex;
  var formRef = React81.createRef();
  var _useMultiItemContext = useMultiItemContext(),
    packageType = _useMultiItemContext.packageType,
    sessionId = _useMultiItemContext.sessionId,
    handleMultiItemCallback = _useMultiItemContext.handleMultiItemCallback;
  var selectPackage = usePackageOperations2().selectPackage;
  var replaceProduct = useSessionOperations().replaceProduct;
  var currentPath = useUrlPath();
  var _useAdaptExEvents2 = useAdaptExEvents2(),
    offerAdaptExSuccessEvents = _useAdaptExEvents2.adaptExSuccessEvents;
  var context = useBexApi3().context;
  var action = data.action,
    inputs = data.inputs,
    method = data.method,
    submit = data.submit;
  var selectionEvent = "".concat(RECOMMENDATION_MODULE, ".").concat(MODULE_SELECTED);
  var setAdaptExSuccessEvent = useContext3(ProductGalleryContext2).setAdaptExSuccessEvent;
  var track = useClickTracker23();
  var _useClickstreamAnalytics2 = useClickstreamAnalytics2(),
    clickStreamTrack = _useClickstreamAnalytics2.track;
  var _useContext3 = _sliced_to_array(useContext3(PropertyDetailsAdaptExContext2), 1),
    adaptExState = _useContext3[0];
  var reserveAdaptExSuccessEvents = adaptExState.reserveAdaptExSuccessEvents;
  var submitText = submit.text,
    accessibilityLabel = submit.accessibilityLabel,
    _submit_adaptExSuccessEvents = submit.adaptExSuccessEvents,
    adaptExSuccessEvents = _submit_adaptExSuccessEvents === void 0 ? [] : _submit_adaptExSuccessEvents,
    lodgingRecommendationClickstreamEvent = submit.lodgingRecommendationClickstreamEvent,
    _submit_adaptExSuccessActionTracking = submit.adaptExSuccessActionTracking,
    adaptExSuccessActionTracking = _submit_adaptExSuccessActionTracking === void 0 ? [] : _submit_adaptExSuccessActionTracking;
  var _useAdaptExEvents21 = useAdaptExEvents2(adaptExSuccessActionTracking !== null && adaptExSuccessActionTracking !== void 0 ? adaptExSuccessActionTracking : []),
    otherActiveCampaignsAdaptExSuccessEvents = _useAdaptExEvents21.adaptExSuccessEvents;
  var _useExperiment5 = useExperiment5("Adaptex_campaign_PDP_mosaic_for_large_screens"),
    imageMosaicLargeScreensExposure = _useExperiment5.exposure;
  var _useExperiment51 = useExperiment5("Adaptex_campaign_PDP_mosaic_for_small_screens"),
    imageMosaicMWebExposure = _useExperiment51.exposure;
  var adaptexCampaignVariant = imageMosaicLargeScreensExposure.bucket === 1 || imageMosaicMWebExposure.bucket === 1;
  if (!(inputs === null || inputs === void 0 ? void 0 : inputs.length)) {
    return null;
  }
  var rateUpsell = getInputValue2(inputs, "rateUpsell") === "true";
  var roomUpsell = getInputValue2(inputs, "roomUpsell") === "true";
  var ratePlanDenseRank = getInputValue2(inputs, "ratePlanDenseRank");
  var additionalAmount = getInputValue2(inputs, "additionalAmount");
  var propertyUpsellAmount = getInputValue2(inputs, "propertyUpsellAmount");
  var roomUpgradeEligible = getInputValue2(inputs, "roomUpgradeEligible") === "true";
  var rateUpgradeEligible = getInputValue2(inputs, "rateUpgradeEligible") === "true";
  var roomTypeCode = getInputValue2(inputs, "roomTypeCode") || getInputValue2(inputs, "bookingRequest.items[0].roomTypeCode");
  var ratePlanCode = getInputValue2(inputs, "ratePlanCode") || getInputValue2(inputs, "bookingRequest.items[0].rateCode");
  var hotelID = getInputValue2(inputs, "hotelID") || getInputValue2(inputs, "bookingRequest.expediaPropertyId");
  var trackReserveAdaptExSuccessEvents = function () {
    if (reserveAdaptExSuccessEvents === null || reserveAdaptExSuccessEvents === void 0 ? void 0 : reserveAdaptExSuccessEvents.length) {
      reserveAdaptExSuccessEvents.forEach(function (reserveAdaptExSuccessEvent) {
        var _reserveAdaptExSuccessEvent_events_, _reserveAdaptExSuccessEvent_events_1, _reserveAdaptExSuccessEvent_events_2;
        clickStreamTrack(ITrackType2.EVENT, {
          data: lightweightAdaptExMicroMessage2({
            campaignId: reserveAdaptExSuccessEvent.campaignId,
            payloadId: ((_reserveAdaptExSuccessEvent_events_ = reserveAdaptExSuccessEvent.events[0]) === null || _reserveAdaptExSuccessEvent_events_ === void 0 ? void 0 : _reserveAdaptExSuccessEvent_events_.payloadId) || "",
            eventType: ((_reserveAdaptExSuccessEvent_events_1 = reserveAdaptExSuccessEvent.events[0]) === null || _reserveAdaptExSuccessEvent_events_1 === void 0 ? void 0 : _reserveAdaptExSuccessEvent_events_1.eventType) || "",
            eventTarget: ((_reserveAdaptExSuccessEvent_events_2 = reserveAdaptExSuccessEvent.events[0]) === null || _reserveAdaptExSuccessEvent_events_2 === void 0 ? void 0 : _reserveAdaptExSuccessEvent_events_2.eventTarget) || ""
          })
        });
      });
    }
  };
  var trackReserveButton = function () {
    if (hotelID) {
      track("HOT.HIS.RoomsAndRates.Upsell", "Click on reserve button", void 0, allRoomsSchema({
        additionalAmount: additionalAmount ? parseInt(additionalAmount, 10) : void 0,
        propertyId: hotelID,
        propertyUpsellAmount: propertyUpsellAmount ? parseInt(propertyUpsellAmount, 10) : void 0,
        rateUpsell: rateUpsell,
        ratePlanCode: ratePlanCode,
        ratePlanDenseRank: ratePlanDenseRank ? parseInt(ratePlanDenseRank, 10) : void 0,
        roomId: roomTypeCode,
        roomUpsell: roomUpsell,
        roomUpgradeEligible: roomUpgradeEligible,
        rateUpgradeEligible: rateUpgradeEligible
      }));
    }
    trackReserveButtonClick();
  };
  var handleSubmit = function (event) {
    if (adaptexCampaignVariant) {
      setAdaptExSuccessEvent("ADAPTEX_MOSAIC_VIEW_BOOKING_FORM_EVENT");
    }
    if (submit.analytics) {
      var _submit_analytics, _submit_analytics1;
      track((_submit_analytics = submit.analytics) === null || _submit_analytics === void 0 ? void 0 : _submit_analytics.referrerId, (_submit_analytics1 = submit.analytics) === null || _submit_analytics1 === void 0 ? void 0 : _submit_analytics1.linkName);
      if ((lodgingRecommendationClickstreamEvent === null || lodgingRecommendationClickstreamEvent === void 0 ? void 0 : lodgingRecommendationClickstreamEvent.recommendationResponseId) && ratePlanCode) {
        clickStreamTrack(ITrackType2.EVENT, {
          data: egRecommendationClickstreamBuilder(lodgingRecommendationClickstreamEvent.recommendationResponseId, ratePlanCode, selectionEvent, INTERACTION, listingIndex, submit.analytics)
        });
      }
    }
    trackReserveAdaptExSuccessEvents();
    _to_consumable_array(offerAdaptExSuccessEvents).concat(_to_consumable_array(adaptExSuccessEvents), _to_consumable_array(otherActiveCampaignsAdaptExSuccessEvents)).forEach(function (adaptExEvent) {
      clickStreamTrack(ITrackType2.EVENT, {
        data: adaptToAdaptExSuccessEventSchema2(_object_spread_props(_object_spread({}, adaptExEvent), {
          events: adaptExEvent.events
        }))
      });
    });
    if (handleMultiItemCallback && typeof handleMultiItemCallback === "function") {
      if (event && typeof event.preventDefault === "function") {
        event.preventDefault();
        track("MultiProp.Reserve", "Clicking on Reserve into multi property experiment");
        handleMultiItemCallback(propertyNaturalKeys, getBusinessModel(hotelCollect), noCreditCard, void 0, formRef);
      }
    } else {
      trackReserveButton();
    }
  };
  if (packageType) {
    var handlePackageSubmit = function () {
      var _ref = _async_to_generator(function (event) {
        var _priceDetail_action, variables, response, redirectUrl, _priceDetail_price, _priceDetail_dealMarker, _priceDetail_price1, multiItemProperties, variables1, response1, redirectUrl1;
        return _ts_generator(this, function (_state) {
          switch (_state.label) {
            case 0:
              if (event && typeof event.preventDefault === "function") {
                event.preventDefault();
              }
              if (adaptexCampaignVariant) {
                setAdaptExSuccessEvent("ADAPTEX_MOSAIC_VIEW_REVIEW_PAGE_EVENT");
              }
              trackReserveButton();
              if (!priceDetail) return [3, 5];
              if (!(((_priceDetail_action = priceDetail.action) === null || _priceDetail_action === void 0 ? void 0 : _priceDetail_action.__typename) === "SelectPackageActionInput" && sessionId && priceDetail.action.packageOfferId)) return [3, 2];
              variables = {
                context: context,
                multiItemSessionId: sessionId,
                packageOfferId: priceDetail.action.packageOfferId
              };
              return [4, selectPackage(variables, "PACKAGE_ADD")];
            case 1:
              response = _state.sent();
              if (response.success && response.data.multiItemShopping.selectPackage.__typename === "MultiItemSearchContextCreatedResponse") {
                redirectUrl = new URL(response.data.multiItemShopping.selectPackage.redirectUrl);
                if (currentPath !== redirectUrl.pathname) {
                  window.location.href = response.data.multiItemShopping.selectPackage.redirectUrl;
                }
              }
              return [3, 5];
            case 2:
              if (!handleMultiItemCallback) return [3, 3];
              handleMultiItemCallback(propertyNaturalKeys, void 0, void 0, (_priceDetail_price = priceDetail.price) === null || _priceDetail_price === void 0 ? void 0 : _priceDetail_price.multiItemPriceToken, void 0, (_priceDetail_dealMarker = priceDetail.dealMarker) !== null && _priceDetail_dealMarker !== void 0 ? _priceDetail_dealMarker : void 0);
              return [3, 5];
            case 3:
              multiItemProperties = priceDetail.propertyNaturalKeys;
              variables1 = {
                context: context,
                multiItemSessionId: sessionId !== null && sessionId !== void 0 ? sessionId : "",
                priceToken: (_priceDetail_price1 = priceDetail.price) === null || _priceDetail_price1 === void 0 ? void 0 : _priceDetail_price1.multiItemPriceToken,
                properties: JSON.parse(JSON.stringify(multiItemProperties), omitTypename)
              };
              return [4, replaceProduct(variables1, "REPLACE_PRODUCT")];
            case 4:
              response1 = _state.sent();
              if (response1.success && response1.data.multiItemShopping.selectProducts.__typename === "MultiItemSearchContextCreatedResponse") {
                redirectUrl1 = new URL(response1.data.multiItemShopping.selectProducts.redirectUrl);
                if (currentPath !== redirectUrl1.pathname) {
                  window.location.href = response1.data.multiItemShopping.selectProducts.redirectUrl;
                }
              }
              _state.label = 5;
            case 5:
              return [2];
          }
        });
      });
      return function handlePackageSubmit(event) {
        return _ref.apply(this, arguments);
      };
    }();
    return /* @__PURE__ */React81.createElement(EGDSPrimaryButton6, {
      size: showLargeBtn ? EGDSButtonSize5.LARGE : EGDSButtonSize5.MEDIUM,
      isFullWidth: isFullWidth,
      type: "submit",
      onClick: handlePackageSubmit,
      "data-stid": "submit-hotel-reserve",
      role: "link"
    }, /* @__PURE__ */React81.createElement(React81.Fragment, null, /* @__PURE__ */React81.createElement("span", {
      "aria-hidden": Boolean(accessibilityLabel)
    }, submitText), accessibilityLabel && /* @__PURE__ */React81.createElement("span", {
      className: "is-visually-hidden"
    }, accessibilityLabel)));
  }
  var reserveButtonBase = /* @__PURE__ */React81.createElement(EGDSPrimaryButton6, {
    size: EGDSButtonSize5.MEDIUM,
    isFullWidth: isFullWidth,
    type: "submit",
    onClick: handleSubmit,
    "data-stid": "submit-hotel-reserve",
    role: "link"
  }, /* @__PURE__ */React81.createElement(React81.Fragment, null, /* @__PURE__ */React81.createElement("span", {
    "aria-hidden": Boolean(accessibilityLabel)
  }, submitText), accessibilityLabel && /* @__PURE__ */React81.createElement("span", {
    className: "is-visually-hidden"
  }, accessibilityLabel)));
  var reserveButton = !isFullWidth ? /* @__PURE__ */React81.createElement(EGDSLayoutFlex17, {
    justifyContent: "end"
  }, reserveButtonBase) : reserveButtonBase;
  return /* @__PURE__ */React81.createElement("form", {
    action: action,
    method: method,
    ref: formRef,
    onSubmit: onSubmit,
    "data-stid": "property-lodging-form-button-form"
  }, inputs === null || inputs === void 0 ? void 0 : inputs.map(function (input, index) {
    return (input === null || input === void 0 ? void 0 : input.name) && (input === null || input === void 0 ? void 0 : input.value) && /* @__PURE__ */React81.createElement("input", {
      key: "formBtn-".concat(index),
      type: getInputType(input === null || input === void 0 ? void 0 : input.type),
      name: input === null || input === void 0 ? void 0 : input.name,
      value: input === null || input === void 0 ? void 0 : input.value
    });
  }), reserveButton);
};
PropertyLodgingFormButton.fragment = fragment37;
PropertyLodgingFormButton.displayName = "PropertyLodgingFormButton";
// src/components/property-offers/__private/__fragments/reserve-button/prepare-checkout/property-lodging-prepare-checkout-experiment-component.tsx
var Control = function (param) {
  var trackReserveButtonClick = param.trackReserveButtonClick,
    isFullWidth = param.isFullWidth,
    propertyNaturalKeys = param.propertyNaturalKeys,
    hotelCollect = param.hotelCollect,
    noCreditCard = param.noCreditCard,
    priceDetail = param.priceDetail,
    showLargeBtn = param.showLargeBtn,
    listingIndex = param.listingIndex,
    offerBookButton = param.offerBookButton;
  return /* @__PURE__ */React82.createElement(React82.Fragment, null, offerBookButton && /* @__PURE__ */React82.createElement(PropertyLodgingFormButton, {
    data: offerBookButton,
    isFullWidth: isFullWidth,
    trackReserveButtonClick: trackReserveButtonClick,
    propertyNaturalKeys: propertyNaturalKeys,
    noCreditCard: noCreditCard,
    hotelCollect: hotelCollect,
    priceDetail: priceDetail,
    showLargeBtn: showLargeBtn,
    listingIndex: listingIndex
  }));
};
var PropertyLodgingPrepareCheckoutComponent = function (props) {
  var packageType = useMultiItemContext().packageType;
  var isFullWidth = props.isFullWidth,
    lodgingPrepareCheckout = props.lodgingPrepareCheckout,
    propertyNaturalKeys = props.propertyNaturalKeys,
    offerBookButton = props.offerBookButton;
  var adaptExSuccessActionTracking = ((offerBookButton === null || offerBookButton === void 0 ? void 0 : offerBookButton.submit) || {}).adaptExSuccessActionTracking;
  return packageType ? /* @__PURE__ */React82.createElement(Control, _object_spread({}, props)) : /* @__PURE__ */React82.createElement(Experiment, {
    name: "Lodging_use_prepareCheckout_mutation"
  }, /* @__PURE__ */React82.createElement(ExperimentControl, null, /* @__PURE__ */React82.createElement(Control, _object_spread({}, props))), /* @__PURE__ */React82.createElement(ExperimentVariant, {
    bucket: 1
  }, lodgingPrepareCheckout && /* @__PURE__ */React82.createElement(PropertyLodgingPrepareCheckout, {
    isFullWidth: isFullWidth,
    data: lodgingPrepareCheckout,
    adaptExSuccessActionTracking: adaptExSuccessActionTracking !== null && adaptExSuccessActionTracking !== void 0 ? adaptExSuccessActionTracking : [],
    priceDetailsPropertyNaturalKeys: propertyNaturalKeys
  })));
};
PropertyLodgingPrepareCheckoutComponent.displayName = "PropertyLodgingFormButton";
// src/components/property-offers/__private/__fragments/reserve-button/dialog/property-payment-price.tsx
import React83 from "react";
import { gql as gql68 } from "@apollo/client";
import { UitkPriceLockup as EGDSPriceLockup, UitkPriceLockupAlign as EGDSPriceLockupAlign } from "@egds/react-core/price-lockup";
var fragment38 = gql68(_templateObject68());
var PropertyPaymentPrice = function (param) {
  var data = param.data,
    alignment = param.alignment;
  var _price_lead, _priceMessaging_, _priceMessaging_priceSubtextBoldIndex;
  var price = data.price;
  if (!(price === null || price === void 0 ? void 0 : (_price_lead = price.lead) === null || _price_lead === void 0 ? void 0 : _price_lead.formatted) || !(price === null || price === void 0 ? void 0 : price.options) || price.options.length === 0) {
    return null;
  }
  var priceMessaging = price.priceMessaging,
    lead = price.lead,
    options = price.options;
  var priceSubtextBoldIndex = (priceMessaging === null || priceMessaging === void 0 ? void 0 : priceMessaging.findIndex(function (msg) {
    return msg.theme === "STRONG" /* STRONG */;
  })) || -1;
  var priceSubtextStandardRawData = priceSubtextBoldIndex === -1 ? priceMessaging === null || priceMessaging === void 0 ? void 0 : priceMessaging.slice(1) : priceMessaging === null || priceMessaging === void 0 ? void 0 : priceMessaging.slice(1).splice(priceSubtextBoldIndex, 1);
  var priceSubtextStandard = priceSubtextStandardRawData === null || priceSubtextStandardRawData === void 0 ? void 0 : priceSubtextStandardRawData.map(function (msg) {
    return msg.value;
  });
  var priceProps = buildEGDSPriceLockupProps(options);
  return /* @__PURE__ */React83.createElement(EGDSPriceLockup, _object_spread_props(_object_spread({}, priceProps), {
    a11yPrice: lead.formatted || "",
    align: alignment !== null && alignment !== void 0 ? alignment : EGDSPriceLockupAlign.RIGHT,
    priceSubtextFirst: priceMessaging && priceMessaging.length > 0 ? (_priceMessaging_ = priceMessaging[0]) === null || _priceMessaging_ === void 0 ? void 0 : _priceMessaging_.value : "",
    stids: {
      subtextStandardId: "property-payment-price-standard-first"
    },
    priceSubtextStandard: priceSubtextStandard,
    priceSubtextBold: priceMessaging && priceMessaging.length > 0 && priceSubtextBoldIndex !== -1 ? (_priceMessaging_priceSubtextBoldIndex = priceMessaging[priceSubtextBoldIndex]) === null || _priceMessaging_priceSubtextBoldIndex === void 0 ? void 0 : _priceMessaging_priceSubtextBoldIndex.value : ""
  }));
};
var formatStrikeOutText = function (price, points, unit, leadingCaption, isPointsFirst) {
  if (!price && !points) {
    return void 0;
  }
  if (!points) {
    return price === null || price === void 0 ? void 0 : price.formatted;
  }
  if (!price) {
    return "".concat(points.formatted, " ").concat(unit);
  }
  if (isPointsFirst) {
    return "".concat(points.formatted, " ").concat(unit, " ").concat(leadingCaption, " ").concat(price.formatted);
  }
  return "".concat(price.formatted, " ").concat(leadingCaption, " ").concat(points.formatted, " ").concat(unit);
};
var buildEGDSPriceLockupProps = function (options) {
  var _loyaltyPoints_amount, _priceDisclaimer_trigger_icon, _priceDisclaimer_trigger;
  var _options = _sliced_to_array(options, 3),
    leadOption = _options[0],
    otherOption = _options[1],
    disclaimerForPoints = _options[2];
  var _ref = leadOption || {},
    leadingCaption = _ref.leadingCaption,
    loyaltyPrice = _ref.loyaltyPrice,
    displayPrice = _ref.displayPrice,
    accessibilityLabel = _ref.accessibilityLabel,
    priceDisclaimer = _ref.priceDisclaimer,
    strikeOut = _ref.strikeOut;
  if (options.length === 1 && loyaltyPrice) {
    var _loyaltyPrice_totalStrikeOutPoints, _loyaltyPrice_amount;
    var strikeThroughPoints = loyaltyPrice.totalStrikeOutPoints ? "".concat((_loyaltyPrice_totalStrikeOutPoints = loyaltyPrice.totalStrikeOutPoints) === null || _loyaltyPrice_totalStrikeOutPoints === void 0 ? void 0 : _loyaltyPrice_totalStrikeOutPoints.formatted, " ").concat(loyaltyPrice.unit) : "";
    return {
      isStrikeThroughFirst: true,
      lockupFormattedPoints: "".concat((_loyaltyPrice_amount = loyaltyPrice.amount) === null || _loyaltyPrice_amount === void 0 ? void 0 : _loyaltyPrice_amount.formatted, " ").concat(loyaltyPrice.unit),
      strikeThroughPrice: strikeThroughPoints,
      a11yPrice: accessibilityLabel || ""
    };
  }
  if (loyaltyPrice) {
    var _otherOption_displayPrice, _loyaltyPrice_amount1, _disclaimerForPoints_priceDisclaimer_trigger_icon, _disclaimerForPoints_priceDisclaimer_trigger, _disclaimerForPoints_priceDisclaimer;
    var moneyPrice = "".concat(otherOption === null || otherOption === void 0 ? void 0 : otherOption.leadingCaption, " ").concat(otherOption === null || otherOption === void 0 ? void 0 : (_otherOption_displayPrice = otherOption.displayPrice) === null || _otherOption_displayPrice === void 0 ? void 0 : _otherOption_displayPrice.formatted);
    return {
      isStrikeThroughFirst: true,
      isPointsFirst: true,
      lockupPrice: moneyPrice,
      lockupFormattedPoints: "".concat((_loyaltyPrice_amount1 = loyaltyPrice.amount) === null || _loyaltyPrice_amount1 === void 0 ? void 0 : _loyaltyPrice_amount1.formatted, " ").concat(loyaltyPrice.unit),
      a11yPrice: (otherOption === null || otherOption === void 0 ? void 0 : otherOption.accessibilityLabel) || "",
      strikeThroughPrice: formatStrikeOutText(disclaimerForPoints === null || disclaimerForPoints === void 0 ? void 0 : disclaimerForPoints.strikeOut, loyaltyPrice.totalStrikeOutPoints, loyaltyPrice.unit, otherOption === null || otherOption === void 0 ? void 0 : otherOption.leadingCaption, true),
      a11yStrikeThroughDialogTrigger: disclaimerForPoints === null || disclaimerForPoints === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer = disclaimerForPoints.priceDisclaimer) === null || _disclaimerForPoints_priceDisclaimer === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer_trigger = _disclaimerForPoints_priceDisclaimer.trigger) === null || _disclaimerForPoints_priceDisclaimer_trigger === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer_trigger_icon = _disclaimerForPoints_priceDisclaimer_trigger.icon) === null || _disclaimerForPoints_priceDisclaimer_trigger_icon === void 0 ? void 0 : _disclaimerForPoints_priceDisclaimer_trigger_icon.description
    };
  }
  var leadPrice = leadingCaption ? "".concat(leadingCaption, " ").concat(displayPrice === null || displayPrice === void 0 ? void 0 : displayPrice.formatted) : displayPrice === null || displayPrice === void 0 ? void 0 : displayPrice.formatted;
  if (options.length === 1) {
    var _priceDisclaimer_trigger_icon1, _priceDisclaimer_trigger1;
    return {
      lockupPrice: leadPrice,
      a11yPrice: accessibilityLabel || "",
      strikeThroughPrice: strikeOut === null || strikeOut === void 0 ? void 0 : strikeOut.formatted,
      a11yStrikeThroughDialogTrigger: priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_trigger1 = priceDisclaimer.trigger) === null || _priceDisclaimer_trigger1 === void 0 ? void 0 : (_priceDisclaimer_trigger_icon1 = _priceDisclaimer_trigger1.icon) === null || _priceDisclaimer_trigger_icon1 === void 0 ? void 0 : _priceDisclaimer_trigger_icon1.description
    };
  }
  var loyaltyPoints = otherOption === null || otherOption === void 0 ? void 0 : otherOption.loyaltyPrice;
  return {
    isStrikeThroughFirst: true,
    isPointsFirst: false,
    strikeThroughPrice: formatStrikeOutText(strikeOut, loyaltyPoints === null || loyaltyPoints === void 0 ? void 0 : loyaltyPoints.totalStrikeOutPoints, loyaltyPoints === null || loyaltyPoints === void 0 ? void 0 : loyaltyPoints.unit, otherOption === null || otherOption === void 0 ? void 0 : otherOption.leadingCaption, false),
    lockupPrice: leadPrice,
    lockupFormattedPoints: "".concat(otherOption === null || otherOption === void 0 ? void 0 : otherOption.leadingCaption, " ").concat(loyaltyPoints === null || loyaltyPoints === void 0 ? void 0 : (_loyaltyPoints_amount = loyaltyPoints.amount) === null || _loyaltyPoints_amount === void 0 ? void 0 : _loyaltyPoints_amount.formatted, " ").concat(loyaltyPoints === null || loyaltyPoints === void 0 ? void 0 : loyaltyPoints.unit),
    a11yStrikeThroughDialogTrigger: priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_trigger = priceDisclaimer.trigger) === null || _priceDisclaimer_trigger === void 0 ? void 0 : (_priceDisclaimer_trigger_icon = _priceDisclaimer_trigger.icon) === null || _priceDisclaimer_trigger_icon === void 0 ? void 0 : _priceDisclaimer_trigger_icon.description,
    a11yPrice: accessibilityLabel || ""
  };
};
PropertyPaymentPrice.fragment = fragment38;
PropertyPaymentPrice.displayName = "PropertyPaymentPrice";
// src/components/property-offers/__private/__fragments/reserve-button/dialog/property-payment-options.tsx
var fragment39 = gql69(_templateObject69(), PropertyLodgingPrepareCheckout.fragment, PropertyLodgingFormButton.fragment, PropertyPaymentPrice.fragment, PropertyPriceDocumentNode);
var _obj2;
var propertyPaymentTypeToModel = (_obj2 = {}, _define_property(_obj2, "PAY_LATER" /* PAY_LATER */, "PAY_LATER" /* PAY_LATER */), _define_property(_obj2, "PAY_LATER_WITH_DEPOSIT" /* PAY_LATER_WITH_DEPOSIT */, "PAY_LATER_WITH_DEPOSIT" /* PAY_LATER_WITH_DEPOSIT */), _define_property(_obj2, "PAY_NOW" /* PAY_NOW */, "PAY_NOW" /* PAY_NOW */), _obj2);
var trackPaymentOptionClickInEtpDialog = function (param) {
  var noCreditCard = param.noCreditCard,
    paymentModel = param.paymentModel,
    propertyNaturalKeys = param.propertyNaturalKeys,
    track = param.track;
  var LINK_NAME2 = "Book selected room choice";
  var RFRR_MRP_PREFIX2 = "HOT.HIS.MRP.RoomsAndRates.";
  var _propertyNaturalKeys = _sliced_to_array(propertyNaturalKeys, 1),
    _propertyNaturalKeys_ = _propertyNaturalKeys[0],
    ratePlanId = _propertyNaturalKeys_.ratePlanId,
    roomTypeId = _propertyNaturalKeys_.roomTypeId;
  var uisMicroMessage = roomSchema(roomTypeId, [{
    ratePlanCode: ratePlanId
  }]);
  var paymentRfrr;
  if (paymentModel === "PAY_LATER" /* PAY_LATER */) {
    paymentRfrr = "PayLater";
  } else if (paymentModel === "PAY_LATER_WITH_DEPOSIT" /* PAY_LATER_WITH_DEPOSIT */) {
    paymentRfrr = "PayDeposit";
  } else if (noCreditCard) {
    paymentRfrr = "NoCreditCardRequired";
  } else {
    paymentRfrr = "PayNow";
  }
  track("".concat(RFRR_MRP_PREFIX2).concat(paymentRfrr), LINK_NAME2, void 0, [uisMicroMessage]);
};
var stidGenerator = function (items) {
  return items.map(function (i) {
    return i.text;
  }).join("-").toLowerCase();
};
var findIcon = function (items) {
  return items.find(function (i) {
    return i.icon;
  });
};
var getListBulletType = function (items) {
  return findIcon(items) ? "icon-alternate" : "default";
};
var HandleCompatibilityCase = function (param) {
  var heading = param.heading,
    items = param.items,
    mktDescIndex = param.mktDescIndex;
  return heading && /* @__PURE__ */React84.createElement(React84.Fragment, null, /* @__PURE__ */React84.createElement(EGDSSpacing43, {
    padding: {
      blockstart: "three"
    },
    key: "policy_description_0"
  }, /* @__PURE__ */React84.createElement(EGDSHeading15, {
    tag: "h3",
    size: 7
  }, heading)), /* @__PURE__ */React84.createElement(EGDSList5, {
    bullet: getListBulletType(items),
    size: 3,
    "data-stid": stidGenerator(items)
  }, items === null || items === void 0 ? void 0 : items.map(function (param, mktDescItemIndex) {
    var text = param.text,
      icon = param.icon;
    return /* @__PURE__ */React84.createElement(EGDSListItem8, {
      key: "policy_".concat(mktDescIndex, "_").concat(mktDescItemIndex),
      "data-stid": "pppdescr-".concat(icon === null || icon === void 0 ? void 0 : icon.token)
    }, icon && /* @__PURE__ */React84.createElement(EGDSIcon23, {
      name: icon.id,
      className: "pppdescr-".concat(icon.token)
    }), /* @__PURE__ */React84.createElement(EGDSText30, null, text));
  })));
};
var PropertyPaymentPolicyDescriptions = function (param) {
  var descriptions = param.descriptions;
  return descriptions.map(function (param, mktDescIndex) {
    var header = param.header,
      heading = param.heading,
      items = param.items;
    var _header_mark_url, _header_mark, _header_mark1;
    return !header ? /* @__PURE__ */React84.createElement(HandleCompatibilityCase, {
      heading: heading,
      items: items,
      mktDescIndex: mktDescIndex,
      key: "policy_description_".concat(mktDescIndex)
    }) : /* @__PURE__ */React84.createElement(EGDSSpacing43, {
      key: "policy_description_".concat(mktDescIndex)
    }, /* @__PURE__ */React84.createElement(EGDSList5, {
      bullet: getListBulletType(items),
      size: 3,
      "data-stid": stidGenerator(items)
    }, header && /* @__PURE__ */React84.createElement(EGDSListItem8, {
      key: "policy_-_".concat(mktDescIndex)
    }, /* @__PURE__ */React84.createElement(EGDSMark4, {
      url: (_header_mark = header.mark) === null || _header_mark === void 0 ? void 0 : (_header_mark_url = _header_mark.url) === null || _header_mark_url === void 0 ? void 0 : _header_mark_url.value,
      name: (_header_mark1 = header.mark) === null || _header_mark1 === void 0 ? void 0 : _header_mark1.id,
      size: EGDSMarkSize5.SMALL
    }), /* @__PURE__ */React84.createElement(EGDSHeading15, {
      tag: "h3",
      size: 7
    }, header.text)), items === null || items === void 0 ? void 0 : items.map(function (param, mktDescItemIndex) {
      var text = param.text,
        icon = param.icon;
      return /* @__PURE__ */React84.createElement(EGDSListItem8, {
        key: "policy_".concat(mktDescIndex, "_").concat(mktDescItemIndex),
        "data-stid": "pppdescr-".concat(icon === null || icon === void 0 ? void 0 : icon.token)
      }, icon && /* @__PURE__ */React84.createElement(EGDSIcon23, {
        name: icon.id,
        className: "pppdescr-".concat(icon.token)
      }), /* @__PURE__ */React84.createElement(EGDSText30, null, text));
    })));
  });
};
var PropertyPaymentOptions = function (param) {
  var data = param.data,
    paymentPolicy = param.paymentPolicy,
    paymentModel = param.paymentModel,
    propertyNaturalKeys = param.propertyNaturalKeys,
    hotelCollect = param.hotelCollect,
    noCreditCard = param.noCreditCard,
    listingIndex = param.listingIndex;
  var _propertyPaymentPolicy_descriptions;
  var loyaltyMessage = data.loyaltyMessage,
    offerBookButton = data.offerBookButton,
    lodgingPrepareCheckout = data.lodgingPrepareCheckout;
  var propertyPaymentPolicy = paymentPolicy === null || paymentPolicy === void 0 ? void 0 : paymentPolicy.find(function (policy) {
    return propertyPaymentTypeToModel[policy === null || policy === void 0 ? void 0 : policy.paymentType] === paymentModel;
  });
  var firstPolicy = propertyPaymentPolicy === null || propertyPaymentPolicy === void 0 ? void 0 : (_propertyPaymentPolicy_descriptions = propertyPaymentPolicy.descriptions) === null || _propertyPaymentPolicy_descriptions === void 0 ? void 0 : _propertyPaymentPolicy_descriptions.find(function (element) {
    return element;
  });
  var track = useClickTracker24();
  var trackReserveButtonClick = function () {
    return trackPaymentOptionClickInEtpDialog({
      noCreditCard: noCreditCard,
      paymentModel: paymentModel,
      propertyNaturalKeys: propertyNaturalKeys,
      track: track
    });
  };
  var RewardsDescriptionList = function () {
    var list = React84.useMemo(function () {
      var _propertyPaymentPolicy_descriptions;
      return propertyPaymentPolicy === null || propertyPaymentPolicy === void 0 ? void 0 : (_propertyPaymentPolicy_descriptions = propertyPaymentPolicy.descriptions) === null || _propertyPaymentPolicy_descriptions === void 0 ? void 0 : _propertyPaymentPolicy_descriptions.filter(function (description, index) {
        return (description === null || description === void 0 ? void 0 : description.items) && index > 0;
      });
    }, []);
    if (list === void 0) {
      return [];
    }
    return list;
  };
  var isRewardEligible = function () {
    return RewardsDescriptionList().length > 0;
  };
  var propertyPaymentPolicyHeader = function () {
    var _firstPolicy_items;
    return /* @__PURE__ */React84.createElement("div", null, (propertyPaymentPolicy === null || propertyPaymentPolicy === void 0 ? void 0 : propertyPaymentPolicy.heading) && /* @__PURE__ */React84.createElement(EGDSHeading15, {
      tag: "h4",
      size: 7
    }, propertyPaymentPolicy === null || propertyPaymentPolicy === void 0 ? void 0 : propertyPaymentPolicy.heading), !(!(firstPolicy === null || firstPolicy === void 0 ? void 0 : (_firstPolicy_items = firstPolicy.items) === null || _firstPolicy_items === void 0 ? void 0 : _firstPolicy_items.length) && !(loyaltyMessage === null || loyaltyMessage === void 0 ? void 0 : loyaltyMessage.value)) && /* @__PURE__ */React84.createElement(EGDSList5, {
      className: "uitk-type-list-300",
      "data-stid": "payment-options-details"
    }, firstPolicy === null || firstPolicy === void 0 ? void 0 : firstPolicy.items.map(function (item, descItemIndex) {
      return item && /* @__PURE__ */React84.createElement(PropertyInfoMessage, {
        index: descItemIndex,
        textSize: 300,
        markSize: EGDSMarkSize5.SMALL,
        data: item
      });
    })));
  };
  var priceDisplayAndRewardsDescription = function () {
    var _propertyPaymentPolicy_price_displayMessages, _propertyPaymentPolicy_price;
    var justifyContentClass = isRewardEligible() ? "space-between" : "end";
    return /* @__PURE__ */React84.createElement(EGDSLayoutFlex18, {
      direction: "row",
      justifyContent: justifyContentClass,
      space: "four",
      wrap: "nowrap"
    }, isRewardEligible() && /* @__PURE__ */React84.createElement(EGDSLayoutFlexItem13, null, /* @__PURE__ */React84.createElement(PropertyPaymentPolicyDescriptions, {
      descriptions: RewardsDescriptionList()
    })), /* @__PURE__ */React84.createElement(EGDSLayoutFlexItem13, {
      alignSelf: "end"
    }, /* @__PURE__ */React84.createElement("div", null, (propertyPaymentPolicy === null || propertyPaymentPolicy === void 0 ? void 0 : (_propertyPaymentPolicy_price = propertyPaymentPolicy.price) === null || _propertyPaymentPolicy_price === void 0 ? void 0 : (_propertyPaymentPolicy_price_displayMessages = _propertyPaymentPolicy_price.displayMessages) === null || _propertyPaymentPolicy_price_displayMessages === void 0 ? void 0 : _propertyPaymentPolicy_price_displayMessages.length) ? /* @__PURE__ */React84.createElement(PriceSummary, {
      data: propertyPaymentPolicy.price,
      flexAlignment: "end"
    }) : /* @__PURE__ */React84.createElement(PropertyPaymentPrice, {
      data: data,
      alignment: EGDSPriceLockupAlign2.RIGHT
    }))));
  };
  return /* @__PURE__ */React84.createElement(EGDSLayoutFlex18, {
    blockSize: "full_size"
  }, /* @__PURE__ */React84.createElement(EGDSSpacing43, {
    padding: "four"
  }, /* @__PURE__ */React84.createElement(EGDSLayoutFlexItem13, {
    minWidth: "full_width"
  }, /* @__PURE__ */React84.createElement(EGDSCard12, {
    border: true
  }, /* @__PURE__ */React84.createElement(EGDSLayoutFlex18, {
    direction: "column",
    "data-stid": "payment-options"
  }, /* @__PURE__ */React84.createElement(EGDSLayoutFlexItem13, {
    grow: 1
  }, /* @__PURE__ */React84.createElement("div", null, propertyPaymentPolicyHeader())), /* @__PURE__ */React84.createElement(EGDSSpacing43, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React84.createElement(EGDSLayoutFlexItem13, {
    grow: 0
  }, /* @__PURE__ */React84.createElement("div", {
    "data-stid": "payment-option-".concat(paymentModel)
  }, /* @__PURE__ */React84.createElement(EGDSSpacing43, {
    padding: {
      blockend: "three"
    }
  }, priceDisplayAndRewardsDescription()), /* @__PURE__ */React84.createElement(PropertyLodgingPrepareCheckoutComponent, {
    isFullWidth: true,
    lodgingPrepareCheckout: lodgingPrepareCheckout,
    offerBookButton: offerBookButton,
    propertyNaturalKeys: propertyNaturalKeys,
    hotelCollect: hotelCollect,
    noCreditCard: noCreditCard,
    trackReserveButtonClick: trackReserveButtonClick,
    listingIndex: listingIndex
  })))))))));
};
PropertyPaymentOptions.fragment = fragment39;
PropertyPaymentOptions.displayName = "PropertyPaymentOptions";
// src/components/property-offers/__private/__fragments/reserve-button/property-reserve-button.tsx
var fragment40 = gql70(_templateObject70(), AdaptExAnalyticsEventFragment3, LodgingEGDSGraphicText.fragment, PropertyLodgingFormButton.fragment, MessageResult2.fragment, PropertyPaymentOptions.fragment, LodgingSignInDialog.fragment, DatelessCheckAvailability.fragment, ChangeOfferCallToAction.fragment);
var LINK_NAME = "Book selected room choice";
var RFRR_MRP_PREFIX = "HOT.HIS.MRP";
var RFRR_PREFIX = "HOT.HIS" /* Infosite */;
var START_DATE_REF_NAME2 = "startDate";
var RFRR_RECOMMENDED = "HOT.HIS.MRP.RoomsAndRates.BookButton.Recommended";
var LINK_NAME_RECOMMENDED = "Recommended room reserve button";
var trackReserveClickToCheckout = function (param) {
  var noCreditCard = param.noCreditCard,
    rfrrSuffix = param.rfrrSuffix,
    trackClick = param.trackClick,
    hasRecommendation = param.hasRecommendation,
    analyticsList = param.analyticsList,
    moreDetailsAnalyticsList = param.moreDetailsAnalyticsList,
    isWithinDetailsDialog = param.isWithinDetailsDialog;
  if (hasRecommendation) {
    trackClick(RFRR_RECOMMENDED, LINK_NAME_RECOMMENDED);
  }
  if (noCreditCard) {
    trackClick("".concat(RFRR_MRP_PREFIX, ".").concat(rfrrSuffix, ".NoCreditCardRequired"), LINK_NAME);
  }
  if (isWithinDetailsDialog) {
    if (moreDetailsAnalyticsList) {
      track_analytics_list_default(trackClick, moreDetailsAnalyticsList);
    }
  } else if (analyticsList) {
    track_analytics_list_default(trackClick, analyticsList);
  }
};
var trackEtpDialogButtonClick = function (param) {
  var isPayLater = param.isPayLater,
    isPayWithDeposit = param.isPayWithDeposit,
    noCreditCard = param.noCreditCard,
    rfrrSuffix = param.rfrrSuffix,
    trackClick = param.trackClick,
    trackEgClickstream = param.trackEgClickstream,
    hasRecommendation = param.hasRecommendation;
  if (hasRecommendation) {
    trackClick(RFRR_RECOMMENDED, LINK_NAME_RECOMMENDED);
  }
  if (isPayLater || isPayWithDeposit) {
    var paymentOption = isPayLater ? "PAY_LATER" /* PAY_LATER */ : "PAY_LATER_WITH_DEPOSIT" /* PAY_LATER_WITH_DEPOSIT */;
    trackClick("".concat(RFRR_PREFIX, ".").concat(rfrrSuffix, ".OpenEtpDialog"), "User opening payment options dialog");
    trackClick("".concat(RFRR_PREFIX, ".").concat(rfrrSuffix, ".EtpDialogOption.").concat(paymentOption), "User opened etp modal with ".concat(paymentOption, " option"));
    if (noCreditCard) {
      trackClick("".concat(RFRR_PREFIX, ".").concat(rfrrSuffix, ".EtpDialogOption.noCCRequired"), "User opened etp modal with noCCRequired option");
    }
    trackEgClickstream(clickstreamPresentedEventBuilder("expedia_traveler_preference_dialog" /* ETP */, "Product Details" /* PRODUCT_DETAILS */, "PDP" /* PDP */));
  }
};
var PropertyReserveButton = function (param) {
  var data = param.data,
    dialogSuffix = param.dialogSuffix,
    isEtpCallToActionDisabled = param.isEtpCallToActionDisabled,
    isFullWidth = param.isFullWidth,
    listingIndex = param.listingIndex,
    paymentPolicy = param.paymentPolicy,
    rfrrSuffix = param.rfrrSuffix,
    showLargeBtn = param.showLargeBtn,
    onClose = param.onClose;
  var ratePlanId = data.id,
    priceDetails = data.priceDetails,
    reserveCallToAction = data.reserveCallToAction;
  var isWithinDetailsDialog = React85.useContext(DialogContext7);
  var dialogPostfix = useDialogId9();
  var _useDialog14 = _sliced_to_array(useDialog14("payment-".concat(dialogPostfix), "pwaPaymentDialog"), 3),
    isPaymentDialogOpen = _useDialog14[0],
    paymentDialogActions = _useDialog14[1],
    PaymentDialogComponent = _useDialog14[2];
  var trackEgClickstream = useEgClickstream8();
  var hasRecommendation = React85.useContext(UnitRateContext).hasRecommendation;
  var paymentOptionsTrigger = React85.useRef(null);
  var trackClick = useClickTracker25();
  var _useExperiment6 = useExperiment6("Add_Currency_Code_to_Deposit_option_on_ETP_Web"),
    addCurrencyCodeToDepositOptionOnETPWebExposure = _useExperiment6.exposure,
    addCurrencyCodeToDepositOptionOnETPWebLogger = _useExperiment6.logExperiment;
  var _useExperiment61 = useExperiment6("ETP_Dynamic_Optimisation_via_Adaptex"),
    etpDynamicOptimisationViaAdaptexExposure = _useExperiment61.exposure,
    etpDynamicOptimisationViaAdaptexLogger = _useExperiment61.logExperiment;
  var adaptExAttemptEvents;
  if ((reserveCallToAction === null || reserveCallToAction === void 0 ? void 0 : reserveCallToAction.__typename) === "EtpDialog" && !isEtpCallToActionDisabled) {
    var etpDialogFragment = reserveCallToAction;
    var trigger = etpDialogFragment.trigger;
    adaptExAttemptEvents = trigger.adaptExAttemptEvents;
  }
  var _useClickstreamAnalytics3 = useClickstreamAnalytics3(),
    clickStreamTrack = _useClickstreamAnalytics3.track;
  useEffect6(function () {
    if (isPaymentDialogOpen && adaptExAttemptEvents) {
      etpDynamicOptimisationViaAdaptexLogger(etpDynamicOptimisationViaAdaptexExposure);
      adaptExAttemptEvents.forEach(function (adaptExAttemptEvent) {
        clickStreamTrack(ITrackType3.EVENT, {
          data: adaptToAdaptExSuccessEventSchema3(_object_spread_props(_object_spread({}, adaptExAttemptEvent), {
            events: [adaptExAttemptEvent.events[0]]
          }))
        });
      });
    }
  }, [isPaymentDialogOpen]);
  var priceDetail = priceDetails[0];
  if (priceDetail === null || priceDetail === void 0 ? void 0 : priceDetail.changeOfferCallToAction) {
    return /* @__PURE__ */React85.createElement(ChangeOfferCallToAction, {
      data: priceDetail.changeOfferCallToAction,
      isFullWidth: isFullWidth
    });
  }
  if (!reserveCallToAction) {
    return null;
  }
  var hasMultiplePaymentTypes = priceDetails && priceDetails.length > 1;
  var isPayWithDeposit = hasMultiplePaymentTypes && priceDetails.some(function (it) {
    return it.paymentModel === "PAY_LATER_WITH_DEPOSIT" /* PAY_LATER_WITH_DEPOSIT */;
  });
  var isPayLater = hasMultiplePaymentTypes && priceDetails.some(function (it) {
    return it.paymentModel === "PAY_LATER" /* PAY_LATER */;
  });
  var isNoCC = hasMultiplePaymentTypes && priceDetails.some(function (it) {
    return it.noCreditCard;
  });
  var closePaymentDialog = function () {
    paymentDialogActions.closeDialog();
    trackClick("".concat(RFRR_PREFIX, ".EtpDialog.Close"), "close payment options dialog");
    var focusElem = paymentOptionsTrigger === null || paymentOptionsTrigger === void 0 ? void 0 : paymentOptionsTrigger.current;
    if (focusElem && typeof focusElem.focus === "function") {
      focusElem.focus();
    }
  };
  var openPaymentDialog = function () {
    paymentDialogActions.openDialog();
    if (isPayWithDeposit) {
      addCurrencyCodeToDepositOptionOnETPWebLogger(addCurrencyCodeToDepositOptionOnETPWebExposure);
    }
    trackEtpDialogButtonClick({
      isPayLater: isPayLater,
      isPayWithDeposit: isPayWithDeposit,
      noCreditCard: isNoCC,
      rfrrSuffix: rfrrSuffix,
      trackClick: trackClick,
      trackEgClickstream: trackEgClickstream,
      hasRecommendation: hasRecommendation
    });
  };
  var renderETPContent = function () {
    var _etpDialogFragment_content, _etpDialogFragment_content_messages, _etpDialogFragment_content1;
    var propertyPaymentOptionsColSpan = priceDetails.length > 1 ? {
      small: 2,
      medium: 1
    } : 2;
    var etpDialogFragment;
    if ((reserveCallToAction === null || reserveCallToAction === void 0 ? void 0 : reserveCallToAction.__typename) === "EtpDialog" && !isEtpCallToActionDisabled) {
      etpDialogFragment = reserveCallToAction;
    }
    return /* @__PURE__ */React85.createElement(React85.Fragment, null, /* @__PURE__ */React85.createElement(EGDSSpacing44, {
      padding: {
        blockend: "two"
      }
    }, /* @__PURE__ */React85.createElement(EGDSLayoutGridItem11, {
      colSpan: 2
    }, (etpDialogFragment === null || etpDialogFragment === void 0 ? void 0 : (_etpDialogFragment_content = etpDialogFragment.content) === null || _etpDialogFragment_content === void 0 ? void 0 : _etpDialogFragment_content.messages) && /* @__PURE__ */React85.createElement("div", null, etpDialogFragment === null || etpDialogFragment === void 0 ? void 0 : (_etpDialogFragment_content1 = etpDialogFragment.content) === null || _etpDialogFragment_content1 === void 0 ? void 0 : (_etpDialogFragment_content_messages = _etpDialogFragment_content1.messages) === null || _etpDialogFragment_content_messages === void 0 ? void 0 : _etpDialogFragment_content_messages.map(function (etpMessage, etpMessageIndex) {
      var __typename = etpMessage.__typename,
        text = etpMessage.text,
        graphic = etpMessage.graphic;
      return etpMessage && /* @__PURE__ */React85.createElement(EGDSSpacing44, {
        padding: {
          block: "one"
        },
        key: "etp-message-".concat(etpMessageIndex)
      }, /* @__PURE__ */React85.createElement("div", null, /* @__PURE__ */React85.createElement(LodgingEGDSGraphicText, {
        key: "etp-message-".concat(etpMessageIndex),
        data: {
          __typename: __typename,
          text: text,
          graphic: graphic,
          accessibility: null
        },
        customTextSize: 300
      })));
    })))), priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.map(function (pd, priceDetailIndex) {
      return pd && /* @__PURE__ */React85.createElement(EGDSLayoutGridItem11, {
        colSpan: propertyPaymentOptionsColSpan,
        key: "price-details-".concat(priceDetailIndex)
      }, /* @__PURE__ */React85.createElement("div", null, /* @__PURE__ */React85.createElement(PropertyPaymentOptions, {
        data: pd,
        paymentPolicy: paymentPolicy,
        paymentModel: pd === null || pd === void 0 ? void 0 : pd.paymentModel,
        propertyNaturalKeys: pd.propertyNaturalKeys,
        hotelCollect: pd.hotelCollect,
        noCreditCard: pd.noCreditCard,
        listingIndex: listingIndex
      })));
    }));
  };
  if ((reserveCallToAction === null || reserveCallToAction === void 0 ? void 0 : reserveCallToAction.__typename) === "LodgingMemberSignInDialog") {
    return /* @__PURE__ */React85.createElement(LodgingSignInDialog, {
      data: reserveCallToAction,
      showLargeBtn: showLargeBtn,
      isFullWidth: isFullWidth,
      dialogId: "lodging-signin-dialog-".concat(ratePlanId, "-").concat(dialogSuffix)
    });
  }
  if ((reserveCallToAction === null || reserveCallToAction === void 0 ? void 0 : reserveCallToAction.__typename) === "DatelessCheckAvailability") {
    return /* @__PURE__ */React85.createElement(DatelessCheckAvailability, {
      data: reserveCallToAction,
      clickRefTarget: START_DATE_REF_NAME2,
      onClose: onClose
    });
  }
  if ((reserveCallToAction === null || reserveCallToAction === void 0 ? void 0 : reserveCallToAction.__typename) === "EtpDialog" && !isEtpCallToActionDisabled) {
    var _toolbar_icon, _toolbar_icon1;
    var etpDialogFragment1 = reserveCallToAction;
    var trigger1 = etpDialogFragment1.trigger,
      toolbar = etpDialogFragment1.toolbar;
    var sheetProps = {
      isVisible: isPaymentDialogOpen,
      triggerRef: paymentOptionsTrigger,
      returnFocusOnClose: true
    };
    var _toolbar_title, _toolbar_title1;
    return /* @__PURE__ */React85.createElement(React85.Fragment, null, /* @__PURE__ */React85.createElement(EGDSPrimaryButton7, {
      size: showLargeBtn ? EGDSButtonSize6.LARGE : EGDSButtonSize6.MEDIUM,
      onClick: openPaymentDialog,
      isFullWidth: isFullWidth,
      domRef: paymentOptionsTrigger,
      "data-stid": "submit-hotel-reserve"
    }, /* @__PURE__ */React85.createElement(React85.Fragment, null, (trigger1 === null || trigger1 === void 0 ? void 0 : trigger1.accessibilityLabel) && /* @__PURE__ */React85.createElement("span", {
      className: "is-visually-hidden"
    }, trigger1.accessibilityLabel), /* @__PURE__ */React85.createElement("span", {
      "aria-hidden": (trigger1 === null || trigger1 === void 0 ? void 0 : trigger1.accessibilityLabel) !== null
    }, trigger1 === null || trigger1 === void 0 ? void 0 : trigger1.value))), /* @__PURE__ */React85.createElement(EGDSSheetTransition12, {
      isVisible: sheetProps.isVisible
    }, /* @__PURE__ */React85.createElement(EGDSSheetTransition12, {
      isVisible: isPaymentDialogOpen
    }, /* @__PURE__ */React85.createElement(PaymentDialogComponent, null, /* @__PURE__ */React85.createElement(Viewport9, null, /* @__PURE__ */React85.createElement(ViewSmall9, null, /* @__PURE__ */React85.createElement(EGDSSheet10, _object_spread_props(_object_spread({}, sheetProps), {
      type: "full"
    }), /* @__PURE__ */React85.createElement(EGDSToolbar9, {
      toolbarTitle: (_toolbar_title = toolbar === null || toolbar === void 0 ? void 0 : toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
      navigationContent: {
        onClick: closePaymentDialog,
        navIconLabel: toolbar === null || toolbar === void 0 ? void 0 : (_toolbar_icon = toolbar.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description
      }
    }), /* @__PURE__ */React85.createElement(EGDSSpacing44, {
      padding: {
        blockstart: "one",
        blockend: "three",
        inline: "three"
      }
    }, /* @__PURE__ */React85.createElement(EGDSSheetContent6, {
      padded: false
    }, /* @__PURE__ */React85.createElement(EGDSLayoutGrid12, {
      columns: 1,
      space: {
        row: "three"
      },
      "data-stid": "content-payment-options"
    }, renderETPContent()))))), /* @__PURE__ */React85.createElement(ViewMedium7, null, /* @__PURE__ */React85.createElement(EGDSSheet10, _object_spread_props(_object_spread({}, sheetProps), {
      type: "centered"
    }), /* @__PURE__ */React85.createElement(EGDSToolbar9, {
      toolbarTitle: (_toolbar_title1 = toolbar === null || toolbar === void 0 ? void 0 : toolbar.title) !== null && _toolbar_title1 !== void 0 ? _toolbar_title1 : void 0,
      navigationContent: {
        onClick: closePaymentDialog,
        navIconLabel: toolbar === null || toolbar === void 0 ? void 0 : (_toolbar_icon1 = toolbar.icon) === null || _toolbar_icon1 === void 0 ? void 0 : _toolbar_icon1.description
      }
    }), /* @__PURE__ */React85.createElement(EGDSSpacing44, {
      padding: {
        blockstart: "one",
        blockend: "three",
        inline: "three"
      }
    }, /* @__PURE__ */React85.createElement(EGDSSheetContent6, {
      padded: false
    }, /* @__PURE__ */React85.createElement(EGDSLayoutGrid12, {
      columns: 2,
      space: {
        column: "three"
      },
      "data-stid": "content-payment-options"
    }, renderETPContent()))))))))));
  }
  if (!priceDetail) {
    return null;
  }
  var lodgingFormFragment = (reserveCallToAction === null || reserveCallToAction === void 0 ? void 0 : reserveCallToAction.__typename) === "EtpDialog" ? priceDetail.offerBookButton : reserveCallToAction;
  var noCreditCard = priceDetail.noCreditCard,
    hotelCollect = priceDetail.hotelCollect,
    lodgingPrepareCheckout = priceDetail.lodgingPrepareCheckout;
  var trackReserveButtonClick = function () {
    trackReserveClickToCheckout({
      noCreditCard: noCreditCard,
      rfrrSuffix: rfrrSuffix,
      trackClick: trackClick,
      hasRecommendation: hasRecommendation,
      analyticsList: lodgingPrepareCheckout === null || lodgingPrepareCheckout === void 0 ? void 0 : lodgingPrepareCheckout.action.analyticsList,
      moreDetailsAnalyticsList: lodgingPrepareCheckout === null || lodgingPrepareCheckout === void 0 ? void 0 : lodgingPrepareCheckout.action.moreDetailsAnalyticsList,
      isWithinDetailsDialog: isWithinDetailsDialog
    });
  };
  return /* @__PURE__ */React85.createElement(PropertyLodgingPrepareCheckoutComponent, {
    lodgingPrepareCheckout: lodgingPrepareCheckout,
    offerBookButton: lodgingFormFragment,
    isFullWidth: isFullWidth,
    trackReserveButtonClick: trackReserveButtonClick,
    propertyNaturalKeys: priceDetail.propertyNaturalKeys,
    hotelCollect: hotelCollect,
    noCreditCard: noCreditCard,
    priceDetail: priceDetail,
    showLargeBtn: showLargeBtn,
    listingIndex: listingIndex
  });
};
PropertyReserveButton.fragment = fragment40;
PropertyReserveButton.displayName = "PropertyReserveButton";
// src/components/property-offers/__private/__fragments/rate-plan/amenities/rate-plan-amenities.tsx
import React86 from "react";
import { gql as gql71 } from "@apollo/client";
import { EGDSDialogContent as EGDSDialogContent7 } from "@egds/react-core/dialog";
import { EGDSIcon as EGDSIcon24, EGDSIconSize as EGDSIconSize16 } from "@egds/react-core/icons";
import { EGDSMoreInfoTrigger as EGDSMoreInfoTrigger4 } from "@egds/react-core/more-info-trigger";
import { EGDSSheet as EGDSSheet11, EGDSSheetTransition as EGDSSheetTransition13 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing45 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText31 } from "@egds/react-core/text";
import { EGDSToolbar as EGDSToolbar10 } from "@egds/react-core/toolbar";
import { EGDSUnformattedHtml as EGDSUnformattedHtml6 } from "@egds/react-core/unformatted-html";
import { useClickTracker as useClickTracker26 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog15 } from "@shared-ui/dialog-context";
import { useDialogId as useDialogId10 } from "@shared-ui/lodging-fragments";
var fragment41 = gql71(_templateObject71());
var RatePlanAmenities = function (param) {
  var data = param.data,
    _param_textSize = param.textSize,
    textSize = _param_textSize === void 0 ? 200 : _param_textSize,
    listingIndex = param.listingIndex;
  var additionalInformation = data.additionalInformation,
    description = data.description,
    icon = data.icon;
  var dialogPostfix = useDialogId10();
  var _useDialog15 = _sliced_to_array(useDialog15("rate-plan-additional-info-".concat(dialogPostfix), "pwaDialogNested"), 3),
    isDialogOpen = _useDialog15[0],
    dialogActions = _useDialog15[1],
    DialogComponent = _useDialog15[2];
  var track = useClickTracker26();
  var triggerRef = React86.useRef(null);
  var onAdditionalInfoClick = React86.useCallback(function () {
    track("HOT.HIS.specialdealsinfo", "Open Special Deals Info Dialog");
    dialogActions.openDialog();
  }, [track, dialogActions]);
  var handleToolbarClick = React86.useCallback(function () {
    dialogActions.closeDialog();
  }, [dialogActions]);
  return /* @__PURE__ */React86.createElement(React86.Fragment, null, /* @__PURE__ */React86.createElement(EGDSText31, {
    size: textSize,
    theme: "standard",
    inline: true
  }, /* @__PURE__ */React86.createElement(EGDSSpacing45, {
    margin: {
      inlineend: "two"
    }
  }, /* @__PURE__ */React86.createElement(EGDSIcon24, {
    name: (icon === null || icon === void 0 ? void 0 : icon.id.toLowerCase()) || "done",
    description: (icon === null || icon === void 0 ? void 0 : icon.description) || "",
    id: (icon === null || icon === void 0 ? void 0 : icon.id) || "done",
    size: (icon === null || icon === void 0 ? void 0 : icon.size) ? EGDSIconSize16[icon.size] : EGDSIconSize16.SMALL
  })), !additionalInformation && description, " ", additionalInformation && /* @__PURE__ */React86.createElement(EGDSMoreInfoTrigger4, {
    size: "small"
  }, /* @__PURE__ */React86.createElement("button", {
    onClick: onAdditionalInfoClick,
    type: "button",
    ref: triggerRef
  }, /* @__PURE__ */React86.createElement("span", null, description), /* @__PURE__ */React86.createElement(EGDSIcon24, {
    name: "info_outline",
    size: EGDSIconSize16.SMALL
  })))), additionalInformation && /* @__PURE__ */React86.createElement(EGDSSheetTransition13, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React86.createElement(DialogComponent, null, /* @__PURE__ */React86.createElement(EGDSSheet11, {
    type: "centered",
    isVisible: isDialogOpen,
    triggerRef: triggerRef,
    returnFocusOnClose: true
  }, /* @__PURE__ */React86.createElement(EGDSToolbar10, {
    toolbarTitle: description !== null && description !== void 0 ? description : void 0,
    navigationContent: {
      navType: "close",
      onClick: handleToolbarClick
    }
  }), /* @__PURE__ */React86.createElement(EGDSDialogContent7, null, /* @__PURE__ */React86.createElement(EGDSSpacing45, {
    margin: "six",
    padding: {
      blockstart: "six",
      inline: "six"
    }
  }, /* @__PURE__ */React86.createElement(EGDSUnformattedHtml6, {
    htmlToParse: additionalInformation
  })))))));
};
RatePlanAmenities.fragment = fragment41;
RatePlanAmenities.displayName = "RatePlanAmenities";
// src/components/property-offers/__private/__fragments/rate-plan/rate-plan-analytics-tracker.tsx
import React87 from "react";
import { gql as gql72 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker7 } from "@shared-ui/clickstream-analytics-context";
var fragment42 = gql72(_templateObject72());
var RatePlanAnalyticsTracker = function (param) {
  var children = param.children,
    data = param.data,
    ratePlanId = param.ratePlanId;
  var clientSideAnalytics = data.clientSideAnalytics;
  var _clientSideAnalytics_referrerId, _clientSideAnalytics_linkName;
  return /* @__PURE__ */React87.createElement(IntersectionTracker7, {
    referrerId: (_clientSideAnalytics_referrerId = clientSideAnalytics === null || clientSideAnalytics === void 0 ? void 0 : clientSideAnalytics.referrerId) !== null && _clientSideAnalytics_referrerId !== void 0 ? _clientSideAnalytics_referrerId : "",
    linkName: (_clientSideAnalytics_linkName = clientSideAnalytics === null || clientSideAnalytics === void 0 ? void 0 : clientSideAnalytics.linkName) !== null && _clientSideAnalytics_linkName !== void 0 ? _clientSideAnalytics_linkName : "",
    additionalUisPrimeMicroMessages: clientSideAnalytics === null || clientSideAnalytics === void 0 ? void 0 : clientSideAnalytics.uisPrimeMessages.map(function (msg) {
      return {
        messageContent: JSON.parse(msg.messageContent),
        schemaName: msg.schemaName
      };
    }),
    intersectionOptions: {
      threshold: 0.5
    },
    deps: [ratePlanId]
  }, children);
};
RatePlanAnalyticsTracker.fragment = fragment42;
RatePlanAnalyticsTracker.displayName = "RatePlanAnalyticsTracker";
// src/components/property-offers/__private/__fragments/rate-plan/rate-plan-with-amenities.tsx
var fragment43 = gql73(_templateObject73(), PropertyFeatures.fragment, PropertyBaseFeatures.fragment, MarketingSection.fragment, LodgingHighlightedMessages.fragment, PropertyOffersRateViewScarcity.fragment, LodgingPriceSummary.fragment, PriceBreakdownSummary.fragment, PropertyRatePlanBadge.fragment, RatePlanAmenities.fragment, PropertyReserveButton.fragment, PropertyOffersPriceChangeMessage.fragment, LodgingEnrichedMessage11.fragment, PropertyPriceDocumentNode2, PricePresentationDialog.fragment, PropertyInfoMessage.fragment, RatePlanAnalyticsTracker.fragment);
var ROOM_INFO_ETP_DIALOG_QUERY_PARAM = "infosite-room-info-dialog-ratePlans";
var RatePlanWithAmenities = function (param) {
  var data = param.data,
    listingIndex = param.listingIndex,
    roomId = param.roomId,
    _param_amenityTextSize = param.amenityTextSize,
    amenityTextSize = _param_amenityTextSize === void 0 ? 200 : _param_amenityTextSize;
  var _priceDetail_price_displayMessages, _priceDetail_price;
  var _data_priceDetails = _sliced_to_array(data.priceDetails, 1),
    priceDetail = _data_priceDetails[0],
    amenities = data.amenities,
    loyaltyMessage = data.loyaltyMessage,
    marketingSection = data.marketingSection,
    shareUrl = data.shareUrl,
    paymentPolicy = data.paymentPolicy,
    id = data.id;
  var isWithinDetailsDialog = React88.useContext(DialogContext8);
  if (!priceDetail) {
    return null;
  }
  return /* @__PURE__ */React88.createElement(RatePlanAnalyticsTracker, {
    data: data,
    ratePlanId: id
  }, (priceDetail === null || priceDetail === void 0 ? void 0 : priceDetail.optionTitle) && /* @__PURE__ */React88.createElement(EGDSHeading16, {
    tag: "h4",
    size: 7
  }, priceDetail.optionTitle.text), /* @__PURE__ */React88.createElement(PropertyOffersPriceChangeMessage, {
    data: data
  }), /* @__PURE__ */React88.createElement(EGDSLayoutFlex19, {
    justifyContent: "space-between",
    wrap: "nowrap"
  }, /* @__PURE__ */React88.createElement(EGDSLayoutFlexItem14, {
    grow: 1
  }, /* @__PURE__ */React88.createElement("div", null, /* @__PURE__ */React88.createElement(LodgingHighlightedMessages, {
    data: data
  }), /* @__PURE__ */React88.createElement("ul", {
    className: "no-bullet"
  }, amenities.map(function (amenity, amenityIndex) {
    return /* @__PURE__ */React88.createElement(EGDSSpacing46, {
      key: "rate-plan-amenity-".concat(amenityIndex),
      padding: {
        blockend: "one"
      }
    }, /* @__PURE__ */React88.createElement("li", null, /* @__PURE__ */React88.createElement(RatePlanAmenities, {
      textSize: amenityTextSize,
      data: amenity,
      listingIndex: listingIndex
    })));
  }), loyaltyMessage && /* @__PURE__ */React88.createElement(EGDSSpacing46, {
    padding: {
      blockend: "one"
    }
  }, /* @__PURE__ */React88.createElement("li", null, /* @__PURE__ */React88.createElement(LodgingEnrichedMessage11, {
    data: loyaltyMessage
  })))), marketingSection && /* @__PURE__ */React88.createElement(EGDSSpacing46, {
    margin: {
      blockstart: "three",
      blockend: "two"
    }
  }, /* @__PURE__ */React88.createElement("div", null, /* @__PURE__ */React88.createElement(MarketingSection, {
    data: marketingSection
  }))))), /* @__PURE__ */React88.createElement(EGDSLayoutFlexItem14, {
    grow: 1,
    minWidth: "third_width",
    className: "uitk-type-right"
  }, /* @__PURE__ */React88.createElement(EGDSLayoutFlex19, {
    direction: "column",
    alignItems: "end"
  }, /* @__PURE__ */React88.createElement("div", null, /* @__PURE__ */React88.createElement(PropertyRatePlanBadge, {
    data: data
  })), ((_priceDetail_price = priceDetail.price) === null || _priceDetail_price === void 0 ? void 0 : (_priceDetail_price_displayMessages = _priceDetail_price.displayMessages) === null || _priceDetail_price_displayMessages === void 0 ? void 0 : _priceDetail_price_displayMessages.length) ? /* @__PURE__ */React88.createElement(PriceSummary2, {
    data: priceDetail.price
  }) : /* @__PURE__ */React88.createElement(LodgingPriceSummary, {
    align: EGDSPriceLockupAlign3.RIGHT,
    data: priceDetail
  }), priceDetail.priceBreakDownSummary ? /* @__PURE__ */React88.createElement(PriceBreakdownSummary, {
    data: priceDetail,
    actionButton: /* @__PURE__ */React88.createElement(PropertyReserveButton, {
      paymentPolicy: paymentPolicy,
      dialogSuffix: "".concat(ROOM_INFO_ETP_DIALOG_QUERY_PARAM, "-price-breakdown"),
      data: data,
      isFullWidth: true,
      listingIndex: listingIndex,
      rfrrSuffix: isWithinDetailsDialog ? "RoomInfoDialog.RoomsAndRates" /* Dialog */ : "PriceDetailMenu.RoomsAndRates" /* Menu */
    })
  }) : /* @__PURE__ */React88.createElement("div", null, /* @__PURE__ */React88.createElement(PricePresentationDialog, {
    data: priceDetail,
    actionButton: /* @__PURE__ */React88.createElement(PropertyReserveButton, {
      paymentPolicy: paymentPolicy,
      dialogSuffix: "".concat(ROOM_INFO_ETP_DIALOG_QUERY_PARAM, "-price-breakdown"),
      data: data,
      isFullWidth: true,
      listingIndex: listingIndex,
      rfrrSuffix: isWithinDetailsDialog ? "RoomInfoDialog.RoomsAndRates" /* Dialog */ : "PriceDetailMenu.RoomsAndRates" /* Menu */
    }),
    roomTypeId: roomId,
    ratePlanId: id
  })), priceDetail.pointsApplied && /* @__PURE__ */React88.createElement(EGDSSpacing46, {
    margin: {
      blockend: "one"
    }
  }, /* @__PURE__ */React88.createElement(EGDSText32, {
    size: 100,
    theme: "standard",
    "data-stid": "price-points"
  }, priceDetail.pointsApplied)), /* @__PURE__ */React88.createElement(PropertyOffersRateViewScarcity, {
    data: priceDetail
  }), /* @__PURE__ */React88.createElement(EGDSSpacing46, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React88.createElement("div", null, /* @__PURE__ */React88.createElement(PropertyReserveButton, {
    paymentPolicy: paymentPolicy,
    dialogSuffix: ROOM_INFO_ETP_DIALOG_QUERY_PARAM,
    data: data,
    listingIndex: listingIndex,
    rfrrSuffix: isWithinDetailsDialog ? "RoomInfoDialog.RoomsAndRates" /* Dialog */ : "RoomsAndRates" /* Standard */
  })))))), shareUrl && /* @__PURE__ */React88.createElement(MarketingSectionLink, {
    shareUrl: shareUrl
  }));
};
RatePlanWithAmenities.fragment = fragment43;
RatePlanWithAmenities.displayName = "RatePlanWithAmenities";
// src/components/property-offers/__private/__fragments/rate-plan/unit-categorization-rate-plan.tsx
import React94 from "react";
import { gql as gql76 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex20, EGDSLayoutFlexItem as EGDSLayoutFlexItem15 } from "@egds/react-core/layout-flex";
import { EGDSMarkSize as EGDSMarkSize6 } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing52 } from "@egds/react-core/spacing";
import { DialogContext as DialogContext10, LodgingEnrichedMessage as LodgingEnrichedMessage13, LodgingPriceSummary as LodgingPriceSummary3, PropertyPriceDocumentNode as PropertyPriceDocumentNode3 } from "@shared-ui/lodging-fragments";
// src/components/property-offers/__private/__fragments/listings/sections/offer-notifications.tsx
import React90 from "react";
import { EGDSSpacing as EGDSSpacing48 } from "@egds/react-core/spacing";
// src/components/property-offers/__private/__fragments/notifications-card/index.tsx
import React89 from "react";
import { gql as gql74 } from "@apollo/client";
import { EGDSCard as EGDSCard13 } from "@egds/react-core/cards";
import { EGDSList as EGDSList6, EGDSListItem as EGDSListItem9 } from "@egds/react-core/list";
import { EGDSSpacing as EGDSSpacing47 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading17 } from "@egds/react-core/text";
import { LodgingEnrichedMessage as LodgingEnrichedMessage12 } from "@shared-ui/lodging-fragments";
var fragment44 = gql74(_templateObject74(), LodgingEnrichedMessage12.fragment);
var LodgingNotificationsCard = function (param) {
  var data = param.data,
    _param_border = param.border,
    border = _param_border === void 0 ? true : _param_border;
  if (!data) {
    return null;
  }
  var header = data.header,
    messages = data.messages;
  return /* @__PURE__ */React89.createElement(EGDSCard13, {
    padded: true,
    border: border
  }, header && /* @__PURE__ */React89.createElement(EGDSHeading17, {
    size: 7,
    tag: "h2"
  }, header.text), /* @__PURE__ */React89.createElement(EGDSSpacing47, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React89.createElement(EGDSList6, {
    bullet: "no-bullet"
  }, messages.map(function (message, index) {
    switch (message.__typename) {
      case "LodgingEnrichedMessage":
        return /* @__PURE__ */React89.createElement(EGDSListItem9, {
          key: "room-level-notification-".concat(index)
        }, /* @__PURE__ */React89.createElement(LodgingEnrichedMessage12, {
          data: message
        }));
      default:
        return null;
    }
  }))));
};
LodgingNotificationsCard.displayName = "LodgingNotificationsCard";
LodgingNotificationsCard.fragment = fragment44;
// src/components/property-offers/__private/__fragments/listings/sections/offer-notifications.tsx
var OfferNotifications = function () {
  var ratePlan = React90.useContext(UnitRateContext).ratePlan;
  if (!ratePlan || !(ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.offerNotifications)) {
    return null;
  }
  var offerNotifications = ratePlan.offerNotifications;
  return /* @__PURE__ */React90.createElement(EGDSSpacing48, {
    margin: {
      block: "six"
    }
  }, /* @__PURE__ */React90.createElement("div", null, /* @__PURE__ */React90.createElement(LodgingNotificationsCard, {
    data: offerNotifications
  })));
};
var offer_notifications_default = OfferNotifications;
// src/components/property-offers/__private/__fragments/listings/sections/unit-categorization-highlighted-messages.tsx
import React91 from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid13 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing49 } from "@egds/react-core/spacing";
var UnitCategorizationHighlightedMessages = function (param) {
  var _param_highlightedMessages = param.highlightedMessages,
    highlightedMessages = _param_highlightedMessages === void 0 ? [] : _param_highlightedMessages,
    _param_id = param.id,
    id = _param_id === void 0 ? "" : _param_id;
  return /* @__PURE__ */React91.createElement(React91.Fragment, null, highlightedMessages.length > 0 && /* @__PURE__ */React91.createElement(EGDSSpacing49, {
    margin: {
      block: "two"
    }
  }, /* @__PURE__ */React91.createElement(EGDSLayoutGrid13, {
    "data-stid": "highlightedMessages-".concat(id)
  }, highlightedMessages.map(function (highlightedMessage, index) {
    return /* @__PURE__ */React91.createElement(RatePlanMessage, {
      key: "highlightedMessages-".concat(id, "-").concat(index),
      data: highlightedMessage
    });
  }))));
};
UnitCategorizationHighlightedMessages.displayName = "UnitCategorizationHighlightedMessages";
// src/components/property-offers/__private/__fragments/property-rate-plan-standard-badge.tsx
import React92 from "react";
import { gql as gql75 } from "@apollo/client";
import { EGDSBadge as EGDSBadge2, EGDSBadgeLoyalty as EGDSBadgeLoyalty3 } from "@egds/react-core/badge";
import { EGDSIcon as EGDSIcon25, EGDSIconSize as EGDSIconSize17 } from "@egds/react-core/icons";
import { EGDSSpacing as EGDSSpacing50 } from "@egds/react-core/spacing";
import { IntersectionTracker as IntersectionTracker8 } from "@shared-ui/clickstream-analytics-context";
import { EGDSBadgeLoyaltyThemeMapper as EGDSBadgeLoyaltyThemeMapper2, EGDSBadgeThemeMapper } from "@shared-ui/lodging-fragments";
var fragment45 = gql75(_templateObject75());
var PropertyRatePlanStandardBadge = function (param) {
  var data = param.data;
  var _data_standardBadge;
  var _ref = (_data_standardBadge = data === null || data === void 0 ? void 0 : data.standardBadge) !== null && _data_standardBadge !== void 0 ? _data_standardBadge : {},
    standardBadge = _ref.standardBadge,
    impressionEventAnalytics = _ref.impressionEventAnalytics;
  if (!standardBadge || !standardBadge.text) {
    return null;
  }
  var text = standardBadge.text,
    theme = standardBadge.theme,
    graphic = standardBadge.graphic;
  var loyaltyBadge = theme ? EGDSBadgeLoyaltyThemeMapper2[theme] : void 0;
  var _ref1 = impressionEventAnalytics !== null && impressionEventAnalytics !== void 0 ? impressionEventAnalytics : {},
    referrerId = _ref1.referrerId,
    linkName = _ref1.linkName;
  var graphics = function () {
    switch (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) {
      case "Icon":
        return graphic.id && /* @__PURE__ */React92.createElement(EGDSIcon25, {
          name: graphic.id,
          id: graphic.id,
          description: graphic.description,
          size: EGDSIconSize17.SMALL
        });
      default:
        return null;
    }
  };
  var EGDSLoyaltyBadge = /* @__PURE__ */React92.createElement(EGDSBadgeLoyalty3, {
    theme: loyaltyBadge,
    text: text
  }, graphics());
  var impressionTrackingTieredMod = referrerId && linkName ? /* @__PURE__ */React92.createElement(IntersectionTracker8, {
    referrerId: referrerId,
    linkName: linkName,
    trackOnce: true
  }, EGDSLoyaltyBadge) : EGDSLoyaltyBadge;
  return /* @__PURE__ */React92.createElement(EGDSSpacing50, {
    margin: {
      blockend: "one"
    }
  }, loyaltyBadge ? impressionTrackingTieredMod :
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  /* @__PURE__ */
  React92.createElement(EGDSBadge2, {
    theme: theme ? EGDSBadgeThemeMapper[theme] : void 0,
    text: text
  }, graphics()));
};
PropertyRatePlanStandardBadge.fragment = fragment45;
PropertyRatePlanStandardBadge.displayName = "PropertyRatePlanStandardBadge";
// src/components/property-offers/__private/__fragments/rate-plan/price-details.tsx
import React93 from "react";
import { PositionType as PositionType2 } from "@egds/react-core/menu";
import { UitkPriceLockupAlign as EGDSPriceLockupAlign4 } from "@egds/react-core/price-lockup";
import { EGDSSpacing as EGDSSpacing51 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText33 } from "@egds/react-core/text";
import { useEgClickstream as useEgClickstream9 } from "@shared-ui/clickstream-analytics-context";
import { DialogContext as DialogContext9, LodgingPriceSummary as LodgingPriceSummary2 } from "@shared-ui/lodging-fragments";
import { PriceSummary as PriceSummary3 } from "@shared-ui/pricing-price-summary";
var ETP_DIALOG_QUERY_PARAM = "infosite-room-ratePlans";
var PointsApplied = function (param) {
  var pointsApplied = param.pointsApplied;
  if (!pointsApplied) {
    return null;
  }
  return /* @__PURE__ */React93.createElement(EGDSSpacing51, {
    margin: {
      blockend: "one"
    }
  }, /* @__PURE__ */React93.createElement(EGDSText33, {
    size: 100,
    theme: "standard",
    "data-stid": "price-points"
  }, pointsApplied));
};
var PriceDetails = function (param) {
  var listingIndex = param.listingIndex,
    paymentPolicy = param.paymentPolicy,
    priceDetail = param.priceDetail,
    ratePlan = param.ratePlan,
    _param_enableInlineLink = param.enableInlineLink,
    enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink,
    roomTypeId = param.roomTypeId;
  var _priceDetail_price_displayMessages, _priceDetail_price;
  var isWithinDetailsDialog = React93.useContext(DialogContext9);
  var trackEgClickstreamEvent = useEgClickstream9();
  var handleDisclaimerClick = React93.useCallback(function () {
    if (roomTypeId && (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.id)) {
      trackEgClickstreamEvent(buildRoomsAndRatesClientPayload("strikethrough_price.selected" /* STRIKETHROUGH_PRICE_SELECTED */, roomTypeId, ratePlan.id));
    }
  }, [roomTypeId, ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.id]);
  if (!priceDetail) {
    return null;
  }
  return /* @__PURE__ */React93.createElement("div", null, ((_priceDetail_price = priceDetail.price) === null || _priceDetail_price === void 0 ? void 0 : (_priceDetail_price_displayMessages = _priceDetail_price.displayMessages) === null || _priceDetail_price_displayMessages === void 0 ? void 0 : _priceDetail_price_displayMessages.length) ? /* @__PURE__ */React93.createElement("div", {
    "data-stid": "price-summary"
  }, /* @__PURE__ */React93.createElement(PriceSummary3, {
    data: priceDetail.price,
    flexAlignment: "start",
    enableInlineLink: enableInlineLink,
    onDisclaimerClick: handleDisclaimerClick
  })) : /* @__PURE__ */React93.createElement(LodgingPriceSummary2, {
    align: EGDSPriceLockupAlign4.LEFT,
    data: priceDetail
  }), !isWithinDetailsDialog && /* @__PURE__ */React93.createElement(PointsApplied, {
    pointsApplied: priceDetail.pointsApplied
  }), priceDetail.priceBreakDownSummary ? /* @__PURE__ */React93.createElement(PriceBreakdownSummary, {
    data: priceDetail,
    menuContainerPosition: PositionType2.LEFT,
    actionButton: /* @__PURE__ */React93.createElement(PropertyReserveButton, {
      dialogSuffix: ETP_DIALOG_QUERY_PARAM,
      data: ratePlan,
      listingIndex: listingIndex,
      paymentPolicy: paymentPolicy,
      rfrrSuffix: "RoomsAndRates" /* Standard */
    }),
    roomTypeId: roomTypeId,
    ratePlanId: ratePlan.id
  }) : /* @__PURE__ */React93.createElement(PricePresentationDialog, {
    data: priceDetail,
    actionButton: /* @__PURE__ */React93.createElement(PropertyReserveButton, {
      dialogSuffix: ETP_DIALOG_QUERY_PARAM,
      data: ratePlan,
      listingIndex: listingIndex,
      paymentPolicy: paymentPolicy,
      rfrrSuffix: "RoomsAndRates" /* Standard */,
      isFullWidth: true
    }),
    roomTypeId: roomTypeId,
    ratePlanId: ratePlan.id
  }), isWithinDetailsDialog && /* @__PURE__ */React93.createElement(PointsApplied, {
    pointsApplied: priceDetail.pointsApplied
  }));
};
// src/components/property-offers/__private/__fragments/rate-plan/unit-categorization-rate-plan.tsx
var UnitCategorizationRatePlanFragment = gql76(_templateObject76(), LodgingEnrichedMessage13.fragment, PropertyOffersRateViewScarcity.fragment, LodgingPriceSummary3.fragment, PriceBreakdownSummary.fragment, PropertyRatePlanBadge.fragment, PropertyRatePlanStandardBadge.fragment, PropertyOffersPriceChangeMessage.fragment, PropertyReserveButton.fragment, PropertyPriceDocumentNode3, LodgingNotificationsCard.fragment, PricePresentationDialog.fragment, RatePlanAnalyticsTracker.fragment);
var UnitCategorizationRatePlan = function (param) {
  var listingIndex = param.listingIndex,
    roomId = param.roomId,
    highlightedMessages = param.highlightedMessages,
    onClose = param.onClose;
  var ETP_DIALOG_QUERY_PARAM3 = "infosite-room-ratePlans";
  var ratePlan = React94.useContext(UnitRateContext).ratePlan;
  var isWithinDetailsDialog = React94.useContext(DialogContext10);
  var _useMicroRoomCard = useMicroRoomCard(),
    isMicroRoomCardRatesDialog = _useMicroRoomCard.isMicroRoomCardRatesDialog,
    hasSelections = _useMicroRoomCard.hasSelections,
    isMicroRoomCardCarousel = _useMicroRoomCard.isMicroRoomCardCarousel;
  if (!ratePlan) {
    return null;
  }
  var id = ratePlan.id,
    loyaltyMessage = ratePlan.loyaltyMessage,
    marketingSection = ratePlan.marketingSection,
    headerMessage = ratePlan.headerMessage,
    paymentPolicy = ratePlan.paymentPolicy,
    _ratePlan_priceDetails = _sliced_to_array(ratePlan.priceDetails, 1),
    priceDetail = _ratePlan_priceDetails[0];
  var reserveButtonBase = /* @__PURE__ */React94.createElement(PropertyReserveButton, {
    dialogSuffix: ETP_DIALOG_QUERY_PARAM3,
    data: ratePlan,
    listingIndex: listingIndex,
    paymentPolicy: paymentPolicy,
    rfrrSuffix: "RoomsAndRates" /* Standard */,
    isFullWidth: isMicroRoomCardCarousel && !isWithinDetailsDialog,
    onClose: onClose
  });
  var reserveButton = null;
  switch (isWithinDetailsDialog) {
    case false:
      if (isMicroRoomCardCarousel) {
        reserveButton = /* @__PURE__ */React94.createElement(EGDSSpacing52, {
          margin: {
            block: "three"
          }
        }, /* @__PURE__ */React94.createElement("div", null, reserveButtonBase));
      } else if (isMicroRoomCardRatesDialog) {
        reserveButton = null;
      } else {
        reserveButton = reserveButtonBase;
      }
      break;
    default:
      reserveButton = reserveButtonBase;
  }
  var priceBadge = /* @__PURE__ */React94.createElement("div", null, ratePlan.standardBadge ? /* @__PURE__ */React94.createElement(PropertyRatePlanStandardBadge, {
    data: ratePlan
  }) : /* @__PURE__ */React94.createElement(PropertyRatePlanBadge, {
    data: ratePlan
  }));
  return /* @__PURE__ */React94.createElement(RatePlanAnalyticsTracker, {
    data: ratePlan,
    ratePlanId: id
  }, /* @__PURE__ */React94.createElement(UnitCategorizationHighlightedMessages, {
    highlightedMessages: highlightedMessages,
    id: id
  }), (!isMicroRoomCardCarousel || isWithinDetailsDialog) && /* @__PURE__ */React94.createElement(offer_notifications_default, null), marketingSection && /* @__PURE__ */React94.createElement(EGDSSpacing52, {
    margin: {
      block: "six"
    }
  }, /* @__PURE__ */React94.createElement("div", null, /* @__PURE__ */React94.createElement(MarketingSection, {
    data: marketingSection
  }))), headerMessage && /* @__PURE__ */React94.createElement(PropertyOffersPriceChangeMessage, {
    data: ratePlan
  }), loyaltyMessage && /* @__PURE__ */React94.createElement(EGDSSpacing52, {
    margin: {
      block: "three"
    }
  }, /* @__PURE__ */React94.createElement("div", null, /* @__PURE__ */React94.createElement(LodgingEnrichedMessage13, {
    data: loyaltyMessage,
    markSize: EGDSMarkSize6.SMALL,
    textSize: 300
  }))), priceBadge, /* @__PURE__ */React94.createElement(EGDSLayoutFlex20, {
    alignItems: isWithinDetailsDialog ? "start" : "end",
    justifyContent: "space-between"
  }, /* @__PURE__ */React94.createElement(EGDSLayoutFlexItem15, null, /* @__PURE__ */React94.createElement("div", null, /* @__PURE__ */React94.createElement(PriceDetails, {
    listingIndex: listingIndex,
    paymentPolicy: paymentPolicy,
    priceDetail: priceDetail,
    ratePlan: ratePlan,
    roomTypeId: roomId,
    enableInlineLink: true
  }))), /* @__PURE__ */React94.createElement(EGDSLayoutFlexItem15, {
    alignSelf: "end"
  }, /* @__PURE__ */React94.createElement(EGDSLayoutFlex20, {
    direction: "column",
    alignItems: "end",
    space: "two"
  }, priceDetail && /* @__PURE__ */React94.createElement(PropertyOffersRateViewScarcity, {
    data: priceDetail
  }), (!isMicroRoomCardCarousel || isWithinDetailsDialog) && reserveButton))), isMicroRoomCardCarousel && !hasSelections && !isWithinDetailsDialog && reserveButton);
};
UnitCategorizationRatePlan.displayName = "UnitCategorizationRatePlan";
// src/components/property-offers/__private/__fragments/listings/sections/footer-text.tsx
import React95 from "react";
import { gql as gql77 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing53 } from "@egds/react-core/spacing";
import { UitkText } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker9 } from "@shared-ui/clickstream-analytics-context";
var fragment46 = gql77(_templateObject77());
var FooterText = function (param) {
  var data = param.data;
  var footerText = data.footerText;
  if (!footerText) {
    return null;
  }
  var text = footerText.text,
    impressionAnalytics = footerText.impressionAnalytics,
    accessibilityLabel = footerText.accessibilityLabel;
  var contentBase = /* @__PURE__ */React95.createElement(React95.Fragment, null, /* @__PURE__ */React95.createElement(UitkText, {
    "aria-hidden": "true",
    align: "center"
  }, text), accessibilityLabel && /* @__PURE__ */React95.createElement("span", {
    className: "is-visually-hidden"
  }, accessibilityLabel));
  var hasImpressionAnalytics = impressionAnalytics && Boolean((impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) && (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName));
  var content = hasImpressionAnalytics ? /* @__PURE__ */React95.createElement(IntersectionTracker9, {
    referrerId: impressionAnalytics.referrerId,
    linkName: impressionAnalytics.linkName
  }, contentBase) : /* @__PURE__ */React95.createElement("div", null, "contentBase");
  return /* @__PURE__ */React95.createElement(EGDSSpacing53, {
    margin: {
      blockstart: "two"
    }
  }, content);
};
FooterText.fragment = fragment46;
FooterText.displayName = "FooterButton";
// src/components/property-offers/__private/__fragments/listings/sections/radio-group-extension.tsx
import React99 from "react";
import { RadioButtonDescriptionExtensionWithPositiveThemeGroup } from "@egds/react-lodging";
// src/components/property-offers/__private/__fragments/listings/sections/selection-header.tsx
import React98 from "react";
import { gql as gql80 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex21, EGDSLayoutFlexItem as EGDSLayoutFlexItem16 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing55 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading19, EGDSText as EGDSText35 } from "@egds/react-core/text";
// src/components/property-offers/__private/__fragments/unit-categorization-complex-dialog.tsx
import React96 from "react";
import { gql as gql78 } from "@apollo/client";
import { EGDSTertiaryButton as EGDSTertiaryButton3 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon26, EGDSIconSize as EGDSIconSize18 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink12 } from "@egds/react-core/link";
import { EGDSSheet as EGDSSheet12, EGDSSheetContent as EGDSSheetContent7, EGDSSheetTransition as EGDSSheetTransition14 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing54 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading18, EGDSText as EGDSText34 } from "@egds/react-core/text";
import { EGDSToolbar as EGDSToolbar11 } from "@egds/react-core/toolbar";
import { useClickTracker as useClickTracker27, useEgClickstream as useEgClickstream10 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog16 } from "@shared-ui/dialog-context";
import { useDialogId as useDialogId11 } from "@shared-ui/lodging-fragments";
import { ViewMedium as ViewMedium8, Viewport as Viewport10, ViewSmall as ViewSmall10 } from "@shared-ui/viewport-context";
var fragment47 = gql78(_templateObject78(), __UIPrimaryButtonFragment);
var UnitCategorizationComplexDialog = function (param) {
  var data = param.data;
  var _toolbar_icon;
  var _React96_useContext = React96.useContext(UnitRateContext),
    ratePlan = _React96_useContext.ratePlan,
    roomTypeId = _React96_useContext.roomTypeId;
  var dialogPostfix = useDialogId11();
  var _useDialog16 = _sliced_to_array(useDialog16("unit-categorization-complex-".concat(dialogPostfix), "pwaDialogNested"), 3),
    isOpen = _useDialog16[0],
    dialogActions = _useDialog16[1],
    DialogComponent = _useDialog16[2];
  var trackClick = useClickTracker27();
  var trackEgClickstreamEvent = useEgClickstream10();
  var triggerRef = React96.useRef(null);
  if (!data) {
    return null;
  }
  var content = data.content,
    primaryUIButton = data.primaryUIButton,
    toolbar = data.toolbar,
    trigger = data.trigger;
  var openDialog = function () {
    dialogActions.openDialog();
    if (roomTypeId && (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.id)) {
      trackEgClickstreamEvent(buildRoomsAndRatesClientPayload("more_details.selected" /* MORE_DETAILS_SELECTED */, roomTypeId, ratePlan.id));
    }
    if (trigger === null || trigger === void 0 ? void 0 : trigger.clientSideAnalytics) {
      trackClick("HOT.HIS" /* Infosite */.concat(trigger.clientSideAnalytics.referrerId), trigger.clientSideAnalytics.linkName);
    }
  };
  var closeDialog = function () {
    dialogActions.closeDialog();
    if (toolbar === null || toolbar === void 0 ? void 0 : toolbar.clientSideAnalytics) {
      trackClick("HOT.HIS" /* Infosite */.concat(toolbar.clientSideAnalytics.referrerId), toolbar.clientSideAnalytics.linkName);
    }
  };
  var renderDialogEntries = function (entry, entryIndex) {
    return /* @__PURE__ */React96.createElement(EGDSText34, {
      key: entryIndex,
      size: 300,
      spacing: entryIndex ? "three" : void 0
    }, entry);
  };
  var renderDialogContent = function (param, sectionIndex) {
    var entries = param.content,
      title = param.title;
    return /* @__PURE__ */React96.createElement(React96.Fragment, {
      key: sectionIndex
    }, /* @__PURE__ */React96.createElement(EGDSSpacing54, {
      margin: {
        blockstart: sectionIndex ? "three" : void 0
      }
    }, /* @__PURE__ */React96.createElement(EGDSHeading18, {
      tag: "h3",
      size: 7,
      "data-stid": "property-offers-secondary-dialog-heading"
    }, title === null || title === void 0 ? void 0 : title.text)), entries === null || entries === void 0 ? void 0 : entries.map(renderDialogEntries));
  };
  var _toolbar_title;
  var dialogContent = /* @__PURE__ */React96.createElement(React96.Fragment, null, /* @__PURE__ */React96.createElement(EGDSToolbar11, {
    toolbarTitle: (_toolbar_title = toolbar === null || toolbar === void 0 ? void 0 : toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
    navigationContent: {
      navType: "close",
      navIconLabel: toolbar === null || toolbar === void 0 ? void 0 : (_toolbar_icon = toolbar.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description,
      onClick: closeDialog
    }
  }), /* @__PURE__ */React96.createElement(EGDSSheetContent7, null, content === null || content === void 0 ? void 0 : content.map(renderDialogContent), primaryUIButton && /* @__PURE__ */React96.createElement(EGDSSpacing54, {
    padding: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React96.createElement("div", null, /* @__PURE__ */React96.createElement(EGDSTertiaryButton3, _object_spread_props(_object_spread({}, getUiButtonProps(primaryUIButton.action, trackClick, closeDialog)), {
    isFullWidth: true
  }), primaryUIButton.primary || "")))));
  var sheetProps = {
    isVisible: isOpen,
    returnFocusOnClose: true,
    triggerRef: triggerRef
  };
  return /* @__PURE__ */React96.createElement(EGDSSpacing54, {
    padding: {
      blockstart: "half",
      blockend: "one"
    }
  }, /* @__PURE__ */React96.createElement("div", null, /* @__PURE__ */React96.createElement(EGDSSpacing54, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React96.createElement(EGDSLink12, {
    onClick: openDialog,
    "data-stid": "property-offers-secondary-dialog-link"
  }, /* @__PURE__ */React96.createElement("button", {
    type: "button",
    ref: triggerRef
  }, /* @__PURE__ */React96.createElement(EGDSText34, {
    size: 200,
    theme: "standard",
    "data-stid": "property-offers-secondary-dialog-trigger"
  }, trigger.value, trigger.icon && /* @__PURE__ */React96.createElement(EGDSIcon26, {
    name: trigger.icon.id,
    size: EGDSIconSize18.SMALL
  }))))), content && /* @__PURE__ */React96.createElement(EGDSSheetTransition14, {
    isVisible: isOpen
  }, /* @__PURE__ */React96.createElement(DialogComponent, null, /* @__PURE__ */React96.createElement(Viewport10, null, /* @__PURE__ */React96.createElement(ViewSmall10, null, /* @__PURE__ */React96.createElement(EGDSSheet12, _object_spread_props(_object_spread({}, sheetProps), {
    type: "full"
  }), dialogContent)), /* @__PURE__ */React96.createElement(ViewMedium8, null, /* @__PURE__ */React96.createElement(EGDSSheet12, _object_spread_props(_object_spread({}, sheetProps), {
    type: "centered"
  }), dialogContent)))))));
};
UnitCategorizationComplexDialog.fragment = fragment47;
UnitCategorizationComplexDialog.displayName = "UnitCategorizationComplexDialog";
// src/components/property-offers/__private/__fragments/listings/sections/selection-header-dialog.tsx
import React97 from "react";
import { gql as gql79 } from "@apollo/client";
var fragment48 = gql79(_templateObject79(), UnitCategorizationComplexDialog.fragment, LodgingPolicyDialog.fragment);
var SelectionHeaderDialog = function (param) {
  var data = param.data;
  switch (data.__typename) {
    case "LodgingComplexDialog":
      return /* @__PURE__ */React97.createElement(UnitCategorizationComplexDialog, {
        data: data
      });
    case "LodgingPolicyDialog":
      return /* @__PURE__ */React97.createElement(LodgingPolicyDialog, {
        data: data,
        uniqueDialogId: "lodging-cancellation-policy-dialog",
        policyType: "MULTIPLE" /* MULTIPLE */
      });
    default:
      return null;
  }
};
SelectionHeaderDialog.fragment = fragment48;
SelectionHeaderDialog.displayName = "SelectionHeader";
// src/components/property-offers/__private/__fragments/listings/sections/selection-header.tsx
var fragment49 = gql80(_templateObject80(), UnitCategorizationComplexDialog.fragment, SelectionHeaderDialog.fragment);
var SelectionHeader = function (param) {
  var data = param.data;
  var title = data.title;
  if (!title) {
    return null;
  }
  return /* @__PURE__ */React98.createElement(EGDSSpacing55, null, /* @__PURE__ */React98.createElement("div", null, /* @__PURE__ */React98.createElement(EGDSLayoutFlex21, {
    space: "one",
    justifyContent: "space-between"
  }, /* @__PURE__ */React98.createElement(EGDSLayoutFlexItem16, null, /* @__PURE__ */React98.createElement(EGDSHeading19, {
    tag: "h4",
    size: 7
  }, title.text)), title.subText && /* @__PURE__ */React98.createElement(EGDSLayoutFlexItem16, null, /* @__PURE__ */React98.createElement(EGDSText35, {
    size: 200
  }, title.subText))), data.dialog && /* @__PURE__ */React98.createElement(UnitCategorizationComplexDialog, {
    data: data.dialog
  }), !data.dialog && data.complexDialog && /* @__PURE__ */React98.createElement(SelectionHeaderDialog, {
    data: data.complexDialog
  })));
};
SelectionHeader.fragment = fragment49;
SelectionHeader.displayName = "SelectionHeader";
// src/components/property-offers/__private/__fragments/listings/sections/radio-group-extension.tsx
var RadioGroupExtension = function (param) {
  var selectionHeader = param.selectionHeader,
    radioGroup = param.radioGroup,
    children = param.children,
    unitCategorizationKey = param.unitCategorizationKey,
    handleChange = param.handleChange,
    selectedIndex = param.selectedIndex,
    listingIndex = param.listingIndex;
  var groupName = "".concat(unitCategorizationKey, "-").concat(radioGroup, "-").concat(listingIndex);
  return /* @__PURE__ */React99.createElement(React99.Fragment, null, selectionHeader && /* @__PURE__ */React99.createElement(SelectionHeader, {
    data: selectionHeader
  }), /* @__PURE__ */React99.createElement(RadioButtonDescriptionExtensionWithPositiveThemeGroup, {
    legendLabel: (selectionHeader === null || selectionHeader === void 0 ? void 0 : selectionHeader.title.text) || "",
    group: groupName,
    onChange: handleChange,
    selected: "".concat(unitCategorizationKey, "-").concat(radioGroup, "-").concat(selectedIndex),
    key: "".concat(unitCategorizationKey, "-").concat(radioGroup, "RadioGroup")
  }, children));
};
RadioGroupExtension.displayName = "RadioGroup";
// src/components/property-offers/__private/__fragments/listings/sections/unit-categorization.tsx
var UnitCategorizationPropertyUnitFragment = gql81(_templateObject81(), AvailabilityCta.fragment, LinkTrigger.fragment, UnitPropertyOffersDetailsDialog.fragment, RatePlanWithAmenities.fragment, RoomAmenitiesDescription.fragment, UnitCategorizationRatePlanFragment, SpaceDetails.fragment, UnitHighlights.fragment, UnitHighlights.fragment, LodgingReviewSection.fragment);
var UnitCategorizationSelectionFragment = gql81(_templateObject82());
var fragment50 = gql81(_templateObject83(), LodgingPlainFullscreenDialog.fragment, SelectionHeader.fragment, UnitCategorizationPropertyUnitFragment, UnitCategorizationSelectionFragment, FooterText.fragment);
var UnitCategorization = function (param) {
  var data = param.data,
    listingIndex = param.listingIndex;
  var _secondaryTarget_tertiarySelections;
  var primarySelections = data.primarySelections,
    primaryHeader = data.primaryHeader,
    secondaryHeader = data.secondaryHeader,
    tertiaryHeader = data.tertiaryHeader;
  var _React100_useContext = React100.useContext(UnitRateContext),
    primaryIndex = _React100_useContext.primaryIndex,
    secondaryIndex = _React100_useContext.secondaryIndex,
    tertiaryIndex = _React100_useContext.tertiaryIndex,
    handleRadio = _React100_useContext.handleRadio,
    radioSelections = _React100_useContext.radioSelections;
  var indexes = {
    primaryIndex: primaryIndex || 0,
    secondaryIndex: secondaryIndex || 0,
    tertiaryIndex: tertiaryIndex || 0
  };
  var _ref = primarySelections ? getSelections(primarySelections, indexes) : {
      secondaryTarget: void 0,
      secondarySelections: void 0
    },
    secondaryTarget = _ref.secondaryTarget,
    secondarySelections = _ref.secondarySelections;
  var isWithinDetailsDialog = React100.useContext(DialogContext11);
  var unitCategorizationKey = "".concat(isWithinDetailsDialog ? "dialog" : "LodgingCategorizedUnit", "-").concat(listingIndex);
  var _ref1 = radioSelections || {},
    hasPrimary = _ref1.hasPrimary,
    hasSecondary = _ref1.hasSecondary,
    hasTertiary = _ref1.hasTertiary;
  React100.useEffect(function () {
    if (primarySelections && primaryIndex !== void 0) {
      var _primarySelections_primaryIndex_primarySelection, _primarySelections_primaryIndex;
      var liveAnnounceMessage = (_primarySelections_primaryIndex = primarySelections[primaryIndex]) === null || _primarySelections_primaryIndex === void 0 ? void 0 : (_primarySelections_primaryIndex_primarySelection = _primarySelections_primaryIndex.primarySelection) === null || _primarySelections_primaryIndex_primarySelection === void 0 ? void 0 : _primarySelections_primaryIndex_primarySelection.liveAnnounceMessage;
      if (!liveAnnounceMessage) {
        return;
      }
      liveAnnounce(liveAnnounceMessage, Level.POLITE);
      setTimeout(function () {
        liveAnnounce("", Level.ASSERTIVE);
      }, 500);
    }
  }, [primarySelections, primaryIndex]);
  if (!primarySelections || !radioSelections) {
    return null;
  }
  return /* @__PURE__ */React100.createElement(EGDSSpacing56, {
    margin: !isWithinDetailsDialog ? {
      inline: "three",
      blockstart: "three"
    } : void 0
  }, /* @__PURE__ */React100.createElement("div", null, hasPrimary && /* @__PURE__ */React100.createElement(EGDSSpacing56, {
    padding: {
      inline: "half"
    }
  }, /* @__PURE__ */React100.createElement(EGDSCardContentSection8, {
    padded: false
  }, /* @__PURE__ */React100.createElement(RadioGroupExtension, {
    selectionHeader: primaryHeader,
    selectedIndex: primaryIndex,
    handleChange: handleRadio,
    unitCategorizationKey: unitCategorizationKey,
    radioGroup: "roomFeatures",
    listingIndex: listingIndex
  }, primarySelections.map(function (option, index) {
    var _option_primarySelection, _option_primarySelection1, _option_primarySelection2, _option_primarySelection3, _option_primarySelection4;
    var key = "".concat(unitCategorizationKey, "-roomFeatures-").concat(index);
    var _option_primarySelection_stylizedSubTexts;
    return /* @__PURE__ */React100.createElement(RadioButtonDescriptionExtensionWithPositiveTheme, {
      description: (option === null || option === void 0 ? void 0 : (_option_primarySelection = option.primarySelection) === null || _option_primarySelection === void 0 ? void 0 : _option_primarySelection.subText) || "",
      descriptionList: _to_consumable_array((_option_primarySelection_stylizedSubTexts = option === null || option === void 0 ? void 0 : (_option_primarySelection1 = option.primarySelection) === null || _option_primarySelection1 === void 0 ? void 0 : _option_primarySelection1.stylizedSubTexts) !== null && _option_primarySelection_stylizedSubTexts !== void 0 ? _option_primarySelection_stylizedSubTexts : []),
      id: key,
      key: key,
      labelSuffix: (option === null || option === void 0 ? void 0 : (_option_primarySelection2 = option.primarySelection) === null || _option_primarySelection2 === void 0 ? void 0 : _option_primarySelection2.price) || "",
      value: key,
      a11yLabel: option === null || option === void 0 ? void 0 : (_option_primarySelection3 = option.primarySelection) === null || _option_primarySelection3 === void 0 ? void 0 : _option_primarySelection3.description
    }, (option === null || option === void 0 ? void 0 : (_option_primarySelection4 = option.primarySelection) === null || _option_primarySelection4 === void 0 ? void 0 : _option_primarySelection4.description) && /* @__PURE__ */React100.createElement("span", {
      "aria-hidden": "true"
    }, option.primarySelection.description));
  })))), hasSecondary && /* @__PURE__ */React100.createElement(EGDSSpacing56, {
    padding: {
      inline: "half"
    },
    margin: hasPrimary ? {
      blockstart: "two"
    } : void 0
  }, /* @__PURE__ */React100.createElement(EGDSCardContentSection8, {
    padded: hasPrimary ? ["blockstart"] : false,
    border: hasPrimary ? "top" : void 0
  }, /* @__PURE__ */React100.createElement(RadioGroupExtension, {
    selectionHeader: secondaryHeader,
    selectedIndex: secondaryIndex,
    handleChange: handleRadio,
    unitCategorizationKey: unitCategorizationKey,
    radioGroup: "cancellationPolicy",
    listingIndex: listingIndex
  }, secondarySelections === null || secondarySelections === void 0 ? void 0 : secondarySelections.map(function (option, index) {
    var _option_secondarySelection, _option_secondarySelection1, _option_secondarySelection2, _option_secondarySelection3, _option_secondarySelection4, _option_secondarySelection5, _option_secondarySelection6;
    var key = "".concat(unitCategorizationKey, "-cancellationPolicy-").concat(index);
    var _option_secondarySelection_stylizedSubTexts;
    return /* @__PURE__ */React100.createElement(RadioButtonDescriptionExtensionWithPositiveTheme, {
      description: (option === null || option === void 0 ? void 0 : (_option_secondarySelection = option.secondarySelection) === null || _option_secondarySelection === void 0 ? void 0 : _option_secondarySelection.subText) || "",
      descriptionList: _to_consumable_array((_option_secondarySelection_stylizedSubTexts = option === null || option === void 0 ? void 0 : (_option_secondarySelection1 = option.secondarySelection) === null || _option_secondarySelection1 === void 0 ? void 0 : _option_secondarySelection1.stylizedSubTexts) !== null && _option_secondarySelection_stylizedSubTexts !== void 0 ? _option_secondarySelection_stylizedSubTexts : []),
      disabled: !(option === null || option === void 0 ? void 0 : (_option_secondarySelection2 = option.secondarySelection) === null || _option_secondarySelection2 === void 0 ? void 0 : _option_secondarySelection2.enabled) || false,
      id: key,
      key: key,
      labelSuffix: (option === null || option === void 0 ? void 0 : (_option_secondarySelection3 = option.secondarySelection) === null || _option_secondarySelection3 === void 0 ? void 0 : _option_secondarySelection3.price) || "",
      value: key,
      a11yLabel: option === null || option === void 0 ? void 0 : (_option_secondarySelection4 = option.secondarySelection) === null || _option_secondarySelection4 === void 0 ? void 0 : _option_secondarySelection4.description
    }, (option === null || option === void 0 ? void 0 : (_option_secondarySelection5 = option.secondarySelection) === null || _option_secondarySelection5 === void 0 ? void 0 : _option_secondarySelection5.description) && /* @__PURE__ */React100.createElement("span", {
      "aria-hidden": "true"
    }, option.secondarySelection.description), (option === null || option === void 0 ? void 0 : (_option_secondarySelection6 = option.secondarySelection) === null || _option_secondarySelection6 === void 0 ? void 0 : _option_secondarySelection6.dialog) && /* @__PURE__ */React100.createElement("div", null, /* @__PURE__ */React100.createElement(LodgingPlainFullscreenDialog, {
      key: "".concat(key, "-dialog"),
      isHtmlContent: true,
      uniqueDialogId: "".concat(key, "-dialog"),
      spacing: {
        padding: {
          block: "two"
        }
      },
      data: option.secondarySelection.dialog
    })));
  })))), hasTertiary && /* @__PURE__ */React100.createElement(EGDSSpacing56, {
    padding: {
      inline: "half"
    },
    margin: hasPrimary || hasSecondary ? {
      blockstart: "two"
    } : void 0
  }, /* @__PURE__ */React100.createElement(EGDSCardContentSection8, {
    padded: hasPrimary || hasSecondary ? ["blockstart"] : false,
    border: hasPrimary || hasSecondary ? "top" : void 0
  }, /* @__PURE__ */React100.createElement(RadioGroupExtension, {
    handleChange: handleRadio,
    radioGroup: "extras",
    selectionHeader: tertiaryHeader,
    unitCategorizationKey: unitCategorizationKey,
    selectedIndex: tertiaryIndex,
    listingIndex: listingIndex
  }, secondaryTarget === null || secondaryTarget === void 0 ? void 0 : (_secondaryTarget_tertiarySelections = secondaryTarget.tertiarySelections) === null || _secondaryTarget_tertiarySelections === void 0 ? void 0 : _secondaryTarget_tertiarySelections.map(function (option, index) {
    var key = "".concat(unitCategorizationKey, "-extras-").concat(index);
    var _option_stylizedSubTexts, _option_price;
    return /* @__PURE__ */React100.createElement(RadioButtonDescriptionExtensionWithPositiveTheme, {
      description: (option === null || option === void 0 ? void 0 : option.subText) || "",
      descriptionList: _to_consumable_array((_option_stylizedSubTexts = option === null || option === void 0 ? void 0 : option.stylizedSubTexts) !== null && _option_stylizedSubTexts !== void 0 ? _option_stylizedSubTexts : []),
      disabled: !option.enabled,
      id: key,
      key: key,
      labelSuffix: (_option_price = option === null || option === void 0 ? void 0 : option.price) !== null && _option_price !== void 0 ? _option_price : "",
      value: key,
      a11yLabel: (option === null || option === void 0 ? void 0 : option.accessibilityLabel) || (option === null || option === void 0 ? void 0 : option.description)
    }, (option === null || option === void 0 ? void 0 : option.description) && /* @__PURE__ */React100.createElement("span", {
      "aria-hidden": "true"
    }, option.description), (option === null || option === void 0 ? void 0 : option.dialog) && /* @__PURE__ */React100.createElement("div", null, /* @__PURE__ */React100.createElement(LodgingPlainFullscreenDialog, {
      key: "".concat(key, "-dialog"),
      isHtmlContent: true,
      uniqueDialogId: "".concat(key, "-dialog"),
      spacing: {
        padding: {
          block: "two"
        }
      },
      data: option.dialog
    })));
  }))))));
};
UnitCategorization.fragment = fragment50;
UnitCategorization.displayName = "UnitCategorization";
// src/components/property-offers/__private/__fragments/listings/property-unit-categorization/property-unit-card.tsx
import React104, { useMemo as useMemo3 } from "react";
import { gql as gql82 } from "@apollo/client";
import { EGDSCard as EGDSCard15, EGDSCardContentSection as EGDSCardContentSection10, EGDSCardFeaturedHeader } from "@egds/react-core/cards";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType4 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex23, EGDSLayoutFlexItem as EGDSLayoutFlexItem18 } from "@egds/react-core/layout-flex";
import { withUitkLayoutGrid } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition3 } from "@egds/react-core/layout-position";
import { EGDSList as EGDSList7 } from "@egds/react-core/list";
import { EGDSSheetTransition as EGDSSheetTransition15 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing59 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker29, useEgClickstream as useEgClickstream12 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog17 } from "@shared-ui/dialog-context";
import { useExperiment as useExperiment7 } from "@shared-ui/experiment-context";
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/sections/dialog-unit-categorization.tsx
import React101 from "react";
import { EGDSCard as EGDSCard14, EGDSCardContentSection as EGDSCardContentSection9 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex22, EGDSLayoutFlexItem as EGDSLayoutFlexItem17 } from "@egds/react-core/layout-flex";
import { EGDSScrollable } from "@egds/react-core/scrollable";
import { EGDSSpacing as EGDSSpacing57 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading20 } from "@egds/react-core/text";
var DialogUnitCategorization = function (param) {
  var data = param.data,
    listingIndex = param.listingIndex,
    roomId = param.roomId,
    closeDialog = param.closeDialog;
  var _data_primarySelections_find, _data_primarySelections, _propertyUnit_ratePlans, _detailsDialog_content_ratePlanTitle, _detailsDialog_content;
  var propertyUnit = data === null || data === void 0 ? void 0 : (_data_primarySelections = data.primarySelections) === null || _data_primarySelections === void 0 ? void 0 : (_data_primarySelections_find = _data_primarySelections.find(function () {
    return true;
  })) === null || _data_primarySelections_find === void 0 ? void 0 : _data_primarySelections_find.propertyUnit;
  var detailsDialog = propertyUnit === null || propertyUnit === void 0 ? void 0 : propertyUnit.detailsDialog;
  var hasRatePlans = Boolean(propertyUnit === null || propertyUnit === void 0 ? void 0 : (_propertyUnit_ratePlans = propertyUnit.ratePlans) === null || _propertyUnit_ratePlans === void 0 ? void 0 : _propertyUnit_ratePlans.length);
  var highlightedMessages = data.highlightedMessages;
  var alignAvailabilityCta = "end";
  var isSimplifiedAddOnsDrawer = useMicroRoomCard().isSimplifiedAddOnsDrawer;
  if (!hasRatePlans) {
    return /* @__PURE__ */React101.createElement(EGDSSpacing57, {
      margin: {
        blockend: "unset"
      }
    }, /* @__PURE__ */React101.createElement("div", null, /* @__PURE__ */React101.createElement(EGDSLayoutFlex22, {
      direction: "column"
    }, /* @__PURE__ */React101.createElement(EGDSLayoutFlexItem17, {
      alignSelf: alignAvailabilityCta,
      grow: 0
    }, /* @__PURE__ */React101.createElement("div", null, /* @__PURE__ */React101.createElement(AvailabilityCta, {
      data: propertyUnit,
      listingIndex: listingIndex,
      closeDialog: closeDialog
    }))))));
  }
  if (isSimplifiedAddOnsDrawer) {
    return /* @__PURE__ */React101.createElement(EGDSCard14, null, /* @__PURE__ */React101.createElement(EGDSLayoutFlex22, {
      direction: "column"
    }, /* @__PURE__ */React101.createElement(EGDSLayoutFlexItem17, {
      shrink: 1
    }, /* @__PURE__ */React101.createElement(EGDSScrollable, {
      direction: "vertical"
    }, /* @__PURE__ */React101.createElement(EGDSSpacing57, {
      padding: "three"
    }, /* @__PURE__ */React101.createElement("div", null, /* @__PURE__ */React101.createElement(UnitCategorization, {
      data: data,
      listingIndex: listingIndex
    }))))), /* @__PURE__ */React101.createElement(EGDSLayoutFlexItem17, null, /* @__PURE__ */React101.createElement(EGDSCardContentSection9, {
      border: "top",
      padded: true
    }, /* @__PURE__ */React101.createElement(UnitCategorizationRatePlan, {
      listingIndex: listingIndex,
      roomId: roomId,
      highlightedMessages: highlightedMessages
    }), /* @__PURE__ */React101.createElement(AvailabilityCta, {
      data: propertyUnit,
      listingIndex: listingIndex
    })))));
  }
  return /* @__PURE__ */React101.createElement(EGDSCard14, {
    border: true,
    padded: true,
    overflow: true
  }, /* @__PURE__ */React101.createElement(EGDSCardContentSection9, null, /* @__PURE__ */React101.createElement(EGDSSpacing57, {
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React101.createElement(EGDSHeading20, {
    tag: "h3",
    size: 5
  }, detailsDialog === null || detailsDialog === void 0 ? void 0 : (_detailsDialog_content = detailsDialog.content) === null || _detailsDialog_content === void 0 ? void 0 : (_detailsDialog_content_ratePlanTitle = _detailsDialog_content.ratePlanTitle) === null || _detailsDialog_content_ratePlanTitle === void 0 ? void 0 : _detailsDialog_content_ratePlanTitle.text)), /* @__PURE__ */React101.createElement(UnitCategorization, {
    data: data,
    listingIndex: listingIndex
  }), /* @__PURE__ */React101.createElement(EGDSSpacing57, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React101.createElement("div", null, /* @__PURE__ */React101.createElement(UnitCategorizationRatePlan, {
    listingIndex: listingIndex,
    roomId: roomId,
    highlightedMessages: highlightedMessages,
    onClose: closeDialog
  }))), /* @__PURE__ */React101.createElement(AvailabilityCta, {
    data: propertyUnit,
    listingIndex: listingIndex
  })));
};
DialogUnitCategorization.displayName = "DialogUnitCategorization";
// src/components/property-offers/__private/__fragments/listings/sections/media-section.tsx
import React102 from "react";
import { UitkGalleryCarousel as EGDSGalleryCarousel2 } from "@egds/react-core/gallery-carousel";
import { EGDSFigure as EGDSFigure3, EGDSImage as EGDSImage3 } from "@egds/react-core/images";
import { IntersectionTracker as IntersectionTracker10, useClickTracker as useClickTracker28, useEgClickstream as useEgClickstream11 } from "@shared-ui/clickstream-analytics-context";
var MediaSection = function (param) {
  var listingIndex = param.listingIndex,
    listingName = param.listingName,
    unitGallery = param.unitGallery,
    className = param.className,
    imageRatio = param.imageRatio,
    handleCarouselImageClick = param.handleCarouselImageClick,
    roomSchemaMessageContent = param.roomSchemaMessageContent,
    propertyId = param.propertyId;
  var _currentImage_image_thumbnailClickAnalytics, _unitGallery_images_currentMediaIndex, _unitGallery_images_currentMediaIndex1;
  var _unitGallery_images_map;
  var srcImages = (_unitGallery_images_map = unitGallery === null || unitGallery === void 0 ? void 0 : unitGallery.images.map(function (param) {
    var image = param.image;
    return {
      src: image.url,
      alt: image.description
    };
  })) !== null && _unitGallery_images_map !== void 0 ? _unitGallery_images_map : [];
  var galleryLength = (unitGallery === null || unitGallery === void 0 ? void 0 : unitGallery.images.length) || 0;
  var track = useClickTracker28();
  var trackEgClickstreamEvent = useEgClickstream11();
  var repeatedGalleryIndex = listingIndex ? (listingIndex - 1).toString() : "0";
  var _React102_useState = _sliced_to_array(React102.useState(0), 2),
    currentMediaIndex = _React102_useState[0],
    setCurrentMediaIndex = _React102_useState[1];
  var carouselId = "property-offers-media-carousel-".concat(listingIndex);
  var currentImage = unitGallery === null || unitGallery === void 0 ? void 0 : unitGallery.images[currentMediaIndex];
  var isImageThumbnailClickAnalytics = currentImage === null || currentImage === void 0 ? void 0 : currentImage.image.thumbnailClickAnalytics;
  var analyticsId = "".concat(currentImage === null || currentImage === void 0 ? void 0 : (_currentImage_image_thumbnailClickAnalytics = currentImage.image.thumbnailClickAnalytics) === null || _currentImage_image_thumbnailClickAnalytics === void 0 ? void 0 : _currentImage_image_thumbnailClickAnalytics.referrerId);
  var _React102_useContext = React102.useContext(UnitRateContext),
    ratePlan = _React102_useContext.ratePlan,
    roomTypeId = _React102_useContext.roomTypeId;
  var mediaClickstreamTracking = React102.useMemo(function () {
    if (roomTypeId && (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.id)) {
      return buildRoomsAndRatesClientPayload("room_rate_plan_image.selected" /* ROOM_RATE_PLAN_IMAGE_SELECTED */, roomTypeId, ratePlan.id);
    }
  }, [roomTypeId, ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.id]);
  var handleCurrentMediaIndexChange = function (index) {
    setCurrentMediaIndex(index);
    if (mediaClickstreamTracking) {
      trackEgClickstreamEvent(mediaClickstreamTracking);
    }
  };
  React102.useEffect(function () {
    setCurrentMediaIndex(0);
  }, [carouselId]);
  var trackControlAnalytics = function () {
    if (isImageThumbnailClickAnalytics) {
      var _currentImage_image_thumbnailClickAnalytics;
      return {
        id: analyticsId,
        description: "".concat(currentImage === null || currentImage === void 0 ? void 0 : (_currentImage_image_thumbnailClickAnalytics = currentImage.image.thumbnailClickAnalytics) === null || _currentImage_image_thumbnailClickAnalytics === void 0 ? void 0 : _currentImage_image_thumbnailClickAnalytics.linkName),
        callback: function (id, desc) {
          var _unitGallery_images_currentMediaIndex, _unitGallery_images_currentMediaIndex1;
          var currentImageIndex = getCarouselNextIndex(currentMediaIndex, galleryLength, id);
          var uisMicroMessages2 = additionalUisPrimeMicroMessages(currentImageIndex, (unitGallery === null || unitGallery === void 0 ? void 0 : (_unitGallery_images_currentMediaIndex = unitGallery.images[currentMediaIndex]) === null || _unitGallery_images_currentMediaIndex === void 0 ? void 0 : _unitGallery_images_currentMediaIndex.trackingId) || "", galleryLength, (unitGallery === null || unitGallery === void 0 ? void 0 : (_unitGallery_images_currentMediaIndex1 = unitGallery.images[currentMediaIndex]) === null || _unitGallery_images_currentMediaIndex1 === void 0 ? void 0 : _unitGallery_images_currentMediaIndex1.imageId) || "", propertyId, "PDP_ROOMS_AND_RATES" /* PDP_ROOMS_AND_RATES */, repeatedGalleryIndex);
          if (roomSchemaMessageContent) {
            uisMicroMessages2.push({
              schemaName: "room",
              messageContent: JSON.parse(roomSchemaMessageContent)
            });
          }
          track(id, desc, void 0, uisMicroMessages2);
        }
      };
    }
  };
  var controlAnalytics = React102.useMemo(function () {
    return trackControlAnalytics();
  }, [track]);
  var handleClick = function () {
    if (mediaClickstreamTracking) {
      trackEgClickstreamEvent(mediaClickstreamTracking);
    }
    if (isImageThumbnailClickAnalytics) {
      var _currentImage_image_thumbnailClickAnalytics, _unitGallery_images_currentMediaIndex, _unitGallery_images_currentMediaIndex1;
      var referrerId = "".concat(analyticsId, ".").concat(currentMediaIndex);
      var linkName = "".concat(currentImage === null || currentImage === void 0 ? void 0 : (_currentImage_image_thumbnailClickAnalytics = currentImage.image.thumbnailClickAnalytics) === null || _currentImage_image_thumbnailClickAnalytics === void 0 ? void 0 : _currentImage_image_thumbnailClickAnalytics.linkName);
      track(referrerId, linkName, void 0, additionalUisPrimeMicroMessages(currentMediaIndex, (unitGallery === null || unitGallery === void 0 ? void 0 : (_unitGallery_images_currentMediaIndex = unitGallery.images[currentMediaIndex]) === null || _unitGallery_images_currentMediaIndex === void 0 ? void 0 : _unitGallery_images_currentMediaIndex.trackingId) || "", galleryLength, (unitGallery === null || unitGallery === void 0 ? void 0 : (_unitGallery_images_currentMediaIndex1 = unitGallery.images[currentMediaIndex]) === null || _unitGallery_images_currentMediaIndex1 === void 0 ? void 0 : _unitGallery_images_currentMediaIndex1.imageId) || "", propertyId, "PDP_ROOMS_AND_RATES" /* PDP_ROOMS_AND_RATES */, repeatedGalleryIndex));
    }
    handleCarouselImageClick === null || handleCarouselImageClick === void 0 ? void 0 : handleCarouselImageClick();
  };
  var handleMediaButtonClick = React102.useCallback(function () {
    if (mediaClickstreamTracking) {
      trackEgClickstreamEvent(mediaClickstreamTracking);
    }
    handleCarouselImageClick === null || handleCarouselImageClick === void 0 ? void 0 : handleCarouselImageClick();
  }, [roomTypeId, ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.id]);
  var galleryCarousel = /* @__PURE__ */React102.createElement(EGDSGalleryCarousel2, {
    allyHeadingText: (unitGallery === null || unitGallery === void 0 ? void 0 : unitGallery.accessibilityLabel) || "",
    triggerA11yText: (unitGallery === null || unitGallery === void 0 ? void 0 : unitGallery.accessibilityLabel) || "",
    analytics: controlAnalytics,
    carouselName: "PhotoGallery",
    carouselId: carouselId,
    listingName: listingName,
    className: className,
    images: srcImages,
    onImageClick: handleClick,
    onMediaButtonClick: handleMediaButtonClick,
    ratio: imageRatio,
    onIndexChange: handleCurrentMediaIndexChange,
    currentIndex: currentMediaIndex,
    showGalleryButton: true
  });
  var uisMicroMessages = additionalUisPrimeMicroMessages(currentMediaIndex, (unitGallery === null || unitGallery === void 0 ? void 0 : (_unitGallery_images_currentMediaIndex = unitGallery.images[currentMediaIndex]) === null || _unitGallery_images_currentMediaIndex === void 0 ? void 0 : _unitGallery_images_currentMediaIndex.trackingId) || "", galleryLength, (unitGallery === null || unitGallery === void 0 ? void 0 : (_unitGallery_images_currentMediaIndex1 = unitGallery.images[currentMediaIndex]) === null || _unitGallery_images_currentMediaIndex1 === void 0 ? void 0 : _unitGallery_images_currentMediaIndex1.imageId) || "", propertyId, "PDP_ROOMS_AND_RATES" /* PDP_ROOMS_AND_RATES */, repeatedGalleryIndex);
  if (roomSchemaMessageContent) {
    uisMicroMessages.push({
      schemaName: "room",
      messageContent: JSON.parse(roomSchemaMessageContent)
    });
  }
  var galleryIntersectionWrapper = (currentImage === null || currentImage === void 0 ? void 0 : currentImage.impressionAnalytics) ? /* @__PURE__ */React102.createElement(IntersectionTracker10, {
    tag: "span",
    referrerId: "".concat(currentImage.impressionAnalytics.referrerId, ".").concat(repeatedGalleryIndex),
    linkName: currentImage.impressionAnalytics.linkName || "",
    trackOnce: true,
    additionalUisPrimeMicroMessages: uisMicroMessages
  }, galleryCarousel) : /* @__PURE__ */React102.createElement(React102.Fragment, null, galleryCarousel);
  return /* @__PURE__ */React102.createElement("div", null, srcImages.length === 0 ? /* @__PURE__ */React102.createElement(EGDSFigure3, {
    className: className,
    ratio: imageRatio
  }, /* @__PURE__ */React102.createElement(EGDSImage3, {
    placeholderImage: true
  })) : /* @__PURE__ */React102.createElement(React102.Fragment, null, galleryIntersectionWrapper));
};
MediaSection.displayName = "MediaSection";
// src/components/property-offers/__private/__fragments/listings/property-unit-categorization/micro-room-card/micro-room-card-footer-button.tsx
import React103 from "react";
import { EGDSPrimaryButton as EGDSPrimaryButton8 } from "@egds/react-core/button";
import { EGDSSpacing as EGDSSpacing58 } from "@egds/react-core/spacing";
var MicroRoomCardFooterButton = function (param) {
  var footerButton = param.footerButton,
    onClick = param.onClick;
  if (!footerButton) {
    return null;
  }
  var primary = footerButton.primary,
    accessibility = footerButton.accessibility;
  return /* @__PURE__ */React103.createElement(EGDSSpacing58, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React103.createElement("div", null, /* @__PURE__ */React103.createElement(EGDSPrimaryButton8, {
    "data-stid": "see-options-dialog",
    onClick: onClick,
    "aria-label": accessibility || void 0,
    isFullWidth: true
  }, primary)));
};
// src/components/property-offers/__private/__fragments/listings/property-unit-categorization/property-unit-card.tsx
var __PropertyUnitCardFragment = gql82(_templateObject84(), PropertyOffersHeader.fragment, PropertyFeatures.fragment, PropertyBaseFeatures.fragment, RatePlanMessage.fragment, ExpandoItemsCard.fragment, UnitCategorization.fragment, LodgingReviewSection.fragment);
var PropertyUnitCard = function (param) {
  var data = param.data,
    listingIndex = param.listingIndex,
    _param_isMicroRoomCardCarouselVariant = param.isMicroRoomCardCarouselVariant,
    isMicroRoomCardCarouselVariant = _param_isMicroRoomCardCarouselVariant === void 0 ? false : _param_isMicroRoomCardCarouselVariant,
    propertyId = param.propertyId,
    _param_showRoomHighlights = param.showRoomHighlights,
    showRoomHighlights = _param_showRoomHighlights === void 0 ? false : _param_showRoomHighlights,
    targetItem = param.targetItem;
  var _data_primarySelections_primaryIndex, _data_primarySelections, _context_device;
  var features = data.features,
    header = data.header,
    highlightedMessages = data.highlightedMessages,
    featureHeader = data.featureHeader,
    expandoItemsCard = data.expandoItemsCard,
    lodgingReview = data.lodgingReview,
    baseFeatures = data.baseFeatures;
  var _React104_useState = _sliced_to_array(React104.useState(""), 2),
    dialogCloseReferrerId = _React104_useState[0],
    setDialogCloseReferrerId = _React104_useState[1];
  var _React104_useState1 = _sliced_to_array(React104.useState(""), 2),
    dialogCloseLinkName = _React104_useState1[0],
    setDialogCloseLinkName = _React104_useState1[1];
  var trackClick = useClickTracker29();
  var trackEgClickstreamEvent = useEgClickstream12();
  var primaryIndex = React104.useContext(UnitRateContext).primaryIndex;
  var propertyUnit = (_data_primarySelections = data.primarySelections) === null || _data_primarySelections === void 0 ? void 0 : (_data_primarySelections_primaryIndex = _data_primarySelections[primaryIndex]) === null || _data_primarySelections_primaryIndex === void 0 ? void 0 : _data_primarySelections_primaryIndex.propertyUnit;
  var _ref = propertyUnit !== null && propertyUnit !== void 0 ? propertyUnit : {},
    _ref_id = _ref.id,
    id = _ref_id === void 0 ? "" : _ref_id,
    detailsDialog = _ref.detailsDialog,
    ratePlans = _ref.ratePlans,
    unitGallery = _ref.unitGallery;
  var _React104_useContext = React104.useContext(UnitRateContext),
    ratePlan = _React104_useContext.ratePlan,
    radioSelections = _React104_useContext.radioSelections,
    roomTypeId = _React104_useContext.roomTypeId,
    setHasRecommendationValue = _React104_useContext.setHasRecommendationValue;
  var context = useBexApi4().context;
  var isMobile = (context === null || context === void 0 ? void 0 : (_context_device = context.device) === null || _context_device === void 0 ? void 0 : _context_device.type) === "MOBILE_PHONE" /* MOBILE_PHONE */;
  var shareUrl = ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.shareUrl;
  var footerButton = data.footerButton;
  var hasSelections = Boolean(radioSelections);
  var isMicroRoomCardRatesDialog = !!footerButton;
  var isMicroRoomCardCarousel = isMobile && isMicroRoomCardCarouselVariant;
  var _useDialog17 = _sliced_to_array(useDialog17("room-info-".concat(id, "-").concat(listingIndex), "propertyUnitRoomInfoDialog"), 3),
    isDialogOpen = _useDialog17[0],
    dialogActions = _useDialog17[1],
    DialogComponent = _useDialog17[2];
  var _React104_useState2 = _sliced_to_array(React104.useState(false), 2),
    isSeeOptionsDialogLayout = _React104_useState2[0],
    setIsSeeOptionsDialogLayout = _React104_useState2[1];
  var _React104_useState3 = _sliced_to_array(React104.useState(false), 2),
    isSimplifiedAddOnsDrawer = _React104_useState3[0],
    setIsSimplifiedAddOnsDrawer = _React104_useState3[1];
  var closeMoreDetailsDialog = React104.useCallback(function () {
    if (isDialogOpen) {
      dialogActions.closeDialog({
        closeAllDialogs: true
      });
    }
    trackClick(dialogCloseReferrerId, dialogCloseLinkName);
    setTimeout(function () {
      setIsSeeOptionsDialogLayout(false);
      setIsSimplifiedAddOnsDrawer(false);
    }, 100);
  }, [dialogActions, trackClick, dialogCloseReferrerId, dialogCloseLinkName, isDialogOpen]);
  var _useExperiment7 = useExperiment7("SmaSh_Simplified_Addons_Drawer_mweb", false),
    simplifiedAddOnsDrawerExposure = _useExperiment7.exposure,
    logExperiment = _useExperiment7.logExperiment;
  var simplifiedAddOnsDrawerBucket = simplifiedAddOnsDrawerExposure.bucket;
  var openMoreDetailsDialog = function (propertyUnitDetailsDialog) {
    var isSeeOptionsDialog = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function () {
      var _footerButton_analytics, _propertyUnitDetailsDialog_trigger_clientSideAnalytics, _propertyUnitDetailsDialog_trigger, _footerButton_analytics1, _propertyUnitDetailsDialog_trigger_clientSideAnalytics1, _propertyUnitDetailsDialog_trigger1, _propertyUnitDetailsDialog_toolbar_clientSideAnalytics, _propertyUnitDetailsDialog_toolbar, _propertyUnitDetailsDialog_toolbar_clientSideAnalytics1, _propertyUnitDetailsDialog_toolbar1;
      setIsSeeOptionsDialogLayout(isSeeOptionsDialog);
      var nextIsSimplifiedAddOnsDrawer = isSeeOptionsDialog && (isMobile && simplifiedAddOnsDrawerBucket === 1 || !isMobile && isMicroRoomCardRatesDialog);
      setIsSimplifiedAddOnsDrawer(nextIsSimplifiedAddOnsDrawer);
      var referrerId = isSeeOptionsDialog ? (footerButton === null || footerButton === void 0 ? void 0 : (_footerButton_analytics = footerButton.analytics) === null || _footerButton_analytics === void 0 ? void 0 : _footerButton_analytics.referrerId) || "" : "".concat(propertyUnitDetailsDialog === null || propertyUnitDetailsDialog === void 0 ? void 0 : (_propertyUnitDetailsDialog_trigger = propertyUnitDetailsDialog.trigger) === null || _propertyUnitDetailsDialog_trigger === void 0 ? void 0 : (_propertyUnitDetailsDialog_trigger_clientSideAnalytics = _propertyUnitDetailsDialog_trigger.clientSideAnalytics) === null || _propertyUnitDetailsDialog_trigger_clientSideAnalytics === void 0 ? void 0 : _propertyUnitDetailsDialog_trigger_clientSideAnalytics.referrerId, ".").concat(id, ".").concat(ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.id);
      var linkName = isSeeOptionsDialog ? (footerButton === null || footerButton === void 0 ? void 0 : (_footerButton_analytics1 = footerButton.analytics) === null || _footerButton_analytics1 === void 0 ? void 0 : _footerButton_analytics1.linkName) || "" : (propertyUnitDetailsDialog === null || propertyUnitDetailsDialog === void 0 ? void 0 : (_propertyUnitDetailsDialog_trigger1 = propertyUnitDetailsDialog.trigger) === null || _propertyUnitDetailsDialog_trigger1 === void 0 ? void 0 : (_propertyUnitDetailsDialog_trigger_clientSideAnalytics1 = _propertyUnitDetailsDialog_trigger1.clientSideAnalytics) === null || _propertyUnitDetailsDialog_trigger_clientSideAnalytics1 === void 0 ? void 0 : _propertyUnitDetailsDialog_trigger_clientSideAnalytics1.linkName) || "Open Room Gallery dialog";
      var detailsDialogCloseReferrerId = nextIsSimplifiedAddOnsDrawer ? "HOT.HIS.AddOnsDrawer.Close" : (propertyUnitDetailsDialog === null || propertyUnitDetailsDialog === void 0 ? void 0 : (_propertyUnitDetailsDialog_toolbar = propertyUnitDetailsDialog.toolbar) === null || _propertyUnitDetailsDialog_toolbar === void 0 ? void 0 : (_propertyUnitDetailsDialog_toolbar_clientSideAnalytics = _propertyUnitDetailsDialog_toolbar.clientSideAnalytics) === null || _propertyUnitDetailsDialog_toolbar_clientSideAnalytics === void 0 ? void 0 : _propertyUnitDetailsDialog_toolbar_clientSideAnalytics.referrerId) || "Room.InfoDialog.PhotoGallery".concat(listingIndex, ".Close");
      var detailsDialogCloseLinkName = nextIsSimplifiedAddOnsDrawer ? "Close add-ons drawer" : (propertyUnitDetailsDialog === null || propertyUnitDetailsDialog === void 0 ? void 0 : (_propertyUnitDetailsDialog_toolbar1 = propertyUnitDetailsDialog.toolbar) === null || _propertyUnitDetailsDialog_toolbar1 === void 0 ? void 0 : (_propertyUnitDetailsDialog_toolbar_clientSideAnalytics1 = _propertyUnitDetailsDialog_toolbar1.clientSideAnalytics) === null || _propertyUnitDetailsDialog_toolbar_clientSideAnalytics1 === void 0 ? void 0 : _propertyUnitDetailsDialog_toolbar_clientSideAnalytics1.linkName) || "Close Room Info dialog";
      dialogActions.openDialog();
      if (roomTypeId && (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.id)) {
        trackEgClickstreamEvent(buildRoomsAndRatesClientPayload(isMobile && isSeeOptionsDialog ? "options_button.selected" /* OPTIONS_BUTTON_SELECTED */ : "more_details.selected" /* MORE_DETAILS_SELECTED */, roomTypeId, ratePlan.id));
      }
      trackClick(referrerId, linkName);
      setDialogCloseReferrerId(detailsDialogCloseReferrerId);
      setDialogCloseLinkName(detailsDialogCloseLinkName);
      if (isMobile && isSeeOptionsDialog) {
        logExperiment(simplifiedAddOnsDrawerExposure);
      }
    };
  };
  var microRoomCardProviderValue = useMemo3(function () {
    return {
      isMicroRoomCardRatesDialog: isMicroRoomCardRatesDialog,
      isMicroRoomCardCarousel: isMicroRoomCardCarousel,
      listingIndex: listingIndex,
      hasSelections: hasSelections,
      isSeeOptionsDialogLayout: isSeeOptionsDialogLayout,
      isSimplifiedAddOnsDrawer: isSimplifiedAddOnsDrawer
    };
  }, [isMicroRoomCardRatesDialog, isMicroRoomCardCarousel, listingIndex, hasSelections, isSeeOptionsDialogLayout, isSimplifiedAddOnsDrawer]);
  if (!propertyUnit) {
    return null;
  }
  if (featureHeader && setHasRecommendationValue) {
    setHasRecommendationValue();
  }
  var BaseFeaturesListComponent = withUitkLayoutGrid(function (props) {
    return /* @__PURE__ */React104.createElement(EGDSList7, _object_spread_props(_object_spread({}, props), {
      bullet: "icon-standard",
      "data-stid": "base-features"
    }), baseFeatures && baseFeatures.length > 0 && baseFeatures.map(function (baseFeature) {
      var _baseFeature_primary;
      return baseFeature.primary && /* @__PURE__ */React104.createElement(PropertyBaseFeatures, {
        data: baseFeature,
        key: (_baseFeature_primary = baseFeature.primary) === null || _baseFeature_primary === void 0 ? void 0 : _baseFeature_primary.text
      });
    }));
  });
  var _header_text;
  return /* @__PURE__ */React104.createElement(MicroRoomCardProvider, {
    value: microRoomCardProviderValue
  }, /* @__PURE__ */React104.createElement(EGDSCard15, {
    border: true,
    overflow: true
  }, /* @__PURE__ */React104.createElement(EGDSLayoutFlex23, {
    direction: "column",
    justifyContent: "space-between",
    key: "property-offer-".concat(listingIndex),
    "data-stid": "property-offer-".concat(listingIndex),
    blockSize: "full_size"
  }, /* @__PURE__ */React104.createElement(EGDSLayoutFlexItem18, null, featureHeader && /* @__PURE__ */React104.createElement(EGDSLayoutPosition3, {
    type: "absolute",
    position: {
      left: "zero",
      top: "zero",
      right: "zero",
      zindex: "layer3"
    }
  }, /* @__PURE__ */React104.createElement(EGDSCardFeaturedHeader, {
    title: {
      tag: "h3",
      text: featureHeader.text
    }
  }))), /* @__PURE__ */React104.createElement(EGDSLayoutFlexItem18, null, /* @__PURE__ */React104.createElement("div", null, unitGallery && /* @__PURE__ */React104.createElement(MediaSection, {
    listingIndex: listingIndex,
    listingName: (_header_text = header === null || header === void 0 ? void 0 : header.text) !== null && _header_text !== void 0 ? _header_text : void 0,
    unitGallery: unitGallery,
    className: "uitk-rounded-border-top",
    imageRatio: isMicroRoomCardCarouselVariant ? EGDSFigureAspectRatioType4.R3_2 : EGDSFigureAspectRatioType4.R16_9,
    handleCarouselImageClick: dialogActions.openDialog,
    roomSchemaMessageContent: getRoomSchemaMessageContent(ratePlan),
    propertyId: propertyId
  }), /* @__PURE__ */React104.createElement(EGDSSpacing59, {
    padding: {
      blockstart: "three",
      blockend: "two",
      inline: "three"
    }
  }, /* @__PURE__ */React104.createElement("div", null, header && /* @__PURE__ */React104.createElement(PropertyOffersHeader, {
    data: header,
    reviewSection: lodgingReview !== null && lodgingReview !== void 0 ? lodgingReview : void 0,
    textSize: 6,
    roomId: id
  }), showRoomHighlights && propertyUnit.roomHighlights && /* @__PURE__ */React104.createElement(EGDSSpacing59, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React104.createElement("div", null, /* @__PURE__ */React104.createElement(UnitHighlights, {
    data: propertyUnit.roomHighlights
  }))), baseFeatures && baseFeatures.length > 0 && /* @__PURE__ */React104.createElement(EGDSSpacing59, {
    margin: {
      blockstart: "three",
      blockend: "four"
    }
  }, /* @__PURE__ */React104.createElement(BaseFeaturesListComponent, {
    autoColumns: null,
    columns: ["1fr 1fr"]
  })), features && features.length > 0 && /* @__PURE__ */React104.createElement(EGDSSpacing59, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React104.createElement(EGDSList7, {
    bullet: "icon-standard"
  }, features.map(function (feature, index) {
    return /* @__PURE__ */React104.createElement(PropertyFeatures, {
      data: feature,
      uniqueDialogId: "propertyunit-feature",
      key: "feature-".concat(index)
    });
  }))), /* @__PURE__ */React104.createElement(UnitCategorizationHighlightedMessages, {
    highlightedMessages: highlightedMessages,
    id: id
  }), (detailsDialog === null || detailsDialog === void 0 ? void 0 : detailsDialog.trigger) && /* @__PURE__ */React104.createElement(EGDSSpacing59, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React104.createElement(EGDSCardContentSection10, {
    "data-stid": "section-roomtype",
    padded: false
  }, /* @__PURE__ */React104.createElement(LinkTrigger, {
    data: detailsDialog === null || detailsDialog === void 0 ? void 0 : detailsDialog.trigger,
    openDialog: openMoreDetailsDialog(detailsDialog)
  }), /* @__PURE__ */React104.createElement(EGDSSheetTransition15, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React104.createElement(DialogComponent, null, /* @__PURE__ */React104.createElement(UnitPropertyOffersDetailsDialog, {
    closeDialog: closeMoreDetailsDialog,
    data: propertyUnit === null || propertyUnit === void 0 ? void 0 : propertyUnit.detailsDialog,
    isDialogOpen: isDialogOpen,
    listing: propertyUnit,
    expandoItemsCard: expandoItemsCard,
    ratePlans: /* @__PURE__ */React104.createElement(DialogUnitCategorization, {
      data: data,
      listingIndex: listingIndex,
      roomId: id,
      closeDialog: closeMoreDetailsDialog
    })
  }))))))), expandoItemsCard && /* @__PURE__ */React104.createElement(ExpandoItemsCard, {
    isWithinDetailsDialog: false,
    data: expandoItemsCard
  }), !isMicroRoomCardRatesDialog && !isMicroRoomCardCarousel && hasSelections && /* @__PURE__ */React104.createElement(EGDSCardContentSection10, {
    padded: false,
    border: "top"
  }, /* @__PURE__ */React104.createElement(UnitCategorization, {
    data: data,
    listingIndex: listingIndex
  })))), /* @__PURE__ */React104.createElement(EGDSLayoutFlexItem18, {
    alignSelf: !(ratePlans === null || ratePlans === void 0 ? void 0 : ratePlans.length) ? "end" : "stretch"
  }, /* @__PURE__ */React104.createElement(EGDSCardContentSection10, {
    padded: false,
    border: isMicroRoomCardRatesDialog || isMicroRoomCardCarousel && !propertyUnit.availabilityCallToAction ? "top" : void 0
  }, /* @__PURE__ */React104.createElement(EGDSSpacing59, {
    margin: "three"
  }, /* @__PURE__ */React104.createElement("div", null, /* @__PURE__ */React104.createElement(UnitCategorizationRatePlan, {
    listingIndex: listingIndex,
    roomId: id
  }), /* @__PURE__ */React104.createElement(AvailabilityCta, {
    data: propertyUnit,
    listingIndex: listingIndex,
    targetItem: targetItem
  }), shareUrl && /* @__PURE__ */React104.createElement(EGDSSpacing59, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React104.createElement("div", null, /* @__PURE__ */React104.createElement(MarketingSectionLink, {
    shareUrl: shareUrl
  }))), (isMicroRoomCardRatesDialog || isMicroRoomCardCarousel && hasSelections) && /* @__PURE__ */React104.createElement(MicroRoomCardFooterButton, {
    footerButton: footerButton,
    onClick: openMoreDetailsDialog(detailsDialog, true)
  }), /* @__PURE__ */React104.createElement(FooterText, {
    data: data
  }))))))));
};
PropertyUnitCard.displayName = "PropertyUnitCard";
PropertyUnitCard.fragment = __PropertyUnitCardFragment;
// src/components/property-offers/__private/__fragments/listings/property-unit-categorization/property-unit-categorization.tsx
var __PropertyUnitCategorizationFragment = gql83(_templateObject85(), PropertyOffersHeader.fragment, PropertyFeatures.fragment, PropertyBaseFeatures.fragment, RatePlanMessage.fragment, ExpandoItemsCard.fragment, UnitCategorization.fragment, LodgingReviewSection.fragment);
var PropertyUnitCategorization = function (param) {
  var data = param.data,
    listingIndex = param.listingIndex,
    _param_isMicroRoomCardCarouselVariant = param.isMicroRoomCardCarouselVariant,
    isMicroRoomCardCarouselVariant = _param_isMicroRoomCardCarouselVariant === void 0 ? false : _param_isMicroRoomCardCarouselVariant,
    propertyId = param.propertyId,
    _param_showRoomHighlights = param.showRoomHighlights,
    showRoomHighlights = _param_showRoomHighlights === void 0 ? false : _param_showRoomHighlights,
    targetItem = param.targetItem;
  var primarySelections = data.primarySelections;
  var _React105_useContext = React105.useContext(OffersLevelContext),
    isFullyRefundable = _React105_useContext.isFullyRefundable,
    setDismissMessagingCard = _React105_useContext.setDismissMessagingCard,
    setDefaultToFullyRefundable = _React105_useContext.setDefaultToFullyRefundable;
  var searchCriteria = usePropertyOffersInputs().searchCriteria;
  var isDateless = !(searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.primary.dateRange);
  var unitImpressionAnalytics = {
    referrerId: "HOT.HIS".concat(isDateless ? ".Dateless" : "", ".view.impression.Room.Carousel.Card.").concat(listingIndex),
    linkName: "Room carousel card view impression",
    trackOnce: true
  };
  if (!primarySelections) {
    return null;
  }
  return /* @__PURE__ */React105.createElement(UnitRateContextProvider, {
    isFullyRefundable: isFullyRefundable,
    primarySelections: primarySelections,
    setDismissMessagingCard: setDismissMessagingCard,
    setDefaultToFullyRefundable: setDefaultToFullyRefundable
  }, /* @__PURE__ */React105.createElement(IntersectionTracker11, _object_spread({}, unitImpressionAnalytics), /* @__PURE__ */React105.createElement(PropertyUnitCard, {
    data: data,
    listingIndex: listingIndex,
    isMicroRoomCardCarouselVariant: isMicroRoomCardCarouselVariant,
    propertyId: propertyId,
    showRoomHighlights: showRoomHighlights,
    targetItem: targetItem
  })));
};
PropertyUnitCategorization.displayName = "sharedui-PropertyUnitCategorization";
PropertyUnitCategorization.fragment = __PropertyUnitCategorizationFragment;
// src/components/experimental-offer-categories-section/overlay-content/overlay-content-body/offers.tsx
var Offers = function (param) {
  var offerIdentifiers = param.offerIdentifiers;
  var offers = useSelectedPropertyOffers(offerIdentifiers);
  var filteredList = usePropertyOffersFiltersContext().filteredList;
  return /* @__PURE__ */React106.createElement(React106.Fragment, null, filteredList === null || filteredList === void 0 ? void 0 : filteredList.map(function (offer, idx) {
    if (offer.__typename === "LodgingCategorizedUnit") {
      return /* @__PURE__ */React106.createElement(EGDSSpacing60, {
        margin: {
          block: "three"
        },
        key: "".concat(offer.unitId)
      }, /* @__PURE__ */React106.createElement("div", null, /* @__PURE__ */React106.createElement(PropertyUnitCategorization, {
        data: offer,
        listingIndex: idx,
        propertyId: ""
      })));
    }
    return null;
  }));
};
// src/components/experimental-offer-categories-section/overlay-content/overlay-content-body/overlay-content-body.tsx
var fragment51 = gql84(_templateObject86(), EGDSStylizedText3.fragment, Message.fragment, LodgingOfferFilters.fragment);
var OverlayContentBody = function (param) {
  var data = param.data;
  var messages = data.messages,
    offerIdentifiers = data.offerIdentifiers,
    offerFilters = data.offerFilters;
  var offers = useSelectedPropertyOffers(offerIdentifiers);
  var _offerFilters_filterPills;
  return /* @__PURE__ */React107.createElement("div", null, /* @__PURE__ */React107.createElement(PropertyOffersFiltersProvider, {
    value: {
      filters: (_offerFilters_filterPills = offerFilters === null || offerFilters === void 0 ? void 0 : offerFilters.filterPills) !== null && _offerFilters_filterPills !== void 0 ? _offerFilters_filterPills : null,
      list: offers !== null && offers !== void 0 ? offers : null
    }
  }, /* @__PURE__ */React107.createElement(Messages, {
    data: messages
  }), offerFilters && /* @__PURE__ */React107.createElement(LodgingOfferFilters, {
    data: offerFilters
  }), /* @__PURE__ */React107.createElement(Offers, {
    offerIdentifiers: offerIdentifiers
  })));
};
OverlayContentBody.fragment = fragment51;
OverlayContentBody.displayName = "CategoryOverlayBody";
// src/components/experimental-offer-categories-section/overlay-content/overlay-content-body/overlay-body.tsx
var fragment52 = gql85(_templateObject87(), OverlayContentBody.fragment);
var OverlayBody = function (param) {
  var data = param.data;
  var body = data.body;
  if ((body === null || body === void 0 ? void 0 : body.__typename) === "OfferCategoryOverlayContentBodyCategorizedOffers") {
    return /* @__PURE__ */React108.createElement(OverlayContentBody, {
      data: body
    });
  }
  return null;
};
OverlayBody.fragment = fragment52;
OverlayBody.displayName = "Body";
// src/components/experimental-offer-categories-section/overlay-content/overlay-content-body/overlay-heading.tsx
import React109 from "react";
import { gql as gql86 } from "@apollo/client";
import { EGDSHeading as EGDSHeading21 } from "@egds/react-core/text";
var fragment53 = gql86(_templateObject88(), Heading.fragment);
var OverlayHeading = function (param) {
  var data = param.data;
  var heading = data.heading;
  if ((heading === null || heading === void 0 ? void 0 : heading.__typename) === "OfferCategoryHeading") {
    return /* @__PURE__ */React109.createElement(EGDSHeading21, {
      size: 5
    }, heading.text);
  }
  return null;
};
OverlayHeading.fragment = fragment53;
OverlayHeading.displayName = "Heading";
// src/components/experimental-offer-categories-section/overlay-content/overlay-content.tsx
var fragment54 = gql87(_templateObject89(), OverlayHeading.fragment, OverlayBody.fragment);
var OverlayContent = function (param) {
  var data = param.data;
  return /* @__PURE__ */React110.createElement(EGDSSpacing61, {
    padding: {
      inline: "three"
    }
  }, /* @__PURE__ */React110.createElement(EGDSSheetContent8, {
    padded: false
  }, /* @__PURE__ */React110.createElement(OverlayHeading, {
    data: data
  }), /* @__PURE__ */React110.createElement(OverlayBody, {
    data: data
  })));
};
OverlayContent.fragment = fragment54;
OverlayContent.displayName = "OverlayContent";
// src/components/experimental-offer-categories-section/overlay-content/context/overlay-content-provider.tsx
import React111 from "react";
var defaultValue2 = {
  overlayContents: null
};
var OverlayContentContext = React111.createContext(defaultValue2);
var OverlayContentProvider = function (param) {
  var children = param.children,
    value = param.value;
  var overlayContents = React111.useMemo(function () {
    return {
      overlayContents: value
    };
  }, [value]);
  return /* @__PURE__ */React111.createElement(OverlayContentContext.Provider, {
    value: overlayContents
  }, children);
};
// src/components/experimental-offer-categories-section/overlay-content/context/hooks.tsx
import React112 from "react";
var useOverlayContent = function (contentId) {
  var _overlayContents_find;
  var overlayContents = React112.useContext(OverlayContentContext).overlayContents;
  if (!contentId) {
    return;
  }
  return overlayContents === null || overlayContents === void 0 ? void 0 : (_overlayContents_find = overlayContents.find(function (content) {
    return content.contentId === contentId;
  })) === null || _overlayContents_find === void 0 ? void 0 : _overlayContents_find.content;
};
// src/components/experimental-offer-categories-section/offer-categories/card-action-wrapper.tsx
var CardActionWrapper = function (param) {
  var actionId = param.actionId,
    triggerComponent = param.triggerComponent,
    triggerRef = param.triggerRef;
  var cardAction = useShoppingAction(actionId);
  var overlayContainer = useShoppingOverlayContainer(actionId);
  var overlayContent = useOverlayContent(overlayContainer === null || overlayContainer === void 0 ? void 0 : overlayContainer.contentId);
  if ((cardAction === null || cardAction === void 0 ? void 0 : cardAction.__typename) === "ShoppingNavigateToOverlay") {
    if (!overlayContainer || !overlayContent) {
      return triggerComponent;
    }
    return /* @__PURE__ */React113.createElement(React113.Fragment, null, triggerComponent, /* @__PURE__ */React113.createElement(ShoppingOverlayMapper, {
      actionId: actionId,
      ref: triggerRef,
      tall: true
    }, /* @__PURE__ */React113.createElement(OverlayContent, {
      data: overlayContent
    })));
  }
  return triggerComponent;
};
// src/components/experimental-offer-categories-section/all-offers-section.tsx
var fragment55 = gql88(_templateObject90());
var AllOffersSection = function (param) {
  var data = param.data;
  var primaryButton = data.primaryButton,
    actionId = data.actionId;
  var actionCallback = useShoppingActionCallback(actionId);
  var triggerRef = React114.useRef(null);
  var track = useClickTracker30();
  var callback = useCallback(function () {
    if (primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.analytics) {
      var _primaryButton_analytics = primaryButton.analytics,
        referrerId = _primaryButton_analytics.referrerId,
        linkName = _primaryButton_analytics.linkName;
      track(referrerId, linkName);
    }
    actionCallback();
  }, [primaryButton, actionCallback, track]);
  var triggerComponent = useMemo4(function () {
    return /* @__PURE__ */React114.createElement(EGDSPrimaryButton9, {
      domRef: triggerRef,
      size: UitkButtonSize.LARGE,
      isFullWidth: true,
      onClick: callback
    }, primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.primary);
  }, [primaryButton, callback]);
  if (!data || !(primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.primary)) {
    return null;
  }
  return /* @__PURE__ */React114.createElement(CardActionWrapper, {
    actionId: actionId,
    triggerComponent: triggerComponent,
    triggerRef: triggerRef
  });
};
AllOffersSection.fragment = fragment55;
AllOffersSection.displayName = "AllOffersSection";
// src/components/experimental-offer-categories-section/offer-categories/categories.tsx
import React117 from "react";
import { gql as gql90 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing63 } from "@egds/react-core/spacing";
// src/components/experimental-offer-categories-section/offer-categories/category-card.tsx
import React116 from "react";
import { gql as gql89 } from "@apollo/client";
import { EGDSCard as EGDSCard16 } from "@egds/react-core/cards";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType5 } from "@egds/react-core/images";
import { EGDSScrim as EGDSScrim2, EGDSScrimType as EGDSScrimType2 } from "@egds/react-core/scrim";
import { EGDSSpacing as EGDSSpacing62 } from "@egds/react-core/spacing";
import { LodgingEGDSImage } from "@shared-ui/lodging-fragments";
// src/components/experimental-offer-categories-section/offer-categories/category-link.tsx
import React115 from "react";
import { EGDSCardLink as EGDSCardLink2 } from "@egds/react-core/cards";
import { useShoppingAction as useShoppingAction2, useShoppingActionCallback as useShoppingActionCallback2 } from "@shared-ui/retail-shopping-tools-action-providers";
var OfferCardLink = function (param) {
  var actionId = param.actionId;
  var action = useShoppingAction2(actionId);
  var actionCallback = useShoppingActionCallback2(actionId);
  var triggerRef = React115.useRef(null);
  var cardActionTrigger = /* @__PURE__ */React115.createElement(EGDSCardLink2, null, /* @__PURE__ */React115.createElement("button", {
    onClick: actionCallback,
    type: "button",
    ref: triggerRef
  }, /* @__PURE__ */React115.createElement("span", {
    className: "is-visually-hidden"
  }, action === null || action === void 0 ? void 0 : action.accessibility)));
  return /* @__PURE__ */React115.createElement(CardActionWrapper, {
    actionId: actionId,
    triggerComponent: cardActionTrigger,
    triggerRef: triggerRef
  });
};
// src/components/experimental-offer-categories-section/offer-categories/category-card.tsx
var fragment56 = gql89(_templateObject91(), LodgingEGDSImage.fragment, Heading.fragment, Message.fragment);
var CategoryCard = function (param) {
  var data = param.data;
  var media = data.media,
    heading = data.heading,
    messages = data.messages,
    actionId = data.actionId;
  return /* @__PURE__ */React116.createElement(EGDSCard16, null, media && /* @__PURE__ */React116.createElement(LodgingEGDSImage, {
    data: media,
    ratio: EGDSFigureAspectRatioType5.R3_2
  }), /* @__PURE__ */React116.createElement(EGDSSpacing62, {
    padding: "three"
  }, /* @__PURE__ */React116.createElement(EGDSScrim2, {
    type: EGDSScrimType2.BOTTOM
  }, /* @__PURE__ */React116.createElement(Heading, {
    data: heading
  }), /* @__PURE__ */React116.createElement(Messages, {
    data: messages
  }))), /* @__PURE__ */React116.createElement(OfferCardLink, {
    actionId: actionId
  }));
};
CategoryCard.fragment = fragment56;
CategoryCard.displayName = "OfferCategory";
// src/components/experimental-offer-categories-section/offer-categories/categories.tsx
var fragment57 = gql90(_templateObject92(), CategoryCard.fragment);
var Categories = function (param) {
  var data = param.data;
  var offerCategories = data.offerCategories;
  if (!offerCategories || offerCategories.length === 0) {
    return null;
  }
  return /* @__PURE__ */React117.createElement("div", null, offerCategories.map(function (offerCategory, idx) {
    return /* @__PURE__ */React117.createElement(EGDSSpacing63, {
      margin: {
        block: "three",
        inline: "three"
      },
      key: idx
    }, /* @__PURE__ */React117.createElement("div", null, /* @__PURE__ */React117.createElement(CategoryCard, {
      data: offerCategory
    })));
  }));
};
Categories.fragment = fragment57;
Categories.displayName = "OffersCategories";
// src/components/experimental-offer-categories-section/experimental-offer-categories-section.tsx
var fragment58 = gql91(_templateObject93(), AllOffersSection.fragment, Categories.fragment, OverlayContent.fragment, shoppingJoinListContainerFragment);
var ExperimentalOfferCategoriesSection = function (param) {
  var data = param.data;
  var _data_experimentalOfferCategoriesSection;
  if (!data.experimentalOfferCategoriesSection || !((_data_experimentalOfferCategoriesSection = data.experimentalOfferCategoriesSection) === null || _data_experimentalOfferCategoriesSection === void 0 ? void 0 : _data_experimentalOfferCategoriesSection.offerCategories)) {
    return null;
  }
  var experimentalOfferCategoriesSection = data.experimentalOfferCategoriesSection;
  var overlayContents = experimentalOfferCategoriesSection.overlayContents,
    shoppingJoinListContainer = experimentalOfferCategoriesSection.shoppingJoinListContainer,
    allOffersSection = experimentalOfferCategoriesSection.allOffersSection;
  return /* @__PURE__ */React118.createElement(ShoppingActionProvider, {
    id: "",
    shoppingJoinListContainer: shoppingJoinListContainer
  }, /* @__PURE__ */React118.createElement(OverlayContentProvider, {
    value: overlayContents
  }, /* @__PURE__ */React118.createElement(EGDSSpacing64, {
    margin: {
      block: "three",
      inline: "three"
    }
  }, /* @__PURE__ */React118.createElement(EGDSHeading22, {
    size: 5
  }, experimentalOfferCategoriesSection.heading)), /* @__PURE__ */React118.createElement(Categories, {
    data: experimentalOfferCategoriesSection
  }), allOffersSection && /* @__PURE__ */React118.createElement(EGDSSpacing64, {
    margin: {
      block: "three",
      inline: "three"
    }
  }, /* @__PURE__ */React118.createElement("div", null, /* @__PURE__ */React118.createElement(AllOffersSection, {
    data: allOffersSection
  })))));
};
ExperimentalOfferCategoriesSection.fragment = fragment58;
ExperimentalOfferCategoriesSection.displayName = "ExperimentalOfferCategoriesSection";
// src/components/property-offers-included-perks/property-offers-included-perks.tsx
import React119 from "react";
import { gql as gql92 } from "@apollo/client";
import { EGDSCard as EGDSCard17 } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon27 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex24, EGDSLayoutFlexItem as EGDSLayoutFlexItem19 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid14, EGDSLayoutGridItem as EGDSLayoutGridItem12 } from "@egds/react-core/layout-grid";
import { EGDSMark as EGDSMark5 } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing65 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading23, EGDSText as EGDSText36 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker12 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium9, Viewport as Viewport11, ViewSmall as ViewSmall11 } from "@shared-ui/viewport-context";
var fragment59 = gql92(_templateObject94(), LodgingPlainFullscreenDialog.fragment);
var listDirectionMapper = {
  small: "column",
  medium: "row"
};
var getGraphic = function (graphic) {
  var size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "medium";
  switch (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) {
    case "Icon":
      return /* @__PURE__ */React119.createElement(EGDSIcon27, {
        name: graphic.id,
        description: graphic.description,
        size: size
      });
    case "Mark":
      var _graphic_url;
      return /* @__PURE__ */React119.createElement(EGDSMark5, {
        url: (_graphic_url = graphic.url) === null || _graphic_url === void 0 ? void 0 : _graphic_url.value,
        name: graphic.id,
        description: graphic.description,
        size: size
      });
    default:
      return null;
  }
};
var OrientedList = function (param) {
  var viewport = param.viewport,
    items = param.items;
  return /* @__PURE__ */React119.createElement(EGDSLayoutFlex24, {
    direction: listDirectionMapper[viewport],
    space: "two",
    wrap: "wrap",
    tag: "ul"
  }, items.map(function (param, index) {
    var accessibilityLabel = param.accessibilityLabel,
      graphic = param.graphic,
      text = param.text,
      moreInfoDialog = param.moreInfoDialog;
    return /* @__PURE__ */React119.createElement(EGDSLayoutFlexItem19, {
      key: index
    }, /* @__PURE__ */React119.createElement(EGDSSpacing65, {
      margin: {
        inlineend: "four"
      }
    }, /* @__PURE__ */React119.createElement("li", {
      "aria-label": accessibilityLabel !== null && accessibilityLabel !== void 0 ? accessibilityLabel : void 0
    }, /* @__PURE__ */React119.createElement(EGDSLayoutFlex24, {
      alignItems: "center",
      space: "two"
    }, /* @__PURE__ */React119.createElement(EGDSLayoutFlexItem19, {
      alignSelf: "start"
    }, getGraphic(graphic, viewport)), /* @__PURE__ */React119.createElement(EGDSLayoutFlexItem19, null, moreInfoDialog ? /* @__PURE__ */React119.createElement(LodgingPlainFullscreenDialog, {
      data: moreInfoDialog,
      uniqueDialogId: "perks-dialog",
      isHtmlContent: true
    }) : /* @__PURE__ */React119.createElement(EGDSText36, null, text))))));
  }));
};
var PerksContentSmall = function (param) {
  var includedPerks = param.includedPerks;
  var _icon_spotLight;
  var header = includedPerks.header,
    icon = includedPerks.icon,
    items = includedPerks.items;
  var _header_accessibilityLabel;
  return /* @__PURE__ */React119.createElement(EGDSSpacing65, {
    padding: {
      blockend: "one"
    }
  }, /* @__PURE__ */React119.createElement(EGDSLayoutGrid14, {
    columns: ["min-content", "auto"],
    space: "three"
  }, /* @__PURE__ */React119.createElement(EGDSLayoutGridItem12, null, /* @__PURE__ */React119.createElement("div", null, icon && /* @__PURE__ */React119.createElement(EGDSIcon27, {
    name: icon === null || icon === void 0 ? void 0 : icon.id,
    spotlight: icon === null || icon === void 0 ? void 0 : (_icon_spotLight = icon.spotLight) === null || _icon_spotLight === void 0 ? void 0 : _icon_spotLight.toLowerCase()
  }))), /* @__PURE__ */React119.createElement(EGDSLayoutGridItem12, null, /* @__PURE__ */React119.createElement("div", null, /* @__PURE__ */React119.createElement(EGDSSpacing65, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React119.createElement(EGDSHeading23, {
    "aria-label": (_header_accessibilityLabel = header === null || header === void 0 ? void 0 : header.accessibilityLabel) !== null && _header_accessibilityLabel !== void 0 ? _header_accessibilityLabel : void 0,
    size: 5
  }, header === null || header === void 0 ? void 0 : header.text)), /* @__PURE__ */React119.createElement(EGDSSpacing65, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React119.createElement("div", null, /* @__PURE__ */React119.createElement(OrientedList, {
    items: items,
    viewport: "small"
  })))))));
};
var PerksContentMedium = function (param) {
  var includedPerks = param.includedPerks;
  var _icon_spotLight;
  var header = includedPerks.header,
    icon = includedPerks.icon,
    items = includedPerks.items;
  var _header_accessibilityLabel;
  return /* @__PURE__ */React119.createElement(EGDSSpacing65, {
    padding: "two"
  }, /* @__PURE__ */React119.createElement(EGDSLayoutGrid14, {
    columns: ["min-content", "max-content", "auto"],
    space: "three"
  }, /* @__PURE__ */React119.createElement(EGDSLayoutGridItem12, null, /* @__PURE__ */React119.createElement("div", null, icon && /* @__PURE__ */React119.createElement(EGDSIcon27, {
    name: icon === null || icon === void 0 ? void 0 : icon.id,
    spotlight: icon === null || icon === void 0 ? void 0 : (_icon_spotLight = icon.spotLight) === null || _icon_spotLight === void 0 ? void 0 : _icon_spotLight.toLowerCase()
  }))), /* @__PURE__ */React119.createElement(EGDSLayoutGridItem12, null, /* @__PURE__ */React119.createElement("div", null, /* @__PURE__ */React119.createElement(EGDSSpacing65, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React119.createElement(EGDSHeading23, {
    "aria-label": (_header_accessibilityLabel = header === null || header === void 0 ? void 0 : header.accessibilityLabel) !== null && _header_accessibilityLabel !== void 0 ? _header_accessibilityLabel : void 0,
    size: 5
  }, header === null || header === void 0 ? void 0 : header.text)))), /* @__PURE__ */React119.createElement(EGDSLayoutGridItem12, null, /* @__PURE__ */React119.createElement("div", null, /* @__PURE__ */React119.createElement(EGDSSpacing65, {
    margin: {
      blockstart: "three",
      inlinestart: "two"
    }
  }, /* @__PURE__ */React119.createElement("div", null, /* @__PURE__ */React119.createElement(OrientedList, {
    items: items,
    viewport: "medium"
  })))))));
};
var PropertyOffersIncludedPerks = function (param) {
  var data = param.data;
  var _iconAnalytics_uisPrimeMessages;
  if (!data || !data.includedPerks) {
    return null;
  }
  var iconAnalytics = data.includedPerks.iconAnalytics;
  var _iconAnalytics_referrerId, _iconAnalytics_linkName;
  var trackingProps = {
    referrerId: (_iconAnalytics_referrerId = iconAnalytics === null || iconAnalytics === void 0 ? void 0 : iconAnalytics.referrerId) !== null && _iconAnalytics_referrerId !== void 0 ? _iconAnalytics_referrerId : "",
    linkName: (_iconAnalytics_linkName = iconAnalytics === null || iconAnalytics === void 0 ? void 0 : iconAnalytics.linkName) !== null && _iconAnalytics_linkName !== void 0 ? _iconAnalytics_linkName : "",
    additionalUisPrimeMicroMessages: iconAnalytics === null || iconAnalytics === void 0 ? void 0 : (_iconAnalytics_uisPrimeMessages = iconAnalytics.uisPrimeMessages) === null || _iconAnalytics_uisPrimeMessages === void 0 ? void 0 : _iconAnalytics_uisPrimeMessages.map(function (param) {
      var messageContent = param.messageContent,
        schemaName = param.schemaName;
      return {
        messageContent: JSON.parse(messageContent),
        schemaName: schemaName
      };
    })
  };
  return /* @__PURE__ */React119.createElement(IntersectionTracker12, _object_spread({}, trackingProps), /* @__PURE__ */React119.createElement(EGDSSpacing65, {
    margin: {
      block: "three"
    }
  }, /* @__PURE__ */React119.createElement(EGDSCard17, {
    padded: true
  }, /* @__PURE__ */React119.createElement("div", null, /* @__PURE__ */React119.createElement(Viewport11, null, /* @__PURE__ */React119.createElement(ViewSmall11, null, /* @__PURE__ */React119.createElement(PerksContentSmall, {
    includedPerks: data.includedPerks
  })), /* @__PURE__ */React119.createElement(ViewMedium9, null, /* @__PURE__ */React119.createElement(PerksContentMedium, {
    includedPerks: data.includedPerks
  })))))));
};
PropertyOffersIncludedPerks.fragment = fragment59;
PropertyOffersIncludedPerks.displayName = "PropertyOffersIncludedPerks";
// src/components/property-offers/__private/__fragments/listings/categorized-listings/categorized-listings.tsx
import React128, { useMemo as useMemo5, useState as useState3 } from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex26, EGDSLayoutFlexItem as EGDSLayoutFlexItem21 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing69 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi6 } from "@shared-ui/bex-api-context";
import { Experiment as Experiment3, ExperimentControl as ExperimentControl3, ExperimentVariant as ExperimentVariant3 } from "@shared-ui/experiment-context";
import { usePropertyOffersFiltersContext as usePropertyOffersFiltersContext2 } from "@shared-ui/retail-sort-and-filter-shared";
import { ViewMedium as ViewMedium11, Viewport as Viewport13, ViewSmall as ViewSmall12 } from "@shared-ui/viewport-context";
// src/components/property-offers/__private/__fragments/listings/categorized-listings/layouts/listings-layouts.tsx
import React125, { useState as useState2 } from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid15, EGDSLayoutGridItem as EGDSLayoutGridItem13 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing67 } from "@egds/react-core/spacing";
import { useExperiment as useExperiment8 } from "@shared-ui/experiment-context";
// src/components/property-offers/__private/__fragments/lodging-section-header.tsx
import React120 from "react";
import { gql as gql93 } from "@apollo/client";
import { EGDSSpacingHr as EGDSSpacingHr2 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading24 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker13 } from "@shared-ui/clickstream-analytics-context";
var fragment60 = gql93(_templateObject95());
var LodgingSectionHeader = function (param) {
  var data = param.data;
  var text = data.text,
    accessibilityLabel = data.accessibilityLabel,
    impressionAnalytics = data.impressionAnalytics;
  return /* @__PURE__ */React120.createElement(React120.Fragment, null, text && /* @__PURE__ */React120.createElement(IntersectionTracker13, {
    trackOnce: true,
    referrerId: "".concat(impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId),
    linkName: "".concat(impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.event)
  }, /* @__PURE__ */React120.createElement(EGDSSpacingHr2, null), /* @__PURE__ */React120.createElement(EGDSHeading24, {
    tag: "h4",
    size: 5
  }, text)), accessibilityLabel && /* @__PURE__ */React120.createElement("span", {
    className: "is-visually-hidden"
  }, accessibilityLabel));
};
LodgingSectionHeader.displayName = "LodgingSectionHeader";
LodgingSectionHeader.fragment = fragment60;
// src/components/property-offers/__private/__fragments/vertical-messaging-card/hooks/with-messaging-card-actions.tsx
import React122 from "react";
// src/components/property-offers/__private/__fragments/vertical-messaging-card/hooks/default-to-fully-refundable.ts
import React121 from "react";
import { Level as Level2, liveAnnounce as liveAnnounce2 } from "@egds/react-core/utils";
function UseDefaultToFullyRefundable() {
  var _React121_useContext = React121.useContext(OffersLevelContext),
    setDefaultToFullyRefundable = _React121_useContext.setDefaultToFullyRefundable,
    setDismissMessagingCard = _React121_useContext.setDismissMessagingCard;
  var primaryClickHandler = function (primaryAction, primaryActionLiveAnnounce) {
    return function () {
      if (primaryAction === "DEFAULT_TO_RECOMMENDED" && setDefaultToFullyRefundable) {
        setDefaultToFullyRefundable(true);
        liveAnnounce2(primaryActionLiveAnnounce, Level2.ASSERTIVE);
      }
    };
  };
  var secondaryClickHandler = function (secondaryAction, secondaryActionLiveAnnounce) {
    return function () {
      if (secondaryAction === "DISMISS_RECOMMENDATIONS_CARD" && setDismissMessagingCard) {
        setDismissMessagingCard(true);
        liveAnnounce2(secondaryActionLiveAnnounce, Level2.ASSERTIVE);
      }
    };
  };
  return {
    primaryClickHandler: primaryClickHandler,
    secondaryClickHandler: secondaryClickHandler
  };
}
// src/components/property-offers/__private/__fragments/vertical-messaging-card/hooks/with-messaging-card-actions.tsx
function withMessagingCardActions(MessagingCard) {
  var WithMessagingCardActions = function (props) {
    var _data_action_primary_actionDetails, _data_action_primary, _data_action, _data_action_primary_actionDetails1, _data_action_primary1, _data_action1, _data_action_secondary_actionDetails, _data_action_secondary, _data_action2, _data_action_secondary_actionDetails1, _data_action_secondary1, _data_action3;
    var className = props.className,
      data = props.data;
    var primaryAction = (_data_action = data.action) === null || _data_action === void 0 ? void 0 : (_data_action_primary = _data_action.primary) === null || _data_action_primary === void 0 ? void 0 : (_data_action_primary_actionDetails = _data_action_primary.actionDetails) === null || _data_action_primary_actionDetails === void 0 ? void 0 : _data_action_primary_actionDetails.action;
    var primaryActionLiveAnnounce = ((_data_action1 = data.action) === null || _data_action1 === void 0 ? void 0 : (_data_action_primary1 = _data_action1.primary) === null || _data_action_primary1 === void 0 ? void 0 : (_data_action_primary_actionDetails1 = _data_action_primary1.actionDetails) === null || _data_action_primary_actionDetails1 === void 0 ? void 0 : _data_action_primary_actionDetails1.accessibilityLabel) || "";
    var secondaryAction = (_data_action2 = data.action) === null || _data_action2 === void 0 ? void 0 : (_data_action_secondary = _data_action2.secondary) === null || _data_action_secondary === void 0 ? void 0 : (_data_action_secondary_actionDetails = _data_action_secondary.actionDetails) === null || _data_action_secondary_actionDetails === void 0 ? void 0 : _data_action_secondary_actionDetails.action;
    var secondaryActionLiveAnnounce = ((_data_action3 = data.action) === null || _data_action3 === void 0 ? void 0 : (_data_action_secondary1 = _data_action3.secondary) === null || _data_action_secondary1 === void 0 ? void 0 : (_data_action_secondary_actionDetails1 = _data_action_secondary1.actionDetails) === null || _data_action_secondary_actionDetails1 === void 0 ? void 0 : _data_action_secondary_actionDetails1.accessibilityLabel) || "";
    var _UseDefaultToFullyRefundable = UseDefaultToFullyRefundable(),
      primaryClickHandler = _UseDefaultToFullyRefundable.primaryClickHandler,
      secondaryClickHandler = _UseDefaultToFullyRefundable.secondaryClickHandler;
    var primaryActionClickHandler = primaryClickHandler(primaryAction, primaryActionLiveAnnounce);
    var secondaryActionClickHandler = secondaryClickHandler(secondaryAction, secondaryActionLiveAnnounce);
    var messagingCardProps = _object_spread_props(_object_spread({}, props), {
      primaryActionClickHandler: primaryActionClickHandler,
      secondaryActionClickHandler: secondaryActionClickHandler,
      className: className
    });
    return /* @__PURE__ */React122.createElement(MessagingCard, _object_spread({}, messagingCardProps));
  };
  WithMessagingCardActions.displayName = "WithMessagingCardActions(".concat(MessagingCard.displayName || MessagingCard.name, ")");
  return WithMessagingCardActions;
}
// src/components/property-offers/__private/__fragments/vertical-messaging-card/vertical-message-card.tsx
import React123 from "react";
import { gql as gql94 } from "@apollo/client";
import { EGDSCard as EGDSCard18, EGDSCardContentSection as EGDSCardContentSection11 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure4, EGDSImage as EGDSImage4 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex25, EGDSLayoutFlexItem as EGDSLayoutFlexItem20 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink13 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing66 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading25, EGDSText as EGDSText37 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker31 } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2 } from "@shared-ui/experiment-context";
import { ViewMedium as ViewMedium10, Viewport as Viewport12 } from "@shared-ui/viewport-context";
var fragment61 = gql94(_templateObject96());
var analytics = function (linkName, referrerId, trackClick) {
  if (linkName && referrerId) {
    return {
      id: referrerId,
      callback: function () {
        return trackClick(referrerId, linkName);
      }
    };
  }
  return void 0;
};
var VerticalMessagingCard = function (param) {
  var data = param.data,
    primaryActionClickHandler = param.primaryActionClickHandler,
    secondaryActionClickHandler = param.secondaryActionClickHandler;
  var title = data.title,
    subtitle = data.subtitle,
    action = data.action,
    featuredImage = data.featuredImage;
  var trackClick = useClickTracker31();
  if (!title && !subtitle) {
    return null;
  }
  var _$_object_spread = _object_spread({}, featuredImage),
    url = _$_object_spread.url,
    description = _$_object_spread.description;
  var _$_object_spread1 = _object_spread({}, action),
    primary = _$_object_spread1.primary,
    secondary = _$_object_spread1.secondary;
  return /* @__PURE__ */React123.createElement(EGDSLayoutFlex25, {
    direction: "column"
  }, /* @__PURE__ */React123.createElement(EGDSCard18, {
    border: true,
    "data-stid": "vertical-messaging-card"
  }, /* @__PURE__ */React123.createElement(Experiment2, {
    name: "SmaSh_Desktop_Room_Carousel",
    logExposure: false
  }, /* @__PURE__ */React123.createElement(ExperimentControl2, null, /* @__PURE__ */React123.createElement(Viewport12, null, /* @__PURE__ */React123.createElement(ViewMedium10, null, /* @__PURE__ */React123.createElement(EGDSFigure4, null, /* @__PURE__ */React123.createElement(EGDSImage4, {
    placeholderImage: true,
    alt: description,
    src: url
  }))))), /* @__PURE__ */React123.createElement(ExperimentVariant2, {
    bucket: 1
  })), /* @__PURE__ */React123.createElement(EGDSCardContentSection11, null, /* @__PURE__ */React123.createElement(EGDSHeading25, {
    tag: "h3",
    size: 7
  }, title === null || title === void 0 ? void 0 : title.text), /* @__PURE__ */React123.createElement(EGDSSpacing66, {
    margin: {
      blockstart: "two",
      blockend: "one"
    }
  }, /* @__PURE__ */React123.createElement(EGDSText37, {
    size: 300
  }, subtitle === null || subtitle === void 0 ? void 0 : subtitle.text)), /* @__PURE__ */React123.createElement(EGDSLayoutFlex25, {
    direction: "column"
  }, (primary === null || primary === void 0 ? void 0 : primary.text) && /* @__PURE__ */React123.createElement(EGDSLayoutFlexItem20, null, /* @__PURE__ */React123.createElement(EGDSSpacing66, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React123.createElement(EGDSLink13, {
    analytics: analytics(primary.text, primary.referrerId, trackClick)
  }, /* @__PURE__ */React123.createElement("button", {
    type: "button",
    onClick: primaryActionClickHandler
  }, primary.text)))), (secondary === null || secondary === void 0 ? void 0 : secondary.text) && /* @__PURE__ */React123.createElement(EGDSLayoutFlexItem20, null, /* @__PURE__ */React123.createElement(EGDSSpacing66, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React123.createElement(EGDSLink13, {
    analytics: analytics(secondary.text, secondary.referrerId, trackClick)
  }, /* @__PURE__ */React123.createElement("button", {
    type: "button",
    onClick: secondaryActionClickHandler
  }, secondary.text))))))));
};
VerticalMessagingCard.fragment = fragment61;
VerticalMessagingCard.displayName = "VerticalMessagingCard";
// src/components/property-offers/__private/__fragments/vertical-messaging-card/vertical-message-card-with-actions.tsx
var VerticalMessageCardWithActions = withMessagingCardActions(VerticalMessagingCard);
// src/components/property-offers/__private/__fragments/listings/insurtechPrimingCardCategorizedListing/insurtech-priming-card-categorized-listing.tsx
import React124 from "react";
import { gql as gql95 } from "@apollo/client";
import { UitkCardBackgroundThemes } from "@egds/react-core/cards";
import { PrimingCard } from "@shared-ui/retail-insurtech-priming-card";
var fragment62 = gql95(_templateObject97());
var InsurtechPrimingCardCategorizedListing = function (param) {
  var data = param.data,
    onError = param.onError;
  var _data_placementContext = data.placementContext,
    lob = _data_placementContext.lob,
    path = _data_placementContext.path,
    placement = _data_placementContext.placement;
  return /* @__PURE__ */React124.createElement(PrimingCard, {
    inputs: {
      placement: {
        placementContext: {
          lob: lob,
          path: path,
          placement: placement
        }
      }
    },
    onError: onError,
    showSkeletonView: true,
    backgroundTheme: UitkCardBackgroundThemes.PRIMARY
  });
};
InsurtechPrimingCardCategorizedListing.fragment = fragment62;
InsurtechPrimingCardCategorizedListing.displayName = "InsurtechPrimingCardCategorizedListing";
// src/components/property-offers/__private/__fragments/listings/categorized-listings/layouts/listings-layouts.tsx
var CategorizedListingsGrid = function (param) {
  var listings = param.listings,
    propertyId = param.propertyId,
    _param_showRoomHighlights = param.showRoomHighlights,
    showRoomHighlights = _param_showRoomHighlights === void 0 ? false : _param_showRoomHighlights,
    _param_useInlineMargin = param.useInlineMargin,
    useInlineMargin = _param_useInlineMargin === void 0 ? true : _param_useInlineMargin,
    _param_filterActive = param.filterActive,
    filterActive = _param_filterActive === void 0 ? false : _param_filterActive,
    insurtechPrimingCardCategorizedListing = param.insurtechPrimingCardCategorizedListing,
    targetItem = param.targetItem;
  var isMessagingCardDismissed = React125.useContext(OffersLevelContext).isMessagingCardDismissed;
  var _useState2 = _sliced_to_array(useState2(!!insurtechPrimingCardCategorizedListing), 2),
    showPrimingCard = _useState2[0],
    setShowPrimingCard = _useState2[1];
  var roomPosition = 0;
  var inRecsVariant = useExperiment8("SmaSh_IR_Recommendations_highlights_MVP").exposure.bucket > 0;
  var listingsLimit = useListingsLimitContext().listingsLimit;
  var onErrorPrimingHandler = function () {
    setShowPrimingCard(false);
  };
  var wrapper = function (children) {
    if (useInlineMargin) {
      return /* @__PURE__ */React125.createElement(EGDSSpacing67, {
        margin: {
          small: {
            inline: "three"
          },
          medium: {
            inline: "unset"
          }
        }
      }, children);
    }
    return children;
  };
  var _insurtechPrimingCardCategorizedListing_position;
  return wrapper( /* @__PURE__ */React125.createElement(EGDSLayoutGrid15, {
    columns: {
      auto_fill: "seventy_six"
    },
    space: "three",
    justifyContent: "start"
  }, showPrimingCard && insurtechPrimingCardCategorizedListing && /* @__PURE__ */React125.createElement(EGDSLayoutGridItem13, {
    key: "insurtech-priming-card",
    colSpan: "all",
    rowStart: (_insurtechPrimingCardCategorizedListing_position = insurtechPrimingCardCategorizedListing.position) !== null && _insurtechPrimingCardCategorizedListing_position !== void 0 ? _insurtechPrimingCardCategorizedListing_position : DEFAULT_INSURANCE_PRIMING_POSITION
  }, /* @__PURE__ */React125.createElement("div", null, /* @__PURE__ */React125.createElement(InsurtechPrimingCardCategorizedListing, {
    data: insurtechPrimingCardCategorizedListing,
    onError: onErrorPrimingHandler
  }))), listings === null || listings === void 0 ? void 0 : listings.map(function (listing, index) {
    var __typename = listing.__typename;
    if (__typename === "MessageResult" && !isMessagingCardDismissed) {
      return /* @__PURE__ */React125.createElement(EGDSLayoutGridItem13, {
        key: "".concat(__typename, "-").concat(index)
      }, /* @__PURE__ */React125.createElement(VerticalMessageCardWithActions, {
        data: listing
      }));
    }
    if (__typename === "LodgingCategorizedUnit") {
      roomPosition += 1;
      if (listingsLimit && roomPosition > listingsLimit) {
        return null;
      }
      return /* @__PURE__ */React125.createElement(EGDSLayoutGridItem13, {
        key: "".concat(__typename, "-").concat(listing.unitId)
      }, /* @__PURE__ */React125.createElement(PropertyUnitCategorization, {
        data: listing,
        listingIndex: roomPosition,
        propertyId: propertyId,
        showRoomHighlights: showRoomHighlights,
        targetItem: targetItem
      }));
    }
    if (__typename === "LodgingHeader") {
      if (inRecsVariant && filterActive) {
        return null;
      }
      return /* @__PURE__ */React125.createElement(EGDSLayoutGridItem13, {
        colStart: 1,
        colEnd: "end",
        key: "".concat(__typename, "-").concat(index)
      }, /* @__PURE__ */React125.createElement("div", null, /* @__PURE__ */React125.createElement(LodgingSectionHeader, {
        data: listing
      })));
    }
    return null;
  })));
};
// src/components/property-offers/__private/__fragments/listings/categorized-listings/layouts/listings-carousel.tsx
import React126 from "react";
import { EGDSSpacing as EGDSSpacing68 } from "@egds/react-core/spacing";
import { Carousel } from "@egds/react-lodging";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker14, useClickTracker as useClickTracker32 } from "@shared-ui/clickstream-analytics-context";
var CAROUSEL_NAME = "OffersCarousel";
var ListingsCarouselSection = function (param) {
  var listingsSection = param.listingsSection,
    index = param.index,
    isMicroRoomCardEnabled = param.isMicroRoomCardEnabled,
    propertyId = param.propertyId,
    _param_showRoomHighlights = param.showRoomHighlights,
    showRoomHighlights = _param_showRoomHighlights === void 0 ? false : _param_showRoomHighlights,
    targetItem = param.targetItem;
  var _useBexApi5_context_device, _useBexApi5_context;
  var carouselNamePostfix = index > 0 ? ".FiltersNotMatched" : "";
  var carouselName = "".concat(CAROUSEL_NAME).concat(carouselNamePostfix);
  var searchCriteria = usePropertyOffersInputs().searchCriteria;
  var isDateless = !(searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.primary.dateRange);
  var carouselImpressionAnalytics = {
    referrerId: "HOT.HIS".concat(isDateless ? ".Dateless" : "", ".view.impression.Room.Carousel"),
    linkName: "Room carousel view impression",
    trackOnce: true
  };
  var track = useClickTracker32();
  var analytics2 = React126.useMemo(function () {
    return {
      id: "HOT.HIS.".concat(carouselName).concat(isDateless ? ".dateless" : ""),
      description: "Carousel interaction",
      callback: function (rfrrId, linkName) {
        track(rfrrId, linkName);
      }
    };
  }, []);
  var header = listingsSection.header;
  var roomPosition = 0;
  var isMobile = ((_useBexApi5_context = useBexApi5().context) === null || _useBexApi5_context === void 0 ? void 0 : (_useBexApi5_context_device = _useBexApi5_context.device) === null || _useBexApi5_context_device === void 0 ? void 0 : _useBexApi5_context_device.type) === "MOBILE_PHONE" /* MOBILE_PHONE */;
  var carouselProps = {
    carouselName: carouselName,
    analytics: analytics2,
    buttonText: {
      nextButton: "",
      prevButton: ""
    },
    itemsVisible: {
      sm: 1,
      md: 2,
      lg: 3
    },
    pageBy: 1,
    peek: true,
    itemsMaxHeight: true,
    pagingInset: false,
    hideNav: isMobile,
    shouldSnapOnScroll: false,
    extraPeekWidth: true
  };
  var unitsCarousel = /* @__PURE__ */React126.createElement(Carousel, _object_spread({}, carouselProps), listingsSection.items.map(function (listing, idx) {
    var __typename = listing.__typename;
    if (__typename === "LodgingCategorizedUnit") {
      roomPosition += 1;
      return /* @__PURE__ */React126.createElement(PropertyUnitCategorization, {
        data: listing,
        listingIndex: roomPosition,
        key: "".concat(__typename, "-").concat(listing.unitId),
        propertyId: propertyId,
        isMicroRoomCardCarouselVariant: isMicroRoomCardEnabled,
        showRoomHighlights: showRoomHighlights,
        targetItem: targetItem
      });
    }
    return null;
  }));
  return /* @__PURE__ */React126.createElement("div", null, header && /* @__PURE__ */React126.createElement(EGDSSpacing68, {
    margin: "three"
  }, /* @__PURE__ */React126.createElement("div", null, /* @__PURE__ */React126.createElement(LodgingSectionHeader, {
    data: header
  }))), /* @__PURE__ */React126.createElement(EGDSSpacing68, null, /* @__PURE__ */React126.createElement(IntersectionTracker14, _object_spread({}, carouselImpressionAnalytics), /* @__PURE__ */React126.createElement("div", null, unitsCarousel))));
};
var splitListings = function (listings) {
  return listings === null || listings === void 0 ? void 0 : listings.reduce(function (acc, listing) {
    var __typename = listing.__typename;
    if (__typename === "MessageResult") {
      return acc;
    }
    if (__typename === "LodgingHeader") {
      acc.push({
        header: listing,
        items: []
      });
    } else if (!acc.length) {
      acc.push({
        header: null,
        items: [listing]
      });
    } else {
      var _acc_;
      var _ref = (_acc_ = acc[acc.length - 1]) !== null && _acc_ !== void 0 ? _acc_ : {},
        _ref_header = _ref.header,
        header = _ref_header === void 0 ? null : _ref_header,
        _ref_items = _ref.items,
        items = _ref_items === void 0 ? [] : _ref_items;
      acc[acc.length - 1] = {
        header: header,
        items: items.concat(listing)
      };
    }
    return acc;
  }, []);
};
var CategorizedListingsBySections = function (param) {
  var listings = param.listings,
    _param_isMicroRoomCardEnabled = param.isMicroRoomCardEnabled,
    isMicroRoomCardEnabled = _param_isMicroRoomCardEnabled === void 0 ? true : _param_isMicroRoomCardEnabled,
    propertyId = param.propertyId,
    _param_showRoomHighlights = param.showRoomHighlights,
    showRoomHighlights = _param_showRoomHighlights === void 0 ? false : _param_showRoomHighlights,
    targetItem = param.targetItem;
  var isMessagingCardDismissed = React126.useContext(OffersLevelContext).isMessagingCardDismissed;
  var messageResultBanner = !isMessagingCardDismissed ? listings === null || listings === void 0 ? void 0 : listings.find(function (listing) {
    return listing.__typename === "MessageResult";
  }) : null;
  var listingsBySections = React126.useMemo(function () {
    return splitListings(listings);
  }, [listings]);
  return /* @__PURE__ */React126.createElement(React126.Fragment, null, messageResultBanner && /* @__PURE__ */React126.createElement(EGDSSpacing68, {
    margin: "three"
  }, /* @__PURE__ */React126.createElement("div", null, /* @__PURE__ */React126.createElement(VerticalMessageCardWithActions, {
    data: messageResultBanner
  }))), listingsBySections === null || listingsBySections === void 0 ? void 0 : listingsBySections.map(function (section, idx) {
    return /* @__PURE__ */React126.createElement(ListingsCarouselSection, {
      listingsSection: section,
      index: idx,
      key: idx,
      propertyId: propertyId,
      isMicroRoomCardEnabled: isMicroRoomCardEnabled,
      showRoomHighlights: showRoomHighlights,
      targetItem: targetItem
    });
  }));
};
// src/components/property-offers/__private/__fragments/listings/categorized-listings/listings-toggle.tsx
import React127 from "react";
import { gql as gql96 } from "@apollo/client";
import { EGDSSecondaryButton } from "@egds/react-core/button";
import { useClickTracker as useClickTracker33 } from "@shared-ui/clickstream-analytics-context";
// src/components/property-offers/__private/__fragments/listings/categorized-listings/utilities/localization-helper.ts
function getPluralKey(count) {
  switch (true) {
    case count === 0:
      return "zero";
    case count === 1:
      return "one";
    case count === 2:
      return "two";
    case count >= 3 && count <= 5:
      return "few";
    case count >= 6:
      return "many";
    default:
      return "other";
  }
}
function interpolate(locString, locMap) {
  var result = locString;
  Object.keys(locMap).forEach(function (key) {
    result = locString.replace("${".concat(key, "}"), locMap[key] || "");
  });
  return result;
}
// src/components/property-offers/__private/__fragments/listings/categorized-listings/utilities/map-helper.ts
function adaptPairList(pairList) {
  var result = {};
  pairList.forEach(function (pair) {
    result[pair.key] = pair.value;
  });
  return result;
}
// src/components/property-offers/__private/__fragments/listings/categorized-listings/listings-toggle.tsx
var fragment63 = gql96(_templateObject98());
var ListingsToggle = function (param) {
  var data = param.data,
    hiddenCount = param.hiddenCount;
  var analytics2 = data.analytics,
    localizationMap = data.localizationMap;
  var _useListingsLimitContext = useListingsLimitContext(),
    listingsLimit = _useListingsLimitContext.listingsLimit,
    setListingsLimit = _useListingsLimitContext.setListingsLimit;
  var track = useClickTracker33();
  var toggleListings = function () {
    if ((analytics2 === null || analytics2 === void 0 ? void 0 : analytics2.toggled) && analytics2.untoggled) {
      var rfrr = listingsLimit ? analytics2.toggled.referrerId : analytics2.untoggled.referrerId;
      var link = listingsLimit ? analytics2.toggled.linkName : analytics2.untoggled.linkName;
      track(rfrr, link);
    }
    if (!listingsLimit) {
      var _document_getElementById, _document;
      (_document = document) === null || _document === void 0 ? void 0 : (_document_getElementById = _document.getElementById("ListingsHeader")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.scrollIntoView();
    }
    setListingsLimit(function (prevListingsLimit) {
      return prevListingsLimit ? void 0 : 6;
    });
  };
  if (!localizationMap || localizationMap.length === 0) {
    return null;
  }
  var localizations = adaptPairList(_to_consumable_array(localizationMap));
  var toggledLocalization = localizations[getPluralKey(hiddenCount)];
  var untoggledLocalization = localizations.untoggled;
  if (!toggledLocalization || !untoggledLocalization) {
    return null;
  }
  var locString = listingsLimit ? toggledLocalization : untoggledLocalization;
  var label = interpolate(locString, {
    numberOfRooms: "".concat(hiddenCount)
  });
  return /* @__PURE__ */React127.createElement(EGDSSecondaryButton, {
    onClick: toggleListings
  }, label);
};
ListingsToggle.fragment = fragment63;
ListingsToggle.displayName = "ListingsToggle";
// src/components/property-offers/__private/__fragments/listings/categorized-listings/categorized-listings.tsx
var CategorizedListings = function (param) {
  var listings = param.listings,
    propertyId = param.propertyId,
    _param_renderLayout = param.renderLayout,
    renderLayout = _param_renderLayout === void 0 ? OffersLayouts.GRID : _param_renderLayout,
    _param_showRoomHighlights = param.showRoomHighlights,
    showRoomHighlights = _param_showRoomHighlights === void 0 ? false : _param_showRoomHighlights,
    toggle = param.toggle,
    useInlineMargin = param.useInlineMargin,
    targetItem = param.targetItem,
    insurtechPrimingCardCategorizedListing = param.insurtechPrimingCardCategorizedListing;
  var _context_device;
  var context = useBexApi6().context;
  var isMobile = (context === null || context === void 0 ? void 0 : (_context_device = context.device) === null || _context_device === void 0 ? void 0 : _context_device.type) === "MOBILE_PHONE" /* MOBILE_PHONE */;
  var _usePropertyOffersFiltersContext2 = usePropertyOffersFiltersContext2(),
    filteredListings = _usePropertyOffersFiltersContext2.filteredList;
  var listingsList = filteredListings || listings;
  var filterActive = filteredListings && listings && filteredListings.length !== listings.length || false;
  var _useState3 = _sliced_to_array(useState3(toggle ? 6 : void 0), 2),
    listingsLimit = _useState3[0],
    setListingsLimit = _useState3[1];
  var limitProviderValue = useMemo5(function () {
    return {
      listingsLimit: listingsLimit,
      setListingsLimit: setListingsLimit
    };
  }, [listingsLimit, setListingsLimit]);
  var withToggleButton = function (children) {
    if (toggle && listingsList && listingsList.length > 6) {
      return /* @__PURE__ */React128.createElement(ListingsLimitContext.Provider, {
        value: limitProviderValue
      }, children, /* @__PURE__ */React128.createElement(EGDSSpacing69, {
        padding: {
          block: "four"
        }
      }, /* @__PURE__ */React128.createElement(EGDSLayoutFlex26, {
        justifyContent: "center"
      }, /* @__PURE__ */React128.createElement(EGDSLayoutFlexItem21, null, /* @__PURE__ */React128.createElement(ListingsToggle, {
        data: toggle,
        hiddenCount: listingsList.length - 6
      })))));
    }
    return children;
  };
  if (renderLayout === OffersLayouts.CAROUSEL) {
    return /* @__PURE__ */React128.createElement(CategorizedListingsBySections, {
      listings: listingsList,
      propertyId: propertyId,
      showRoomHighlights: showRoomHighlights,
      targetItem: targetItem
    });
  }
  if (isMobile) {
    return withToggleButton( /* @__PURE__ */React128.createElement(Viewport13, null, /* @__PURE__ */React128.createElement(ViewSmall12, null, /* @__PURE__ */React128.createElement(Experiment3, {
      name: "Micro_Room_Card_Side_By_Side_Carousel_mWeb"
    }, /* @__PURE__ */React128.createElement(ExperimentControl3, null, /* @__PURE__ */React128.createElement(CategorizedListingsGrid, {
      listings: listingsList,
      propertyId: propertyId,
      showRoomHighlights: showRoomHighlights,
      useInlineMargin: useInlineMargin,
      filterActive: filterActive,
      insurtechPrimingCardCategorizedListing: insurtechPrimingCardCategorizedListing,
      targetItem: targetItem
    })), /* @__PURE__ */React128.createElement(ExperimentVariant3, {
      bucket: 1
    }, /* @__PURE__ */React128.createElement(CategorizedListingsBySections, {
      listings: listingsList,
      propertyId: propertyId,
      showRoomHighlights: showRoomHighlights,
      targetItem: targetItem
    })))), /* @__PURE__ */React128.createElement(ViewMedium11, null, /* @__PURE__ */React128.createElement(CategorizedListingsGrid, {
      listings: listingsList,
      propertyId: propertyId,
      showRoomHighlights: showRoomHighlights,
      useInlineMargin: useInlineMargin,
      filterActive: filterActive,
      targetItem: targetItem,
      insurtechPrimingCardCategorizedListing: insurtechPrimingCardCategorizedListing
    }))));
  }
  return withToggleButton( /* @__PURE__ */React128.createElement(Viewport13, null, /* @__PURE__ */React128.createElement(ViewSmall12, null, /* @__PURE__ */React128.createElement(CategorizedListingsGrid, {
    listings: listingsList,
    propertyId: propertyId,
    showRoomHighlights: showRoomHighlights,
    useInlineMargin: useInlineMargin,
    filterActive: filterActive,
    targetItem: targetItem,
    insurtechPrimingCardCategorizedListing: insurtechPrimingCardCategorizedListing
  })), /* @__PURE__ */React128.createElement(ViewMedium11, null, /* @__PURE__ */React128.createElement(Experiment3, {
    name: "SmaSh_Desktop_Room_Carousel"
  }, /* @__PURE__ */React128.createElement(ExperimentControl3, null, /* @__PURE__ */React128.createElement(CategorizedListingsGrid, {
    listings: listingsList,
    propertyId: propertyId,
    showRoomHighlights: showRoomHighlights,
    useInlineMargin: useInlineMargin,
    filterActive: filterActive,
    targetItem: targetItem,
    insurtechPrimingCardCategorizedListing: insurtechPrimingCardCategorizedListing
  })), /* @__PURE__ */React128.createElement(ExperimentVariant3, {
    bucket: 1
  }, /* @__PURE__ */React128.createElement(CategorizedListingsBySections, {
    listings: listingsList,
    isMicroRoomCardEnabled: false,
    propertyId: propertyId,
    showRoomHighlights: showRoomHighlights,
    targetItem: targetItem
  }))))));
};
// src/components/property-offers/__private/__fragments/listings/listings.tsx
import React140, { useContext as useContext4, useImperativeHandle } from "react";
import { gql as gql100 } from "@apollo/client";
import { AdaptExAnalyticsEventFragment as AdaptExAnalyticsEventFragment4, AdaptExEventsProvider } from "@shared-ui/lodging-fragments";
import { PropertyDetailsAdaptExContext as PropertyDetailsAdaptExContext3 } from "@shared-ui/lodging-property-details";
// src/components/property-offers/__private/__fragments/listings/simple-listings/simple-listings.tsx
import React139 from "react";
// src/components/property-offers/__private/__fragments/listings/simple-listings/layouts/simple-listings-grid.tsx
import React138 from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid20, EGDSLayoutGridItem as EGDSLayoutGridItem17 } from "@egds/react-core/layout-grid";
// src/components/property-offers/__private/__fragments/listings/simple-listings/property-unit/control-property-unit.tsx
import React137 from "react";
import { gql as gql99 } from "@apollo/client";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType6 } from "@egds/react-core/images";
import { EGDSSheetTransition as EGDSSheetTransition16 } from "@egds/react-core/sheet";
import { useClickTracker as useClickTracker34 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog18 } from "@shared-ui/dialog-context";
import { ViewLarge as ViewLarge3, Viewport as Viewport16, ViewSmall as ViewSmall15 } from "@shared-ui/viewport-context";
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/sections/dialog-info-section/sections/sleeping-arrangements.tsx
import React129 from "react";
import { gql as gql97 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing70 } from "@egds/react-core/spacing";
var __SleepingArrangementsFragment = gql97(_templateObject99(), SpaceDetailsHeader.fragment, SpaceDetailsSpaces.fragment, SpaceDetailsFloorPlan.fragment);
var SleepingArrangements = function (param) {
  var data = param.data;
  if (!data) {
    return null;
  }
  return /* @__PURE__ */React129.createElement("div", null, /* @__PURE__ */React129.createElement(SpaceDetailsHeader, {
    data: data,
    headingSize: 5
  }), /* @__PURE__ */React129.createElement(SpaceDetailsFloorPlan, {
    data: data,
    rfrr: "HOT.HIS.SpaceDetails.MultiUnit.Floorplan"
  }), /* @__PURE__ */React129.createElement(EGDSSpacing70, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React129.createElement(SpaceDetailsSpaces, {
    data: data
  })));
};
SleepingArrangements.displayName = "SleepingArrangements";
SleepingArrangements.fragment = __SleepingArrangementsFragment;
// src/components/property-offers/__private/__fragments/details-dialog-trigger/dialog/sections/dialog-rate-plan-section.tsx
import React130 from "react";
import { EGDSCard as EGDSCard19 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid16, EGDSLayoutGridItem as EGDSLayoutGridItem14, MinMax as MinMax2, Repeat } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing71 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading26 } from "@egds/react-core/text";
var DialogRatePlanSection = function (param) {
  var listing = param.listing,
    ratePlanTitle = param.ratePlanTitle,
    listingIndex = param.listingIndex,
    closeDialog = param.closeDialog;
  return /* @__PURE__ */React130.createElement("div", null, listing.ratePlans.length > 0 && ratePlanTitle && /* @__PURE__ */React130.createElement(EGDSHeading26, {
    tag: "h3",
    size: 4,
    "data-stid": "property-offers-details-room-options-header"
  }, ratePlanTitle.text), listing && /* @__PURE__ */React130.createElement(EGDSSpacing71, {
    margin: {
      block: "two"
    }
  }, /* @__PURE__ */React130.createElement("div", {
    className: "uitk-type-right"
  }, /* @__PURE__ */React130.createElement(AvailabilityCta, {
    key: "availability-cta-".concat(listingIndex),
    data: listing,
    closeDialog: closeDialog,
    listingIndex: listingIndex
  }))), /* @__PURE__ */React130.createElement(EGDSLayoutGrid16, {
    columns: [Repeat("auto-fit", MinMax2("70x", "1fr"))],
    space: "three"
  }, listing.ratePlans.map(function (ratePlan, index) {
    return /* @__PURE__ */React130.createElement(EGDSLayoutGridItem14, {
      key: "dialog-rate-plan-".concat(index)
    }, /* @__PURE__ */React130.createElement(EGDSCard19, {
      border: true,
      padded: true,
      overflow: true
    }, /* @__PURE__ */React130.createElement(RatePlanWithAmenities, {
      data: ratePlan,
      listingIndex: listingIndex,
      roomId: listing.id
    })));
  })));
};
DialogRatePlanSection.displayName = "DialogRatePlanSection";
// src/components/property-offers/__private/__fragments/property-rate-plans-expando.tsx
import React131 from "react";
import { gql as gql98 } from "@apollo/client";
import { EGDSExpandoLink } from "@egds/react-core/expando";
import { EGDSSpacing as EGDSSpacing72 } from "@egds/react-core/spacing";
var fragment64 = gql98(_templateObject100());
var RatePlansExpando = function (param) {
  var data = param.data,
    children = param.children;
  var collapseButton = data.collapseButton,
    expandButton = data.expandButton;
  return /* @__PURE__ */React131.createElement(EGDSSpacing72, {
    padding: {
      inlinestart: "one"
    }
  }, /* @__PURE__ */React131.createElement(EGDSExpandoLink, {
    size: "small",
    isVisible: false,
    expandoTitle: expandButton.text,
    expandedLabel: collapseButton.text
  }, children));
};
RatePlansExpando.fragment = fragment64;
RatePlansExpando.displayName = "RatePlansExpando";
// src/components/property-offers/__private/__fragments/listings/sections/info-section.tsx
import React133 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex27 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing73 } from "@egds/react-core/spacing";
import { ViewMedium as ViewMedium13, Viewport as Viewport15, ViewSmall as ViewSmall14 } from "@shared-ui/viewport-context";
// src/components/property-offers/__private/__fragments/listings/sections/multi-column-features-section.tsx
import React132 from "react";
import { withEGDSLayoutGrid as withEGDSLayoutGrid3 } from "@egds/react-core/layout-grid";
import { EGDSList as EGDSList8 } from "@egds/react-core/list";
import { ViewMedium as ViewMedium12, Viewport as Viewport14, ViewSmall as ViewSmall13 } from "@shared-ui/viewport-context";
var Features = function (param) {
  var features = param.features,
    maxColumns = param.maxColumns;
  var list = function (props) {
    return /* @__PURE__ */React132.createElement(EGDSList8, _object_spread({
      bullet: "icon-standard"
    }, props), features.map(function (feature, index) {
      return /* @__PURE__ */React132.createElement(PropertyFeatures, {
        data: feature,
        uniqueDialogId: "propertyunit-feature",
        key: "feature-".concat(index)
      });
    }));
  };
  var ListWithGrid = withEGDSLayoutGrid3(list);
  return /* @__PURE__ */React132.createElement(ListWithGrid, {
    columns: features.length <= 4 || maxColumns === 1 ? 1 : 2
  });
};
Features.displayName = "Features";
var MultiColumnFeaturesSection = function (param) {
  var features = param.features;
  if (!(features === null || features === void 0 ? void 0 : features.length)) {
    return null;
  }
  return /* @__PURE__ */React132.createElement(Viewport14, null, /* @__PURE__ */React132.createElement(ViewSmall13, null, /* @__PURE__ */React132.createElement(Features, {
    features: features,
    maxColumns: 1
  })), /* @__PURE__ */React132.createElement(ViewMedium12, null, /* @__PURE__ */React132.createElement(Features, {
    features: features,
    maxColumns: 2
  })));
};
MultiColumnFeaturesSection.displayName = "MultiColumnFeaturesSection";
// src/components/property-offers/__private/__fragments/listings/sections/info-section.tsx
var InfoSection = function (param) {
  var children = param.children,
    headerData = param.headerData,
    features = param.features,
    roomId = param.roomId;
  return /* @__PURE__ */React133.createElement("div", {
    "data-stid": "section-roomtype"
  }, /* @__PURE__ */React133.createElement(EGDSSpacing73, {
    padding: {
      large: {
        inlineend: "six"
      },
      extra_large: {
        inlineend: "six"
      }
    }
  }, /* @__PURE__ */React133.createElement("div", null, /* @__PURE__ */React133.createElement(Viewport15, null, /* @__PURE__ */React133.createElement(ViewSmall14, null, /* @__PURE__ */React133.createElement(PropertyOffersHeader, {
    data: headerData,
    textSize: 6,
    roomId: roomId
  })), /* @__PURE__ */React133.createElement(ViewMedium13, null, /* @__PURE__ */React133.createElement(PropertyOffersHeader, {
    data: headerData,
    textSize: 5,
    roomId: roomId
  }))))), /* @__PURE__ */React133.createElement(MultiColumnFeaturesSection, {
    features: features
  }), /* @__PURE__ */React133.createElement(Viewport15, null, /* @__PURE__ */React133.createElement(ViewSmall14, null, /* @__PURE__ */React133.createElement(EGDSLayoutFlex27, {
    justifyContent: "start"
  }, /* @__PURE__ */React133.createElement("div", null, children))), /* @__PURE__ */React133.createElement(ViewMedium13, null, /* @__PURE__ */React133.createElement("div", null, children))));
};
InfoSection.displayName = "InfoSection";
// src/components/property-offers/__private/__fragments/listings/simple-listings/property-unit/layouts/horizontal-one-row-property-unit-layout.tsx
import React134 from "react";
import { EGDSCard as EGDSCard20, EGDSCardContentSection as EGDSCardContentSection12 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid18, EGDSLayoutGridItem as EGDSLayoutGridItem15 } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition4 } from "@egds/react-core/layout-position";
import { EGDSSpacing as EGDSSpacing74 } from "@egds/react-core/spacing";
// src/utils/react-children-to-display-name-map.ts
import { Children } from "react";
function reactChildrenToDisplayNameMap(children) {
  if (!children) {
    return {};
  }
  var map = {};
  Children.forEach(children, function (c) {
    var _c_type, _map_displayName;
    var displayName = c === null || c === void 0 ? void 0 : (_c_type = c.type) === null || _c_type === void 0 ? void 0 : _c_type.displayName;
    if (!displayName) {
      return;
    }
    if (!map[displayName]) {
      map[displayName] = [];
    }
    (_map_displayName = map[displayName]) === null || _map_displayName === void 0 ? void 0 : _map_displayName.push(c);
  });
  return map;
}
// src/components/property-offers/__private/__fragments/listings/simple-listings/property-unit/layouts/horizontal-one-row-property-unit-layout.tsx
var HorizontalOneRowPropertyUnitLayout = function (param) {
  var children = param.children,
    shouldRenderLargeImage = param.shouldRenderLargeImage;
  if (!children) {
    return null;
  }
  var _reactChildrenToDisplayNameMap = reactChildrenToDisplayNameMap(children),
    MediaSection2 = _reactChildrenToDisplayNameMap.MediaSection,
    InfoSection2 = _reactChildrenToDisplayNameMap.InfoSection,
    RatePlanWithAmenities2 = _reactChildrenToDisplayNameMap.RatePlanWithAmenities,
    AvailabilityCta3 = _reactChildrenToDisplayNameMap.AvailabilityCta;
  return /* @__PURE__ */React134.createElement(EGDSCard20, {
    overflow: true,
    padded: !shouldRenderLargeImage
  }, /* @__PURE__ */React134.createElement("div", {
    "data-stid": "horizontal-layout"
  }, /* @__PURE__ */React134.createElement(EGDSLayoutGrid18, {
    columns: 12,
    space: "three"
  }, /* @__PURE__ */React134.createElement(EGDSLayoutGridItem15, {
    colSpan: shouldRenderLargeImage ? 4 : 3
  }, /* @__PURE__ */React134.createElement("div", null, MediaSection2 && MediaSection2.length > 0 && MediaSection2[0] && React134.cloneElement(MediaSection2[0], {
    className: "uitk-rounded-border-top uitk-rounded-border-bottom"
  }))), /* @__PURE__ */React134.createElement(EGDSLayoutGridItem15, {
    colSpan: shouldRenderLargeImage ? 8 : 9
  }, /* @__PURE__ */React134.createElement(EGDSSpacing74, {
    padding: shouldRenderLargeImage ? {
      blockstart: "three",
      inlineend: "two"
    } : {}
  }, /* @__PURE__ */React134.createElement(EGDSCardContentSection12, {
    padded: false
  }, /* @__PURE__ */React134.createElement(EGDSLayoutGrid18, {
    columns: 8,
    space: "three"
  }, /* @__PURE__ */React134.createElement(EGDSLayoutGridItem15, {
    colSpan: 4
  }, /* @__PURE__ */React134.createElement("div", null, InfoSection2)), /* @__PURE__ */React134.createElement(EGDSLayoutGridItem15, {
    colSpan: 4
  }, /* @__PURE__ */React134.createElement("div", null, RatePlanWithAmenities2)))))), AvailabilityCta3 && /* @__PURE__ */React134.createElement(EGDSLayoutPosition4, {
    type: "absolute",
    position: {
      top: "three",
      right: "three"
    }
  }, AvailabilityCta3))));
};
HorizontalOneRowPropertyUnitLayout.displayName = "HorizontalOneRowPropertyUnitLayout";
// src/components/property-offers/__private/__fragments/listings/simple-listings/property-unit/layouts/horizontal-two-row-property-unit-layout.tsx
import React135 from "react";
import { EGDSCard as EGDSCard21 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid19, EGDSLayoutGridItem as EGDSLayoutGridItem16 } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition5 } from "@egds/react-core/layout-position";
var HorizontalTwoRowsPropertyUnitLayout = function (param) {
  var children = param.children;
  if (!children) {
    return null;
  }
  var _reactChildrenToDisplayNameMap = reactChildrenToDisplayNameMap(children),
    MediaSection2 = _reactChildrenToDisplayNameMap.MediaSection,
    InfoSection2 = _reactChildrenToDisplayNameMap.InfoSection,
    RatePlanWithAmenities2 = _reactChildrenToDisplayNameMap.RatePlanWithAmenities,
    AvailabilityCta3 = _reactChildrenToDisplayNameMap.AvailabilityCta;
  return /* @__PURE__ */React135.createElement(EGDSCard21, {
    padded: true,
    overflow: true
  }, /* @__PURE__ */React135.createElement("div", {
    "data-stid": "horizontal-two-row-layout"
  }, /* @__PURE__ */React135.createElement(EGDSLayoutGrid19, {
    columns: 6,
    space: "three"
  }, /* @__PURE__ */React135.createElement(EGDSLayoutGridItem16, {
    colSpan: 2
  }, /* @__PURE__ */React135.createElement("div", null, MediaSection2 && (MediaSection2 === null || MediaSection2 === void 0 ? void 0 : MediaSection2.length) > 0 && MediaSection2[0] && React135.cloneElement(MediaSection2[0], {
    className: "uitk-rounded-border-top uitk-rounded-border-bottom"
  }))), /* @__PURE__ */React135.createElement(EGDSLayoutGridItem16, {
    colSpan: 4
  }, /* @__PURE__ */React135.createElement("div", null, InfoSection2)), RatePlanWithAmenities2 === null || RatePlanWithAmenities2 === void 0 ? void 0 : RatePlanWithAmenities2.map(function (child, index) {
    return /* @__PURE__ */React135.createElement(EGDSLayoutGridItem16, {
      key: "horizontal-two-rows-unit-".concat(index),
      colSpan: 3
    }, /* @__PURE__ */React135.createElement("div", null, /* @__PURE__ */React135.createElement(EGDSCard21, {
      overflow: true,
      padded: true,
      border: true
    }, child)));
  }), AvailabilityCta3 && /* @__PURE__ */React135.createElement(EGDSLayoutPosition5, {
    type: "absolute",
    position: {
      top: "four",
      right: "four"
    }
  }, AvailabilityCta3))));
};
HorizontalTwoRowsPropertyUnitLayout.displayName = "HorizontalTwoRowsPropertyUnitLayout";
// src/components/property-offers/__private/__fragments/listings/simple-listings/property-unit/layouts/vertical-property-unit-layout.tsx
import React136 from "react";
import { EGDSCard as EGDSCard22, EGDSCardContentSection as EGDSCardContentSection13 } from "@egds/react-core/cards";
import { EGDSSpacing as EGDSSpacing75 } from "@egds/react-core/spacing";
var VerticalPropertyUnitLayout = function (param) {
  var children = param.children,
    imageRatio = param.imageRatio;
  if (!children) {
    return null;
  }
  var _reactChildrenToDisplayNameMap = reactChildrenToDisplayNameMap(children),
    MediaSection2 = _reactChildrenToDisplayNameMap.MediaSection,
    InfoSection2 = _reactChildrenToDisplayNameMap.InfoSection,
    RatePlanWithAmenities2 = _reactChildrenToDisplayNameMap.RatePlanWithAmenities,
    AvailabilityCta3 = _reactChildrenToDisplayNameMap.AvailabilityCta,
    RatePlansExpando2 = _reactChildrenToDisplayNameMap.RatePlansExpando;
  var StaticRatePlans = (RatePlanWithAmenities2 === null || RatePlanWithAmenities2 === void 0 ? void 0 : RatePlanWithAmenities2.slice(0, 2)) || RatePlanWithAmenities2;
  var DynamicRatePlans = RatePlanWithAmenities2 && (RatePlanWithAmenities2 === null || RatePlanWithAmenities2 === void 0 ? void 0 : RatePlanWithAmenities2.length) > 2 && RatePlanWithAmenities2.slice(2) || null;
  var DynamicRatePlansComponents = DynamicRatePlans === null || DynamicRatePlans === void 0 ? void 0 : DynamicRatePlans.map(function (child, index) {
    return /* @__PURE__ */React136.createElement(EGDSCardContentSection13, {
      key: "vertical-dynamic-unit-".concat(index),
      border: "top"
    }, child);
  });
  var ExpandoWrapper = DynamicRatePlansComponents && RatePlansExpando2 && RatePlansExpando2.length > 0 && RatePlansExpando2[0] && React136.cloneElement(RatePlansExpando2[0], {}, DynamicRatePlansComponents);
  return /* @__PURE__ */React136.createElement(EGDSSpacing75, {
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React136.createElement(EGDSCard22, {
    "data-stid": "vertical-layout",
    overflow: true
  }, MediaSection2 && (MediaSection2 === null || MediaSection2 === void 0 ? void 0 : MediaSection2.length) > 0 && MediaSection2[0] && React136.cloneElement(MediaSection2[0], {
    className: "uitk-rounded-border-top",
    imageRatio: imageRatio
  }), /* @__PURE__ */React136.createElement(EGDSCardContentSection13, {
    padded: false
  }, /* @__PURE__ */React136.createElement(EGDSSpacing75, {
    padding: {
      small: "three",
      medium: {
        blockstart: "four",
        blockend: "one",
        inline: "four"
      }
    }
  }, /* @__PURE__ */React136.createElement("div", null, InfoSection2))), AvailabilityCta3 && /* @__PURE__ */React136.createElement(EGDSCardContentSection13, {
    className: "uitk-type-right",
    border: "top"
  }, AvailabilityCta3), StaticRatePlans === null || StaticRatePlans === void 0 ? void 0 : StaticRatePlans.map(function (child, index) {
    return /* @__PURE__ */React136.createElement(EGDSCardContentSection13, {
      key: "vertical-unit-".concat(index),
      border: "top"
    }, /* @__PURE__ */React136.createElement(EGDSSpacing75, {
      padding: {
        block: "two"
      }
    }, /* @__PURE__ */React136.createElement("div", null, child)));
  }), ExpandoWrapper));
};
VerticalPropertyUnitLayout.displayName = "VerticalPropertyUnitLayout";
// src/components/property-offers/__private/__fragments/listings/simple-listings/property-unit/control-property-unit.tsx
var fragment65 = gql99(_templateObject101(), PropertyOffersHeader.fragment, PropertyFeatures.fragment, PropertyBaseFeatures.fragment, LodgingHighlightedMessages.fragment, PropertyOffersRateViewScarcity.fragment, PropertyReserveButton.fragment, PropertyRatePlanBadge.fragment, UnitPropertyOffersDetailsDialog.fragment, RatePlanWithAmenities.fragment, LinkTrigger.fragment, AvailabilityCta.fragment, RatePlansExpando.fragment, SleepingArrangements.fragment, RoomAmenitiesDescription.fragment, SpaceDetails.fragment, UnitHighlights.fragment, LodgingReviewSection.fragment);
var ControlPropertyUnit = function (param) {
  var data = param.data,
    listingIndex = param.listingIndex,
    shouldRenderAsTwoRows = param.shouldRenderAsTwoRows,
    shouldRenderLargeImage = param.shouldRenderLargeImage,
    className = param.className,
    forceVerticalPropertyUnitLayout = param.forceVerticalPropertyUnitLayout,
    propertyId = param.propertyId;
  var getContent = function getContent(amenityTextSize) {
    var _trigger_clientSideAnalytics, _trigger_clientSideAnalytics1, _toolbar_clientSideAnalytics, _toolbar_clientSideAnalytics1;
    return [/* @__PURE__ */React137.createElement(MediaSection, {
      key: "media-section-".concat(id),
      unitGallery: unitGallery,
      handleCarouselImageClick: dialogActions.openDialog,
      propertyId: propertyId
    }), /* @__PURE__ */React137.createElement(InfoSection, {
      key: "info-section-".concat(id),
      headerData: header,
      roomId: id,
      features: features
    }, /* @__PURE__ */React137.createElement(LinkTrigger, {
      data: trigger,
      openDialog: openMoreDetailsDialog("".concat((_trigger_clientSideAnalytics = trigger.clientSideAnalytics) === null || _trigger_clientSideAnalytics === void 0 ? void 0 : _trigger_clientSideAnalytics.referrerId), "".concat((_trigger_clientSideAnalytics1 = trigger.clientSideAnalytics) === null || _trigger_clientSideAnalytics1 === void 0 ? void 0 : _trigger_clientSideAnalytics1.linkName), "".concat(toolbar === null || toolbar === void 0 ? void 0 : (_toolbar_clientSideAnalytics = toolbar.clientSideAnalytics) === null || _toolbar_clientSideAnalytics === void 0 ? void 0 : _toolbar_clientSideAnalytics.referrerId), "".concat(toolbar === null || toolbar === void 0 ? void 0 : (_toolbar_clientSideAnalytics1 = toolbar.clientSideAnalytics) === null || _toolbar_clientSideAnalytics1 === void 0 ? void 0 : _toolbar_clientSideAnalytics1.linkName))
    }))].concat(_to_consumable_array(ratePlans.map(function (ratePlan, index) {
      return /* @__PURE__ */React137.createElement(RatePlanWithAmenities, {
        key: "rate-plan-section-".concat(id, "-").concat(index),
        data: ratePlan,
        listingIndex: listingIndex,
        roomId: id,
        amenityTextSize: amenityTextSize
      });
    })), [availabilityCallToAction && /* @__PURE__ */React137.createElement(AvailabilityCta, {
      key: "availability-cta-".concat(id),
      data: data,
      listingIndex: listingIndex
    }), /* @__PURE__ */React137.createElement(RatePlansExpando, {
      data: ratePlansExpando,
      key: "rate-plans-expando-".concat(id)
    })]);
  };
  var unitGallery = data.unitGallery,
    detailsDialog = data.detailsDialog,
    id = data.id,
    features = data.features,
    ratePlans = data.ratePlans,
    availabilityCallToAction = data.availabilityCallToAction,
    ratePlansExpando = data.ratePlansExpando,
    header = data.header;
  var trackClick = useClickTracker34();
  var _React137_useState = _sliced_to_array(React137.useState(""), 2),
    dialogCloseReferrerId = _React137_useState[0],
    setDialogCloseReferrerId = _React137_useState[1];
  var _React137_useState1 = _sliced_to_array(React137.useState(""), 2),
    dialogCloseLinkName = _React137_useState1[0],
    setDialogCloseLinkName = _React137_useState1[1];
  var _useDialog18 = _sliced_to_array(useDialog18("room-info-dialog-".concat(id, "-").concat(listingIndex), "propertyUnitRoomInfoDialog"), 3),
    isDialogOpen = _useDialog18[0],
    dialogActions = _useDialog18[1],
    DialogComponent = _useDialog18[2];
  var closeMoreDetailsDialog = React137.useCallback(function () {
    if (isDialogOpen) {
      dialogActions.closeDialog();
    }
    trackClick(dialogCloseReferrerId, dialogCloseLinkName);
  }, [dialogActions, trackClick, dialogCloseReferrerId, dialogCloseLinkName, isDialogOpen]);
  if (!id || !detailsDialog) {
    return null;
  }
  var trigger = detailsDialog.trigger,
    toolbar = detailsDialog.toolbar,
    content = detailsDialog.content;
  var openMoreDetailsDialog = function (referrerId, linkName, detailsDialogCloseReferrerId, detailsDialogCloseLinkName) {
    return function () {
      dialogActions.openDialog();
      trackClick(referrerId, linkName);
      setDialogCloseReferrerId(detailsDialogCloseReferrerId);
      setDialogCloseLinkName(detailsDialogCloseLinkName);
    };
  };
  var horizontalLayout = shouldRenderAsTwoRows ? /* @__PURE__ */React137.createElement(HorizontalTwoRowsPropertyUnitLayout, null, getContent(200)) : /* @__PURE__ */React137.createElement(HorizontalOneRowPropertyUnitLayout, {
    shouldRenderLargeImage: shouldRenderLargeImage
  }, getContent(300));
  return /* @__PURE__ */React137.createElement("div", {
    className: className,
    key: "property-offer-".concat(listingIndex),
    "data-stid": "property-offer-".concat(listingIndex)
  }, /* @__PURE__ */React137.createElement(Viewport16, null, /* @__PURE__ */React137.createElement(ViewSmall15, null, /* @__PURE__ */React137.createElement(VerticalPropertyUnitLayout, {
    imageRatio: EGDSFigureAspectRatioType6.R21_9
  }, getContent())), /* @__PURE__ */React137.createElement(ViewLarge3, null, forceVerticalPropertyUnitLayout ? /* @__PURE__ */React137.createElement(VerticalPropertyUnitLayout, {
    imageRatio: EGDSFigureAspectRatioType6.R21_9
  }, getContent()) : horizontalLayout)), /* @__PURE__ */React137.createElement(EGDSSheetTransition16, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React137.createElement(DialogComponent, null, /* @__PURE__ */React137.createElement(UnitPropertyOffersDetailsDialog, {
    closeDialog: closeMoreDetailsDialog,
    isDialogOpen: isDialogOpen,
    listing: data,
    data: detailsDialog,
    ratePlans: /* @__PURE__ */React137.createElement(DialogRatePlanSection, {
      ratePlanTitle: content.ratePlanTitle,
      listing: data,
      closeDialog: closeMoreDetailsDialog,
      listingIndex: listingIndex
    })
  }))));
};
ControlPropertyUnit.fragment = fragment65;
ControlPropertyUnit.displayName = "ControlPropertyUnit";
// src/components/property-offers/__private/__fragments/listings/simple-listings/layouts/simple-listings-grid.tsx
var SimpleListingsGrid = function (param) {
  var listings = param.listings,
    _param_forceVerticalPropertyUnitLayout = param.forceVerticalPropertyUnitLayout,
    forceVerticalPropertyUnitLayout = _param_forceVerticalPropertyUnitLayout === void 0 ? false : _param_forceVerticalPropertyUnitLayout,
    propertyId = param.propertyId;
  var isMessagingCardDismissed = React138.useContext(OffersLevelContext).isMessagingCardDismissed;
  var shouldRenderTwoRows = ((listings === null || listings === void 0 ? void 0 : listings.filter(function (listing) {
    var _listing_ratePlans;
    return "ratePlans" in listing && (listing === null || listing === void 0 ? void 0 : (_listing_ratePlans = listing.ratePlans) === null || _listing_ratePlans === void 0 ? void 0 : _listing_ratePlans.length) > 1;
  }).length) || 0) > 0;
  var shouldRenderLargeImage = (listings === null || listings === void 0 ? void 0 : listings.filter(function (listing) {
    var _listing_ratePlans;
    return "ratePlans" in listing && (listing === null || listing === void 0 ? void 0 : (_listing_ratePlans = listing.ratePlans) === null || _listing_ratePlans === void 0 ? void 0 : _listing_ratePlans.length) >= 1;
  }).length) === 0;
  var roomPosition = 0;
  return /* @__PURE__ */React138.createElement(EGDSLayoutGrid20, {
    columns: {
      auto_fill: "seventy_six"
    },
    space: "three",
    justifyContent: "start"
  }, listings === null || listings === void 0 ? void 0 : listings.map(function (listing, index) {
    var __typename = listing.__typename;
    if (__typename === "MessageResult" && !isMessagingCardDismissed) {
      return /* @__PURE__ */React138.createElement(EGDSLayoutGridItem17, {
        key: "".concat(__typename, "-").concat(index)
      }, /* @__PURE__ */React138.createElement(VerticalMessageCardWithActions, {
        data: listing
      }));
    }
    if (__typename === "PropertyUnit") {
      roomPosition += 1;
      return /* @__PURE__ */React138.createElement(EGDSLayoutGridItem17, {
        colSpan: "all",
        key: "".concat(__typename, "-").concat(index)
      }, /* @__PURE__ */React138.createElement("div", null, /* @__PURE__ */React138.createElement(ControlPropertyUnit, {
        listingIndex: roomPosition,
        data: listing,
        shouldRenderAsTwoRows: shouldRenderTwoRows,
        shouldRenderLargeImage: shouldRenderLargeImage,
        forceVerticalPropertyUnitLayout: forceVerticalPropertyUnitLayout,
        propertyId: propertyId
      })));
    }
    return null;
  }));
};
// src/components/property-offers/__private/__fragments/listings/simple-listings/simple-listings.tsx
var SimpleListings = function (param) {
  var forceVerticalPropertyUnitLayout = param.forceVerticalPropertyUnitLayout,
    listings = param.listings,
    propertyId = param.propertyId;
  return /* @__PURE__ */React139.createElement(SimpleListingsGrid, {
    listings: listings,
    forceVerticalPropertyUnitLayout: forceVerticalPropertyUnitLayout,
    propertyId: propertyId
  });
};
// src/components/property-offers/__private/__fragments/listings/listings.tsx
var fragment66 = gql100(_templateObject102(), AdaptExAnalyticsEventFragment4, ControlPropertyUnit.fragment, PropertyUnitCategorization.fragment, VerticalMessagingCard.fragment, LodgingSectionHeader.fragment, ListingsToggle.fragment, InsurtechPrimingCardCategorizedListing.fragment);
var Listings = function (props) {
  var data = props.data,
    className = props.className,
    forceVerticalPropertyUnitLayout = props.forceVerticalPropertyUnitLayout,
    renderLayout = props.renderLayout,
    _props_showRoomHighlights = props.showRoomHighlights,
    showRoomHighlights = _props_showRoomHighlights === void 0 ? false : _props_showRoomHighlights,
    listingsRef = props.listingsRef,
    targetItem = props.targetItem;
  var isMessagingCardDismissed = React140.useContext(OffersLevelContext).isMessagingCardDismissed;
  var ref = React140.useRef(null);
  useImperativeHandle(listingsRef, function () {
    return ref.current;
  }, []);
  var propertyId = data.id;
  React140.useEffect(function () {
    if (isMessagingCardDismissed) {
      if (ref === null || ref === void 0 ? void 0 : ref.current) {
        var firstfocusElement = ref.current.firstChild;
        firstfocusElement.setAttribute("tabIndex", "-1");
        firstfocusElement === null || firstfocusElement === void 0 ? void 0 : firstfocusElement.focus();
      }
    }
  }, [isMessagingCardDismissed]);
  var offerAdaptExSuccessEvents = data.offerAdaptExSuccessEvents,
    categorizedListings = data.categorizedListings,
    listings = data.listings,
    listingsToggle = data.listingsToggle,
    insurtechPrimingCardCategorizedListing = data.insurtechPrimingCardCategorizedListing;
  var _useContext4 = _sliced_to_array(useContext4(PropertyDetailsAdaptExContext3), 1),
    adaptExState = _useContext4[0];
  var amenitiesAdaptExSuccessEvents = adaptExState.amenitiesAdaptExSuccessEvents;
  var adaptExSuccessEvents = offerAdaptExSuccessEvents !== null && offerAdaptExSuccessEvents !== void 0 ? offerAdaptExSuccessEvents : [];
  if (amenitiesAdaptExSuccessEvents && (amenitiesAdaptExSuccessEvents === null || amenitiesAdaptExSuccessEvents === void 0 ? void 0 : amenitiesAdaptExSuccessEvents.length) > 0) {
    adaptExSuccessEvents = _to_consumable_array(adaptExSuccessEvents).concat(_to_consumable_array(amenitiesAdaptExSuccessEvents));
  }
  if (!categorizedListings && !listings) {
    return null;
  }
  var categorizedListingsUnavailable = !!data.listings;
  if (categorizedListingsUnavailable) {
    return /* @__PURE__ */React140.createElement("div", {
      "data-stid": "section-room-list",
      className: className,
      ref: ref
    }, /* @__PURE__ */React140.createElement(AdaptExEventsProvider, {
      value: {
        adaptExSuccessEvents: adaptExSuccessEvents
      }
    }, /* @__PURE__ */React140.createElement(SimpleListings, {
      listings: listings,
      forceVerticalPropertyUnitLayout: forceVerticalPropertyUnitLayout,
      propertyId: propertyId
    })));
  }
  return /* @__PURE__ */React140.createElement("div", {
    "data-stid": "section-room-list",
    className: className,
    ref: ref
  }, /* @__PURE__ */React140.createElement(AdaptExEventsProvider, {
    value: {
      adaptExSuccessEvents: adaptExSuccessEvents
    }
  }, /* @__PURE__ */React140.createElement(CategorizedListings, {
    listings: categorizedListings,
    renderLayout: renderLayout,
    propertyId: propertyId,
    showRoomHighlights: showRoomHighlights,
    targetItem: targetItem,
    toggle: listingsToggle,
    insurtechPrimingCardCategorizedListing: insurtechPrimingCardCategorizedListing
  })));
};
Listings.fragment = fragment66;
Listings.displayName = "Listings";
// src/components/property-offers/__private/__fragments/listings-error-message.tsx
import React142 from "react";
import { gql as gql102 } from "@apollo/client";
import { EGDSCard as EGDSCard23, EGDSCardContentSection as EGDSCardContentSection14 } from "@egds/react-core/cards";
// src/components/__private/__fragments/error-message.tsx
import React141 from "react";
import { gql as gql101 } from "@apollo/client";
import { EGDSLink as EGDSLink14 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing76 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText38 } from "@egds/react-core/text";
var __ErrorMessageFragment = gql101(_templateObject103());
var ErrorMessage = function (param) {
  var className = param.className,
    data = param.data;
  var _action_primary;
  var title = data.title,
    action = data.action;
  var Link = useLinkComponent().Link;
  if (!(title === null || title === void 0 ? void 0 : title.text)) {
    return null;
  }
  return /* @__PURE__ */React141.createElement("div", {
    "data-stid": "error-messages",
    className: className
  }, /* @__PURE__ */React141.createElement(EGDSSpacing76, {
    padding: {
      inlineend: "one"
    }
  }, /* @__PURE__ */React141.createElement(EGDSText38, {
    theme: "negative",
    inline: true
  }, title.text)), (action === null || action === void 0 ? void 0 : (_action_primary = action.primary) === null || _action_primary === void 0 ? void 0 : _action_primary.linkUrl) && /* @__PURE__ */React141.createElement(EGDSLink14, {
    inline: true
  }, /* @__PURE__ */React141.createElement(Link, {
    href: action.primary.linkUrl
  }, action.primary.text)));
};
ErrorMessage.displayName = "ErrorMessage";
ErrorMessage.fragment = __ErrorMessageFragment;
// src/components/property-offers/__private/__fragments/listings-error-message.tsx
var __fragment = gql102(_templateObject104(), ErrorMessage.fragment);
var ListingsErrorMessage = function (param) {
  var data = param.data,
    className = param.className;
  var _data_errorMessage;
  var error = useMultiItemContext().error;
  if (!((_data_errorMessage = data.errorMessage) === null || _data_errorMessage === void 0 ? void 0 : _data_errorMessage.title) && !error) {
    return null;
  }
  var errorMessage = data.errorMessage ? data.errorMessage : {
    __typename: "MessageResult",
    title: {
      text: error || null,
      __typename: "MessagingResultTitle"
    },
    action: null
  };
  return /* @__PURE__ */React142.createElement(EGDSCard23, {
    className: className
  }, /* @__PURE__ */React142.createElement(EGDSCardContentSection14, null, /* @__PURE__ */React142.createElement(ErrorMessage, {
    data: errorMessage
  })));
};
ListingsErrorMessage.displayName = "ListingsErrorMessage";
ListingsErrorMessage.fragment = __fragment;
// src/components/property-offers/__private/__fragments/shopping-context.tsx
import { gql as gql103 } from "@apollo/client";
var __ShoppingContextFragment = gql103(_templateObject105());
// src/components/property-offers/__private/__fragments/sticky-bar-disclaimer.tsx
import React143 from "react";
import { gql as gql104 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing77 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText39 } from "@egds/react-core/text";
var __fragment2 = gql104(_templateObject106());
var StickyBarDisclaimer = function (param) {
  var data = param.data;
  var _stickyBar_price_disclaimer, _stickyBar_price, _stickyBar_price_disclaimer1, _stickyBar_price1;
  var stickyBar = data.stickyBar;
  if (!(stickyBar === null || stickyBar === void 0 ? void 0 : (_stickyBar_price = stickyBar.price) === null || _stickyBar_price === void 0 ? void 0 : (_stickyBar_price_disclaimer = _stickyBar_price.disclaimer) === null || _stickyBar_price_disclaimer === void 0 ? void 0 : _stickyBar_price_disclaimer.value)) {
    return null;
  }
  return /* @__PURE__ */React143.createElement(EGDSSpacing77, {
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React143.createElement(EGDSText39, {
    size: 200
  }, stickyBar === null || stickyBar === void 0 ? void 0 : (_stickyBar_price1 = stickyBar.price) === null || _stickyBar_price1 === void 0 ? void 0 : (_stickyBar_price_disclaimer1 = _stickyBar_price1.disclaimer) === null || _stickyBar_price_disclaimer1 === void 0 ? void 0 : _stickyBar_price_disclaimer1.value));
};
StickyBarDisclaimer.displayName = "StickyBarDisclaimer";
StickyBarDisclaimer.fragment = __fragment2;
// src/components/property-offers/horizontal-messaging-card-wrapper.tsx
import React144 from "react";
import { EGDSSpacing as EGDSSpacing78 } from "@egds/react-core/spacing";
import { MessageResult as MessageResult3 } from "@shared-ui/lodging-fragments";
var HorizontalMessagingCardWrapper = function (param) {
  var offerLevelMessages = param.offerLevelMessages;
  var isMessagingCardDismissed = React144.useContext(OffersLevelContext).isMessagingCardDismissed;
  if (!offerLevelMessages) {
    return null;
  }
  var MessagingCard = withMessagingCardActions(MessageResult3);
  if (!isMessagingCardDismissed) {
    var messageCardElements = offerLevelMessages === null || offerLevelMessages === void 0 ? void 0 : offerLevelMessages.map(function (message, index) {
      var _action_primary_actionDetails, _action_primary, _action_secondary_actionDetails, _action_secondary;
      var action = message.action;
      return /* @__PURE__ */React144.createElement(EGDSSpacing78, {
        margin: {
          blockend: "three",
          blockstart: "three"
        },
        key: "horizontal-message-".concat(index)
      }, /* @__PURE__ */React144.createElement("div", {
        "data-stid": "horizontal-messaging-card"
      }, /* @__PURE__ */React144.createElement(MessagingCard, {
        data: message,
        primaryAction: action === null || action === void 0 ? void 0 : (_action_primary = action.primary) === null || _action_primary === void 0 ? void 0 : (_action_primary_actionDetails = _action_primary.actionDetails) === null || _action_primary_actionDetails === void 0 ? void 0 : _action_primary_actionDetails.action,
        secondaryAction: action === null || action === void 0 ? void 0 : (_action_secondary = action.secondary) === null || _action_secondary === void 0 ? void 0 : (_action_secondary_actionDetails = _action_secondary.actionDetails) === null || _action_secondary_actionDetails === void 0 ? void 0 : _action_secondary_actionDetails.action
      })));
    });
    return /* @__PURE__ */React144.createElement(React144.Fragment, null, messageCardElements);
  }
  return null;
};
var horizontal_messaging_card_wrapper_default = HorizontalMessagingCardWrapper;
// src/components/property-offers/property-offers.tsx
var __PropertyOffersFragment = gql105(_templateObject107(), ExperimentalOfferCategoriesSection.fragment, ListingsHeader.fragment, AlternateDates.fragment, ListingsErrorMessage.fragment, Listings.fragment, StickyBarDisclaimer.fragment, __ShoppingContextFragment, MessageResult4.fragment, LodgingOfferFilters2.fragment, FilterPills.fragment, PropertyOffersIncludedPerks.fragment);
var Form = function (param) {
  var children = param.children;
  return /* @__PURE__ */React145.createElement(React145.Fragment, null, children);
};
var HeaderRight = function (param) {
  var children = param.children;
  return /* @__PURE__ */React145.createElement(React145.Fragment, null, children);
};
var PropertyOffers = function (param) {
  var children = param.children,
    data = param.data,
    defaultErrorMessage = param.defaultErrorMessage,
    LinkWrapper = param.LinkWrapper,
    handleMultiItemCallback = param.handleMultiItemCallback,
    updateSearchAndFilters = param.updateSearchAndFilters,
    _param_loading = param.loading,
    loading = _param_loading === void 0 ? false : _param_loading,
    refetch = param.refetch,
    variables = param.variables;
  var _data_shoppingContext_multiItem, _data_shoppingContext, _data_shoppingContext_multiItem1, _data_shoppingContext1, _variables_searchCriteria, _variables_searchCriteria_secondary, _data_categorizedListings, _data_offerFilters;
  var multiItemContext = {
    packageType: data === null || data === void 0 ? void 0 : (_data_shoppingContext = data.shoppingContext) === null || _data_shoppingContext === void 0 ? void 0 : (_data_shoppingContext_multiItem = _data_shoppingContext.multiItem) === null || _data_shoppingContext_multiItem === void 0 ? void 0 : _data_shoppingContext_multiItem.packageType,
    handleMultiItemCallback: handleMultiItemCallback,
    sessionId: data === null || data === void 0 ? void 0 : (_data_shoppingContext1 = data.shoppingContext) === null || _data_shoppingContext1 === void 0 ? void 0 : (_data_shoppingContext_multiItem1 = _data_shoppingContext1.multiItem) === null || _data_shoppingContext_multiItem1 === void 0 ? void 0 : _data_shoppingContext_multiItem1.id
  };
  var inputDateRange = variables === null || variables === void 0 ? void 0 : (_variables_searchCriteria = variables.searchCriteria) === null || _variables_searchCriteria === void 0 ? void 0 : _variables_searchCriteria.primary.dateRange;
  var _usePropertyOffersContext = usePropertyOffersContext(),
    setIsLoading = _usePropertyOffersContext.setIsLoading,
    setAvailableRooms = _usePropertyOffersContext.setAvailableRooms;
  var _usePropertyActivitiesCrossSellContext2 = usePropertyActivitiesCrossSellContext2(),
    dateRange = _usePropertyActivitiesCrossSellContext2.dateRange,
    setDateRange = _usePropertyActivitiesCrossSellContext2.setDateRange,
    triggerRefetch = _usePropertyActivitiesCrossSellContext2.triggerRefetch,
    activityNaturalKey = _usePropertyActivitiesCrossSellContext2.activityNaturalKey,
    setActivityNaturalKey = _usePropertyActivitiesCrossSellContext2.setActivityNaturalKey,
    setHasAvailableListings = _usePropertyActivitiesCrossSellContext2.setHasAvailableListings,
    propertyOffersMountRef = _usePropertyActivitiesCrossSellContext2.propertyOffersMountRef;
  var searchCriteria = (variables === null || variables === void 0 ? void 0 : variables.searchCriteria) && {
    primary: variables.searchCriteria.primary,
    secondary: _object_spread_props(_object_spread({}, variables.searchCriteria.secondary), {
      booleans: _to_consumable_array(((_variables_searchCriteria_secondary = variables.searchCriteria.secondary) === null || _variables_searchCriteria_secondary === void 0 ? void 0 : _variables_searchCriteria_secondary.booleans) || []).concat([{
        id: "activitySelected",
        value: true
      }])
    })
  };
  React145.useEffect(function () {
    if (propertyOffersMountRef) {
      if (!(propertyOffersMountRef === null || propertyOffersMountRef === void 0 ? void 0 : propertyOffersMountRef.current) && setDateRange) {
        setDateRange(JSON.stringify(inputDateRange));
      }
      propertyOffersMountRef.current = true;
    }
  }, []);
  React145.useEffect(function () {
    if (JSON.stringify(inputDateRange) !== dateRange && setActivityNaturalKey && setDateRange) {
      setActivityNaturalKey({
        offerToken: "",
        productToken: ""
      });
      setDateRange(JSON.stringify(inputDateRange));
    }
  }, [inputDateRange]);
  React145.useEffect(function () {
    if (setIsLoading) {
      setIsLoading(loading);
    }
  }, [loading]);
  React145.useEffect(function () {
    if (setHasAvailableListings) {
      var _data_categorizedListings;
      setHasAvailableListings(!!((_data_categorizedListings = data.categorizedListings) === null || _data_categorizedListings === void 0 ? void 0 : _data_categorizedListings.length));
    }
    if (setAvailableRooms) {
      var _data_categorizedListings1, _data_listings;
      setAvailableRooms(!!((_data_categorizedListings1 = data.categorizedListings) === null || _data_categorizedListings1 === void 0 ? void 0 : _data_categorizedListings1.length) || !!((_data_listings = data.listings) === null || _data_listings === void 0 ? void 0 : _data_listings.length));
    }
  }, [data]);
  React145.useEffect(function () {
    if (triggerRefetch && refetch) {
      refetch(_object_spread({}, variables, (activityNaturalKey === null || activityNaturalKey === void 0 ? void 0 : activityNaturalKey.offerToken) && {
        searchCriteria: searchCriteria
      }));
    }
  }, [triggerRefetch]);
  var context = useBexApi7().context;
  var device = context.device;
  var isDesktop = device.type === "DESKTOP" /* DESKTOP */;
  var isMobileTablet = device.type === "MOBILE_TABLET" /* MOBILE_TABLET */;
  var listingsRef = useRef3(null);
  var _useState4 = _sliced_to_array(useState4(0), 2),
    styleHeight = _useState4[0],
    setStyleHeight = _useState4[1];
  var _useState41 = _sliced_to_array(useState4(1), 2),
    duration = _useState41[0],
    setDuration = _useState41[1];
  useEffect7(function () {
    var divElement = listingsRef.current;
    if (!divElement) {
      return;
    }
    var adjustHeight = function () {
      var _data_categorizedListings;
      var listingLength = ((_data_categorizedListings = data.categorizedListings) === null || _data_categorizedListings === void 0 ? void 0 : _data_categorizedListings.length) || 0;
      if (listingLength <= 3 && isDesktop || listingLength <= 2 && isMobileTablet) {
        setDuration(1);
      } else {
        setDuration(2);
      }
      setStyleHeight(divElement.offsetHeight);
    };
    adjustHeight();
    var resizeObserver = new ResizeObserver(function () {
      return adjustHeight();
    });
    resizeObserver.observe(divElement);
    return function () {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [data]);
  var _data_categorizedListings_filter;
  var dataWithRecsOnly = (_data_categorizedListings_filter = (_data_categorizedListings = data.categorizedListings) === null || _data_categorizedListings === void 0 ? void 0 : _data_categorizedListings.filter(function (listing) {
    var _listing_featureHeader;
    return listing.__typename !== "LodgingCategorizedUnit" || !!((_listing_featureHeader = listing.featureHeader) === null || _listing_featureHeader === void 0 ? void 0 : _listing_featureHeader.text);
  })) !== null && _data_categorizedListings_filter !== void 0 ? _data_categorizedListings_filter : [];
  var isSmashRoomCatExperiment = !!data.experimentalOfferCategoriesSection;
  var listingsData = _object_spread_props(_object_spread({}, data), {
    categorizedListings: isSmashRoomCatExperiment ? dataWithRecsOnly : data.categorizedListings
  });
  var track = useEgClickstream13();
  useEffect7(function () {
    if ((data === null || data === void 0 ? void 0 : data.clickstreamEvents) && data.clickstreamEvents.length > 0) {
      var _analyticPayloads_events_PRICE_REQUEST_CALIFORNIA_SUBMITTED_v1, _analyticPayloads_events_PRICE_REQUEST_CALIFORNIA_SUBMITTED;
      var californiaAnalyticsPayload = data.clickstreamEvents.find(function (element) {
        return Object.hasOwn(JSON.parse(element.toString()).events, PRICE_REQUEST_CALIFORNIA_SUBMITTED);
      });
      var analyticPayloads = JSON.parse(californiaAnalyticsPayload.toString());
      var priceRequestCaliforniaSubmittedEvent = (_analyticPayloads_events_PRICE_REQUEST_CALIFORNIA_SUBMITTED = analyticPayloads.events[PRICE_REQUEST_CALIFORNIA_SUBMITTED]) === null || _analyticPayloads_events_PRICE_REQUEST_CALIFORNIA_SUBMITTED === void 0 ? void 0 : (_analyticPayloads_events_PRICE_REQUEST_CALIFORNIA_SUBMITTED_v1 = _analyticPayloads_events_PRICE_REQUEST_CALIFORNIA_SUBMITTED.v1) === null || _analyticPayloads_events_PRICE_REQUEST_CALIFORNIA_SUBMITTED_v1 === void 0 ? void 0 : _analyticPayloads_events_PRICE_REQUEST_CALIFORNIA_SUBMITTED_v1.event_data;
      if (priceRequestCaliforniaSubmittedEvent != null) {
        track(priceRequestCaliforniaSubmittedEvent);
      }
    }
  }, [data === null || data === void 0 ? void 0 : data.clickstreamEvents]);
  return /* @__PURE__ */React145.createElement(PropertyOffersFiltersProvider2, {
    value: {
      filters: ((_data_offerFilters = data.offerFilters) === null || _data_offerFilters === void 0 ? void 0 : _data_offerFilters.filterPills) || null,
      list: listingsData.categorizedListings
    }
  }, /* @__PURE__ */React145.createElement(LinkComponentProvider, {
    Link: LinkWrapper
  }, /* @__PURE__ */React145.createElement(MultiItemProvider, {
    defaultError: defaultErrorMessage,
    multiItemContext: multiItemContext
  }, /* @__PURE__ */React145.createElement(OffersLevelProvider, null, /* @__PURE__ */React145.createElement(PropertyOffersProvider, {
    value: data.categorizedListings || []
  }, /* @__PURE__ */React145.createElement(EGDSSpacing79, {
    margin: {
      small: {
        inline: "three"
      },
      medium: {
        inline: "unset"
      }
    }
  }, /* @__PURE__ */React145.createElement("div", null, /* @__PURE__ */React145.createElement(EGDSSpacing79, {
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React145.createElement(EGDSLayoutFlex28, {
    justifyContent: "space-between"
  }, /* @__PURE__ */React145.createElement(ListingsHeader, {
    data: data
  }), findReactChildByType(children, HeaderRight))), /* @__PURE__ */React145.createElement(EGDSSpacing79, {
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React145.createElement(ListingsErrorMessage, {
    data: data
  })), /* @__PURE__ */React145.createElement(EGDSSpacing79, {
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React145.createElement(AlternateDates, {
    data: data
  })), findReactChildByType(children, Form), /* @__PURE__ */React145.createElement(horizontal_messaging_card_wrapper_default, {
    offerLevelMessages: data.offerLevelMessages
  }), /* @__PURE__ */React145.createElement(PropertyOffersIncludedPerks, {
    data: data
  }), (data === null || data === void 0 ? void 0 : data.offerFilters) && /* @__PURE__ */React145.createElement(LodgingOfferFilters2, {
    data: data.offerFilters
  }), /* @__PURE__ */React145.createElement(FilterPills, {
    data: data
  }))), /* @__PURE__ */React145.createElement(EGDSSpacing79, {
    margin: {
      block: "three"
    }
  }, /* @__PURE__ */React145.createElement(Experiment4, {
    name: "Property_Offers_Loader_POC"
  }, /* @__PURE__ */React145.createElement(ExperimentControl4, null, /* @__PURE__ */React145.createElement(Listings, {
    data: listingsData
  })), /* @__PURE__ */React145.createElement(ExperimentVariant4, {
    bucket: 1
  }, /* @__PURE__ */React145.createElement("div", {
    role: "region",
    "aria-live": "polite",
    style: {
      height: "".concat(styleHeight, "px"),
      transition: "".concat(duration, "s ease-in-out"),
      overflow: "hidden"
    }
  }, /* @__PURE__ */React145.createElement(Listings, {
    data: listingsData,
    listingsRef: listingsRef
  }))))), /* @__PURE__ */React145.createElement(ExperimentalOfferCategoriesSection, {
    data: data
  }), /* @__PURE__ */React145.createElement(StickyBarDisclaimer, {
    data: data
  }))))));
};
PropertyOffers.displayName = "PropertyOffers";
PropertyOffers.fragment = __PropertyOffersFragment;
// src/components/property-offers/listings-placeholder.tsx
var OfferCarouselPlaceholder = function (param) {
  var cards = param.cards;
  var carouselProps = {
    carouselName: "OffersCarouselPlaceholder",
    buttonText: {
      nextButton: "",
      prevButton: ""
    },
    itemsVisible: {
      sm: 1,
      md: 2,
      lg: 3
    },
    pageBy: 1,
    peek: true,
    itemsMaxHeight: true,
    pagingInset: true,
    hideNav: true,
    shouldSnapOnScroll: false,
    extraPeekWidth: true
  };
  return /* @__PURE__ */React146.createElement(Carousel2, _object_spread({}, carouselProps), _to_consumable_array(Array(cards)).map(function (_, index) {
    return /* @__PURE__ */React146.createElement("div", {
      key: "similar-properties-placeholder-".concat(index)
    }, /* @__PURE__ */React146.createElement(EGDSCard24, {
      padded: true
    }, /* @__PURE__ */React146.createElement("div", null, /* @__PURE__ */React146.createElement(EGDSSpacing80, {
      padding: {
        blockend: "sixteen"
      },
      margin: {
        blockend: "six"
      }
    }, /* @__PURE__ */React146.createElement("div", null, /* @__PURE__ */React146.createElement(EGDSFigure5, {
      ratio: EGDSFigureAspectRatioType7.R16_9,
      className: "uitk-card-roundcorner-all"
    }, /* @__PURE__ */React146.createElement(EGDSBlockSkeleton, null)), /* @__PURE__ */React146.createElement(EGDSCardContentSection15, {
      padded: false
    }, /* @__PURE__ */React146.createElement(EGDSSpacing80, {
      margin: {
        block: "four"
      }
    }, /* @__PURE__ */React146.createElement(EGDSLineSkeleton2, {
      animation: true
    })), /* @__PURE__ */React146.createElement(EGDSSpacing80, {
      margin: {
        block: "four"
      }
    }, /* @__PURE__ */React146.createElement(EGDSLineSkeleton2, {
      animation: true
    })), /* @__PURE__ */React146.createElement(EGDSSpacing80, {
      margin: {
        block: "four"
      }
    }, /* @__PURE__ */React146.createElement(EGDSLineSkeleton2, {
      animation: true,
      type: "secondary"
    })), /* @__PURE__ */React146.createElement(EGDSSpacing80, {
      margin: {
        block: "four"
      }
    }, /* @__PURE__ */React146.createElement(EGDSLineSkeleton2, {
      animation: true,
      type: "secondary"
    }))))))));
  }));
};
var CheckInCheckOutInputPlaceholder = function () {
  return /* @__PURE__ */React146.createElement(Viewport17, null, /* @__PURE__ */React146.createElement(ViewSmall16, null, /* @__PURE__ */React146.createElement(EGDSSpacing80, {
    margin: {
      block: "four"
    }
  }, /* @__PURE__ */React146.createElement(EGDSCard24, {
    padded: true
  }, /* @__PURE__ */React146.createElement(EGDSCardContentSection15, {
    padded: false
  }, /* @__PURE__ */React146.createElement(EGDSLayoutFlex29, {
    justifyContent: "space-between"
  }, /* @__PURE__ */React146.createElement(EGDSSpacing80, {
    margin: {
      block: "four"
    }
  }, /* @__PURE__ */React146.createElement(EGDSLineSkeleton2, {
    animation: true
  })), /* @__PURE__ */React146.createElement(EGDSSpacing80, {
    margin: {
      block: "four"
    }
  }, /* @__PURE__ */React146.createElement(EGDSLineSkeleton2, {
    animation: true
  }))))))), /* @__PURE__ */React146.createElement(ViewLarge4, null, /* @__PURE__ */React146.createElement(EGDSLayoutGrid21, {
    columns: 6,
    space: "two"
  }, [1, 2, 3].map(function (value, index) {
    return /* @__PURE__ */React146.createElement(EGDSLayoutGridItem18, {
      colSpan: value === 3 ? 3 : 1,
      key: "date-placeholder-".concat(index)
    }, /* @__PURE__ */React146.createElement(EGDSSpacing80, {
      margin: {
        block: "four"
      }
    }, /* @__PURE__ */React146.createElement(EGDSCard24, {
      padded: true
    }, /* @__PURE__ */React146.createElement(EGDSCardContentSection15, {
      padded: false
    }, /* @__PURE__ */React146.createElement(EGDSSpacing80, {
      margin: {
        block: "four"
      }
    }, /* @__PURE__ */React146.createElement(EGDSLineSkeleton2, {
      animation: true
    }))))));
  }), /* @__PURE__ */React146.createElement(EGDSLayoutGridItem18, null, /* @__PURE__ */React146.createElement(EGDSSpacing80, {
    margin: {
      block: "twelve"
    }
  }, /* @__PURE__ */React146.createElement(EGDSLineSkeleton2, {
    animation: true
  }))))));
};
var OffersHeadingPlaceholder = function () {
  return /* @__PURE__ */React146.createElement(EGDSSpacing80, {
    margin: {
      block: "four"
    }
  }, /* @__PURE__ */React146.createElement(EGDSLayoutFlex29, {
    justifyContent: "space-between"
  }, /* @__PURE__ */React146.createElement(EGDSLineSkeleton2, {
    animation: true
  }), /* @__PURE__ */React146.createElement(Viewport17, null, /* @__PURE__ */React146.createElement(ViewSmall16, null, /* @__PURE__ */React146.createElement(EGDSLineSkeleton2, {
    animation: true,
    type: "secondary"
  })), /* @__PURE__ */React146.createElement(ViewLarge4, null))));
};
var VerticalListingPlaceholderCard = function () {
  return /* @__PURE__ */React146.createElement(EGDSCard24, {
    padded: true
  }, /* @__PURE__ */React146.createElement(EGDSFigure5, {
    ratio: EGDSFigureAspectRatioType7.R16_9,
    className: "uitk-card-roundcorner-all"
  }, /* @__PURE__ */React146.createElement(EGDSBlockSkeleton, null)), /* @__PURE__ */React146.createElement(EGDSCardContentSection15, {
    padded: false
  }, /* @__PURE__ */React146.createElement(EGDSSpacing80, {
    margin: {
      block: "four"
    }
  }, /* @__PURE__ */React146.createElement(EGDSLineSkeleton2, {
    animation: true
  })), /* @__PURE__ */React146.createElement(EGDSSpacing80, {
    margin: {
      block: "four"
    }
  }, /* @__PURE__ */React146.createElement(EGDSLineSkeleton2, {
    animation: true,
    type: "secondary"
  }))));
};
var carouselPlaceholders = function (cards) {
  return /* @__PURE__ */React146.createElement(OfferCarouselPlaceholder, {
    cards: cards
  });
};
var carouselPlaceholdersSmall = carouselPlaceholders(2);
var carouselPlaceholdersMedium = carouselPlaceholders(3);
var carouselPlaceholdersLarge = carouselPlaceholders(4);
var verticalPlaceholders = /* @__PURE__ */React146.createElement(EGDSSpacing80, {
  margin: {
    small: {
      inline: "three"
    },
    medium: {
      inline: "unset"
    }
  }
}, /* @__PURE__ */React146.createElement(EGDSLayoutGrid21, {
  columns: {
    auto_fill: "seventy_six"
  },
  space: "three",
  justifyContent: "start"
}, [0, 1, 2].map(function (_, index) {
  return /* @__PURE__ */React146.createElement(VerticalListingPlaceholderCard, {
    key: "listing-placeholder-".concat(index)
  });
})));
var LoadingPlaceholderCards = function () {
  var _useBexApi8_context_device, _useBexApi8_context;
  var isMobile = ((_useBexApi8_context = useBexApi8().context) === null || _useBexApi8_context === void 0 ? void 0 : (_useBexApi8_context_device = _useBexApi8_context.device) === null || _useBexApi8_context_device === void 0 ? void 0 : _useBexApi8_context_device.type) === "MOBILE_PHONE" /* MOBILE_PHONE */;
  var _useExperiment9_exposure = useExperiment9("Micro_Room_Card_Side_By_Side_Carousel_mWeb").exposure,
    microRoomCardCarouselBucket = _useExperiment9_exposure.bucket;
  var _useExperiment9_exposure1 = useExperiment9("SmaSh_Desktop_Room_Carousel").exposure,
    desktopCarouselBucket = _useExperiment9_exposure1.bucket;
  return /* @__PURE__ */React146.createElement(EGDSSpacing80, {
    margin: isMobile ? {
      inlinestart: "three"
    } : {
      inline: "three"
    }
  }, /* @__PURE__ */React146.createElement("div", null, /* @__PURE__ */React146.createElement(Viewport17, null, /* @__PURE__ */React146.createElement(ViewSmall16, null, isMobile && microRoomCardCarouselBucket === 1 ? carouselPlaceholdersSmall : verticalPlaceholders), /* @__PURE__ */React146.createElement(ViewMedium14, null, !isMobile && desktopCarouselBucket === 1 ? carouselPlaceholdersMedium : verticalPlaceholders), /* @__PURE__ */React146.createElement(ViewLarge4, null, !isMobile && desktopCarouselBucket === 1 ? carouselPlaceholdersLarge : verticalPlaceholders))));
};
var ListingsInitialPlaceholder = function () {
  return /* @__PURE__ */React146.createElement(React146.Fragment, null, /* @__PURE__ */React146.createElement(EGDSSpacing80, {
    margin: {
      small: {
        inline: "three"
      },
      medium: {
        inline: "unset"
      }
    }
  }, /* @__PURE__ */React146.createElement("div", null, /* @__PURE__ */React146.createElement(OffersHeadingPlaceholder, null), /* @__PURE__ */React146.createElement(CheckInCheckOutInputPlaceholder, null))), /* @__PURE__ */React146.createElement(EGDSSpacing80, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React146.createElement(LoadingPlaceholderCards, null)));
};
var ListingsPlaceholder = function (param) {
  var data = param.data,
    children = param.children;
  if (!data) {
    return /* @__PURE__ */React146.createElement("div", null, /* @__PURE__ */React146.createElement(ListingsInitialPlaceholder, null));
  }
  return /* @__PURE__ */React146.createElement("div", null, /* @__PURE__ */React146.createElement(EGDSSpacing80, {
    margin: {
      small: {
        inline: "three"
      },
      medium: {
        inline: "unset"
      }
    }
  }, /* @__PURE__ */React146.createElement("div", null, /* @__PURE__ */React146.createElement(EGDSSpacing80, {
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React146.createElement(EGDSLayoutFlex29, {
    justifyContent: "space-between"
  }, data && /* @__PURE__ */React146.createElement(ListingsHeader, {
    data: data
  }), findReactChildByType2(children, HeaderRight))), findReactChildByType2(children, Form), (data === null || data === void 0 ? void 0 : data.offerFilters) && /* @__PURE__ */React146.createElement(LodgingOfferFilters3, {
    data: data.offerFilters
  }))), /* @__PURE__ */React146.createElement(EGDSSpacing80, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React146.createElement(LoadingPlaceholderCards, null)));
};
LoadingPlaceholderCards.displayName = "sharedui-LoadingPlaceholderCards";
VerticalListingPlaceholderCard.displayName = "sharedui-VerticalListingPlaceholderCard";
OffersHeadingPlaceholder.displayName = "sharedui-OffersHeadingPlaceholder";
CheckInCheckOutInputPlaceholder.displayName = "sharedui-CheckInCheckOutInputPlaceholder";
ListingsInitialPlaceholder.displayName = "sharedui-ListingsInitialPlaceholder";
OfferCarouselPlaceholder.displayName = "sharedui-OfferCarouselPlaceholder";
// src/components/property-search-link/placeholder.tsx
import React147 from "react";
import { EGDSLineSkeleton as EGDSLineSkeleton3 } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing81 } from "@egds/react-core/spacing";
var PropertySearchLinkPlaceholder = function () {
  return /* @__PURE__ */React147.createElement(EGDSSpacing81, {
    margin: {
      blockend: "two"
    },
    padding: {
      inline: "six"
    }
  }, /* @__PURE__ */React147.createElement(EGDSLineSkeleton3, {
    animation: true,
    type: "secondary"
  }));
};
// src/components/property-search-link/property-search-link.tsx
import React149 from "react";
import { gql as gql107 } from "@apollo/client";
// src/components/property-search-link/__private/__fragments/lodging-link-message.tsx
import React148, { useContext as useContext5 } from "react";
import { useHistory } from "react-router-dom";
import { gql as gql106 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize7, EGDSFloatingButton } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon28, EGDSIconSize as EGDSIconSize20 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink15 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing82 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker35 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment10 } from "@shared-ui/experiment-context";
import { ProductGalleryContext as ProductGalleryContext3 } from "@shared-ui/retail-product-gallery";
import { ViewMedium as ViewMedium15, Viewport as Viewport18, ViewSmall as ViewSmall17 } from "@shared-ui/viewport-context";
var __LodgingLinkMessageFragment = gql106(_templateObject108());
var IconWrapper = function (param) {
  var iconId = param.iconId;
  return /* @__PURE__ */React148.createElement(EGDSSpacing82, {
    margin: {
      inlineend: "one"
    }
  }, /* @__PURE__ */React148.createElement(EGDSIcon28, {
    "data-stid": "lodging-link-message-icon",
    name: iconId,
    size: EGDSIconSize20.SMALL
  }));
};
var LodgingLinkMessage = function (param) {
  var data = param.data,
    onClick = param.onClick,
    _param_isNavigationFromSRP = param.isNavigationFromSRP,
    isNavigationFromSRP = _param_isNavigationFromSRP === void 0 ? false : _param_isNavigationFromSRP,
    useAbsolutePath = param.useAbsolutePath,
    isDateless = param.isDateless,
    _param_showLinkLabel = param.showLinkLabel,
    showLinkLabel = _param_showLinkLabel === void 0 ? true : _param_showLinkLabel,
    _param_hasInputUpdated = param.hasInputUpdated,
    hasInputUpdated = _param_hasInputUpdated === void 0 ? false : _param_hasInputUpdated;
  var link = data.link,
    value = data.value,
    icon = data.icon;
  var useControlBehaviour = useContext5(ProductGalleryContext3).useControlBehaviour;
  var track = useClickTracker35();
  var history = useHistory();
  var Link = useLinkComponent().Link;
  var href = useAbsolutePath ? link.uri.value : link.uri.relativePath;
  var _useExperiment10 = useExperiment10("Adaptex_campaign_PDP_mosaic_for_large_screens"),
    adaptexCampaignLargeScreensExposure = _useExperiment10.exposure;
  var _useExperiment101 = useExperiment10("Adaptex_campaign_PDP_mosaic_for_small_screens"),
    adaptexCampaignSmallScreenExposure = _useExperiment101.exposure;
  var _useExperiment102 = useExperiment10("mWeb_larger_image_for_top_of_PDP_gallery"),
    mWebLargerImageExposure = _useExperiment102.exposure;
  var handleClick = function () {
    onClick === null || onClick === void 0 ? void 0 : onClick();
    if (!useAbsolutePath) {
      if (history.length > 1 && isNavigationFromSRP) {
        if (!hasInputUpdated) {
          history.goBack();
        } else {
          history.replace(href);
        }
      } else {
        history.push(href);
      }
    }
    if (link === null || link === void 0 ? void 0 : link.clientSideAnalytics) {
      track("HOT.HIS.".concat(link.clientSideAnalytics.referrerId), link.clientSideAnalytics.linkName, false);
    }
  };
  if (!value) {
    return null;
  }
  var hideLabel = adaptexCampaignLargeScreensExposure.bucket !== 0 && !useControlBehaviour || adaptexCampaignSmallScreenExposure.bucket !== 0 || mWebLargerImageExposure.bucket !== 0;
  var searchButtonWithValue = /* @__PURE__ */React148.createElement(EGDSLink15, {
    onClick: handleClick
  }, /* @__PURE__ */React148.createElement("button", {
    type: "button",
    role: "link"
  }, (icon === null || icon === void 0 ? void 0 : icon.id) && /* @__PURE__ */React148.createElement(IconWrapper, {
    iconId: icon.id
  }), value));
  var searchButtonWithoutValue = /* @__PURE__ */React148.createElement(EGDSLink15, {
    onClick: handleClick
  }, /* @__PURE__ */React148.createElement(EGDSFloatingButton, {
    "aria-label": value,
    size: EGDSButtonSize7.SMALL
  }, (icon === null || icon === void 0 ? void 0 : icon.id) && /* @__PURE__ */React148.createElement(EGDSIcon28, {
    name: icon.id,
    id: icon.id,
    size: EGDSIconSize20.SMALL
  })));
  var searchButton = isDateless && showLinkLabel || !hideLabel ? searchButtonWithValue : searchButtonWithoutValue;
  var absoluteLink = /* @__PURE__ */React148.createElement(EGDSLink15, {
    onClick: handleClick
  }, /* @__PURE__ */React148.createElement(Link, {
    href: href
  }, (icon === null || icon === void 0 ? void 0 : icon.id) && /* @__PURE__ */React148.createElement(IconWrapper, {
    iconId: icon.id
  }), value));
  return /* @__PURE__ */React148.createElement(Viewport18, null, /* @__PURE__ */React148.createElement(ViewSmall17, null, useAbsolutePath ? absoluteLink : searchButton), /* @__PURE__ */React148.createElement(ViewMedium15, null, useAbsolutePath ? absoluteLink : searchButton));
};
LodgingLinkMessage.displayName = "LodgingLinkMessage";
LodgingLinkMessage.fragment = __LodgingLinkMessageFragment;
// src/components/property-search-link/property-search-link.tsx
var __PropertySearchLinkFragment = gql107(_templateObject109(), LodgingLinkMessage.fragment);
var PropertySearchLink = function (param) {
  var data = param.data,
    onClick = param.onClick,
    isNavigationFromSRP = param.isNavigationFromSRP,
    _param_useExternalLink = param.useExternalLink,
    useExternalLink = _param_useExternalLink === void 0 ? false : _param_useExternalLink,
    inputs = param.inputs,
    _param_showLinkLabel = param.showLinkLabel,
    showLinkLabel = _param_showLinkLabel === void 0 ? false : _param_showLinkLabel,
    _param_hasInputUpdated = param.hasInputUpdated,
    hasInputUpdated = _param_hasInputUpdated === void 0 ? false : _param_hasInputUpdated;
  var _inputs_searchCriteria;
  var propertySearchLink = data.propertySearchLink,
    partnerPropertySearchLink = data.partnerPropertySearchLink;
  var _useMultiItemContext = useMultiItemContext(),
    sessionId = _useMultiItemContext.sessionId,
    packageType = _useMultiItemContext.packageType;
  var forceRefresh = sessionId && packageType;
  var isDateless = (inputs === null || inputs === void 0 ? void 0 : (_inputs_searchCriteria = inputs.searchCriteria) === null || _inputs_searchCriteria === void 0 ? void 0 : _inputs_searchCriteria.primary.dateRange) === null;
  var onBackLinkClick = React149.useCallback(function () {
    if (forceRefresh) {
      window.location.href = (propertySearchLink === null || propertySearchLink === void 0 ? void 0 : propertySearchLink.link.uri.relativePath) || (partnerPropertySearchLink === null || partnerPropertySearchLink === void 0 ? void 0 : partnerPropertySearchLink.link.uri.relativePath) || "";
    }
  }, [(propertySearchLink === null || propertySearchLink === void 0 ? void 0 : propertySearchLink.link.uri.relativePath) || (partnerPropertySearchLink === null || partnerPropertySearchLink === void 0 ? void 0 : partnerPropertySearchLink.link.uri.relativePath), forceRefresh]);
  var handleClick = function () {
    onBackLinkClick();
    onClick === null || onClick === void 0 ? void 0 : onClick();
  };
  if (propertySearchLink) {
    return /* @__PURE__ */React149.createElement(LodgingLinkMessage, {
      data: propertySearchLink,
      onClick: handleClick,
      isNavigationFromSRP: isNavigationFromSRP,
      useAbsolutePath: useExternalLink,
      isDateless: isDateless,
      showLinkLabel: showLinkLabel,
      hasInputUpdated: hasInputUpdated
    });
  }
  if (partnerPropertySearchLink) {
    return /* @__PURE__ */React149.createElement(LodgingLinkMessage, {
      onClick: handleClick,
      data: partnerPropertySearchLink,
      isNavigationFromSRP: isNavigationFromSRP,
      useAbsolutePath: true
    });
  }
  return null;
};
PropertySearchLink.displayName = "PropertySearchLink";
PropertySearchLink.fragment = __PropertySearchLinkFragment;
// src/components/property-single-offer/property-single-offer.tsx
import React165, { useContext as useContext6 } from "react";
import { gql as gql119 } from "@apollo/client";
import { AdaptExEventsProvider as AdaptExEventsProvider2 } from "@shared-ui/lodging-fragments";
import { PropertyDetailsAdaptExContext as PropertyDetailsAdaptExContext4 } from "@shared-ui/lodging-property-details";
// src/components/property-single-offer/__private/__fragments/property-single-rate-plan.tsx
import React164 from "react";
import { gql as gql118 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex33, EGDSLayoutFlexItem as EGDSLayoutFlexItem25 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing86 } from "@egds/react-core/spacing";
import { LodgingEnrichedMessage as LodgingEnrichedMessage16 } from "@shared-ui/lodging-fragments";
import { ViewLarge as ViewLarge5, Viewport as Viewport20, ViewSmall as ViewSmall19 } from "@shared-ui/viewport-context";
// src/components/property-single-offer/__private/__fragments/alternate-availability-msg.tsx
import React150 from "react";
import { gql as gql108 } from "@apollo/client";
import { EGDSCard as EGDSCard25, EGDSCardContentSection as EGDSCardContentSection16 } from "@egds/react-core/cards";
import { EGDSLink as EGDSLink16 } from "@egds/react-core/link";
import { EGDSText as EGDSText40 } from "@egds/react-core/text";
var fragment67 = gql108(_templateObject110());
var AlternateAvailabilityMsg = function (param) {
  var data = param.data;
  var _actionLink_link;
  if (!data || !data.text || !data.actionLink) {
    return null;
  }
  var text = data.text,
    actionLink = data.actionLink;
  return /* @__PURE__ */React150.createElement(EGDSCard25, {
    key: "alternate-availability",
    "data-stid": "alternate-availability"
  }, /* @__PURE__ */React150.createElement(EGDSCardContentSection16, null, /* @__PURE__ */React150.createElement(EGDSText40, {
    size: 300
  }, text.value), /* @__PURE__ */React150.createElement(EGDSLink16, null, /* @__PURE__ */React150.createElement("a", {
    href: actionLink === null || actionLink === void 0 ? void 0 : (_actionLink_link = actionLink.link) === null || _actionLink_link === void 0 ? void 0 : _actionLink_link.uri.relativePath
  }, actionLink === null || actionLink === void 0 ? void 0 : actionLink.value))));
};
AlternateAvailabilityMsg.displayName = "AlternateAvailabilityMsg";
AlternateAvailabilityMsg.fragment = fragment67;
// src/components/property-single-offer/__private/__fragments/price-breakdown-expanded.tsx
import React151 from "react";
var PriceBreakdownExpanded = function (param) {
  var data = param.data;
  var _ref = data.priceBreakDownSummary || {},
    sections = _ref.sections,
    priceSummaryHeading = _ref.priceSummaryHeading;
  var _ref1 = priceSummaryHeading || {},
    accessibilityLabel = _ref1.accessibilityLabel,
    value = _ref1.value;
  var a11yLabel = accessibilityLabel || value;
  return /* @__PURE__ */React151.createElement(React151.Fragment, null, a11yLabel && /* @__PURE__ */React151.createElement("h3", {
    className: "is-visually-hidden"
  }, a11yLabel), sections === null || sections === void 0 ? void 0 : sections.map(function (section, index) {
    return /* @__PURE__ */React151.createElement(PriceSummarySection, {
      data: section,
      key: "price-summary-section-".concat(index),
      lastSection: index === sections.length - 1
    });
  }));
};
PriceBreakdownExpanded.fragment = fragment4;
PriceBreakdownExpanded.displayName = "PriceBreakdownDialog";
// src/components/property-single-offer/__private/__fragments/price-presentation-expanded.tsx
import React152 from "react";
import { EGDSSpacing as EGDSSpacing83 } from "@egds/react-core/spacing";
import { PricePresentation as PricePresentation2 } from "@shared-ui/pricing-price-details";
var PricePresentationExpanded = function (param) {
  var data = param.data;
  var pricePresentation = data.pricePresentation,
    pricePresentationDialog = data.pricePresentationDialog;
  if (!pricePresentation || !pricePresentationDialog) {
    return null;
  }
  var trigger = pricePresentationDialog.trigger;
  return /* @__PURE__ */React152.createElement(EGDSSpacing83, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React152.createElement("div", null, /* @__PURE__ */React152.createElement("h3", {
    className: "is-visually-hidden"
  }, trigger.value), /* @__PURE__ */React152.createElement(PricePresentation2, {
    data: pricePresentation
  })));
};
PricePresentationExpanded.fragment = PricePresentationDialogComponentFragment;
PricePresentationExpanded.displayName = "PricePresentationExpanded";
// src/components/property-single-offer/__private/__fragments/property-single-offer-details.tsx
import React156 from "react";
import { gql as gql112 } from "@apollo/client";
import { EGDSCard as EGDSCard26, EGDSCardContentSection as EGDSCardContentSection17 } from "@egds/react-core/cards";
import { EGDSSpacing as EGDSSpacing84 } from "@egds/react-core/spacing";
// src/components/property-single-offer/__private/__fragments/availability-cta.tsx
import React153 from "react";
import { gql as gql109 } from "@apollo/client";
var fragment68 = gql109(_templateObject111());
var AvailabilityCta2 = function (param) {
  var closeDialog = param.closeDialog,
    listingIndex = param.listingIndex,
    data = param.data;
  var availabilityCallToAction = data.availabilityCallToAction;
  if (!availabilityCallToAction) {
    return null;
  }
  return /* @__PURE__ */React153.createElement(AvailabilityCallToAction, {
    closeDialog: closeDialog,
    listingIndex: listingIndex,
    data: availabilityCallToAction
  });
};
AvailabilityCta2.displayName = "AvailabilityCta";
AvailabilityCta2.fragment = fragment68;
// src/components/property-single-offer/__private/__fragments/price-messages.tsx
import React154 from "react";
import { gql as gql110 } from "@apollo/client";
import { EGDSText as EGDSText41 } from "@egds/react-core/text";
import { LodgingEnrichedMessage as LodgingEnrichedMessage14 } from "@shared-ui/lodging-fragments";
var fragment69 = gql110(_templateObject112(), LodgingEnrichedMessage14.fragment);
var PriceMessages = function (param) {
  var data = param.data;
  var _data_displayPrice, _data_displayPrice1;
  return /* @__PURE__ */React154.createElement(React154.Fragment, null, Array.isArray(data === null || data === void 0 ? void 0 : (_data_displayPrice = data.displayPrice) === null || _data_displayPrice === void 0 ? void 0 : _data_displayPrice.priceMessages) && (data === null || data === void 0 ? void 0 : (_data_displayPrice1 = data.displayPrice) === null || _data_displayPrice1 === void 0 ? void 0 : _data_displayPrice1.priceMessages.map(function (message, messageIndex) {
    return /* @__PURE__ */React154.createElement(EGDSText41, {
      size: 200,
      key: "message-".concat(messageIndex)
    }, /* @__PURE__ */React154.createElement(LodgingEnrichedMessage14, {
      data: message
    }));
  })));
};
PriceMessages.fragment = fragment69;
PriceMessages.displayName = "SingleUnitPriceMessages";
// src/components/property-single-offer/__private/__fragments/single-unit-rate-plan-summary.tsx
import React155 from "react";
import { gql as gql111 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex30, EGDSLayoutFlexItem as EGDSLayoutFlexItem22 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText42 } from "@egds/react-core/text";
import { LodgingPriceSummary as LodgingPriceSummary4, PropertyPriceDocumentNode as PropertyPriceDocumentNode4 } from "@shared-ui/lodging-fragments";
import { PriceSummary as PriceSummary4 } from "@shared-ui/pricing-price-summary";
var fragment70 = gql111(_templateObject113(), LodgingPriceSummary4.fragment, PropertyRatePlanBadge.fragment, PropertyOffersPriceChangeMessage.fragment, PropertyPriceDocumentNode4);
var SingleUnitRatePlanSummary = function (param) {
  var data = param.data;
  var _priceDetail_price, _priceDetail_price_priceMessaging_, _priceDetail_price_displayMessages, _priceDetail_price1;
  var _data_priceDetails = _sliced_to_array(data.priceDetails, 1),
    priceDetail = _data_priceDetails[0];
  var priceSubtext = (priceDetail === null || priceDetail === void 0 ? void 0 : (_priceDetail_price = priceDetail.price) === null || _priceDetail_price === void 0 ? void 0 : _priceDetail_price.priceMessaging) && priceDetail.price.priceMessaging.length > 0 && ((_priceDetail_price_priceMessaging_ = priceDetail.price.priceMessaging[0]) === null || _priceDetail_price_priceMessaging_ === void 0 ? void 0 : _priceDetail_price_priceMessaging_.value);
  return /* @__PURE__ */React155.createElement(React155.Fragment, null, /* @__PURE__ */React155.createElement(PropertyOffersPriceChangeMessage, {
    data: data
  }), /* @__PURE__ */React155.createElement(EGDSLayoutFlex30, {
    justifyContent: "space-between",
    alignItems: "center"
  }, /* @__PURE__ */React155.createElement(EGDSLayoutFlexItem22, null, /* @__PURE__ */React155.createElement(EGDSLayoutFlex30, {
    alignItems: "end",
    space: "two"
  }, (priceDetail === null || priceDetail === void 0 ? void 0 : (_priceDetail_price1 = priceDetail.price) === null || _priceDetail_price1 === void 0 ? void 0 : (_priceDetail_price_displayMessages = _priceDetail_price1.displayMessages) === null || _priceDetail_price_displayMessages === void 0 ? void 0 : _priceDetail_price_displayMessages.length) ? /* @__PURE__ */React155.createElement(PriceSummary4, {
    data: priceDetail.price,
    flexAlignment: "start",
    enableInlineLink: true
  }) : /* @__PURE__ */React155.createElement(React155.Fragment, null, priceDetail && /* @__PURE__ */React155.createElement(LodgingPriceSummary4, {
    data: priceDetail,
    showPriceDetails: false
  }), /* @__PURE__ */React155.createElement(EGDSText42, {
    theme: "standard"
  }, priceSubtext)))), /* @__PURE__ */React155.createElement(EGDSLayoutFlexItem22, null, /* @__PURE__ */React155.createElement(PropertyRatePlanBadge, {
    data: data
  }))));
};
SingleUnitRatePlanSummary.fragment = fragment70;
SingleUnitRatePlanSummary.displayName = "SingleUnitRatePlan";
// src/components/property-single-offer/__private/__fragments/property-single-offer-details.tsx
var fragment71 = gql112(_templateObject114(), PriceMessages.fragment, SingleUnitRatePlanSummary.fragment, LodgingHighlightedMessages.fragment, AvailabilityCta2.fragment);
var PropertySingleOfferDetails = function (param) {
  var data = param.data;
  var singleUnitOffer = data;
  var id = singleUnitOffer.id;
  if (!id) {
    return null;
  }
  var singleRatePlan = Array.isArray(singleUnitOffer === null || singleUnitOffer === void 0 ? void 0 : singleUnitOffer.ratePlans) && (singleUnitOffer === null || singleUnitOffer === void 0 ? void 0 : singleUnitOffer.ratePlans.length) === 1 && (singleUnitOffer === null || singleUnitOffer === void 0 ? void 0 : singleUnitOffer.ratePlans[0]);
  if (!singleRatePlan) {
    return null;
  }
  return /* @__PURE__ */React156.createElement(EGDSCard26, {
    overflow: true
  }, /* @__PURE__ */React156.createElement(EGDSCardContentSection17, {
    "data-stid": "property-offer"
  }, /* @__PURE__ */React156.createElement(AvailabilityCta2, {
    data: data,
    listingIndex: 1
  }), /* @__PURE__ */React156.createElement(SingleUnitRatePlanSummary, {
    data: singleRatePlan
  }), /* @__PURE__ */React156.createElement(PriceMessages, {
    data: singleUnitOffer
  }), singleRatePlan.highlightedMessages && /* @__PURE__ */React156.createElement(EGDSSpacing84, {
    margin: {
      blockstart: "three"
    },
    padding: {
      blockstart: "three"
    },
    border: ["blockstart"]
  }, /* @__PURE__ */React156.createElement("div", null, /* @__PURE__ */React156.createElement(LodgingHighlightedMessages, {
    data: singleRatePlan
  })))));
};
PropertySingleOfferDetails.fragment = fragment71;
PropertySingleOfferDetails.displayName = "PropertySingleOfferDetails";
// src/components/property-single-offer/__private/__fragments/property-single-offer-dialog-link.tsx
import React160 from "react";
import { gql as gql116 } from "@apollo/client";
import { EGDSDialogContent as EGDSDialogContent8 } from "@egds/react-core/dialog";
import { EGDSIcon as EGDSIcon29, EGDSIconSize as EGDSIconSize21 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex31, EGDSLayoutFlexItem as EGDSLayoutFlexItem23 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink17 } from "@egds/react-core/link";
import { EGDSSheet as EGDSSheet13, EGDSSheetTransition as EGDSSheetTransition17 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing85 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText43 } from "@egds/react-core/text";
import { EGDSToolbar as EGDSToolbar12 } from "@egds/react-core/toolbar";
import { useClickTracker as useClickTracker37 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog19 } from "@shared-ui/dialog-context";
import { useExperiment as useExperiment11 } from "@shared-ui/experiment-context";
import { ViewMedium as ViewMedium16, Viewport as Viewport19, ViewSmall as ViewSmall18 } from "@shared-ui/viewport-context";
// src/components/property-single-offer/__private/__fragments/property-single-offer-installment-plan.tsx
import React158, { useEffect as useEffect8 } from "react";
import { gql as gql114 } from "@apollo/client";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "@egds/react-core/layout-flex";
import { UitkSpacing } from "@egds/react-core/spacing";
import { IntersectionTracker as IntersectionTracker15 } from "@shared-ui/clickstream-analytics-context";
// src/components/property-single-offer/utils/property-single-offer-affirm.ts
var createAffirmScript = function (apiKey, script) {
  return '_affirm_config = {\n    public_api_key: "'.concat(apiKey, '",\n    script: "').concat(script, '"\n  };\n(function(l,g,m,e,a,f,b,p){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];h.id=g[p];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready", "id");');
};
var loadAffirmScript = function (apiKey, scriptUrl) {
  var flag = document.getElementById("affirm-script");
  if (!flag) {
    var scriptElement = document.createElement("script");
    scriptElement.type = "text/javascript";
    var externalScript = document.createTextNode(createAffirmScript(apiKey, scriptUrl));
    scriptElement.appendChild(externalScript);
    document.head.appendChild(scriptElement);
    scriptElement.setAttribute("data-stid", "affirm-script");
    scriptElement.setAttribute("id", "affirm-script");
  }
};
// src/components/property-single-offer/__private/property-single-offer-affirm-details.tsx
import React157 from "react";
import { gql as gql113 } from "@apollo/client";
import { UitkText as UitkText2 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker36 } from "@shared-ui/clickstream-analytics-context";
var fragment72 = gql113(_templateObject115());
var PropertyAffirmDetails = function (param) {
  var _param_data = param.data,
    elementAttributes = _param_data.elementAttributes,
    interactionAnalytics = _param_data.interactionAnalytics;
  var track = useClickTracker36();
  var pricedAffirmElementAttributes = Object.fromEntries(elementAttributes.map(function (e) {
    return [e.key, e.value];
  }));
  var handleClick = function () {
    track(interactionAnalytics.referrerId, interactionAnalytics.linkName);
  };
  return /* @__PURE__ */React157.createElement(UitkText2, {
    size: 100,
    weight: "regular"
  }, /* @__PURE__ */React157.createElement("div", _object_spread_props(_object_spread({}, pricedAffirmElementAttributes), {
    onClick: handleClick,
    "aria-hidden": "true",
    role: "link"
  })));
};
PropertyAffirmDetails.fragment = fragment72;
PropertyAffirmDetails.displayName = "PropertyAffirmDetails";
// src/components/property-single-offer/__private/__fragments/property-single-offer-installment-plan.tsx
var fragment73 = gql114(_templateObject116(), PropertyAffirmDetails.fragment);
var PropertySingleOfferInstallmentPlan = function (param) {
  var _param_data = param.data,
    installmentPlanDetails = _param_data.installmentPlanDetails,
    impressionAnalytics = _param_data.impressionAnalytics;
  useEffect8(function () {
    var affirm = window.affirm;
    loadAffirmScript(installmentPlanDetails.apiKey, installmentPlanDetails.scriptUrl);
    affirm === null || affirm === void 0 ? void 0 : affirm.ui.ready(function () {
      affirm.ui.refresh();
    });
  }, [installmentPlanDetails]);
  return /* @__PURE__ */React158.createElement(UitkSpacing, {
    margin: "half"
  }, /* @__PURE__ */React158.createElement(UitkLayoutFlex, {
    direction: "column"
  }, /* @__PURE__ */React158.createElement(UitkLayoutFlexItem, {
    minWidth: "4x__half"
  }, impressionAnalytics && /* @__PURE__ */React158.createElement(IntersectionTracker15, {
    trackOnce: true,
    referrerId: impressionAnalytics.referrerId,
    linkName: impressionAnalytics.linkName
  }, /* @__PURE__ */React158.createElement(PropertyAffirmDetails, {
    data: installmentPlanDetails
  })))));
};
PropertySingleOfferInstallmentPlan.fragment = fragment73;
PropertySingleOfferInstallmentPlan.displayName = "SingleUnitRatePlan";
// src/components/property-single-offer/__private/__fragments/reserve-property.tsx
import React159 from "react";
import { gql as gql115 } from "@apollo/client";
import { PropertyPriceDocumentNode as PropertyPriceDocumentNode5 } from "@shared-ui/lodging-fragments";
var fragment74 = gql115(_templateObject117(), PropertyPriceDocumentNode5, PropertyReserveButton.fragment, PropertyInfoMessage.fragment);
var ETP_DIALOG_QUERY_PARAM2 = "infosite-room-ratePlans";
var ReserveProperty = function (param) {
  var data = param.data,
    _param_isFullWidth = param.isFullWidth,
    isFullWidth = _param_isFullWidth === void 0 ? true : _param_isFullWidth,
    onClose = param.onClose;
  var paymentPolicy = data.paymentPolicy;
  return /* @__PURE__ */React159.createElement(React159.Fragment, null, /* @__PURE__ */React159.createElement(PropertyReserveButton, {
    paymentPolicy: paymentPolicy,
    dialogSuffix: ETP_DIALOG_QUERY_PARAM2,
    data: data,
    listingIndex: 1,
    isFullWidth: isFullWidth,
    onClose: onClose,
    showLargeBtn: true
  }));
};
ReserveProperty.fragment = fragment74;
ReserveProperty.displayName = "SingleUnitRatePlan";
// src/components/property-single-offer/__private/__fragments/property-single-offer-dialog-link.tsx
var fragment75 = gql116(_templateObject118(), PropertySingleOfferDetails.fragment, MarketingSection.fragment, ReserveProperty.fragment, PricePresentationExpanded.fragment);
var Dialog2 = function (param) {
  var singleUnitOfferDialog = param.singleUnitOfferDialog,
    onClose = param.onClose,
    triggerRef = param.triggerRef,
    viewport = param.viewport,
    installmentPlan = param.installmentPlan;
  var _content_ratePlans, _toolbar_icon;
  var content = singleUnitOfferDialog.content,
    toolbar = singleUnitOfferDialog.toolbar;
  var singleRatePlan = Array.isArray(content === null || content === void 0 ? void 0 : content.ratePlans) && (content === null || content === void 0 ? void 0 : content.ratePlans.length) === 1 && (content === null || content === void 0 ? void 0 : (_content_ratePlans = content.ratePlans) === null || _content_ratePlans === void 0 ? void 0 : _content_ratePlans[0]);
  var _ref = singleRatePlan || {},
    tmp = _ref.priceDetails,
    _ref1 = _sliced_to_array(tmp === void 0 ? [] : tmp, 1),
    priceDetail = _ref1[0];
  var priceBreakDownSummary = (priceDetail || {}).priceBreakDownSummary;
  var _toolbar_title;
  return /* @__PURE__ */React160.createElement(EGDSSheet13, {
    type: viewport === "SMALL" ? "full" : "centered",
    isVisible: true,
    triggerRef: triggerRef,
    returnFocusOnClose: true
  }, /* @__PURE__ */React160.createElement(EGDSToolbar12, {
    toolbarTitle: (_toolbar_title = toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
    navigationContent: {
      onClick: onClose,
      navIconLabel: toolbar === null || toolbar === void 0 ? void 0 : (_toolbar_icon = toolbar.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description
    }
  }), /* @__PURE__ */React160.createElement(EGDSDialogContent8, {
    zeroPadding: true
  }, /* @__PURE__ */React160.createElement(React160.Fragment, null, /* @__PURE__ */React160.createElement(PropertySingleOfferDetails, {
    data: content
  }), /* @__PURE__ */React160.createElement(EGDSSpacing85, {
    padding: {
      inline: "three"
    }
  }, /* @__PURE__ */React160.createElement("div", null, priceBreakDownSummary ? /* @__PURE__ */React160.createElement(PriceBreakdownExpanded, {
    data: priceDetail
  }) : /* @__PURE__ */React160.createElement(PricePresentationExpanded, {
    data: priceDetail
  }), /* @__PURE__ */React160.createElement(MarketingSection, {
    data: singleRatePlan.marketingSection
  }))), installmentPlan && /* @__PURE__ */React160.createElement(EGDSSpacing85, {
    padding: {
      inlinestart: "four",
      inlineend: "four",
      blockstart: "six",
      blockend: "two"
    }
  }, /* @__PURE__ */React160.createElement(EGDSLayoutFlex31, {
    wrap: "wrap"
  }, /* @__PURE__ */React160.createElement(EGDSLayoutFlexItem23, {
    minWidth: "full_width"
  }, /* @__PURE__ */React160.createElement(PropertySingleOfferInstallmentPlan, {
    data: installmentPlan
  })))))), /* @__PURE__ */React160.createElement(EGDSSpacing85, {
    padding: {
      small: "four"
    }
  }, /* @__PURE__ */React160.createElement(EGDSLayoutFlex31, {
    wrap: "wrap"
  }, /* @__PURE__ */React160.createElement(EGDSLayoutFlexItem23, {
    minWidth: "full_width"
  }, /* @__PURE__ */React160.createElement("div", null, /* @__PURE__ */React160.createElement(ReserveProperty, {
    data: singleRatePlan,
    onClose: onClose
  }))))));
};
var PropertySingleOfferDialogLink = function (param) {
  var data = param.data,
    view = param.view,
    installmentPlan = param.installmentPlan;
  var _singleUnitOfferDialog_content_ratePlans, _singleUnitOfferDialog_content;
  var singleUnitOfferDialog = data.singleUnitOfferDialog;
  var trigger = (singleUnitOfferDialog || {}).trigger;
  var _useDialog19 = _sliced_to_array(useDialog19("price-details", "pwaDialogNested"), 3),
    isOpen = _useDialog19[0],
    priceDetailsDialogActions = _useDialog19[1],
    PriceDetailsDialogComponent = _useDialog19[2];
  var trackClick = useClickTracker37();
  var triggerRef = React160.useRef(null);
  var exposure = useExperiment11("Enhance_clarity_of_total_price_message_Vrbex_PDP_on_US_POSa").exposure;
  if (!(trigger === null || trigger === void 0 ? void 0 : trigger.value) || !(singleUnitOfferDialog === null || singleUnitOfferDialog === void 0 ? void 0 : singleUnitOfferDialog.content) || !(singleUnitOfferDialog === null || singleUnitOfferDialog === void 0 ? void 0 : (_singleUnitOfferDialog_content = singleUnitOfferDialog.content) === null || _singleUnitOfferDialog_content === void 0 ? void 0 : (_singleUnitOfferDialog_content_ratePlans = _singleUnitOfferDialog_content.ratePlans) === null || _singleUnitOfferDialog_content_ratePlans === void 0 ? void 0 : _singleUnitOfferDialog_content_ratePlans.length)) {
    return null;
  }
  var openPriceDetailsDialog = function () {
    priceDetailsDialogActions.openDialog();
    trackClick("HOT.HIS.PriceDetails.Open", "open price details dialog");
  };
  var closePriceDetailsDialog = function () {
    priceDetailsDialogActions.closeDialog();
    trackClick("HOT.HIS.PriceDetails.Close", "close price details dialog");
  };
  return /* @__PURE__ */React160.createElement(React160.Fragment, null, /* @__PURE__ */React160.createElement(EGDSLayoutFlex31, {
    justifyContent: "space-between",
    direction: exposure.bucket === 0 ? "row" : "column"
  }, view === "COMPACT" /* COMPACT */ && /* @__PURE__ */React160.createElement(EGDSLayoutFlexItem23, null, /* @__PURE__ */React160.createElement(EGDSText43, null, trigger.secondaryValue)), /* @__PURE__ */React160.createElement(EGDSLayoutFlexItem23, null, /* @__PURE__ */React160.createElement(EGDSLink17, {
    onClick: openPriceDetailsDialog,
    inline: true
  }, /* @__PURE__ */React160.createElement("button", {
    type: "button",
    ref: triggerRef
  }, trigger.value, view !== "COMPACT" /* COMPACT */ && /* @__PURE__ */React160.createElement(EGDSIcon29, {
    name: "chevron_right",
    size: EGDSIconSize21.SMALL
  }))))), /* @__PURE__ */React160.createElement(EGDSSheetTransition17, {
    isVisible: isOpen
  }, /* @__PURE__ */React160.createElement(PriceDetailsDialogComponent, null, /* @__PURE__ */React160.createElement(Viewport19, null, /* @__PURE__ */React160.createElement(ViewSmall18, null, /* @__PURE__ */React160.createElement(Dialog2, {
    singleUnitOfferDialog: singleUnitOfferDialog,
    installmentPlan: installmentPlan,
    onClose: closePriceDetailsDialog,
    triggerRef: triggerRef,
    viewport: "SMALL"
  })), /* @__PURE__ */React160.createElement(ViewMedium16, null, /* @__PURE__ */React160.createElement(Dialog2, {
    singleUnitOfferDialog: singleUnitOfferDialog,
    installmentPlan: installmentPlan,
    onClose: closePriceDetailsDialog,
    triggerRef: triggerRef,
    viewport: "MEDIUM"
  }))))));
};
PropertySingleOfferDialogLink.fragment = fragment75;
PropertySingleOfferDialogLink.displayName = "PropertySingleOfferDialogLink";
// src/components/property-single-offer/__private/__fragments/property-single-offer-form.tsx
import React162 from "react";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { UitkSpacing as UitkSpacing2 } from "@egds/react-core/spacing";
import { LocalizedText } from "@shared-ui/localization-context";
// src/components/property-single-offer/utils/property-single-offer-utils.ts
var START_DATE_REF_NAME3 = "startDate";
var END_DATE_REF_NAME = "endDate";
var PropertyOffersFormSubmitType = /* @__PURE__ */function (PropertyOffersFormSubmitType2) {
  PropertyOffersFormSubmitType2["TRAVELER_SELECTOR"] = "TRAVELER_SELECTOR";
  PropertyOffersFormSubmitType2["AVAILABILITY_CALENDAR"] = "AVAILABILITY_CALENDAR";
  PropertyOffersFormSubmitType2["LODGING_ONE_KEY_BURN_SWITCH"] = "LODGING_ONE_KEY_BURN_SWITCH";
  return PropertyOffersFormSubmitType2;
}(PropertyOffersFormSubmitType || {});
// src/components/property-single-offer/__private/__fragments/property-date-field.tsx
import React161 from "react";
import { useRefContext as useRefContext3 } from "@shared-ui/ref-context";
import { PropertyAvailability } from "@shared-ui/retail-lodging-property-availability";
var PropertyDateField = function (param) {
  var hotelId = param.hotelId,
    dateRangeInput = param.dateRangeInput,
    onSubmitCB = param.onSubmitCB;
  var registerTarget = useRefContext3().registerTarget;
  var startDateRef = registerTarget(START_DATE_REF_NAME3);
  var endDateRef = registerTarget(END_DATE_REF_NAME);
  var dateRange = dateRangeInput ? {
    end: dateRangeInput.checkOutDate,
    start: dateRangeInput.checkInDate
  } : null;
  return /* @__PURE__ */React161.createElement(PropertyAvailability, {
    startDateRef: startDateRef,
    endDateRef: endDateRef,
    inputs: {
      eid: String(hotelId),
      dateRange: dateRange
    },
    onSubmit: onSubmitCB,
    skipSsr: true
  });
};
// src/components/property-single-offer/__private/__fragments/property-single-offer-form.tsx
var SingleUnitForm = function (param) {
  var children = param.children,
    travelerSingleUnitData = param.travelerSingleUnitData;
  if (!travelerSingleUnitData) {
    return null;
  }
  var hotelId = travelerSingleUnitData.hotelId,
    dateRangeInput = travelerSingleUnitData.dateRangeInput,
    offersFormSubmit = travelerSingleUnitData.offersFormSubmit;
  var onSubmitCB = function (startDate, endDate) {
    offersFormSubmit({
      startDate: startDate,
      endDate: endDate
    }, "AVAILABILITY_CALENDAR" /* AVAILABILITY_CALENDAR */);
  };
  var _reactChildrenToDisplayNameMap = reactChildrenToDisplayNameMap(children),
    PropertyOffersLodgingOneKeyBurnSwitch = _reactChildrenToDisplayNameMap.PropertyOffersLodgingOneKeyBurnSwitch,
    PropertyOffersTravelerSelector = _reactChildrenToDisplayNameMap.PropertyOffersTravelerSelector;
  return /* @__PURE__ */React162.createElement(UitkSpacing2, {
    padding: {
      inline: "three",
      block: "three"
    }
  }, /* @__PURE__ */React162.createElement("div", null, /* @__PURE__ */React162.createElement("h3", {
    className: "is-visually-hidden"
  }, /* @__PURE__ */React162.createElement(LocalizedText, {
    message: "hotels.infosite.availabilityWizard.changeSearch.a11yLabel"
  })), /* @__PURE__ */React162.createElement(UitkSpacing2, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React162.createElement(UitkLayoutFlex2, {
    direction: "column",
    space: "three"
  }, /* @__PURE__ */React162.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React162.createElement(PropertyDateField, {
    hotelId: hotelId,
    dateRangeInput: dateRangeInput,
    onSubmitCB: onSubmitCB
  })), /* @__PURE__ */React162.createElement(UitkLayoutFlexItem2, null, PropertyOffersTravelerSelector))), PropertyOffersLodgingOneKeyBurnSwitch));
};
// src/components/property-single-offer/__private/__fragments/total-price.tsx
import React163 from "react";
import { gql as gql117 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex32, EGDSLayoutFlexItem as EGDSLayoutFlexItem24 } from "@egds/react-core/layout-flex";
import { EGDSHeading as EGDSHeading27 } from "@egds/react-core/text";
import { LodgingEnrichedMessage as LodgingEnrichedMessage15 } from "@shared-ui/lodging-fragments";
var fragment76 = gql117(_templateObject119(), LodgingEnrichedMessage15.fragment);
var TotalPrice = function (param) {
  var data = param.data;
  var _data_totalPrice, _data_totalPrice1;
  if (!(data === null || data === void 0 ? void 0 : (_data_totalPrice = data.totalPrice) === null || _data_totalPrice === void 0 ? void 0 : _data_totalPrice.label) || !(data === null || data === void 0 ? void 0 : (_data_totalPrice1 = data.totalPrice) === null || _data_totalPrice1 === void 0 ? void 0 : _data_totalPrice1.amount)) {
    return null;
  }
  return /* @__PURE__ */React163.createElement(EGDSLayoutFlex32, {
    justifyContent: "space-between"
  }, /* @__PURE__ */React163.createElement(EGDSLayoutFlexItem24, null, /* @__PURE__ */React163.createElement("div", null, /* @__PURE__ */React163.createElement(EGDSHeading27, {
    size: 6,
    tag: "h4"
  }, /* @__PURE__ */React163.createElement(LodgingEnrichedMessage15, {
    data: data.totalPrice.label
  })))), /* @__PURE__ */React163.createElement(EGDSLayoutFlexItem24, null, /* @__PURE__ */React163.createElement("div", null, /* @__PURE__ */React163.createElement(EGDSHeading27, {
    size: 6,
    tag: "h4"
  }, /* @__PURE__ */React163.createElement(LodgingEnrichedMessage15, {
    data: data.totalPrice.amount
  })))));
};
TotalPrice.fragment = fragment76;
TotalPrice.displayName = "TotalPrice";
// src/components/property-single-offer/__private/__fragments/property-single-rate-plan.tsx
var fragment77 = gql118(_templateObject120(), ErrorMessage.fragment, AlternateAvailabilityMsg.fragment, AlternateDates.fragment, TotalPrice.fragment, PropertySingleOfferDetails.fragment, MarketingSection.fragment, ReserveProperty.fragment, PropertySingleOfferDialogLink.fragment, PricePresentationExpanded.fragment, LodgingEnrichedMessage16.fragment, PropertySingleOfferInstallmentPlan.fragment);
var PropertySingleRatePlan = function (param) {
  var children = param.children,
    data = param.data,
    travelerSingleUnitData = param.travelerSingleUnitData;
  var _singleUnitOffer_ratePlans;
  var offersData = data;
  if (!offersData || !travelerSingleUnitData) {
    return null;
  }
  var singleUnitOffer = offersData.singleUnitOffer;
  var accessibilityLabel = (singleUnitOffer || {}).accessibilityLabel;
  var singleRatePlan = Array.isArray(singleUnitOffer === null || singleUnitOffer === void 0 ? void 0 : singleUnitOffer.ratePlans) && (singleUnitOffer === null || singleUnitOffer === void 0 ? void 0 : (_singleUnitOffer_ratePlans = singleUnitOffer.ratePlans) === null || _singleUnitOffer_ratePlans === void 0 ? void 0 : _singleUnitOffer_ratePlans[0]) || null;
  var _ref = singleRatePlan || {},
    tmp = _ref.priceDetails,
    _ref1 = _sliced_to_array(tmp === void 0 ? [] : tmp, 1),
    priceDetail = _ref1[0];
  var priceBreakDownSummary = (priceDetail || {}).priceBreakDownSummary;
  var marketingSection = singleRatePlan === null || singleRatePlan === void 0 ? void 0 : singleRatePlan.marketingSection;
  var shareUrl = singleRatePlan === null || singleRatePlan === void 0 ? void 0 : singleRatePlan.shareUrl;
  var installmentPlan = singleUnitOffer === null || singleUnitOffer === void 0 ? void 0 : singleUnitOffer.installmentPlan;
  var paymentReassuranceMessage = singleRatePlan === null || singleRatePlan === void 0 ? void 0 : singleRatePlan.paymentReassuranceMessage;
  var compactOfferView = /* @__PURE__ */React164.createElement(React164.Fragment, null, singleUnitOffer && /* @__PURE__ */React164.createElement(React164.Fragment, null, /* @__PURE__ */React164.createElement(EGDSSpacing86, {
    padding: {
      inline: "three"
    }
  }, /* @__PURE__ */React164.createElement("div", {
    "data-stid": "total-price"
  }, /* @__PURE__ */React164.createElement(TotalPrice, {
    data: singleUnitOffer
  }))), /* @__PURE__ */React164.createElement(EGDSSpacing86, {
    padding: {
      inline: "three",
      block: "one"
    }
  }, /* @__PURE__ */React164.createElement("div", null, /* @__PURE__ */React164.createElement(PropertySingleOfferDialogLink, {
    data: offersData,
    view: singleUnitOffer.view,
    installmentPlan: installmentPlan
  })))));
  return /* @__PURE__ */React164.createElement("div", {
    "data-stid": "property-offers"
  }, accessibilityLabel && /* @__PURE__ */React164.createElement("h2", {
    className: "is-visually-hidden"
  }, accessibilityLabel), offersData.errorMessage && /* @__PURE__ */React164.createElement(EGDSSpacing86, {
    padding: {
      blockstart: "three",
      inline: "three"
    }
  }, /* @__PURE__ */React164.createElement(ErrorMessage, {
    data: offersData.errorMessage
  })), offersData.alternateAvailabilityMsg && /* @__PURE__ */React164.createElement(EGDSSpacing86, {
    padding: {
      blockend: "three"
    }
  }, /* @__PURE__ */React164.createElement(AlternateAvailabilityMsg, {
    data: offersData.alternateAvailabilityMsg
  })), offersData.alternateDates && /* @__PURE__ */React164.createElement(EGDSSpacing86, {
    padding: {
      blockend: "three"
    }
  }, /* @__PURE__ */React164.createElement(AlternateDates, {
    data: offersData,
    columns: 1,
    justifyContent: "space-between"
  })), /* @__PURE__ */React164.createElement("div", {
    key: "single-unit-offer"
  }, singleUnitOffer && /* @__PURE__ */React164.createElement(PropertySingleOfferDetails, {
    data: singleUnitOffer
  }), /* @__PURE__ */React164.createElement(SingleUnitForm, {
    travelerSingleUnitData: travelerSingleUnitData
  }, children), (singleUnitOffer === null || singleUnitOffer === void 0 ? void 0 : singleUnitOffer.view) === "COMPACT" /* COMPACT */ ? /* @__PURE__ */React164.createElement(React164.Fragment, null, compactOfferView) : /* @__PURE__ */React164.createElement(Viewport20, null, /* @__PURE__ */React164.createElement(ViewSmall19, null, compactOfferView), /* @__PURE__ */React164.createElement(ViewLarge5, null, /* @__PURE__ */React164.createElement(React164.Fragment, null, singleRatePlan && /* @__PURE__ */React164.createElement(EGDSSpacing86, {
    padding: {
      inline: "three"
    }
  }, /* @__PURE__ */React164.createElement("div", null, priceBreakDownSummary ? priceDetail && /* @__PURE__ */React164.createElement(PriceBreakdownExpanded, {
    data: priceDetail
  }) : priceDetail && /* @__PURE__ */React164.createElement(PricePresentationExpanded, {
    data: priceDetail
  })))))), marketingSection && /* @__PURE__ */React164.createElement(EGDSSpacing86, {
    margin: {
      block: "two"
    }
  }, /* @__PURE__ */React164.createElement("div", null, /* @__PURE__ */React164.createElement(MarketingSection, {
    data: marketingSection
  }))), installmentPlan && /* @__PURE__ */React164.createElement(EGDSSpacing86, {
    padding: {
      blockstart: "six",
      blockend: "three",
      inline: "three"
    }
  }, /* @__PURE__ */React164.createElement("div", null, /* @__PURE__ */React164.createElement(PropertySingleOfferInstallmentPlan, {
    data: installmentPlan
  }))), singleRatePlan && /* @__PURE__ */React164.createElement(EGDSSpacing86, {
    padding: {
      blockstart: "three",
      inline: "three"
    }
  }, /* @__PURE__ */React164.createElement("div", null, /* @__PURE__ */React164.createElement(ReserveProperty, {
    data: singleRatePlan
  }))), paymentReassuranceMessage && /* @__PURE__ */React164.createElement(EGDSSpacing86, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React164.createElement(EGDSLayoutFlex33, {
    direction: "column",
    alignItems: "center"
  }, /* @__PURE__ */React164.createElement(EGDSLayoutFlexItem25, null, /* @__PURE__ */React164.createElement(LodgingEnrichedMessage16, {
    data: paymentReassuranceMessage
  })))), shareUrl && /* @__PURE__ */React164.createElement(EGDSSpacing86, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React164.createElement("div", null, /* @__PURE__ */React164.createElement(MarketingSectionLink, {
    shareUrl: shareUrl,
    linkAlignment: "center"
  })))));
};
PropertySingleRatePlan.fragment = fragment77;
PropertySingleRatePlan.displayName = "PropertySingleRatePlan";
// src/components/property-single-offer/property-single-offer.tsx
var __SingleOfferFragment = gql119(_templateObject121(), PropertySingleRatePlan.fragment);
var PropertySingleOffer = function (param) {
  var children = param.children,
    data = param.data,
    travelerSingleUnitData = param.travelerSingleUnitData;
  var _useContext6 = _sliced_to_array(useContext6(PropertyDetailsAdaptExContext4), 1),
    adaptExState = _useContext6[0];
  var amenitiesAdaptExSuccessEvents = adaptExState.amenitiesAdaptExSuccessEvents;
  var adaptExSuccessEvents = amenitiesAdaptExSuccessEvents !== null && amenitiesAdaptExSuccessEvents !== void 0 ? amenitiesAdaptExSuccessEvents : [];
  return /* @__PURE__ */React165.createElement(AdaptExEventsProvider2, {
    value: {
      adaptExSuccessEvents: adaptExSuccessEvents
    }
  }, /* @__PURE__ */React165.createElement(PropertySingleRatePlan, {
    data: data,
    travelerSingleUnitData: travelerSingleUnitData
  }, children));
};
PropertySingleOffer.displayName = "PropertySingleOffer";
PropertySingleOffer.fragment = __SingleOfferFragment;
// src/components/property-single-offer/lodging-property-single-offer.tsx
import React167 from "react";
// src/components/single-offer-search/__private/button-wrapper.tsx
import React166 from "react";
import { SubmitButton } from "@shared-ui/lodging-form";
var ButtonWrapper = function (param) {
  var text = param.text;
  var submitButtonData = {
    __typename: "LodgingFormSubmitButton",
    label: text
  };
  return /* @__PURE__ */React166.createElement(SubmitButton, {
    fieldName: "submit",
    data: submitButtonData
  });
};
// src/components/property-single-offer/lodging-property-single-offer.tsx
var LodgingPropertySingleOffer = function (param) {
  var travelerSingleUnitData = param.travelerSingleUnitData,
    skipSsr = param.skipSsr;
  var ref = React167.useRef(null);
  if (!travelerSingleUnitData) {
    return null;
  }
  var offersFormSubmit = travelerSingleUnitData.offersFormSubmit;
  var updateStoreWithTravelerUrlData = function (travelerSelectorPayload) {
    var adults = travelerSelectorPayload.adults,
      children = travelerSelectorPayload.children,
      isPetsIncluded = travelerSelectorPayload.isPetsIncluded;
    offersFormSubmit({
      adults: adults,
      children: children,
      petsIncluded: isPetsIncluded
    }, "TRAVELER_SELECTOR" /* TRAVELER_SELECTOR */);
  };
  var getHandleOneKeyClick = function (isChecked) {
    offersFormSubmit({
      isChecked: isChecked
    }, "LODGING_ONE_KEY_BURN_SWITCH" /* LODGING_ONE_KEY_BURN_SWITCH */);
  };
  return /* @__PURE__ */React167.createElement(PropertySingleOffer2, {
    travelerSingleUnitData: travelerSingleUnitData,
    inputs: travelerSingleUnitData.inputs,
    skipSsr: skipSsr
  }, /* @__PURE__ */React167.createElement(TravelerSelector, {
    inputs: travelerSingleUnitData.inputs,
    updateStoreWithTravelerUrlData: updateStoreWithTravelerUrlData,
    triggerRef: ref
  }), /* @__PURE__ */React167.createElement(LodgingOneKeyBurnSwitch2, {
    inputs: travelerSingleUnitData.inputs,
    handler: getHandleOneKeyClick,
    skipSsr: true
  }), /* @__PURE__ */React167.createElement(SingleOfferSearchButton, {
    inputs: travelerSingleUnitData.inputs,
    ButtonWrapper: ButtonWrapper,
    skipSsr: true
  }));
};
// src/components/property-space-details/property-space-details.tsx
import React168 from "react";
import { gql as gql120 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing87 } from "@egds/react-core/spacing";
var __PropertySpaceDetailsFragment = gql120(_templateObject122(), SpaceDetailsHeader.fragment, SpaceDetailsSpaces.fragment, SpaceDetailsFloorPlan.fragment, VirtualTourPrompt.fragment);
var PropertySpaceDetails = function (param) {
  var data = param.data,
    className = param.className;
  var spaceDetails = data.spaceDetails;
  if (!spaceDetails) {
    return null;
  }
  return /* @__PURE__ */React168.createElement(EGDSSpacing87, {
    padding: "six"
  }, /* @__PURE__ */React168.createElement(SpaceDetails, {
    className: className,
    data: spaceDetails
  }));
};
PropertySpaceDetails.displayName = "PropertySpaceDetails";
PropertySpaceDetails.fragment = __PropertySpaceDetailsFragment;
// src/components/property-space-details/placeholder.tsx
import React169 from "react";
import { EGDSCard as EGDSCard27, EGDSCardContentSection as EGDSCardContentSection18 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure6, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType8 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex34, EGDSLayoutFlexItem as EGDSLayoutFlexItem26 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid22, EGDSLayoutGridItem as EGDSLayoutGridItem19 } from "@egds/react-core/layout-grid";
import { EGDSBlockSkeleton as EGDSBlockSkeleton2, EGDSLineSkeleton as EGDSLineSkeleton4 } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing88 } from "@egds/react-core/spacing";
import { ViewLarge as ViewLarge6, Viewport as Viewport21, ViewSmall as ViewSmall20 } from "@shared-ui/viewport-context";
var LineSkeletonPlaceholder = function (param) {
  var colSpan = param.colSpan,
    colStart = param.colStart;
  return /* @__PURE__ */React169.createElement(EGDSLayoutGridItem19, {
    colSpan: colSpan,
    colStart: colStart
  }, /* @__PURE__ */React169.createElement(EGDSLayoutFlex34, {
    space: "four",
    direction: "column"
  }, /* @__PURE__ */React169.createElement(EGDSLayoutFlexItem26, null, /* @__PURE__ */React169.createElement(EGDSLineSkeleton4, {
    animation: true
  })), /* @__PURE__ */React169.createElement(EGDSLayoutFlexItem26, null, /* @__PURE__ */React169.createElement(EGDSLineSkeleton4, {
    animation: true,
    type: "secondary"
  }))));
};
var BlockSkeletonPlaceholder = function (param) {
  var colSpan = param.colSpan,
    colStart = param.colStart;
  return /* @__PURE__ */React169.createElement(EGDSLayoutGridItem19, {
    colSpan: colSpan,
    colStart: colStart
  }, /* @__PURE__ */React169.createElement(EGDSFigure6, {
    ratio: EGDSFigureAspectRatioType8.R4_1
  }, /* @__PURE__ */React169.createElement(EGDSBlockSkeleton2, {
    type: "rounded"
  })));
};
var PropertySpaceDetailsPlaceholder = function () {
  return /* @__PURE__ */React169.createElement(EGDSSpacing88, {
    padding: {
      block: "six",
      large: {
        inline: "six"
      }
    }
  }, /* @__PURE__ */React169.createElement(EGDSCard27, {
    overflow: false
  }, /* @__PURE__ */React169.createElement(EGDSCardContentSection18, null, /* @__PURE__ */React169.createElement(EGDSLayoutGrid22, {
    space: "six",
    columns: {
      small: 1,
      medium: 1,
      large: 3
    }
  }, /* @__PURE__ */React169.createElement(LineSkeletonPlaceholder, null), /* @__PURE__ */React169.createElement(Viewport21, null, /* @__PURE__ */React169.createElement(ViewSmall20, null, /* @__PURE__ */React169.createElement(BlockSkeletonPlaceholder, {
    colSpan: 1,
    colStart: 1
  })), /* @__PURE__ */React169.createElement(ViewLarge6, null, /* @__PURE__ */React169.createElement(BlockSkeletonPlaceholder, {
    colSpan: 1,
    colStart: 3
  })))))));
};
PropertySpaceDetailsPlaceholder.displayName = "PropertySpaceDetailsPlaceholder";
// src/components/property-sticky-book-bar/property-sticky-book-bar.tsx
import React176, { useContext as useContext7 } from "react";
import { gql as gql126 } from "@apollo/client";
import { EGDSDialog as EGDSDialog3, EGDSDialogContent as EGDSDialogContent9, EGDSDialogFooter as EGDSDialogFooter3 } from "@egds/react-core/dialog";
import { EGDSLayoutFlex as EGDSLayoutFlex36, EGDSLayoutFlexItem as EGDSLayoutFlexItem28 } from "@egds/react-core/layout-flex";
import { EGDSSheet as EGDSSheet15, EGDSSheetTransition as EGDSSheetTransition19 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing90 } from "@egds/react-core/spacing";
import { useEgClickstream as useEgClickstream14 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog22 } from "@shared-ui/dialog-context";
import { AdaptExEventsProvider as AdaptExEventsProvider3, useDialogId as useDialogId12 } from "@shared-ui/lodging-fragments";
import { PropertyDetailsAdaptExContext as PropertyDetailsAdaptExContext5 } from "@shared-ui/lodging-property-details";
import { useRefContext as useRefContext5, useVisibility, VisibilityEventType } from "@shared-ui/ref-context";
import { ViewLarge as ViewLarge7, ViewMedium as ViewMedium18, Viewport as Viewport23, ViewSmall as ViewSmall22 } from "@shared-ui/viewport-context";
// src/components/__private/__fragments/sticky-cta.tsx
import React170 from "react";
import { gql as gql121 } from "@apollo/client";
import { EGDSPrimaryButton as EGDSPrimaryButton10 } from "@egds/react-core/button";
import { ITrackType as ITrackType4, useClickstreamAnalytics as useClickstreamAnalytics4, useClickTracker as useClickTracker38 } from "@shared-ui/clickstream-analytics-context";
import { AdaptExAnalyticsEventFragment as AdaptExAnalyticsEventFragment5, adaptToAdaptExSuccessEventSchema as adaptToAdaptExSuccessEventSchema4, useAdaptExEvents as useAdaptExEvents3 } from "@shared-ui/lodging-fragments";
import { useRefContext as useRefContext4, useRefTargetScroll } from "@shared-ui/ref-context";
var SCROLL_OFFSETS = [{
  sectionName: "navigation"
}];
var SCROLL_TO_TARGET_SECTION = "Offers";
var SCROLL_TIMEOUT = 1e3;
var __StickyCtaFragment = gql121(_templateObject123(), PropertySingleOfferDialogLink.fragment, AdaptExAnalyticsEventFragment5);
var StickyCta = function (param) {
  var data = param.data,
    isFullWidth = param.isFullWidth,
    clickTargetRef = param.clickTargetRef,
    focusTargetRef = param.focusTargetRef,
    scrollSectionRef = param.scrollSectionRef;
  var _shoppingContext_multiItem, _singleUnitOffer_ratePlans;
  var stickyBar = data.stickyBar,
    singleUnitOfferDialog = data.singleUnitOfferDialog,
    shoppingContext = data.shoppingContext;
  var packageType = shoppingContext === null || shoppingContext === void 0 ? void 0 : (_shoppingContext_multiItem = shoppingContext.multiItem) === null || _shoppingContext_multiItem === void 0 ? void 0 : _shoppingContext_multiItem.packageType;
  var singleUnitOffer = singleUnitOfferDialog === null || singleUnitOfferDialog === void 0 ? void 0 : singleUnitOfferDialog.content;
  var singleUnitRatePlan = Array.isArray(singleUnitOffer === null || singleUnitOffer === void 0 ? void 0 : singleUnitOffer.ratePlans) && (singleUnitOffer === null || singleUnitOffer === void 0 ? void 0 : (_singleUnitOffer_ratePlans = singleUnitOffer.ratePlans) === null || _singleUnitOffer_ratePlans === void 0 ? void 0 : _singleUnitOffer_ratePlans[0]);
  var stickyButton = stickyBar === null || stickyBar === void 0 ? void 0 : stickyBar.stickyButton;
  var withAvailabilityCalendarStartDateRef = (stickyButton === null || stickyButton === void 0 ? void 0 : stickyButton.targetRef) === "AVAILABILITY_CALENDAR_START_DATE";
  var adaptExSuccessActionTracking = (stickyButton || {}).adaptExSuccessActionTracking;
  var adaptExSuccessEvents = useAdaptExEvents3(adaptExSuccessActionTracking !== null && adaptExSuccessActionTracking !== void 0 ? adaptExSuccessActionTracking : []).adaptExSuccessEvents;
  var scrollTo = useRefTargetScroll().scrollTo;
  var getTargets = useRefContext4().getTargets;
  var trackClick = useClickTracker38();
  var _useClickstreamAnalytics4 = useClickstreamAnalytics4(),
    clickStreamTrack = _useClickstreamAnalytics4.track;
  var handleClick = function (ref) {
    var _getTargets = getTargets([ref]),
      clickRef = _getTargets[ref];
    setTimeout(function () {
      var _clickRef_current;
      clickRef === null || clickRef === void 0 ? void 0 : (_clickRef_current = clickRef.current) === null || _clickRef_current === void 0 ? void 0 : _clickRef_current.click();
    }, SCROLL_TIMEOUT);
  };
  var onClick = function () {
    trackClick("HOT.HIS.StickyBookButton", "Sticky Book Button");
    _to_consumable_array(adaptExSuccessEvents).forEach(function (adaptExEvent) {
      clickStreamTrack(ITrackType4.EVENT, {
        data: adaptToAdaptExSuccessEventSchema4(_object_spread_props(_object_spread({}, adaptExEvent), {
          events: adaptExEvent.events
        }))
      });
    });
    if (scrollSectionRef) {
      scrollTo(scrollSectionRef, SCROLL_OFFSETS);
    } else {
      scrollTo(SCROLL_TO_TARGET_SECTION, SCROLL_OFFSETS);
    }
    if (focusTargetRef) {
      var _getTargets = getTargets([focusTargetRef]),
        focusRef = _getTargets[focusTargetRef];
      setTimeout(function () {
        var _focusRef_current;
        focusRef === null || focusRef === void 0 ? void 0 : (_focusRef_current = focusRef.current) === null || _focusRef_current === void 0 ? void 0 : _focusRef_current.focus();
      }, SCROLL_TIMEOUT);
    }
    if (clickTargetRef) {
      handleClick(clickTargetRef);
    } else if (withAvailabilityCalendarStartDateRef) {
      handleClick("startDate");
    }
  };
  return /* @__PURE__ */React170.createElement(React170.Fragment, null, packageType || !singleUnitRatePlan || withAvailabilityCalendarStartDateRef ? /* @__PURE__ */React170.createElement(EGDSPrimaryButton10, {
    "data-stid": "sticky-button",
    onClick: onClick,
    isFullWidth: isFullWidth
  }, stickyButton === null || stickyButton === void 0 ? void 0 : stickyButton.text) : /* @__PURE__ */React170.createElement(ReserveProperty, {
    data: singleUnitRatePlan,
    isFullWidth: isFullWidth
  }));
};
StickyCta.fragment = __StickyCtaFragment;
StickyCta.displayName = "StickyCta";
// src/components/__private/__fragments/sticky-price-summary.tsx
import React171 from "react";
import { gql as gql122 } from "@apollo/client";
import { EGDSIcon as EGDSIcon30, EGDSIconSize as EGDSIconSize22 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex35, EGDSLayoutFlexItem as EGDSLayoutFlexItem27 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink18 } from "@egds/react-core/link";
import { EGDSText as EGDSText44 } from "@egds/react-core/text";
import { useDialog as useDialog20 } from "@shared-ui/dialog-context";
import { PropertyPriceDocumentNode as PropertyPriceDocumentNode6 } from "@shared-ui/lodging-fragments";
import { PriceSummary as PriceSummary5 } from "@shared-ui/pricing-price-summary";
var __StickyPropertyPriceFragment = gql122(_templateObject124(), PropertyPriceDocumentNode6);
var createCorrectFormat = function (propertyPrice) {
  if (!propertyPrice || !(propertyPrice === null || propertyPrice === void 0 ? void 0 : propertyPrice.displayMessages) || (propertyPrice === null || propertyPrice === void 0 ? void 0 : propertyPrice.displayMessages.length) !== 1) {
    return null;
  }
  var allLineItems = propertyPrice.displayMessages.map(function (x) {
    return x.lineItems;
  }).reduce(function (a, b) {
    return a.concat(b);
  });
  if (allLineItems.length === 0) {
    return null;
  }
  var leadPrice = {
    __typename: "PriceDisplayMessage",
    lineItems: allLineItems.filter(function (x, index) {
      return index === 0;
    })
  };
  var qualifiers = {
    __typename: "PriceDisplayMessage",
    lineItems: allLineItems.length > 1 ? allLineItems.slice(1) : []
  };
  var newPropertyPrice = {
    __typename: propertyPrice.__typename,
    options: propertyPrice.options,
    priceMessaging: propertyPrice.priceMessaging,
    displayMessages: [leadPrice, qualifiers]
  };
  return newPropertyPrice;
};
var StickyPriceSummary = function (param) {
  var data = param.data,
    wrapLeadPriceQualifier = param.wrapLeadPriceQualifier,
    align = param.align,
    dialogId = param.dialogId,
    _param_justifyContent = param.justifyContent,
    justifyContent = _param_justifyContent === void 0 ? "start" : _param_justifyContent,
    triggerRef = param.triggerRef,
    children = param.children;
  var _priceDisclaimer_trigger_icon, _priceDisclaimer_trigger, _formattedPropertyPrice_displayMessages;
  var _useDialog20 = _sliced_to_array(useDialog20(dialogId), 2),
    dialogActions = _useDialog20[1];
  var handleDialogOpen = React171.useCallback(function () {
    dialogActions.openDialog();
  }, [dialogActions]);
  var price = data.price,
    propertyPrice = data.propertyPrice,
    qualifier = data.qualifier,
    subText = data.subText;
  var _ref = price || {},
    formattedDisplayPrice = _ref.formattedDisplayPrice,
    accessibilityLabel = _ref.accessibilityLabel,
    priceDisclaimer = _ref.priceDisclaimer;
  var priceAvailable = formattedDisplayPrice || subText || propertyPrice;
  var disclaimerIcon = /* @__PURE__ */React171.createElement(React171.Fragment, null, (priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_trigger = priceDisclaimer.trigger) === null || _priceDisclaimer_trigger === void 0 ? void 0 : (_priceDisclaimer_trigger_icon = _priceDisclaimer_trigger.icon) === null || _priceDisclaimer_trigger_icon === void 0 ? void 0 : _priceDisclaimer_trigger_icon.id) && /* @__PURE__ */React171.createElement(EGDSLayoutFlexItem27, null, /* @__PURE__ */React171.createElement(EGDSLink18, {
    inline: true,
    onClick: handleDialogOpen,
    className: "uitk-more-info-trigger",
    "data-stid": "disclaimer-dialog-link"
  }, /* @__PURE__ */React171.createElement("button", {
    type: "button",
    ref: triggerRef
  }, /* @__PURE__ */React171.createElement(EGDSIcon30, {
    name: priceDisclaimer.trigger.icon.id,
    size: EGDSIconSize22.SMALL
  })))));
  var priceDisplay = /* @__PURE__ */React171.createElement(EGDSLayoutFlexItem27, null, /* @__PURE__ */React171.createElement(React171.Fragment, null, /* @__PURE__ */React171.createElement(EGDSText44, {
    className: "is-visually-hidden"
  }, accessibilityLabel || formattedDisplayPrice), /* @__PURE__ */React171.createElement("span", {
    "aria-hidden": "true"
  }, /* @__PURE__ */React171.createElement(EGDSText44, {
    size: 500,
    weight: "bold"
  }, formattedDisplayPrice, qualifier && /* @__PURE__ */React171.createElement(EGDSText44, {
    size: 200,
    weight: "medium",
    inline: true
  }, qualifier)))));
  var formattedPropertyPrice = wrapLeadPriceQualifier && propertyPrice ? createCorrectFormat(propertyPrice) : propertyPrice;
  return /* @__PURE__ */React171.createElement(React171.Fragment, null, priceAvailable && /* @__PURE__ */React171.createElement(React171.Fragment, null, (formattedPropertyPrice === null || formattedPropertyPrice === void 0 ? void 0 : (_formattedPropertyPrice_displayMessages = formattedPropertyPrice.displayMessages) === null || _formattedPropertyPrice_displayMessages === void 0 ? void 0 : _formattedPropertyPrice_displayMessages.length) ? /* @__PURE__ */React171.createElement("div", null, /* @__PURE__ */React171.createElement(PriceSummary5, {
    data: formattedPropertyPrice,
    flexAlignment: justifyContent
  }), children) : /* @__PURE__ */React171.createElement(EGDSLayoutFlexItem27, null, /* @__PURE__ */React171.createElement(EGDSLayoutFlex35, {
    direction: "column",
    alignItems: align
  }, /* @__PURE__ */React171.createElement(React171.Fragment, null, formattedDisplayPrice && /* @__PURE__ */React171.createElement(EGDSLayoutFlexItem27, null, /* @__PURE__ */React171.createElement("div", null, /* @__PURE__ */React171.createElement(EGDSLayoutFlex35, null, align === "start" && /* @__PURE__ */React171.createElement(React171.Fragment, null, priceDisplay, disclaimerIcon), align === "end" && /* @__PURE__ */React171.createElement(React171.Fragment, null, disclaimerIcon, priceDisplay)), children)), subText && /* @__PURE__ */React171.createElement(EGDSLayoutFlexItem27, null, /* @__PURE__ */React171.createElement(EGDSText44, {
    size: 100,
    weight: "medium"
  }, subText)))))));
};
StickyPriceSummary.fragment = __StickyPropertyPriceFragment;
StickyPriceSummary.displayName = "StickyPriceSummary";
// src/components/property-offers/__private/__fragments/property-sticky-book-bar-price-presentation-dialog/property-sticky-book-bar-price-presentation-dialog.tsx
import React172 from "react";
import { EGDSIcon as EGDSIcon31, EGDSIconSize as EGDSIconSize23 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink19 } from "@egds/react-core/link";
import { EGDSSheet as EGDSSheet14, EGDSSheetContent as EGDSSheetContent9, EGDSSheetTransition as EGDSSheetTransition18 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing89 } from "@egds/react-core/spacing";
import { EGDSToolbar as EGDSToolbar13 } from "@egds/react-core/toolbar";
import { useClickTracker as useClickTracker39 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog21 } from "@shared-ui/dialog-context";
import { PricePresentation as PricePresentation3 } from "@shared-ui/pricing-price-details";
import { ViewMedium as ViewMedium17, Viewport as Viewport22, ViewSmall as ViewSmall21 } from "@shared-ui/viewport-context";
// src/components/property-offers/__private/__fragments/property-sticky-book-bar-price-presentation-dialog/property-sticky-book-bar-price-presentation-dialog-fragment.tsx
import { gql as gql123 } from "@apollo/client";
import { UiGraphic as UiGraphic3 } from "@shared-ui/lodging-fragments";
var PropertyStickyBookBarPricePresentationDialogFragment = gql123(_templateObject125(), UiGraphic3.fragment);
// src/components/property-offers/__private/__fragments/property-sticky-book-bar-price-presentation-dialog/property-sticky-book-bar-price-presentation-dialog.tsx
var Dialog3 = function (param) {
  var data = param.data,
    onClose = param.onClose,
    triggerRef = param.triggerRef,
    viewport = param.viewport;
  var _toolbar_icon;
  var pricePresentation = data.pricePresentation,
    pricePresentationDialog = data.pricePresentationDialog;
  var toolbar = pricePresentationDialog.toolbar;
  var _toolbar_title;
  return /* @__PURE__ */React172.createElement(EGDSSheet14, {
    type: viewport === "SMALL" ? "full" : "centered",
    isVisible: true,
    triggerRef: triggerRef,
    returnFocusOnClose: true
  }, /* @__PURE__ */React172.createElement(EGDSToolbar13, {
    toolbarTitle: (_toolbar_title = toolbar === null || toolbar === void 0 ? void 0 : toolbar.title) !== null && _toolbar_title !== void 0 ? _toolbar_title : void 0,
    navigationContent: {
      onClick: onClose,
      navType: "close",
      navIconLabel: toolbar === null || toolbar === void 0 ? void 0 : (_toolbar_icon = toolbar.icon) === null || _toolbar_icon === void 0 ? void 0 : _toolbar_icon.description
    }
  }), /* @__PURE__ */React172.createElement(EGDSSheetContent9, {
    padded: false
  }, /* @__PURE__ */React172.createElement(EGDSSpacing89, {
    padding: viewport === "SMALL" ? {
      block: "four",
      inline: "four"
    } : {
      block: "six",
      inline: "six"
    }
  }, /* @__PURE__ */React172.createElement("div", null, /* @__PURE__ */React172.createElement(PricePresentation3, {
    data: pricePresentation
  })))));
};
var PropertyStickyBookBarPricePresentationDialog = function (param) {
  var data = param.data;
  var triggerRef = React172.useRef(null);
  var _useDialog21 = _sliced_to_array(useDialog21("price-presentation-book-bar-dialog", "pwaDialogNested"), 3),
    isDialogOpen = _useDialog21[0],
    dialogActions = _useDialog21[1],
    DialogComponent = _useDialog21[2];
  var track = useClickTracker39();
  var pricePresentation = data.pricePresentation,
    pricePresentationDialog = data.pricePresentationDialog;
  if (!pricePresentation || !pricePresentationDialog) {
    return null;
  }
  var toolbar = pricePresentationDialog.toolbar,
    trigger = pricePresentationDialog.trigger;
  var openDialog = function () {
    var clientSideAnalytics = trigger.clientSideAnalytics;
    dialogActions.openDialog();
    if (clientSideAnalytics) {
      track(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
    }
  };
  var closeDialog = function () {
    var clientSideAnalytics = (toolbar || {}).clientSideAnalytics;
    dialogActions.closeDialog();
    if (clientSideAnalytics) {
      track(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
    }
  };
  return /* @__PURE__ */React172.createElement(React172.Fragment, null, /* @__PURE__ */React172.createElement(EGDSSpacing89, null, /* @__PURE__ */React172.createElement(EGDSLink19, {
    onClick: openDialog
  }, /* @__PURE__ */React172.createElement("button", {
    type: "button"
  }, trigger.value, /* @__PURE__ */React172.createElement(EGDSIcon31, {
    name: "chevron_right",
    size: EGDSIconSize23.SMALL
  })))), /* @__PURE__ */React172.createElement(EGDSSheetTransition18, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React172.createElement(DialogComponent, null, /* @__PURE__ */React172.createElement(Viewport22, null, /* @__PURE__ */React172.createElement(ViewSmall21, null, /* @__PURE__ */React172.createElement(Dialog3, {
    data: data,
    onClose: closeDialog,
    triggerRef: triggerRef,
    viewport: "SMALL"
  })), /* @__PURE__ */React172.createElement(ViewMedium17, null, /* @__PURE__ */React172.createElement(Dialog3, {
    data: data,
    onClose: closeDialog,
    triggerRef: triggerRef,
    viewport: "MEDIUM"
  }))))));
};
PropertyStickyBookBarPricePresentationDialog.fragment = PropertyStickyBookBarPricePresentationDialogFragment;
PropertyStickyBookBarPricePresentationDialog.displayName = "PropertyStickyBookBarPricePresentationDialog";
// src/components/property-unit-list-view/property-unit-list-view.tsx
import React174 from "react";
import { gql as gql125 } from "@apollo/client";
import { EGDSCard as EGDSCard28 } from "@egds/react-core/cards";
// src/components/property-unit-list-view/__private/__fragments/property-unit-list-view-element.tsx
import React173 from "react";
import { gql as gql124 } from "@apollo/client";
import { EGDSCardContentSection as EGDSCardContentSection19 } from "@egds/react-core/cards";
import { EGDSHeading as EGDSHeading28 } from "@egds/react-core/text";
var __PropertyUnitListViewElementFragment = gql124(_templateObject126());
var PropertyUnitListViewElement = function (param) {
  var data = param.data,
    listingIndex = param.listingIndex;
  var header = data.header;
  var _React173_useState = _sliced_to_array(React173.useState(false), 2),
    mounted = _React173_useState[0],
    setMounted = _React173_useState[1];
  React173.useEffect(function () {
    setMounted(true);
  }, []);
  if (!header) {
    return null;
  }
  return /* @__PURE__ */React173.createElement(React173.Fragment, null, mounted && /* @__PURE__ */React173.createElement(EGDSCardContentSection19, {
    border: "top",
    "data-stid": "property-offer-list-view-element-".concat(listingIndex)
  }, header && /* @__PURE__ */React173.createElement("div", null, /* @__PURE__ */React173.createElement(EGDSHeading28, {
    tag: "h2",
    size: 6
  }, header.text))));
};
PropertyUnitListViewElement.fragment = __PropertyUnitListViewElementFragment;
PropertyUnitListViewElement.displayName = "PropertyUnitListViewElement";
// src/components/property-unit-list-view/property-unit-list-view.tsx
var __PropertyUnitListViewFragment = gql125(_templateObject127(), PropertyUnitListViewElement.fragment);
var PropertyUnitListView = function (param) {
  var data = param.data;
  var categorizedListings = data.categorizedListings;
  if (!categorizedListings) {
    return null;
  }
  return /* @__PURE__ */React174.createElement(EGDSCard28, {
    border: true
  }, /* @__PURE__ */React174.createElement("div", null, categorizedListings.map(function (listing, index) {
    switch (listing.__typename) {
      case "LodgingCategorizedUnit":
        return /* @__PURE__ */React174.createElement(PropertyUnitListViewElement, {
          key: "property-offer-list-view-element-".concat(index),
          listingIndex: index + 1,
          data: listing
        });
      default:
        return null;
    }
  })));
};
PropertyUnitListView.fragment = __PropertyUnitListViewFragment;
PropertyUnitListView.displayName = "PropertyUnitListView";
// src/components/property-sticky-book-bar/structured-data.tsx
import React175 from "react";
var generateSchema = function (content) {
  if (!content) {
    return null;
  }
  var schemaJson = {
    "@context": "https://schema.org",
    "@type": "priceRange",
    priceRange: content
  };
  return JSON.stringify(schemaJson);
};
var StickyBarStructuredData = function (param) {
  var content = param.content;
  var data = generateSchema(content);
  if (!data) {
    return null;
  }
  return /* @__PURE__ */React175.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: data
    }
  });
};
// src/components/property-sticky-book-bar/property-sticky-book-bar.tsx
var fragment78 = gql126(_templateObject128(), PropertySingleOfferDialogLink.fragment, StickyCta.fragment, StickyPriceSummary.fragment, PropertyStickyBookBarPricePresentationDialog.fragment, __PropertyUnitListViewFragment);
var HIDE_STICKY_TARGET_SECTION = "Offers";
var PropertyStickyBookBar = function (param) {
  var clickTargetRef = param.clickTargetRef,
    focusTargetRef = param.focusTargetRef,
    scrollSectionRef = param.scrollSectionRef,
    hideSectionRef = param.hideSectionRef,
    _param_isSticky = param.isSticky,
    isSticky = _param_isSticky === void 0 ? true : _param_isSticky,
    _param_align = param.align,
    align = _param_align === void 0 ? "end" : _param_align,
    priceSummaryJustifyContent = param.priceSummaryJustifyContent,
    _param_hideCtaButton = param.hideCtaButton,
    hideCtaButton = _param_hideCtaButton === void 0 ? false : _param_hideCtaButton,
    _param_hidePrice = param.hidePrice,
    hidePrice = _param_hidePrice === void 0 ? false : _param_hidePrice,
    data = param.data,
    children = param.children,
    refTargets = param.refTargets;
  var _stickyBar_stickyButton, _priceDisclaimer_primaryUIButton;
  var stickyBar = data.stickyBar,
    soldOut = data.soldOut,
    singleUnitOfferDialog = data.singleUnitOfferDialog,
    categorizedListings = data.categorizedListings;
  var _React176_useState = _sliced_to_array(React176.useState(false), 2),
    stickyVisible = _React176_useState[0],
    setStickyVisible = _React176_useState[1];
  var triggerRef = React176.useRef(null);
  var track = useEgClickstream14();
  var getTargets = useRefContext5().getTargets;
  var dialogPostix = useDialogId12();
  var dialogId = "dateless-price-".concat(dialogPostix);
  var _useDialog22 = _sliced_to_array(useDialog22(dialogId), 3),
    isDialogOpen = _useDialog22[0],
    dialogActions = _useDialog22[1],
    DialogComponent = _useDialog22[2];
  var _useContext7 = _sliced_to_array(useContext7(PropertyDetailsAdaptExContext5), 1),
    adaptExState = _useContext7[0];
  var amenitiesAdaptExSuccessEvents = adaptExState.amenitiesAdaptExSuccessEvents;
  var adaptExSuccessEvents = amenitiesAdaptExSuccessEvents !== null && amenitiesAdaptExSuccessEvents !== void 0 ? amenitiesAdaptExSuccessEvents : [];
  var nameHideSection = hideSectionRef || HIDE_STICKY_TARGET_SECTION;
  var hideTargetRef = (refTargets === null || refTargets === void 0 ? void 0 : refTargets[nameHideSection]) || getTargets([nameHideSection])[nameHideSection] || {
    current: null
  };
  var targetList = [{
    id: nameHideSection,
    ref: hideTargetRef
  }];
  var threshold = (hideTargetRef === null || hideTargetRef === void 0 ? void 0 : hideTargetRef.current) && typeof window !== "undefined" && hideTargetRef.current.clientHeight > window.innerHeight ? window.innerHeight * 0.4 / hideTargetRef.current.clientHeight : 0;
  var onVisibilityChange = React176.useCallback(function (visibilityEvents) {
    var targetVisible = false;
    Object.keys(visibilityEvents).forEach(function (sectionName) {
      targetVisible = sectionName === nameHideSection && visibilityEvents[sectionName] === VisibilityEventType.PARTIAL_TOP || visibilityEvents[sectionName] === VisibilityEventType.PARTIAL_BOTTOM || visibilityEvents[sectionName] === VisibilityEventType.ENTER_COMPLETE;
    });
    setStickyVisible(!targetVisible);
  }, [nameHideSection]);
  useVisibility(targetList, onVisibilityChange, {
    thresholds: [threshold]
  });
  React176.useEffect(function () {
    track(clickstreamPresentedEventBuilder("sticky_bar" /* STICKY_BOOKBAR */, "Product Details" /* PRODUCT_DETAILS */, "PDP" /* PDP */));
  }, []);
  if (!(stickyBar === null || stickyBar === void 0 ? void 0 : (_stickyBar_stickyButton = stickyBar.stickyButton) === null || _stickyBar_stickyButton === void 0 ? void 0 : _stickyBar_stickyButton.text) || soldOut) {
    return null;
  }
  var subText = stickyBar.subText,
    price = stickyBar.price,
    structuredData = stickyBar.structuredData,
    propertyPrice = stickyBar.propertyPrice,
    pricePresentation = stickyBar.pricePresentation,
    pricePresentationDialog = stickyBar.pricePresentationDialog;
  var _ref = price || {},
    formattedDisplayPrice = _ref.formattedDisplayPrice,
    priceDisclaimer = _ref.priceDisclaimer;
  var priceAvailable = formattedDisplayPrice || subText || propertyPrice;
  var shouldShowPropertyStickyBookBarPricePresentationDialog = function (listingsArray) {
    return !(!listingsArray || listingsArray.length > 1);
  };
  var priceComponent = /* @__PURE__ */React176.createElement(React176.Fragment, null, !hidePrice && /* @__PURE__ */React176.createElement(StickyPriceSummary, {
    data: stickyBar,
    wrapLeadPriceQualifier: false,
    dialogId: dialogId,
    align: align,
    justifyContent: priceSummaryJustifyContent,
    triggerRef: triggerRef
  }, singleUnitOfferDialog && !pricePresentation && !pricePresentationDialog && /* @__PURE__ */React176.createElement(PropertySingleOfferDialogLink, {
    data: data
  }, children), pricePresentation && pricePresentationDialog && shouldShowPropertyStickyBookBarPricePresentationDialog(categorizedListings) && /* @__PURE__ */React176.createElement(PropertyStickyBookBarPricePresentationDialog, {
    data: stickyBar
  })), /* @__PURE__ */React176.createElement(EGDSLayoutFlexItem28, null, (stickyVisible || !isSticky) && !hideCtaButton && /* @__PURE__ */React176.createElement(StickyCta, {
    data: data,
    isFullWidth: !priceAvailable || hidePrice,
    clickTargetRef: clickTargetRef,
    focusTargetRef: focusTargetRef,
    scrollSectionRef: scrollSectionRef
  })));
  var stickyCard = /* @__PURE__ */React176.createElement(EGDSSpacing90, {
    padding: {
      small: {
        block: "three",
        inline: "three"
      },
      large: {
        block: "two",
        inline: "three"
      }
    },
    className: "elevation-24"
  }, /* @__PURE__ */React176.createElement("div", null, /* @__PURE__ */React176.createElement(EGDSLayoutFlex36, {
    justifyContent: "space-between",
    wrap: "nowrap",
    alignItems: "center",
    space: "two"
  }, priceComponent)));
  return /* @__PURE__ */React176.createElement(AdaptExEventsProvider3, {
    value: {
      adaptExSuccessEvents: adaptExSuccessEvents
    }
  }, isSticky ? /* @__PURE__ */React176.createElement(Viewport23, null, /* @__PURE__ */React176.createElement(ViewSmall22, null, /* @__PURE__ */React176.createElement(EGDSSheetTransition19, {
    isVisible: stickyVisible
  }, /* @__PURE__ */React176.createElement(EGDSSheet15, {
    isVisible: stickyVisible,
    triggerRef: null
  }, stickyCard))), /* @__PURE__ */React176.createElement(ViewMedium18, null, /* @__PURE__ */React176.createElement(React176.Fragment, null, priceAvailable && /* @__PURE__ */React176.createElement(EGDSSheetTransition19, {
    isVisible: stickyVisible
  }, /* @__PURE__ */React176.createElement(EGDSSheet15, {
    isVisible: stickyVisible,
    triggerRef: null
  }, stickyCard)))), /* @__PURE__ */React176.createElement(ViewLarge7, null, /* @__PURE__ */React176.createElement(React176.Fragment, null, stickyVisible && /* @__PURE__ */React176.createElement(StickyCta, {
    data: data,
    isFullWidth: false,
    clickTargetRef: clickTargetRef,
    focusTargetRef: focusTargetRef,
    scrollSectionRef: scrollSectionRef
  })))) : /* @__PURE__ */React176.createElement(React176.Fragment, null, (structuredData === null || structuredData === void 0 ? void 0 : structuredData.content) && /* @__PURE__ */React176.createElement(React176.Fragment, null, /* @__PURE__ */React176.createElement("meta", {
    itemProp: structuredData.itemprop,
    content: structuredData.content
  }), /* @__PURE__ */React176.createElement(StickyBarStructuredData, {
    content: structuredData.content
  })), /* @__PURE__ */React176.createElement(EGDSLayoutFlex36, {
    wrap: "nowrap",
    direction: "column",
    alignItems: align,
    space: "two"
  }, priceComponent), (priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : priceDisclaimer.content) && /* @__PURE__ */React176.createElement(EGDSSheetTransition19, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React176.createElement(DialogComponent, null, /* @__PURE__ */React176.createElement(EGDSDialog3, {
    returnFocusOnClose: true,
    dialogShow: isDialogOpen,
    triggerRef: triggerRef
  }, /* @__PURE__ */React176.createElement(EGDSDialogContent9, null, priceDisclaimer.content, /* @__PURE__ */React176.createElement(EGDSDialogFooter3, {
    buttonOne: {
      onClick: dialogActions.closeDialog,
      text: ((_priceDisclaimer_primaryUIButton = priceDisclaimer.primaryUIButton) === null || _priceDisclaimer_primaryUIButton === void 0 ? void 0 : _priceDisclaimer_primaryUIButton.primary) || "",
      type: "tertiary"
    }
  })))))));
};
PropertyStickyBookBar.displayName = "PropertyStickyBookBar";
PropertyStickyBookBar.fragment = fragment78;
// src/components/property-sticky-price-header/property-sticky-price-header.tsx
import React177, { useContext as useContext8 } from "react";
import { gql as gql127 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex37, EGDSLayoutFlexItem as EGDSLayoutFlexItem29 } from "@egds/react-core/layout-flex";
import { AdaptExEventsProvider as AdaptExEventsProvider4, useDialogId as useDialogId13 } from "@shared-ui/lodging-fragments";
import { PropertyDetailsAdaptExContext as PropertyDetailsAdaptExContext6 } from "@shared-ui/lodging-property-details";
var fragment79 = gql127(_templateObject129(), StickyCta.fragment, StickyPriceSummary.fragment);
var PropertyStickyPriceHeader = function (param) {
  var _param_align = param.align,
    align = _param_align === void 0 ? "end" : _param_align,
    hideCtaButton = param.hideCtaButton,
    hidePrice = param.hidePrice,
    wrapPriceSummary = param.wrapPriceSummary,
    clickTargetRef = param.clickTargetRef,
    focusTargetRef = param.focusTargetRef,
    scrollSectionRef = param.scrollSectionRef,
    data = param.data;
  var _data_singleUnitOfferDialog;
  var stickyBar = data.stickyBar,
    soldOut = data.soldOut;
  var dialogPostfix = useDialogId13();
  var dialogId = "dateless-price-".concat(dialogPostfix);
  var isSingleUnitOffer = (_data_singleUnitOfferDialog = data.singleUnitOfferDialog) === null || _data_singleUnitOfferDialog === void 0 ? void 0 : _data_singleUnitOfferDialog.content;
  var _useContext8 = _sliced_to_array(useContext8(PropertyDetailsAdaptExContext6), 1),
    adaptExState = _useContext8[0];
  var amenitiesAdaptExSuccessEvents = adaptExState.amenitiesAdaptExSuccessEvents;
  var adaptExSuccessEvents = amenitiesAdaptExSuccessEvents !== null && amenitiesAdaptExSuccessEvents !== void 0 ? amenitiesAdaptExSuccessEvents : [];
  if (soldOut || !stickyBar || isSingleUnitOffer) {
    return null;
  }
  return /* @__PURE__ */React177.createElement(AdaptExEventsProvider4, {
    value: {
      adaptExSuccessEvents: adaptExSuccessEvents
    }
  }, /* @__PURE__ */React177.createElement(EGDSLayoutFlex37, {
    justifyContent: "space-between",
    space: "three",
    wrap: "nowrap",
    alignItems: "center"
  }, !hidePrice && /* @__PURE__ */React177.createElement(EGDSLayoutFlexItem29, null, /* @__PURE__ */React177.createElement(StickyPriceSummary, {
    data: stickyBar,
    wrapLeadPriceQualifier: !!wrapPriceSummary,
    dialogId: dialogId,
    align: align,
    justifyContent: "end"
  })), !hideCtaButton && /* @__PURE__ */React177.createElement(EGDSLayoutFlexItem29, null, /* @__PURE__ */React177.createElement(StickyCta, {
    data: data,
    isFullWidth: false,
    clickTargetRef: clickTargetRef,
    focusTargetRef: focusTargetRef,
    scrollSectionRef: scrollSectionRef
  }))));
};
PropertyStickyPriceHeader.displayName = "PropertyStickyPriceHeader";
PropertyStickyPriceHeader.fragment = fragment79;
// src/components/property-trip-summary/property-trip-summary.tsx
import React179 from "react";
import { gql as gql129 } from "@apollo/client";
// src/components/property-trip-summary/__private/__fragments/trip-summary.tsx
import React178 from "react";
import { gql as gql128 } from "@apollo/client";
import { EGDSCard as EGDSCard29, EGDSCardContentSection as EGDSCardContentSection20 } from "@egds/react-core/cards";
import { EGDSDialog as EGDSDialog4, EGDSDialogContent as EGDSDialogContent10, EGDSDialogFooter as EGDSDialogFooter4 } from "@egds/react-core/dialog";
import { EGDSLayoutFlex as EGDSLayoutFlex38 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid23, EGDSLayoutGridItem as EGDSLayoutGridItem20 } from "@egds/react-core/layout-grid";
import { UitkPriceLockup as EGDSPriceLockup2, UitkPriceLockupAlign as EGDSPriceLockupAlign5 } from "@egds/react-core/price-lockup";
import { EGDSSheetTransition as EGDSSheetTransition20 } from "@egds/react-core/sheet";
import { EGDSHeading as EGDSHeading29, EGDSText as EGDSText45 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker40 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog23 } from "@shared-ui/dialog-context";
import { buildEGDSPriceLockupProps as buildEGDSPriceLockupProps2, EGDSStandardMessage, PriceHeaderDialog } from "@shared-ui/lodging-fragments";
import { InstallmentPlan } from "@shared-ui/retail-multi-item-installment-plan";
var fragment80 = gql128(_templateObject130(), PriceHeaderDialog.fragment, EGDSStandardMessage.fragment);
var gridColumns = {
  medium: ["2fr", "1fr"]
};
var TripSummary = function (param) {
  var className = param.className,
    showBorder = param.showBorder,
    data = param.data;
  var _data_price, _priceDisclaimer_trigger, _priceDisclaimer_tertiaryUIButton_action, _priceDisclaimer_tertiaryUIButton, _priceDisclaimer_tertiaryUIButton1, _priceDisclaimer_trigger1, _data_installmentPlanOptions, _data_installmentPlanOptions1;
  var _useDialog23 = _sliced_to_array(useDialog23("TripSummaryStrikeThroughDisclaimer"), 3),
    isDialogOpen = _useDialog23[0],
    dialogActions = _useDialog23[1],
    DialogComponent = _useDialog23[2];
  var clickTracker = useClickTracker40();
  var triggerRef = React178.useRef(null);
  if (!((_data_price = data.price) === null || _data_price === void 0 ? void 0 : _data_price.options) || data.price.options.length === 0) {
    return null;
  }
  var _data_price1 = data.price,
    priceMessaging = _data_price1.priceMessaging,
    options = _data_price1.options;
  var priceOption = options === null || options === void 0 ? void 0 : options[0];
  var priceDisclaimer = priceOption === null || priceOption === void 0 ? void 0 : priceOption.priceDisclaimer;
  var openAnalytics = priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_trigger = priceDisclaimer.trigger) === null || _priceDisclaimer_trigger === void 0 ? void 0 : _priceDisclaimer_trigger.clientSideAnalytics;
  var closeAnalytics = priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_tertiaryUIButton = priceDisclaimer.tertiaryUIButton) === null || _priceDisclaimer_tertiaryUIButton === void 0 ? void 0 : (_priceDisclaimer_tertiaryUIButton_action = _priceDisclaimer_tertiaryUIButton.action) === null || _priceDisclaimer_tertiaryUIButton_action === void 0 ? void 0 : _priceDisclaimer_tertiaryUIButton_action.analytics;
  var closeButtonText = priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_tertiaryUIButton1 = priceDisclaimer.tertiaryUIButton) === null || _priceDisclaimer_tertiaryUIButton1 === void 0 ? void 0 : _priceDisclaimer_tertiaryUIButton1.primary;
  var _priceMessaging_map;
  var priceMessages = (_priceMessaging_map = priceMessaging === null || priceMessaging === void 0 ? void 0 : priceMessaging.map(function (message) {
    return message.value;
  })) !== null && _priceMessaging_map !== void 0 ? _priceMessaging_map : [];
  var dialogMessage = priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : priceDisclaimer.content;
  var tripSummaryHeaderBanner = data === null || data === void 0 ? void 0 : data.tripSummaryHeaderBanner;
  var openStrikeThroughPriceDialog = function () {
    dialogActions.openDialog();
    if (openAnalytics) {
      clickTracker(openAnalytics.referrerId, openAnalytics.linkName);
    }
  };
  var closeStrikeThroughPriceDialog = function () {
    dialogActions.closeDialog();
    if (closeAnalytics) {
      clickTracker(closeAnalytics.referrerId, closeAnalytics.linkName);
    }
  };
  var priceProps = buildEGDSPriceLockupProps2(options);
  var priceHeaderOption = options.find(function (opt) {
    return opt.priceHeaderDialog;
  });
  return /* @__PURE__ */React178.createElement(EGDSCard29, {
    className: className,
    border: showBorder
  }, /* @__PURE__ */React178.createElement(EGDSCardContentSection20, {
    padded: true
  }, tripSummaryHeaderBanner && /* @__PURE__ */React178.createElement(EGDSLayoutGrid23, null, /* @__PURE__ */React178.createElement(EGDSLayoutGridItem20, null, /* @__PURE__ */React178.createElement("div", null, /* @__PURE__ */React178.createElement(EGDSStandardMessage, {
    data: tripSummaryHeaderBanner
  })))), /* @__PURE__ */React178.createElement(EGDSLayoutGrid23, {
    columns: gridColumns
  }, /* @__PURE__ */React178.createElement(EGDSLayoutGridItem20, null, /* @__PURE__ */React178.createElement("div", null, /* @__PURE__ */React178.createElement(EGDSHeading29, {
    tag: "h3",
    size: 7
  }, data.header.text), data.summary.map(function (param, index) {
    var value = param.value;
    return /* @__PURE__ */React178.createElement(EGDSText45, {
      size: 300,
      theme: "standard",
      key: "trip-summary-secondary-".concat(index)
    }, value);
  }))), /* @__PURE__ */React178.createElement(EGDSLayoutGridItem20, null, /* @__PURE__ */React178.createElement("div", null, priceHeaderOption && /* @__PURE__ */React178.createElement(PriceHeaderDialog, {
    data: priceHeaderOption,
    direction: "row-reverse",
    justifyContent: "start"
  }), /* @__PURE__ */React178.createElement(EGDSPriceLockup2, _object_spread_props(_object_spread({}, priceProps), {
    align: EGDSPriceLockupAlign5.RIGHT,
    priceSubtextFirst: priceMessages,
    a11yStrikeThroughDialogTrigger: priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_trigger1 = priceDisclaimer.trigger) === null || _priceDisclaimer_trigger1 === void 0 ? void 0 : _priceDisclaimer_trigger1.value,
    strikeThroughTrigger: dialogMessage && /* @__PURE__ */React178.createElement("button", {
      onClick: openStrikeThroughPriceDialog,
      type: "button",
      ref: triggerRef
    })
  })), /* @__PURE__ */React178.createElement(EGDSSheetTransition20, {
    isVisible: isDialogOpen,
    closeCallback: dialogActions.closeDialog
  }, /* @__PURE__ */React178.createElement(DialogComponent, null, /* @__PURE__ */React178.createElement(EGDSDialog4, {
    dialogShow: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef: triggerRef
  }, dialogMessage && /* @__PURE__ */React178.createElement(EGDSDialogContent10, null, dialogMessage.map(function (msg, index) {
    return /* @__PURE__ */React178.createElement("div", {
      key: "dialog-message-content-".concat(index)
    }, msg);
  }), closeButtonText && /* @__PURE__ */React178.createElement(EGDSDialogFooter4, {
    buttonOne: {
      onClick: closeStrikeThroughPriceDialog,
      text: closeButtonText,
      type: "tertiary"
    }
  }))))), data.installmentPlanOptions && /* @__PURE__ */React178.createElement(EGDSLayoutFlex38, {
    justifyContent: "end",
    "data-stid": "property-offer-installment-plan"
  }, /* @__PURE__ */React178.createElement(InstallmentPlan, {
    inputs: {
      multiItemSessionId: null,
      amount: (_data_installmentPlanOptions = data.installmentPlanOptions) === null || _data_installmentPlanOptions === void 0 ? void 0 : _data_installmentPlanOptions.totalPrice
    },
    alignment: "end",
    legalText: (_data_installmentPlanOptions1 = data.installmentPlanOptions) === null || _data_installmentPlanOptions1 === void 0 ? void 0 : _data_installmentPlanOptions1.textRequired
  })))))));
};
TripSummary.displayName = "TripSummary";
TripSummary.fragment = fragment80;
// src/components/property-trip-summary/property-trip-summary.tsx
var __PropertyTripSummaryFragment = gql129(_templateObject131(), TripSummary.fragment);
var PropertyTripSummary = function (param) {
  var className = param.className,
    showBorder = param.showBorder,
    data = param.data;
  var tripSummary = data.tripSummary;
  if (!tripSummary) {
    return null;
  }
  return /* @__PURE__ */React179.createElement(TripSummary, {
    className: className,
    data: tripSummary,
    showBorder: showBorder
  });
};
PropertyTripSummary.fragment = __PropertyTripSummaryFragment;
PropertyTripSummary.displayName = "PropertyTripSummary";
// src/components/single-offer-search/single-offer-search.tsx
import React180 from "react";
import { gql as gql130 } from "@apollo/client";
import { useLocalization as useLocalization2 } from "@shared-ui/localization-context";
var __SingleOfferSearchFragment = gql130(_templateObject132());
var SingleOfferSearchDateField = function (param) {
  var data = param.data,
    doneKey = param.doneKey,
    submitKey = param.submitKey,
    DateFieldWrapper = param.DateFieldWrapper;
  var formatText = useLocalization2().formatText;
  var l10nKey = shouldShowFormButton(data) ? doneKey : submitKey;
  return /* @__PURE__ */React180.createElement(DateFieldWrapper, {
    buttonText: formatText(l10nKey),
    closeOnSubmit: false
  });
};
SingleOfferSearchDateField.displayName = "SingleOfferSearchDateField";
SingleOfferSearchDateField.fragment = __SingleOfferSearchFragment;
var SingleOfferSearchButton2 = function (param) {
  var data = param.data,
    ButtonWrapper2 = param.ButtonWrapper;
  var _data_errorMessage_action_primary, _data_errorMessage_action, _data_errorMessage;
  if (!shouldShowFormButton(data)) {
    return null;
  }
  var locText = (_data_errorMessage = data.errorMessage) === null || _data_errorMessage === void 0 ? void 0 : (_data_errorMessage_action = _data_errorMessage.action) === null || _data_errorMessage_action === void 0 ? void 0 : (_data_errorMessage_action_primary = _data_errorMessage_action.primary) === null || _data_errorMessage_action_primary === void 0 ? void 0 : _data_errorMessage_action_primary.text;
  return locText ? /* @__PURE__ */React180.createElement("div", null, /* @__PURE__ */React180.createElement(ButtonWrapper2, {
    text: locText
  })) : null;
};
SingleOfferSearchButton2.displayName = "SingleOfferSearchButton";
SingleOfferSearchButton2.fragment = __SingleOfferSearchFragment;
function shouldShowFormButton(data) {
  var _errorMessage_title;
  var errorMessage = data.errorMessage,
    searchCriteria = data.searchCriteria,
    singleUnitOffer = data.singleUnitOffer;
  return Boolean((searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.primary.dateRange) || (errorMessage === null || errorMessage === void 0 ? void 0 : (_errorMessage_title = errorMessage.title) === null || _errorMessage_title === void 0 ? void 0 : _errorMessage_title.text) && !hasActionUrl(errorMessage) && hasActionText(errorMessage) || !(singleUnitOffer === null || singleUnitOffer === void 0 ? void 0 : singleUnitOffer.ratePlans));
}
function hasActionUrl(errorMessage) {
  var _errorMessage_action_primary, _errorMessage_action;
  return Boolean(errorMessage === null || errorMessage === void 0 ? void 0 : (_errorMessage_action = errorMessage.action) === null || _errorMessage_action === void 0 ? void 0 : (_errorMessage_action_primary = _errorMessage_action.primary) === null || _errorMessage_action_primary === void 0 ? void 0 : _errorMessage_action_primary.linkUrl);
}
function hasActionText(errorMessage) {
  var _errorMessage_action_primary, _errorMessage_action;
  return Boolean(errorMessage === null || errorMessage === void 0 ? void 0 : (_errorMessage_action = errorMessage.action) === null || _errorMessage_action === void 0 ? void 0 : (_errorMessage_action_primary = _errorMessage_action.primary) === null || _errorMessage_action_primary === void 0 ? void 0 : _errorMessage_action_primary.text);
}
// src/components/traveler-selector/traveler-selector.tsx
import React186 from "react";
import { gql as gql135 } from "@apollo/client";
// src/components/traveler-selector/__private/egds-search-form-travelers-field.tsx
import React185, { useRef as useRef4 } from "react";
import { gql as gql134 } from "@apollo/client";
import isEqual from "lodash.isequal";
import { EGDSFakeInput } from "@egds/react-core/input";
import { EGDSLayoutPosition as EGDSLayoutPosition6 } from "@egds/react-core/layout-position";
import { EGDSSheet as EGDSSheet16, EGDSSheetContent as EGDSSheetContent10, EGDSSheetTransition as EGDSSheetTransition21 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing94 } from "@egds/react-core/spacing";
import { EGDSToolbar as EGDSToolbar14 } from "@egds/react-core/toolbar";
import { useDialog as useDialog24 } from "@shared-ui/dialog-context";
import { ViewLarge as ViewLarge8, ViewMedium as ViewMedium19, Viewport as Viewport24, ViewSmall as ViewSmall23 } from "@shared-ui/viewport-context";
// src/components/traveler-selector/__private/utils/traveler-action-context.tsx
import React181 from "react";
var DEFAULT_SA_CHILD_AGE = 0;
var roomPickerReducer = function (state, action) {
  switch (action.type) {
    case "UPDATE_ADULTS_COUNT":
      {
        var count = action.count;
        return _object_spread_props(_object_spread({}, state), {
          adults: count
        });
      }
    case "UPDATE_CHILDREN_COUNT":
      {
        var _state_children, _state_children1, _state_children2;
        var count1 = action.count;
        var childrenAdded = count1 > (((_state_children = state.children) === null || _state_children === void 0 ? void 0 : _state_children.length) || 0);
        return _object_spread_props(_object_spread({}, state), {
          children: childrenAdded ? ((_state_children1 = state.children) === null || _state_children1 === void 0 ? void 0 : _state_children1.concat([{
            age: DEFAULT_SA_CHILD_AGE
          }])) || [{
            age: DEFAULT_SA_CHILD_AGE
          }] : (_state_children2 = state.children) === null || _state_children2 === void 0 ? void 0 : _state_children2.slice(0, -1)
        });
      }
    case "UPDATE_CHILD_AGE":
      {
        var _state_children3;
        var childIndex = action.childIndex,
          childAge = action.childAge;
        return _object_spread_props(_object_spread({}, state), {
          children: (_state_children3 = state.children) === null || _state_children3 === void 0 ? void 0 : _state_children3.map(function (child, index) {
            return childIndex === index ? {
              age: childAge
            } : child;
          })
        });
      }
    case "INCLUDE_PETS":
      {
        return _object_spread_props(_object_spread({}, state), {
          petsIncluded: true
        });
      }
    case "EXCLUDE_PETS":
      {
        return _object_spread_props(_object_spread({}, state), {
          petsIncluded: false
        });
      }
    case "RESET_STATE":
      {
        return action.payload;
      }
    default:
      return state;
  }
};
var TravelerContext = React181.createContext(function () {
  return void 0;
});
var useTravelerAction = function () {
  return React181.useContext(TravelerContext);
};
var TravelerActionProvider = TravelerContext.Provider;
// src/components/traveler-selector/__private/utils/traveler-selector-utils.ts
var getPluralCategory = function (value) {
  if (value === 0) {
    return "ZERO" /* ZERO */;
  }
  if (value === 1) {
    return "ONE" /* ONE */;
  }
  if (value === 2) {
    return "TWO" /* TWO */;
  }
  if (value > 2 && value < 5) {
    return "FEW" /* FEW */;
  }
  if (value >= 5 && value < 10) {
    return "MANY" /* MANY */;
  }
  return "OTHER" /* OTHER */;
};
function formatLocalizedTokenString(localizedString, token, value) {
  return localizedString.replace("${".concat(token, "}"), value);
}
var formatCardinalText = function (cardinalText, value) {
  var useSecondaryTemplates = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var _cardinalText_templateKey;
  var templateKey = useSecondaryTemplates ? "secondaryTemplates" : "templates";
  var cardinalTemplate = (_cardinalText_templateKey = cardinalText[templateKey]) === null || _cardinalText_templateKey === void 0 ? void 0 : _cardinalText_templateKey.find(function (template) {
    return template.category === getPluralCategory(value);
  });
  if (!cardinalTemplate || !cardinalText.models[0]) {
    return "";
  }
  return formatLocalizedTokenString(cardinalTemplate.template, cardinalText.models[0].key, value.toString());
};
// src/components/traveler-selector/__private/egds-open-traveler-selector-action.tsx
import React184 from "react";
import { gql as gql133 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing93 } from "@egds/react-core/spacing";
// src/components/traveler-selector/__private/egds-basic-traveler-selector.tsx
import React183 from "react";
import { gql as gql132 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing92 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading30 } from "@egds/react-core/text";
import { LodgingEGDSButton as LodgingEGDSButton2 } from "@shared-ui/lodging-fragments";
// src/components/traveler-selector/__private/egds-travelers.tsx
import React182 from "react";
import { gql as gql131 } from "@apollo/client";
import { EGDSLayoutGrid as EGDSLayoutGrid24 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing91 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker41 } from "@shared-ui/clickstream-analytics-context";
import { EGDSBasicCheckBox, EGDSTravelerChildAgeSelect, EGDSTravelerStepInput } from "@shared-ui/lodging-fragments";
var __EGDSTravelersFragment = gql131(_templateObject133(), EGDSTravelerStepInput.fragment, EGDSTravelerChildAgeSelect.fragment, EGDSBasicCheckBox.fragment);
var INCLUDE_PETS = "INCLUDE_PETS";
var EXCLUDE_PETS = "EXCLUDE_PETS";
var MAX_TRAVELERS = 14;
var EGDSTravelers = function (param) {
  var data = param.data,
    state = param.state,
    maxGuests = param.maxGuests;
  var _state_children, _state_children1, _state_children2, _state_children3, _state_children4, _state_children5;
  var track = useClickTracker41();
  var dispatch = useTravelerAction();
  var _React182_useState = _sliced_to_array(React182.useState(state.petsIncluded ? "CHECKED" /* CHECKED */ : "UNCHECKED" /* UNCHECKED */), 2),
    checked = _React182_useState[0],
    setChecked = _React182_useState[1];
  var adults = data.adults,
    children = data.children,
    pets = data.pets;
  var buildOnChange = function (event, type) {
    var actionType = type === "adults" /* ADULTS */ ? "UPDATE_ADULTS_COUNT" : "UPDATE_CHILDREN_COUNT";
    var count = parseInt(event.target.value, 10);
    if (!Number.isNaN(count)) {
      dispatch({
        type: actionType,
        count: count
      });
    }
  };
  var onSelectChange = function (event, childIndex) {
    var age = parseInt(event.target.value, 10);
    if (!Number.isNaN(age)) {
      dispatch({
        type: "UPDATE_CHILD_AGE",
        childIndex: childIndex,
        childAge: age
      });
    }
    track("HOT.HIS:ROOM.Child.".concat(childIndex, ".AGE.").concat(age), "Child age update");
  };
  var handleCheckboxChange = React182.useCallback(function (event) {
    var eventTarget = event.target.checked;
    var petsIncluded = eventTarget ? INCLUDE_PETS : EXCLUDE_PETS;
    setChecked(eventTarget ? "CHECKED" /* CHECKED */ : "UNCHECKED" /* UNCHECKED */);
    dispatch({
      type: petsIncluded
    });
    track("HOT.HIS.TravelersField.".concat(petsIncluded), "Travelers Field ".concat(petsIncluded));
  }, []);
  var totalTravelers = state.adults + (((_state_children = state.children) === null || _state_children === void 0 ? void 0 : _state_children.length) || 0);
  var maxChildren = (children === null || children === void 0 ? void 0 : children.count.max) || 0;
  var defaultMaxChild = (((_state_children1 = state.children) === null || _state_children1 === void 0 ? void 0 : _state_children1.length) || 0) + MAX_TRAVELERS - totalTravelers;
  var _adults_max;
  var adultMax = totalTravelers < maxGuests ? (_adults_max = adults.max) !== null && _adults_max !== void 0 ? _adults_max : MAX_TRAVELERS : state.adults;
  var childMax = totalTravelers < maxGuests ? maxChildren !== null && maxChildren !== void 0 ? maxChildren : defaultMaxChild : ((_state_children2 = state.children) === null || _state_children2 === void 0 ? void 0 : _state_children2.length) || 0;
  var _state_children_length, _state_petsIncluded;
  return /* @__PURE__ */React182.createElement(React182.Fragment, null, adults.__typename === "EGDSTravelerStepInput" && /* @__PURE__ */React182.createElement(EGDSTravelerStepInput, {
    data: adults,
    onChange: buildOnChange,
    value: state.adults,
    customMax: adultMax,
    travelerType: "adults" /* ADULTS */
  }), (children === null || children === void 0 ? void 0 : children.__typename) === "EGDSTravelerChildren" && /* @__PURE__ */React182.createElement(React182.Fragment, null, children.count.__typename === "EGDSTravelerStepInput" && /* @__PURE__ */React182.createElement(EGDSTravelerStepInput, {
    data: children.count,
    onChange: buildOnChange,
    value: (_state_children_length = (_state_children3 = state.children) === null || _state_children3 === void 0 ? void 0 : _state_children3.length) !== null && _state_children_length !== void 0 ? _state_children_length : 0,
    customMax: childMax,
    travelerType: "children" /* CHILDREN */
  }), state.children && ((_state_children4 = state.children) === null || _state_children4 === void 0 ? void 0 : _state_children4.length) > 0 && /* @__PURE__ */React182.createElement(EGDSLayoutGrid24, {
    space: "two",
    columns: 2
  }, (_state_children5 = state.children) === null || _state_children5 === void 0 ? void 0 : _state_children5.map(function (param, childIndex) {
    var age = param.age;
    var child = children.ages[childIndex];
    return (child === null || child === void 0 ? void 0 : child.__typename) === "EGDSTravelerChildAgeSelect" && /* @__PURE__ */React182.createElement(EGDSTravelerChildAgeSelect, {
      data: child,
      customValue: age.toString(),
      name: "child-".concat(childIndex),
      childIndex: childIndex,
      onSelect: onSelectChange
    });
  }))), pets && /* @__PURE__ */React182.createElement(EGDSSpacing91, {
    padding: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React182.createElement("div", null, pets.__typename === "EGDSBasicCheckBox" && /* @__PURE__ */React182.createElement(EGDSBasicCheckBox, {
    data: pets,
    isChecked: (_state_petsIncluded = state.petsIncluded) !== null && _state_petsIncluded !== void 0 ? _state_petsIncluded : false,
    handleCheckboxChange: handleCheckboxChange
  }))));
};
EGDSTravelers.displayName = "EGDSTravelers";
EGDSTravelers.fragment = __EGDSTravelersFragment;
// src/components/traveler-selector/__private/egds-basic-traveler-selector.tsx
var __EGDSBasicTravelerSelectorFragment = gql132(_templateObject134(), LodgingEGDSButton2.fragment, EGDSTravelers.fragment);
var MAX_TRAVELERS2 = 14;
var EGDSBasicTravelerSelector = function (param) {
  var data = param.data,
    state = param.state,
    handleSubmit = param.handleSubmit;
  var doneButton = data.doneButton,
    travelers = data.travelers,
    title = data.title,
    validations = data.validations;
  var errors = validations === null || validations === void 0 ? void 0 : validations.map(function (validation) {
    if (validation.__typename === "EGDSTravelersInputValidation") {
      var maxCount = validation.maxCount;
      var validationErrors = _define_property({}, "MAX_TRAVELERS" /* MAX_TRAVELERS */, maxCount);
      return validationErrors["MAX_TRAVELERS" /* MAX_TRAVELERS */];
    }
    return null;
  });
  var _errors_at;
  var maxGuests = errors && errors.length !== 1 ? MAX_TRAVELERS2 : (_errors_at = errors === null || errors === void 0 ? void 0 : errors.at(0)) !== null && _errors_at !== void 0 ? _errors_at : MAX_TRAVELERS2;
  if (!travelers) {
    return null;
  }
  return /* @__PURE__ */React183.createElement(React183.Fragment, null, title !== "" && /* @__PURE__ */React183.createElement(EGDSHeading30, {
    size: 5
  }, title), /* @__PURE__ */React183.createElement(EGDSTravelers, {
    data: travelers,
    state: state,
    maxGuests: maxGuests
  }), /* @__PURE__ */React183.createElement(EGDSSpacing92, {
    padding: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React183.createElement("div", null, /* @__PURE__ */React183.createElement(LodgingEGDSButton2, {
    data: doneButton,
    isFullWidth: true,
    onClick: handleSubmit
  }))));
};
EGDSBasicTravelerSelector.displayName = "EGDSBasicTravelerSelector";
EGDSBasicTravelerSelector.fragment = __EGDSBasicTravelerSelectorFragment;
// src/components/traveler-selector/__private/egds-open-traveler-selector-action.tsx
var __EGDSOpenTravelerSelectorActionFragment = gql133(_templateObject135(), EGDSBasicTravelerSelector.fragment);
var EGDSOpenTravelerSelectorAction = function (param) {
  var data = param.data,
    state = param.state,
    handleSubmit = param.handleSubmit;
  var travelerSelector = data.travelerSelector;
  if (!data || !travelerSelector || travelerSelector.__typename !== "EGDSBasicTravelerSelector") {
    return null;
  }
  return /* @__PURE__ */React184.createElement("section", null, /* @__PURE__ */React184.createElement(EGDSSpacing93, {
    padding: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React184.createElement(EGDSBasicTravelerSelector, {
    data: travelerSelector,
    state: state,
    handleSubmit: handleSubmit
  })));
};
EGDSOpenTravelerSelectorAction.displayName = "EGDSOpenTravelerSelectorAction";
EGDSOpenTravelerSelectorAction.fragment = __EGDSOpenTravelerSelectorActionFragment;
// src/components/traveler-selector/__private/hooks/use-update-url.ts
import { useCallback as useCallback2 } from "react";
import { useHistory as useHistory2 } from "react-router-dom";
var useUpdateURL = function () {
  var history = useHistory2();
  return useCallback2(function (event) {
    var params = new URLSearchParams(history.location.search);
    params.set("adults", String(event.adults));
    params.set("children", String(event.children));
    params.delete("rm1");
    if (event.amenities) {
      params.set("amenities", String(event.amenities));
      params.set("house_rules_group", String(event.house_rules_group));
    } else {
      params.delete("amenities");
      params.delete("house_rules_group");
    }
    history.replace("".concat(history.location.pathname, "?").concat(params));
  }, [history]);
};
// src/components/traveler-selector/__private/egds-search-form-travelers-field.tsx
var __EGDSSearchFormTravelersFieldFragment = gql134(_templateObject136(), EGDSOpenTravelerSelectorAction.fragment);
var DEFAULT_TRAVELERS = {
  adults: 1,
  children: [{
    age: 1
  }],
  petsIncluded: false
};
var TravelerSelectorActionSheetContentSection = function (param) {
  var action = param.action,
    state = param.state,
    handleSubmit = param.handleSubmit;
  return /* @__PURE__ */React185.createElement(EGDSSheetContent10, null, /* @__PURE__ */React185.createElement(EGDSSpacing94, {
    padding: {
      blockstart: "half"
    }
  }, action && action.__typename === "EGDSOpenTravelerSelectorAction" && /* @__PURE__ */React185.createElement("div", null, /* @__PURE__ */React185.createElement(EGDSOpenTravelerSelectorAction, {
    data: action,
    state: state,
    handleSubmit: handleSubmit
  }))));
};
var EGDSSearchFormTravelersField = function (param) {
  var data = param.data,
    triggerRef = param.triggerRef,
    updateStoreWithTravelerUrlData = param.updateStoreWithTravelerUrlData,
    _param_isNestDialog = param.isNestDialog,
    isNestDialog = _param_isNestDialog === void 0 ? false : _param_isNestDialog,
    _param_dialogId = param.dialogId,
    dialogId = _param_dialogId === void 0 ? "full-sheet-traveler-selector" : _param_dialogId,
    initialState = param.initialState;
  var _action_travelerSelector, _travelers_children_ages, _travelers_children, _travelers_pets;
  var nestedDialogKey = isNestDialog ? "pwaDialogNested" : void 0;
  var _useDialog24 = _sliced_to_array(useDialog24(dialogId, nestedDialogKey), 3),
    isDialogOpen = _useDialog24[0],
    dialogActions = _useDialog24[1],
    DialogComponent = _useDialog24[2];
  var action = data.action,
    label = data.label,
    labelTemplate = data.labelTemplate,
    value = data.value;
  var travelers = (action === null || action === void 0 ? void 0 : action.__typename) === "EGDSOpenTravelerSelectorAction" && (action === null || action === void 0 ? void 0 : action.travelerSelector.__typename) === "EGDSBasicTravelerSelector" ? action === null || action === void 0 ? void 0 : (_action_travelerSelector = action.travelerSelector) === null || _action_travelerSelector === void 0 ? void 0 : _action_travelerSelector.travelers : null;
  var formatTravelerSummary = function (room) {
    var _room_children;
    var travelersCount = room.adults + (((_room_children = room.children) === null || _room_children === void 0 ? void 0 : _room_children.length) || 0);
    var isPetsChecked = room.petsIncluded;
    if ((labelTemplate === null || labelTemplate === void 0 ? void 0 : labelTemplate.__typename) === "EGDSCardinalLocalizedText") {
      return formatCardinalText(labelTemplate, travelersCount, isPetsChecked);
    }
    return value;
  };
  var inputValue = function () {
    if (!initialState || !labelTemplate) {
      return value;
    }
    return formatTravelerSummary(initialState);
  };
  var getPetsIncludedFromState = function (state2) {
    return state2 === "CHECKED" /* CHECKED */;
  };
  var initChildren = [];
  travelers === null || travelers === void 0 ? void 0 : (_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : (_travelers_children_ages = _travelers_children.ages) === null || _travelers_children_ages === void 0 ? void 0 : _travelers_children_ages.forEach(function (child) {
    if (child.__typename === "EGDSTravelerChildAgeSelect" && child.value !== null) {
      initChildren.push({
        age: child.value
      });
    }
  });
  var _travelers_adults_value;
  var initialData = (travelers === null || travelers === void 0 ? void 0 : travelers.__typename) === "EGDSTravelers" ? {
    adults: (_travelers_adults_value = travelers === null || travelers === void 0 ? void 0 : travelers.adults.value) !== null && _travelers_adults_value !== void 0 ? _travelers_adults_value : 1,
    children: initChildren,
    petsIncluded: (travelers === null || travelers === void 0 ? void 0 : (_travelers_pets = travelers.pets) === null || _travelers_pets === void 0 ? void 0 : _travelers_pets.__typename) === "EGDSBasicCheckBox" ? getPetsIncludedFromState(travelers.pets.state) : false
  } : DEFAULT_TRAVELERS;
  var _React185_useReducer = _sliced_to_array(React185.useReducer(roomPickerReducer, initialState || initialData), 2),
    state = _React185_useReducer[0],
    dispatch = _React185_useReducer[1];
  var travelerSelectorState = useRef4(state);
  var updateUrl = useUpdateURL();
  var handleSubmit = React185.useCallback(function () {
    var alreadyClosed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var adultCount = state.adults;
    var _state_petsIncluded;
    var isPetsIncluded = (_state_petsIncluded = state.petsIncluded) !== null && _state_petsIncluded !== void 0 ? _state_petsIncluded : false;
    var amenities = isPetsIncluded ? "PETS" : void 0;
    var house_rules_group = isPetsIncluded ? "pets_allowed" : void 0;
    var children = state.children;
    travelerSelectorState.current = state;
    var travelerSelectorPayload = {
      adults: adultCount,
      children: (children === null || children === void 0 ? void 0 : children.map(function (param) {
        var age = param.age;
        return "".concat(1, "_").concat(age);
      })) || [],
      amenities: amenities,
      house_rules_group: house_rules_group,
      isPetsIncluded: isPetsIncluded
    };
    if (!isNestDialog) {
      setTimeout(function () {
        return updateUrl(travelerSelectorPayload);
      }, 50);
    }
    if (!alreadyClosed) {
      dialogActions.closeDialog();
    }
    updateStoreWithTravelerUrlData(travelerSelectorPayload);
  }, [state]);
  var onClose = function () {
    if (!isEqual(travelerSelectorState.current, state)) {
      handleSubmit(true);
      travelerSelectorState.current = state;
    }
  };
  if (!data || !data.action || data.action.__typename !== "EGDSOpenTravelerSelectorAction") {
    return null;
  }
  var _inputValue;
  return /* @__PURE__ */React185.createElement(EGDSLayoutPosition6, {
    type: "relative"
  }, /* @__PURE__ */React185.createElement(EGDSFakeInput, {
    label: label !== null && label !== void 0 ? label : "",
    value: (_inputValue = inputValue()) !== null && _inputValue !== void 0 ? _inputValue : "",
    "data-stid": "open-room-picker",
    onClick: function () {
      return dialogActions.openDialog();
    },
    domRef: triggerRef
  }), /* @__PURE__ */React185.createElement(TravelerActionProvider, {
    value: dispatch
  }, /* @__PURE__ */React185.createElement(Viewport24, null, /* @__PURE__ */React185.createElement(ViewLarge8, null, /* @__PURE__ */React185.createElement(EGDSSheetTransition21, {
    isVisible: isDialogOpen,
    closeCallback: onClose
  }, /* @__PURE__ */React185.createElement(EGDSSheet16, {
    isVisible: isDialogOpen,
    type: "popover",
    triggerRef: triggerRef,
    onDismiss: dialogActions.closeDialog,
    showOverTrigger: true,
    width: 400
  }, /* @__PURE__ */React185.createElement(TravelerSelectorActionSheetContentSection, {
    action: action,
    state: state,
    handleSubmit: function () {
      return handleSubmit(false);
    }
  })))), /* @__PURE__ */React185.createElement(ViewMedium19, null, /* @__PURE__ */React185.createElement(EGDSSheetTransition21, {
    isVisible: isDialogOpen,
    closeCallback: onClose
  }, /* @__PURE__ */React185.createElement(DialogComponent, null, /* @__PURE__ */React185.createElement(EGDSSheet16, {
    isVisible: isDialogOpen,
    type: "centered",
    triggerRef: triggerRef
  }, /* @__PURE__ */React185.createElement(EGDSToolbar14, {
    navigationContent: {
      onClick: function () {
        return dialogActions.closeDialog();
      },
      navIconLabel: "Close"
    }
  }), /* @__PURE__ */React185.createElement(TravelerSelectorActionSheetContentSection, {
    action: action,
    state: state,
    handleSubmit: function () {
      return handleSubmit(false);
    }
  }))))), /* @__PURE__ */React185.createElement(ViewSmall23, null, /* @__PURE__ */React185.createElement(EGDSSheetTransition21, {
    isVisible: isDialogOpen,
    closeCallback: onClose
  }, /* @__PURE__ */React185.createElement(DialogComponent, null, /* @__PURE__ */React185.createElement(EGDSSheet16, {
    isVisible: isDialogOpen,
    type: "full",
    triggerRef: triggerRef
  }, /* @__PURE__ */React185.createElement(EGDSToolbar14, {
    navigationContent: {
      onClick: function () {
        return dialogActions.closeDialog();
      },
      navIconLabel: "Close"
    }
  }), /* @__PURE__ */React185.createElement(TravelerSelectorActionSheetContentSection, {
    action: action,
    state: state,
    handleSubmit: function () {
      return handleSubmit(false);
    }
  }))))))));
};
EGDSSearchFormTravelersField.displayName = "EGDSSearchFormTravelersField";
EGDSSearchFormTravelersField.fragment = __EGDSSearchFormTravelersFieldFragment;
// src/components/traveler-selector/traveler-selector.tsx
var __TravelerSelectorFragment = gql135(_templateObject137(), EGDSSearchFormTravelersField.fragment);
var TravelerSelector2 = function (param) {
  var data = param.data,
    updateStoreWithTravelerUrlData = param.updateStoreWithTravelerUrlData,
    triggerRef = param.triggerRef,
    dialogId = param.dialogId,
    isNestDialog = param.isNestDialog,
    initialState = param.initialState;
  if (!data || !(data === null || data === void 0 ? void 0 : data.travelers)) {
    return null;
  }
  var travelers = data.travelers;
  return /* @__PURE__ */React186.createElement(EGDSSearchFormTravelersField, {
    data: travelers,
    isNestDialog: isNestDialog,
    dialogId: dialogId,
    triggerRef: triggerRef,
    initialState: initialState,
    updateStoreWithTravelerUrlData: updateStoreWithTravelerUrlData
  });
};
TravelerSelector2.displayName = "TravelerSelector";
TravelerSelector2.fragment = __TravelerSelectorFragment;
// src/components/units-carousel/placeholder.tsx
import React187 from "react";
import { EGDSCard as EGDSCard30, EGDSCardContentSection as EGDSCardContentSection21 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure7, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType9 } from "@egds/react-core/images";
import { EGDSLayoutGrid as EGDSLayoutGrid25, EGDSLayoutGridItem as EGDSLayoutGridItem21 } from "@egds/react-core/layout-grid";
import { EGDSBlockSkeleton as EGDSBlockSkeleton3, EGDSLineSkeleton as EGDSLineSkeleton5 } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing95 } from "@egds/react-core/spacing";
var UnitsCarouselPlaceholder = function () {
  return /* @__PURE__ */React187.createElement(EGDSSpacing95, {
    padding: {
      blockend: "six"
    }
  }, /* @__PURE__ */React187.createElement("div", null, /* @__PURE__ */React187.createElement(EGDSLineSkeleton5, {
    type: "primary"
  }), /* @__PURE__ */React187.createElement(EGDSSpacing95, {
    padding: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React187.createElement(EGDSLayoutGrid25, {
    columns: {
      small: 2,
      medium: 2,
      large: 2
    },
    space: "three"
  }, [0, 1].map(function (_, index) {
    return /* @__PURE__ */React187.createElement(EGDSLayoutGridItem21, {
      key: "units-carousel-placeholder-".concat(index)
    }, /* @__PURE__ */React187.createElement(EGDSCard30, null, /* @__PURE__ */React187.createElement(EGDSFigure7, {
      ratio: EGDSFigureAspectRatioType9.R16_9
    }, /* @__PURE__ */React187.createElement(EGDSBlockSkeleton3, null)), /* @__PURE__ */React187.createElement(EGDSCardContentSection21, {
      padded: true
    }, /* @__PURE__ */React187.createElement(EGDSSpacing95, {
      margin: {
        blockstart: "one"
      }
    }, /* @__PURE__ */React187.createElement(EGDSLineSkeleton5, {
      animation: true
    })), /* @__PURE__ */React187.createElement(EGDSSpacing95, {
      margin: {
        block: "three"
      }
    }, /* @__PURE__ */React187.createElement(EGDSLineSkeleton5, {
      animation: true,
      type: "secondary"
    })))));
  })))));
};
// src/components/units-carousel/units-carousel.tsx
import React188 from "react";
import { gql as gql136 } from "@apollo/client";
import { EGDSCarousel } from "@egds/react-core/carousel";
import { EGDSSpacing as EGDSSpacing96 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading31 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker16 } from "@shared-ui/clickstream-analytics-context";
import { LodgingUnitCard } from "@shared-ui/lodging-fragments";
var fragment81 = gql136(_templateObject138(), LodgingUnitCard.fragment);
var UnitsCarousel = function (param) {
  var data = param.data;
  var _carousel_nextButton_icon, _carousel_nextButton, _carousel_previousButton_icon, _carousel_previousButton;
  if (!data || !data.unitsCarousel || data.unitsCarousel.items.length === 0) {
    return null;
  }
  var _data_unitsCarousel = data.unitsCarousel,
    carousel = _data_unitsCarousel.carousel,
    heading = _data_unitsCarousel.heading,
    impressionAnalytics = _data_unitsCarousel.impressionAnalytics,
    items = _data_unitsCarousel.items;
  var _impressionAnalytics_referrerId, _impressionAnalytics_linkName;
  return /* @__PURE__ */React188.createElement(IntersectionTracker16, {
    referrerId: (_impressionAnalytics_referrerId = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) !== null && _impressionAnalytics_referrerId !== void 0 ? _impressionAnalytics_referrerId : "",
    linkName: (_impressionAnalytics_linkName = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) !== null && _impressionAnalytics_linkName !== void 0 ? _impressionAnalytics_linkName : "",
    trackOnce: true
  }, /* @__PURE__ */React188.createElement(EGDSSpacing96, {
    padding: {
      blockend: "six"
    }
  }, /* @__PURE__ */React188.createElement("div", null, heading.__typename === "EGDSStylizedText" && /* @__PURE__ */React188.createElement(EGDSHeading31, {
    size: 5,
    tag: "h2"
  }, heading.text), (items === null || items === void 0 ? void 0 : items.length) > 0 && /* @__PURE__ */React188.createElement(EGDSSpacing96, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React188.createElement(EGDSCarousel, {
    buttonText: {
      nextButton: (carousel === null || carousel === void 0 ? void 0 : (_carousel_nextButton = carousel.nextButton) === null || _carousel_nextButton === void 0 ? void 0 : (_carousel_nextButton_icon = _carousel_nextButton.icon) === null || _carousel_nextButton_icon === void 0 ? void 0 : _carousel_nextButton_icon.description) || "",
      prevButton: (carousel === null || carousel === void 0 ? void 0 : (_carousel_previousButton = carousel.previousButton) === null || _carousel_previousButton === void 0 ? void 0 : (_carousel_previousButton_icon = _carousel_previousButton.icon) === null || _carousel_previousButton_icon === void 0 ? void 0 : _carousel_previousButton_icon.description) || ""
    },
    itemsVisible: {
      sm: 2,
      md: 2,
      lg: 2
    },
    pageBy: 1,
    peek: true,
    itemsMaxHeight: true
  }, items.map(function (item, index) {
    return item.__typename === "LodgingUnitCard" && /* @__PURE__ */React188.createElement(LodgingUnitCard, {
      data: item,
      key: "units-carousel-item-".concat(index),
      dialogProps: {
        id: "room-info-".concat(item.unitId, "-").concat(index + 1),
        dialogQueryKey: "propertyUnitRoomInfoDialog"
      }
    });
  }))))));
};
UnitsCarousel.fragment = fragment81;
UnitsCarousel.displayName = "UnitsCarousel";
// src/components/vip-messaging-card/vip-messaging-card.tsx
import React193 from "react";
import { gql as gql141 } from "@apollo/client";
// src/components/vip-access-module/__private/__fragments/vip-access-module-detail.tsx
import React191 from "react";
import { gql as gql139 } from "@apollo/client";
import { EGDSBadgeSize as EGDSBadgeSize2 } from "@egds/react-core/badge";
import { EGDSCard as EGDSCard31, EGDSCardContentSection as EGDSCardContentSection22 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex39, EGDSLayoutFlexItem as EGDSLayoutFlexItem30 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid26, EGDSLayoutGridItem as EGDSLayoutGridItem23 } from "@egds/react-core/layout-grid";
import { EGDSList as EGDSList9, EGDSListItem as EGDSListItem10 } from "@egds/react-core/list";
import { EGDSSpacing as EGDSSpacing98 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading32, EGDSText as EGDSText47 } from "@egds/react-core/text";
// src/components/vip-access-module/__private/__fragments/property-content-item-lodging-link-message.tsx
import React189 from "react";
import { gql as gql137 } from "@apollo/client";
import { EGDSIcon as EGDSIcon32 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink20 } from "@egds/react-core/link";
import { useClickTracker as useClickTracker42 } from "@shared-ui/clickstream-analytics-context";
var __PropertyContentItemLodgingLinkMessageFragment = gql137(_templateObject139());
var PropertyContentItemLodgingLinkMessage = function (param) {
  var data = param.data;
  var icon = data.icon,
    link = data.link,
    value = data.value,
    accessibilityLabel = data.accessibilityLabel;
  var track = useClickTracker42();
  var onClickLearnMoreLink = function () {
    var _link_clientSideAnalytics, _link_clientSideAnalytics1;
    if (!((_link_clientSideAnalytics = link.clientSideAnalytics) === null || _link_clientSideAnalytics === void 0 ? void 0 : _link_clientSideAnalytics.referrerId) || !((_link_clientSideAnalytics1 = link.clientSideAnalytics) === null || _link_clientSideAnalytics1 === void 0 ? void 0 : _link_clientSideAnalytics1.linkName)) {
      return;
    }
    track(link.clientSideAnalytics.referrerId, link.clientSideAnalytics.linkName);
  };
  return /* @__PURE__ */React189.createElement("div", null, /* @__PURE__ */React189.createElement(EGDSLink20, {
    onClick: onClickLearnMoreLink
  }, /* @__PURE__ */React189.createElement("a", {
    href: link === null || link === void 0 ? void 0 : link.uri.value,
    target: (link === null || link === void 0 ? void 0 : link.target) || "",
    "aria-hidden": "false"
  }, value, /* @__PURE__ */React189.createElement("span", {
    className: "is-visually-hidden"
  }, accessibilityLabel), /* @__PURE__ */React189.createElement(EGDSIcon32, {
    name: (icon === null || icon === void 0 ? void 0 : icon.id) || ""
  }))));
};
PropertyContentItemLodgingLinkMessage.fragment = __PropertyContentItemLodgingLinkMessageFragment;
PropertyContentItemLodgingLinkMessage.displayName = "PropertyContentItemLodgingLinkMessage";
// src/components/vip-access-module/__private/__fragments/property-content-item-text.tsx
import React190 from "react";
import { gql as gql138 } from "@apollo/client";
import { EGDSBadgeLoyalty as EGDSBadgeLoyalty4 } from "@egds/react-core/badge";
import { EGDSLayoutGridItem as EGDSLayoutGridItem22 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing97 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText46 } from "@egds/react-core/text";
import { EGDSBadgeLoyaltyThemePerksMessageMapper } from "@shared-ui/lodging-fragments";
var __PropertyContentItemTextFragment = gql138(_templateObject140());
var PropertyContentItemText = function (param) {
  var data = param.data,
    badgeSize = param.badgeSize;
  if (!data.content) {
    return null;
  }
  var primary = data.content.primary;
  var _primary_badge_text;
  return /* @__PURE__ */React190.createElement(React190.Fragment, null, primary.badge && /* @__PURE__ */React190.createElement(EGDSLayoutGridItem22, null, /* @__PURE__ */React190.createElement(EGDSSpacing97, {
    margin: {
      inlineend: "two"
    }
  }, /* @__PURE__ */React190.createElement(EGDSText46, {
    "aria-hidden": primary.badge.text === "VIP Access" ? "true" : "false"
  }, /* @__PURE__ */React190.createElement(EGDSBadgeLoyalty4, {
    text: (_primary_badge_text = primary.badge.text) !== null && _primary_badge_text !== void 0 ? _primary_badge_text : void 0,
    theme: primary.badge.theme_temp ? EGDSBadgeLoyaltyThemePerksMessageMapper[primary.badge.theme_temp] : void 0,
    size: badgeSize,
    a11yText: primary.badge.text === "VIP Access" ? void 0 : "".concat(primary.badge.text, " tier member")
  })))), primary.value && /* @__PURE__ */React190.createElement(EGDSLayoutGridItem22, null, /* @__PURE__ */React190.createElement(EGDSSpacing97, {
    padding: {
      small: {
        inlineend: "unset"
      },
      medium: {
        inlineend: "four"
      }
    }
  }, /* @__PURE__ */React190.createElement(EGDSText46, {
    theme: "standard",
    size: 300
  }, primary.value))));
};
PropertyContentItemText.displayName = "PropertyContentItemText";
PropertyContentItemText.fragment = __PropertyContentItemTextFragment;
// src/components/vip-access-module/__private/__fragments/vip-access-module-detail.tsx
var __VipAccessModuleDetailFragment = gql139(_templateObject141(), PropertyContentItemText.fragment, PropertyContentItemLodgingLinkMessage.fragment);
var VipAccessModuleDetail = function (param) {
  var data = param.data;
  var sections = data.sections;
  if (!sections || !(sections === null || sections === void 0 ? void 0 : sections.length) || sections.some(function (sec) {
    var _sec_bodySubSections;
    return sec.bodySubSections === null || !(sec === null || sec === void 0 ? void 0 : (_sec_bodySubSections = sec.bodySubSections) === null || _sec_bodySubSections === void 0 ? void 0 : _sec_bodySubSections.length);
  })) {
    return null;
  }
  var isRightSectionPresent = sections.some(function (section) {
    return section.sectionName === "rightSection";
  });
  var content = sections.map(function (section, i) {
    var _section_bodySubSections, _section_bodySubSections__elementsV2_, _section_bodySubSections_;
    if (!section.bodySubSections || !((_section_bodySubSections = section.bodySubSections) === null || _section_bodySubSections === void 0 ? void 0 : _section_bodySubSections.length)) {
      return null;
    }
    var elements = (_section_bodySubSections_ = section.bodySubSections[0]) === null || _section_bodySubSections_ === void 0 ? void 0 : (_section_bodySubSections__elementsV2_ = _section_bodySubSections_.elementsV2[0]) === null || _section_bodySubSections__elementsV2_ === void 0 ? void 0 : _section_bodySubSections__elementsV2_.elements[0];
    var sectionContent = (elements === null || elements === void 0 ? void 0 : elements.__typename) === "PropertyContent" ? elements.items : null;
    if (!(sectionContent === null || sectionContent === void 0 ? void 0 : sectionContent.length)) {
      return null;
    }
    var sectionItems = sectionContent.map(function (item, index) {
      return item.__typename === "PropertyContentItemText" ? /* @__PURE__ */React191.createElement(PropertyContentItemText, {
        key: "content-item-text-".concat(index),
        data: item
      }) : null;
    });
    switch (section.sectionName) {
      case "headerSection":
        {
          return /* @__PURE__ */React191.createElement(EGDSLayoutGridItem23, {
            colSpan: {
              small: 1,
              medium: 3
            }
          }, /* @__PURE__ */React191.createElement(EGDSCardContentSection22, {
            border: "bottom",
            padded: false
          }, /* @__PURE__ */React191.createElement(EGDSSpacing98, {
            padding: {
              blockend: "three"
            }
          }, /* @__PURE__ */React191.createElement(EGDSLayoutFlex39, null, sectionItems))));
        }
      case "leftSection":
        {
          return /* @__PURE__ */React191.createElement(EGDSLayoutGridItem23, {
            colSpan: !isRightSectionPresent ? {
              small: 1,
              medium: 3
            } : void 0
          }, /* @__PURE__ */React191.createElement(EGDSSpacing98, {
            padding: {
              block: "four"
            }
          }, /* @__PURE__ */React191.createElement(EGDSLayoutFlex39, {
            direction: "column",
            space: "two"
          }, /* @__PURE__ */React191.createElement(EGDSLayoutFlexItem30, null, section.header && /* @__PURE__ */React191.createElement(EGDSHeading32, {
            tag: "h3",
            size: 5
          }, /* @__PURE__ */React191.createElement(EGDSText47, {
            weight: "bold"
          }, section.header.text))), !isRightSectionPresent ? /* @__PURE__ */React191.createElement(EGDSLayoutFlexItem30, null, /* @__PURE__ */React191.createElement(EGDSList9, null, sectionContent.map(function (item, index) {
            return item.__typename === "PropertyContentItemText" ? /* @__PURE__ */React191.createElement(EGDSListItem10, {
              key: "property-content-list-item-".concat(index)
            }, item.content.primary.value) : null;
          }))) : /* @__PURE__ */React191.createElement(EGDSLayoutFlexItem30, null, sectionItems))));
        }
      case "rightSection":
        {
          return /* @__PURE__ */React191.createElement(EGDSLayoutGridItem23, {
            colSpan: {
              small: 1,
              medium: 2
            }
          }, /* @__PURE__ */React191.createElement(EGDSSpacing98, {
            padding: {
              small: {
                blockend: "four"
              },
              medium: {
                block: "three",
                inlinestart: "twelve"
              }
            }
          }, /* @__PURE__ */React191.createElement(EGDSLayoutFlex39, {
            direction: "column",
            space: "two"
          }, /* @__PURE__ */React191.createElement(EGDSSpacing98, {
            margin: {
              small: {
                blockstart: "two",
                blockend: "two"
              },
              medium: {
                blockstart: "one"
              }
            }
          }, /* @__PURE__ */React191.createElement(EGDSLayoutFlexItem30, null, /* @__PURE__ */React191.createElement(EGDSLayoutFlex39, {
            space: "two",
            alignItems: "center"
          }, /* @__PURE__ */React191.createElement(EGDSLayoutFlexItem30, null, section.header && /* @__PURE__ */React191.createElement(EGDSHeading32, {
            tag: "h3",
            size: 7
          }, /* @__PURE__ */React191.createElement(EGDSText47, {
            weight: "bold"
          }, section.header.text)))))), /* @__PURE__ */React191.createElement(EGDSLayoutFlexItem30, null, /* @__PURE__ */React191.createElement(EGDSLayoutGrid26, {
            space: "two",
            columns: ["max-content", "auto"]
          }, sectionContent.map(function (item, index) {
            switch (item.__typename) {
              case "PropertyContentItemText":
                return /* @__PURE__ */React191.createElement(PropertyContentItemText, {
                  data: item,
                  badgeSize: EGDSBadgeSize2.SMALL,
                  key: index
                });
              default:
                return null;
            }
          }))))));
        }
      case "footerSection":
        {
          var _sectionContent_;
          return ((_sectionContent_ = sectionContent[0]) === null || _sectionContent_ === void 0 ? void 0 : _sectionContent_.__typename) === "LodgingLinkMessage" ? /* @__PURE__ */React191.createElement(EGDSLayoutGridItem23, {
            colSpan: {
              small: 1,
              medium: 3
            }
          }, /* @__PURE__ */React191.createElement(EGDSSpacing98, null, /* @__PURE__ */React191.createElement(EGDSLayoutFlexItem30, null, /* @__PURE__ */React191.createElement(EGDSSpacing98, {
            margin: {
              small: {
                block: "unset"
              },
              medium: {
                block: "two"
              }
            }
          }, /* @__PURE__ */React191.createElement("div", null, sectionContent && /* @__PURE__ */React191.createElement(PropertyContentItemLodgingLinkMessage, {
            data: sectionContent[0]
          })))))) : null;
        }
      default:
        return null;
    }
  });
  return /* @__PURE__ */React191.createElement("div", null, /* @__PURE__ */React191.createElement(EGDSCard31, {
    border: true
  }, /* @__PURE__ */React191.createElement(EGDSSpacing98, {
    padding: {
      blockstart: "four",
      small: {
        blockend: "six",
        inline: "four"
      },
      medium: {
        blockend: "two",
        inline: "six"
      }
    }
  }, /* @__PURE__ */React191.createElement(EGDSCardContentSection22, null, /* @__PURE__ */React191.createElement(EGDSLayoutGrid26, {
    columns: {
      medium: ["1fr", "2fr"]
    },
    rows: {
      small: ["1fr"],
      medium: ["1fr"]
    }
  }, content)))));
};
VipAccessModuleDetail.fragment = __VipAccessModuleDetailFragment;
VipAccessModuleDetail.displayName = "VipAccessModuleDetail";
// src/components/vip-messaging/__private/__fragments/property-highlight-section.tsx
import React192 from "react";
import { gql as gql140 } from "@apollo/client";
import { EGDSBadgeSize as EGDSBadgeSize3, EGDSBadgeTheme as EGDSBadgeTheme3, EGDSMemberBadge as EGDSMemberBadge2 } from "@egds/react-core/badge";
import { EGDSCard as EGDSCard32, EGDSCardContentSection as EGDSCardContentSection23 } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon33 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex40, EGDSLayoutFlexItem as EGDSLayoutFlexItem31 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid27, EGDSLayoutGridItem as EGDSLayoutGridItem24, withEGDSLayoutGrid as withEGDSLayoutGrid4 } from "@egds/react-core/layout-grid";
import { EGDSLink as EGDSLink21 } from "@egds/react-core/link";
import { EGDSList as EGDSList10, EGDSListItem as EGDSListItem11 } from "@egds/react-core/list";
import { EGDSMark as EGDSMark6, EGDSMarkSize as EGDSMarkSize8 } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing99 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading33, EGDSText as EGDSText48 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker43 } from "@shared-ui/clickstream-analytics-context";
var fragment82 = gql140(_templateObject142());
var PropertyHighlightSection = function (param) {
  var data = param.data;
  var _footerLink_icon;
  var label = data.label,
    header = data.header,
    subSections = data.subSections,
    footerLink = data.footerLink;
  var track = useClickTracker43();
  if (!(subSections === null || subSections === void 0 ? void 0 : subSections.length) || !subSections[0]) {
    return null;
  }
  var _subSections_ = subSections[0],
    contents = _subSections_.contents,
    description = _subSections_.description;
  if (!(contents === null || contents === void 0 ? void 0 : contents.length)) {
    return null;
  }
  var onClickFooterLink = function () {
    if (!(footerLink === null || footerLink === void 0 ? void 0 : footerLink.link.referrerId)) {
      return;
    }
    track(footerLink.link.referrerId, label || "Clicked footer link of PropertyHighlightSection");
  };
  var list = function (props) {
    return /* @__PURE__ */React192.createElement(EGDSList10, _object_spread_props(_object_spread({}, props), {
      bullet: "icon-alternate",
      spacing: true
    }), contents.map(function (content, index) {
      var icon = content.icon,
        value = content.value;
      return /* @__PURE__ */React192.createElement(EGDSListItem11, {
        key: "property-highlight-list-item-".concat(index)
      }, (icon === null || icon === void 0 ? void 0 : icon.id) && /* @__PURE__ */React192.createElement(EGDSIcon33, {
        name: icon.id
      }), /* @__PURE__ */React192.createElement(EGDSLayoutFlex40, {
        space: "two"
      }, /* @__PURE__ */React192.createElement(EGDSText48, null, value)));
    }));
  };
  var MessagesListWithGrid = withEGDSLayoutGrid4(list);
  var messagesRowsCount = Math.ceil(contents.length / 2);
  return /* @__PURE__ */React192.createElement("div", null, /* @__PURE__ */React192.createElement(EGDSCard32, null, /* @__PURE__ */React192.createElement(EGDSCardContentSection23, {
    padded: true
  }, /* @__PURE__ */React192.createElement(EGDSLayoutGrid27, {
    columns: {
      small: 1,
      medium: 2,
      large: 3
    }
  }, /* @__PURE__ */React192.createElement(EGDSLayoutGridItem24, {
    colStart: 1,
    colSpan: "all"
  }, /* @__PURE__ */React192.createElement("div", null, /* @__PURE__ */React192.createElement(EGDSText48, {
    className: "is-visually-hidden"
  }, label), (header === null || header === void 0 ? void 0 : header.mark) && /* @__PURE__ */React192.createElement(EGDSSpacing99, {
    margin: {
      inlineend: "three"
    }
  }, /* @__PURE__ */React192.createElement(EGDSMark6, {
    name: header.mark.id,
    size: EGDSMarkSize8.MEDIUM_LARGE
  })), (header === null || header === void 0 ? void 0 : header.badge) && /* @__PURE__ */React192.createElement(EGDSMemberBadge2, {
    text: header.badge.text || "",
    theme: header.badge.theme_temp && EGDSBadgeTheme3[header.badge.theme_temp],
    size: EGDSBadgeSize3.LARGE
  }), (header === null || header === void 0 ? void 0 : header.text) && /* @__PURE__ */React192.createElement(EGDSHeading33, {
    tag: "h2",
    size: 5
  }, header.text))), /* @__PURE__ */React192.createElement(EGDSSpacing99, {
    padding: {
      blockstart: "two"
    },
    margin: {
      inlineend: "three"
    }
  }, /* @__PURE__ */React192.createElement(EGDSLayoutGridItem24, {
    colSpan: {
      medium: 2,
      large: 1
    }
  }, /* @__PURE__ */React192.createElement(EGDSText48, null, description))), /* @__PURE__ */React192.createElement(EGDSSpacing99, {
    padding: {
      blockstart: "two",
      inlinestart: "two"
    },
    margin: {
      inlineend: "three"
    }
  }, /* @__PURE__ */React192.createElement(EGDSLayoutGridItem24, {
    colSpan: {
      medium: 2,
      large: 2
    }
  }, /* @__PURE__ */React192.createElement(MessagesListWithGrid, {
    rows: messagesRowsCount,
    autoFlow: "column"
  })))), footerLink && /* @__PURE__ */React192.createElement(EGDSSpacing99, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React192.createElement(EGDSLayoutFlex40, {
    alignItems: "end",
    direction: "column",
    wrap: "nowrap"
  }, /* @__PURE__ */React192.createElement(EGDSLayoutFlexItem31, null, /* @__PURE__ */React192.createElement(EGDSLink21, {
    inline: true,
    onClick: onClickFooterLink
  }, /* @__PURE__ */React192.createElement("a", {
    href: footerLink.link.uri.value,
    target: footerLink.link.target || ""
  }, footerLink.value, /* @__PURE__ */React192.createElement("span", {
    className: "is-visually-hidden"
  }, footerLink.accessibilityLabel), /* @__PURE__ */React192.createElement(EGDSIcon33, {
    name: ((_footerLink_icon = footerLink.icon) === null || _footerLink_icon === void 0 ? void 0 : _footerLink_icon.id) || ""
  })))))))));
};
PropertyHighlightSection.fragment = fragment82;
PropertyHighlightSection.displayName = "PropertyHighlightSection";
// src/components/vip-messaging-card/vip-messaging-card.tsx
var fragment83 = gql141(_templateObject143(), VipAccessModuleDetail.fragment, PropertyHighlightSection.fragment);
var VipMessagingCard = function (param) {
  var data = param.data;
  var propertyHighlightSection = data.propertyHighlightSection,
    propertyContentSectionGroup = data.propertyContentSectionGroup;
  if (!propertyHighlightSection && !propertyContentSectionGroup) {
    return null;
  }
  if (propertyHighlightSection) {
    return /* @__PURE__ */React193.createElement(PropertyHighlightSection, {
      data: propertyHighlightSection
    });
  }
  if (propertyContentSectionGroup) {
    return /* @__PURE__ */React193.createElement(VipAccessModuleDetail, {
      data: propertyContentSectionGroup
    });
  }
  return null;
};
VipMessagingCard.fragment = fragment83;
VipMessagingCard.displayName = "VipMessagingCard";
// src/components/property-offers.tsx
var PropertyOffersDocumentNode = gql142(_templateObject144(), PropertyLevelOffersMessage.fragment, PropertyLevelOffersCard.fragment, VipMessagingCard.fragment, DamageAndIncidentalsCard.fragment, NewVipModule.fragment, PriceInsight.fragment, PropertyTripSummary.fragment, PropertySingleOffer.fragment, PropertyStickyBookBar.fragment, PropertyStickyPriceHeader.fragment, PropertyOffers.fragment, PropertySpaceDetails.fragment, PropertySearchLink.fragment, PropertyUnitListView.fragment, ListingsHeader.fragment, FilterPills.fragment, LoyaltyDiscountToggle.fragment, LegalDisclaimer.fragment, HighlightedBenefits.fragment, LodgingOneKeyBurnSwitch.fragment, TravelerSelector2.fragment, UnitsCarousel.fragment, CancellationPolicyInfo.fragment);
var RoomsAndRatesPropertyOffersDocumentNode = gql142(_templateObject145(), PropertyOffers.fragment);
var AncillaryPropertyOffersDocumentNode = gql142(_templateObject146(), PropertyLevelOffersMessage.fragment, PropertyLevelOffersCard.fragment, VipMessagingCard.fragment, DamageAndIncidentalsCard.fragment, NewVipModule.fragment, PriceInsight.fragment, PropertyTripSummary.fragment, PropertySingleOffer.fragment, PropertyStickyBookBar.fragment, PropertyStickyPriceHeader.fragment, PropertySpaceDetails.fragment, PropertySearchLink.fragment, PropertyUnitListView.fragment, ListingsHeader.fragment, FilterPills.fragment, LoyaltyDiscountToggle.fragment, LegalDisclaimer.fragment, HighlightedBenefits.fragment, LodgingOneKeyBurnSwitch.fragment, TravelerSelector2.fragment, UnitsCarousel.fragment, CancellationPolicyInfo.fragment, fragment4);
function findOperationDefinition(definition) {
  return definition.kind === "OperationDefinition";
}
function PropertyOffersComponent(WrappedComponent, LoadingPlaceholder) {
  var documentNode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : AncillaryPropertyOffersDocumentNode;
  var Component = function (props) {
    var _query_definitions_find_name, _query_definitions_find;
    var inputs = props.inputs,
      skipSsr = props.skipSsr,
      children = props.children;
    var context = useBexApi9().context;
    var exposure = useExperiment12("split_up_property_offers_query").exposure;
    var shouldSplitPropertyOffersQuery = exposure.bucket === 1;
    var fetchPolicy = documentNode === RoomsAndRatesPropertyOffersDocumentNode && shouldSplitPropertyOffersQuery ? "no-cache" : "cache-first";
    var setIsLoading = usePropertyOffersContext().setIsLoading;
    var variables = _object_spread_props(_object_spread({}, inputs), {
      context: context
    });
    var timeRef = useRef5({
      startTime: Date.now()
    });
    if (timeRef.current.startTime === 0) {
      timeRef.current = {
        startTime: Date.now()
      };
    }
    var query = shouldSplitPropertyOffersQuery ? documentNode : PropertyOffersDocumentNode;
    var operationName = (_query_definitions_find = query.definitions.find(findOperationDefinition)) === null || _query_definitions_find === void 0 ? void 0 : (_query_definitions_find_name = _query_definitions_find.name) === null || _query_definitions_find_name === void 0 ? void 0 : _query_definitions_find_name.value;
    var onCompleted = function () {
      var endTime = Date.now();
      if (typeof window !== "undefined" && window.DD_RUM && (WrappedComponent.displayName === "PropertyOffers" || WrappedComponent.displayName === "PropertySearchLink" && shouldSplitPropertyOffersQuery)) {
        window.DD_RUM.addAction("propertyOffersCompleteOperation", {
          operationName: operationName,
          duration: endTime - timeRef.current.startTime
        });
      }
      timeRef.current = {
        startTime: 0
      };
    };
    React194.useEffect(function () {
      timeRef.current = {
        startTime: Date.now()
      };
    }, [JSON.stringify(inputs)]);
    var _useQuery = useQuery(query, {
        variables: variables,
        context: {
          batchKey: "lodging-property-offers"
        },
        ssr: !skipSsr,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted
      }),
      data = _useQuery.data,
      previousData = _useQuery.previousData,
      loading = _useQuery.loading,
      refetch = _useQuery.refetch;
    var propertyOffers = data === null || data === void 0 ? void 0 : data.propertyOffers;
    var previousPropertyOffers = previousData === null || previousData === void 0 ? void 0 : previousData.propertyOffers;
    setIsLoading(loading);
    if (loading) {
      return LoadingPlaceholder ? /* @__PURE__ */React194.createElement(LoadingPlaceholder, {
        data: previousPropertyOffers
      }, children) : null;
    }
    if (!propertyOffers) {
      return null;
    }
    return /* @__PURE__ */React194.createElement(InputsProvider, {
      inputs: inputs
    }, /* @__PURE__ */React194.createElement(WrappedComponent, _object_spread({
      data: propertyOffers,
      loading: loading,
      refetch: refetch,
      variables: variables
    }, props), children));
  };
  Component.displayName = "PropertyOffers".concat(WrappedComponent.displayName);
  return Component;
}
function TravelerSelectorComponent(WrappedComponent, LoadingPlaceholder) {
  var Component = function (props) {
    var inputs = props.inputs,
      skipSsr = props.skipSsr,
      children = props.children;
    var context = useBexApi9().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
      context: context
    });
    var _useQuery = useQuery(PropertyOffersDocumentNode, {
        variables: variables,
        ssr: !skipSsr
      }),
      data = _useQuery.data,
      previousData = _useQuery.previousData,
      loading = _useQuery.loading;
    var travelerSelector = data === null || data === void 0 ? void 0 : data.offersTravelerSelector;
    var previousPropertyOffers = previousData === null || previousData === void 0 ? void 0 : previousData.propertyOffers;
    if (loading) {
      return LoadingPlaceholder ? /* @__PURE__ */React194.createElement(LoadingPlaceholder, {
        data: previousPropertyOffers
      }, children) : null;
    }
    if (!travelerSelector) {
      return null;
    }
    return /* @__PURE__ */React194.createElement(InputsProvider, {
      inputs: inputs
    }, /* @__PURE__ */React194.createElement(WrappedComponent, _object_spread({
      data: travelerSelector
    }, props), children));
  };
  Component.displayName = "PropertyOffers".concat(WrappedComponent.displayName);
  return Component;
}
function CancellationPolicyInfoComponent(WrappedComponent, LoadingPlaceholder) {
  var Component = function (props) {
    var inputs = props.inputs,
      skipSsr = props.skipSsr,
      children = props.children;
    var context = useBexApi9().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
      context: context
    });
    var _useQuery = useQuery(PropertyOffersDocumentNode, {
        variables: variables,
        ssr: !skipSsr
      }),
      data = _useQuery.data,
      previousData = _useQuery.previousData,
      loading = _useQuery.loading;
    var cancellationPolicyInfoData = data === null || data === void 0 ? void 0 : data.cancellationPolicyInfo;
    var previousPropertyOffers = previousData === null || previousData === void 0 ? void 0 : previousData.propertyOffers;
    if (loading) {
      return LoadingPlaceholder ? /* @__PURE__ */React194.createElement(LoadingPlaceholder, {
        data: previousPropertyOffers
      }, children) : null;
    }
    if ((cancellationPolicyInfoData === null || cancellationPolicyInfoData === void 0 ? void 0 : cancellationPolicyInfoData.policyContent) == null || cancellationPolicyInfoData.title == null) {
      return null;
    }
    var cancellationPolicyInfo = {
      __typename: "LodgingCancellationPolicyInfo",
      policyContent: cancellationPolicyInfoData.policyContent,
      title: cancellationPolicyInfoData.title
    };
    if (!cancellationPolicyInfo) {
      return null;
    }
    return /* @__PURE__ */React194.createElement(InputsProvider, {
      inputs: inputs
    }, /* @__PURE__ */React194.createElement(WrappedComponent, _object_spread({
      data: cancellationPolicyInfo
    }, props), children));
  };
  Component.displayName = "PropertyOffers".concat(WrappedComponent.displayName);
  return Component;
}
var ListingsHeader2 = PropertyOffersComponent(ListingsHeader);
var VipMessagingCard2 = PropertyOffersComponent(VipMessagingCard);
var DamageAndIncidentalsCard2 = PropertyOffersComponent(DamageAndIncidentalsCard);
var NewVipModule2 = PropertyOffersComponent(NewVipModule);
var PriceInsight2 = PropertyOffersComponent(PriceInsight);
var PropertyTripSummary2 = PropertyOffersComponent(PropertyTripSummary);
var PropertyLevelOffersMessage2 = PropertyOffersComponent(PropertyLevelOffersMessage);
var PropertyLevelOffersCard2 = PropertyOffersComponent(PropertyLevelOffersCard);
var PropertySingleOffer2 = PropertyOffersComponent(PropertySingleOffer);
var PropertyStickyBookBar2 = PropertyOffersComponent(PropertyStickyBookBar);
var PropertyStickyPriceHeader2 = PropertyOffersComponent(PropertyStickyPriceHeader);
var PropertySpaceDetails2 = PropertyOffersComponent(PropertySpaceDetails, PropertySpaceDetailsPlaceholder);
var PropertySearchLink2 = PropertyOffersComponent(PropertySearchLink, PropertySearchLinkPlaceholder);
var PropertyUnitListView2 = PropertyOffersComponent(PropertyUnitListView);
var FilterPills2 = PropertyOffersComponent(FilterPills);
var LoyaltyDiscountToggle2 = PropertyOffersComponent(LoyaltyDiscountToggle);
var SingleOfferSearchDateField2 = PropertyOffersComponent(SingleOfferSearchDateField);
var SingleOfferSearchButton = PropertyOffersComponent(SingleOfferSearchButton2);
var PropertyLegalDisclaimer = PropertyOffersComponent(LegalDisclaimer);
var PropertyOffersIncludedPerks2 = PropertyOffersComponent(PropertyOffersIncludedPerks);
var HighlightedBenefits2 = PropertyOffersComponent(HighlightedBenefits, HighlightedBenefitsPlaceholder);
var LodgingOneKeyBurnSwitch2 = PropertyOffersComponent(LodgingOneKeyBurnSwitch);
var UnitsCarousel2 = PropertyOffersComponent(UnitsCarousel, UnitsCarouselPlaceholder);
var TravelerSelector = TravelerSelectorComponent(TravelerSelector2);
var CancellationPolicyInfo2 = CancellationPolicyInfoComponent(CancellationPolicyInfo);
var PropertyOffers2 = Object.assign(PropertyOffersComponent(PropertyOffers, ListingsPlaceholder, RoomsAndRatesPropertyOffersDocumentNode), {
  Form: Form,
  HeaderRight: HeaderRight
});
// src/components/change-shopping/index.ts
var change_shopping_exports = {};
__export(change_shopping_exports, {
  ChangeShopping: function () {
    return ChangeShopping;
  },
  ChangeShoppingComponent: function () {
    return ChangeShoppingComponent;
  },
  ListingsDisplayContext: function () {
    return ListingsDisplayContext;
  },
  LodgingBookingPlayback: function () {
    return LodgingBookingPlayback;
  },
  LodgingCSPConfig: function () {
    return LodgingCSPConfig;
  },
  NavigationContext: function () {
    return NavigationContext;
  },
  NavigationToolbar: function () {
    return NavigationToolbar;
  },
  __ChangeShoppingNavigationLinkActionFragment: function () {
    return __ChangeShoppingNavigationLinkActionFragment;
  },
  __Query: function () {
    return __Query;
  },
  defaultBackToCLP: function () {
    return defaultBackToCLP;
  },
  defaultListingsDisplayState: function () {
    return defaultListingsDisplayState;
  },
  redirect: function () {
    return redirect;
  },
  useListingsDisplayContext: function () {
    return useListingsDisplayContext;
  },
  useNavigationContext: function () {
    return useNavigationContext;
  },
  useNavigationLinkAction: function () {
    return useNavigationLinkAction;
  }
});
// src/components/change-shopping/components/change-shopping/change-shopping.tsx
import React213, { useEffect as useEffect9, useMemo as useMemo7, useState as useState6 } from "react";
import { gql as gql160, useQuery as useQuery2 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing108 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading38, EGDSParagraph as EGDSParagraph2 } from "@egds/react-core/text";
import { useBexApi as useBexApi10 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker18, useClickTracker as useClickTracker46 } from "@shared-ui/clickstream-analytics-context";
import { LodgingChangeLoader } from "@shared-ui/lodging-fragments";
// src/components/change-shopping/contexts/navigation-context.ts
import { createContext as createContext2, useContext as useContext9 } from "react";
var defaultBackToCLP = {
  actionDestinationResolver: /* istanbul ignore next -- @preserve */function () {
    return void 0;
  },
  actionElementId: "",
  actionAnalyticsCallback: /* istanbul ignore next -- @preserve */function () {
    return void 0;
  },
  accessibility: null
};
var defaultNavigationContextDefinition = {
  config: {
    backToCLP: defaultBackToCLP
  },
  setConfig: /* istanbul ignore next -- @preserve */function () {
    return void 0;
  }
};
var NavigationContext = createContext2(defaultNavigationContextDefinition);
function useNavigationContext() {
  return useContext9(NavigationContext);
}
// src/components/change-shopping/contexts/display-state-context.ts
import { createContext as createContext3, useContext as useContext10 } from "react";
var defaultListingsDisplayState = {
  listingsDisplayed: false,
  setListingsDisplayed: function () {
    return void 0;
  }
};
var ListingsDisplayContext = createContext3(defaultListingsDisplayState);
function useListingsDisplayContext() {
  return useContext10(ListingsDisplayContext);
}
// src/components/change-shopping/components/change-shopping/__private/__fragments/cancellation-change.tsx
import React195, { useRef as useRef6 } from "react";
import { gql as gql143 } from "@apollo/client";
import { EGDSTertiaryButton as EGDSTertiaryButton4 } from "@egds/react-core/button";
import { EGDSDialog as EGDSDialog5, EGDSDialogContent as EGDSDialogContent11, EGDSDialogFooter as EGDSDialogFooter5 } from "@egds/react-core/dialog";
import { EGDSIcon as EGDSIcon34 } from "@egds/react-core/icons";
import { EGDSMoreInfoTrigger as EGDSMoreInfoTrigger5 } from "@egds/react-core/more-info-trigger";
import { EGDSSheetTransition as EGDSSheetTransition22 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing100 } from "@egds/react-core/spacing";
import { EGDSParagraph } from "@egds/react-core/text";
import { useDialog as useDialog25 } from "@shared-ui/dialog-context";
// src/components/change-shopping/components/change-shopping/__private/__fragments/utilities/theme.ts
function getTheme(theme) {
  switch (theme) {
    case "HIGHLIGHT" /* HIGHLIGHT */:
      return "positive";
    case "AGGRESSIVE" /* AGGRESSIVE */:
      return "negative";
    default:
      return "default";
  }
}
// src/components/change-shopping/components/change-shopping/__private/__fragments/cancellation-change.tsx
var fragment84 = gql143(_templateObject147());
var CancellationChange = function (param) {
  var data = param.data;
  var linkRef = useRef6(null);
  var _useDialog25 = _sliced_to_array(useDialog25("cancellation-change-info"), 3),
    isDialogOpen = _useDialog25[0],
    dialogActions = _useDialog25[1],
    DialogComponent = _useDialog25[2];
  var closeDialog = dialogActions.closeDialog,
    openDialog = dialogActions.openDialog;
  var content = data.content,
    trigger = data.trigger,
    primaryUIButton = data.primaryUIButton;
  var theme = getTheme(trigger.theme);
  var close = function () {
    closeDialog();
    if (linkRef.current) {
      linkRef.current.focus();
    }
  };
  var open = function () {
    return openDialog();
  };
  return /* @__PURE__ */React195.createElement(EGDSSpacing100, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React195.createElement("div", null, /* @__PURE__ */React195.createElement(EGDSSheetTransition22, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React195.createElement(DialogComponent, null, /* @__PURE__ */React195.createElement(EGDSDialog5, {
    returnFocusOnClose: true,
    dialogShow: isDialogOpen
  }, /* @__PURE__ */React195.createElement(EGDSDialogContent11, null, content.map(function (c, idx) {
    return /* @__PURE__ */React195.createElement(EGDSParagraph, {
      key: "cc-d-p-".concat(idx),
      size: 2
    }, c);
  }), primaryUIButton && /* @__PURE__ */React195.createElement(EGDSDialogFooter5, {
    key: "EGDSDialogFooter",
    stacked: true
  }, /* @__PURE__ */React195.createElement(EGDSTertiaryButton4, {
    onClick: close
  }, primaryUIButton.primary || "")))))), /* @__PURE__ */React195.createElement(EGDSMoreInfoTrigger5, {
    theme: theme
  }, /* @__PURE__ */React195.createElement("button", {
    type: "button",
    onClick: open,
    ref: linkRef
  }, trigger.value, /* @__PURE__ */React195.createElement(EGDSIcon34, {
    name: "info_outline"
  })))));
};
CancellationChange.fragment = fragment84;
CancellationChange.displayName = "CancellationChange";
// src/components/change-shopping/components/change-shopping/__private/__fragments/error-banner/error-banner.tsx
import React197 from "react";
import { gql as gql145 } from "@apollo/client";
import { UitkBanner } from "@egds/react-core/banner";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { UitkSpacing as UitkSpacing3 } from "@egds/react-core/spacing";
import { UiGraphic as UiGraphic4 } from "@shared-ui/lodging-fragments";
// src/components/change-shopping/components/change-shopping/shared/lodging-change-shopping-banner-text.tsx
import React196 from "react";
import { gql as gql144 } from "@apollo/client";
import { EGDSPlainText, EGDSStylizedText as EGDSStylizedText4 } from "@shared-ui/lodging-fragments";
var fragment85 = gql144(_templateObject148(), EGDSStylizedText4.fragment, EGDSPlainText.fragment);
var LodgingChangeShoppingBannerText = function (param) {
  var data = param.data;
  switch (data.__typename) {
    case "EGDSPlainText":
      return /* @__PURE__ */React196.createElement(EGDSPlainText, {
        data: data
      });
    case "EGDSStylizedText":
      return /* @__PURE__ */React196.createElement(EGDSStylizedText4, {
        data: data
      });
    default:
      return null;
  }
};
LodgingChangeShoppingBannerText.fragment = fragment85;
LodgingChangeShoppingBannerText.displayName = "LodgingChangeShoppingBannerText";
// src/components/change-shopping/components/change-shopping/__private/__fragments/error-banner/error-banner.tsx
var fragment86 = gql145(_templateObject149(), UiGraphic4.fragment, LodgingChangeShoppingBannerText.fragment);
var LodgingErrorBanner = function (param) {
  var data = param.data;
  var graphic = data.graphic,
    content = data.content;
  if (!graphic || !content) {
    return null;
  }
  return /* @__PURE__ */React197.createElement(UitkBanner, {
    theme: "critical"
  }, /* @__PURE__ */React197.createElement(UitkLayoutFlex3, {
    alignItems: "center",
    space: "four"
  }, /* @__PURE__ */React197.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React197.createElement(UitkSpacing3, {
    margin: {
      inlinestart: "three"
    }
  }, /* @__PURE__ */React197.createElement(UiGraphic4, {
    data: graphic
  }))), /* @__PURE__ */React197.createElement(UitkLayoutFlexItem3, null, content.map(function (text, idx) {
    return /* @__PURE__ */React197.createElement(LodgingChangeShoppingBannerText, {
      key: "error-banner-text-".concat(idx),
      data: text
    });
  }))));
};
LodgingErrorBanner.fragment = fragment86;
LodgingErrorBanner.displayName = "LodgingErrorBanner";
// src/components/change-shopping/components/change-shopping/__private/__fragments/messaging/content-section.tsx
import React201 from "react";
import { gql as gql149 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing103, EGDSSpacingHr as EGDSSpacingHr3 } from "@egds/react-core/spacing";
// src/components/change-shopping/components/change-shopping/__private/__fragments/messaging/content-subsection.tsx
import React200 from "react";
import { gql as gql148 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing102 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading35 } from "@egds/react-core/text";
// src/components/change-shopping/components/change-shopping/__private/__fragments/messaging/content-element-group.tsx
import React199 from "react";
import { gql as gql147 } from "@apollo/client";
// src/components/change-shopping/components/change-shopping/__private/__fragments/messaging/content-element.tsx
import React198 from "react";
import { gql as gql146 } from "@apollo/client";
import { EGDSCard as EGDSCard33 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex41, EGDSLayoutFlexItem as EGDSLayoutFlexItem32 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing101 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading34, EGDSText as EGDSText49 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker17 } from "@shared-ui/clickstream-analytics-context";
import { Icon as Icon2 } from "@shared-ui/lodging-fragments";
var fragment87 = gql146(_templateObject150(), Icon2.fragment);
var LodgingChangeContentElement = function (param) {
  var className = param.className,
    _param_data = param.data,
    header = _param_data.header,
    items = _param_data.items,
    impressionAnalytics = _param_data.impressionAnalytics;
  if (!items.some(function (param) {
    var __typename = param.__typename;
    return __typename === "EGDSPlainText";
  })) {
    return null;
  }
  var _impressionAnalytics_referrerId, _impressionAnalytics_linkName;
  return /* @__PURE__ */React198.createElement(IntersectionTracker17, {
    trackOnce: true,
    referrerId: (_impressionAnalytics_referrerId = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) !== null && _impressionAnalytics_referrerId !== void 0 ? _impressionAnalytics_referrerId : "",
    linkName: (_impressionAnalytics_linkName = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) !== null && _impressionAnalytics_linkName !== void 0 ? _impressionAnalytics_linkName : ""
  }, /* @__PURE__ */React198.createElement(EGDSCard33, {
    className: className,
    border: true,
    overflow: true,
    padded: true
  }, /* @__PURE__ */React198.createElement(EGDSLayoutFlex41, null, (header === null || header === void 0 ? void 0 : header.icon) && /* @__PURE__ */React198.createElement(EGDSLayoutFlexItem32, null, /* @__PURE__ */React198.createElement(EGDSSpacing101, {
    margin: {
      inlineend: "three"
    }
  }, /* @__PURE__ */React198.createElement(Icon2, {
    data: header.icon
  }))), /* @__PURE__ */React198.createElement(EGDSLayoutFlexItem32, {
    grow: 1
  }, /* @__PURE__ */React198.createElement(EGDSLayoutFlex41, {
    direction: "column",
    justifyContent: "space-between",
    space: "one"
  }, /* @__PURE__ */React198.createElement(EGDSLayoutFlexItem32, null, /* @__PURE__ */React198.createElement(React198.Fragment, null, (header === null || header === void 0 ? void 0 : header.text) && /* @__PURE__ */React198.createElement(EGDSHeading34, {
    tag: "h3",
    size: 7
  }, header.text), items.map(function (item, i) {
    return item.__typename === "EGDSPlainText" && /* @__PURE__ */React198.createElement(EGDSText49, {
      size: 300,
      key: "info-card-text-".concat(i)
    }, item.text);
  }))))))));
};
LodgingChangeContentElement.fragment = fragment87;
LodgingChangeContentElement.displayName = "LodgingChangeContentElement";
// src/components/change-shopping/components/change-shopping/__private/__fragments/messaging/content-element-group.tsx
var fragment88 = gql147(_templateObject151(), LodgingChangeContentElement.fragment);
var LodgingChangeContentElementGroup = function (param) {
  var className = param.className,
    elements = param.data.elements;
  return /* @__PURE__ */React199.createElement(React199.Fragment, null, elements.map(function (element, i) {
    return /* @__PURE__ */React199.createElement(LodgingChangeContentElement, {
      data: element,
      key: "element-".concat(i),
      className: className
    });
  }));
};
LodgingChangeContentElementGroup.fragment = fragment88;
LodgingChangeContentElementGroup.displayName = "LodgingChangeContentElementGroup";
// src/components/change-shopping/components/change-shopping/__private/__fragments/messaging/content-subsection.tsx
var fragment89 = gql148(_templateObject152(), LodgingChangeContentElementGroup.fragment);
var LodgingChangeContentSubSection = function (param) {
  var _param_data = param.data,
    elements = _param_data.elements,
    header = _param_data.header;
  if (!elements.length) {
    return null;
  }
  return /* @__PURE__ */React200.createElement(React200.Fragment, null, header && /* @__PURE__ */React200.createElement(EGDSSpacing102, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React200.createElement(EGDSHeading35, {
    tag: "h2",
    size: 6
  }, header.text)), elements.map(function (element, i) {
    return /* @__PURE__ */React200.createElement(EGDSSpacing102, {
      margin: {
        blockstart: "four"
      },
      key: "element-".concat(i)
    }, /* @__PURE__ */React200.createElement(LodgingChangeContentElementGroup, {
      data: element
    }));
  }));
};
LodgingChangeContentSubSection.fragment = fragment89;
LodgingChangeContentSubSection.displayName = "LodgingChangeContentSubSection";
// src/components/change-shopping/components/change-shopping/__private/__fragments/messaging/content-section.tsx
var fragment90 = gql149(_templateObject153(), LodgingChangeContentSubSection.fragment);
var LodgingChangeContentSection = function (param) {
  var subSections = param.data.subSections;
  if (!subSections.length) {
    return null;
  }
  return /* @__PURE__ */React201.createElement(EGDSSpacing103, {
    padding: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React201.createElement("div", {
    "data-stid": "messaging"
  }, /* @__PURE__ */React201.createElement(EGDSSpacingHr3, {
    blockMargin: "six"
  }), subSections.map(function (subSection, i) {
    return /* @__PURE__ */React201.createElement(LodgingChangeContentSubSection, {
      data: subSection,
      key: "subsection-".concat(i)
    });
  })));
};
LodgingChangeContentSection.fragment = fragment90;
LodgingChangeContentSection.displayName = "LodgingChangeContentSection";
// src/components/change-shopping/components/change-shopping/__private/__fragments/playback/playback-section.tsx
import React211 from "react";
import { gql as gql158 } from "@apollo/client";
import { EGDSIcon as EGDSIcon36 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex45, EGDSLayoutFlexItem as EGDSLayoutFlexItem36 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing106 } from "@egds/react-core/spacing";
import { UitkHeading } from "@egds/react-core/text";
import { LodgingMicroCard } from "@shared-ui/lodging-fragments";
// src/components/change-shopping/components/change-shopping/shared/criteria-playback-card.tsx
import React203 from "react";
import { gql as gql151 } from "@apollo/client";
import { EGDSCard as EGDSCard34 } from "@egds/react-core/cards";
import { EGDSLayoutColumns, EGDSLayoutColumnsItem } from "@egds/react-core/layout-columns";
import { EGDSLayoutFlex as EGDSLayoutFlex43, EGDSLayoutFlexItem as EGDSLayoutFlexItem34 } from "@egds/react-core/layout-flex";
import { EGDSSubheading as EGDSSubheading2 } from "@egds/react-core/text";
// src/components/change-shopping/components/change-shopping/shared/egds-text-list-item.tsx
import React202 from "react";
import { gql as gql150 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex42, EGDSLayoutFlexItem as EGDSLayoutFlexItem33 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing104 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading36, EGDSText as EGDSText50 } from "@egds/react-core/text";
var fragment91 = gql150(_templateObject154());
var EGDSTextListItem = function (param) {
  var data = param.data;
  var item = data.__typename === "EGDSTextIconListItem" ? data : data;
  return /* @__PURE__ */React202.createElement(React202.Fragment, null, /* @__PURE__ */React202.createElement("div", {
    "aria-hidden": "true"
  }, /* @__PURE__ */React202.createElement(EGDSHeading36, {
    tag: "h3"
  }, item.text), /* @__PURE__ */React202.createElement(EGDSSpacing104, {
    padding: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React202.createElement(EGDSLayoutFlex42, {
    alignItems: "center",
    space: "one"
  }, /* @__PURE__ */React202.createElement(EGDSLayoutFlexItem33, null, /* @__PURE__ */React202.createElement(EGDSText50, null, item.subText))))), /* @__PURE__ */React202.createElement("p", {
    className: "is-visually-hidden"
  }, item.accessibilityLabel));
};
EGDSTextListItem.fragment = fragment91;
EGDSTextListItem.displayName = "EGDSTextListItem";
// src/components/change-shopping/components/change-shopping/shared/criteria-playback-card.tsx
var fragment92 = gql151(_templateObject155(), EGDSTextListItem.fragment);
var CriteriaPlaybackCard = function (param) {
  var data = param.data;
  var title = data.title,
    criteria = data.criteria;
  return /* @__PURE__ */React203.createElement(EGDSCard34, {
    border: true,
    padded: true
  }, /* @__PURE__ */React203.createElement(EGDSLayoutFlex43, {
    direction: "column",
    space: "three"
  }, /* @__PURE__ */React203.createElement(EGDSLayoutFlexItem34, null, /* @__PURE__ */React203.createElement(EGDSSubheading2, {
    tag: "h2"
  }, title)), /* @__PURE__ */React203.createElement(EGDSLayoutFlexItem34, null, /* @__PURE__ */React203.createElement(EGDSLayoutColumns, {
    columns: 2
  }, criteria === null || criteria === void 0 ? void 0 : criteria.map(function (item, idx) {
    return /* @__PURE__ */React203.createElement(EGDSLayoutColumnsItem, {
      key: "".concat(title, "-").concat(idx)
    }, /* @__PURE__ */React203.createElement(EGDSTextListItem, {
      key: idx,
      data: item
    }));
  })))));
};
CriteriaPlaybackCard.fragment = fragment92;
CriteriaPlaybackCard.displayName = "CriteriaPlaybackCard";
// src/components/change-shopping/components/change-shopping/__private/__fragments/price-playback-details.tsx
import React206 from "react";
import { gql as gql154 } from "@apollo/client";
import { PricePresentationLineItem } from "@shared-ui/pricing-price-details";
// src/components/change-shopping/components/change-shopping/__private/__fragments/price-presentation/price-presentation.tsx
import React204 from "react";
import { PricePresentation as PricingPricePresentation } from "@shared-ui/pricing-price-details";
// src/components/change-shopping/components/change-shopping/__private/__fragments/price-presentation/price-presentation-fragment.tsx
import { gql as gql152 } from "@apollo/client";
var PricePresentationFragment = gql152(_templateObject156());
// src/components/change-shopping/components/change-shopping/__private/__fragments/price-presentation/price-presentation.tsx
var LodgingPricePresentation = function (param) {
  var data = param.data,
    loading = param.loading;
  return /* @__PURE__ */React204.createElement(PricingPricePresentation, {
    "data-stid": "price-presentation",
    data: data,
    loading: loading
  });
};
LodgingPricePresentation.fragment = _object_spread_props(_object_spread({}, PricePresentationFragment), {
  __typename: "PricePresentation"
});
LodgingPricePresentation.displayName = "LodgingPricePresentation";
// src/components/change-shopping/components/change-shopping/__private/__fragments/price-presentation-expando/price-presentation-expando.tsx
import React205, { useMemo as useMemo6, useState as useState5 } from "react";
import { gql as gql153 } from "@apollo/client";
import { EGDSCard as EGDSCard35, EGDSCardContentSection as EGDSCardContentSection24 } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon35 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex44, EGDSLayoutFlexItem as EGDSLayoutFlexItem35 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing105 } from "@egds/react-core/spacing";
import { EGDSTable, EGDSTableBody } from "@egds/react-core/tables";
import { useClickTracker as useClickTracker44 } from "@shared-ui/clickstream-analytics-context";
var fragment93 = gql153(_templateObject157());
var getLabel = function (customLabel, fragmentLabel) {
  return customLabel || fragmentLabel;
};
var LodgingPricePresentationExpando = function (param) {
  var id = param.id,
    customCollapsedLabel = param.collapsedLabel,
    _param_data = param.data,
    fragmentExpandedLabel = _param_data.expandedLabel,
    fragmentCollapsedLabel = _param_data.collapsedLabel,
    expandedAnalytics = _param_data.expandedAnalytics,
    collapsedAnalytics = _param_data.collapsedAnalytics,
    customExpandedLabel = param.expandedLabel,
    children = param.children;
  var collapsedLabel = useMemo6(function () {
    return getLabel(customCollapsedLabel, fragmentCollapsedLabel);
  }, [customCollapsedLabel, fragmentCollapsedLabel]);
  var expandedLabel = useMemo6(function () {
    return getLabel(customExpandedLabel, fragmentExpandedLabel);
  }, [customExpandedLabel, fragmentExpandedLabel]);
  var trackClick = useClickTracker44();
  var _useState5 = _sliced_to_array(useState5(false), 2),
    visible = _useState5[0],
    setVisible = _useState5[1];
  var _useState51 = _sliced_to_array(useState5(visible ? expandedLabel : collapsedLabel), 2),
    label = _useState51[0],
    setLabel = _useState51[1];
  var toggle = function () {
    if (visible) {
      if (collapsedAnalytics) {
        trackClick(collapsedAnalytics.referrerId, collapsedAnalytics.linkName);
      }
      setLabel(collapsedLabel);
    } else {
      if (expandedAnalytics) {
        trackClick(expandedAnalytics.referrerId, expandedAnalytics.linkName);
      }
      setLabel(expandedLabel);
    }
    setVisible(function (isVisible) {
      return !isVisible;
    });
    setTimeout(function () {
      var ctrlTarget = document.getElementById(id);
      if (ctrlTarget) {
        ctrlTarget.focus();
      }
    });
  };
  var onToggle = React205.useCallback(toggle, [visible, collapsedLabel, expandedLabel]);
  var keyUpHandler = function (event) {
    if (event.key === "Enter" || event.key === " ") {
      toggle();
    }
  };
  return /* @__PURE__ */React205.createElement(EGDSCard35, {
    border: true
  }, /* @__PURE__ */React205.createElement(EGDSSpacing105, {
    className: "uitk-expando-trigger-content",
    padding: "three"
  }, /* @__PURE__ */React205.createElement(EGDSLayoutFlex44, {
    alignItems: "center",
    space: "two",
    onClick: onToggle,
    role: "button",
    "aria-expanded": visible,
    tabIndex: 0,
    id: id,
    onKeyUp: keyUpHandler
  }, /* @__PURE__ */React205.createElement(EGDSLayoutFlexItem35, null, /* @__PURE__ */React205.createElement("div", null, /* @__PURE__ */React205.createElement(EGDSIcon35, {
    name: visible ? "expand_less" : "expand_more",
    className: visible ? "expand_less_price_presentation" : "expand_more_price_presentation"
  }))), /* @__PURE__ */React205.createElement(EGDSLayoutFlexItem35, {
    grow: 1
  }, /* @__PURE__ */React205.createElement(EGDSCardContentSection24, {
    padded: false
  }, /* @__PURE__ */React205.createElement(EGDSTable, {
    overflow: false
  }, /* @__PURE__ */React205.createElement(EGDSTableBody, null, label)))))), visible && /* @__PURE__ */React205.createElement(EGDSCardContentSection24, {
    className: "expando-content",
    border: "top"
  }, children));
};
LodgingPricePresentationExpando.fragment = fragment93;
LodgingPricePresentationExpando.displayName = "LodgingPricePresentationExpando";
// src/components/change-shopping/components/change-shopping/__private/__fragments/price-playback-details.tsx
var fragment94 = gql154(_templateObject158(), LodgingPricePresentation.fragment, LodgingPricePresentationExpando.fragment);
var PricePlaybackDetails = function (param) {
  var id = param.id,
    data = param.data,
    displayPricePlayback = param.displayPricePlayback;
  var content = data.content,
    expando = data.expando;
  if (!displayPricePlayback) {
    return null;
  }
  return /* @__PURE__ */React206.createElement("div", {
    className: "uitk-expando-list"
  }, expando && content && /* @__PURE__ */React206.createElement(LodgingPricePresentationExpando, {
    id: id,
    collapsedLabel: /* @__PURE__ */React206.createElement(PricePresentationLineItem, {
      data: expando === null || expando === void 0 ? void 0 : expando.collapsedLabel
    }),
    data: expando,
    expandedLabel: /* @__PURE__ */React206.createElement(PricePresentationLineItem, {
      data: expando === null || expando === void 0 ? void 0 : expando.expandedLabel
    })
  }, /* @__PURE__ */React206.createElement(LodgingPricePresentation, {
    data: content
  })));
};
PricePlaybackDetails.fragment = fragment94;
PricePlaybackDetails.displayName = "PricePlaybackDetails";
// src/components/change-shopping/components/change-shopping/__private/__fragments/playback/button/playback-button.tsx
import React208 from "react";
import { gql as gql155 } from "@apollo/client";
import { clientSideAnalyticsFragment as clientSideAnalyticsFragment3 } from "@shared-ui/lodging-fragments";
// src/components/change-shopping/components/change-shopping/__private/__fragments/playback/button/listings-toggle-button.tsx
import React207 from "react";
import { EGDSPrimaryButton as EGDSPrimaryButton11, EGDSSecondaryButton as EGDSSecondaryButton2, EGDSTertiaryButton as EGDSTertiaryButton5 } from "@egds/react-core/button";
import { useClickTracker as useClickTracker45 } from "@shared-ui/clickstream-analytics-context";
// src/components/change-shopping/components/change-shopping/__private/__fragments/playback/display-states.ts
var displayStates = {
  listingsShown: {
    original: {
      title: true,
      pricePlayback: true,
      separator: false,
      toggleButtonText: "alternate"
    },
    updated: {
      title: true,
      pricePlayback: false
    }
  },
  listingsHidden: {
    original: {
      title: true,
      pricePlayback: true,
      separator: true,
      toggleButtonText: "primary"
    },
    updated: {
      title: false,
      pricePlayback: true
    }
  }
};
// src/components/change-shopping/components/change-shopping/__private/__fragments/playback/button/listings-toggle-button.tsx
var ListingsToggleButton = function (props) {
  var _currentState_original;
  var data = props.data;
  var button = data.button,
    toggledText = data.toggledText;
  var _useListingsDisplayContext = useListingsDisplayContext(),
    listingsDisplayed = _useListingsDisplayContext.listingsDisplayed,
    setListingsDisplayed = _useListingsDisplayContext.setListingsDisplayed;
  var currentState = listingsDisplayed ? displayStates.listingsShown : displayStates.listingsHidden;
  var buttonText = ((_currentState_original = currentState.original) === null || _currentState_original === void 0 ? void 0 : _currentState_original.toggleButtonText) === "alternate" ? toggledText : button === null || button === void 0 ? void 0 : button.primary;
  var track = useClickTracker45();
  var handleClick = function () {
    setListingsDisplayed(function (prevListingsState) {
      return !prevListingsState;
    });
    if (button === null || button === void 0 ? void 0 : button.analytics) {
      var _button_analytics = button.analytics,
        referrerId = _button_analytics.referrerId,
        linkName = _button_analytics.linkName;
      track(referrerId, linkName);
    }
  };
  switch (button === null || button === void 0 ? void 0 : button.__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React207.createElement(EGDSPrimaryButton11, {
        onClick: handleClick
      }, buttonText);
    case "UISecondaryButton":
      return /* @__PURE__ */React207.createElement(EGDSSecondaryButton2, {
        onClick: handleClick
      }, buttonText);
    case "UITertiaryButton":
      return /* @__PURE__ */React207.createElement(EGDSTertiaryButton5, {
        onClick: handleClick
      }, buttonText);
    default:
      return null;
  }
};
ListingsToggleButton.displayName = "ListingsToggleButton";
// src/components/change-shopping/components/change-shopping/__private/__fragments/playback/button/playback-button.tsx
var fragment95 = gql155(_templateObject159(), clientSideAnalyticsFragment3);
var LodgingChangePlaybackButton = function (param) {
  var data = param.data;
  var action = data.action;
  switch (action) {
    case "toggleListings":
      return /* @__PURE__ */React208.createElement(ListingsToggleButton, {
        data: data
      });
    default:
      return null;
  }
};
LodgingChangePlaybackButton.fragment = fragment95;
LodgingChangePlaybackButton.displayName = "LodgingChangeListings";
// src/components/change-shopping/components/change-shopping/__private/__fragments/playback/change-listings.tsx
import React210 from "react";
import { gql as gql157 } from "@apollo/client";
// src/components/change-shopping/components/change-shopping/__private/__fragments/details-disclaimer/details-disclaimer.tsx
import React209 from "react";
import { gql as gql156 } from "@apollo/client";
import { UitkCard, UitkCardContentSection } from "@egds/react-core/cards";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { UitkSpacing as UitkSpacing4 } from "@egds/react-core/spacing";
import { UiGraphic as UiGraphic5 } from "@shared-ui/lodging-fragments";
var fragment96 = gql156(_templateObject160(), UiGraphic5.fragment, LodgingChangeShoppingBannerText.fragment);
var DetailsDisclaimer = function (param) {
  var data = param.data;
  var graphic = data.graphic,
    content = data.content;
  if (!graphic || !content) {
    return null;
  }
  return /* @__PURE__ */React209.createElement(UitkCard, {
    border: true,
    padded: true
  }, /* @__PURE__ */React209.createElement(UitkLayoutFlex4, null, /* @__PURE__ */React209.createElement(UitkLayoutFlexItem4, {
    alignSelf: "center",
    grow: 0
  }, /* @__PURE__ */React209.createElement(UitkCardContentSection, {
    padded: ["blockstart", "blockend", "inlinestart"]
  }, /* @__PURE__ */React209.createElement(UitkSpacing4, {
    margin: {
      inlineend: "four"
    }
  }, /* @__PURE__ */React209.createElement(UiGraphic5, {
    data: graphic
  })))), /* @__PURE__ */React209.createElement(UitkLayoutFlexItem4, {
    alignSelf: "center",
    grow: 1
  }, /* @__PURE__ */React209.createElement(UitkCardContentSection, {
    padded: true
  }, content.map(function (text, idx) {
    return /* @__PURE__ */React209.createElement(LodgingChangeShoppingBannerText, {
      key: "error-banner-text-".concat(idx),
      data: text
    });
  })))));
};
DetailsDisclaimer.fragment = fragment96;
DetailsDisclaimer.displayName = "DetailsDisclaimer";
// src/components/change-shopping/components/change-shopping/__private/__fragments/playback/change-listings.tsx
var fragment97 = gql157(_templateObject161(), __PropertyUnitCategorizationFragment, DetailsDisclaimer.fragment);
var LodgingChangeListings = function (param) {
  var data = param.data,
    propertyId = param.propertyId,
    listingsDisplayed = param.listingsDisplayed;
  var banner = data.banner,
    listings = data.listings;
  if (!listingsDisplayed) {
    return null;
  }
  return /* @__PURE__ */React210.createElement(React210.Fragment, null, banner && /* @__PURE__ */React210.createElement(DetailsDisclaimer, {
    data: banner
  }), /* @__PURE__ */React210.createElement(CategorizedListings, {
    listings: listings,
    propertyId: propertyId !== null && propertyId !== void 0 ? propertyId : "",
    useInlineMargin: false
  }));
};
LodgingChangeListings.fragment = fragment97;
LodgingChangeListings.displayName = "LodgingChangeListings";
// src/components/change-shopping/components/change-shopping/__private/__fragments/playback/playback-section.tsx
var fragment98 = gql158(_templateObject162(), CriteriaPlaybackCard.fragment, LodgingChangeListings.fragment, LodgingChangePlaybackButton.fragment, LodgingMicroCard.fragment, PricePlaybackDetails.fragment);
var LodgingChangePlaybackSection = function (param) {
  var data = param.data,
    propertyId = param.propertyId,
    sectionIdx = param.sectionIdx;
  var _separator_graphic;
  var sectionId = data.sectionId,
    title = data.title,
    items = data.items,
    separator = data.separator;
  var listingsDisplayed = useListingsDisplayContext().listingsDisplayed;
  var currentState = listingsDisplayed ? displayStates.listingsShown : displayStates.listingsHidden;
  var sectionState = currentState[sectionId];
  var sectionWrapper = function (child) {
    return /* @__PURE__ */React211.createElement(EGDSSpacing106, {
      padding: {
        blockend: "three"
      }
    }, /* @__PURE__ */React211.createElement(EGDSLayoutFlexItem36, null, child));
  };
  var sectionItems = items === null || items === void 0 ? void 0 : items.map(function (item, idx) {
    switch (item.__typename) {
      case "LodgingChangeListings":
        return sectionWrapper( /* @__PURE__ */React211.createElement(LodgingChangeListings, {
          data: item,
          propertyId: propertyId,
          listingsDisplayed: listingsDisplayed
        }));
      case "LodgingChangePriceDetails":
        return sectionWrapper( /* @__PURE__ */React211.createElement(PricePlaybackDetails, {
          id: "price-expando-".concat(sectionIdx, "-").concat(idx),
          data: item,
          displayPricePlayback: (sectionState === null || sectionState === void 0 ? void 0 : sectionState.pricePlayback) || false
        }));
      case "LodgingCriteriaPlaybackCard":
        return sectionWrapper( /* @__PURE__ */React211.createElement(CriteriaPlaybackCard, {
          data: item
        }));
      case "LodgingChangePlaybackButton":
        return sectionWrapper( /* @__PURE__ */React211.createElement(LodgingChangePlaybackButton, {
          data: item
        }));
      case "LodgingMicroCard":
        return sectionWrapper( /* @__PURE__ */React211.createElement(LodgingMicroCard, {
          data: item
        }));
      default:
        return null;
    }
  });
  return /* @__PURE__ */React211.createElement(EGDSSpacing106, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React211.createElement(EGDSLayoutFlex45, {
    direction: "column",
    alignItems: "stretch",
    space: "four"
  }, title && (sectionState === null || sectionState === void 0 ? void 0 : sectionState.title) && /* @__PURE__ */React211.createElement(UitkHeading, {
    size: 6,
    tag: "h2"
  }, title), sectionItems, separator && ((_separator_graphic = separator.graphic) === null || _separator_graphic === void 0 ? void 0 : _separator_graphic.__typename) === "Icon" && (sectionState === null || sectionState === void 0 ? void 0 : sectionState.separator) && /* @__PURE__ */React211.createElement(EGDSLayoutFlexItem36, {
    alignSelf: "center"
  }, /* @__PURE__ */React211.createElement(EGDSIcon36, {
    title: separator.accessibilityLabel || "",
    name: separator.graphic.id
  }))));
};
LodgingChangePlaybackSection.fragment = fragment98;
LodgingChangePlaybackSection.displayName = "LodgingChangeListings";
// src/components/change-shopping/components/change-shopping/__private/__fragments/total-difference.tsx
import React212 from "react";
import { gql as gql159 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex46, EGDSLayoutFlexItem as EGDSLayoutFlexItem37 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing107 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading37 } from "@egds/react-core/text";
var fragment99 = gql159(_templateObject163());
var TotalDifference = function (param) {
  var data = param.data;
  if (!data.header) {
    return null;
  }
  var _data_header = data.header,
    name = _data_header.name,
    enrichedValue = _data_header.enrichedValue,
    accessibilityLabel = _data_header.accessibilityLabel;
  if (!enrichedValue || name.primaryMessage.__typename !== "PriceLineHeading" || enrichedValue.primaryMessage.__typename !== "PriceLineHeading") {
    return null;
  }
  return /* @__PURE__ */React212.createElement(React212.Fragment, null, /* @__PURE__ */React212.createElement(EGDSSpacing107, {
    padding: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React212.createElement("div", {
    "aria-hidden": "true"
  }, /* @__PURE__ */React212.createElement(EGDSLayoutFlex46, {
    justifyContent: "space-between"
  }, /* @__PURE__ */React212.createElement(EGDSLayoutFlexItem37, null, /* @__PURE__ */React212.createElement(EGDSHeading37, {
    tag: "h2",
    size: 6
  }, name.primaryMessage.primary)), /* @__PURE__ */React212.createElement(EGDSLayoutFlexItem37, null, /* @__PURE__ */React212.createElement(EGDSHeading37, {
    tag: "h2",
    size: 6
  }, enrichedValue.primaryMessage.primary))))), /* @__PURE__ */React212.createElement("span", {
    className: "is-visually-hidden"
  }, " ", accessibilityLabel, " "));
};
TotalDifference.fragment = fragment99;
TotalDifference.displayName = "TotalDifference";
// src/components/change-shopping/components/change-shopping/change-shopping.tsx
var __Query = gql160(_templateObject164(), ChangeOfferCallToAction.fragment, LodgingChangePlaybackSection.fragment, CancellationChange.fragment, TotalDifference.fragment, LodgingChangeContentSection.fragment, LodgingErrorBanner.fragment);
var ChangeShopping = function (props) {
  var _data_changeOffers;
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    onContinue = props.onContinue,
    errorRedirection = props.errorRedirection;
  var context = useBexApi10().context;
  var track = useClickTracker46();
  var _useNavigationContext = useNavigationContext(),
    config = _useNavigationContext.config,
    setConfig = _useNavigationContext.setConfig;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery2 = useQuery2(__Query, {
      variables: variables,
      ssr: !skipSsr,
      fetchPolicy: "no-cache"
    }),
    data = _useQuery2.data,
    error = _useQuery2.error,
    loading = _useQuery2.loading;
  var changeType = inputs.changeType;
  useEffect9(function () {
    if (!loading) {
      var _data_changeOffers;
      if (data === null || data === void 0 ? void 0 : (_data_changeOffers = data.changeOffers) === null || _data_changeOffers === void 0 ? void 0 : _data_changeOffers.changeYourOptionsLink) {
        var _data_changeOffers_changeYourOptionsLink_action = data.changeOffers.changeYourOptionsLink.action,
          analytics2 = _data_changeOffers_changeYourOptionsLink_action.analytics,
          accessibility = _data_changeOffers_changeYourOptionsLink_action.accessibility;
        setConfig(_object_spread_props(_object_spread({}, config), {
          backToCLP: _object_spread_props(_object_spread({}, config.backToCLP || defaultBackToCLP), {
            actionAnalyticsCallback: function () {
              return track(analytics2.referrerId, analytics2.linkName);
            },
            accessibility: accessibility
          })
        }));
      }
      if (window && errorRedirection) {
        var _data_changeOffers1;
        if (error || !data) {
          var payload = {
            errorType: "technical",
            errorMessage: (error === null || error === void 0 ? void 0 : error.message) || ""
          };
          errorRedirection(window.location, void 0, payload);
        }
        if (data === null || data === void 0 ? void 0 : (_data_changeOffers1 = data.changeOffers) === null || _data_changeOffers1 === void 0 ? void 0 : _data_changeOffers1.errorRedirectUrlPath) {
          errorRedirection(window.location, data.changeOffers.errorRedirectUrlPath, void 0);
        }
      }
    }
  }, [loading, data]);
  if (!changeType) {
    return null;
  }
  if (loading || (data === null || data === void 0 ? void 0 : (_data_changeOffers = data.changeOffers) === null || _data_changeOffers === void 0 ? void 0 : _data_changeOffers.errorRedirectUrlPath)) {
    return /* @__PURE__ */React213.createElement(LodgingChangeLoader, null);
  }
  if (!(data === null || data === void 0 ? void 0 : data.changeOffers)) {
    return null;
  }
  return /* @__PURE__ */React213.createElement(ChangeShoppingComponent, {
    changeType: changeType,
    changeOffers: data.changeOffers,
    onContinue: onContinue
  });
};
ChangeShopping.displayName = "sharedui-ChangeShopping";
var ChangeShoppingComponent = function (param) {
  var changeType = param.changeType,
    changeOffers = param.changeOffers,
    onContinue = param.onContinue;
  var _changeOffers_impressionAnalytics, _changeOffers_impressionAnalytics1, _changeOffers_changePlaybackSections, _changeOffers_cancellationChange;
  var comboChangeType = changeOffers.comboChangeType;
  var initialListingsDisplayState = changeType === "ROOM" || changeType === "UPGRADE_ROOM" || comboChangeType === "INVOLUNTARY";
  var _useState6 = _sliced_to_array(useState6(initialListingsDisplayState), 2),
    listingsDisplayed = _useState6[0],
    setListingsDisplayed = _useState6[1];
  var displayContextValue = useMemo7(function () {
    return {
      listingsDisplayed: listingsDisplayed,
      setListingsDisplayed: setListingsDisplayed
    };
  }, [listingsDisplayed, setListingsDisplayed]);
  var _changeOffers_impressionAnalytics_referrerId, _changeOffers_impressionAnalytics_linkName;
  return /* @__PURE__ */React213.createElement(IntersectionTracker18, {
    trackOnce: true,
    referrerId: (_changeOffers_impressionAnalytics_referrerId = changeOffers === null || changeOffers === void 0 ? void 0 : (_changeOffers_impressionAnalytics = changeOffers.impressionAnalytics) === null || _changeOffers_impressionAnalytics === void 0 ? void 0 : _changeOffers_impressionAnalytics.referrerId) !== null && _changeOffers_impressionAnalytics_referrerId !== void 0 ? _changeOffers_impressionAnalytics_referrerId : "",
    linkName: (_changeOffers_impressionAnalytics_linkName = changeOffers === null || changeOffers === void 0 ? void 0 : (_changeOffers_impressionAnalytics1 = changeOffers.impressionAnalytics) === null || _changeOffers_impressionAnalytics1 === void 0 ? void 0 : _changeOffers_impressionAnalytics1.linkName) !== null && _changeOffers_impressionAnalytics_linkName !== void 0 ? _changeOffers_impressionAnalytics_linkName : ""
  }, changeOffers.banner && /* @__PURE__ */React213.createElement(LodgingErrorBanner, {
    data: changeOffers.banner
  }), changeOffers.title && /* @__PURE__ */React213.createElement(EGDSSpacing108, {
    margin: {
      blockstart: changeOffers.banner ? "six" : void 0
    }
  }, /* @__PURE__ */React213.createElement(EGDSHeading38, {
    tag: "h1",
    size: 4
  }, changeOffers.title)), changeOffers.subtitle && /* @__PURE__ */React213.createElement(EGDSSpacing108, {
    margin: {
      block: "three"
    }
  }, /* @__PURE__ */React213.createElement(EGDSParagraph2, null, changeOffers.subtitle)), (_changeOffers_changePlaybackSections = changeOffers.changePlaybackSections) === null || _changeOffers_changePlaybackSections === void 0 ? void 0 : _changeOffers_changePlaybackSections.map(function (section, idx) {
    return /* @__PURE__ */React213.createElement(ListingsDisplayContext.Provider, {
      value: displayContextValue,
      key: "section-".concat(idx)
    }, /* @__PURE__ */React213.createElement(LodgingChangePlaybackSection, {
      data: section,
      propertyId: changeOffers.propertyId || "",
      sectionIdx: idx
    }));
  }), !listingsDisplayed && /* @__PURE__ */React213.createElement(React213.Fragment, null, ((_changeOffers_cancellationChange = changeOffers.cancellationChange) === null || _changeOffers_cancellationChange === void 0 ? void 0 : _changeOffers_cancellationChange.__typename) === "LodgingPlainDialog" && /* @__PURE__ */React213.createElement(CancellationChange, {
    data: changeOffers.cancellationChange
  }), changeOffers.totalDifference && /* @__PURE__ */React213.createElement(TotalDifference, {
    data: changeOffers.totalDifference
  }), changeOffers.messaging && /* @__PURE__ */React213.createElement(LodgingChangeContentSection, {
    data: changeOffers.messaging
  }), changeOffers.callToAction && /* @__PURE__ */React213.createElement(EGDSSpacing108, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React213.createElement(ChangeOfferCallToAction, {
    data: changeOffers.callToAction,
    onContinue: onContinue,
    isFullWidth: true
  }))));
};
ChangeShoppingComponent.displayName = "sharedui-ChangeShoppingComponent";
// src/components/change-shopping/components/change-shopping/lodging-csp-config.ts
var LodgingCSPConfig = {
  backToCLP: {
    actionDestinationResolver: function (params) {
      var tripId = params.tripId;
      var orderNumber = params.orderNumber;
      var orderLineGuid = params.orderLineGuid;
      if (!tripId || !orderNumber || !orderLineGuid) {
        return;
      }
      return {
        pathname: "/trips/".concat(tripId, "/ordernumber/").concat(orderNumber, "/orderlinenumber/").concat(orderLineGuid, "/change"),
        search: "?bspwa=true"
      };
    },
    actionElementId: "back-to-clp"
  }
};
// src/components/change-shopping/components/change-shopping/navigation-toolbar.tsx
import React214 from "react";
import { useHistory as useHistory3, useParams } from "react-router-dom";
import { EGDSTertiaryButton as EGDSTertiaryButton6 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon37, EGDSIconSize as EGDSIconSize24 } from "@egds/react-core/icons";
import { EGDSSpacing as EGDSSpacing109 } from "@egds/react-core/spacing";
import { EGDSToolbar as EGDSToolbar15 } from "@egds/react-core/toolbar";
var NavigationToolbar = function (param) {
  var actionName = param.actionName;
  var navContext = useNavigationContext();
  var actionConfig = navContext.config[actionName];
  var params = useParams();
  var history = useHistory3();
  if (!actionConfig) {
    return null;
  }
  var actionDestinationResolver = actionConfig.actionDestinationResolver,
    actionElementId = actionConfig.actionElementId,
    actionAnalyticsCallback = actionConfig.actionAnalyticsCallback,
    accessibility = actionConfig.accessibility;
  var destination = actionDestinationResolver(params);
  if (!destination) {
    return null;
  }
  var props = typeof destination === "string" ? {
    children: /* @__PURE__ */React214.createElement(EGDSSpacing109, {
      padding: "one"
    }, /* @__PURE__ */React214.createElement("div", null, /* @__PURE__ */React214.createElement(EGDSSpacing109, {
      padding: "half"
    }, /* @__PURE__ */React214.createElement("div", null, /* @__PURE__ */React214.createElement(EGDSTertiaryButton6, {
      id: actionElementId,
      href: destination,
      tag: "a",
      onClick: actionAnalyticsCallback,
      "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : ""
    }, /* @__PURE__ */React214.createElement(EGDSIcon37, {
      name: "arrow_back",
      size: EGDSIconSize24.MEDIUM
    }))))))
  } : {
    navigationContent: {
      navType: "back",
      onClick: function () {
        if (actionAnalyticsCallback) {
          actionAnalyticsCallback();
        }
        history.push(destination);
      },
      navButtonId: actionElementId,
      navIconLabel: accessibility !== null && accessibility !== void 0 ? accessibility : void 0
    }
  };
  return /* @__PURE__ */React214.createElement(EGDSToolbar15, _object_spread({}, props));
};
NavigationToolbar.displayName = "sharedui-NavigationToolbar";
// src/components/change-shopping/components/change-shopping/__private/__fragments/utilities/error-redirection.ts
function redirect(location, errorRedirectUrlPath, errorRedirectionPayload) {
  if (!location) {
    return;
  }
  if (errorRedirectUrlPath) {
    location.replace("".concat(location.origin).concat(errorRedirectUrlPath));
    return;
  }
  location.replace(assembleUrl(location, errorRedirectionPayload));
}
function assembleUrl(location, errorRedirectionPayload) {
  var origin = location.origin,
    pathname = location.pathname,
    search = location.search;
  var updatedPath = "".concat(pathname, "/error");
  var query = new URLSearchParams(search);
  var toAdd = {
    errorType: (errorRedirectionPayload === null || errorRedirectionPayload === void 0 ? void 0 : errorRedirectionPayload.errorType) || "technical",
    errorMessage: (errorRedirectionPayload === null || errorRedirectionPayload === void 0 ? void 0 : errorRedirectionPayload.errorMessage) && encodeURIComponent(errorRedirectionPayload === null || errorRedirectionPayload === void 0 ? void 0 : errorRedirectionPayload.errorMessage),
    checkInDate: query.get("checkin"),
    checkOutDate: query.get("checkout"),
    backNavigation: "".concat(pathname, "?bspwa=true")
  };
  var toRemove = ["checkin", "checkout"];
  Object.keys(toAdd).forEach(function (key) {
    return query.append(key, toAdd[key] || "");
  });
  toRemove.forEach(function (key) {
    return query.delete(key);
  });
  var updatedSearch = query.toString();
  return "".concat(origin).concat(updatedPath, "?").concat(updatedSearch);
}
// src/components/change-shopping/components/lodging-booking-playback/lodging-booking-playback.tsx
import React218 from "react";
import { gql as gql161, useQuery as useQuery3 } from "@apollo/client";
import { useBexApi as useBexApi11 } from "@shared-ui/bex-api-context";
// src/components/change-shopping/components/lodging-booking-playback/lodging-booking-playback-skeleton.tsx
import React217 from "react";
import { UitkLayoutFlex as UitkLayoutFlex7 } from "@egds/react-core/layout-flex";
// src/components/change-shopping/components/lodging-booking-playback/criteria-playback-skeleton.tsx
import React215 from "react";
import { UitkCard as UitkCard2 } from "@egds/react-core/cards";
import { UitkLayoutColumns } from "@egds/react-core/layout-columns";
import { UitkLayoutFlex as UitkLayoutFlex5 } from "@egds/react-core/layout-flex";
import { UitkLineSkeleton } from "@egds/react-core/skeleton";
import { UitkSpacing as UitkSpacing5 } from "@egds/react-core/spacing";
var CriteriaPlaybackSkeleton = function () {
  return /* @__PURE__ */React215.createElement(UitkCard2, null, /* @__PURE__ */React215.createElement(UitkSpacing5, {
    padding: "six"
  }, /* @__PURE__ */React215.createElement(UitkLayoutFlex5, {
    direction: "column",
    space: "six"
  }, /* @__PURE__ */React215.createElement(UitkLineSkeleton, null), /* @__PURE__ */React215.createElement(UitkLayoutColumns, {
    columns: 2
  }, /* @__PURE__ */React215.createElement(UitkLineSkeleton, {
    type: "secondary"
  }), /* @__PURE__ */React215.createElement(UitkLineSkeleton, {
    type: "secondary"
  })))));
};
// src/components/change-shopping/components/lodging-booking-playback/pricing-playback-skeleton.tsx
import React216 from "react";
import { UitkCard as UitkCard3 } from "@egds/react-core/cards";
import { UitkLayoutFlex as UitkLayoutFlex6 } from "@egds/react-core/layout-flex";
import { UitkLineSkeleton as UitkLineSkeleton2 } from "@egds/react-core/skeleton";
import { UitkSpacing as UitkSpacing6 } from "@egds/react-core/spacing";
var PricingPlaybackSkeleton = function () {
  return /* @__PURE__ */React216.createElement(UitkCard3, null, /* @__PURE__ */React216.createElement(UitkSpacing6, {
    padding: "six"
  }, /* @__PURE__ */React216.createElement(UitkLayoutFlex6, {
    justifyContent: "space-between"
  }, /* @__PURE__ */React216.createElement(UitkLineSkeleton2, null), /* @__PURE__ */React216.createElement(UitkLineSkeleton2, {
    type: "secondary"
  }))));
};
// src/components/change-shopping/components/lodging-booking-playback/lodging-booking-playback-skeleton.tsx
var LodgingBookingPlaybackSkeleton = function (props) {
  var showOriginal = props.showOriginal,
    showUpdated = props.showUpdated;
  return /* @__PURE__ */React217.createElement("div", {
    "data-test-id": "lodging-booking-playback-skeleton"
  }, /* @__PURE__ */React217.createElement(UitkLayoutFlex7, {
    direction: "column",
    space: "six"
  }, showOriginal && /* @__PURE__ */React217.createElement(PricingPlaybackSkeleton, null), showOriginal && /* @__PURE__ */React217.createElement(CriteriaPlaybackSkeleton, null), showUpdated && /* @__PURE__ */React217.createElement(CriteriaPlaybackSkeleton, null), showUpdated && /* @__PURE__ */React217.createElement(PricingPlaybackSkeleton, null)));
};
// src/components/change-shopping/components/lodging-booking-playback/lodging-booking-playback.tsx
var __Query2 = gql161(_templateObject165(), LodgingChangePlaybackSection.fragment);
var LodgingBookingPlayback = function (param) {
  var inputs = param.inputs,
    _param_hidePricePlayback = param.hidePricePlayback,
    hidePricePlayback = _param_hidePricePlayback === void 0 ? false : _param_hidePricePlayback,
    skipSsr = param.skipSsr,
    onLoad = param.onLoad;
  var context = useBexApi11().context;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery3 = useQuery3(__Query2, {
      context: {
        useApq: true
      },
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery3.data,
    error = _useQuery3.error,
    loading = _useQuery3.loading;
  React218.useEffect(function () {
    if (!loading) {
      onLoad === null || onLoad === void 0 ? void 0 : onLoad(!error && !!(data === null || data === void 0 ? void 0 : data.lodgingBookingPlayback));
    }
  }, [loading, error, data, onLoad]);
  if (loading || error || !(data === null || data === void 0 ? void 0 : data.lodgingBookingPlayback)) {
    return /* @__PURE__ */React218.createElement(LodgingBookingPlaybackSkeleton, {
      showOriginal: !!inputs.tripId,
      showUpdated: !!inputs.offerKey
    });
  }
  var changePlaybackSections = data.lodgingBookingPlayback.changePlaybackSections;
  var filteredSections = changePlaybackSections === null || changePlaybackSections === void 0 ? void 0 : changePlaybackSections.map(function (section) {
    var _section_items;
    var _section_items_filter;
    return _object_spread_props(_object_spread({}, section), {
      items: !hidePricePlayback ? section.items : (_section_items_filter = (_section_items = section.items) === null || _section_items === void 0 ? void 0 : _section_items.filter(function (item) {
        return item.__typename !== "LodgingChangePriceDetails";
      })) !== null && _section_items_filter !== void 0 ? _section_items_filter : null
    });
  });
  return /* @__PURE__ */React218.createElement(React218.Fragment, null, filteredSections === null || filteredSections === void 0 ? void 0 : filteredSections.map(function (section, idx) {
    return /* @__PURE__ */React218.createElement(LodgingChangePlaybackSection, {
      key: section.sectionId,
      data: section,
      propertyId: "",
      sectionIdx: idx
    });
  }));
};
LodgingBookingPlayback.displayName = "sharedui-LodgingBookingPlayback";
// src/components/change-shopping/hooks/use-navigation-link-action.ts
import { useEffect as useEffect10 } from "react";
import { gql as gql162 } from "@apollo/client";
import { useClickTracker as useClickTracker47 } from "@shared-ui/clickstream-analytics-context";
var __ChangeShoppingNavigationLinkActionFragment = gql162(_templateObject166());
var useNavigationLinkAction = function (navigationAction, actionElementId, configKey) {
  var _useNavigationContext = useNavigationContext(),
    config = _useNavigationContext.config,
    setConfig = _useNavigationContext.setConfig;
  var track = useClickTracker47();
  useEffect10(function () {
    if (navigationAction) {
      var accessibility = navigationAction.accessibility,
        analytics2 = navigationAction.analytics,
        resource = navigationAction.resource;
      setConfig(_object_spread_props(_object_spread({}, config), _define_property({}, configKey, {
        accessibility: accessibility,
        actionAnalyticsCallback: function () {
          return track(analytics2.referrerId, analytics2.linkName);
        },
        actionDestinationResolver: function () {
          return resource.value;
        },
        actionElementId: actionElementId
      })));
    }
  }, [actionElementId, configKey, navigationAction]);
};
// src/components/basic-property-offers.tsx
import React219 from "react";
import { gql as gql163, useQuery as useQuery4 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing110 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi12 } from "@shared-ui/bex-api-context";
import { LodgingOfferFilters as LodgingOfferFilters4, PropertyOffersFiltersProvider as PropertyOffersFiltersProvider3 } from "@shared-ui/retail-sort-and-filter-shared";
var __Query3 = gql163(_templateObject167(), ListingsHeader.fragment, Listings.fragment, __ShoppingContextFragment, LodgingOfferFilters4.fragment);
var BasicPropertyOffers = function (param) {
  var inputs = param.inputs,
    children = param.children,
    skipSsr = param.skipSsr,
    forceVerticalPropertyUnitLayout = param.forceVerticalPropertyUnitLayout,
    _param_renderLayout = param.renderLayout,
    renderLayout = _param_renderLayout === void 0 ? OffersLayouts.GRID : _param_renderLayout,
    _param_showRoomHighlights = param.showRoomHighlights,
    showRoomHighlights = _param_showRoomHighlights === void 0 ? false : _param_showRoomHighlights,
    _param_displayRateCheckForm = param.displayRateCheckForm,
    displayRateCheckForm = _param_displayRateCheckForm === void 0 ? false : _param_displayRateCheckForm;
  var _data_propertyOffers_offerFilters, _data_propertyOffers_offerFilters1;
  var context = useBexApi12().context;
  var _useQuery4 = useQuery4(__Query3, {
      variables: _object_spread_props(_object_spread({}, inputs), {
        context: context
      }),
      ssr: !skipSsr
    }),
    data = _useQuery4.data,
    error = _useQuery4.error,
    loading = _useQuery4.loading;
  if (loading) {
    return /* @__PURE__ */React219.createElement(LoadingPlaceholderCards, null);
  }
  if (error || !(data === null || data === void 0 ? void 0 : data.propertyOffers)) {
    return null;
  }
  var listingsHeader = /* @__PURE__ */React219.createElement(EGDSSpacing110, {
    margin: renderLayout === OffersLayouts.CAROUSEL ? {
      blockend: "one"
    } : {
      small: {
        inline: "three"
      },
      medium: {
        inline: "unset"
      },
      blockend: "one"
    }
  }, /* @__PURE__ */React219.createElement(ListingsHeader, {
    data: data.propertyOffers
  }));
  var listings = /* @__PURE__ */React219.createElement(Listings, {
    data: data.propertyOffers,
    forceVerticalPropertyUnitLayout: forceVerticalPropertyUnitLayout,
    renderLayout: renderLayout,
    showRoomHighlights: showRoomHighlights,
    targetItem: displayRateCheckForm ? "PROPERTY_OFFERS_RATE_CHECK_CTA_BUTTON_CLICK" /* RATE_CHECK_CTA_BUTTON_CLICK */ : void 0
  });
  return /* @__PURE__ */React219.createElement(InputsProvider, {
    inputs: inputs
  }, /* @__PURE__ */React219.createElement(MultiItemProvider, {
    multiItemContext: setMultiItemContext(data.propertyOffers.shoppingContext)
  }, ((_data_propertyOffers_offerFilters = data.propertyOffers.offerFilters) === null || _data_propertyOffers_offerFilters === void 0 ? void 0 : _data_propertyOffers_offerFilters.filterPills) ? /* @__PURE__ */React219.createElement(PropertyOffersFiltersProvider3, {
    value: {
      filters: ((_data_propertyOffers_offerFilters1 = data.propertyOffers.offerFilters) === null || _data_propertyOffers_offerFilters1 === void 0 ? void 0 : _data_propertyOffers_offerFilters1.filterPills) || null,
      list: data.propertyOffers.categorizedListings
    }
  }, listingsHeader, children, /* @__PURE__ */React219.createElement(EGDSSpacing110, {
    margin: {
      small: {
        inline: "three"
      },
      medium: {
        inline: "unset"
      },
      blockend: "one"
    }
  }, /* @__PURE__ */React219.createElement("div", null, /* @__PURE__ */React219.createElement(LodgingOfferFilters4, {
    data: data.propertyOffers.offerFilters
  }))), listings) : /* @__PURE__ */React219.createElement(React219.Fragment, null, listingsHeader, children, listings)));
};
BasicPropertyOffers.displayName = "BasicPropertyOffers";
// src/components/room-details.tsx
import React221 from "react";
import { gql as gql164, useQuery as useQuery5 } from "@apollo/client";
import { useBexApi as useBexApi13 } from "@shared-ui/bex-api-context";
// src/components/room-detail-loading.tsx
import React220 from "react";
import { EGDSCardContentSection as EGDSCardContentSection25, UitkCard as UitkCard4 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure8, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType10 } from "@egds/react-core/images";
import { EGDSBlockSkeleton as EGDSBlockSkeleton4, EGDSLineSkeleton as EGDSLineSkeleton6 } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing111 } from "@egds/react-core/spacing";
var LoadingStateImageSkeleton = function () {
  return /* @__PURE__ */React220.createElement(EGDSSpacing111, {
    margin: {
      blockend: "six"
    }
  }, /* @__PURE__ */React220.createElement(UitkCard4, null, /* @__PURE__ */React220.createElement(EGDSFigure8, {
    ratio: EGDSFigureAspectRatioType10.R16_9
  }, /* @__PURE__ */React220.createElement(EGDSBlockSkeleton4, null))));
};
var LoadingStateTextSkeleton = function () {
  return /* @__PURE__ */React220.createElement(React220.Fragment, null, /* @__PURE__ */React220.createElement(EGDSSpacing111, null, /* @__PURE__ */React220.createElement(EGDSLineSkeleton6, {
    animation: true,
    type: "primary"
  })), /* @__PURE__ */React220.createElement(EGDSSpacing111, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React220.createElement(EGDSLineSkeleton6, {
    animation: true,
    type: "secondary"
  })));
};
var LoadingStateContentSkeleton = function () {
  return /* @__PURE__ */React220.createElement(EGDSCardContentSection25, {
    padded: false
  }, /* @__PURE__ */React220.createElement(LoadingStateTextSkeleton, null));
};
var RoomsDetailLoadingPlaceHolder = function () {
  return /* @__PURE__ */React220.createElement(EGDSSpacing111, {
    margin: "six"
  }, /* @__PURE__ */React220.createElement("div", {
    "data-stid": "testRoomDetailLoading"
  }, /* @__PURE__ */React220.createElement(LoadingStateImageSkeleton, null), /* @__PURE__ */React220.createElement(LoadingStateContentSkeleton, null)));
};
// src/components/room-details.tsx
var __RoomDetailsQuery = gql164(_templateObject168(), ControlPropertyUnit.fragment);
var RoomDetails = function (param) {
  var inputs = param.inputs,
    skipSsr = param.skipSsr;
  var _data_propertyOffers, _unitGallery_images;
  var context = useBexApi13().context;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery5 = useQuery5(__RoomDetailsQuery, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery5.data,
    loading = _useQuery5.loading,
    error = _useQuery5.error;
  var selectedPropertyUnit = data === null || data === void 0 ? void 0 : (_data_propertyOffers = data.propertyOffers) === null || _data_propertyOffers === void 0 ? void 0 : _data_propertyOffers.units.find(function (unit) {
    var _inputs_searchOffer;
    return unit.id === ((_inputs_searchOffer = inputs.searchOffer) === null || _inputs_searchOffer === void 0 ? void 0 : _inputs_searchOffer.roomTypeId);
  });
  if (loading) {
    return /* @__PURE__ */React221.createElement(RoomsDetailLoadingPlaceHolder, null);
  }
  if (error || !selectedPropertyUnit) {
    return null;
  }
  var unitGallery = selectedPropertyUnit.unitGallery,
    features = selectedPropertyUnit.features,
    roomAmenities = selectedPropertyUnit.roomAmenities;
  if (!(unitGallery === null || unitGallery === void 0 ? void 0 : (_unitGallery_images = unitGallery.images) === null || _unitGallery_images === void 0 ? void 0 : _unitGallery_images.length) && !features.length && !roomAmenities) {
    return null;
  }
  return /* @__PURE__ */React221.createElement(InputsProvider, {
    inputs: inputs
  }, /* @__PURE__ */React221.createElement(DetailsDialogContent, {
    listing: selectedPropertyUnit
  }));
};
RoomDetails.displayName = "RoomDetails";
export { BasicPropertyOffers, CancellationPolicyInfo2 as CancellationPolicyInfo, CategorizedListings, DamageAndIncidentalsCard2 as DamageAndIncidentalsCard, FilterPills2 as FilterPills, HighlightedBenefits2 as HighlightedBenefits, IdentifierType, ListingsHeader2 as ListingsHeader, change_shopping_exports as LodgingChangeShopping, LodgingOneKeyBurnSwitch2 as LodgingOneKeyBurnSwitch, LodgingPropertySingleOffer, LoyaltyDiscountToggle2 as LoyaltyDiscountToggle, NewVipModule2 as NewVipModule, OffersLayouts, PriceInsight2 as PriceInsight, PropertyLegalDisclaimer, PropertyLevelOffersCard2 as PropertyLevelOffersCard, PropertyLevelOffersMessage2 as PropertyLevelOffersMessage, PropertyLodgingPrepareCheckout, PropertyOffers2 as PropertyOffers, PropertyOffersContextProvider, PropertyOffersFormSubmitType, PropertyOffersIncludedPerks2 as PropertyOffersIncludedPerks, PropertyOffersSignalNames, PropertySearchLink2 as PropertySearchLink, PropertySingleOffer2 as PropertySingleOffer, PropertySpaceDetails2 as PropertySpaceDetails, PropertyStickyBookBar2 as PropertyStickyBookBar, PropertyStickyPriceHeader2 as PropertyStickyPriceHeader, PropertyTripSummary2 as PropertyTripSummary, PropertyUnitListView2 as PropertyUnitListView, RoomDetails, SingleOfferSearchButton, SingleOfferSearchDateField2 as SingleOfferSearchDateField, TravelerSelector, UnitsCarousel2 as UnitsCarousel, VipMessagingCard2 as VipMessagingCard, usePropertyOffersContext }; /* istanbul ignore file -- @preserve */ /* istanbul ignore next -- @preserve */ // istanbul ignore next -- @preserve